export const Data1:any = [
    {
        "id": "52955757",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:27:42.023",
        "brokerTime": "2025-05-14 02:27:42.023",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55952702",
        "positionId": "55952702",
        "volume": 0.1,
        "price": 3254.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3354.85,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3254.85,
        "doubleCheck": true
    },
    {
        "id": "52955758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:27:43.086",
        "brokerTime": "2025-05-14 02:27:43.086",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55952703",
        "positionId": "55952703",
        "volume": 0.1,
        "price": 3254.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3154.59,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3254.59,
        "doubleCheck": true
    },
    {
        "id": "52955783",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:37:04.506",
        "brokerTime": "2025-05-14 02:37:04.506",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55952731",
        "positionId": "55952731",
        "volume": 0.12,
        "price": 3253.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3353.83,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3253.79,
        "doubleCheck": true
    },
    {
        "id": "52955901",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:39:37.237",
        "brokerTime": "2025-05-14 02:39:37.237",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55952845",
        "positionId": "55952845",
        "volume": 0.14,
        "price": 3252.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3352.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3252.79,
        "doubleCheck": true
    },
    {
        "id": "52955960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:46:23.213",
        "brokerTime": "2025-05-14 02:46:23.213",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55952907",
        "positionId": "55952907",
        "volume": 0.12,
        "price": 3255.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.63,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3255.63,
        "doubleCheck": true
    },
    {
        "id": "52957843",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:01:26.749",
        "brokerTime": "2025-05-14 03:01:26.749",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954454",
        "positionId": "55954454",
        "volume": 0.17,
        "price": 3251.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3351.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3251.79,
        "doubleCheck": true
    },
    {
        "id": "52957871",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:02:00.132",
        "brokerTime": "2025-05-14 03:02:00.132",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954479",
        "positionId": "55954479",
        "volume": 0.21,
        "price": 3250.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3350.51,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3250.51,
        "doubleCheck": true
    },
    {
        "id": "52958016",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:03:00.120",
        "brokerTime": "2025-05-14 03:03:00.120",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954602",
        "positionId": "55954602",
        "volume": 0.25,
        "price": 3248.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3348.26,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3248.15,
        "doubleCheck": true
    },
    {
        "id": "52958211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:46:23.213",
        "brokerTime": "2025-05-14 03:03:24.168",
        "commission": -0.84,
        "swap": 0,
        "profit": 75.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954736",
        "positionId": "55952907",
        "volume": 0.12,
        "price": 3249.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.89,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 74.52,
        "priceIn": 3255.63,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0",
        "tProfit": 127.76,
        "tnProfit": 126.22,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "52958212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 02:27:43.086",
        "brokerTime": "2025-05-14 03:03:24.188",
        "commission": -0.7,
        "swap": 0,
        "profit": 52.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954737",
        "positionId": "55952703",
        "volume": 0.1,
        "price": 3249.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3155.89,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 51.699999999999996,
        "priceIn": 3254.59,
        "doubleCheck": true
    },
    {
        "id": "52958217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:03:36.689",
        "brokerTime": "2025-05-14 03:03:36.689",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954741",
        "positionId": "55954741",
        "volume": 0.1,
        "price": 3249.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3249.18,
        "doubleCheck": true
    },
    {
        "id": "52958439",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:06:02.208",
        "brokerTime": "2025-05-14 03:06:02.208",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954912",
        "positionId": "55954912",
        "volume": 0.3,
        "price": 3247.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3347.1,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3247.07,
        "doubleCheck": true
    },
    {
        "id": "52958484",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:09:54.609",
        "brokerTime": "2025-05-14 03:09:54.609",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55954949",
        "positionId": "55954949",
        "volume": 0.36,
        "price": 3246.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3346.05,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 3246.05,
        "doubleCheck": true
    },
    {
        "id": "52958833",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:12:29.452",
        "brokerTime": "2025-05-14 03:12:29.452",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955262",
        "positionId": "55955262",
        "volume": 0.43,
        "price": 3244.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.69,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 3244.69,
        "doubleCheck": true
    },
    {
        "id": "52958925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.494",
        "brokerTime": "2025-05-14 03:19:02.494",
        "commission": -4.2,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955342",
        "positionId": "55955342",
        "volume": 0.6,
        "price": 3244.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.2,
        "takeProfit": null,
        "priceIn": 3244.66,
        "doubleCheck": true
    },
    {
        "id": "52958926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.765",
        "brokerTime": "2025-05-14 03:19:02.765",
        "commission": -3.85,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955343",
        "positionId": "55955343",
        "volume": 0.55,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.85,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.993",
        "brokerTime": "2025-05-14 03:19:02.993",
        "commission": -3.22,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955344",
        "positionId": "55955344",
        "volume": 0.46,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.22,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03.215",
        "brokerTime": "2025-05-14 03:19:03.215",
        "commission": -2.87,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955345",
        "positionId": "55955345",
        "volume": 0.41,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.87,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03.470",
        "brokerTime": "2025-05-14 03:19:03.470",
        "commission": -2.66,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955346",
        "positionId": "55955346",
        "volume": 0.38,
        "price": 3244.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.66,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03.470",
        "brokerTime": "2025-05-14 03:19:03.760",
        "commission": -2.66,
        "swap": 0,
        "profit": -9.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955347",
        "positionId": "55955346",
        "volume": 0.38,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12.540000000000001,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2",
        "tProfit": -10,
        "tnProfit": -27.5,
        "tVolume": 2.5,
        "tTrades": 6
    },
    {
        "id": "52958931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:03.215",
        "brokerTime": "2025-05-14 03:19:03.804",
        "commission": -2.87,
        "swap": 0,
        "profit": -10.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955348",
        "positionId": "55955345",
        "volume": 0.41,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.530000000000001,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.993",
        "brokerTime": "2025-05-14 03:19:03.810",
        "commission": -3.22,
        "swap": 0,
        "profit": -11.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955349",
        "positionId": "55955344",
        "volume": 0.46,
        "price": 3245,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.180000000000001,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.765",
        "brokerTime": "2025-05-14 03:19:03.846",
        "commission": -3.85,
        "swap": 0,
        "profit": -9.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955350",
        "positionId": "55955343",
        "volume": 0.55,
        "price": 3244.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.75,
        "takeProfit": null,
        "priceIn": 3244.74,
        "doubleCheck": true
    },
    {
        "id": "52958934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:19:02.494",
        "brokerTime": "2025-05-14 03:19:03.879",
        "commission": -4.2,
        "swap": 0,
        "profit": -15.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955351",
        "positionId": "55955342",
        "volume": 0.6,
        "price": 3244.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -19.8,
        "takeProfit": null,
        "priceIn": 3244.66,
        "doubleCheck": true
    },
    {
        "id": "52958940",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:12:29.452",
        "brokerTime": "2025-05-14 03:19:27.509",
        "commission": -3.01,
        "swap": 0,
        "profit": -24.51,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955356",
        "positionId": "55955262",
        "volume": 0.43,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -27.520000000000003,
        "priceIn": 3244.69,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1",
        "tProfit": -892.54,
        "tnProfit": -907.1,
        "tVolume": 2.08,
        "tTrades": 9
    },
    {
        "id": "52958941",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:09:54.609",
        "brokerTime": "2025-05-14 03:19:27.592",
        "commission": -2.52,
        "swap": 0,
        "profit": -69.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955357",
        "positionId": "55954949",
        "volume": 0.36,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72,
        "priceIn": 3246.05,
        "doubleCheck": true
    },
    {
        "id": "52958942",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:06:02.208",
        "brokerTime": "2025-05-14 03:19:27.635",
        "commission": -2.1,
        "swap": 0,
        "profit": -88.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955358",
        "positionId": "55954912",
        "volume": 0.3,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -90.6,
        "priceIn": 3247.07,
        "doubleCheck": true
    },
    {
        "id": "52958943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 03:03:36.689",
        "brokerTime": "2025-05-14 03:19:27.685",
        "commission": -0.7,
        "swap": 0,
        "profit": 48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955359",
        "positionId": "55954741",
        "volume": 0.1,
        "price": 3244.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 47.3,
        "takeProfit": null,
        "priceIn": 3249.18,
        "doubleCheck": true
    },
    {
        "id": "52958944",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:03:00.120",
        "brokerTime": "2025-05-14 03:19:27.725",
        "commission": -1.75,
        "swap": 0,
        "profit": -100.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955360",
        "positionId": "55954602",
        "volume": 0.25,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.5,
        "priceIn": 3248.15,
        "doubleCheck": true
    },
    {
        "id": "52958945",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:02:00.132",
        "brokerTime": "2025-05-14 03:19:27.777",
        "commission": -1.47,
        "swap": 0,
        "profit": -134.19,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955361",
        "positionId": "55954479",
        "volume": 0.21,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -135.66,
        "priceIn": 3250.51,
        "doubleCheck": true
    },
    {
        "id": "52958946",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 03:01:26.749",
        "brokerTime": "2025-05-14 03:19:27.799",
        "commission": -1.19,
        "swap": 0,
        "profit": -130.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955362",
        "positionId": "55954454",
        "volume": 0.17,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.57999999999998,
        "priceIn": 3251.79,
        "doubleCheck": true
    },
    {
        "id": "52958947",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:39:37.237",
        "brokerTime": "2025-05-14 03:19:27.844",
        "commission": -0.98,
        "swap": 0,
        "profit": -121.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955363",
        "positionId": "55952845",
        "volume": 0.14,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -122.36,
        "priceIn": 3252.79,
        "doubleCheck": true
    },
    {
        "id": "52958948",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:37:04.506",
        "brokerTime": "2025-05-14 03:19:27.871",
        "commission": -0.84,
        "swap": 0,
        "profit": -116.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955364",
        "positionId": "55952731",
        "volume": 0.12,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.88000000000001,
        "priceIn": 3253.79,
        "doubleCheck": true
    },
    {
        "id": "52958949",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 02:27:42.023",
        "brokerTime": "2025-05-14 03:19:27.918",
        "commission": -0.7,
        "swap": 0,
        "profit": -107.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "55955365",
        "positionId": "55952702",
        "volume": 0.1,
        "price": 3244.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3344.44,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108,
        "priceIn": 3254.85,
        "doubleCheck": true
    },
    {
        "id": "53048709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:38:35.227",
        "brokerTime": "2025-05-14 12:38:35.227",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022456",
        "positionId": "56022456",
        "volume": 0.1,
        "price": 3231.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.34,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3231.34,
        "doubleCheck": true
    },
    {
        "id": "53048710",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:36.257",
        "brokerTime": "2025-05-14 12:38:36.257",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022457",
        "positionId": "56022457",
        "volume": 0.1,
        "price": 3231.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.55,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3231.55,
        "doubleCheck": true
    },
    {
        "id": "53048711",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:38.438",
        "brokerTime": "2025-05-14 12:38:38.438",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022458",
        "positionId": "56022458",
        "volume": 0.12,
        "price": 3231.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.35,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3231.4,
        "doubleCheck": true
    },
    {
        "id": "53048755",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:39:01.710",
        "brokerTime": "2025-05-14 12:39:01.710",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022496",
        "positionId": "56022496",
        "volume": 0.14,
        "price": 3231.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.29,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3231.29,
        "doubleCheck": true
    },
    {
        "id": "53048756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:39:02.123",
        "brokerTime": "2025-05-14 12:39:02.123",
        "commission": -2.31,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022497",
        "positionId": "56022497",
        "volume": 0.33,
        "price": 3231.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.31,
        "takeProfit": null,
        "priceIn": 3231.09,
        "doubleCheck": true
    },
    {
        "id": "53048857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:39:02.123",
        "brokerTime": "2025-05-14 12:42:27.508",
        "commission": -2.31,
        "swap": 0,
        "profit": -37.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022575",
        "positionId": "56022497",
        "volume": 0.33,
        "price": 3232.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -39.93,
        "takeProfit": null,
        "priceIn": 3231.09,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4",
        "tProfit": -49.92,
        "tnProfit": -52.93,
        "tVolume": 0.43000000000000005,
        "tTrades": 2
    },
    {
        "id": "53048858",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:39:01.710",
        "brokerTime": "2025-05-14 12:42:27.542",
        "commission": -0.98,
        "swap": 0,
        "profit": 10.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022576",
        "positionId": "56022496",
        "volume": 0.14,
        "price": 3232.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9.52,
        "priceIn": 3231.29,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3",
        "tProfit": 27.34,
        "tnProfit": 24.82,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "id": "53048859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:38.438",
        "brokerTime": "2025-05-14 12:42:27.632",
        "commission": -0.84,
        "swap": 0,
        "profit": 9.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022577",
        "positionId": "56022458",
        "volume": 0.12,
        "price": 3232.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9,
        "priceIn": 3231.4,
        "doubleCheck": true
    },
    {
        "id": "53048860",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:38:36.257",
        "brokerTime": "2025-05-14 12:42:27.725",
        "commission": -0.7,
        "swap": 0,
        "profit": 7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022578",
        "positionId": "56022457",
        "volume": 0.1,
        "price": 3232.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.08,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 6.3,
        "priceIn": 3231.55,
        "doubleCheck": true
    },
    {
        "id": "53048861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:38:35.227",
        "brokerTime": "2025-05-14 12:42:27.762",
        "commission": -0.7,
        "swap": 0,
        "profit": -12.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56022579",
        "positionId": "56022456",
        "volume": 0.1,
        "price": 3232.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.54,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13,
        "priceIn": 3231.34,
        "doubleCheck": true
    },
    {
        "id": "53049699",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:46:57.134",
        "brokerTime": "2025-05-14 12:46:57.134",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023253",
        "positionId": "56023253",
        "volume": 0.1,
        "price": 3234.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.49,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.49,
        "doubleCheck": true
    },
    {
        "id": "53049702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:46:58.242",
        "brokerTime": "2025-05-14 12:46:58.242",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023255",
        "positionId": "56023255",
        "volume": 0.1,
        "price": 3234.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.24,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.24,
        "doubleCheck": true
    },
    {
        "id": "53049703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:47:00.626",
        "brokerTime": "2025-05-14 12:47:00.626",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023256",
        "positionId": "56023256",
        "volume": 0.12,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3234.4,
        "doubleCheck": true
    },
    {
        "id": "53049740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:48:00.151",
        "brokerTime": "2025-05-14 12:48:00.151",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023291",
        "positionId": "56023291",
        "volume": 0.14,
        "price": 3235.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "id": "53049743",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:48:00.668",
        "brokerTime": "2025-05-14 12:48:00.668",
        "commission": -2.31,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023294",
        "positionId": "56023294",
        "volume": 0.33,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.31,
        "takeProfit": null,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "id": "53049766",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:48:00.668",
        "brokerTime": "2025-05-14 12:48:59.769",
        "commission": -2.31,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023315",
        "positionId": "56023294",
        "volume": 0.33,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.62,
        "takeProfit": null,
        "priceIn": 3235.38,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5",
        "tProfit": 6.39,
        "tnProfit": 3.38,
        "tVolume": 0.43000000000000005,
        "tTrades": 2
    },
    {
        "id": "53049767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:48:00.151",
        "brokerTime": "2025-05-14 12:48:59.858",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023316",
        "positionId": "56023291",
        "volume": 0.14,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.33,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.02,
        "priceIn": 3235.14,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6",
        "tProfit": -31.82,
        "tnProfit": -34.34,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "id": "53049768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:47:00.626",
        "brokerTime": "2025-05-14 12:48:59.913",
        "commission": -0.84,
        "swap": 0,
        "profit": -13.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023317",
        "positionId": "56023256",
        "volume": 0.12,
        "price": 3235.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -14.52,
        "priceIn": 3234.4,
        "doubleCheck": true
    },
    {
        "id": "53049769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:46:58.242",
        "brokerTime": "2025-05-14 12:48:59.980",
        "commission": -0.7,
        "swap": 0,
        "profit": -13.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023318",
        "positionId": "56023255",
        "volume": 0.1,
        "price": 3235.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.799999999999999,
        "priceIn": 3234.24,
        "doubleCheck": true
    },
    {
        "id": "53049770",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:46:57.134",
        "brokerTime": "2025-05-14 12:49:00.027",
        "commission": -0.7,
        "swap": 0,
        "profit": 8.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023319",
        "positionId": "56023253",
        "volume": 0.1,
        "price": 3235.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.29,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 7.999999999999999,
        "priceIn": 3234.49,
        "doubleCheck": true
    },
    {
        "id": "53049778",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:20.666",
        "brokerTime": "2025-05-14 12:49:20.666",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023326",
        "positionId": "56023326",
        "volume": 0.1,
        "price": 3235.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.75,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3235.75,
        "doubleCheck": true
    },
    {
        "id": "53049779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:49:21.406",
        "brokerTime": "2025-05-14 12:49:21.406",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023327",
        "positionId": "56023327",
        "volume": 0.1,
        "price": 3235.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.61,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3235.62,
        "doubleCheck": true
    },
    {
        "id": "53049781",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:23.762",
        "brokerTime": "2025-05-14 12:49:23.762",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023329",
        "positionId": "56023329",
        "volume": 0.12,
        "price": 3235.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.59,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3235.59,
        "doubleCheck": true
    },
    {
        "id": "53050132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:50:00.128",
        "brokerTime": "2025-05-14 12:50:00.128",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56023584",
        "positionId": "56023584",
        "volume": 0.12,
        "price": 3235.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "id": "53050859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:51:00.299",
        "brokerTime": "2025-05-14 12:51:00.299",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024047",
        "positionId": "56024047",
        "volume": 0.14,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.41,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "id": "53050860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:00.618",
        "brokerTime": "2025-05-14 12:51:00.618",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024048",
        "positionId": "56024048",
        "volume": 0.21,
        "price": 3235.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.2,
        "doubleCheck": true
    },
    {
        "id": "53050869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:00.618",
        "brokerTime": "2025-05-14 12:51:01.496",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024053",
        "positionId": "56024048",
        "volume": 0.21,
        "price": 3235.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.46,
        "takeProfit": null,
        "priceIn": 3235.2,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8",
        "tProfit": -491.29,
        "tnProfit": -694.22,
        "tVolume": 28.990000000000066,
        "tTrades": 98
    },
    {
        "id": "53050870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:01.680",
        "brokerTime": "2025-05-14 12:51:01.680",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024054",
        "positionId": "56024054",
        "volume": 0.21,
        "price": 3235.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "id": "53050871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:01.680",
        "brokerTime": "2025-05-14 12:51:02.198",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024055",
        "positionId": "56024054",
        "volume": 0.21,
        "price": 3235.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.25,
        "takeProfit": null,
        "priceIn": 3235.14,
        "doubleCheck": true
    },
    {
        "id": "53050873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02.492",
        "brokerTime": "2025-05-14 12:51:02.492",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024059",
        "positionId": "56024059",
        "volume": 0.21,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.17,
        "doubleCheck": true
    },
    {
        "id": "53050899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:02.492",
        "brokerTime": "2025-05-14 12:51:03.023",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024085",
        "positionId": "56024059",
        "volume": 0.21,
        "price": 3235.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.67,
        "takeProfit": null,
        "priceIn": 3235.17,
        "doubleCheck": true
    },
    {
        "id": "53050923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:03.768",
        "brokerTime": "2025-05-14 12:51:03.768",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024092",
        "positionId": "56024092",
        "volume": 0.21,
        "price": 3235,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235,
        "doubleCheck": true
    },
    {
        "id": "53050924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:03.768",
        "brokerTime": "2025-05-14 12:51:05.356",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024093",
        "positionId": "56024092",
        "volume": 0.21,
        "price": 3235.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.51,
        "takeProfit": null,
        "priceIn": 3235,
        "doubleCheck": true
    },
    {
        "id": "53050925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:06.153",
        "brokerTime": "2025-05-14 12:51:06.153",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024094",
        "positionId": "56024094",
        "volume": 0.21,
        "price": 3234.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "id": "53050926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:06.153",
        "brokerTime": "2025-05-14 12:51:06.720",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024095",
        "positionId": "56024094",
        "volume": 0.21,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.7800000000000002,
        "takeProfit": null,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "id": "53050927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:07.035",
        "brokerTime": "2025-05-14 12:51:07.035",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024096",
        "positionId": "56024096",
        "volume": 0.21,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53050928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:07.035",
        "brokerTime": "2025-05-14 12:51:08.610",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024097",
        "positionId": "56024096",
        "volume": 0.21,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53050929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:09.055",
        "brokerTime": "2025-05-14 12:51:09.055",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024098",
        "positionId": "56024098",
        "volume": 0.21,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53050930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:09.055",
        "brokerTime": "2025-05-14 12:51:10.076",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024099",
        "positionId": "56024098",
        "volume": 0.21,
        "price": 3234.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.46,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53050931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:11.685",
        "brokerTime": "2025-05-14 12:51:11.685",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024100",
        "positionId": "56024100",
        "volume": 0.21,
        "price": 3234.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.53,
        "doubleCheck": true
    },
    {
        "id": "53050932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:11.685",
        "brokerTime": "2025-05-14 12:51:12.017",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024101",
        "positionId": "56024100",
        "volume": 0.21,
        "price": 3234.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.88,
        "takeProfit": null,
        "priceIn": 3234.53,
        "doubleCheck": true
    },
    {
        "id": "53050933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12.284",
        "brokerTime": "2025-05-14 12:51:12.284",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024102",
        "positionId": "56024102",
        "volume": 0.21,
        "price": 3234.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.51,
        "doubleCheck": true
    },
    {
        "id": "53050934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12.284",
        "brokerTime": "2025-05-14 12:51:12.853",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024103",
        "positionId": "56024102",
        "volume": 0.21,
        "price": 3234.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.35,
        "takeProfit": null,
        "priceIn": 3234.51,
        "doubleCheck": true
    },
    {
        "id": "53050935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12.983",
        "brokerTime": "2025-05-14 12:51:12.983",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024104",
        "positionId": "56024104",
        "volume": 0.21,
        "price": 3234.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.55,
        "doubleCheck": true
    },
    {
        "id": "53050936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:12.983",
        "brokerTime": "2025-05-14 12:51:13.555",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024105",
        "positionId": "56024104",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.7800000000000002,
        "takeProfit": null,
        "priceIn": 3234.55,
        "doubleCheck": true
    },
    {
        "id": "53050937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:13.819",
        "brokerTime": "2025-05-14 12:51:13.819",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024106",
        "positionId": "56024106",
        "volume": 0.21,
        "price": 3234.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "id": "53050938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:13.819",
        "brokerTime": "2025-05-14 12:51:14.242",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024107",
        "positionId": "56024106",
        "volume": 0.21,
        "price": 3234.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.99,
        "takeProfit": null,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "id": "53050939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:14.969",
        "brokerTime": "2025-05-14 12:51:14.969",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024108",
        "positionId": "56024108",
        "volume": 0.21,
        "price": 3234.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "id": "53050940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:14.969",
        "brokerTime": "2025-05-14 12:51:15.266",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024109",
        "positionId": "56024108",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3234.43,
        "doubleCheck": true
    },
    {
        "id": "53050946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15.482",
        "brokerTime": "2025-05-14 12:51:15.482",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024115",
        "positionId": "56024115",
        "volume": 0.21,
        "price": 3234.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.33,
        "doubleCheck": true
    },
    {
        "id": "53050965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:15.482",
        "brokerTime": "2025-05-14 12:51:16.134",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024134",
        "positionId": "56024115",
        "volume": 0.21,
        "price": 3234.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3234.33,
        "doubleCheck": true
    },
    {
        "id": "53050967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:16.305",
        "brokerTime": "2025-05-14 12:51:16.305",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024135",
        "positionId": "56024135",
        "volume": 0.21,
        "price": 3234.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.36,
        "doubleCheck": true
    },
    {
        "id": "53050968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:16.305",
        "brokerTime": "2025-05-14 12:51:18.318",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024136",
        "positionId": "56024135",
        "volume": 0.21,
        "price": 3234.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.25,
        "takeProfit": null,
        "priceIn": 3234.36,
        "doubleCheck": true
    },
    {
        "id": "53050969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:18.482",
        "brokerTime": "2025-05-14 12:51:18.482",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024137",
        "positionId": "56024137",
        "volume": 0.21,
        "price": 3234.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.37,
        "doubleCheck": true
    },
    {
        "id": "53050971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:18.482",
        "brokerTime": "2025-05-14 12:51:21.717",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024139",
        "positionId": "56024137",
        "volume": 0.21,
        "price": 3234.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.67,
        "takeProfit": null,
        "priceIn": 3234.37,
        "doubleCheck": true
    },
    {
        "id": "53050972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:21.888",
        "brokerTime": "2025-05-14 12:51:21.888",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024140",
        "positionId": "56024140",
        "volume": 0.21,
        "price": 3234.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.26,
        "doubleCheck": true
    },
    {
        "id": "53050973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:21.888",
        "brokerTime": "2025-05-14 12:51:22.843",
        "commission": -1.47,
        "swap": 0,
        "profit": 2.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024141",
        "positionId": "56024140",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 1.05,
        "takeProfit": null,
        "priceIn": 3234.26,
        "doubleCheck": true
    },
    {
        "id": "53050974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:23.120",
        "brokerTime": "2025-05-14 12:51:23.120",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024142",
        "positionId": "56024142",
        "volume": 0.21,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3233.95,
        "doubleCheck": true
    },
    {
        "id": "53050975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:23.120",
        "brokerTime": "2025-05-14 12:51:23.958",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024143",
        "positionId": "56024142",
        "volume": 0.21,
        "price": 3234.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.14,
        "takeProfit": null,
        "priceIn": 3233.95,
        "doubleCheck": true
    },
    {
        "id": "53050976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:24.134",
        "brokerTime": "2025-05-14 12:51:24.134",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024144",
        "positionId": "56024144",
        "volume": 0.21,
        "price": 3234.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.03,
        "doubleCheck": true
    },
    {
        "id": "53050979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:24.134",
        "brokerTime": "2025-05-14 12:51:24.828",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024146",
        "positionId": "56024144",
        "volume": 0.21,
        "price": 3234.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.41,
        "takeProfit": null,
        "priceIn": 3234.03,
        "doubleCheck": true
    },
    {
        "id": "53050980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:25.064",
        "brokerTime": "2025-05-14 12:51:25.064",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024147",
        "positionId": "56024147",
        "volume": 0.21,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3233.92,
        "doubleCheck": true
    },
    {
        "id": "53050981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:25.064",
        "brokerTime": "2025-05-14 12:51:26.064",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024148",
        "positionId": "56024147",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3233.92,
        "doubleCheck": true
    },
    {
        "id": "53050982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26.288",
        "brokerTime": "2025-05-14 12:51:26.288",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024149",
        "positionId": "56024149",
        "volume": 0.21,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3233.99,
        "doubleCheck": true
    },
    {
        "id": "53050983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26.288",
        "brokerTime": "2025-05-14 12:51:26.601",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024150",
        "positionId": "56024149",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.77,
        "takeProfit": null,
        "priceIn": 3233.99,
        "doubleCheck": true
    },
    {
        "id": "53050984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26.786",
        "brokerTime": "2025-05-14 12:51:26.786",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024151",
        "positionId": "56024151",
        "volume": 0.21,
        "price": 3234.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "id": "53050985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:26.786",
        "brokerTime": "2025-05-14 12:51:27.125",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024152",
        "positionId": "56024151",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.88,
        "takeProfit": null,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "id": "53050986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27.334",
        "brokerTime": "2025-05-14 12:51:27.334",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024153",
        "positionId": "56024153",
        "volume": 0.21,
        "price": 3234.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.21,
        "doubleCheck": true
    },
    {
        "id": "53050987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:27.334",
        "brokerTime": "2025-05-14 12:51:27.685",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024154",
        "positionId": "56024153",
        "volume": 0.21,
        "price": 3234.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3234.21,
        "doubleCheck": true
    },
    {
        "id": "53050988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28.340",
        "brokerTime": "2025-05-14 12:51:28.340",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024155",
        "positionId": "56024155",
        "volume": 0.21,
        "price": 3234.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.23,
        "doubleCheck": true
    },
    {
        "id": "53050989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28.340",
        "brokerTime": "2025-05-14 12:51:28.690",
        "commission": -1.47,
        "swap": 0,
        "profit": -8.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024156",
        "positionId": "56024155",
        "volume": 0.21,
        "price": 3234.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.870000000000001,
        "takeProfit": null,
        "priceIn": 3234.23,
        "doubleCheck": true
    },
    {
        "id": "53050990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28.841",
        "brokerTime": "2025-05-14 12:51:28.841",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024157",
        "positionId": "56024157",
        "volume": 0.21,
        "price": 3234.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.29,
        "doubleCheck": true
    },
    {
        "id": "53050991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:28.841",
        "brokerTime": "2025-05-14 12:51:29.343",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.57,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024158",
        "positionId": "56024157",
        "volume": 0.21,
        "price": 3234.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.04,
        "takeProfit": null,
        "priceIn": 3234.29,
        "doubleCheck": true
    },
    {
        "id": "53050992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:29.608",
        "brokerTime": "2025-05-14 12:51:29.608",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024159",
        "positionId": "56024159",
        "volume": 0.21,
        "price": 3234.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.22,
        "doubleCheck": true
    },
    {
        "id": "53050993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:29.608",
        "brokerTime": "2025-05-14 12:51:30.273",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.73,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024160",
        "positionId": "56024159",
        "volume": 0.21,
        "price": 3234.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.2,
        "takeProfit": null,
        "priceIn": 3234.22,
        "doubleCheck": true
    },
    {
        "id": "53050994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30.394",
        "brokerTime": "2025-05-14 12:51:30.394",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024161",
        "positionId": "56024161",
        "volume": 0.21,
        "price": 3234.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.19,
        "doubleCheck": true
    },
    {
        "id": "53050995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:30.394",
        "brokerTime": "2025-05-14 12:51:30.797",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024162",
        "positionId": "56024161",
        "volume": 0.21,
        "price": 3234.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3234.19,
        "doubleCheck": true
    },
    {
        "id": "53050996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:31.191",
        "brokerTime": "2025-05-14 12:51:31.191",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024163",
        "positionId": "56024163",
        "volume": 0.21,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "id": "53050997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:31.191",
        "brokerTime": "2025-05-14 12:51:32.006",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024164",
        "positionId": "56024163",
        "volume": 0.21,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "id": "53050998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:32.267",
        "brokerTime": "2025-05-14 12:51:32.267",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024165",
        "positionId": "56024165",
        "volume": 0.21,
        "price": 3234.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.14,
        "doubleCheck": true
    },
    {
        "id": "53050999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:32.267",
        "brokerTime": "2025-05-14 12:51:32.625",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.46,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024166",
        "positionId": "56024165",
        "volume": 0.21,
        "price": 3234.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.93,
        "takeProfit": null,
        "priceIn": 3234.14,
        "doubleCheck": true
    },
    {
        "id": "53051000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:33.094",
        "brokerTime": "2025-05-14 12:51:33.094",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024167",
        "positionId": "56024167",
        "volume": 0.21,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "id": "53051001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:33.094",
        "brokerTime": "2025-05-14 12:51:33.478",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.57,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024168",
        "positionId": "56024167",
        "volume": 0.21,
        "price": 3234.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.04,
        "takeProfit": null,
        "priceIn": 3234.18,
        "doubleCheck": true
    },
    {
        "id": "53051002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35.045",
        "brokerTime": "2025-05-14 12:51:35.045",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024169",
        "positionId": "56024169",
        "volume": 0.21,
        "price": 3234.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.15,
        "doubleCheck": true
    },
    {
        "id": "53051003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35.045",
        "brokerTime": "2025-05-14 12:51:35.608",
        "commission": -1.47,
        "swap": 0,
        "profit": -11.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024170",
        "positionId": "56024169",
        "volume": 0.21,
        "price": 3234.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.440000000000001,
        "takeProfit": null,
        "priceIn": 3234.15,
        "doubleCheck": true
    },
    {
        "id": "53051004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35.804",
        "brokerTime": "2025-05-14 12:51:35.804",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024171",
        "positionId": "56024171",
        "volume": 0.21,
        "price": 3234.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "id": "53051005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:35.804",
        "brokerTime": "2025-05-14 12:51:36.313",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024172",
        "positionId": "56024171",
        "volume": 0.21,
        "price": 3234.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.41,
        "takeProfit": null,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "id": "53051006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:36.727",
        "brokerTime": "2025-05-14 12:51:36.727",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024173",
        "positionId": "56024173",
        "volume": 0.21,
        "price": 3234.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.39,
        "doubleCheck": true
    },
    {
        "id": "53051007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:36.727",
        "brokerTime": "2025-05-14 12:51:37.131",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024174",
        "positionId": "56024173",
        "volume": 0.21,
        "price": 3234.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.14,
        "takeProfit": null,
        "priceIn": 3234.39,
        "doubleCheck": true
    },
    {
        "id": "53051008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37.329",
        "brokerTime": "2025-05-14 12:51:37.329",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024175",
        "positionId": "56024175",
        "volume": 0.21,
        "price": 3234.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.45,
        "doubleCheck": true
    },
    {
        "id": "53051009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:37.329",
        "brokerTime": "2025-05-14 12:51:37.777",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024176",
        "positionId": "56024175",
        "volume": 0.21,
        "price": 3234.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.72,
        "takeProfit": null,
        "priceIn": 3234.45,
        "doubleCheck": true
    },
    {
        "id": "53051010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:38.626",
        "brokerTime": "2025-05-14 12:51:38.626",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024177",
        "positionId": "56024177",
        "volume": 0.21,
        "price": 3234.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.47,
        "doubleCheck": true
    },
    {
        "id": "53051011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:38.626",
        "brokerTime": "2025-05-14 12:51:40.701",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024178",
        "positionId": "56024177",
        "volume": 0.21,
        "price": 3234.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3234.47,
        "doubleCheck": true
    },
    {
        "id": "53051012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:40.824",
        "brokerTime": "2025-05-14 12:51:40.824",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024179",
        "positionId": "56024179",
        "volume": 0.21,
        "price": 3234.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.84,
        "doubleCheck": true
    },
    {
        "id": "53051013",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:40.824",
        "brokerTime": "2025-05-14 12:51:42.077",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024180",
        "positionId": "56024179",
        "volume": 0.21,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.19,
        "takeProfit": null,
        "priceIn": 3234.84,
        "doubleCheck": true
    },
    {
        "id": "53051014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:42.165",
        "brokerTime": "2025-05-14 12:51:42.165",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024181",
        "positionId": "56024181",
        "volume": 0.21,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "id": "53051015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:42.165",
        "brokerTime": "2025-05-14 12:51:42.842",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024182",
        "positionId": "56024181",
        "volume": 0.21,
        "price": 3235.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "id": "53051016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:45.504",
        "brokerTime": "2025-05-14 12:51:45.504",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024183",
        "positionId": "56024183",
        "volume": 0.21,
        "price": 3234.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.95,
        "doubleCheck": true
    },
    {
        "id": "53051017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:45.504",
        "brokerTime": "2025-05-14 12:51:45.973",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024184",
        "positionId": "56024183",
        "volume": 0.21,
        "price": 3235.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.25,
        "takeProfit": null,
        "priceIn": 3234.95,
        "doubleCheck": true
    },
    {
        "id": "53051018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46.087",
        "brokerTime": "2025-05-14 12:51:46.087",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024185",
        "positionId": "56024185",
        "volume": 0.21,
        "price": 3234.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "id": "53051019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46.087",
        "brokerTime": "2025-05-14 12:51:46.603",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024186",
        "positionId": "56024185",
        "volume": 0.21,
        "price": 3235.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.67,
        "takeProfit": null,
        "priceIn": 3234.93,
        "doubleCheck": true
    },
    {
        "id": "53051020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46.960",
        "brokerTime": "2025-05-14 12:51:46.960",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024187",
        "positionId": "56024187",
        "volume": 0.21,
        "price": 3234.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "id": "53051021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:46.960",
        "brokerTime": "2025-05-14 12:51:47.284",
        "commission": -1.47,
        "swap": 0,
        "profit": -9.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024188",
        "positionId": "56024187",
        "volume": 0.21,
        "price": 3235.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.71,
        "takeProfit": null,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "id": "53051022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:47.839",
        "brokerTime": "2025-05-14 12:51:47.839",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024189",
        "positionId": "56024189",
        "volume": 0.21,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.98,
        "doubleCheck": true
    },
    {
        "id": "53051023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:47.839",
        "brokerTime": "2025-05-14 12:51:48.696",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024190",
        "positionId": "56024189",
        "volume": 0.21,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.51,
        "takeProfit": null,
        "priceIn": 3234.98,
        "doubleCheck": true
    },
    {
        "id": "53051024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:48.942",
        "brokerTime": "2025-05-14 12:51:48.942",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024191",
        "positionId": "56024191",
        "volume": 0.21,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "id": "53051025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:48.942",
        "brokerTime": "2025-05-14 12:51:49.688",
        "commission": -1.47,
        "swap": 0,
        "profit": -2.73,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024192",
        "positionId": "56024191",
        "volume": 0.21,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.2,
        "takeProfit": null,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "id": "53051026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:49.984",
        "brokerTime": "2025-05-14 12:51:49.984",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024193",
        "positionId": "56024193",
        "volume": 0.21,
        "price": 3234.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.94,
        "doubleCheck": true
    },
    {
        "id": "53051027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:49.984",
        "brokerTime": "2025-05-14 12:51:51.120",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024194",
        "positionId": "56024193",
        "volume": 0.21,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3234.94,
        "doubleCheck": true
    },
    {
        "id": "53051028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:51.713",
        "brokerTime": "2025-05-14 12:51:51.713",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024195",
        "positionId": "56024195",
        "volume": 0.21,
        "price": 3235.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.36,
        "doubleCheck": true
    },
    {
        "id": "53051030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:51.713",
        "brokerTime": "2025-05-14 12:51:52.112",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024197",
        "positionId": "56024195",
        "volume": 0.21,
        "price": 3235.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.25,
        "takeProfit": null,
        "priceIn": 3235.36,
        "doubleCheck": true
    },
    {
        "id": "53051031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52.373",
        "brokerTime": "2025-05-14 12:51:52.373",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024198",
        "positionId": "56024198",
        "volume": 0.21,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.31,
        "doubleCheck": true
    },
    {
        "id": "53051032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:52.373",
        "brokerTime": "2025-05-14 12:51:52.876",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024199",
        "positionId": "56024198",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.62,
        "takeProfit": null,
        "priceIn": 3235.31,
        "doubleCheck": true
    },
    {
        "id": "53051033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:53.113",
        "brokerTime": "2025-05-14 12:51:53.113",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024200",
        "positionId": "56024200",
        "volume": 0.21,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.22,
        "doubleCheck": true
    },
    {
        "id": "53051034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:53.113",
        "brokerTime": "2025-05-14 12:51:54.068",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024201",
        "positionId": "56024200",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.51,
        "takeProfit": null,
        "priceIn": 3235.22,
        "doubleCheck": true
    },
    {
        "id": "53051036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:54.605",
        "brokerTime": "2025-05-14 12:51:54.605",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024203",
        "positionId": "56024203",
        "volume": 0.21,
        "price": 3235.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.23,
        "doubleCheck": true
    },
    {
        "id": "53051037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:54.605",
        "brokerTime": "2025-05-14 12:51:55.708",
        "commission": -1.47,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024204",
        "positionId": "56024203",
        "volume": 0.21,
        "price": 3235.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.35,
        "takeProfit": null,
        "priceIn": 3235.23,
        "doubleCheck": true
    },
    {
        "id": "53051038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:55.832",
        "brokerTime": "2025-05-14 12:51:55.832",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024205",
        "positionId": "56024205",
        "volume": 0.21,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.34,
        "doubleCheck": true
    },
    {
        "id": "53051039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:55.832",
        "brokerTime": "2025-05-14 12:51:56.224",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024206",
        "positionId": "56024205",
        "volume": 0.21,
        "price": 3235.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.46,
        "takeProfit": null,
        "priceIn": 3235.34,
        "doubleCheck": true
    },
    {
        "id": "53051040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:56.513",
        "brokerTime": "2025-05-14 12:51:56.513",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024207",
        "positionId": "56024207",
        "volume": 0.21,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "id": "53051041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:56.513",
        "brokerTime": "2025-05-14 12:51:57.184",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024208",
        "positionId": "56024207",
        "volume": 0.21,
        "price": 3235.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "id": "53051042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57.509",
        "brokerTime": "2025-05-14 12:51:57.509",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024209",
        "positionId": "56024209",
        "volume": 0.21,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "id": "53051043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57.509",
        "brokerTime": "2025-05-14 12:51:57.756",
        "commission": -1.47,
        "swap": 0,
        "profit": -6.93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024210",
        "positionId": "56024209",
        "volume": 0.21,
        "price": 3235.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.4,
        "takeProfit": null,
        "priceIn": 3235.33,
        "doubleCheck": true
    },
    {
        "id": "53051044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57.941",
        "brokerTime": "2025-05-14 12:51:57.941",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024211",
        "positionId": "56024211",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "id": "53051045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:57.941",
        "brokerTime": "2025-05-14 12:51:58.643",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024212",
        "positionId": "56024211",
        "volume": 0.21,
        "price": 3235.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.25,
        "takeProfit": null,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "id": "53051046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:59.065",
        "brokerTime": "2025-05-14 12:51:59.065",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024213",
        "positionId": "56024213",
        "volume": 0.21,
        "price": 3235.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.45,
        "doubleCheck": true
    },
    {
        "id": "53051047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:51:59.065",
        "brokerTime": "2025-05-14 12:51:59.784",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024214",
        "positionId": "56024213",
        "volume": 0.21,
        "price": 3235.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.83,
        "takeProfit": null,
        "priceIn": 3235.45,
        "doubleCheck": true
    },
    {
        "id": "53051048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:00.112",
        "brokerTime": "2025-05-14 12:52:00.112",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024215",
        "positionId": "56024215",
        "volume": 0.21,
        "price": 3235.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.42,
        "doubleCheck": true
    },
    {
        "id": "53051050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:00.112",
        "brokerTime": "2025-05-14 12:52:00.926",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024217",
        "positionId": "56024215",
        "volume": 0.21,
        "price": 3235.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.09,
        "takeProfit": null,
        "priceIn": 3235.42,
        "doubleCheck": true
    },
    {
        "id": "53051051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:01.105",
        "brokerTime": "2025-05-14 12:52:01.105",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024218",
        "positionId": "56024218",
        "volume": 0.21,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "id": "53051053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:01.105",
        "brokerTime": "2025-05-14 12:52:02.004",
        "commission": -1.47,
        "swap": 0,
        "profit": -3.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024220",
        "positionId": "56024218",
        "volume": 0.21,
        "price": 3235.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.62,
        "takeProfit": null,
        "priceIn": 3235.46,
        "doubleCheck": true
    },
    {
        "id": "53051054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:02.331",
        "brokerTime": "2025-05-14 12:52:02.331",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024221",
        "positionId": "56024221",
        "volume": 0.21,
        "price": 3235.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.44,
        "doubleCheck": true
    },
    {
        "id": "53051056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:02.331",
        "brokerTime": "2025-05-14 12:52:03.362",
        "commission": -1.47,
        "swap": 0,
        "profit": -1.89,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024223",
        "positionId": "56024221",
        "volume": 0.21,
        "price": 3235.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.36,
        "takeProfit": null,
        "priceIn": 3235.44,
        "doubleCheck": true
    },
    {
        "id": "53051057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:03.720",
        "brokerTime": "2025-05-14 12:52:03.720",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024224",
        "positionId": "56024224",
        "volume": 0.21,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "id": "53051059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:03.720",
        "brokerTime": "2025-05-14 12:52:04.165",
        "commission": -1.47,
        "swap": 0,
        "profit": 0.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024228",
        "positionId": "56024224",
        "volume": 0.21,
        "price": 3235.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.26,
        "takeProfit": null,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "id": "53051062",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:52:04.252",
        "brokerTime": "2025-05-14 12:52:04.252",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024229",
        "positionId": "56024229",
        "volume": 0.17,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.21,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3235.21,
        "doubleCheck": true
    },
    {
        "id": "53051076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:04.811",
        "brokerTime": "2025-05-14 12:52:04.811",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024244",
        "positionId": "56024244",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "id": "53051117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:04.811",
        "brokerTime": "2025-05-14 12:52:05.777",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024265",
        "positionId": "56024244",
        "volume": 0.42,
        "price": 3235.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "id": "53051119",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:06.595",
        "brokerTime": "2025-05-14 12:52:06.595",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024267",
        "positionId": "56024267",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "id": "53051120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:06.595",
        "brokerTime": "2025-05-14 12:52:07.037",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024268",
        "positionId": "56024267",
        "volume": 0.42,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.92,
        "takeProfit": null,
        "priceIn": 3235.02,
        "doubleCheck": true
    },
    {
        "id": "53051121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:09.083",
        "brokerTime": "2025-05-14 12:52:09.083",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024269",
        "positionId": "56024269",
        "volume": 0.42,
        "price": 3235.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "id": "53051122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:09.083",
        "brokerTime": "2025-05-14 12:52:10.158",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024270",
        "positionId": "56024269",
        "volume": 0.42,
        "price": 3235.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.72,
        "takeProfit": null,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "id": "53051123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:10.383",
        "brokerTime": "2025-05-14 12:52:10.383",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024271",
        "positionId": "56024271",
        "volume": 0.42,
        "price": 3235.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "id": "53051124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:10.383",
        "brokerTime": "2025-05-14 12:52:11.068",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024272",
        "positionId": "56024271",
        "volume": 0.42,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.5,
        "takeProfit": null,
        "priceIn": 3235.04,
        "doubleCheck": true
    },
    {
        "id": "53051125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:11.263",
        "brokerTime": "2025-05-14 12:52:11.263",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024273",
        "positionId": "56024273",
        "volume": 0.42,
        "price": 3235.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.25,
        "doubleCheck": true
    },
    {
        "id": "53051126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:11.263",
        "brokerTime": "2025-05-14 12:52:11.562",
        "commission": -2.94,
        "swap": 0,
        "profit": -9.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024274",
        "positionId": "56024273",
        "volume": 0.42,
        "price": 3235.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12.18,
        "takeProfit": null,
        "priceIn": 3235.25,
        "doubleCheck": true
    },
    {
        "id": "53051127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12.108",
        "brokerTime": "2025-05-14 12:52:12.108",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024275",
        "positionId": "56024275",
        "volume": 0.42,
        "price": 3235.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "id": "53051128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12.108",
        "brokerTime": "2025-05-14 12:52:12.372",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024276",
        "positionId": "56024275",
        "volume": 0.42,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.92,
        "takeProfit": null,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "id": "53051129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12.551",
        "brokerTime": "2025-05-14 12:52:12.551",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024277",
        "positionId": "56024277",
        "volume": 0.42,
        "price": 3235.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "id": "53051130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:12.551",
        "brokerTime": "2025-05-14 12:52:13.055",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024278",
        "positionId": "56024277",
        "volume": 0.42,
        "price": 3235.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.92,
        "takeProfit": null,
        "priceIn": 3235.27,
        "doubleCheck": true
    },
    {
        "id": "53051131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13.329",
        "brokerTime": "2025-05-14 12:52:13.329",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024279",
        "positionId": "56024279",
        "volume": 0.42,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "id": "53051132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13.329",
        "brokerTime": "2025-05-14 12:52:13.697",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024280",
        "positionId": "56024279",
        "volume": 0.42,
        "price": 3235.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "id": "53051133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13.983",
        "brokerTime": "2025-05-14 12:52:13.983",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024281",
        "positionId": "56024281",
        "volume": 0.42,
        "price": 3235.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.16,
        "doubleCheck": true
    },
    {
        "id": "53051134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:13.983",
        "brokerTime": "2025-05-14 12:52:14.415",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024282",
        "positionId": "56024281",
        "volume": 0.42,
        "price": 3235.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.98,
        "takeProfit": null,
        "priceIn": 3235.16,
        "doubleCheck": true
    },
    {
        "id": "53051135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:15.774",
        "brokerTime": "2025-05-14 12:52:15.774",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024283",
        "positionId": "56024283",
        "volume": 0.42,
        "price": 3235.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.06,
        "doubleCheck": true
    },
    {
        "id": "53051136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:15.774",
        "brokerTime": "2025-05-14 12:52:16.348",
        "commission": -2.94,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024284",
        "positionId": "56024283",
        "volume": 0.42,
        "price": 3235.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.24,
        "takeProfit": null,
        "priceIn": 3235.06,
        "doubleCheck": true
    },
    {
        "id": "53051137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:17.122",
        "brokerTime": "2025-05-14 12:52:17.122",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024285",
        "positionId": "56024285",
        "volume": 0.42,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:17.122",
        "brokerTime": "2025-05-14 12:52:19.083",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024286",
        "positionId": "56024285",
        "volume": 0.42,
        "price": 3235.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.82,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:20.643",
        "brokerTime": "2025-05-14 12:52:20.643",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024287",
        "positionId": "56024287",
        "volume": 0.42,
        "price": 3235.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "id": "53051140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:20.643",
        "brokerTime": "2025-05-14 12:52:20.975",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024288",
        "positionId": "56024287",
        "volume": 0.42,
        "price": 3235.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "takeProfit": null,
        "priceIn": 3235.03,
        "doubleCheck": true
    },
    {
        "id": "53051141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21.093",
        "brokerTime": "2025-05-14 12:52:21.093",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024289",
        "positionId": "56024289",
        "volume": 0.42,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53051142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21.093",
        "brokerTime": "2025-05-14 12:52:21.573",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024290",
        "positionId": "56024289",
        "volume": 0.42,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53051143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21.835",
        "brokerTime": "2025-05-14 12:52:21.835",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024291",
        "positionId": "56024291",
        "volume": 0.42,
        "price": 3234.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.8,
        "doubleCheck": true
    },
    {
        "id": "53051144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:21.835",
        "brokerTime": "2025-05-14 12:52:22.729",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024292",
        "positionId": "56024291",
        "volume": 0.42,
        "price": 3234.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.5,
        "takeProfit": null,
        "priceIn": 3234.8,
        "doubleCheck": true
    },
    {
        "id": "53051146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24.175",
        "brokerTime": "2025-05-14 12:52:24.175",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024294",
        "positionId": "56024294",
        "volume": 0.42,
        "price": 3234.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53051147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24.175",
        "brokerTime": "2025-05-14 12:52:24.493",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024295",
        "positionId": "56024294",
        "volume": 0.42,
        "price": 3234.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.82,
        "takeProfit": null,
        "priceIn": 3234.75,
        "doubleCheck": true
    },
    {
        "id": "53051148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24.704",
        "brokerTime": "2025-05-14 12:52:24.704",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024296",
        "positionId": "56024296",
        "volume": 0.42,
        "price": 3234.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.87,
        "doubleCheck": true
    },
    {
        "id": "53051150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:24.704",
        "brokerTime": "2025-05-14 12:52:25.172",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024298",
        "positionId": "56024296",
        "volume": 0.42,
        "price": 3234.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "takeProfit": null,
        "priceIn": 3234.87,
        "doubleCheck": true
    },
    {
        "id": "53051151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:25.520",
        "brokerTime": "2025-05-14 12:52:25.520",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024299",
        "positionId": "56024299",
        "volume": 0.42,
        "price": 3234.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "id": "53051152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:25.520",
        "brokerTime": "2025-05-14 12:52:26.046",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024300",
        "positionId": "56024299",
        "volume": 0.42,
        "price": 3234.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.82,
        "takeProfit": null,
        "priceIn": 3234.5,
        "doubleCheck": true
    },
    {
        "id": "53051153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:26.836",
        "brokerTime": "2025-05-14 12:52:26.836",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024301",
        "positionId": "56024301",
        "volume": 0.42,
        "price": 3234.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "id": "53051154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:26.836",
        "brokerTime": "2025-05-14 12:52:27.215",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024302",
        "positionId": "56024301",
        "volume": 0.42,
        "price": 3234.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.72,
        "takeProfit": null,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "id": "53051155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:27.556",
        "brokerTime": "2025-05-14 12:52:27.556",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024303",
        "positionId": "56024303",
        "volume": 0.42,
        "price": 3234.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "id": "53051156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:27.556",
        "brokerTime": "2025-05-14 12:52:28.127",
        "commission": -2.94,
        "swap": 0,
        "profit": -4.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024304",
        "positionId": "56024303",
        "volume": 0.42,
        "price": 3234.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.140000000000001,
        "takeProfit": null,
        "priceIn": 3234.08,
        "doubleCheck": true
    },
    {
        "id": "53051158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:28.671",
        "brokerTime": "2025-05-14 12:52:28.671",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024306",
        "positionId": "56024306",
        "volume": 0.42,
        "price": 3233.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.98,
        "doubleCheck": true
    },
    {
        "id": "53051159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:28.671",
        "brokerTime": "2025-05-14 12:52:29.337",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024307",
        "positionId": "56024306",
        "volume": 0.42,
        "price": 3234.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3233.98,
        "doubleCheck": true
    },
    {
        "id": "53051160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:29.573",
        "brokerTime": "2025-05-14 12:52:29.573",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024308",
        "positionId": "56024308",
        "volume": 0.42,
        "price": 3234.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3234.05,
        "doubleCheck": true
    },
    {
        "id": "53051161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:29.573",
        "brokerTime": "2025-05-14 12:52:30.091",
        "commission": -2.94,
        "swap": 0,
        "profit": -2.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024309",
        "positionId": "56024308",
        "volume": 0.42,
        "price": 3234.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.04,
        "takeProfit": null,
        "priceIn": 3234.05,
        "doubleCheck": true
    },
    {
        "id": "53051162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:30.651",
        "brokerTime": "2025-05-14 12:52:30.651",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024310",
        "positionId": "56024310",
        "volume": 0.42,
        "price": 3233.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "id": "53051163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:30.651",
        "brokerTime": "2025-05-14 12:52:31.086",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024311",
        "positionId": "56024310",
        "volume": 0.42,
        "price": 3234.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "id": "53051164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:31.630",
        "brokerTime": "2025-05-14 12:52:31.630",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024312",
        "positionId": "56024312",
        "volume": 0.42,
        "price": 3233.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "id": "53051165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:31.630",
        "brokerTime": "2025-05-14 12:52:32.037",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.46,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024313",
        "positionId": "56024312",
        "volume": 0.42,
        "price": 3233.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.4,
        "takeProfit": null,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "id": "53051166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:32.748",
        "brokerTime": "2025-05-14 12:52:32.748",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024314",
        "positionId": "56024314",
        "volume": 0.42,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.7,
        "doubleCheck": true
    },
    {
        "id": "53051167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:32.748",
        "brokerTime": "2025-05-14 12:52:33.459",
        "commission": -2.94,
        "swap": 0,
        "profit": -17.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024315",
        "positionId": "56024314",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -20.580000000000002,
        "takeProfit": null,
        "priceIn": 3233.7,
        "doubleCheck": true
    },
    {
        "id": "53051168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:33.675",
        "brokerTime": "2025-05-14 12:52:33.675",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024316",
        "positionId": "56024316",
        "volume": 0.42,
        "price": 3233.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "id": "53051169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:33.675",
        "brokerTime": "2025-05-14 12:52:34.056",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024317",
        "positionId": "56024316",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "id": "53051170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34.230",
        "brokerTime": "2025-05-14 12:52:34.230",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024318",
        "positionId": "56024318",
        "volume": 0.42,
        "price": 3233.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.89,
        "doubleCheck": true
    },
    {
        "id": "53051171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34.230",
        "brokerTime": "2025-05-14 12:52:34.574",
        "commission": -2.94,
        "swap": 0,
        "profit": -4.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024319",
        "positionId": "56024318",
        "volume": 0.42,
        "price": 3234,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.5600000000000005,
        "takeProfit": null,
        "priceIn": 3233.89,
        "doubleCheck": true
    },
    {
        "id": "53051172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34.851",
        "brokerTime": "2025-05-14 12:52:34.851",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024320",
        "positionId": "56024320",
        "volume": 0.42,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53051173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:34.851",
        "brokerTime": "2025-05-14 12:52:35.394",
        "commission": -2.94,
        "swap": 0,
        "profit": -5.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024321",
        "positionId": "56024320",
        "volume": 0.42,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.98,
        "takeProfit": null,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53051174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:35.528",
        "brokerTime": "2025-05-14 12:52:35.528",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024322",
        "positionId": "56024322",
        "volume": 0.42,
        "price": 3233.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "id": "53051175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:35.528",
        "brokerTime": "2025-05-14 12:52:35.853",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024323",
        "positionId": "56024322",
        "volume": 0.42,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.86,
        "takeProfit": null,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "id": "53051176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36.354",
        "brokerTime": "2025-05-14 12:52:36.354",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024324",
        "positionId": "56024324",
        "volume": 0.42,
        "price": 3233.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "id": "53051177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:36.354",
        "brokerTime": "2025-05-14 12:52:37.040",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024325",
        "positionId": "56024324",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.02,
        "takeProfit": null,
        "priceIn": 3233.8,
        "doubleCheck": true
    },
    {
        "id": "53051178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:38.020",
        "brokerTime": "2025-05-14 12:52:38.020",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024326",
        "positionId": "56024326",
        "volume": 0.42,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "id": "53051179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:38.020",
        "brokerTime": "2025-05-14 12:52:39.096",
        "commission": -2.94,
        "swap": 0,
        "profit": -6.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024327",
        "positionId": "56024326",
        "volume": 0.42,
        "price": 3233.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.24,
        "takeProfit": null,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "id": "53051180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:39.475",
        "brokerTime": "2025-05-14 12:52:39.475",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024328",
        "positionId": "56024328",
        "volume": 0.42,
        "price": 3233.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.79,
        "doubleCheck": true
    },
    {
        "id": "53051181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:39.475",
        "brokerTime": "2025-05-14 12:52:39.837",
        "commission": -2.94,
        "swap": 0,
        "profit": -10.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024329",
        "positionId": "56024328",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.44,
        "takeProfit": null,
        "priceIn": 3233.79,
        "doubleCheck": true
    },
    {
        "id": "53051182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40.229",
        "brokerTime": "2025-05-14 12:52:40.229",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024330",
        "positionId": "56024330",
        "volume": 0.42,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53051183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40.229",
        "brokerTime": "2025-05-14 12:52:40.576",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024331",
        "positionId": "56024330",
        "volume": 0.42,
        "price": 3234.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.92,
        "takeProfit": null,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53051184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40.753",
        "brokerTime": "2025-05-14 12:52:40.753",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024332",
        "positionId": "56024332",
        "volume": 0.42,
        "price": 3233.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.72,
        "doubleCheck": true
    },
    {
        "id": "53051185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:40.753",
        "brokerTime": "2025-05-14 12:52:41.568",
        "commission": -2.94,
        "swap": 0,
        "profit": -20.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024333",
        "positionId": "56024332",
        "volume": 0.42,
        "price": 3234.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -23.1,
        "takeProfit": null,
        "priceIn": 3233.72,
        "doubleCheck": true
    },
    {
        "id": "53051186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:41.869",
        "brokerTime": "2025-05-14 12:52:41.869",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024334",
        "positionId": "56024334",
        "volume": 0.42,
        "price": 3233.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "id": "53051187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:41.869",
        "brokerTime": "2025-05-14 12:52:42.349",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024335",
        "positionId": "56024334",
        "volume": 0.42,
        "price": 3234.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3233.9,
        "doubleCheck": true
    },
    {
        "id": "53051188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:43.095",
        "brokerTime": "2025-05-14 12:52:43.095",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024336",
        "positionId": "56024336",
        "volume": 0.42,
        "price": 3233.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "id": "53051189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:43.095",
        "brokerTime": "2025-05-14 12:52:44.044",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024337",
        "positionId": "56024336",
        "volume": 0.42,
        "price": 3234.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.76,
        "takeProfit": null,
        "priceIn": 3233.91,
        "doubleCheck": true
    },
    {
        "id": "53051190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:44.726",
        "brokerTime": "2025-05-14 12:52:44.726",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024338",
        "positionId": "56024338",
        "volume": 0.42,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "id": "53051192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:44.726",
        "brokerTime": "2025-05-14 12:52:45.069",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024340",
        "positionId": "56024338",
        "volume": 0.42,
        "price": 3233.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.5,
        "takeProfit": null,
        "priceIn": 3233.81,
        "doubleCheck": true
    },
    {
        "id": "53051193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45.422",
        "brokerTime": "2025-05-14 12:52:45.422",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024341",
        "positionId": "56024341",
        "volume": 0.42,
        "price": 3233.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "id": "53051195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:45.422",
        "brokerTime": "2025-05-14 12:52:46.120",
        "commission": -2.94,
        "swap": 0,
        "profit": -9.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024343",
        "positionId": "56024341",
        "volume": 0.42,
        "price": 3233.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12.6,
        "takeProfit": null,
        "priceIn": 3233.73,
        "doubleCheck": true
    },
    {
        "id": "53051196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:46.280",
        "brokerTime": "2025-05-14 12:52:46.280",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024344",
        "positionId": "56024344",
        "volume": 0.42,
        "price": 3233.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.76,
        "doubleCheck": true
    },
    {
        "id": "53051197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:46.280",
        "brokerTime": "2025-05-14 12:52:47.087",
        "commission": -2.94,
        "swap": 0,
        "profit": -7.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024345",
        "positionId": "56024344",
        "volume": 0.42,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.92,
        "takeProfit": null,
        "priceIn": 3233.76,
        "doubleCheck": true
    },
    {
        "id": "53051198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:47.767",
        "brokerTime": "2025-05-14 12:52:47.767",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024346",
        "positionId": "56024346",
        "volume": 0.42,
        "price": 3233.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.87,
        "doubleCheck": true
    },
    {
        "id": "53051199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:47.767",
        "brokerTime": "2025-05-14 12:52:48.107",
        "commission": -2.94,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024347",
        "positionId": "56024346",
        "volume": 0.42,
        "price": 3233.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.3,
        "takeProfit": null,
        "priceIn": 3233.87,
        "doubleCheck": true
    },
    {
        "id": "53051200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:49.658",
        "brokerTime": "2025-05-14 12:52:49.658",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024348",
        "positionId": "56024348",
        "volume": 0.42,
        "price": 3233.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.75,
        "doubleCheck": true
    },
    {
        "id": "53051201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:49.658",
        "brokerTime": "2025-05-14 12:52:50.049",
        "commission": -2.94,
        "swap": 0,
        "profit": 0.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024349",
        "positionId": "56024348",
        "volume": 0.42,
        "price": 3233.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "takeProfit": null,
        "priceIn": 3233.75,
        "doubleCheck": true
    },
    {
        "id": "53051202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50.382",
        "brokerTime": "2025-05-14 12:52:50.382",
        "commission": -2.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024350",
        "positionId": "56024350",
        "volume": 0.42,
        "price": 3233.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.94,
        "takeProfit": null,
        "priceIn": 3233.51,
        "doubleCheck": true
    },
    {
        "id": "53051203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:52:50.382",
        "brokerTime": "2025-05-14 12:52:50.764",
        "commission": -2.94,
        "swap": 0,
        "profit": -8.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024351",
        "positionId": "56024350",
        "volume": 0.42,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -11.34,
        "takeProfit": null,
        "priceIn": 3233.51,
        "doubleCheck": true
    },
    {
        "id": "53051204",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:52:04.252",
        "brokerTime": "2025-05-14 12:52:50.799",
        "commission": -1.19,
        "swap": 0,
        "profit": -28.73,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024352",
        "positionId": "56024229",
        "volume": 0.17,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.01,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -29.92,
        "priceIn": 3235.21,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7",
        "tProfit": -101.91,
        "tnProfit": -105.62,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53051205",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:51:00.299",
        "brokerTime": "2025-05-14 12:52:50.855",
        "commission": -0.98,
        "swap": 0,
        "profit": -26.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024353",
        "positionId": "56024047",
        "volume": 0.14,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -27.02,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "id": "53051206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:50:00.128",
        "brokerTime": "2025-05-14 12:52:50.872",
        "commission": -0.84,
        "swap": 0,
        "profit": 27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024354",
        "positionId": "56023584",
        "volume": 0.12,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.15,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 26.16,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "id": "53051207",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:23.762",
        "brokerTime": "2025-05-14 12:52:50.889",
        "commission": -0.84,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024355",
        "positionId": "56023329",
        "volume": 0.12,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -25.68,
        "priceIn": 3235.59,
        "doubleCheck": true
    },
    {
        "id": "53051208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:49:21.406",
        "brokerTime": "2025-05-14 12:52:50.945",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024356",
        "positionId": "56023327",
        "volume": 0.1,
        "price": 3233.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.19,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 18.400000000000002,
        "priceIn": 3235.62,
        "doubleCheck": true
    },
    {
        "id": "53051209",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:49:20.666",
        "brokerTime": "2025-05-14 12:52:50.995",
        "commission": -0.7,
        "swap": 0,
        "profit": -22.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024357",
        "positionId": "56023326",
        "volume": 0.1,
        "price": 3233.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -23,
        "priceIn": 3235.75,
        "doubleCheck": true
    },
    {
        "id": "53051351",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:33.401",
        "brokerTime": "2025-05-14 12:53:33.401",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024472",
        "positionId": "56024472",
        "volume": 1,
        "price": 3234.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.01,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "id": "53051352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:34.594",
        "brokerTime": "2025-05-14 12:53:34.594",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024473",
        "positionId": "56024473",
        "volume": 1,
        "price": 3234.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.82,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "id": "53051353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:38.438",
        "brokerTime": "2025-05-14 12:53:38.438",
        "commission": -8.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024474",
        "positionId": "56024474",
        "volume": 1.2,
        "price": 3234.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.97,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.4,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "id": "53051355",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.258",
        "brokerTime": "2025-05-14 12:53:45.258",
        "commission": -2.87,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024476",
        "positionId": "56024476",
        "volume": 0.41,
        "price": 3235.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.87,
        "takeProfit": null,
        "priceIn": 3235.05,
        "doubleCheck": true
    },
    {
        "id": "53051356",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.497",
        "brokerTime": "2025-05-14 12:53:45.497",
        "commission": -2.66,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024477",
        "positionId": "56024477",
        "volume": 0.38,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.66,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051357",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.734",
        "brokerTime": "2025-05-14 12:53:45.734",
        "commission": -2.17,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024478",
        "positionId": "56024478",
        "volume": 0.31,
        "price": 3235.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.17,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051358",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.961",
        "brokerTime": "2025-05-14 12:53:45.961",
        "commission": -1.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024479",
        "positionId": "56024479",
        "volume": 0.28,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.96,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "id": "53051359",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46.209",
        "brokerTime": "2025-05-14 12:53:46.209",
        "commission": -1.82,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024480",
        "positionId": "56024480",
        "volume": 0.26,
        "price": 3235.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.82,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "id": "53051360",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:46.209",
        "brokerTime": "2025-05-14 12:53:53.290",
        "commission": -1.82,
        "swap": 0,
        "profit": 2.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024481",
        "positionId": "56024480",
        "volume": 0.26,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0.78,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9",
        "tProfit": 59.06,
        "tnProfit": 40.58,
        "tVolume": 2.6399999999999997,
        "tTrades": 6
    },
    {
        "id": "53051361",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.961",
        "brokerTime": "2025-05-14 12:53:53.319",
        "commission": -1.96,
        "swap": 0,
        "profit": 2.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024482",
        "positionId": "56024479",
        "volume": 0.28,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0.8399999999999999,
        "takeProfit": null,
        "priceIn": 3235.07,
        "doubleCheck": true
    },
    {
        "id": "53051362",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.734",
        "brokerTime": "2025-05-14 12:53:53.421",
        "commission": -2.17,
        "swap": 0,
        "profit": 2.79,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024483",
        "positionId": "56024478",
        "volume": 0.31,
        "price": 3235.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0.6200000000000001,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051363",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.497",
        "brokerTime": "2025-05-14 12:53:53.485",
        "commission": -2.66,
        "swap": 0,
        "profit": 3.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024484",
        "positionId": "56024477",
        "volume": 0.38,
        "price": 3235.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 1.1399999999999997,
        "takeProfit": null,
        "priceIn": 3235.08,
        "doubleCheck": true
    },
    {
        "id": "53051364",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:45.258",
        "brokerTime": "2025-05-14 12:53:53.538",
        "commission": -2.87,
        "swap": 0,
        "profit": 11.07,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024485",
        "positionId": "56024476",
        "volume": 0.41,
        "price": 3235.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 8.2,
        "takeProfit": null,
        "priceIn": 3235.05,
        "doubleCheck": true
    },
    {
        "id": "53051365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:38.438",
        "brokerTime": "2025-05-14 12:53:53.585",
        "commission": -8.4,
        "swap": 0,
        "profit": -63.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024486",
        "positionId": "56024474",
        "volume": 1.2,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.16,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72,
        "priceIn": 3234.97,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10",
        "tProfit": -131.6,
        "tnProfit": -147,
        "tVolume": 2.2,
        "tTrades": 2
    },
    {
        "id": "53051366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:53:34.594",
        "brokerTime": "2025-05-14 12:53:53.665",
        "commission": -7,
        "swap": 0,
        "profit": -68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024487",
        "positionId": "56024473",
        "volume": 1,
        "price": 3235.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.16,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75,
        "priceIn": 3234.82,
        "doubleCheck": true
    },
    {
        "id": "53051367",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:53:33.401",
        "brokerTime": "2025-05-14 12:53:53.687",
        "commission": -7,
        "swap": 0,
        "profit": 36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024488",
        "positionId": "56024472",
        "volume": 1,
        "price": 3235.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.75,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 29,
        "priceIn": 3234.97,
        "doubleCheck": true
    },
    {
        "id": "53051373",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:54:52.688",
        "brokerTime": "2025-05-14 12:54:52.688",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024494",
        "positionId": "56024494",
        "volume": 1,
        "price": 3234.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.52,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7,
        "priceIn": 3234.52,
        "doubleCheck": true
    },
    {
        "id": "53051374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:53.610",
        "brokerTime": "2025-05-14 12:54:53.610",
        "commission": -7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024496",
        "positionId": "56024496",
        "volume": 1,
        "price": 3234.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.3,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "id": "53051376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:57.268",
        "brokerTime": "2025-05-14 12:54:57.268",
        "commission": -8.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024497",
        "positionId": "56024497",
        "volume": 1.2,
        "price": 3234.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.4,
        "priceIn": 3234.6,
        "doubleCheck": true
    },
    {
        "id": "53051380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:00.320",
        "brokerTime": "2025-05-14 12:55:00.320",
        "commission": -10.08,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024501",
        "positionId": "56024501",
        "volume": 1.44,
        "price": 3234.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.91,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.08,
        "priceIn": 3234.91,
        "doubleCheck": true
    },
    {
        "id": "53051382",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:01.254",
        "brokerTime": "2025-05-14 12:55:01.254",
        "commission": -23.59,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024503",
        "positionId": "56024503",
        "volume": 3.37,
        "price": 3235.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -23.59,
        "takeProfit": null,
        "priceIn": 3235.12,
        "doubleCheck": true
    },
    {
        "id": "53051384",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:01.254",
        "brokerTime": "2025-05-14 12:55:07.115",
        "commission": -23.59,
        "swap": 0,
        "profit": -104.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024504",
        "positionId": "56024503",
        "volume": 3.37,
        "price": 3234.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -128.06,
        "takeProfit": null,
        "priceIn": 3235.12,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11",
        "tProfit": -75.47,
        "tnProfit": -106.06,
        "tVolume": 4.37,
        "tTrades": 2
    },
    {
        "id": "53051385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:00.320",
        "brokerTime": "2025-05-14 12:55:07.183",
        "commission": -10.08,
        "swap": 0,
        "profit": -14.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024505",
        "positionId": "56024501",
        "volume": 1.44,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.13,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -24.48,
        "priceIn": 3234.91,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12",
        "tProfit": -134.6,
        "tnProfit": -160.08,
        "tVolume": 3.6399999999999997,
        "tTrades": 3
    },
    {
        "id": "53051386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:57.268",
        "brokerTime": "2025-05-14 12:55:07.205",
        "commission": -8.4,
        "swap": 0,
        "profit": -49.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024506",
        "positionId": "56024497",
        "volume": 1.2,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.12,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.6,
        "priceIn": 3234.6,
        "doubleCheck": true
    },
    {
        "id": "53051387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:54:53.610",
        "brokerTime": "2025-05-14 12:55:07.247",
        "commission": -7,
        "swap": 0,
        "profit": -71,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024507",
        "positionId": "56024496",
        "volume": 1,
        "price": 3235.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.12,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78,
        "priceIn": 3234.3,
        "doubleCheck": true
    },
    {
        "id": "53051388",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:54:52.688",
        "brokerTime": "2025-05-14 12:55:07.288",
        "commission": -7,
        "swap": 0,
        "profit": 29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024508",
        "positionId": "56024494",
        "volume": 1,
        "price": 3234.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.3,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 22,
        "priceIn": 3234.52,
        "doubleCheck": true
    },
    {
        "id": "53051481",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:46.999",
        "brokerTime": "2025-05-14 12:55:46.999",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024597",
        "positionId": "56024597",
        "volume": 0.1,
        "price": 3234.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.44,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.44,
        "doubleCheck": true
    },
    {
        "id": "53051483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:48.161",
        "brokerTime": "2025-05-14 12:55:48.161",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024599",
        "positionId": "56024599",
        "volume": 0.1,
        "price": 3234.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.41,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.41,
        "doubleCheck": true
    },
    {
        "id": "53051491",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:56:00.135",
        "brokerTime": "2025-05-14 12:56:00.135",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024607",
        "positionId": "56024607",
        "volume": 0.12,
        "price": 3233.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.65,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3233.65,
        "doubleCheck": true
    },
    {
        "id": "53051556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:06.894",
        "brokerTime": "2025-05-14 12:56:06.894",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024653",
        "positionId": "56024653",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53051557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.139",
        "brokerTime": "2025-05-14 12:56:07.139",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024654",
        "positionId": "56024654",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53051558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.399",
        "brokerTime": "2025-05-14 12:56:07.399",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024655",
        "positionId": "56024655",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53051559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.722",
        "brokerTime": "2025-05-14 12:56:07.722",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024656",
        "positionId": "56024656",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53051560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.972",
        "brokerTime": "2025-05-14 12:56:07.972",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024657",
        "positionId": "56024657",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53051561",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.972",
        "brokerTime": "2025-05-14 12:56:08.335",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024658",
        "positionId": "56024657",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.6,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14",
        "tProfit": -3.33,
        "tnProfit": -6.41,
        "tVolume": 0.44000000000000006,
        "tTrades": 11
    },
    {
        "id": "53051562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.722",
        "brokerTime": "2025-05-14 12:56:08.345",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024659",
        "positionId": "56024656",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.6,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53051563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.399",
        "brokerTime": "2025-05-14 12:56:08.414",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024660",
        "positionId": "56024655",
        "volume": 0.03,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.6,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53051564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:07.139",
        "brokerTime": "2025-05-14 12:56:08.434",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024661",
        "positionId": "56024654",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.76,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53051565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:56:06.894",
        "brokerTime": "2025-05-14 12:56:08.459",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024662",
        "positionId": "56024653",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.76,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53051638",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:56:00.135",
        "brokerTime": "2025-05-14 12:56:16.402",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024727",
        "positionId": "56024607",
        "volume": 0.12,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.45,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 2.4000000000000004,
        "priceIn": 3233.65,
        "doubleCheck": false,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13",
        "tProfit": -1.96,
        "tnProfit": -3.5,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53051639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:55:48.161",
        "brokerTime": "2025-05-14 12:56:16.426",
        "commission": -0.7,
        "swap": 0,
        "profit": 2.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024728",
        "positionId": "56024599",
        "volume": 0.1,
        "price": 3234.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 2.0999999999999996,
        "priceIn": 3234.41,
        "doubleCheck": false
    },
    {
        "id": "53051640",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:55:46.999",
        "brokerTime": "2025-05-14 12:56:16.453",
        "commission": -0.7,
        "swap": 0,
        "profit": -5.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56024729",
        "positionId": "56024597",
        "volume": 0.1,
        "price": 3233.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.45,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.9,
        "priceIn": 3234.44,
        "doubleCheck": false
    },
    {
        "id": "53052061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:04.994",
        "brokerTime": "2025-05-14 12:57:04.994",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025093",
        "positionId": "56025093",
        "volume": 0.1,
        "price": 3234.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.17,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.17,
        "doubleCheck": true
    },
    {
        "id": "53052062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:05.807",
        "brokerTime": "2025-05-14 12:57:05.807",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025094",
        "positionId": "56025094",
        "volume": 0.1,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.97,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "id": "53052065",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:07.788",
        "brokerTime": "2025-05-14 12:57:07.788",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025097",
        "positionId": "56025097",
        "volume": 0.12,
        "price": 3233.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "id": "53052066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.431",
        "brokerTime": "2025-05-14 12:57:14.431",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025098",
        "positionId": "56025098",
        "volume": 0.04,
        "price": 3233.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53052067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.663",
        "brokerTime": "2025-05-14 12:57:14.663",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025099",
        "positionId": "56025099",
        "volume": 0.04,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53052068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.907",
        "brokerTime": "2025-05-14 12:57:14.907",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025100",
        "positionId": "56025100",
        "volume": 0.03,
        "price": 3233.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53052069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15.141",
        "brokerTime": "2025-05-14 12:57:15.141",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025101",
        "positionId": "56025101",
        "volume": 0.03,
        "price": 3233.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.49,
        "doubleCheck": true
    },
    {
        "id": "53052070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15.411",
        "brokerTime": "2025-05-14 12:57:15.411",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025103",
        "positionId": "56025103",
        "volume": 0.03,
        "price": 3233.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.48,
        "doubleCheck": true
    },
    {
        "id": "53052072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15.411",
        "brokerTime": "2025-05-14 12:57:15.656",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025104",
        "positionId": "56025103",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.87,
        "takeProfit": null,
        "priceIn": 3233.48,
        "doubleCheck": true
    },
    {
        "id": "53052073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:15.141",
        "brokerTime": "2025-05-14 12:57:15.667",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025105",
        "positionId": "56025101",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "takeProfit": null,
        "priceIn": 3233.49,
        "doubleCheck": true
    },
    {
        "id": "53052074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.907",
        "brokerTime": "2025-05-14 12:57:15.680",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025106",
        "positionId": "56025100",
        "volume": 0.03,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.96,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53052075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.663",
        "brokerTime": "2025-05-14 12:57:15.717",
        "commission": -0.28,
        "swap": 0,
        "profit": -1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025107",
        "positionId": "56025099",
        "volume": 0.04,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.28,
        "takeProfit": null,
        "priceIn": 3233.45,
        "doubleCheck": true
    },
    {
        "id": "53052076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:14.431",
        "brokerTime": "2025-05-14 12:57:15.731",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025108",
        "positionId": "56025098",
        "volume": 0.04,
        "price": 3233.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.24,
        "takeProfit": null,
        "priceIn": 3233.46,
        "doubleCheck": true
    },
    {
        "id": "53052172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:29.729",
        "brokerTime": "2025-05-14 12:58:29.729",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025180",
        "positionId": "56025180",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:29.970",
        "brokerTime": "2025-05-14 12:58:29.970",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025181",
        "positionId": "56025181",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.202",
        "brokerTime": "2025-05-14 12:58:30.202",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025182",
        "positionId": "56025182",
        "volume": 0.03,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.440",
        "brokerTime": "2025-05-14 12:58:30.440",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025183",
        "positionId": "56025183",
        "volume": 0.03,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.652",
        "brokerTime": "2025-05-14 12:58:30.652",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025184",
        "positionId": "56025184",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53052177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.652",
        "brokerTime": "2025-05-14 12:58:30.982",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025186",
        "positionId": "56025184",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53052179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.440",
        "brokerTime": "2025-05-14 12:58:31.006",
        "commission": -0.21,
        "swap": 0,
        "profit": 0.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025187",
        "positionId": "56025183",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.18,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16",
        "tProfit": 3.11,
        "tnProfit": -1.51,
        "tVolume": 0.6600000000000001,
        "tTrades": 13
    },
    {
        "id": "53052180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:30.202",
        "brokerTime": "2025-05-14 12:58:31.025",
        "commission": -0.21,
        "swap": 0,
        "profit": 0.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025188",
        "positionId": "56025182",
        "volume": 0.03,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.18,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:29.970",
        "brokerTime": "2025-05-14 12:58:31.062",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025189",
        "positionId": "56025181",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:29.729",
        "brokerTime": "2025-05-14 12:58:31.094",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025190",
        "positionId": "56025180",
        "volume": 0.04,
        "price": 3232.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3232.9,
        "doubleCheck": true
    },
    {
        "id": "53052184",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:58:38.125",
        "brokerTime": "2025-05-14 12:58:38.125",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025192",
        "positionId": "56025192",
        "volume": 0.14,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.88,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "id": "53052185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.258",
        "brokerTime": "2025-05-14 12:58:42.258",
        "commission": -0.56,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025193",
        "positionId": "56025193",
        "volume": 0.08,
        "price": 3232.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.56,
        "takeProfit": null,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "id": "53052186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.477",
        "brokerTime": "2025-05-14 12:58:42.477",
        "commission": -0.56,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025194",
        "positionId": "56025194",
        "volume": 0.08,
        "price": 3232.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.56,
        "takeProfit": null,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "id": "53052187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.694",
        "brokerTime": "2025-05-14 12:58:42.694",
        "commission": -0.42,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025195",
        "positionId": "56025195",
        "volume": 0.06,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.42,
        "takeProfit": null,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53052188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43.001",
        "brokerTime": "2025-05-14 12:58:43.001",
        "commission": -0.42,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025196",
        "positionId": "56025196",
        "volume": 0.06,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.42,
        "takeProfit": null,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "id": "53052189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43.226",
        "brokerTime": "2025-05-14 12:58:43.226",
        "commission": -0.35,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025197",
        "positionId": "56025197",
        "volume": 0.05,
        "price": 3232.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.35,
        "takeProfit": null,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "id": "53052190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43.226",
        "brokerTime": "2025-05-14 12:58:43.484",
        "commission": -0.35,
        "swap": 0,
        "profit": -1.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025198",
        "positionId": "56025197",
        "volume": 0.05,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.4,
        "takeProfit": null,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "id": "53052191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:43.001",
        "brokerTime": "2025-05-14 12:58:43.499",
        "commission": -0.42,
        "swap": 0,
        "profit": -1.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025199",
        "positionId": "56025196",
        "volume": 0.06,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.68,
        "takeProfit": null,
        "priceIn": 3232.88,
        "doubleCheck": true
    },
    {
        "id": "53052192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.694",
        "brokerTime": "2025-05-14 12:58:43.533",
        "commission": -0.42,
        "swap": 0,
        "profit": -1.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025200",
        "positionId": "56025195",
        "volume": 0.06,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.6199999999999999,
        "takeProfit": null,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53052193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.477",
        "brokerTime": "2025-05-14 12:58:43.540",
        "commission": -0.56,
        "swap": 0,
        "profit": -1.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025201",
        "positionId": "56025194",
        "volume": 0.08,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.3200000000000003,
        "takeProfit": null,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "id": "53052194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:58:42.258",
        "brokerTime": "2025-05-14 12:58:43.545",
        "commission": -0.56,
        "swap": 0,
        "profit": -1.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025202",
        "positionId": "56025193",
        "volume": 0.08,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.3200000000000003,
        "takeProfit": null,
        "priceIn": 3232.87,
        "doubleCheck": true
    },
    {
        "id": "53052202",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:58:38.125",
        "brokerTime": "2025-05-14 12:59:22.276",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025210",
        "positionId": "56025192",
        "volume": 0.14,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.300000000000001,
        "priceIn": 3232.88,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15",
        "tProfit": -39.66,
        "tnProfit": -42.18,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "id": "53052203",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:07.788",
        "brokerTime": "2025-05-14 12:59:22.300",
        "commission": -0.84,
        "swap": 0,
        "profit": -17.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025211",
        "positionId": "56025097",
        "volume": 0.12,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -18.48,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "id": "53052204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:57:05.807",
        "brokerTime": "2025-05-14 12:59:22.316",
        "commission": -0.7,
        "swap": 0,
        "profit": 12.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025212",
        "positionId": "56025094",
        "volume": 0.1,
        "price": 3232.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.17,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 11.8,
        "priceIn": 3233.97,
        "doubleCheck": true
    },
    {
        "id": "53052205",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:57:04.994",
        "brokerTime": "2025-05-14 12:59:22.349",
        "commission": -0.7,
        "swap": 0,
        "profit": -16.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025213",
        "positionId": "56025093",
        "volume": 0.1,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.67,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -17.4,
        "priceIn": 3234.17,
        "doubleCheck": true
    },
    {
        "id": "53052207",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:59:58.854",
        "brokerTime": "2025-05-14 12:59:58.854",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025215",
        "positionId": "56025215",
        "volume": 0.1,
        "price": 3232.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.52,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3232.57,
        "doubleCheck": true
    },
    {
        "id": "53052208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:59:59.996",
        "brokerTime": "2025-05-14 12:59:59.996",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025216",
        "positionId": "56025216",
        "volume": 0.1,
        "price": 3232.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.33,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3232.33,
        "doubleCheck": true
    },
    {
        "id": "53052279",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:00:01.662",
        "brokerTime": "2025-05-14 13:00:01.662",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56025272",
        "positionId": "56025272",
        "volume": 0.12,
        "price": 3232.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.32,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3232.32,
        "doubleCheck": true
    },
    {
        "id": "53053398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:08.774",
        "brokerTime": "2025-05-14 13:00:08.774",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026283",
        "positionId": "56026283",
        "volume": 0.04,
        "price": 3231.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "id": "53053399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.019",
        "brokerTime": "2025-05-14 13:00:09.019",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026284",
        "positionId": "56026284",
        "volume": 0.04,
        "price": 3231.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "id": "53053401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.320",
        "brokerTime": "2025-05-14 13:00:09.320",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026286",
        "positionId": "56026286",
        "volume": 0.03,
        "price": 3231.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3231.79,
        "doubleCheck": true
    },
    {
        "id": "53053402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.673",
        "brokerTime": "2025-05-14 13:00:09.673",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026287",
        "positionId": "56026287",
        "volume": 0.03,
        "price": 3231.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3231.72,
        "doubleCheck": true
    },
    {
        "id": "53053404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.935",
        "brokerTime": "2025-05-14 13:00:09.935",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026289",
        "positionId": "56026289",
        "volume": 0.03,
        "price": 3231.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3231.74,
        "doubleCheck": true
    },
    {
        "id": "53053406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.935",
        "brokerTime": "2025-05-14 13:00:10.464",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.57,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026291",
        "positionId": "56026289",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7799999999999999,
        "takeProfit": null,
        "priceIn": 3231.74,
        "doubleCheck": true
    },
    {
        "id": "53053407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.673",
        "brokerTime": "2025-05-14 13:00:10.474",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026292",
        "positionId": "56026287",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "takeProfit": null,
        "priceIn": 3231.72,
        "doubleCheck": true
    },
    {
        "id": "53053408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.320",
        "brokerTime": "2025-05-14 13:00:10.547",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026293",
        "positionId": "56026286",
        "volume": 0.03,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.63,
        "takeProfit": null,
        "priceIn": 3231.79,
        "doubleCheck": true
    },
    {
        "id": "53053409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:09.019",
        "brokerTime": "2025-05-14 13:00:10.563",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026294",
        "positionId": "56026284",
        "volume": 0.04,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.68,
        "takeProfit": null,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "id": "53053410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:00:08.774",
        "brokerTime": "2025-05-14 13:00:10.619",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026295",
        "positionId": "56026283",
        "volume": 0.04,
        "price": 3231.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.68,
        "takeProfit": null,
        "priceIn": 3231.83,
        "doubleCheck": true
    },
    {
        "id": "53053637",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:05:59.457",
        "brokerTime": "2025-05-14 13:05:59.457",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026494",
        "positionId": "56026494",
        "volume": 0.14,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3230.88,
        "doubleCheck": true
    },
    {
        "id": "53053647",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:10.886",
        "brokerTime": "2025-05-14 13:06:10.886",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026501",
        "positionId": "56026501",
        "volume": 0.17,
        "price": 3230.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.75,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3230.75,
        "doubleCheck": true
    },
    {
        "id": "53053652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36.120",
        "brokerTime": "2025-05-14 13:06:36.120",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026506",
        "positionId": "56026506",
        "volume": 0.54,
        "price": 3230.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "id": "53053653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36.120",
        "brokerTime": "2025-05-14 13:06:36.349",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026507",
        "positionId": "56026506",
        "volume": 0.54,
        "price": 3230.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.12,
        "takeProfit": null,
        "priceIn": 3230.41,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
        "tProfit": -107.84,
        "tnProfit": -140.32,
        "tVolume": 4.64,
        "tTrades": 11
    },
    {
        "id": "53053654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36.661",
        "brokerTime": "2025-05-14 13:06:36.661",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026508",
        "positionId": "56026508",
        "volume": 0.54,
        "price": 3230.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "id": "53053655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:36.661",
        "brokerTime": "2025-05-14 13:06:36.897",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026509",
        "positionId": "56026508",
        "volume": 0.54,
        "price": 3230.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.12,
        "takeProfit": null,
        "priceIn": 3230.41,
        "doubleCheck": true
    },
    {
        "id": "53053656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37.131",
        "brokerTime": "2025-05-14 13:06:37.131",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026510",
        "positionId": "56026510",
        "volume": 0.54,
        "price": 3230.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.59,
        "doubleCheck": true
    },
    {
        "id": "53053657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:37.131",
        "brokerTime": "2025-05-14 13:06:37.390",
        "commission": -3.78,
        "swap": 0,
        "profit": -16.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026511",
        "positionId": "56026510",
        "volume": 0.54,
        "price": 3230.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -19.98,
        "takeProfit": null,
        "priceIn": 3230.59,
        "doubleCheck": true
    },
    {
        "id": "53053658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:38.189",
        "brokerTime": "2025-05-14 13:06:38.189",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026512",
        "positionId": "56026512",
        "volume": 0.54,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.68,
        "doubleCheck": true
    },
    {
        "id": "53053659",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:38.189",
        "brokerTime": "2025-05-14 13:06:38.423",
        "commission": -3.78,
        "swap": 0,
        "profit": -10.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026513",
        "positionId": "56026512",
        "volume": 0.54,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -14.58,
        "takeProfit": null,
        "priceIn": 3230.68,
        "doubleCheck": true
    },
    {
        "id": "53053661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:40.569",
        "brokerTime": "2025-05-14 13:06:40.569",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026515",
        "positionId": "56026515",
        "volume": 0.54,
        "price": 3230.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.58,
        "doubleCheck": true
    },
    {
        "id": "53053662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:40.569",
        "brokerTime": "2025-05-14 13:06:40.913",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026516",
        "positionId": "56026515",
        "volume": 0.54,
        "price": 3230.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.66,
        "takeProfit": null,
        "priceIn": 3230.58,
        "doubleCheck": true
    },
    {
        "id": "53053663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:40.993",
        "brokerTime": "2025-05-14 13:06:40.993",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026518",
        "positionId": "56026518",
        "volume": 0.54,
        "price": 3230.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "id": "53053665",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:40.993",
        "brokerTime": "2025-05-14 13:06:41.211",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026519",
        "positionId": "56026518",
        "volume": 0.54,
        "price": 3230.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.12,
        "takeProfit": null,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "id": "53053666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41.622",
        "brokerTime": "2025-05-14 13:06:41.622",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026520",
        "positionId": "56026520",
        "volume": 0.54,
        "price": 3230.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "id": "53053667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:41.622",
        "brokerTime": "2025-05-14 13:06:41.838",
        "commission": -3.78,
        "swap": 0,
        "profit": -10.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026521",
        "positionId": "56026520",
        "volume": 0.54,
        "price": 3230.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -14.04,
        "takeProfit": null,
        "priceIn": 3230.6,
        "doubleCheck": true
    },
    {
        "id": "53053668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42.245",
        "brokerTime": "2025-05-14 13:06:42.245",
        "commission": -3.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026522",
        "positionId": "56026522",
        "volume": 0.54,
        "price": 3230.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "takeProfit": null,
        "priceIn": 3230.67,
        "doubleCheck": true
    },
    {
        "id": "53053669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:42.245",
        "brokerTime": "2025-05-14 13:06:42.484",
        "commission": -3.78,
        "swap": 0,
        "profit": -11.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026523",
        "positionId": "56026522",
        "volume": 0.54,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.12,
        "takeProfit": null,
        "priceIn": 3230.67,
        "doubleCheck": true
    },
    {
        "id": "53053670",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:10.886",
        "brokerTime": "2025-05-14 13:06:42.572",
        "commission": -1.19,
        "swap": 0,
        "profit": -1.19,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026524",
        "positionId": "56026501",
        "volume": 0.17,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.54,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.38,
        "priceIn": 3230.75,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17",
        "tProfit": -30.87,
        "tnProfit": -35.28,
        "tVolume": 0.63,
        "tTrades": 5
    },
    {
        "id": "53053671",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:05:59.457",
        "brokerTime": "2025-05-14 13:06:42.601",
        "commission": -0.98,
        "swap": 0,
        "profit": -2.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026525",
        "positionId": "56026494",
        "volume": 0.14,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.54,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.78,
        "priceIn": 3230.88,
        "doubleCheck": true
    },
    {
        "id": "53053672",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:00:01.662",
        "brokerTime": "2025-05-14 13:06:42.623",
        "commission": -0.84,
        "swap": 0,
        "profit": -19.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026526",
        "positionId": "56025272",
        "volume": 0.12,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.55,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -20.52,
        "priceIn": 3232.32,
        "doubleCheck": true
    },
    {
        "id": "53053673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 12:59:59.996",
        "brokerTime": "2025-05-14 13:06:42.634",
        "commission": -0.7,
        "swap": 0,
        "profit": 14.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026527",
        "positionId": "56025216",
        "volume": 0.1,
        "price": 3230.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.51,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 13.8,
        "priceIn": 3232.33,
        "doubleCheck": true
    },
    {
        "id": "53053674",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 12:59:58.854",
        "brokerTime": "2025-05-14 13:06:42.647",
        "commission": -0.7,
        "swap": 0,
        "profit": -18.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026528",
        "positionId": "56025215",
        "volume": 0.1,
        "price": 3230.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.55,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -19.599999999999998,
        "priceIn": 3232.57,
        "doubleCheck": true
    },
    {
        "id": "53053675",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:47.736",
        "brokerTime": "2025-05-14 13:06:47.736",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026529",
        "positionId": "56026529",
        "volume": 0.1,
        "price": 3231.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.39,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3231.39,
        "doubleCheck": true
    },
    {
        "id": "53053676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:48.580",
        "brokerTime": "2025-05-14 13:06:48.580",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026530",
        "positionId": "56026530",
        "volume": 0.1,
        "price": 3231.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.26,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3231.26,
        "doubleCheck": true
    },
    {
        "id": "53053678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:00.116",
        "brokerTime": "2025-05-14 13:07:00.116",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026532",
        "positionId": "56026532",
        "volume": 0.12,
        "price": 3231.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.69,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3231.69,
        "doubleCheck": true
    },
    {
        "id": "53053743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:00.116",
        "brokerTime": "2025-05-14 13:07:15.510",
        "commission": -0.84,
        "swap": 0,
        "profit": -12.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026577",
        "positionId": "56026532",
        "volume": 0.12,
        "price": 3232.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.88,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.68,
        "priceIn": 3231.69,
        "doubleCheck": true
    },
    {
        "id": "53053744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:06:48.580",
        "brokerTime": "2025-05-14 13:07:15.550",
        "commission": -0.7,
        "swap": 0,
        "profit": -15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026578",
        "positionId": "56026530",
        "volume": 0.1,
        "price": 3232.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3131.88,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.7,
        "priceIn": 3231.26,
        "doubleCheck": true
    },
    {
        "id": "53053745",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:06:47.736",
        "brokerTime": "2025-05-14 13:07:15.590",
        "commission": -0.7,
        "swap": 0,
        "profit": 11.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026579",
        "positionId": "56026529",
        "volume": 0.1,
        "price": 3232.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.18,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 11,
        "priceIn": 3231.39,
        "doubleCheck": true
    },
    {
        "id": "53053754",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:07:38.175",
        "brokerTime": "2025-05-14 13:07:38.175",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026587",
        "positionId": "56026587",
        "volume": 0.1,
        "price": 3233.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.09,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3233.09,
        "doubleCheck": true
    },
    {
        "id": "53053757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:38.958",
        "brokerTime": "2025-05-14 13:07:38.958",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026589",
        "positionId": "56026589",
        "volume": 0.1,
        "price": 3232.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.89,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53053769",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:08:00.129",
        "brokerTime": "2025-05-14 13:08:00.129",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026599",
        "positionId": "56026599",
        "volume": 0.12,
        "price": 3232.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3232.8,
        "doubleCheck": true
    },
    {
        "id": "53053784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:09:00.215",
        "brokerTime": "2025-05-14 13:09:00.215",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026611",
        "positionId": "56026611",
        "volume": 0.12,
        "price": 3233.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3233.55,
        "doubleCheck": true
    },
    {
        "id": "53053933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:10:54.433",
        "brokerTime": "2025-05-14 13:10:54.433",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026721",
        "positionId": "56026721",
        "volume": 0.14,
        "price": 3233.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3233.78,
        "doubleCheck": true
    },
    {
        "id": "53053935",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:10:55.054",
        "brokerTime": "2025-05-14 13:10:55.054",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026723",
        "positionId": "56026723",
        "volume": 0.21,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "takeProfit": null,
        "priceIn": 3234.02,
        "doubleCheck": true
    },
    {
        "id": "53054121",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:10:55.054",
        "brokerTime": "2025-05-14 13:11:04.322",
        "commission": -1.47,
        "swap": 0,
        "profit": -4.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026972",
        "positionId": "56026723",
        "volume": 0.21,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.88,
        "takeProfit": null,
        "priceIn": 3234.02,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19",
        "tProfit": -3.07,
        "tnProfit": -7.62,
        "tVolume": 0.6499999999999999,
        "tTrades": 5
    },
    {
        "id": "53054122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:10:54.433",
        "brokerTime": "2025-05-14 13:11:04.337",
        "commission": -0.98,
        "swap": 0,
        "profit": -3.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026973",
        "positionId": "56026721",
        "volume": 0.14,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.96,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.34,
        "priceIn": 3233.78,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20",
        "tProfit": -19.08,
        "tnProfit": -23.49,
        "tVolume": 0.63,
        "tTrades": 9
    },
    {
        "id": "53054123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:09:00.215",
        "brokerTime": "2025-05-14 13:11:04.374",
        "commission": -0.84,
        "swap": 0,
        "profit": -5.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026974",
        "positionId": "56026611",
        "volume": 0.12,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.96,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.4799999999999995,
        "priceIn": 3233.55,
        "doubleCheck": true
    },
    {
        "id": "53054124",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:08:00.129",
        "brokerTime": "2025-05-14 13:11:04.407",
        "commission": -0.84,
        "swap": 0,
        "profit": 12.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026975",
        "positionId": "56026599",
        "volume": 0.12,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.6,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 11.28,
        "priceIn": 3232.8,
        "doubleCheck": true
    },
    {
        "id": "53054125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:07:38.958",
        "brokerTime": "2025-05-14 13:11:04.422",
        "commission": -0.7,
        "swap": 0,
        "profit": -11.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026976",
        "positionId": "56026589",
        "volume": 0.1,
        "price": 3234.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.04,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12,
        "priceIn": 3232.89,
        "doubleCheck": true
    },
    {
        "id": "53054126",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:07:38.175",
        "brokerTime": "2025-05-14 13:11:04.431",
        "commission": -0.7,
        "swap": 0,
        "profit": 7.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026977",
        "positionId": "56026587",
        "volume": 0.1,
        "price": 3233.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.6,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 6.5,
        "priceIn": 3233.09,
        "doubleCheck": true
    },
    {
        "id": "53054132",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:10.200",
        "brokerTime": "2025-05-14 13:11:10.200",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026981",
        "positionId": "56026981",
        "volume": 0.1,
        "price": 3234.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.06,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3234.06,
        "doubleCheck": true
    },
    {
        "id": "53054133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:11.223",
        "brokerTime": "2025-05-14 13:11:11.223",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026982",
        "positionId": "56026982",
        "volume": 0.1,
        "price": 3233.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.85,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53054134",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:12.570",
        "brokerTime": "2025-05-14 13:11:12.570",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026983",
        "positionId": "56026983",
        "volume": 0.12,
        "price": 3233.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3233.88,
        "doubleCheck": true
    },
    {
        "id": "53054137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.165",
        "brokerTime": "2025-05-14 13:11:16.165",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026985",
        "positionId": "56026985",
        "volume": 0.04,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.385",
        "brokerTime": "2025-05-14 13:11:16.385",
        "commission": -0.28,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026986",
        "positionId": "56026986",
        "volume": 0.04,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.28,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.605",
        "brokerTime": "2025-05-14 13:11:16.605",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026987",
        "positionId": "56026987",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.822",
        "brokerTime": "2025-05-14 13:11:16.822",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026988",
        "positionId": "56026988",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17.069",
        "brokerTime": "2025-05-14 13:11:17.069",
        "commission": -0.21,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026989",
        "positionId": "56026989",
        "volume": 0.03,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "Manual BT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.21,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:17.069",
        "brokerTime": "2025-05-14 13:11:17.331",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026990",
        "positionId": "56026989",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.87,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.822",
        "brokerTime": "2025-05-14 13:11:17.352",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026991",
        "positionId": "56026988",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.87,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.605",
        "brokerTime": "2025-05-14 13:11:17.427",
        "commission": -0.21,
        "swap": 0,
        "profit": -0.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026992",
        "positionId": "56026987",
        "volume": 0.03,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.87,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.385",
        "brokerTime": "2025-05-14 13:11:17.443",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026993",
        "positionId": "56026986",
        "volume": 0.04,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.1600000000000001,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:16.165",
        "brokerTime": "2025-05-14 13:11:17.498",
        "commission": -0.28,
        "swap": 0,
        "profit": -0.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026994",
        "positionId": "56026985",
        "volume": 0.04,
        "price": 3233.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "Manual BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.2000000000000002,
        "takeProfit": null,
        "priceIn": 3233.35,
        "doubleCheck": true
    },
    {
        "id": "53054147",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:12.570",
        "brokerTime": "2025-05-14 13:11:21.989",
        "commission": -0.84,
        "swap": 0,
        "profit": -8.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026995",
        "positionId": "56026983",
        "volume": 0.12,
        "price": 3233.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.68,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.72,
        "priceIn": 3233.88,
        "doubleCheck": true
    },
    {
        "id": "53054148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:11:11.223",
        "brokerTime": "2025-05-14 13:11:22.027",
        "commission": -0.7,
        "swap": 0,
        "profit": 5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026996",
        "positionId": "56026982",
        "volume": 0.1,
        "price": 3233.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.05,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 4.3,
        "priceIn": 3233.85,
        "doubleCheck": true
    },
    {
        "id": "53054149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:11:10.200",
        "brokerTime": "2025-05-14 13:11:22.037",
        "commission": -0.7,
        "swap": 0,
        "profit": -9.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56026997",
        "positionId": "56026981",
        "volume": 0.1,
        "price": 3233.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.68,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.799999999999999,
        "priceIn": 3234.06,
        "doubleCheck": true
    },
    {
        "id": "53055426",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:17:05.690",
        "brokerTime": "2025-05-14 13:17:05.690",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56027913",
        "positionId": "56027913",
        "volume": 0.1,
        "price": 3233.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.57,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3233.57,
        "doubleCheck": true
    },
    {
        "id": "53055440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:06.534",
        "brokerTime": "2025-05-14 13:17:06.534",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56027921",
        "positionId": "56027921",
        "volume": 0.1,
        "price": 3233.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.37,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3233.37,
        "doubleCheck": true
    },
    {
        "id": "53055444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:33.989",
        "brokerTime": "2025-05-14 13:17:33.989",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56027925",
        "positionId": "56027925",
        "volume": 0.12,
        "price": 3234.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3234.38,
        "doubleCheck": true
    },
    {
        "id": "53055844",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:20:34.334",
        "brokerTime": "2025-05-14 13:20:34.334",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56028230",
        "positionId": "56028230",
        "volume": 0.1,
        "price": 2878.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2978.18,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2878.18,
        "doubleCheck": true
    },
    {
        "id": "53055845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:20:35.318",
        "brokerTime": "2025-05-14 13:20:35.318",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56028231",
        "positionId": "56028231",
        "volume": 0.1,
        "price": 2877.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2777.98,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2877.98,
        "doubleCheck": true
    },
    {
        "id": "53057077",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:28:42.705",
        "brokerTime": "2025-05-14 13:28:42.705",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029147",
        "positionId": "56029147",
        "volume": 0.12,
        "price": 2877.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2977.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2877.15,
        "doubleCheck": true
    },
    {
        "id": "53057083",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:29:43.054",
        "brokerTime": "2025-05-14 13:29:43.054",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56029153",
        "positionId": "56029153",
        "volume": 0.12,
        "price": 3232.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.5,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3232.5,
        "doubleCheck": true
    },
    {
        "id": "53057149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:32:21.019",
        "brokerTime": "2025-05-14 13:32:21.019",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029216",
        "positionId": "56029216",
        "volume": 0.14,
        "price": 2876.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2876.14,
        "doubleCheck": true
    },
    {
        "id": "53057165",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:33:04.136",
        "brokerTime": "2025-05-14 13:33:04.136",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029233",
        "positionId": "56029233",
        "volume": 0.17,
        "price": 2875.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2975.11,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 2875.11,
        "doubleCheck": true
    },
    {
        "id": "53057178",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:34:18.517",
        "brokerTime": "2025-05-14 13:34:18.517",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56029246",
        "positionId": "56029246",
        "volume": 0.14,
        "price": 3231.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3231.25,
        "doubleCheck": true
    },
    {
        "id": "53057514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:39:35.875",
        "brokerTime": "2025-05-14 13:39:35.875",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029504",
        "positionId": "56029504",
        "volume": 0.12,
        "price": 2879,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2779,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2879,
        "doubleCheck": true
    },
    {
        "id": "53057517",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:33:04.136",
        "brokerTime": "2025-05-14 13:39:36.805",
        "commission": -1.19,
        "swap": 0,
        "profit": 61.49,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029506",
        "positionId": "56029233",
        "volume": 0.17,
        "price": 2878.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 60.300000000000004,
        "priceIn": 2875.11,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21",
        "tProfit": 107.59,
        "tnProfit": 103.88,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53057518",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:32:21.019",
        "brokerTime": "2025-05-14 13:39:36.831",
        "commission": -0.98,
        "swap": 0,
        "profit": 34.44,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029507",
        "positionId": "56029216",
        "volume": 0.14,
        "price": 2878.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 33.46,
        "priceIn": 2876.14,
        "doubleCheck": true
    },
    {
        "id": "53057519",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:28:42.705",
        "brokerTime": "2025-05-14 13:39:36.877",
        "commission": -0.84,
        "swap": 0,
        "profit": 12.67,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029508",
        "positionId": "56029147",
        "volume": 0.12,
        "price": 2878.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 11.83,
        "priceIn": 2877.15,
        "doubleCheck": true
    },
    {
        "id": "53057520",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:20:34.334",
        "brokerTime": "2025-05-14 13:39:36.915",
        "commission": -0.7,
        "swap": 0,
        "profit": -1.01,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029509",
        "positionId": "56028230",
        "volume": 0.1,
        "price": 2878.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2974.84,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.71,
        "priceIn": 2878.18,
        "doubleCheck": true
    },
    {
        "id": "53057523",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:39:43.485",
        "brokerTime": "2025-05-14 13:39:43.485",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029512",
        "positionId": "56029512",
        "volume": 0.1,
        "price": 2878.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2878.15,
        "doubleCheck": true
    },
    {
        "id": "53057556",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:42:56.903",
        "brokerTime": "2025-05-14 13:42:56.903",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56029550",
        "positionId": "56029550",
        "volume": 0.12,
        "price": 2877.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2977.12,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2877.12,
        "doubleCheck": true
    },
    {
        "id": "53058294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:49:28.142",
        "brokerTime": "2025-05-14 13:49:28.142",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030064",
        "positionId": "56030064",
        "volume": 0.17,
        "price": 3230.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3230.25,
        "doubleCheck": true
    },
    {
        "id": "53058565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:33.989",
        "brokerTime": "2025-05-14 13:50:17.630",
        "commission": -0.84,
        "swap": 0,
        "profit": 37.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030262",
        "positionId": "56027925",
        "volume": 0.12,
        "price": 3231.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 36.839999999999996,
        "priceIn": 3234.38,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22",
        "tProfit": 58.98,
        "tnProfit": 57.44,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53058566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:17:06.534",
        "brokerTime": "2025-05-14 13:50:17.674",
        "commission": -0.7,
        "swap": 0,
        "profit": 21.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030263",
        "positionId": "56027921",
        "volume": 0.1,
        "price": 3231.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.6,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 20.6,
        "priceIn": 3233.37,
        "doubleCheck": true
    },
    {
        "id": "53058575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:50:24.440",
        "brokerTime": "2025-05-14 13:50:24.440",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030272",
        "positionId": "56030272",
        "volume": 0.1,
        "price": 3231.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3231.16,
        "doubleCheck": true
    },
    {
        "id": "53058775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:52:38.535",
        "brokerTime": "2025-05-14 13:52:38.535",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030411",
        "positionId": "56030411",
        "volume": 0.12,
        "price": 3232.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3132.18,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3232.18,
        "doubleCheck": true
    },
    {
        "id": "53058827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:54:54.962",
        "brokerTime": "2025-05-14 13:54:54.962",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030465",
        "positionId": "56030465",
        "volume": 0.14,
        "price": 3233.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3133.24,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3233.24,
        "doubleCheck": true
    },
    {
        "id": "53058846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:55:57.880",
        "brokerTime": "2025-05-14 13:55:57.880",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030482",
        "positionId": "56030482",
        "volume": 0.17,
        "price": 3234.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3134.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3234.34,
        "doubleCheck": true
    },
    {
        "id": "53058863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:27.850",
        "brokerTime": "2025-05-14 13:57:27.850",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030496",
        "positionId": "56030496",
        "volume": 0.21,
        "price": 3235.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3135.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "id": "53058888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:58.984",
        "brokerTime": "2025-05-14 13:57:58.984",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56030517",
        "positionId": "56030517",
        "volume": 0.14,
        "price": 2880.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2780.06,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2880.06,
        "doubleCheck": true
    },
    {
        "id": "53058912",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:49:28.142",
        "brokerTime": "2025-05-14 13:59:04.854",
        "commission": -1.19,
        "swap": 0,
        "profit": 86.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030539",
        "positionId": "56030064",
        "volume": 0.17,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 84.83,
        "priceIn": 3230.25,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23",
        "tProfit": 193.98,
        "tnProfit": 190.27,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53058913",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:34:18.517",
        "brokerTime": "2025-05-14 13:59:04.949",
        "commission": -0.98,
        "swap": 0,
        "profit": 56.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030540",
        "positionId": "56029246",
        "volume": 0.14,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 55.86000000000001,
        "priceIn": 3231.25,
        "doubleCheck": true
    },
    {
        "id": "53058914",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:29:43.054",
        "brokerTime": "2025-05-14 13:59:05.082",
        "commission": -0.84,
        "swap": 0,
        "profit": 33.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030541",
        "positionId": "56029153",
        "volume": 0.12,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 32.879999999999995,
        "priceIn": 3232.5,
        "doubleCheck": true
    },
    {
        "id": "53058915",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:17:05.690",
        "brokerTime": "2025-05-14 13:59:05.129",
        "commission": -0.7,
        "swap": 0,
        "profit": 17.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030542",
        "positionId": "56027913",
        "volume": 0.1,
        "price": 3235.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.05,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 16.7,
        "priceIn": 3233.57,
        "doubleCheck": true
    },
    {
        "id": "53058916",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:59:11.578",
        "brokerTime": "2025-05-14 13:59:11.578",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030544",
        "positionId": "56030544",
        "volume": 0.1,
        "price": 3235.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3235.77,
        "doubleCheck": true
    },
    {
        "id": "53058917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:28.960",
        "brokerTime": "2025-05-14 13:59:28.960",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56030546",
        "positionId": "56030546",
        "volume": 0.17,
        "price": 2881.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2781.09,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 2881.09,
        "doubleCheck": true
    },
    {
        "id": "53058918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:39.330",
        "brokerTime": "2025-05-14 13:59:39.330",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56030547",
        "positionId": "56030547",
        "volume": 0.25,
        "price": 3236.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3136.41,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3236.41,
        "doubleCheck": true
    },
    {
        "id": "53059965",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:01:00.354",
        "brokerTime": "2025-05-14 14:01:00.354",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56031491",
        "positionId": "56031491",
        "volume": 0.12,
        "price": 3234.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.67,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3234.69,
        "doubleCheck": true
    },
    {
        "id": "53059989",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:42:56.903",
        "brokerTime": "2025-05-14 14:02:33.291",
        "commission": -0.84,
        "swap": 0,
        "profit": 42.19,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56031514",
        "positionId": "56029550",
        "volume": 0.12,
        "price": 2880.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.87,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 41.349999999999994,
        "priceIn": 2877.12,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24",
        "tProfit": 65.78,
        "tnProfit": 64.24,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53059990",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:39:43.485",
        "brokerTime": "2025-05-14 14:02:33.388",
        "commission": -0.7,
        "swap": 0,
        "profit": 23.59,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56031515",
        "positionId": "56029512",
        "volume": 0.1,
        "price": 2880.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2976.87,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 22.89,
        "priceIn": 2878.15,
        "doubleCheck": true
    },
    {
        "id": "53059991",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:02:39.998",
        "brokerTime": "2025-05-14 14:02:39.998",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56031516",
        "positionId": "56031516",
        "volume": 0.1,
        "price": 2880.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2880.64,
        "doubleCheck": true
    },
    {
        "id": "53060775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:09:10.994",
        "brokerTime": "2025-05-14 14:09:10.994",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56032160",
        "positionId": "56032160",
        "volume": 0.21,
        "price": 2882.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2782.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 2882.15,
        "doubleCheck": true
    },
    {
        "id": "53061646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:21.474",
        "brokerTime": "2025-05-14 14:13:21.474",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56032843",
        "positionId": "56032843",
        "volume": 0.3,
        "price": 3237.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3137.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3237.47,
        "doubleCheck": true
    },
    {
        "id": "53061651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:35.067",
        "brokerTime": "2025-05-14 14:13:35.067",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56032846",
        "positionId": "56032846",
        "volume": 0.25,
        "price": 2883.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2783.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 2883.16,
        "doubleCheck": true
    },
    {
        "id": "53062152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:15:56.154",
        "brokerTime": "2025-05-14 14:15:56.154",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56033307",
        "positionId": "56033307",
        "volume": 0.3,
        "price": 2884.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2784.23,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 2884.25,
        "doubleCheck": true
    },
    {
        "id": "53063472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:17:16.656",
        "brokerTime": "2025-05-14 14:17:16.656",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56034354",
        "positionId": "56034354",
        "volume": 0.36,
        "price": 2885.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2785.33,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 2885.33,
        "doubleCheck": true
    },
    {
        "id": "53084036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:24:23.904",
        "brokerTime": "2025-05-14 14:24:23.904",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048114",
        "positionId": "56048114",
        "volume": 0.36,
        "price": 3238.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 3238.53,
        "doubleCheck": true
    },
    {
        "id": "53084240",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:01:00.354",
        "brokerTime": "2025-05-14 14:26:29.003",
        "commission": -0.84,
        "swap": 0,
        "profit": 36.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048270",
        "positionId": "56031491",
        "volume": 0.12,
        "price": 3237.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.5,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 36,
        "priceIn": 3234.69,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25",
        "tProfit": 56.74,
        "tnProfit": 55.2,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53084241",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 13:59:11.578",
        "brokerTime": "2025-05-14 14:26:29.073",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048271",
        "positionId": "56030544",
        "volume": 0.1,
        "price": 3237.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.5,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 19.2,
        "priceIn": 3235.77,
        "doubleCheck": true
    },
    {
        "id": "53084242",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:26:35.512",
        "brokerTime": "2025-05-14 14:26:35.512",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048272",
        "positionId": "56048272",
        "volume": 0.1,
        "price": 3238.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3238.09,
        "doubleCheck": true
    },
    {
        "id": "53084247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:27:24.845",
        "brokerTime": "2025-05-14 14:27:24.845",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56048276",
        "positionId": "56048276",
        "volume": 0.43,
        "price": 2886.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 2886.34,
        "doubleCheck": true
    },
    {
        "id": "53084248",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:27:25.291",
        "brokerTime": "2025-05-14 14:27:25.291",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56048277",
        "positionId": "56048277",
        "volume": 2.4,
        "price": 2886.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 2886.55,
        "doubleCheck": true
    },
    {
        "id": "53084297",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:32:18.336",
        "brokerTime": "2025-05-14 14:32:18.336",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048322",
        "positionId": "56048322",
        "volume": 0.12,
        "price": 3237.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3337.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3237.07,
        "doubleCheck": true
    },
    {
        "id": "53084350",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:27:25.291",
        "brokerTime": "2025-05-14 14:35:41.422",
        "commission": -16.8,
        "swap": 0,
        "profit": -829.66,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56048373",
        "positionId": "56048277",
        "volume": 2.4,
        "price": 2883.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -846.4599999999999,
        "takeProfit": null,
        "priceIn": 2886.55,
        "doubleCheck": true,
        "tProfit": -829.66,
        "tnProfit": -846.46,
        "tVolume": 2.4,
        "tTrades": 1
    },
    {
        "id": "53084351",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:35:43.242",
        "brokerTime": "2025-05-14 14:35:43.242",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56048374",
        "positionId": "56048374",
        "volume": 2.4,
        "price": 2883.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 2883.77,
        "doubleCheck": true
    },
    {
        "id": "53084468",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:36:00.510",
        "brokerTime": "2025-05-14 14:36:00.510",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048484",
        "positionId": "56048484",
        "volume": 0.14,
        "price": 3235.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3335.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3235.96,
        "doubleCheck": true
    },
    {
        "id": "53084510",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:37:05.803",
        "brokerTime": "2025-05-14 14:37:05.803",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048522",
        "positionId": "56048522",
        "volume": 0.17,
        "price": 3234.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3334.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3234.96,
        "doubleCheck": true
    },
    {
        "id": "53084526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:24:23.904",
        "brokerTime": "2025-05-14 14:37:16.414",
        "commission": -2.52,
        "swap": 0,
        "profit": 114.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048537",
        "positionId": "56048114",
        "volume": 0.36,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 111.96000000000001,
        "priceIn": 3238.53,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27",
        "tProfit": 79.3,
        "tnProfit": 67.75,
        "tVolume": 1.65,
        "tTrades": 8
    },
    {
        "id": "53084527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:21.474",
        "brokerTime": "2025-05-14 14:37:16.471",
        "commission": -2.1,
        "swap": 0,
        "profit": 63.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048538",
        "positionId": "56032843",
        "volume": 0.3,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 61.5,
        "priceIn": 3237.47,
        "doubleCheck": true
    },
    {
        "id": "53084528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:39.330",
        "brokerTime": "2025-05-14 14:37:16.522",
        "commission": -1.75,
        "swap": 0,
        "profit": 26.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048539",
        "positionId": "56030547",
        "volume": 0.25,
        "price": 3235.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 24.75,
        "priceIn": 3236.41,
        "doubleCheck": true
    },
    {
        "id": "53084529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:27.850",
        "brokerTime": "2025-05-14 14:37:16.651",
        "commission": -1.47,
        "swap": 0,
        "profit": 0.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048540",
        "positionId": "56030496",
        "volume": 0.21,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.67,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.63,
        "priceIn": 3235.38,
        "doubleCheck": true
    },
    {
        "id": "53084530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:55:57.880",
        "brokerTime": "2025-05-14 14:37:16.725",
        "commission": -1.19,
        "swap": 0,
        "profit": -17,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048541",
        "positionId": "56030482",
        "volume": 0.17,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -18.19,
        "priceIn": 3234.34,
        "doubleCheck": true
    },
    {
        "id": "53084531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:54:54.962",
        "brokerTime": "2025-05-14 14:37:16.776",
        "commission": -0.98,
        "swap": 0,
        "profit": -29.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048542",
        "positionId": "56030465",
        "volume": 0.14,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.38,
        "priceIn": 3233.24,
        "doubleCheck": true
    },
    {
        "id": "53084532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:52:38.535",
        "brokerTime": "2025-05-14 14:37:16.827",
        "commission": -0.84,
        "swap": 0,
        "profit": -37.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048543",
        "positionId": "56030411",
        "volume": 0.12,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -38.760000000000005,
        "priceIn": 3232.18,
        "doubleCheck": true
    },
    {
        "id": "53084533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:50:24.440",
        "brokerTime": "2025-05-14 14:37:16.906",
        "commission": -0.7,
        "swap": 0,
        "profit": -41.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048544",
        "positionId": "56030272",
        "volume": 0.1,
        "price": 3235.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3138.63,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -42.5,
        "priceIn": 3231.16,
        "doubleCheck": true
    },
    {
        "id": "53084539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:37:23.431",
        "brokerTime": "2025-05-14 14:37:23.431",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048550",
        "positionId": "56048550",
        "volume": 0.1,
        "price": 3234.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3234.54,
        "doubleCheck": true
    },
    {
        "id": "53084566",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:38:53.196",
        "brokerTime": "2025-05-14 14:38:53.196",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048576",
        "positionId": "56048576",
        "volume": 0.21,
        "price": 3233.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3333.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3233.83,
        "doubleCheck": true
    },
    {
        "id": "53084778",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:42:38.594",
        "brokerTime": "2025-05-14 14:42:38.594",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048738",
        "positionId": "56048738",
        "volume": 0.25,
        "price": 3232.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3332.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3232.72,
        "doubleCheck": true
    },
    {
        "id": "53084804",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:43:00.348",
        "brokerTime": "2025-05-14 14:43:00.348",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048759",
        "positionId": "56048759",
        "volume": 0.3,
        "price": 3231.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3331.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3231.66,
        "doubleCheck": true
    },
    {
        "id": "53084874",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:46:01.531",
        "brokerTime": "2025-05-14 14:46:01.531",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048820",
        "positionId": "56048820",
        "volume": 0.36,
        "price": 3230.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3330.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 3230.66,
        "doubleCheck": true
    },
    {
        "id": "53085036",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:47:21.245",
        "brokerTime": "2025-05-14 14:47:21.245",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048939",
        "positionId": "56048939",
        "volume": 0.43,
        "price": 3229.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3329.65,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 3229.65,
        "doubleCheck": true
    },
    {
        "id": "53085037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:22.092",
        "brokerTime": "2025-05-14 14:47:22.092",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048940",
        "positionId": "56048940",
        "volume": 2.4,
        "price": 3229.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.42,
        "doubleCheck": true
    },
    {
        "id": "53085038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:22.092",
        "brokerTime": "2025-05-14 14:47:22.620",
        "commission": -16.8,
        "swap": 0,
        "profit": -38.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048941",
        "positionId": "56048940",
        "volume": 2.4,
        "price": 3229.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -55.2,
        "takeProfit": null,
        "priceIn": 3229.42,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30",
        "tProfit": -313906.69,
        "tnProfit": -425738.2,
        "tVolume": 15975.92999999995,
        "tTrades": 1971
    },
    {
        "id": "53085039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:23.188",
        "brokerTime": "2025-05-14 14:47:23.188",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048942",
        "positionId": "56048942",
        "volume": 2.4,
        "price": 3229.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.34,
        "doubleCheck": true
    },
    {
        "id": "53085040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:23.188",
        "brokerTime": "2025-05-14 14:47:23.806",
        "commission": -16.8,
        "swap": 0,
        "profit": -52.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048943",
        "positionId": "56048942",
        "volume": 2.4,
        "price": 3229.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.6,
        "takeProfit": null,
        "priceIn": 3229.34,
        "doubleCheck": true
    },
    {
        "id": "53085041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:24.388",
        "brokerTime": "2025-05-14 14:47:24.388",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048944",
        "positionId": "56048944",
        "volume": 2.4,
        "price": 3229.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.44,
        "doubleCheck": true
    },
    {
        "id": "53085042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:24.388",
        "brokerTime": "2025-05-14 14:47:24.910",
        "commission": -16.8,
        "swap": 0,
        "profit": -96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048945",
        "positionId": "56048944",
        "volume": 2.4,
        "price": 3229.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.8,
        "takeProfit": null,
        "priceIn": 3229.44,
        "doubleCheck": true
    },
    {
        "id": "53085043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25.137",
        "brokerTime": "2025-05-14 14:47:25.137",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048946",
        "positionId": "56048946",
        "volume": 2.4,
        "price": 3229.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.63,
        "doubleCheck": true
    },
    {
        "id": "53085044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25.137",
        "brokerTime": "2025-05-14 14:47:25.565",
        "commission": -16.8,
        "swap": 0,
        "profit": -38.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048947",
        "positionId": "56048946",
        "volume": 2.4,
        "price": 3229.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -55.2,
        "takeProfit": null,
        "priceIn": 3229.63,
        "doubleCheck": true
    },
    {
        "id": "53085045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25.854",
        "brokerTime": "2025-05-14 14:47:25.854",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048948",
        "positionId": "56048948",
        "volume": 2.4,
        "price": 3229.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.5,
        "doubleCheck": true
    },
    {
        "id": "53085046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:25.854",
        "brokerTime": "2025-05-14 14:47:26.638",
        "commission": -16.8,
        "swap": 0,
        "profit": -36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048949",
        "positionId": "56048948",
        "volume": 2.4,
        "price": 3229.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -52.8,
        "takeProfit": null,
        "priceIn": 3229.5,
        "doubleCheck": true
    },
    {
        "id": "53085047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:27.605",
        "brokerTime": "2025-05-14 14:47:27.605",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048950",
        "positionId": "56048950",
        "volume": 2.4,
        "price": 3229.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.45,
        "doubleCheck": true
    },
    {
        "id": "53085048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:27.605",
        "brokerTime": "2025-05-14 14:47:28.725",
        "commission": -16.8,
        "swap": 0,
        "profit": -24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048951",
        "positionId": "56048950",
        "volume": 2.4,
        "price": 3229.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.8,
        "takeProfit": null,
        "priceIn": 3229.45,
        "doubleCheck": true
    },
    {
        "id": "53085049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:29.550",
        "brokerTime": "2025-05-14 14:47:29.550",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048952",
        "positionId": "56048952",
        "volume": 2.4,
        "price": 3229.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "id": "53085050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:29.550",
        "brokerTime": "2025-05-14 14:47:29.838",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048953",
        "positionId": "56048952",
        "volume": 2.4,
        "price": 3229.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -67.2,
        "takeProfit": null,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "id": "53085051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36.035",
        "brokerTime": "2025-05-14 14:47:36.035",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048954",
        "positionId": "56048954",
        "volume": 2.4,
        "price": 3229.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "id": "53085052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36.035",
        "brokerTime": "2025-05-14 14:47:36.487",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048955",
        "positionId": "56048954",
        "volume": 2.4,
        "price": 3229.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.4,
        "takeProfit": null,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "id": "53085053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36.810",
        "brokerTime": "2025-05-14 14:47:36.810",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048956",
        "positionId": "56048956",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "id": "53085054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:36.810",
        "brokerTime": "2025-05-14 14:47:37.866",
        "commission": -16.8,
        "swap": 0,
        "profit": -79.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048957",
        "positionId": "56048956",
        "volume": 2.4,
        "price": 3229.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -96,
        "takeProfit": null,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "id": "53085055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:38.289",
        "brokerTime": "2025-05-14 14:47:38.289",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048958",
        "positionId": "56048958",
        "volume": 2.4,
        "price": 3229.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "id": "53085056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:38.289",
        "brokerTime": "2025-05-14 14:47:39.049",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048959",
        "positionId": "56048958",
        "volume": 2.4,
        "price": 3229.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -67.2,
        "takeProfit": null,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "id": "53085057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:39.423",
        "brokerTime": "2025-05-14 14:47:39.423",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048960",
        "positionId": "56048960",
        "volume": 2.4,
        "price": 3229.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "id": "53085058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:39.423",
        "brokerTime": "2025-05-14 14:47:41.124",
        "commission": -16.8,
        "swap": 0,
        "profit": -62.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048961",
        "positionId": "56048960",
        "volume": 2.4,
        "price": 3229.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.2,
        "takeProfit": null,
        "priceIn": 3229.24,
        "doubleCheck": true
    },
    {
        "id": "53085060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:42.065",
        "brokerTime": "2025-05-14 14:47:42.065",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048962",
        "positionId": "56048962",
        "volume": 2.4,
        "price": 3229.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.28,
        "doubleCheck": true
    },
    {
        "id": "53085061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:42.065",
        "brokerTime": "2025-05-14 14:47:42.524",
        "commission": -16.8,
        "swap": 0,
        "profit": -33.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048963",
        "positionId": "56048962",
        "volume": 2.4,
        "price": 3229.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -50.400000000000006,
        "takeProfit": null,
        "priceIn": 3229.28,
        "doubleCheck": true
    },
    {
        "id": "53085062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43.053",
        "brokerTime": "2025-05-14 14:47:43.053",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048964",
        "positionId": "56048964",
        "volume": 2.4,
        "price": 3229.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.22,
        "doubleCheck": true
    },
    {
        "id": "53085063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43.053",
        "brokerTime": "2025-05-14 14:47:43.537",
        "commission": -16.8,
        "swap": 0,
        "profit": -45.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048965",
        "positionId": "56048964",
        "volume": 2.4,
        "price": 3229.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -62.400000000000006,
        "takeProfit": null,
        "priceIn": 3229.22,
        "doubleCheck": true
    },
    {
        "id": "53085064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43.811",
        "brokerTime": "2025-05-14 14:47:43.811",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048966",
        "positionId": "56048966",
        "volume": 2.4,
        "price": 3229.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.19,
        "doubleCheck": true
    },
    {
        "id": "53085066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:43.811",
        "brokerTime": "2025-05-14 14:47:44.225",
        "commission": -16.8,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048967",
        "positionId": "56048966",
        "volume": 2.4,
        "price": 3229.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.599999999999994,
        "takeProfit": null,
        "priceIn": 3229.19,
        "doubleCheck": true
    },
    {
        "id": "53085067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44.487",
        "brokerTime": "2025-05-14 14:47:44.487",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048968",
        "positionId": "56048968",
        "volume": 2.4,
        "price": 3229.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.12,
        "doubleCheck": true
    },
    {
        "id": "53085068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:44.487",
        "brokerTime": "2025-05-14 14:47:45.335",
        "commission": -16.8,
        "swap": 0,
        "profit": -45.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048969",
        "positionId": "56048968",
        "volume": 2.4,
        "price": 3229.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -62.400000000000006,
        "takeProfit": null,
        "priceIn": 3229.12,
        "doubleCheck": true
    },
    {
        "id": "53085069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:45.695",
        "brokerTime": "2025-05-14 14:47:45.695",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048970",
        "positionId": "56048970",
        "volume": 2.4,
        "price": 3229.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "id": "53085070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:45.695",
        "brokerTime": "2025-05-14 14:47:46.273",
        "commission": -16.8,
        "swap": 0,
        "profit": -36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048971",
        "positionId": "56048970",
        "volume": 2.4,
        "price": 3229.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -52.8,
        "takeProfit": null,
        "priceIn": 3229.14,
        "doubleCheck": true
    },
    {
        "id": "53085071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:46.592",
        "brokerTime": "2025-05-14 14:47:46.592",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048972",
        "positionId": "56048972",
        "volume": 2.4,
        "price": 3229.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.08,
        "doubleCheck": true
    },
    {
        "id": "53085072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:46.592",
        "brokerTime": "2025-05-14 14:47:47.118",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048973",
        "positionId": "56048972",
        "volume": 2.4,
        "price": 3229.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.4,
        "takeProfit": null,
        "priceIn": 3229.08,
        "doubleCheck": true
    },
    {
        "id": "53085073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:48.409",
        "brokerTime": "2025-05-14 14:47:48.409",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048974",
        "positionId": "56048974",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "id": "53085074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:48.409",
        "brokerTime": "2025-05-14 14:47:48.900",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048975",
        "positionId": "56048974",
        "volume": 2.4,
        "price": 3229.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -67.2,
        "takeProfit": null,
        "priceIn": 3229.13,
        "doubleCheck": true
    },
    {
        "id": "53085075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:50.640",
        "brokerTime": "2025-05-14 14:47:50.640",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048976",
        "positionId": "56048976",
        "volume": 2.4,
        "price": 3229.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "id": "53085076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:50.640",
        "brokerTime": "2025-05-14 14:47:51.884",
        "commission": -16.8,
        "swap": 0,
        "profit": -50.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048977",
        "positionId": "56048976",
        "volume": 2.4,
        "price": 3229.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -67.2,
        "takeProfit": null,
        "priceIn": 3229.11,
        "doubleCheck": true
    },
    {
        "id": "53085077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:52.939",
        "brokerTime": "2025-05-14 14:47:52.939",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048978",
        "positionId": "56048978",
        "volume": 2.4,
        "price": 3229.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.07,
        "doubleCheck": true
    },
    {
        "id": "53085078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:52.939",
        "brokerTime": "2025-05-14 14:47:55.116",
        "commission": -16.8,
        "swap": 0,
        "profit": -31.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048979",
        "positionId": "56048978",
        "volume": 2.4,
        "price": 3229.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -48,
        "takeProfit": null,
        "priceIn": 3229.07,
        "doubleCheck": true
    },
    {
        "id": "53085079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55.326",
        "brokerTime": "2025-05-14 14:47:55.326",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048980",
        "positionId": "56048980",
        "volume": 2.4,
        "price": 3229.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3229.02,
        "doubleCheck": true
    },
    {
        "id": "53085080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55.326",
        "brokerTime": "2025-05-14 14:47:55.624",
        "commission": -16.8,
        "swap": 0,
        "profit": -26.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048981",
        "positionId": "56048980",
        "volume": 2.4,
        "price": 3229.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -43.2,
        "takeProfit": null,
        "priceIn": 3229.02,
        "doubleCheck": true
    },
    {
        "id": "53085081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55.883",
        "brokerTime": "2025-05-14 14:47:55.883",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048982",
        "positionId": "56048982",
        "volume": 2.4,
        "price": 3228.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "id": "53085082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:55.883",
        "brokerTime": "2025-05-14 14:47:56.636",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048983",
        "positionId": "56048982",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.4,
        "takeProfit": null,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "id": "53085083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:57.035",
        "brokerTime": "2025-05-14 14:47:57.035",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048984",
        "positionId": "56048984",
        "volume": 2.4,
        "price": 3228.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.98,
        "doubleCheck": true
    },
    {
        "id": "53085084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:57.035",
        "brokerTime": "2025-05-14 14:47:57.393",
        "commission": -16.8,
        "swap": 0,
        "profit": -43.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048985",
        "positionId": "56048984",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60,
        "takeProfit": null,
        "priceIn": 3228.98,
        "doubleCheck": true
    },
    {
        "id": "53085085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:58.011",
        "brokerTime": "2025-05-14 14:47:58.011",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048986",
        "positionId": "56048986",
        "volume": 2.4,
        "price": 3228.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "id": "53085086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:58.011",
        "brokerTime": "2025-05-14 14:47:58.658",
        "commission": -16.8,
        "swap": 0,
        "profit": -57.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048987",
        "positionId": "56048986",
        "volume": 2.4,
        "price": 3229.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.4,
        "takeProfit": null,
        "priceIn": 3228.92,
        "doubleCheck": true
    },
    {
        "id": "53085087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:59.023",
        "brokerTime": "2025-05-14 14:47:59.023",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048988",
        "positionId": "56048988",
        "volume": 2.4,
        "price": 3228.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.93,
        "doubleCheck": true
    },
    {
        "id": "53085088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:47:59.023",
        "brokerTime": "2025-05-14 14:47:59.763",
        "commission": -16.8,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048989",
        "positionId": "56048988",
        "volume": 2.4,
        "price": 3229.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.599999999999994,
        "takeProfit": null,
        "priceIn": 3228.93,
        "doubleCheck": true
    },
    {
        "id": "53085090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00.051",
        "brokerTime": "2025-05-14 14:48:00.051",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048992",
        "positionId": "56048992",
        "volume": 2.4,
        "price": 3228.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.91,
        "doubleCheck": true
    },
    {
        "id": "53085095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00.051",
        "brokerTime": "2025-05-14 14:48:00.654",
        "commission": -16.8,
        "swap": 0,
        "profit": 24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048996",
        "positionId": "56048992",
        "volume": 2.4,
        "price": 3228.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 7.199999999999999,
        "takeProfit": null,
        "priceIn": 3228.91,
        "doubleCheck": true
    },
    {
        "id": "53085096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00.931",
        "brokerTime": "2025-05-14 14:48:00.931",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048997",
        "positionId": "56048997",
        "volume": 2.4,
        "price": 3228.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3228.61,
        "doubleCheck": true
    },
    {
        "id": "53085097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:00.931",
        "brokerTime": "2025-05-14 14:48:02.025",
        "commission": -16.8,
        "swap": 0,
        "profit": 7.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048998",
        "positionId": "56048997",
        "volume": 2.4,
        "price": 3228.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.600000000000001,
        "takeProfit": null,
        "priceIn": 3228.61,
        "doubleCheck": true
    },
    {
        "id": "53085098",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:48:02.188",
        "brokerTime": "2025-05-14 14:48:02.188",
        "commission": -3.64,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56048999",
        "positionId": "56048999",
        "volume": 0.52,
        "price": 3228.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3328.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.64,
        "priceIn": 3228.58,
        "doubleCheck": true
    },
    {
        "id": "53085100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:02.692",
        "brokerTime": "2025-05-14 14:48:02.692",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049001",
        "positionId": "56049001",
        "volume": 3.02,
        "price": 3228.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "id": "53085101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:02.692",
        "brokerTime": "2025-05-14 14:48:03.031",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049002",
        "positionId": "56049001",
        "volume": 3.02,
        "price": 3228.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "id": "53085102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:04.074",
        "brokerTime": "2025-05-14 14:48:04.074",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049003",
        "positionId": "56049003",
        "volume": 3.02,
        "price": 3228.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "id": "53085104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:04.074",
        "brokerTime": "2025-05-14 14:48:05.066",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049005",
        "positionId": "56049003",
        "volume": 3.02,
        "price": 3228.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84.56,
        "takeProfit": null,
        "priceIn": 3228.33,
        "doubleCheck": true
    },
    {
        "id": "53085105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:05.430",
        "brokerTime": "2025-05-14 14:48:05.430",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049006",
        "positionId": "56049006",
        "volume": 3.02,
        "price": 3228.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.18,
        "doubleCheck": true
    },
    {
        "id": "53085123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:05.430",
        "brokerTime": "2025-05-14 14:48:06.128",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049022",
        "positionId": "56049006",
        "volume": 3.02,
        "price": 3228.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.5,
        "takeProfit": null,
        "priceIn": 3228.18,
        "doubleCheck": true
    },
    {
        "id": "53085132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:06.407",
        "brokerTime": "2025-05-14 14:48:06.407",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049026",
        "positionId": "56049026",
        "volume": 3.02,
        "price": 3228.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.16,
        "doubleCheck": true
    },
    {
        "id": "53085169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:06.407",
        "brokerTime": "2025-05-14 14:48:09.376",
        "commission": -21.14,
        "swap": 0,
        "profit": -33.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049051",
        "positionId": "56049026",
        "volume": 3.02,
        "price": 3228.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -54.36,
        "takeProfit": null,
        "priceIn": 3228.16,
        "doubleCheck": true
    },
    {
        "id": "53085174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:10.127",
        "brokerTime": "2025-05-14 14:48:10.127",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049056",
        "positionId": "56049056",
        "volume": 3.02,
        "price": 3228.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.03,
        "doubleCheck": true
    },
    {
        "id": "53085178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:10.127",
        "brokerTime": "2025-05-14 14:48:10.464",
        "commission": -21.14,
        "swap": 0,
        "profit": -51.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049058",
        "positionId": "56049056",
        "volume": 3.02,
        "price": 3228.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.48,
        "takeProfit": null,
        "priceIn": 3228.03,
        "doubleCheck": true
    },
    {
        "id": "53085181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:11.193",
        "brokerTime": "2025-05-14 14:48:11.193",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049060",
        "positionId": "56049060",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:11.193",
        "brokerTime": "2025-05-14 14:48:11.755",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049061",
        "positionId": "56049060",
        "volume": 3.02,
        "price": 3228.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.5,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12.143",
        "brokerTime": "2025-05-14 14:48:12.143",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049062",
        "positionId": "56049062",
        "volume": 3.02,
        "price": 3227.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.98,
        "doubleCheck": true
    },
    {
        "id": "53085185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12.143",
        "brokerTime": "2025-05-14 14:48:12.441",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049064",
        "positionId": "56049062",
        "volume": 3.02,
        "price": 3228.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -66.44,
        "takeProfit": null,
        "priceIn": 3227.98,
        "doubleCheck": true
    },
    {
        "id": "53085188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12.957",
        "brokerTime": "2025-05-14 14:48:12.957",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049066",
        "positionId": "56049066",
        "volume": 3.02,
        "price": 3227.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.95,
        "doubleCheck": true
    },
    {
        "id": "53085189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:12.957",
        "brokerTime": "2025-05-14 14:48:13.459",
        "commission": -21.14,
        "swap": 0,
        "profit": -99.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049067",
        "positionId": "56049066",
        "volume": 3.02,
        "price": 3228.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.8,
        "takeProfit": null,
        "priceIn": 3227.95,
        "doubleCheck": true
    },
    {
        "id": "53085190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:13.877",
        "brokerTime": "2025-05-14 14:48:13.877",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049068",
        "positionId": "56049068",
        "volume": 3.02,
        "price": 3228.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.04,
        "doubleCheck": true
    },
    {
        "id": "53085191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:13.877",
        "brokerTime": "2025-05-14 14:48:15.069",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049069",
        "positionId": "56049068",
        "volume": 3.02,
        "price": 3228.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.4,
        "takeProfit": null,
        "priceIn": 3228.04,
        "doubleCheck": true
    },
    {
        "id": "53085192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:15.566",
        "brokerTime": "2025-05-14 14:48:15.566",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049070",
        "positionId": "56049070",
        "volume": 3.02,
        "price": 3227.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.94,
        "doubleCheck": true
    },
    {
        "id": "53085193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:15.566",
        "brokerTime": "2025-05-14 14:48:16.014",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049071",
        "positionId": "56049070",
        "volume": 3.02,
        "price": 3228.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3227.94,
        "doubleCheck": true
    },
    {
        "id": "53085194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16.448",
        "brokerTime": "2025-05-14 14:48:16.448",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049072",
        "positionId": "56049072",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.97,
        "doubleCheck": true
    },
    {
        "id": "53085195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:16.448",
        "brokerTime": "2025-05-14 14:48:16.907",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049073",
        "positionId": "56049072",
        "volume": 3.02,
        "price": 3228.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.97,
        "doubleCheck": true
    },
    {
        "id": "53085196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:17.115",
        "brokerTime": "2025-05-14 14:48:17.115",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049074",
        "positionId": "56049074",
        "volume": 3.02,
        "price": 3228.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.07,
        "doubleCheck": true
    },
    {
        "id": "53085197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:17.115",
        "brokerTime": "2025-05-14 14:48:17.600",
        "commission": -21.14,
        "swap": 0,
        "profit": -81.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049075",
        "positionId": "56049074",
        "volume": 3.02,
        "price": 3228.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.68,
        "takeProfit": null,
        "priceIn": 3228.07,
        "doubleCheck": true
    },
    {
        "id": "53085198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18.092",
        "brokerTime": "2025-05-14 14:48:18.092",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049076",
        "positionId": "56049076",
        "volume": 3.02,
        "price": 3228.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.13,
        "doubleCheck": true
    },
    {
        "id": "53085199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18.092",
        "brokerTime": "2025-05-14 14:48:18.464",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049077",
        "positionId": "56049076",
        "volume": 3.02,
        "price": 3228.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.4,
        "takeProfit": null,
        "priceIn": 3228.13,
        "doubleCheck": true
    },
    {
        "id": "53085200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18.766",
        "brokerTime": "2025-05-14 14:48:18.766",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049078",
        "positionId": "56049078",
        "volume": 3.02,
        "price": 3228.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.17,
        "doubleCheck": true
    },
    {
        "id": "53085201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:18.766",
        "brokerTime": "2025-05-14 14:48:19.565",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049079",
        "positionId": "56049078",
        "volume": 3.02,
        "price": 3228.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3228.17,
        "doubleCheck": true
    },
    {
        "id": "53085202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:20.507",
        "brokerTime": "2025-05-14 14:48:20.507",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049080",
        "positionId": "56049080",
        "volume": 3.02,
        "price": 3228.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.29,
        "doubleCheck": true
    },
    {
        "id": "53085204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:20.507",
        "brokerTime": "2025-05-14 14:48:20.840",
        "commission": -21.14,
        "swap": 0,
        "profit": -75.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049082",
        "positionId": "56049080",
        "volume": 3.02,
        "price": 3228.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -96.64,
        "takeProfit": null,
        "priceIn": 3228.29,
        "doubleCheck": true
    },
    {
        "id": "53085205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21.131",
        "brokerTime": "2025-05-14 14:48:21.131",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049083",
        "positionId": "56049083",
        "volume": 3.02,
        "price": 3228.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3228.37,
        "doubleCheck": true
    },
    {
        "id": "53085206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:21.131",
        "brokerTime": "2025-05-14 14:48:21.863",
        "commission": -21.14,
        "swap": 0,
        "profit": 39.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049084",
        "positionId": "56049083",
        "volume": 3.02,
        "price": 3228.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 18.119999999999997,
        "takeProfit": null,
        "priceIn": 3228.37,
        "doubleCheck": true
    },
    {
        "id": "53085207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:22.169",
        "brokerTime": "2025-05-14 14:48:22.169",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049085",
        "positionId": "56049085",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:22.169",
        "brokerTime": "2025-05-14 14:48:23.051",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049086",
        "positionId": "56049085",
        "volume": 3.02,
        "price": 3228.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84.56,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:23.457",
        "brokerTime": "2025-05-14 14:48:23.457",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049087",
        "positionId": "56049087",
        "volume": 3.02,
        "price": 3227.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.92,
        "doubleCheck": true
    },
    {
        "id": "53085212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:23.457",
        "brokerTime": "2025-05-14 14:48:23.852",
        "commission": -21.14,
        "swap": 0,
        "profit": -21.14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049090",
        "positionId": "56049087",
        "volume": 3.02,
        "price": 3227.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -42.28,
        "takeProfit": null,
        "priceIn": 3227.92,
        "doubleCheck": true
    },
    {
        "id": "53085213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:24.626",
        "brokerTime": "2025-05-14 14:48:24.626",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049091",
        "positionId": "56049091",
        "volume": 3.02,
        "price": 3227.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.78,
        "doubleCheck": true
    },
    {
        "id": "53085214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:24.626",
        "brokerTime": "2025-05-14 14:48:25.025",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049092",
        "positionId": "56049091",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.78,
        "doubleCheck": true
    },
    {
        "id": "53085215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:25.739",
        "brokerTime": "2025-05-14 14:48:25.739",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049093",
        "positionId": "56049093",
        "volume": 3.02,
        "price": 3227.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.8,
        "doubleCheck": true
    },
    {
        "id": "53085216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:25.739",
        "brokerTime": "2025-05-14 14:48:26.378",
        "commission": -21.14,
        "swap": 0,
        "profit": -87.58,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049094",
        "positionId": "56049093",
        "volume": 3.02,
        "price": 3228.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.72,
        "takeProfit": null,
        "priceIn": 3227.8,
        "doubleCheck": true
    },
    {
        "id": "53085218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:27.198",
        "brokerTime": "2025-05-14 14:48:27.198",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049096",
        "positionId": "56049096",
        "volume": 3.02,
        "price": 3227.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:27.198",
        "brokerTime": "2025-05-14 14:48:28.082",
        "commission": -21.14,
        "swap": 0,
        "profit": -63.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049097",
        "positionId": "56049096",
        "volume": 3.02,
        "price": 3228.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84.56,
        "takeProfit": null,
        "priceIn": 3227.91,
        "doubleCheck": true
    },
    {
        "id": "53085220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:28.501",
        "brokerTime": "2025-05-14 14:48:28.501",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049098",
        "positionId": "56049098",
        "volume": 3.02,
        "price": 3227.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.9,
        "doubleCheck": true
    },
    {
        "id": "53085221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:28.501",
        "brokerTime": "2025-05-14 14:48:28.883",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049099",
        "positionId": "56049098",
        "volume": 3.02,
        "price": 3228.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -66.44,
        "takeProfit": null,
        "priceIn": 3227.9,
        "doubleCheck": true
    },
    {
        "id": "53085222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29.347",
        "brokerTime": "2025-05-14 14:48:29.347",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049100",
        "positionId": "56049100",
        "volume": 3.02,
        "price": 3227.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.84,
        "doubleCheck": true
    },
    {
        "id": "53085223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29.347",
        "brokerTime": "2025-05-14 14:48:29.762",
        "commission": -21.14,
        "swap": 0,
        "profit": -66.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049101",
        "positionId": "56049100",
        "volume": 3.02,
        "price": 3228.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -87.58,
        "takeProfit": null,
        "priceIn": 3227.84,
        "doubleCheck": true
    },
    {
        "id": "53085224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29.977",
        "brokerTime": "2025-05-14 14:48:29.977",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049102",
        "positionId": "56049102",
        "volume": 3.02,
        "price": 3227.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.86,
        "doubleCheck": true
    },
    {
        "id": "53085225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:29.977",
        "brokerTime": "2025-05-14 14:48:30.709",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049103",
        "positionId": "56049102",
        "volume": 3.02,
        "price": 3228.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.86,
        "doubleCheck": true
    },
    {
        "id": "53085226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:31.137",
        "brokerTime": "2025-05-14 14:48:31.137",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049106",
        "positionId": "56049106",
        "volume": 3.02,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.7,
        "doubleCheck": true
    },
    {
        "id": "53085231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:31.137",
        "brokerTime": "2025-05-14 14:48:31.576",
        "commission": -21.14,
        "swap": 0,
        "profit": -39.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049109",
        "positionId": "56049106",
        "volume": 3.02,
        "price": 3227.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.4,
        "takeProfit": null,
        "priceIn": 3227.7,
        "doubleCheck": true
    },
    {
        "id": "53085232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32.059",
        "brokerTime": "2025-05-14 14:48:32.059",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049110",
        "positionId": "56049110",
        "volume": 3.02,
        "price": 3227.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.63,
        "doubleCheck": true
    },
    {
        "id": "53085233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32.059",
        "brokerTime": "2025-05-14 14:48:32.490",
        "commission": -21.14,
        "swap": 0,
        "profit": -30.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049111",
        "positionId": "56049110",
        "volume": 3.02,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -51.34,
        "takeProfit": null,
        "priceIn": 3227.63,
        "doubleCheck": true
    },
    {
        "id": "53085238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32.749",
        "brokerTime": "2025-05-14 14:48:32.749",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049116",
        "positionId": "56049116",
        "volume": 3.02,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:32.749",
        "brokerTime": "2025-05-14 14:48:33.086",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049117",
        "positionId": "56049116",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33.470",
        "brokerTime": "2025-05-14 14:48:33.470",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049118",
        "positionId": "56049118",
        "volume": 3.02,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "id": "53085241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:33.470",
        "brokerTime": "2025-05-14 14:48:34.535",
        "commission": -21.14,
        "swap": 0,
        "profit": -84.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049120",
        "positionId": "56049118",
        "volume": 3.02,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.7,
        "takeProfit": null,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "id": "53085243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:34.898",
        "brokerTime": "2025-05-14 14:48:34.898",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049121",
        "positionId": "56049121",
        "volume": 3.02,
        "price": 3227.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "id": "53085244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:34.898",
        "brokerTime": "2025-05-14 14:48:35.395",
        "commission": -21.14,
        "swap": 0,
        "profit": -135.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049122",
        "positionId": "56049121",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.04000000000002,
        "takeProfit": null,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "id": "53085245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:35.747",
        "brokerTime": "2025-05-14 14:48:35.747",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049123",
        "positionId": "56049123",
        "volume": 3.02,
        "price": 3227.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.82,
        "doubleCheck": true
    },
    {
        "id": "53085246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:35.747",
        "brokerTime": "2025-05-14 14:48:36.109",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049124",
        "positionId": "56049123",
        "volume": 3.02,
        "price": 3228.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3227.82,
        "doubleCheck": true
    },
    {
        "id": "53085247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36.361",
        "brokerTime": "2025-05-14 14:48:36.361",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049125",
        "positionId": "56049125",
        "volume": 3.02,
        "price": 3227.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.81,
        "doubleCheck": true
    },
    {
        "id": "53085248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:36.361",
        "brokerTime": "2025-05-14 14:48:37.030",
        "commission": -21.14,
        "swap": 0,
        "profit": -81.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049126",
        "positionId": "56049125",
        "volume": 3.02,
        "price": 3228.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.68,
        "takeProfit": null,
        "priceIn": 3227.81,
        "doubleCheck": true
    },
    {
        "id": "53085249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:37.380",
        "brokerTime": "2025-05-14 14:48:37.380",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049127",
        "positionId": "56049127",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "id": "53085250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:37.380",
        "brokerTime": "2025-05-14 14:48:37.854",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049128",
        "positionId": "56049127",
        "volume": 3.02,
        "price": 3227.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.38,
        "takeProfit": null,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "id": "53085251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:38.023",
        "brokerTime": "2025-05-14 14:48:38.023",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049129",
        "positionId": "56049129",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.76,
        "doubleCheck": true
    },
    {
        "id": "53085252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:38.023",
        "brokerTime": "2025-05-14 14:48:38.665",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049130",
        "positionId": "56049129",
        "volume": 3.02,
        "price": 3227.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.76,
        "doubleCheck": true
    },
    {
        "id": "53085253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:39.059",
        "brokerTime": "2025-05-14 14:48:39.059",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049131",
        "positionId": "56049131",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "id": "53085254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:39.059",
        "brokerTime": "2025-05-14 14:48:39.841",
        "commission": -21.14,
        "swap": 0,
        "profit": -84.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049132",
        "positionId": "56049131",
        "volume": 3.02,
        "price": 3228.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.7,
        "takeProfit": null,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "id": "53085255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:40.708",
        "brokerTime": "2025-05-14 14:48:40.708",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049133",
        "positionId": "56049133",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "id": "53085257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:40.708",
        "brokerTime": "2025-05-14 14:48:41.224",
        "commission": -21.14,
        "swap": 0,
        "profit": -42.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049135",
        "positionId": "56049133",
        "volume": 3.02,
        "price": 3227.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63.42,
        "takeProfit": null,
        "priceIn": 3227.85,
        "doubleCheck": true
    },
    {
        "id": "53085258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:41.834",
        "brokerTime": "2025-05-14 14:48:41.834",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049136",
        "positionId": "56049136",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "id": "53085259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:41.834",
        "brokerTime": "2025-05-14 14:48:42.234",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049137",
        "positionId": "56049136",
        "volume": 3.02,
        "price": 3227.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.38,
        "takeProfit": null,
        "priceIn": 3227.75,
        "doubleCheck": true
    },
    {
        "id": "53085260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:42.641",
        "brokerTime": "2025-05-14 14:48:42.641",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049138",
        "positionId": "56049138",
        "volume": 3.02,
        "price": 3227.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "id": "53085261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:42.641",
        "brokerTime": "2025-05-14 14:48:43.192",
        "commission": -21.14,
        "swap": 0,
        "profit": -18.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049139",
        "positionId": "56049138",
        "volume": 3.02,
        "price": 3227.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -39.260000000000005,
        "takeProfit": null,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "id": "53085262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:43.913",
        "brokerTime": "2025-05-14 14:48:43.913",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049140",
        "positionId": "56049140",
        "volume": 3.02,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.49,
        "doubleCheck": true
    },
    {
        "id": "53085263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:43.913",
        "brokerTime": "2025-05-14 14:48:45.369",
        "commission": -21.14,
        "swap": 0,
        "profit": -102.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049141",
        "positionId": "56049140",
        "volume": 3.02,
        "price": 3227.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -123.82000000000001,
        "takeProfit": null,
        "priceIn": 3227.49,
        "doubleCheck": true
    },
    {
        "id": "53085264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:46.886",
        "brokerTime": "2025-05-14 14:48:46.886",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049142",
        "positionId": "56049142",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.65,
        "doubleCheck": true
    },
    {
        "id": "53085265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:46.886",
        "brokerTime": "2025-05-14 14:48:47.381",
        "commission": -21.14,
        "swap": 0,
        "profit": -36.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049143",
        "positionId": "56049142",
        "volume": 3.02,
        "price": 3227.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.38,
        "takeProfit": null,
        "priceIn": 3227.65,
        "doubleCheck": true
    },
    {
        "id": "53085266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:48.151",
        "brokerTime": "2025-05-14 14:48:48.151",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049144",
        "positionId": "56049144",
        "volume": 3.02,
        "price": 3227.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "id": "53085268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:48.151",
        "brokerTime": "2025-05-14 14:48:49.202",
        "commission": -21.14,
        "swap": 0,
        "profit": -87.58,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049146",
        "positionId": "56049144",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.72,
        "takeProfit": null,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "id": "53085269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:51.045",
        "brokerTime": "2025-05-14 14:48:51.045",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049147",
        "positionId": "56049147",
        "volume": 3.02,
        "price": 3227.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "id": "53085270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:51.045",
        "brokerTime": "2025-05-14 14:48:51.866",
        "commission": -21.14,
        "swap": 0,
        "profit": -57.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049148",
        "positionId": "56049147",
        "volume": 3.02,
        "price": 3227.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -78.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.66,
        "doubleCheck": true
    },
    {
        "id": "53085271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:52.869",
        "brokerTime": "2025-05-14 14:48:52.869",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049149",
        "positionId": "56049149",
        "volume": 3.02,
        "price": 3227.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.64,
        "doubleCheck": true
    },
    {
        "id": "53085272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:52.869",
        "brokerTime": "2025-05-14 14:48:53.332",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049150",
        "positionId": "56049149",
        "volume": 3.02,
        "price": 3227.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.5,
        "takeProfit": null,
        "priceIn": 3227.64,
        "doubleCheck": true
    },
    {
        "id": "53085273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:53.548",
        "brokerTime": "2025-05-14 14:48:53.548",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049151",
        "positionId": "56049151",
        "volume": 3.02,
        "price": 3227.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.61,
        "doubleCheck": true
    },
    {
        "id": "53085274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:53.548",
        "brokerTime": "2025-05-14 14:48:53.987",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049152",
        "positionId": "56049151",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -66.44,
        "takeProfit": null,
        "priceIn": 3227.61,
        "doubleCheck": true
    },
    {
        "id": "53085275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55.065",
        "brokerTime": "2025-05-14 14:48:55.065",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049153",
        "positionId": "56049153",
        "volume": 3.02,
        "price": 3227.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.57,
        "doubleCheck": true
    },
    {
        "id": "53085276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55.065",
        "brokerTime": "2025-05-14 14:48:55.354",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049154",
        "positionId": "56049153",
        "volume": 3.02,
        "price": 3227.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -66.44,
        "takeProfit": null,
        "priceIn": 3227.57,
        "doubleCheck": true
    },
    {
        "id": "53085277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55.608",
        "brokerTime": "2025-05-14 14:48:55.608",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049155",
        "positionId": "56049155",
        "volume": 3.02,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:55.608",
        "brokerTime": "2025-05-14 14:48:56.000",
        "commission": -21.14,
        "swap": 0,
        "profit": -45.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049156",
        "positionId": "56049155",
        "volume": 3.02,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -66.44,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56.169",
        "brokerTime": "2025-05-14 14:48:56.169",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049157",
        "positionId": "56049157",
        "volume": 3.02,
        "price": 3227.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "id": "53085280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:56.169",
        "brokerTime": "2025-05-14 14:48:56.742",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049158",
        "positionId": "56049157",
        "volume": 3.02,
        "price": 3227.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3227.56,
        "doubleCheck": true
    },
    {
        "id": "53085281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57.105",
        "brokerTime": "2025-05-14 14:48:57.105",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049159",
        "positionId": "56049159",
        "volume": 3.02,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "id": "53085282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57.105",
        "brokerTime": "2025-05-14 14:48:57.687",
        "commission": -21.14,
        "swap": 0,
        "profit": -60.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049160",
        "positionId": "56049159",
        "volume": 3.02,
        "price": 3227.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.53999999999999,
        "takeProfit": null,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "id": "53085283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57.901",
        "brokerTime": "2025-05-14 14:48:57.901",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049161",
        "positionId": "56049161",
        "volume": 3.02,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "id": "53085284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:57.901",
        "brokerTime": "2025-05-14 14:48:59.422",
        "commission": -21.14,
        "swap": 0,
        "profit": -54.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049162",
        "positionId": "56049161",
        "volume": 3.02,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.5,
        "takeProfit": null,
        "priceIn": 3227.55,
        "doubleCheck": true
    },
    {
        "id": "53085285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:59.685",
        "brokerTime": "2025-05-14 14:48:59.685",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049163",
        "positionId": "56049163",
        "volume": 3.02,
        "price": 3227.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "id": "53085288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:48:59.685",
        "brokerTime": "2025-05-14 14:49:00.111",
        "commission": -21.14,
        "swap": 0,
        "profit": -48.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049166",
        "positionId": "56049163",
        "volume": 3.02,
        "price": 3227.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.46000000000001,
        "takeProfit": null,
        "priceIn": 3227.52,
        "doubleCheck": true
    },
    {
        "id": "53085292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:00.814",
        "brokerTime": "2025-05-14 14:49:00.814",
        "commission": -21.14,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049170",
        "positionId": "56049170",
        "volume": 3.02,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21.14,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:00.814",
        "brokerTime": "2025-05-14 14:49:01.412",
        "commission": -21.14,
        "swap": 0,
        "profit": 12.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049171",
        "positionId": "56049170",
        "volume": 3.02,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.06,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:49:01.552",
        "brokerTime": "2025-05-14 14:49:01.552",
        "commission": -4.34,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049172",
        "positionId": "56049172",
        "volume": 0.62,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3327.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.34,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "id": "53085297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:02.624",
        "brokerTime": "2025-05-14 14:49:02.624",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049175",
        "positionId": "56049175",
        "volume": 3.76,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085299",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:02.624",
        "brokerTime": "2025-05-14 14:49:03.002",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049177",
        "positionId": "56049175",
        "volume": 3.76,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.2,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03.389",
        "brokerTime": "2025-05-14 14:49:03.389",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049178",
        "positionId": "56049178",
        "volume": 3.76,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085301",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:03.389",
        "brokerTime": "2025-05-14 14:49:03.791",
        "commission": -26.32,
        "swap": 0,
        "profit": -60.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049179",
        "positionId": "56049178",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -86.47999999999999,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04.085",
        "brokerTime": "2025-05-14 14:49:04.085",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049180",
        "positionId": "56049180",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04.085",
        "brokerTime": "2025-05-14 14:49:04.540",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049182",
        "positionId": "56049180",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04.703",
        "brokerTime": "2025-05-14 14:49:04.703",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049184",
        "positionId": "56049184",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:04.703",
        "brokerTime": "2025-05-14 14:49:05.064",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049185",
        "positionId": "56049184",
        "volume": 3.76,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.03999999999999,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05.299",
        "brokerTime": "2025-05-14 14:49:05.299",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049186",
        "positionId": "56049186",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:05.299",
        "brokerTime": "2025-05-14 14:49:05.706",
        "commission": -26.32,
        "swap": 0,
        "profit": -30.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049187",
        "positionId": "56049186",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.4,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06.180",
        "brokerTime": "2025-05-14 14:49:06.180",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049189",
        "positionId": "56049189",
        "volume": 3.76,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06.180",
        "brokerTime": "2025-05-14 14:49:06.679",
        "commission": -26.32,
        "swap": 0,
        "profit": -22.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049191",
        "positionId": "56049189",
        "volume": 3.76,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -48.879999999999995,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06.970",
        "brokerTime": "2025-05-14 14:49:06.970",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049192",
        "positionId": "56049192",
        "volume": 3.76,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53085316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:06.970",
        "brokerTime": "2025-05-14 14:49:07.269",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049193",
        "positionId": "56049192",
        "volume": 3.76,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.03999999999999,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53085320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:07.703",
        "brokerTime": "2025-05-14 14:49:07.703",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049197",
        "positionId": "56049197",
        "volume": 3.76,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "id": "53085323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:07.703",
        "brokerTime": "2025-05-14 14:49:08.104",
        "commission": -26.32,
        "swap": 0,
        "profit": -112.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049198",
        "positionId": "56049197",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.12,
        "takeProfit": null,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "id": "53085324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08.462",
        "brokerTime": "2025-05-14 14:49:08.462",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049199",
        "positionId": "56049199",
        "volume": 3.76,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53085325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:08.462",
        "brokerTime": "2025-05-14 14:49:08.938",
        "commission": -26.32,
        "swap": 0,
        "profit": -225.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049200",
        "positionId": "56049199",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.92,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53085326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09.099",
        "brokerTime": "2025-05-14 14:49:09.099",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049201",
        "positionId": "56049201",
        "volume": 3.76,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09.099",
        "brokerTime": "2025-05-14 14:49:09.473",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049202",
        "positionId": "56049201",
        "volume": 3.76,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.6,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09.600",
        "brokerTime": "2025-05-14 14:49:09.600",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049203",
        "positionId": "56049203",
        "volume": 3.76,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:09.600",
        "brokerTime": "2025-05-14 14:49:09.897",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049204",
        "positionId": "56049203",
        "volume": 3.76,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10.121",
        "brokerTime": "2025-05-14 14:49:10.121",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049205",
        "positionId": "56049205",
        "volume": 3.76,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10.121",
        "brokerTime": "2025-05-14 14:49:10.437",
        "commission": -26.32,
        "swap": 0,
        "profit": -71.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049207",
        "positionId": "56049205",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.75999999999999,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10.622",
        "brokerTime": "2025-05-14 14:49:10.622",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049208",
        "positionId": "56049208",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:10.622",
        "brokerTime": "2025-05-14 14:49:10.929",
        "commission": -26.32,
        "swap": 0,
        "profit": 7.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049209",
        "positionId": "56049208",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -18.8,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11.384",
        "brokerTime": "2025-05-14 14:49:11.384",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049211",
        "positionId": "56049211",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:11.384",
        "brokerTime": "2025-05-14 14:49:11.916",
        "commission": -26.32,
        "swap": 0,
        "profit": -195.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049212",
        "positionId": "56049211",
        "volume": 3.76,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -221.84,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085337",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12.151",
        "brokerTime": "2025-05-14 14:49:12.151",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049213",
        "positionId": "56049213",
        "volume": 3.76,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12.151",
        "brokerTime": "2025-05-14 14:49:12.623",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049214",
        "positionId": "56049213",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.6,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12.843",
        "brokerTime": "2025-05-14 14:49:12.843",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049215",
        "positionId": "56049215",
        "volume": 3.76,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.93,
        "doubleCheck": true
    },
    {
        "id": "53085340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:12.843",
        "brokerTime": "2025-05-14 14:49:13.619",
        "commission": -26.32,
        "swap": 0,
        "profit": -11.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049216",
        "positionId": "56049215",
        "volume": 3.76,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -37.6,
        "takeProfit": null,
        "priceIn": 3226.93,
        "doubleCheck": true
    },
    {
        "id": "53085341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:13.819",
        "brokerTime": "2025-05-14 14:49:13.819",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049217",
        "positionId": "56049217",
        "volume": 3.76,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:13.819",
        "brokerTime": "2025-05-14 14:49:14.269",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049218",
        "positionId": "56049217",
        "volume": 3.76,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.03999999999999,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:14.625",
        "brokerTime": "2025-05-14 14:49:14.625",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049219",
        "positionId": "56049219",
        "volume": 3.76,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "id": "53085346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:14.625",
        "brokerTime": "2025-05-14 14:49:15.162",
        "commission": -26.32,
        "swap": 0,
        "profit": -150.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049221",
        "positionId": "56049219",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.72,
        "takeProfit": null,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "id": "53085347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:15.564",
        "brokerTime": "2025-05-14 14:49:15.564",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049222",
        "positionId": "56049222",
        "volume": 3.76,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:15.564",
        "brokerTime": "2025-05-14 14:49:16.411",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049224",
        "positionId": "56049222",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.03999999999999,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:16.718",
        "brokerTime": "2025-05-14 14:49:16.718",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049225",
        "positionId": "56049225",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:16.718",
        "brokerTime": "2025-05-14 14:49:17.179",
        "commission": -26.32,
        "swap": 0,
        "profit": -71.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049226",
        "positionId": "56049225",
        "volume": 3.76,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.75999999999999,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:17.548",
        "brokerTime": "2025-05-14 14:49:17.548",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049227",
        "positionId": "56049227",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:17.548",
        "brokerTime": "2025-05-14 14:49:17.905",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049228",
        "positionId": "56049227",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085355",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18.284",
        "brokerTime": "2025-05-14 14:49:18.284",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049229",
        "positionId": "56049229",
        "volume": 3.76,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:18.284",
        "brokerTime": "2025-05-14 14:49:18.754",
        "commission": -26.32,
        "swap": 0,
        "profit": -37.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049230",
        "positionId": "56049229",
        "volume": 3.76,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63.92,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085357",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:19.006",
        "brokerTime": "2025-05-14 14:49:19.006",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049231",
        "positionId": "56049231",
        "volume": 3.76,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:19.006",
        "brokerTime": "2025-05-14 14:49:19.790",
        "commission": -26.32,
        "swap": 0,
        "profit": -56.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049232",
        "positionId": "56049231",
        "volume": 3.76,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -82.72,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:20.063",
        "brokerTime": "2025-05-14 14:49:20.063",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049233",
        "positionId": "56049233",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085360",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:20.063",
        "brokerTime": "2025-05-14 14:49:20.913",
        "commission": -26.32,
        "swap": 0,
        "profit": -150.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049234",
        "positionId": "56049233",
        "volume": 3.76,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.72,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085361",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:21.362",
        "brokerTime": "2025-05-14 14:49:21.362",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049235",
        "positionId": "56049235",
        "volume": 3.76,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085362",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:21.362",
        "brokerTime": "2025-05-14 14:49:22.150",
        "commission": -26.32,
        "swap": 0,
        "profit": -97.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049236",
        "positionId": "56049235",
        "volume": 3.76,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -124.08000000000001,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53085363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:22.630",
        "brokerTime": "2025-05-14 14:49:22.630",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049237",
        "positionId": "56049237",
        "volume": 3.76,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:22.630",
        "brokerTime": "2025-05-14 14:49:23.100",
        "commission": -26.32,
        "swap": 0,
        "profit": -142.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049238",
        "positionId": "56049237",
        "volume": 3.76,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -169.2,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23.305",
        "brokerTime": "2025-05-14 14:49:23.305",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049239",
        "positionId": "56049239",
        "volume": 3.76,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:23.305",
        "brokerTime": "2025-05-14 14:49:24.070",
        "commission": -26.32,
        "swap": 0,
        "profit": -154.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049240",
        "positionId": "56049239",
        "volume": 3.76,
        "price": 3227.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -180.48,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085367",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:24.452",
        "brokerTime": "2025-05-14 14:49:24.452",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049241",
        "positionId": "56049241",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "id": "53085369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:24.452",
        "brokerTime": "2025-05-14 14:49:25.004",
        "commission": -26.32,
        "swap": 0,
        "profit": -60.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049243",
        "positionId": "56049241",
        "volume": 3.76,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -86.47999999999999,
        "takeProfit": null,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "id": "53085371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:25.207",
        "brokerTime": "2025-05-14 14:49:25.207",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049244",
        "positionId": "56049244",
        "volume": 3.76,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "id": "53085372",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:25.207",
        "brokerTime": "2025-05-14 14:49:25.702",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049245",
        "positionId": "56049244",
        "volume": 3.76,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "id": "53085373",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26.465",
        "brokerTime": "2025-05-14 14:49:26.465",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049246",
        "positionId": "56049246",
        "volume": 3.76,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "id": "53085374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26.465",
        "brokerTime": "2025-05-14 14:49:26.764",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049247",
        "positionId": "56049246",
        "volume": 3.76,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "id": "53085375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26.988",
        "brokerTime": "2025-05-14 14:49:26.988",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049248",
        "positionId": "56049248",
        "volume": 3.76,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:26.988",
        "brokerTime": "2025-05-14 14:49:27.287",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049249",
        "positionId": "56049248",
        "volume": 3.76,
        "price": 3227.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:27.733",
        "brokerTime": "2025-05-14 14:49:27.733",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049250",
        "positionId": "56049250",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:27.733",
        "brokerTime": "2025-05-14 14:49:28.798",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049251",
        "positionId": "56049250",
        "volume": 3.76,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:29.111",
        "brokerTime": "2025-05-14 14:49:29.111",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049252",
        "positionId": "56049252",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "id": "53085380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:29.111",
        "brokerTime": "2025-05-14 14:49:30.185",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049253",
        "positionId": "56049252",
        "volume": 3.76,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.28,
        "takeProfit": null,
        "priceIn": 3227.25,
        "doubleCheck": true
    },
    {
        "id": "53085382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:31.024",
        "brokerTime": "2025-05-14 14:49:31.024",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049255",
        "positionId": "56049255",
        "volume": 3.76,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085383",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:31.024",
        "brokerTime": "2025-05-14 14:49:31.339",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049256",
        "positionId": "56049255",
        "volume": 3.76,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:32.032",
        "brokerTime": "2025-05-14 14:49:32.032",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049258",
        "positionId": "56049258",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:32.032",
        "brokerTime": "2025-05-14 14:49:32.382",
        "commission": -26.32,
        "swap": 0,
        "profit": -67.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049259",
        "positionId": "56049258",
        "volume": 3.76,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -94,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:33.342",
        "brokerTime": "2025-05-14 14:49:33.342",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049260",
        "positionId": "56049260",
        "volume": 3.76,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:33.342",
        "brokerTime": "2025-05-14 14:49:33.810",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049261",
        "positionId": "56049260",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.2,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:34.163",
        "brokerTime": "2025-05-14 14:49:34.163",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049262",
        "positionId": "56049262",
        "volume": 3.76,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:34.163",
        "brokerTime": "2025-05-14 14:49:34.962",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049263",
        "positionId": "56049262",
        "volume": 3.76,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:35.485",
        "brokerTime": "2025-05-14 14:49:35.485",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049264",
        "positionId": "56049264",
        "volume": 3.76,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:35.485",
        "brokerTime": "2025-05-14 14:49:36.037",
        "commission": -26.32,
        "swap": 0,
        "profit": 124.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049265",
        "positionId": "56049264",
        "volume": 3.76,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 97.75999999999999,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:36.508",
        "brokerTime": "2025-05-14 14:49:36.508",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049266",
        "positionId": "56049266",
        "volume": 3.76,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:36.508",
        "brokerTime": "2025-05-14 14:49:37.150",
        "commission": -26.32,
        "swap": 0,
        "profit": -135.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049267",
        "positionId": "56049266",
        "volume": 3.76,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161.68,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37.412",
        "brokerTime": "2025-05-14 14:49:37.412",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049268",
        "positionId": "56049268",
        "volume": 3.76,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "id": "53085396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:37.412",
        "brokerTime": "2025-05-14 14:49:38.000",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049269",
        "positionId": "56049268",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.92,
        "takeProfit": null,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "id": "53085397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:38.219",
        "brokerTime": "2025-05-14 14:49:38.219",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049270",
        "positionId": "56049270",
        "volume": 3.76,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:38.219",
        "brokerTime": "2025-05-14 14:49:38.862",
        "commission": -26.32,
        "swap": 0,
        "profit": -22.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049272",
        "positionId": "56049270",
        "volume": 3.76,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -48.879999999999995,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39.113",
        "brokerTime": "2025-05-14 14:49:39.113",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049273",
        "positionId": "56049273",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39.113",
        "brokerTime": "2025-05-14 14:49:39.579",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049274",
        "positionId": "56049273",
        "volume": 3.76,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39.837",
        "brokerTime": "2025-05-14 14:49:39.837",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049277",
        "positionId": "56049277",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:39.837",
        "brokerTime": "2025-05-14 14:49:40.345",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049278",
        "positionId": "56049277",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085405",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:40.628",
        "brokerTime": "2025-05-14 14:49:40.628",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049279",
        "positionId": "56049279",
        "volume": 3.76,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:40.628",
        "brokerTime": "2025-05-14 14:49:41.192",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049280",
        "positionId": "56049279",
        "volume": 3.76,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.16,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:41.904",
        "brokerTime": "2025-05-14 14:49:41.904",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049281",
        "positionId": "56049281",
        "volume": 3.76,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:41.904",
        "brokerTime": "2025-05-14 14:49:43.137",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049282",
        "positionId": "56049281",
        "volume": 3.76,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.28,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:43.776",
        "brokerTime": "2025-05-14 14:49:43.776",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049283",
        "positionId": "56049283",
        "volume": 3.76,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:43.776",
        "brokerTime": "2025-05-14 14:49:44.240",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049284",
        "positionId": "56049283",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.2,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:44.926",
        "brokerTime": "2025-05-14 14:49:44.926",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049285",
        "positionId": "56049285",
        "volume": 3.76,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:44.926",
        "brokerTime": "2025-05-14 14:49:45.269",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049286",
        "positionId": "56049285",
        "volume": 3.76,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.28,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:45.599",
        "brokerTime": "2025-05-14 14:49:45.599",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049287",
        "positionId": "56049287",
        "volume": 3.76,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:45.599",
        "brokerTime": "2025-05-14 14:49:46.139",
        "commission": -26.32,
        "swap": 0,
        "profit": -105.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049288",
        "positionId": "56049287",
        "volume": 3.76,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.6,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46.455",
        "brokerTime": "2025-05-14 14:49:46.455",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049289",
        "positionId": "56049289",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085416",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:46.455",
        "brokerTime": "2025-05-14 14:49:46.880",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049290",
        "positionId": "56049289",
        "volume": 3.76,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:47.505",
        "brokerTime": "2025-05-14 14:49:47.505",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049291",
        "positionId": "56049291",
        "volume": 3.76,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:47.505",
        "brokerTime": "2025-05-14 14:49:48.264",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049292",
        "positionId": "56049291",
        "volume": 3.76,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.28,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:48.623",
        "brokerTime": "2025-05-14 14:49:48.623",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049293",
        "positionId": "56049293",
        "volume": 3.76,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:48.623",
        "brokerTime": "2025-05-14 14:49:49.146",
        "commission": -26.32,
        "swap": 0,
        "profit": -86.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049294",
        "positionId": "56049293",
        "volume": 3.76,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112.80000000000001,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085422",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:50.766",
        "brokerTime": "2025-05-14 14:49:50.766",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049295",
        "positionId": "56049295",
        "volume": 3.76,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085423",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:50.766",
        "brokerTime": "2025-05-14 14:49:51.032",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049296",
        "positionId": "56049295",
        "volume": 3.76,
        "price": 3227.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.16,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51.420",
        "brokerTime": "2025-05-14 14:49:51.420",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049297",
        "positionId": "56049297",
        "volume": 3.76,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.17,
        "doubleCheck": true
    },
    {
        "id": "53085425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:51.420",
        "brokerTime": "2025-05-14 14:49:51.918",
        "commission": -26.32,
        "swap": 0,
        "profit": 11.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049298",
        "positionId": "56049297",
        "volume": 3.76,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.040000000000001,
        "takeProfit": null,
        "priceIn": 3227.17,
        "doubleCheck": true
    },
    {
        "id": "53085426",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52.099",
        "brokerTime": "2025-05-14 14:49:52.099",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049299",
        "positionId": "56049299",
        "volume": 3.76,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52.099",
        "brokerTime": "2025-05-14 14:49:52.617",
        "commission": -26.32,
        "swap": 0,
        "profit": -157.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049300",
        "positionId": "56049299",
        "volume": 3.76,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -184.23999999999998,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085429",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52.804",
        "brokerTime": "2025-05-14 14:49:52.804",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049302",
        "positionId": "56049302",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085430",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:52.804",
        "brokerTime": "2025-05-14 14:49:53.221",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049303",
        "positionId": "56049302",
        "volume": 3.76,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:53.661",
        "brokerTime": "2025-05-14 14:49:53.661",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049304",
        "positionId": "56049304",
        "volume": 3.76,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085432",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:53.661",
        "brokerTime": "2025-05-14 14:49:54.090",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049305",
        "positionId": "56049304",
        "volume": 3.76,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.92,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085433",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:54.869",
        "brokerTime": "2025-05-14 14:49:54.869",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049306",
        "positionId": "56049306",
        "volume": 3.76,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085434",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:54.869",
        "brokerTime": "2025-05-14 14:49:55.255",
        "commission": -26.32,
        "swap": 0,
        "profit": -75.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049307",
        "positionId": "56049306",
        "volume": 3.76,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -101.52000000000001,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085435",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:55.639",
        "brokerTime": "2025-05-14 14:49:55.639",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049308",
        "positionId": "56049308",
        "volume": 3.76,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:55.639",
        "brokerTime": "2025-05-14 14:49:56.211",
        "commission": -26.32,
        "swap": 0,
        "profit": -82.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049310",
        "positionId": "56049308",
        "volume": 3.76,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.03999999999999,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:57.141",
        "brokerTime": "2025-05-14 14:49:57.141",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049311",
        "positionId": "56049311",
        "volume": 3.76,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085438",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:57.141",
        "brokerTime": "2025-05-14 14:49:58.059",
        "commission": -26.32,
        "swap": 0,
        "profit": -30.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049312",
        "positionId": "56049311",
        "volume": 3.76,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.4,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085439",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:58.279",
        "brokerTime": "2025-05-14 14:49:58.279",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049313",
        "positionId": "56049313",
        "volume": 3.76,
        "price": 3226.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "id": "53085440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:58.279",
        "brokerTime": "2025-05-14 14:49:58.608",
        "commission": -26.32,
        "swap": 0,
        "profit": -90.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049314",
        "positionId": "56049313",
        "volume": 3.76,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.56,
        "takeProfit": null,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "id": "53085441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59.221",
        "brokerTime": "2025-05-14 14:49:59.221",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049315",
        "positionId": "56049315",
        "volume": 3.76,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "id": "53085443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59.221",
        "brokerTime": "2025-05-14 14:49:59.698",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049317",
        "positionId": "56049315",
        "volume": 3.76,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "id": "53085444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59.939",
        "brokerTime": "2025-05-14 14:49:59.939",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049318",
        "positionId": "56049318",
        "volume": 3.76,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "id": "53085449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:49:59.939",
        "brokerTime": "2025-05-14 14:50:00.504",
        "commission": -26.32,
        "swap": 0,
        "profit": -127.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049322",
        "positionId": "56049318",
        "volume": 3.76,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.16,
        "takeProfit": null,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "id": "53085450",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:00.733",
        "brokerTime": "2025-05-14 14:50:00.733",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049323",
        "positionId": "56049323",
        "volume": 3.76,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "id": "53085453",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:00.733",
        "brokerTime": "2025-05-14 14:50:01.321",
        "commission": -26.32,
        "swap": 0,
        "profit": -131.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049326",
        "positionId": "56049323",
        "volume": 3.76,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.92,
        "takeProfit": null,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "id": "53085455",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:01.947",
        "brokerTime": "2025-05-14 14:50:01.947",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049328",
        "positionId": "56049328",
        "volume": 3.76,
        "price": 3226.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "id": "53085456",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:01.947",
        "brokerTime": "2025-05-14 14:50:02.539",
        "commission": -26.32,
        "swap": 0,
        "profit": -63.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049329",
        "positionId": "56049328",
        "volume": 3.76,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -90.24000000000001,
        "takeProfit": null,
        "priceIn": 3226.5,
        "doubleCheck": true
    },
    {
        "id": "53085457",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:03.409",
        "brokerTime": "2025-05-14 14:50:03.409",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049330",
        "positionId": "56049330",
        "volume": 3.76,
        "price": 3226.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "id": "53085459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:03.409",
        "brokerTime": "2025-05-14 14:50:04.011",
        "commission": -26.32,
        "swap": 0,
        "profit": -78.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049332",
        "positionId": "56049330",
        "volume": 3.76,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.28,
        "takeProfit": null,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "id": "53085462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:04.489",
        "brokerTime": "2025-05-14 14:50:04.489",
        "commission": -26.32,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049334",
        "positionId": "56049334",
        "volume": 3.76,
        "price": 3226.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.32,
        "takeProfit": null,
        "priceIn": 3226.24,
        "doubleCheck": true
    },
    {
        "id": "53085463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:04.489",
        "brokerTime": "2025-05-14 14:50:05.002",
        "commission": -26.32,
        "swap": 0,
        "profit": -48.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049336",
        "positionId": "56049334",
        "volume": 3.76,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.2,
        "takeProfit": null,
        "priceIn": 3226.24,
        "doubleCheck": true
    },
    {
        "id": "53085464",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:50:05.035",
        "brokerTime": "2025-05-14 14:50:05.035",
        "commission": -5.18,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049337",
        "positionId": "56049337",
        "volume": 0.74,
        "price": 3226.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3326.37,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -5.18,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "id": "53085470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:05.953",
        "brokerTime": "2025-05-14 14:50:05.953",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049340",
        "positionId": "56049340",
        "volume": 4.65,
        "price": 3226.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "id": "53085471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:05.953",
        "brokerTime": "2025-05-14 14:50:06.201",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049341",
        "positionId": "56049340",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "id": "53085472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:07.820",
        "brokerTime": "2025-05-14 14:50:07.820",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049342",
        "positionId": "56049342",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085473",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:07.820",
        "brokerTime": "2025-05-14 14:50:08.406",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049343",
        "positionId": "56049342",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:08.579",
        "brokerTime": "2025-05-14 14:50:08.579",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049344",
        "positionId": "56049344",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:08.579",
        "brokerTime": "2025-05-14 14:50:08.810",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049345",
        "positionId": "56049344",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09.072",
        "brokerTime": "2025-05-14 14:50:09.072",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049346",
        "positionId": "56049346",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09.072",
        "brokerTime": "2025-05-14 14:50:09.323",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049347",
        "positionId": "56049346",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085478",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09.626",
        "brokerTime": "2025-05-14 14:50:09.626",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049348",
        "positionId": "56049348",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:09.626",
        "brokerTime": "2025-05-14 14:50:09.865",
        "commission": -32.55,
        "swap": 0,
        "profit": -204.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049349",
        "positionId": "56049348",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -237.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10.066",
        "brokerTime": "2025-05-14 14:50:10.066",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049350",
        "positionId": "56049350",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:10.066",
        "brokerTime": "2025-05-14 14:50:10.310",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049351",
        "positionId": "56049350",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11.010",
        "brokerTime": "2025-05-14 14:50:11.010",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049352",
        "positionId": "56049352",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11.010",
        "brokerTime": "2025-05-14 14:50:11.249",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049353",
        "positionId": "56049352",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11.670",
        "brokerTime": "2025-05-14 14:50:11.670",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049354",
        "positionId": "56049354",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:11.670",
        "brokerTime": "2025-05-14 14:50:11.885",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049355",
        "positionId": "56049354",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12.288",
        "brokerTime": "2025-05-14 14:50:12.288",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049356",
        "positionId": "56049356",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12.288",
        "brokerTime": "2025-05-14 14:50:12.579",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049357",
        "positionId": "56049356",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12.905",
        "brokerTime": "2025-05-14 14:50:12.905",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049359",
        "positionId": "56049359",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:12.905",
        "brokerTime": "2025-05-14 14:50:13.141",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049360",
        "positionId": "56049359",
        "volume": 4.65,
        "price": 3227.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085491",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:13.742",
        "brokerTime": "2025-05-14 14:50:13.742",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049361",
        "positionId": "56049361",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:13.742",
        "brokerTime": "2025-05-14 14:50:13.994",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049363",
        "positionId": "56049361",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14.319",
        "brokerTime": "2025-05-14 14:50:14.319",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049364",
        "positionId": "56049364",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14.319",
        "brokerTime": "2025-05-14 14:50:14.601",
        "commission": -32.55,
        "swap": 0,
        "profit": -167.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049365",
        "positionId": "56049364",
        "volume": 4.65,
        "price": 3227.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.95,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14.854",
        "brokerTime": "2025-05-14 14:50:14.854",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049366",
        "positionId": "56049366",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:14.854",
        "brokerTime": "2025-05-14 14:50:15.117",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049367",
        "positionId": "56049366",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15.305",
        "brokerTime": "2025-05-14 14:50:15.305",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049368",
        "positionId": "56049368",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "id": "53085499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15.305",
        "brokerTime": "2025-05-14 14:50:15.538",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049369",
        "positionId": "56049368",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "id": "53085500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15.809",
        "brokerTime": "2025-05-14 14:50:15.809",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049370",
        "positionId": "56049370",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.31,
        "doubleCheck": true
    },
    {
        "id": "53085502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:15.809",
        "brokerTime": "2025-05-14 14:50:16.079",
        "commission": -32.55,
        "swap": 0,
        "profit": -195.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049372",
        "positionId": "56049370",
        "volume": 4.65,
        "price": 3227.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.85000000000002,
        "takeProfit": null,
        "priceIn": 3227.31,
        "doubleCheck": true
    },
    {
        "id": "53085503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16.395",
        "brokerTime": "2025-05-14 14:50:16.395",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049373",
        "positionId": "56049373",
        "volume": 4.65,
        "price": 3227.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.44,
        "doubleCheck": true
    },
    {
        "id": "53085504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16.395",
        "brokerTime": "2025-05-14 14:50:16.668",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049374",
        "positionId": "56049373",
        "volume": 4.65,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.44,
        "doubleCheck": true
    },
    {
        "id": "53085505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16.893",
        "brokerTime": "2025-05-14 14:50:16.893",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049375",
        "positionId": "56049375",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "id": "53085506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:16.893",
        "brokerTime": "2025-05-14 14:50:17.331",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049376",
        "positionId": "56049375",
        "volume": 4.65,
        "price": 3227.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.42,
        "doubleCheck": true
    },
    {
        "id": "53085507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:17.594",
        "brokerTime": "2025-05-14 14:50:17.594",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049377",
        "positionId": "56049377",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.38,
        "doubleCheck": true
    },
    {
        "id": "53085508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:17.594",
        "brokerTime": "2025-05-14 14:50:17.816",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049378",
        "positionId": "56049377",
        "volume": 4.65,
        "price": 3227.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.38,
        "doubleCheck": true
    },
    {
        "id": "53085509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18.107",
        "brokerTime": "2025-05-14 14:50:18.107",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049379",
        "positionId": "56049379",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "id": "53085510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:18.107",
        "brokerTime": "2025-05-14 14:50:18.320",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049380",
        "positionId": "56049379",
        "volume": 4.65,
        "price": 3227.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "takeProfit": null,
        "priceIn": 3227.47,
        "doubleCheck": true
    },
    {
        "id": "53085511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:19.054",
        "brokerTime": "2025-05-14 14:50:19.054",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049382",
        "positionId": "56049382",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:19.054",
        "brokerTime": "2025-05-14 14:50:19.299",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049383",
        "positionId": "56049382",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20.064",
        "brokerTime": "2025-05-14 14:50:20.064",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049384",
        "positionId": "56049384",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20.064",
        "brokerTime": "2025-05-14 14:50:20.306",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049385",
        "positionId": "56049384",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20.918",
        "brokerTime": "2025-05-14 14:50:20.918",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049386",
        "positionId": "56049386",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:20.918",
        "brokerTime": "2025-05-14 14:50:21.147",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049387",
        "positionId": "56049386",
        "volume": 4.65,
        "price": 3227.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21.394",
        "brokerTime": "2025-05-14 14:50:21.394",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049388",
        "positionId": "56049388",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21.394",
        "brokerTime": "2025-05-14 14:50:21.618",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049389",
        "positionId": "56049388",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21.903",
        "brokerTime": "2025-05-14 14:50:21.903",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049390",
        "positionId": "56049390",
        "volume": 4.65,
        "price": 3227.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.09,
        "doubleCheck": true
    },
    {
        "id": "53085520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:21.903",
        "brokerTime": "2025-05-14 14:50:22.199",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049391",
        "positionId": "56049390",
        "volume": 4.65,
        "price": 3227.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.09,
        "doubleCheck": true
    },
    {
        "id": "53085521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:22.715",
        "brokerTime": "2025-05-14 14:50:22.715",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049392",
        "positionId": "56049392",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:22.715",
        "brokerTime": "2025-05-14 14:50:22.945",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049393",
        "positionId": "56049392",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:23.813",
        "brokerTime": "2025-05-14 14:50:23.813",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049394",
        "positionId": "56049394",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:23.813",
        "brokerTime": "2025-05-14 14:50:24.066",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049395",
        "positionId": "56049394",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:24.513",
        "brokerTime": "2025-05-14 14:50:24.513",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049398",
        "positionId": "56049398",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:24.513",
        "brokerTime": "2025-05-14 14:50:24.772",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049399",
        "positionId": "56049398",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25.088",
        "brokerTime": "2025-05-14 14:50:25.088",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049400",
        "positionId": "56049400",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25.088",
        "brokerTime": "2025-05-14 14:50:25.321",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049401",
        "positionId": "56049400",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25.828",
        "brokerTime": "2025-05-14 14:50:25.828",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049402",
        "positionId": "56049402",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:25.828",
        "brokerTime": "2025-05-14 14:50:26.089",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049403",
        "positionId": "56049402",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26.313",
        "brokerTime": "2025-05-14 14:50:26.313",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049404",
        "positionId": "56049404",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26.313",
        "brokerTime": "2025-05-14 14:50:26.568",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049405",
        "positionId": "56049404",
        "volume": 4.65,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26.782",
        "brokerTime": "2025-05-14 14:50:26.782",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049406",
        "positionId": "56049406",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:26.782",
        "brokerTime": "2025-05-14 14:50:27.031",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049407",
        "positionId": "56049406",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27.263",
        "brokerTime": "2025-05-14 14:50:27.263",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049408",
        "positionId": "56049408",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:27.263",
        "brokerTime": "2025-05-14 14:50:27.509",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049409",
        "positionId": "56049408",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28.106",
        "brokerTime": "2025-05-14 14:50:28.106",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049410",
        "positionId": "56049410",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28.106",
        "brokerTime": "2025-05-14 14:50:28.330",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049411",
        "positionId": "56049410",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28.705",
        "brokerTime": "2025-05-14 14:50:28.705",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049412",
        "positionId": "56049412",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:28.705",
        "brokerTime": "2025-05-14 14:50:28.927",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049413",
        "positionId": "56049412",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29.270",
        "brokerTime": "2025-05-14 14:50:29.270",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049414",
        "positionId": "56049414",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085544",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29.270",
        "brokerTime": "2025-05-14 14:50:29.486",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049415",
        "positionId": "56049414",
        "volume": 4.65,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085545",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29.693",
        "brokerTime": "2025-05-14 14:50:29.693",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049416",
        "positionId": "56049416",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:29.693",
        "brokerTime": "2025-05-14 14:50:29.939",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049417",
        "positionId": "56049416",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085548",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30.318",
        "brokerTime": "2025-05-14 14:50:30.318",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049419",
        "positionId": "56049419",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085549",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30.318",
        "brokerTime": "2025-05-14 14:50:30.632",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049420",
        "positionId": "56049419",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30.863",
        "brokerTime": "2025-05-14 14:50:30.863",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049424",
        "positionId": "56049424",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085555",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:30.863",
        "brokerTime": "2025-05-14 14:50:31.125",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049426",
        "positionId": "56049424",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31.396",
        "brokerTime": "2025-05-14 14:50:31.396",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049427",
        "positionId": "56049427",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31.396",
        "brokerTime": "2025-05-14 14:50:31.626",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049428",
        "positionId": "56049427",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31.888",
        "brokerTime": "2025-05-14 14:50:31.888",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049429",
        "positionId": "56049429",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:31.888",
        "brokerTime": "2025-05-14 14:50:32.123",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049430",
        "positionId": "56049429",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32.541",
        "brokerTime": "2025-05-14 14:50:32.541",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049431",
        "positionId": "56049431",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085561",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32.541",
        "brokerTime": "2025-05-14 14:50:32.793",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049432",
        "positionId": "56049431",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32.909",
        "brokerTime": "2025-05-14 14:50:32.909",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049433",
        "positionId": "56049433",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:32.909",
        "brokerTime": "2025-05-14 14:50:33.142",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049434",
        "positionId": "56049433",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33.369",
        "brokerTime": "2025-05-14 14:50:33.369",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049435",
        "positionId": "56049435",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:33.369",
        "brokerTime": "2025-05-14 14:50:33.607",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049437",
        "positionId": "56049435",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35.160",
        "brokerTime": "2025-05-14 14:50:35.160",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049438",
        "positionId": "56049438",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35.160",
        "brokerTime": "2025-05-14 14:50:35.389",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049439",
        "positionId": "56049438",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35.738",
        "brokerTime": "2025-05-14 14:50:35.738",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049440",
        "positionId": "56049440",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:35.738",
        "brokerTime": "2025-05-14 14:50:35.960",
        "commission": -32.55,
        "swap": 0,
        "profit": -223.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049441",
        "positionId": "56049440",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -255.75,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:37.852",
        "brokerTime": "2025-05-14 14:50:37.852",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049442",
        "positionId": "56049442",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:37.852",
        "brokerTime": "2025-05-14 14:50:38.081",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049443",
        "positionId": "56049442",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38.367",
        "brokerTime": "2025-05-14 14:50:38.367",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049444",
        "positionId": "56049444",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38.367",
        "brokerTime": "2025-05-14 14:50:38.634",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049445",
        "positionId": "56049444",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38.935",
        "brokerTime": "2025-05-14 14:50:38.935",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049446",
        "positionId": "56049446",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:38.935",
        "brokerTime": "2025-05-14 14:50:39.165",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049447",
        "positionId": "56049446",
        "volume": 4.65,
        "price": 3227.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:39.745",
        "brokerTime": "2025-05-14 14:50:39.745",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049448",
        "positionId": "56049448",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:39.745",
        "brokerTime": "2025-05-14 14:50:39.969",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049449",
        "positionId": "56049448",
        "volume": 4.65,
        "price": 3227.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40.437",
        "brokerTime": "2025-05-14 14:50:40.437",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049450",
        "positionId": "56049450",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:40.437",
        "brokerTime": "2025-05-14 14:50:40.646",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049451",
        "positionId": "56049450",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:41.541",
        "brokerTime": "2025-05-14 14:50:41.541",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049452",
        "positionId": "56049452",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:41.541",
        "brokerTime": "2025-05-14 14:50:41.755",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049453",
        "positionId": "56049452",
        "volume": 4.65,
        "price": 3227.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42.092",
        "brokerTime": "2025-05-14 14:50:42.092",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049454",
        "positionId": "56049454",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42.092",
        "brokerTime": "2025-05-14 14:50:42.311",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049455",
        "positionId": "56049454",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42.584",
        "brokerTime": "2025-05-14 14:50:42.584",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049458",
        "positionId": "56049458",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085587",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:42.584",
        "brokerTime": "2025-05-14 14:50:42.847",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049459",
        "positionId": "56049458",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:43.603",
        "brokerTime": "2025-05-14 14:50:43.603",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049460",
        "positionId": "56049460",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:43.603",
        "brokerTime": "2025-05-14 14:50:43.845",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049461",
        "positionId": "56049460",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44.064",
        "brokerTime": "2025-05-14 14:50:44.064",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049462",
        "positionId": "56049462",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44.064",
        "brokerTime": "2025-05-14 14:50:44.301",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049463",
        "positionId": "56049462",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44.753",
        "brokerTime": "2025-05-14 14:50:44.753",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049464",
        "positionId": "56049464",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:44.753",
        "brokerTime": "2025-05-14 14:50:45.000",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049465",
        "positionId": "56049464",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45.399",
        "brokerTime": "2025-05-14 14:50:45.399",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049466",
        "positionId": "56049466",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:45.399",
        "brokerTime": "2025-05-14 14:50:45.638",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049467",
        "positionId": "56049466",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085596",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:46.074",
        "brokerTime": "2025-05-14 14:50:46.074",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049468",
        "positionId": "56049468",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:46.074",
        "brokerTime": "2025-05-14 14:50:46.294",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049469",
        "positionId": "56049468",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:47.209",
        "brokerTime": "2025-05-14 14:50:47.209",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049470",
        "positionId": "56049470",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:47.209",
        "brokerTime": "2025-05-14 14:50:47.494",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049471",
        "positionId": "56049470",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48.114",
        "brokerTime": "2025-05-14 14:50:48.114",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049472",
        "positionId": "56049472",
        "volume": 4.65,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "id": "53085601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48.114",
        "brokerTime": "2025-05-14 14:50:48.323",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049473",
        "positionId": "56049472",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.65,
        "doubleCheck": true
    },
    {
        "id": "53085602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48.755",
        "brokerTime": "2025-05-14 14:50:48.755",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049474",
        "positionId": "56049474",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:48.755",
        "brokerTime": "2025-05-14 14:50:48.971",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049475",
        "positionId": "56049474",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49.191",
        "brokerTime": "2025-05-14 14:50:49.191",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049476",
        "positionId": "56049476",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49.191",
        "brokerTime": "2025-05-14 14:50:49.419",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049477",
        "positionId": "56049476",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49.718",
        "brokerTime": "2025-05-14 14:50:49.718",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049478",
        "positionId": "56049478",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:49.718",
        "brokerTime": "2025-05-14 14:50:49.954",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049479",
        "positionId": "56049478",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:50.856",
        "brokerTime": "2025-05-14 14:50:50.856",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049480",
        "positionId": "56049480",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "id": "53085609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:50.856",
        "brokerTime": "2025-05-14 14:50:51.082",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049481",
        "positionId": "56049480",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "id": "53085610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:51.604",
        "brokerTime": "2025-05-14 14:50:51.604",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049482",
        "positionId": "56049482",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:51.604",
        "brokerTime": "2025-05-14 14:50:51.826",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049483",
        "positionId": "56049482",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52.122",
        "brokerTime": "2025-05-14 14:50:52.122",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049484",
        "positionId": "56049484",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:52.122",
        "brokerTime": "2025-05-14 14:50:52.347",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049485",
        "positionId": "56049484",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53.161",
        "brokerTime": "2025-05-14 14:50:53.161",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049486",
        "positionId": "56049486",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53.161",
        "brokerTime": "2025-05-14 14:50:53.373",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049488",
        "positionId": "56049486",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53.921",
        "brokerTime": "2025-05-14 14:50:53.921",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049489",
        "positionId": "56049489",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:53.921",
        "brokerTime": "2025-05-14 14:50:54.141",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049491",
        "positionId": "56049489",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:55.432",
        "brokerTime": "2025-05-14 14:50:55.432",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049492",
        "positionId": "56049492",
        "volume": 4.65,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "id": "53085620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:55.432",
        "brokerTime": "2025-05-14 14:50:55.675",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049493",
        "positionId": "56049492",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.18,
        "doubleCheck": true
    },
    {
        "id": "53085621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:56.492",
        "brokerTime": "2025-05-14 14:50:56.492",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049494",
        "positionId": "56049494",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.13,
        "doubleCheck": true
    },
    {
        "id": "53085622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:56.492",
        "brokerTime": "2025-05-14 14:50:56.747",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049495",
        "positionId": "56049494",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3227.13,
        "doubleCheck": true
    },
    {
        "id": "53085623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57.090",
        "brokerTime": "2025-05-14 14:50:57.090",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049496",
        "positionId": "56049496",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085624",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57.090",
        "brokerTime": "2025-05-14 14:50:57.324",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049497",
        "positionId": "56049496",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57.914",
        "brokerTime": "2025-05-14 14:50:57.914",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049498",
        "positionId": "56049498",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:57.914",
        "brokerTime": "2025-05-14 14:50:58.143",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049499",
        "positionId": "56049498",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:58.726",
        "brokerTime": "2025-05-14 14:50:58.726",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049500",
        "positionId": "56049500",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:58.726",
        "brokerTime": "2025-05-14 14:50:58.943",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049501",
        "positionId": "56049500",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53085629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59.149",
        "brokerTime": "2025-05-14 14:50:59.149",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049502",
        "positionId": "56049502",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:50:59.149",
        "brokerTime": "2025-05-14 14:50:59.454",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049503",
        "positionId": "56049502",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00.107",
        "brokerTime": "2025-05-14 14:51:00.107",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049504",
        "positionId": "56049504",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00.107",
        "brokerTime": "2025-05-14 14:51:00.370",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049506",
        "positionId": "56049504",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3227.19,
        "doubleCheck": true
    },
    {
        "id": "53085634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00.747",
        "brokerTime": "2025-05-14 14:51:00.747",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049507",
        "positionId": "56049507",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.36,
        "doubleCheck": true
    },
    {
        "id": "53085635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:00.747",
        "brokerTime": "2025-05-14 14:51:01.021",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049508",
        "positionId": "56049507",
        "volume": 4.65,
        "price": 3227.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3227.36,
        "doubleCheck": true
    },
    {
        "id": "53085636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01.307",
        "brokerTime": "2025-05-14 14:51:01.307",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049509",
        "positionId": "56049509",
        "volume": 4.65,
        "price": 3227.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.53,
        "doubleCheck": true
    },
    {
        "id": "53085637",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:01.307",
        "brokerTime": "2025-05-14 14:51:02.030",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049510",
        "positionId": "56049509",
        "volume": 4.65,
        "price": 3227.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.53,
        "doubleCheck": true
    },
    {
        "id": "53085638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:02.326",
        "brokerTime": "2025-05-14 14:51:02.326",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049511",
        "positionId": "56049511",
        "volume": 4.65,
        "price": 3227.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:02.326",
        "brokerTime": "2025-05-14 14:51:02.851",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049512",
        "positionId": "56049511",
        "volume": 4.65,
        "price": 3227.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.5,
        "doubleCheck": true
    },
    {
        "id": "53085640",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:03.057",
        "brokerTime": "2025-05-14 14:51:03.057",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049513",
        "positionId": "56049513",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:03.057",
        "brokerTime": "2025-05-14 14:51:03.985",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049515",
        "positionId": "56049513",
        "volume": 4.65,
        "price": 3227.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:04.651",
        "brokerTime": "2025-05-14 14:51:04.651",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049516",
        "positionId": "56049516",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:04.651",
        "brokerTime": "2025-05-14 14:51:05.605",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049517",
        "positionId": "56049516",
        "volume": 4.65,
        "price": 3227.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.46,
        "doubleCheck": true
    },
    {
        "id": "53085649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06.078",
        "brokerTime": "2025-05-14 14:51:06.078",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049520",
        "positionId": "56049520",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06.078",
        "brokerTime": "2025-05-14 14:51:06.631",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049522",
        "positionId": "56049520",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.35,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06.912",
        "brokerTime": "2025-05-14 14:51:06.912",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049523",
        "positionId": "56049523",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:06.912",
        "brokerTime": "2025-05-14 14:51:07.511",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049524",
        "positionId": "56049523",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:07.771",
        "brokerTime": "2025-05-14 14:51:07.771",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049525",
        "positionId": "56049525",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:07.771",
        "brokerTime": "2025-05-14 14:51:08.316",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049526",
        "positionId": "56049525",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:08.546",
        "brokerTime": "2025-05-14 14:51:08.546",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049527",
        "positionId": "56049527",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:08.546",
        "brokerTime": "2025-05-14 14:51:08.851",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049528",
        "positionId": "56049527",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09.085",
        "brokerTime": "2025-05-14 14:51:09.085",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049529",
        "positionId": "56049529",
        "volume": 4.65,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.67,
        "doubleCheck": true
    },
    {
        "id": "53085659",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:09.085",
        "brokerTime": "2025-05-14 14:51:10.210",
        "commission": -32.55,
        "swap": 0,
        "profit": -320.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049530",
        "positionId": "56049529",
        "volume": 4.65,
        "price": 3227.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.40000000000003,
        "takeProfit": null,
        "priceIn": 3226.67,
        "doubleCheck": true
    },
    {
        "id": "53085660",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:10.871",
        "brokerTime": "2025-05-14 14:51:10.871",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049531",
        "positionId": "56049531",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:10.871",
        "brokerTime": "2025-05-14 14:51:11.181",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049532",
        "positionId": "56049531",
        "volume": 4.65,
        "price": 3227.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.16,
        "doubleCheck": true
    },
    {
        "id": "53085662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:11.612",
        "brokerTime": "2025-05-14 14:51:11.612",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049533",
        "positionId": "56049533",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:11.612",
        "brokerTime": "2025-05-14 14:51:11.929",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049534",
        "positionId": "56049533",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:12.512",
        "brokerTime": "2025-05-14 14:51:12.512",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049535",
        "positionId": "56049535",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "id": "53085666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:12.512",
        "brokerTime": "2025-05-14 14:51:13.344",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049537",
        "positionId": "56049535",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "takeProfit": null,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "id": "53085667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:13.573",
        "brokerTime": "2025-05-14 14:51:13.573",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049538",
        "positionId": "56049538",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:13.573",
        "brokerTime": "2025-05-14 14:51:14.220",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049539",
        "positionId": "56049538",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:14.548",
        "brokerTime": "2025-05-14 14:51:14.548",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049540",
        "positionId": "56049540",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:14.548",
        "brokerTime": "2025-05-14 14:51:15.082",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049541",
        "positionId": "56049540",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.74,
        "doubleCheck": true
    },
    {
        "id": "53085671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:15.613",
        "brokerTime": "2025-05-14 14:51:15.613",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049542",
        "positionId": "56049542",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:15.613",
        "brokerTime": "2025-05-14 14:51:15.930",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049543",
        "positionId": "56049542",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:19.190",
        "brokerTime": "2025-05-14 14:51:19.190",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049544",
        "positionId": "56049544",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:19.190",
        "brokerTime": "2025-05-14 14:51:19.673",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049545",
        "positionId": "56049544",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:20.110",
        "brokerTime": "2025-05-14 14:51:20.110",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049546",
        "positionId": "56049546",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "id": "53085676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:20.110",
        "brokerTime": "2025-05-14 14:51:20.702",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049547",
        "positionId": "56049546",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.69,
        "doubleCheck": true
    },
    {
        "id": "53085677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:21.139",
        "brokerTime": "2025-05-14 14:51:21.139",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049548",
        "positionId": "56049548",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:21.139",
        "brokerTime": "2025-05-14 14:51:22.236",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049549",
        "positionId": "56049548",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:22.556",
        "brokerTime": "2025-05-14 14:51:22.556",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049550",
        "positionId": "56049550",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:22.556",
        "brokerTime": "2025-05-14 14:51:23.045",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049551",
        "positionId": "56049550",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53085681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:23.812",
        "brokerTime": "2025-05-14 14:51:23.812",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049552",
        "positionId": "56049552",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:23.812",
        "brokerTime": "2025-05-14 14:51:24.418",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049554",
        "positionId": "56049552",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:24.877",
        "brokerTime": "2025-05-14 14:51:24.877",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049555",
        "positionId": "56049555",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:24.877",
        "brokerTime": "2025-05-14 14:51:25.426",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049556",
        "positionId": "56049555",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.68,
        "doubleCheck": true
    },
    {
        "id": "53085685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:25.721",
        "brokerTime": "2025-05-14 14:51:25.721",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049557",
        "positionId": "56049557",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:25.721",
        "brokerTime": "2025-05-14 14:51:27.023",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049558",
        "positionId": "56049557",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:27.561",
        "brokerTime": "2025-05-14 14:51:27.561",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049559",
        "positionId": "56049559",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:27.561",
        "brokerTime": "2025-05-14 14:51:28.151",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049560",
        "positionId": "56049559",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28.320",
        "brokerTime": "2025-05-14 14:51:28.320",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049561",
        "positionId": "56049561",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:28.320",
        "brokerTime": "2025-05-14 14:51:28.820",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049562",
        "positionId": "56049561",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:29.093",
        "brokerTime": "2025-05-14 14:51:29.093",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049564",
        "positionId": "56049564",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:29.093",
        "brokerTime": "2025-05-14 14:51:30.226",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049565",
        "positionId": "56049564",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:30.435",
        "brokerTime": "2025-05-14 14:51:30.435",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049566",
        "positionId": "56049566",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:30.435",
        "brokerTime": "2025-05-14 14:51:30.750",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049567",
        "positionId": "56049566",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:31.003",
        "brokerTime": "2025-05-14 14:51:31.003",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049568",
        "positionId": "56049568",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:31.003",
        "brokerTime": "2025-05-14 14:51:31.361",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049569",
        "positionId": "56049568",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32.094",
        "brokerTime": "2025-05-14 14:51:32.094",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049571",
        "positionId": "56049571",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085701",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32.094",
        "brokerTime": "2025-05-14 14:51:32.480",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049573",
        "positionId": "56049571",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32.705",
        "brokerTime": "2025-05-14 14:51:32.705",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049574",
        "positionId": "56049574",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085704",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:32.705",
        "brokerTime": "2025-05-14 14:51:33.142",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049576",
        "positionId": "56049574",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:33.544",
        "brokerTime": "2025-05-14 14:51:33.544",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049577",
        "positionId": "56049577",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:33.544",
        "brokerTime": "2025-05-14 14:51:34.443",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049580",
        "positionId": "56049577",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -181.35000000000002,
        "takeProfit": null,
        "priceIn": 3226.85,
        "doubleCheck": true
    },
    {
        "id": "53085709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:34.594",
        "brokerTime": "2025-05-14 14:51:34.594",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049581",
        "positionId": "56049581",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:34.594",
        "brokerTime": "2025-05-14 14:51:34.992",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049582",
        "positionId": "56049581",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085711",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:35.589",
        "brokerTime": "2025-05-14 14:51:35.589",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049583",
        "positionId": "56049583",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085713",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:35.589",
        "brokerTime": "2025-05-14 14:51:36.208",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049585",
        "positionId": "56049583",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.35,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085714",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:36.525",
        "brokerTime": "2025-05-14 14:51:36.525",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049586",
        "positionId": "56049586",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085715",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:36.525",
        "brokerTime": "2025-05-14 14:51:37.295",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049587",
        "positionId": "56049586",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:37.689",
        "brokerTime": "2025-05-14 14:51:37.689",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049588",
        "positionId": "56049588",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:37.689",
        "brokerTime": "2025-05-14 14:51:38.047",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049589",
        "positionId": "56049588",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38.457",
        "brokerTime": "2025-05-14 14:51:38.457",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049590",
        "positionId": "56049590",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:38.457",
        "brokerTime": "2025-05-14 14:51:38.783",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049591",
        "positionId": "56049590",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39.058",
        "brokerTime": "2025-05-14 14:51:39.058",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049592",
        "positionId": "56049592",
        "volume": 4.65,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "id": "53085721",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39.058",
        "brokerTime": "2025-05-14 14:51:39.585",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049593",
        "positionId": "56049592",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.37,
        "doubleCheck": true
    },
    {
        "id": "53085722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39.818",
        "brokerTime": "2025-05-14 14:51:39.818",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049594",
        "positionId": "56049594",
        "volume": 4.65,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53085723",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:39.818",
        "brokerTime": "2025-05-14 14:51:40.301",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049595",
        "positionId": "56049594",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53085724",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:40.553",
        "brokerTime": "2025-05-14 14:51:40.553",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049596",
        "positionId": "56049596",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085726",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:40.553",
        "brokerTime": "2025-05-14 14:51:41.100",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049598",
        "positionId": "56049596",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:42.195",
        "brokerTime": "2025-05-14 14:51:42.195",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049599",
        "positionId": "56049599",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:42.195",
        "brokerTime": "2025-05-14 14:51:42.804",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049600",
        "positionId": "56049599",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43.201",
        "brokerTime": "2025-05-14 14:51:43.201",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049601",
        "positionId": "56049601",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "id": "53085731",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43.201",
        "brokerTime": "2025-05-14 14:51:43.570",
        "commission": -32.55,
        "swap": 0,
        "profit": -23.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049602",
        "positionId": "56049601",
        "volume": 4.65,
        "price": 3226.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -55.8,
        "takeProfit": null,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "id": "53085732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43.779",
        "brokerTime": "2025-05-14 14:51:43.779",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049603",
        "positionId": "56049603",
        "volume": 4.65,
        "price": 3226.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.36,
        "doubleCheck": true
    },
    {
        "id": "53085733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:43.779",
        "brokerTime": "2025-05-14 14:51:44.178",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049604",
        "positionId": "56049603",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "takeProfit": null,
        "priceIn": 3226.36,
        "doubleCheck": true
    },
    {
        "id": "53085734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44.420",
        "brokerTime": "2025-05-14 14:51:44.420",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049605",
        "positionId": "56049605",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "id": "53085735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:44.420",
        "brokerTime": "2025-05-14 14:51:44.711",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049606",
        "positionId": "56049605",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.27,
        "doubleCheck": true
    },
    {
        "id": "53085736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:45.302",
        "brokerTime": "2025-05-14 14:51:45.302",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049607",
        "positionId": "56049607",
        "volume": 4.65,
        "price": 3226.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.42,
        "doubleCheck": true
    },
    {
        "id": "53085738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:45.302",
        "brokerTime": "2025-05-14 14:51:45.921",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049609",
        "positionId": "56049607",
        "volume": 4.65,
        "price": 3226.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.42,
        "doubleCheck": true
    },
    {
        "id": "53085739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:46.100",
        "brokerTime": "2025-05-14 14:51:46.100",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049610",
        "positionId": "56049610",
        "volume": 4.65,
        "price": 3226.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.39,
        "doubleCheck": true
    },
    {
        "id": "53085740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:46.100",
        "brokerTime": "2025-05-14 14:51:47.540",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049611",
        "positionId": "56049610",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.39,
        "doubleCheck": true
    },
    {
        "id": "53085741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48.031",
        "brokerTime": "2025-05-14 14:51:48.031",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049612",
        "positionId": "56049612",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "id": "53085742",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48.031",
        "brokerTime": "2025-05-14 14:51:48.665",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049613",
        "positionId": "56049612",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.46,
        "doubleCheck": true
    },
    {
        "id": "53085743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48.954",
        "brokerTime": "2025-05-14 14:51:48.954",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049614",
        "positionId": "56049614",
        "volume": 4.65,
        "price": 3226.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "id": "53085744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:48.954",
        "brokerTime": "2025-05-14 14:51:49.339",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049615",
        "positionId": "56049614",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "id": "53085745",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:49.570",
        "brokerTime": "2025-05-14 14:51:49.570",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049616",
        "positionId": "56049616",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085746",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:49.570",
        "brokerTime": "2025-05-14 14:51:50.069",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049617",
        "positionId": "56049616",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:50.608",
        "brokerTime": "2025-05-14 14:51:50.608",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049618",
        "positionId": "56049618",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085748",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:50.608",
        "brokerTime": "2025-05-14 14:51:51.545",
        "commission": -32.55,
        "swap": 0,
        "profit": -153.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049619",
        "positionId": "56049618",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:51.947",
        "brokerTime": "2025-05-14 14:51:51.947",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049621",
        "positionId": "56049621",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085751",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:51.947",
        "brokerTime": "2025-05-14 14:51:52.494",
        "commission": -32.55,
        "swap": 0,
        "profit": 51.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049622",
        "positionId": "56049621",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 18.6,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:52.764",
        "brokerTime": "2025-05-14 14:51:52.764",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049624",
        "positionId": "56049624",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:52.764",
        "brokerTime": "2025-05-14 14:51:53.261",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049626",
        "positionId": "56049624",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:53.780",
        "brokerTime": "2025-05-14 14:51:53.780",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049627",
        "positionId": "56049627",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:53.780",
        "brokerTime": "2025-05-14 14:51:55.016",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049628",
        "positionId": "56049627",
        "volume": 4.65,
        "price": 3226.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:55.346",
        "brokerTime": "2025-05-14 14:51:55.346",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049631",
        "positionId": "56049631",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:55.346",
        "brokerTime": "2025-05-14 14:51:55.852",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049632",
        "positionId": "56049631",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:56.421",
        "brokerTime": "2025-05-14 14:51:56.421",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049633",
        "positionId": "56049633",
        "volume": 4.65,
        "price": 3226.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "id": "53085764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:56.421",
        "brokerTime": "2025-05-14 14:51:56.938",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049634",
        "positionId": "56049633",
        "volume": 4.65,
        "price": 3226.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "id": "53085765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:57.358",
        "brokerTime": "2025-05-14 14:51:57.358",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049635",
        "positionId": "56049635",
        "volume": 4.65,
        "price": 3226.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.51,
        "doubleCheck": true
    },
    {
        "id": "53085766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:57.358",
        "brokerTime": "2025-05-14 14:51:57.994",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049636",
        "positionId": "56049635",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.51,
        "doubleCheck": true
    },
    {
        "id": "53085767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:58.214",
        "brokerTime": "2025-05-14 14:51:58.214",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049637",
        "positionId": "56049637",
        "volume": 4.65,
        "price": 3226.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "id": "53085770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:58.214",
        "brokerTime": "2025-05-14 14:51:58.909",
        "commission": -32.55,
        "swap": 0,
        "profit": 60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049640",
        "positionId": "56049637",
        "volume": 4.65,
        "price": 3226.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 27.900000000000006,
        "takeProfit": null,
        "priceIn": 3226.55,
        "doubleCheck": true
    },
    {
        "id": "53085771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:59.588",
        "brokerTime": "2025-05-14 14:51:59.588",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049641",
        "positionId": "56049641",
        "volume": 4.65,
        "price": 3226.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "id": "53085772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:51:59.588",
        "brokerTime": "2025-05-14 14:51:59.969",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049642",
        "positionId": "56049641",
        "volume": 4.65,
        "price": 3226.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.23,
        "doubleCheck": true
    },
    {
        "id": "53085774",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00.397",
        "brokerTime": "2025-05-14 14:52:00.397",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049644",
        "positionId": "56049644",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53085775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:00.397",
        "brokerTime": "2025-05-14 14:52:01.003",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049645",
        "positionId": "56049644",
        "volume": 4.65,
        "price": 3226.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53085776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:01.386",
        "brokerTime": "2025-05-14 14:52:01.386",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049646",
        "positionId": "56049646",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53085777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:01.386",
        "brokerTime": "2025-05-14 14:52:02.085",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049647",
        "positionId": "56049646",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.39999999999998,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53085778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:02.347",
        "brokerTime": "2025-05-14 14:52:02.347",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049648",
        "positionId": "56049648",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:02.347",
        "brokerTime": "2025-05-14 14:52:02.713",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049649",
        "positionId": "56049648",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085780",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:03.166",
        "brokerTime": "2025-05-14 14:52:03.166",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049650",
        "positionId": "56049650",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:03.166",
        "brokerTime": "2025-05-14 14:52:03.839",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049651",
        "positionId": "56049650",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:04.613",
        "brokerTime": "2025-05-14 14:52:04.613",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049652",
        "positionId": "56049652",
        "volume": 4.65,
        "price": 3226.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.7,
        "doubleCheck": true
    },
    {
        "id": "53085783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:04.613",
        "brokerTime": "2025-05-14 14:52:04.949",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049653",
        "positionId": "56049652",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.7,
        "doubleCheck": true
    },
    {
        "id": "53085784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05.280",
        "brokerTime": "2025-05-14 14:52:05.280",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049654",
        "positionId": "56049654",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:05.280",
        "brokerTime": "2025-05-14 14:52:05.996",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049655",
        "positionId": "56049654",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:06.485",
        "brokerTime": "2025-05-14 14:52:06.485",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049656",
        "positionId": "56049656",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:06.485",
        "brokerTime": "2025-05-14 14:52:07.187",
        "commission": -32.55,
        "swap": 0,
        "profit": -204.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049659",
        "positionId": "56049656",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -237.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53085790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:07.597",
        "brokerTime": "2025-05-14 14:52:07.597",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049660",
        "positionId": "56049660",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:07.597",
        "brokerTime": "2025-05-14 14:52:07.915",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049661",
        "positionId": "56049660",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08.172",
        "brokerTime": "2025-05-14 14:52:08.172",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049662",
        "positionId": "56049662",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:08.172",
        "brokerTime": "2025-05-14 14:52:08.890",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049663",
        "positionId": "56049662",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:09.489",
        "brokerTime": "2025-05-14 14:52:09.489",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049664",
        "positionId": "56049664",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:09.489",
        "brokerTime": "2025-05-14 14:52:10.290",
        "commission": -32.55,
        "swap": 0,
        "profit": -167.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049665",
        "positionId": "56049664",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.95,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:10.539",
        "brokerTime": "2025-05-14 14:52:10.539",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049666",
        "positionId": "56049666",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:10.539",
        "brokerTime": "2025-05-14 14:52:11.053",
        "commission": -32.55,
        "swap": 0,
        "profit": -18.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049668",
        "positionId": "56049666",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -51.15,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53085799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:11.515",
        "brokerTime": "2025-05-14 14:52:11.515",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049669",
        "positionId": "56049669",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:11.515",
        "brokerTime": "2025-05-14 14:52:12.126",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049670",
        "positionId": "56049669",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.7,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:13.496",
        "brokerTime": "2025-05-14 14:52:13.496",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049671",
        "positionId": "56049671",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:13.496",
        "brokerTime": "2025-05-14 14:52:13.974",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049672",
        "positionId": "56049671",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085803",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:15.031",
        "brokerTime": "2025-05-14 14:52:15.031",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049673",
        "positionId": "56049673",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:15.031",
        "brokerTime": "2025-05-14 14:52:15.348",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049674",
        "positionId": "56049673",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:16.050",
        "brokerTime": "2025-05-14 14:52:16.050",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049676",
        "positionId": "56049676",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:16.050",
        "brokerTime": "2025-05-14 14:52:16.399",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049677",
        "positionId": "56049676",
        "volume": 4.65,
        "price": 3227.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53085808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:17.224",
        "brokerTime": "2025-05-14 14:52:17.224",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049678",
        "positionId": "56049678",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:17.224",
        "brokerTime": "2025-05-14 14:52:18.097",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049679",
        "positionId": "56049678",
        "volume": 4.65,
        "price": 3227.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.27,
        "doubleCheck": true
    },
    {
        "id": "53085810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:18.499",
        "brokerTime": "2025-05-14 14:52:18.499",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049680",
        "positionId": "56049680",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:18.499",
        "brokerTime": "2025-05-14 14:52:18.844",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049681",
        "positionId": "56049680",
        "volume": 4.65,
        "price": 3226.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:19.222",
        "brokerTime": "2025-05-14 14:52:19.222",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049682",
        "positionId": "56049682",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:19.222",
        "brokerTime": "2025-05-14 14:52:19.558",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049683",
        "positionId": "56049682",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085814",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:20.058",
        "brokerTime": "2025-05-14 14:52:20.058",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049684",
        "positionId": "56049684",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:20.058",
        "brokerTime": "2025-05-14 14:52:21.214",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049685",
        "positionId": "56049684",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.35,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:21.862",
        "brokerTime": "2025-05-14 14:52:21.862",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049686",
        "positionId": "56049686",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:21.862",
        "brokerTime": "2025-05-14 14:52:23.093",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049687",
        "positionId": "56049686",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.35,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:23.690",
        "brokerTime": "2025-05-14 14:52:23.690",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049688",
        "positionId": "56049688",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:23.690",
        "brokerTime": "2025-05-14 14:52:24.086",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049689",
        "positionId": "56049688",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.39999999999998,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53085820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24.312",
        "brokerTime": "2025-05-14 14:52:24.312",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049690",
        "positionId": "56049690",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:24.312",
        "brokerTime": "2025-05-14 14:52:25.314",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049691",
        "positionId": "56049690",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:25.840",
        "brokerTime": "2025-05-14 14:52:25.840",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049692",
        "positionId": "56049692",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53085823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:25.840",
        "brokerTime": "2025-05-14 14:52:27.562",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049693",
        "positionId": "56049692",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53085824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:29.361",
        "brokerTime": "2025-05-14 14:52:29.361",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049694",
        "positionId": "56049694",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53085825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:29.361",
        "brokerTime": "2025-05-14 14:52:29.656",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049695",
        "positionId": "56049694",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53085826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:30.597",
        "brokerTime": "2025-05-14 14:52:30.597",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049696",
        "positionId": "56049696",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:30.597",
        "brokerTime": "2025-05-14 14:52:31.067",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049697",
        "positionId": "56049696",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:31.564",
        "brokerTime": "2025-05-14 14:52:31.564",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049698",
        "positionId": "56049698",
        "volume": 4.65,
        "price": 3226.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.57,
        "doubleCheck": true
    },
    {
        "id": "53085829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:31.564",
        "brokerTime": "2025-05-14 14:52:32.402",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049699",
        "positionId": "56049698",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.57,
        "doubleCheck": true
    },
    {
        "id": "53085830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:32.587",
        "brokerTime": "2025-05-14 14:52:32.587",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049700",
        "positionId": "56049700",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:32.587",
        "brokerTime": "2025-05-14 14:52:33.572",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049702",
        "positionId": "56049700",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53085833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:33.778",
        "brokerTime": "2025-05-14 14:52:33.778",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049703",
        "positionId": "56049703",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:33.778",
        "brokerTime": "2025-05-14 14:52:34.242",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049704",
        "positionId": "56049703",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3227.03,
        "doubleCheck": true
    },
    {
        "id": "53085835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34.476",
        "brokerTime": "2025-05-14 14:52:34.476",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049705",
        "positionId": "56049705",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:34.476",
        "brokerTime": "2025-05-14 14:52:35.027",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049706",
        "positionId": "56049705",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:35.540",
        "brokerTime": "2025-05-14 14:52:35.540",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049707",
        "positionId": "56049707",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:35.540",
        "brokerTime": "2025-05-14 14:52:35.877",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049708",
        "positionId": "56049707",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.7,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36.305",
        "brokerTime": "2025-05-14 14:52:36.305",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049710",
        "positionId": "56049710",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:36.305",
        "brokerTime": "2025-05-14 14:52:36.730",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049711",
        "positionId": "56049710",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37.092",
        "brokerTime": "2025-05-14 14:52:37.092",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049712",
        "positionId": "56049712",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37.092",
        "brokerTime": "2025-05-14 14:52:37.538",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049713",
        "positionId": "56049712",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37.760",
        "brokerTime": "2025-05-14 14:52:37.760",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049714",
        "positionId": "56049714",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:37.760",
        "brokerTime": "2025-05-14 14:52:38.183",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049715",
        "positionId": "56049714",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -181.35000000000002,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:38.540",
        "brokerTime": "2025-05-14 14:52:38.540",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049716",
        "positionId": "56049716",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:38.540",
        "brokerTime": "2025-05-14 14:52:39.095",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049717",
        "positionId": "56049716",
        "volume": 4.65,
        "price": 3227.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.08,
        "doubleCheck": true
    },
    {
        "id": "53085848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40.110",
        "brokerTime": "2025-05-14 14:52:40.110",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049718",
        "positionId": "56049718",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40.110",
        "brokerTime": "2025-05-14 14:52:40.421",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049719",
        "positionId": "56049718",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40.765",
        "brokerTime": "2025-05-14 14:52:40.765",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049720",
        "positionId": "56049720",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.88,
        "doubleCheck": true
    },
    {
        "id": "53085851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:40.765",
        "brokerTime": "2025-05-14 14:52:41.128",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049721",
        "positionId": "56049720",
        "volume": 4.65,
        "price": 3227.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.88,
        "doubleCheck": true
    },
    {
        "id": "53085852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41.274",
        "brokerTime": "2025-05-14 14:52:41.274",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049722",
        "positionId": "56049722",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:41.274",
        "brokerTime": "2025-05-14 14:52:41.722",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049723",
        "positionId": "56049722",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42.005",
        "brokerTime": "2025-05-14 14:52:42.005",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049724",
        "positionId": "56049724",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42.005",
        "brokerTime": "2025-05-14 14:52:42.394",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049725",
        "positionId": "56049724",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42.825",
        "brokerTime": "2025-05-14 14:52:42.825",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049726",
        "positionId": "56049726",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:42.825",
        "brokerTime": "2025-05-14 14:52:43.384",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049727",
        "positionId": "56049726",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:43.945",
        "brokerTime": "2025-05-14 14:52:43.945",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049728",
        "positionId": "56049728",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:43.945",
        "brokerTime": "2025-05-14 14:52:44.329",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049729",
        "positionId": "56049728",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:44.553",
        "brokerTime": "2025-05-14 14:52:44.553",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049730",
        "positionId": "56049730",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:44.553",
        "brokerTime": "2025-05-14 14:52:47.035",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049732",
        "positionId": "56049730",
        "volume": 4.65,
        "price": 3227.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:48.947",
        "brokerTime": "2025-05-14 14:52:48.947",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049735",
        "positionId": "56049735",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:48.947",
        "brokerTime": "2025-05-14 14:52:50.415",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049739",
        "positionId": "56049735",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53085870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:50.877",
        "brokerTime": "2025-05-14 14:52:50.877",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049740",
        "positionId": "56049740",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:50.877",
        "brokerTime": "2025-05-14 14:52:51.427",
        "commission": -32.55,
        "swap": 0,
        "profit": -241.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049741",
        "positionId": "56049740",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -274.35,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:51.648",
        "brokerTime": "2025-05-14 14:52:51.648",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049742",
        "positionId": "56049742",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "id": "53085873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:51.648",
        "brokerTime": "2025-05-14 14:52:52.426",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049743",
        "positionId": "56049742",
        "volume": 4.65,
        "price": 3227.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227.23,
        "doubleCheck": true
    },
    {
        "id": "53085874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:53.229",
        "brokerTime": "2025-05-14 14:52:53.229",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049744",
        "positionId": "56049744",
        "volume": 4.65,
        "price": 3227.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.22,
        "doubleCheck": true
    },
    {
        "id": "53085875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:53.229",
        "brokerTime": "2025-05-14 14:52:53.957",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049745",
        "positionId": "56049744",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3227.22,
        "doubleCheck": true
    },
    {
        "id": "53085876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54.344",
        "brokerTime": "2025-05-14 14:52:54.344",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049746",
        "positionId": "56049746",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54.344",
        "brokerTime": "2025-05-14 14:52:54.686",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049747",
        "positionId": "56049746",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.99,
        "doubleCheck": true
    },
    {
        "id": "53085878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54.921",
        "brokerTime": "2025-05-14 14:52:54.921",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049748",
        "positionId": "56049748",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:54.921",
        "brokerTime": "2025-05-14 14:52:55.257",
        "commission": -32.55,
        "swap": 0,
        "profit": -106.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049749",
        "positionId": "56049748",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.5,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:55.585",
        "brokerTime": "2025-05-14 14:52:55.585",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049750",
        "positionId": "56049750",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:55.585",
        "brokerTime": "2025-05-14 14:52:55.972",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049751",
        "positionId": "56049750",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.96,
        "doubleCheck": true
    },
    {
        "id": "53085882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56.267",
        "brokerTime": "2025-05-14 14:52:56.267",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049752",
        "positionId": "56049752",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "id": "53085883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:56.267",
        "brokerTime": "2025-05-14 14:52:56.585",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049753",
        "positionId": "56049752",
        "volume": 4.65,
        "price": 3227.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "id": "53085884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:57.019",
        "brokerTime": "2025-05-14 14:52:57.019",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049754",
        "positionId": "56049754",
        "volume": 4.65,
        "price": 3227.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:57.019",
        "brokerTime": "2025-05-14 14:52:57.737",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049755",
        "positionId": "56049754",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.04,
        "doubleCheck": true
    },
    {
        "id": "53085887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:59.338",
        "brokerTime": "2025-05-14 14:52:59.338",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049757",
        "positionId": "56049757",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:52:59.338",
        "brokerTime": "2025-05-14 14:52:59.675",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049758",
        "positionId": "56049757",
        "volume": 4.65,
        "price": 3227.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3227.06,
        "doubleCheck": true
    },
    {
        "id": "53085889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:00.083",
        "brokerTime": "2025-05-14 14:53:00.083",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049759",
        "positionId": "56049759",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:00.083",
        "brokerTime": "2025-05-14 14:53:01.107",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049760",
        "positionId": "56049759",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:01.339",
        "brokerTime": "2025-05-14 14:53:01.339",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049761",
        "positionId": "56049761",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:01.339",
        "brokerTime": "2025-05-14 14:53:02.030",
        "commission": -32.55,
        "swap": 0,
        "profit": -37.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049762",
        "positionId": "56049761",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.75,
        "takeProfit": null,
        "priceIn": 3227.05,
        "doubleCheck": true
    },
    {
        "id": "53085893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:02.519",
        "brokerTime": "2025-05-14 14:53:02.519",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049763",
        "positionId": "56049763",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:02.519",
        "brokerTime": "2025-05-14 14:53:03.100",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049764",
        "positionId": "56049763",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:03.653",
        "brokerTime": "2025-05-14 14:53:03.653",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049766",
        "positionId": "56049766",
        "volume": 4.65,
        "price": 3226.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:03.653",
        "brokerTime": "2025-05-14 14:53:04.355",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049767",
        "positionId": "56049766",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.66,
        "doubleCheck": true
    },
    {
        "id": "53085898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:04.685",
        "brokerTime": "2025-05-14 14:53:04.685",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049768",
        "positionId": "56049768",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:04.685",
        "brokerTime": "2025-05-14 14:53:05.597",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049769",
        "positionId": "56049768",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:07.152",
        "brokerTime": "2025-05-14 14:53:07.152",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049770",
        "positionId": "56049770",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:07.152",
        "brokerTime": "2025-05-14 14:53:08.048",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049771",
        "positionId": "56049770",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:08.510",
        "brokerTime": "2025-05-14 14:53:08.510",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049772",
        "positionId": "56049772",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:08.510",
        "brokerTime": "2025-05-14 14:53:09.226",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049773",
        "positionId": "56049772",
        "volume": 4.65,
        "price": 3227.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:09.547",
        "brokerTime": "2025-05-14 14:53:09.547",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049774",
        "positionId": "56049774",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:09.547",
        "brokerTime": "2025-05-14 14:53:10.075",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049775",
        "positionId": "56049774",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:10.856",
        "brokerTime": "2025-05-14 14:53:10.856",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049776",
        "positionId": "56049776",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "id": "53085907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:10.856",
        "brokerTime": "2025-05-14 14:53:11.362",
        "commission": -32.55,
        "swap": 0,
        "profit": -172.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049777",
        "positionId": "56049776",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -204.60000000000002,
        "takeProfit": null,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "id": "53085908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12.395",
        "brokerTime": "2025-05-14 14:53:12.395",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049778",
        "positionId": "56049778",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12.395",
        "brokerTime": "2025-05-14 14:53:12.680",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049779",
        "positionId": "56049778",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12.993",
        "brokerTime": "2025-05-14 14:53:12.993",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049780",
        "positionId": "56049780",
        "volume": 4.65,
        "price": 3226.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:12.993",
        "brokerTime": "2025-05-14 14:53:15.547",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049781",
        "positionId": "56049780",
        "volume": 4.65,
        "price": 3227.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.92,
        "doubleCheck": true
    },
    {
        "id": "53085912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:16.415",
        "brokerTime": "2025-05-14 14:53:16.415",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049782",
        "positionId": "56049782",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:16.415",
        "brokerTime": "2025-05-14 14:53:17.178",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049783",
        "positionId": "56049782",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3227.11,
        "doubleCheck": true
    },
    {
        "id": "53085914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:17.441",
        "brokerTime": "2025-05-14 14:53:17.441",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049784",
        "positionId": "56049784",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:17.441",
        "brokerTime": "2025-05-14 14:53:17.845",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049786",
        "positionId": "56049784",
        "volume": 4.65,
        "price": 3227.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:18.443",
        "brokerTime": "2025-05-14 14:53:18.443",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049787",
        "positionId": "56049787",
        "volume": 4.65,
        "price": 3227.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:18.443",
        "brokerTime": "2025-05-14 14:53:18.821",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049788",
        "positionId": "56049787",
        "volume": 4.65,
        "price": 3227.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3227.21,
        "doubleCheck": true
    },
    {
        "id": "53085919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19.297",
        "brokerTime": "2025-05-14 14:53:19.297",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049789",
        "positionId": "56049789",
        "volume": 4.65,
        "price": 3227.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19.297",
        "brokerTime": "2025-05-14 14:53:19.731",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049790",
        "positionId": "56049789",
        "volume": 4.65,
        "price": 3227.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3227.1,
        "doubleCheck": true
    },
    {
        "id": "53085921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19.998",
        "brokerTime": "2025-05-14 14:53:19.998",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049791",
        "positionId": "56049791",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:19.998",
        "brokerTime": "2025-05-14 14:53:20.643",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049792",
        "positionId": "56049791",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:20.828",
        "brokerTime": "2025-05-14 14:53:20.828",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049793",
        "positionId": "56049793",
        "volume": 4.65,
        "price": 3227.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:20.828",
        "brokerTime": "2025-05-14 14:53:21.400",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049794",
        "positionId": "56049793",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3227.12,
        "doubleCheck": true
    },
    {
        "id": "53085925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:21.595",
        "brokerTime": "2025-05-14 14:53:21.595",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049795",
        "positionId": "56049795",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:21.595",
        "brokerTime": "2025-05-14 14:53:22.187",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049796",
        "positionId": "56049795",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3227.15,
        "doubleCheck": true
    },
    {
        "id": "53085927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:22.582",
        "brokerTime": "2025-05-14 14:53:22.582",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049797",
        "positionId": "56049797",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:22.582",
        "brokerTime": "2025-05-14 14:53:22.873",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049798",
        "positionId": "56049797",
        "volume": 4.65,
        "price": 3227.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53085929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23.141",
        "brokerTime": "2025-05-14 14:53:23.141",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049799",
        "positionId": "56049799",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:23.141",
        "brokerTime": "2025-05-14 14:53:23.632",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049800",
        "positionId": "56049799",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.8,
        "doubleCheck": true
    },
    {
        "id": "53085931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24.018",
        "brokerTime": "2025-05-14 14:53:24.018",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049801",
        "positionId": "56049801",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24.018",
        "brokerTime": "2025-05-14 14:53:24.336",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049802",
        "positionId": "56049801",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53085933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24.599",
        "brokerTime": "2025-05-14 14:53:24.599",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049803",
        "positionId": "56049803",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:24.599",
        "brokerTime": "2025-05-14 14:53:25.115",
        "commission": -32.55,
        "swap": 0,
        "profit": -55.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049804",
        "positionId": "56049803",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.35,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:25.611",
        "brokerTime": "2025-05-14 14:53:25.611",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049805",
        "positionId": "56049805",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:25.611",
        "brokerTime": "2025-05-14 14:53:26.217",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049806",
        "positionId": "56049805",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26.426",
        "brokerTime": "2025-05-14 14:53:26.426",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049807",
        "positionId": "56049807",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:26.426",
        "brokerTime": "2025-05-14 14:53:27.052",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049808",
        "positionId": "56049807",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:27.498",
        "brokerTime": "2025-05-14 14:53:27.498",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049809",
        "positionId": "56049809",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:27.498",
        "brokerTime": "2025-05-14 14:53:28.060",
        "commission": -32.55,
        "swap": 0,
        "profit": -27.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049810",
        "positionId": "56049809",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.449999999999996,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28.426",
        "brokerTime": "2025-05-14 14:53:28.426",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049811",
        "positionId": "56049811",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "id": "53085942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28.426",
        "brokerTime": "2025-05-14 14:53:28.802",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049812",
        "positionId": "56049811",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.89,
        "doubleCheck": true
    },
    {
        "id": "53085943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28.966",
        "brokerTime": "2025-05-14 14:53:28.966",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049813",
        "positionId": "56049813",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:28.966",
        "brokerTime": "2025-05-14 14:53:29.694",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049815",
        "positionId": "56049813",
        "volume": 4.65,
        "price": 3227.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:30.280",
        "brokerTime": "2025-05-14 14:53:30.280",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049816",
        "positionId": "56049816",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:30.280",
        "brokerTime": "2025-05-14 14:53:31.018",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049818",
        "positionId": "56049816",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -181.35000000000002,
        "takeProfit": null,
        "priceIn": 3226.95,
        "doubleCheck": true
    },
    {
        "id": "53085950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31.260",
        "brokerTime": "2025-05-14 14:53:31.260",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049819",
        "positionId": "56049819",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31.260",
        "brokerTime": "2025-05-14 14:53:31.737",
        "commission": -32.55,
        "swap": 0,
        "profit": 74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049820",
        "positionId": "56049819",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 41.85000000000001,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53085952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31.942",
        "brokerTime": "2025-05-14 14:53:31.942",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049821",
        "positionId": "56049821",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:31.942",
        "brokerTime": "2025-05-14 14:53:32.422",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049822",
        "positionId": "56049821",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53085954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:32.792",
        "brokerTime": "2025-05-14 14:53:32.792",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049823",
        "positionId": "56049823",
        "volume": 4.65,
        "price": 3226.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:32.792",
        "brokerTime": "2025-05-14 14:53:33.250",
        "commission": -32.55,
        "swap": 0,
        "profit": -148.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049824",
        "positionId": "56049823",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -181.35000000000002,
        "takeProfit": null,
        "priceIn": 3226.48,
        "doubleCheck": true
    },
    {
        "id": "53085956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:33.881",
        "brokerTime": "2025-05-14 14:53:33.881",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049825",
        "positionId": "56049825",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:33.881",
        "brokerTime": "2025-05-14 14:53:34.255",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049826",
        "positionId": "56049825",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.75,
        "doubleCheck": true
    },
    {
        "id": "53085958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:34.582",
        "brokerTime": "2025-05-14 14:53:34.582",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049827",
        "positionId": "56049827",
        "volume": 4.65,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53085959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:34.582",
        "brokerTime": "2025-05-14 14:53:35.005",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049828",
        "positionId": "56049827",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53085960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:35.524",
        "brokerTime": "2025-05-14 14:53:35.524",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049829",
        "positionId": "56049829",
        "volume": 4.65,
        "price": 3226.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "id": "53085961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:35.524",
        "brokerTime": "2025-05-14 14:53:37.046",
        "commission": -32.55,
        "swap": 0,
        "profit": -176.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049830",
        "positionId": "56049829",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.25,
        "takeProfit": null,
        "priceIn": 3226.52,
        "doubleCheck": true
    },
    {
        "id": "53085962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:37.255",
        "brokerTime": "2025-05-14 14:53:37.255",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049831",
        "positionId": "56049831",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:37.255",
        "brokerTime": "2025-05-14 14:53:37.895",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049832",
        "positionId": "56049831",
        "volume": 4.65,
        "price": 3226.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3226.72,
        "doubleCheck": true
    },
    {
        "id": "53085964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38.306",
        "brokerTime": "2025-05-14 14:53:38.306",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049833",
        "positionId": "56049833",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38.306",
        "brokerTime": "2025-05-14 14:53:38.768",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049834",
        "positionId": "56049833",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38.942",
        "brokerTime": "2025-05-14 14:53:38.942",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049835",
        "positionId": "56049835",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:38.942",
        "brokerTime": "2025-05-14 14:53:39.220",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049836",
        "positionId": "56049835",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.73,
        "doubleCheck": true
    },
    {
        "id": "53085968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:39.714",
        "brokerTime": "2025-05-14 14:53:39.714",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049837",
        "positionId": "56049837",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:39.714",
        "brokerTime": "2025-05-14 14:53:39.984",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049838",
        "positionId": "56049837",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53085970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40.194",
        "brokerTime": "2025-05-14 14:53:40.194",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049839",
        "positionId": "56049839",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:40.194",
        "brokerTime": "2025-05-14 14:53:40.715",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049840",
        "positionId": "56049839",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53085972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:41.492",
        "brokerTime": "2025-05-14 14:53:41.492",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049841",
        "positionId": "56049841",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:41.492",
        "brokerTime": "2025-05-14 14:53:41.919",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049842",
        "positionId": "56049841",
        "volume": 4.65,
        "price": 3226.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53085974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42.163",
        "brokerTime": "2025-05-14 14:53:42.163",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049843",
        "positionId": "56049843",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42.163",
        "brokerTime": "2025-05-14 14:53:42.452",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049844",
        "positionId": "56049843",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53085976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42.661",
        "brokerTime": "2025-05-14 14:53:42.661",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049845",
        "positionId": "56049845",
        "volume": 4.65,
        "price": 3226.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:42.661",
        "brokerTime": "2025-05-14 14:53:43.277",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049846",
        "positionId": "56049845",
        "volume": 4.65,
        "price": 3227.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.86,
        "doubleCheck": true
    },
    {
        "id": "53085978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:43.770",
        "brokerTime": "2025-05-14 14:53:43.770",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049847",
        "positionId": "56049847",
        "volume": 4.65,
        "price": 3226.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "id": "53085979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:43.770",
        "brokerTime": "2025-05-14 14:53:44.709",
        "commission": -32.55,
        "swap": 0,
        "profit": -27.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049848",
        "positionId": "56049847",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.449999999999996,
        "takeProfit": null,
        "priceIn": 3226.91,
        "doubleCheck": true
    },
    {
        "id": "53085980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:44.991",
        "brokerTime": "2025-05-14 14:53:44.991",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049849",
        "positionId": "56049849",
        "volume": 4.65,
        "price": 3226.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:44.991",
        "brokerTime": "2025-05-14 14:53:45.628",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049850",
        "positionId": "56049849",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.77,
        "doubleCheck": true
    },
    {
        "id": "53085982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:45.822",
        "brokerTime": "2025-05-14 14:53:45.822",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049851",
        "positionId": "56049851",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:45.822",
        "brokerTime": "2025-05-14 14:53:46.460",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049852",
        "positionId": "56049851",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.79,
        "doubleCheck": true
    },
    {
        "id": "53085984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:46.712",
        "brokerTime": "2025-05-14 14:53:46.712",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049853",
        "positionId": "56049853",
        "volume": 4.65,
        "price": 3226.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "id": "53085986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:46.712",
        "brokerTime": "2025-05-14 14:53:47.055",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049855",
        "positionId": "56049853",
        "volume": 4.65,
        "price": 3226.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.76,
        "doubleCheck": true
    },
    {
        "id": "53085987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:48.506",
        "brokerTime": "2025-05-14 14:53:48.506",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049856",
        "positionId": "56049856",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:48.506",
        "brokerTime": "2025-05-14 14:53:49.086",
        "commission": -32.55,
        "swap": 0,
        "profit": -37.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049857",
        "positionId": "56049856",
        "volume": 4.65,
        "price": 3226.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.75,
        "takeProfit": null,
        "priceIn": 3226.81,
        "doubleCheck": true
    },
    {
        "id": "53085989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:49.773",
        "brokerTime": "2025-05-14 14:53:49.773",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049858",
        "positionId": "56049858",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:49.773",
        "brokerTime": "2025-05-14 14:53:50.439",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049859",
        "positionId": "56049858",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:50.816",
        "brokerTime": "2025-05-14 14:53:50.816",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049860",
        "positionId": "56049860",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:50.816",
        "brokerTime": "2025-05-14 14:53:51.131",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049861",
        "positionId": "56049860",
        "volume": 4.65,
        "price": 3226.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53085993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:52.156",
        "brokerTime": "2025-05-14 14:53:52.156",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049862",
        "positionId": "56049862",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:52.156",
        "brokerTime": "2025-05-14 14:53:52.563",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049863",
        "positionId": "56049862",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.9,
        "doubleCheck": true
    },
    {
        "id": "53085995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:53.384",
        "brokerTime": "2025-05-14 14:53:53.384",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049864",
        "positionId": "56049864",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:53.384",
        "brokerTime": "2025-05-14 14:53:54.184",
        "commission": -32.55,
        "swap": 0,
        "profit": -162.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049866",
        "positionId": "56049864",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -195.3,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53085998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:55.583",
        "brokerTime": "2025-05-14 14:53:55.583",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049868",
        "positionId": "56049868",
        "volume": 4.65,
        "price": 3227.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53086001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:55.583",
        "brokerTime": "2025-05-14 14:53:56.519",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049871",
        "positionId": "56049868",
        "volume": 4.65,
        "price": 3227.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3227.2,
        "doubleCheck": true
    },
    {
        "id": "53086002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57.062",
        "brokerTime": "2025-05-14 14:53:57.062",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049873",
        "positionId": "56049873",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "id": "53086004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57.062",
        "brokerTime": "2025-05-14 14:53:57.462",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049874",
        "positionId": "56049873",
        "volume": 4.65,
        "price": 3227.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "id": "53086006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57.857",
        "brokerTime": "2025-05-14 14:53:57.857",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049876",
        "positionId": "56049876",
        "volume": 4.65,
        "price": 3227.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "id": "53086007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:57.857",
        "brokerTime": "2025-05-14 14:53:58.184",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049877",
        "positionId": "56049876",
        "volume": 4.65,
        "price": 3227.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3227.26,
        "doubleCheck": true
    },
    {
        "id": "53086008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58.446",
        "brokerTime": "2025-05-14 14:53:58.446",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049878",
        "positionId": "56049878",
        "volume": 4.65,
        "price": 3227.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "id": "53086009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:58.446",
        "brokerTime": "2025-05-14 14:53:59.263",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049879",
        "positionId": "56049878",
        "volume": 4.65,
        "price": 3227.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3227.28,
        "doubleCheck": true
    },
    {
        "id": "53086010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:59.568",
        "brokerTime": "2025-05-14 14:53:59.568",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049880",
        "positionId": "56049880",
        "volume": 4.65,
        "price": 3227.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.33,
        "doubleCheck": true
    },
    {
        "id": "53086011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:53:59.568",
        "brokerTime": "2025-05-14 14:53:59.840",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049881",
        "positionId": "56049880",
        "volume": 4.65,
        "price": 3227.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3227.33,
        "doubleCheck": true
    },
    {
        "id": "53086012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00.087",
        "brokerTime": "2025-05-14 14:54:00.087",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049882",
        "positionId": "56049882",
        "volume": 4.65,
        "price": 3227.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.35,
        "doubleCheck": true
    },
    {
        "id": "53086013",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:00.087",
        "brokerTime": "2025-05-14 14:54:00.382",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049883",
        "positionId": "56049882",
        "volume": 4.65,
        "price": 3227.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3227.35,
        "doubleCheck": true
    },
    {
        "id": "53086016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:01.113",
        "brokerTime": "2025-05-14 14:54:01.113",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049886",
        "positionId": "56049886",
        "volume": 4.65,
        "price": 3227.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53086017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:01.113",
        "brokerTime": "2025-05-14 14:54:02.066",
        "commission": -32.55,
        "swap": 0,
        "profit": 176.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049887",
        "positionId": "56049886",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 144.14999999999998,
        "takeProfit": null,
        "priceIn": 3227.01,
        "doubleCheck": true
    },
    {
        "id": "53086018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:02.469",
        "brokerTime": "2025-05-14 14:54:02.469",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049888",
        "positionId": "56049888",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.21,
        "doubleCheck": true
    },
    {
        "id": "53086019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:02.469",
        "brokerTime": "2025-05-14 14:54:02.884",
        "commission": -32.55,
        "swap": 0,
        "profit": -46.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049889",
        "positionId": "56049888",
        "volume": 4.65,
        "price": 3226.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "takeProfit": null,
        "priceIn": 3226.21,
        "doubleCheck": true
    },
    {
        "id": "53086020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03.140",
        "brokerTime": "2025-05-14 14:54:03.140",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049890",
        "positionId": "56049890",
        "volume": 4.65,
        "price": 3226.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.12,
        "doubleCheck": true
    },
    {
        "id": "53086021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03.140",
        "brokerTime": "2025-05-14 14:54:03.456",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049891",
        "positionId": "56049890",
        "volume": 4.65,
        "price": 3226.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.12,
        "doubleCheck": true
    },
    {
        "id": "53086022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03.979",
        "brokerTime": "2025-05-14 14:54:03.979",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049892",
        "positionId": "56049892",
        "volume": 4.65,
        "price": 3226.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "id": "53086023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:03.979",
        "brokerTime": "2025-05-14 14:54:04.327",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049893",
        "positionId": "56049892",
        "volume": 4.65,
        "price": 3226.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.39999999999998,
        "takeProfit": null,
        "priceIn": 3226.41,
        "doubleCheck": true
    },
    {
        "id": "53086024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:04.611",
        "brokerTime": "2025-05-14 14:54:04.611",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049894",
        "positionId": "56049894",
        "volume": 4.65,
        "price": 3226.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53086025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:04.611",
        "brokerTime": "2025-05-14 14:54:05.097",
        "commission": -32.55,
        "swap": 0,
        "profit": -144.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049895",
        "positionId": "56049894",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.7,
        "takeProfit": null,
        "priceIn": 3226.29,
        "doubleCheck": true
    },
    {
        "id": "53086026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05.415",
        "brokerTime": "2025-05-14 14:54:05.415",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049896",
        "positionId": "56049896",
        "volume": 4.65,
        "price": 3226.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53086027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:05.415",
        "brokerTime": "2025-05-14 14:54:06.098",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049897",
        "positionId": "56049896",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.4,
        "doubleCheck": true
    },
    {
        "id": "53086028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:06.731",
        "brokerTime": "2025-05-14 14:54:06.731",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049898",
        "positionId": "56049898",
        "volume": 4.65,
        "price": 3226.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "id": "53086029",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:06.731",
        "brokerTime": "2025-05-14 14:54:07.264",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049899",
        "positionId": "56049898",
        "volume": 4.65,
        "price": 3226.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3226.47,
        "doubleCheck": true
    },
    {
        "id": "53086030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:07.637",
        "brokerTime": "2025-05-14 14:54:07.637",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049900",
        "positionId": "56049900",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53086031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:07.637",
        "brokerTime": "2025-05-14 14:54:07.982",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049901",
        "positionId": "56049900",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53086032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:08.593",
        "brokerTime": "2025-05-14 14:54:08.593",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049902",
        "positionId": "56049902",
        "volume": 4.65,
        "price": 3226.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53086033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:08.593",
        "brokerTime": "2025-05-14 14:54:09.527",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049903",
        "positionId": "56049902",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.6,
        "doubleCheck": true
    },
    {
        "id": "53086034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:09.777",
        "brokerTime": "2025-05-14 14:54:09.777",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049904",
        "positionId": "56049904",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:09.777",
        "brokerTime": "2025-05-14 14:54:10.032",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049905",
        "positionId": "56049904",
        "volume": 4.65,
        "price": 3226.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10.169",
        "brokerTime": "2025-05-14 14:54:10.169",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049906",
        "positionId": "56049906",
        "volume": 4.65,
        "price": 3226.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53086037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10.169",
        "brokerTime": "2025-05-14 14:54:10.613",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049907",
        "positionId": "56049906",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.58,
        "doubleCheck": true
    },
    {
        "id": "53086038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10.954",
        "brokerTime": "2025-05-14 14:54:10.954",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049908",
        "positionId": "56049908",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53086039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:10.954",
        "brokerTime": "2025-05-14 14:54:11.388",
        "commission": -32.55,
        "swap": 0,
        "profit": 41.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049909",
        "positionId": "56049908",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9.300000000000004,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53086040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:11.805",
        "brokerTime": "2025-05-14 14:54:11.805",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049910",
        "positionId": "56049910",
        "volume": 4.65,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "id": "53086041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:11.805",
        "brokerTime": "2025-05-14 14:54:12.102",
        "commission": -32.55,
        "swap": 0,
        "profit": -181.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049911",
        "positionId": "56049910",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.89999999999998,
        "takeProfit": null,
        "priceIn": 3226.33,
        "doubleCheck": true
    },
    {
        "id": "53086042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12.471",
        "brokerTime": "2025-05-14 14:54:12.471",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049912",
        "positionId": "56049912",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:12.471",
        "brokerTime": "2025-05-14 14:54:14.496",
        "commission": -32.55,
        "swap": 0,
        "profit": -134.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049916",
        "positionId": "56049912",
        "volume": 4.65,
        "price": 3226.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.39999999999998,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:14.865",
        "brokerTime": "2025-05-14 14:54:14.865",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049921",
        "positionId": "56049921",
        "volume": 4.65,
        "price": 3226.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53086053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:14.865",
        "brokerTime": "2025-05-14 14:54:15.799",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049923",
        "positionId": "56049921",
        "volume": 4.65,
        "price": 3227.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3226.78,
        "doubleCheck": true
    },
    {
        "id": "53086055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:16.052",
        "brokerTime": "2025-05-14 14:54:16.052",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049925",
        "positionId": "56049925",
        "volume": 4.65,
        "price": 3226.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53086056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:16.052",
        "brokerTime": "2025-05-14 14:54:16.387",
        "commission": -32.55,
        "swap": 0,
        "profit": -116.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049926",
        "positionId": "56049925",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.8,
        "takeProfit": null,
        "priceIn": 3226.82,
        "doubleCheck": true
    },
    {
        "id": "53086058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:17.414",
        "brokerTime": "2025-05-14 14:54:17.414",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049929",
        "positionId": "56049929",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53086060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:17.414",
        "brokerTime": "2025-05-14 14:54:18.163",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049931",
        "positionId": "56049929",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53086061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:18.499",
        "brokerTime": "2025-05-14 14:54:18.499",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049932",
        "positionId": "56049932",
        "volume": 4.65,
        "price": 3226.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53086062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:18.499",
        "brokerTime": "2025-05-14 14:54:19.076",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049933",
        "positionId": "56049932",
        "volume": 4.65,
        "price": 3227.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.97,
        "doubleCheck": true
    },
    {
        "id": "53086063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:19.754",
        "brokerTime": "2025-05-14 14:54:19.754",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049934",
        "positionId": "56049934",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "id": "53086064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:19.754",
        "brokerTime": "2025-05-14 14:54:20.126",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049935",
        "positionId": "56049934",
        "volume": 4.65,
        "price": 3227.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3226.83,
        "doubleCheck": true
    },
    {
        "id": "53086065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20.348",
        "brokerTime": "2025-05-14 14:54:20.348",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049936",
        "positionId": "56049936",
        "volume": 4.65,
        "price": 3226.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53086066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:20.348",
        "brokerTime": "2025-05-14 14:54:21.866",
        "commission": -32.55,
        "swap": 0,
        "profit": -51.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049937",
        "positionId": "56049936",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -83.69999999999999,
        "takeProfit": null,
        "priceIn": 3226.87,
        "doubleCheck": true
    },
    {
        "id": "53086067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:22.568",
        "brokerTime": "2025-05-14 14:54:22.568",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049938",
        "positionId": "56049938",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53086068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:22.568",
        "brokerTime": "2025-05-14 14:54:23.325",
        "commission": -32.55,
        "swap": 0,
        "profit": -199.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049939",
        "positionId": "56049938",
        "volume": 4.65,
        "price": 3227.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -232.5,
        "takeProfit": null,
        "priceIn": 3226.84,
        "doubleCheck": true
    },
    {
        "id": "53086069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:23.623",
        "brokerTime": "2025-05-14 14:54:23.623",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049940",
        "positionId": "56049940",
        "volume": 4.65,
        "price": 3227.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53086070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:23.623",
        "brokerTime": "2025-05-14 14:54:24.558",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049941",
        "positionId": "56049940",
        "volume": 4.65,
        "price": 3227.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3227.07,
        "doubleCheck": true
    },
    {
        "id": "53086071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:24.720",
        "brokerTime": "2025-05-14 14:54:24.720",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049942",
        "positionId": "56049942",
        "volume": 4.65,
        "price": 3227,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53086072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:24.720",
        "brokerTime": "2025-05-14 14:54:25.173",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049945",
        "positionId": "56049942",
        "volume": 4.65,
        "price": 3227.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3227,
        "doubleCheck": true
    },
    {
        "id": "53086074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:26.893",
        "brokerTime": "2025-05-14 14:54:26.893",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049946",
        "positionId": "56049946",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53086075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:26.893",
        "brokerTime": "2025-05-14 14:54:27.681",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049947",
        "positionId": "56049946",
        "volume": 4.65,
        "price": 3227.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53086076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28.080",
        "brokerTime": "2025-05-14 14:54:28.080",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049948",
        "positionId": "56049948",
        "volume": 4.65,
        "price": 3226.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53086077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28.080",
        "brokerTime": "2025-05-14 14:54:28.593",
        "commission": -32.55,
        "swap": 0,
        "profit": -120.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049949",
        "positionId": "56049948",
        "volume": 4.65,
        "price": 3227.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.45,
        "takeProfit": null,
        "priceIn": 3226.98,
        "doubleCheck": true
    },
    {
        "id": "53086078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28.799",
        "brokerTime": "2025-05-14 14:54:28.799",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049950",
        "positionId": "56049950",
        "volume": 4.65,
        "price": 3227.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53086079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:28.799",
        "brokerTime": "2025-05-14 14:54:29.247",
        "commission": -32.55,
        "swap": 0,
        "profit": 41.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049951",
        "positionId": "56049950",
        "volume": 4.65,
        "price": 3226.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9.300000000000004,
        "takeProfit": null,
        "priceIn": 3227.02,
        "doubleCheck": true
    },
    {
        "id": "53086080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:29.645",
        "brokerTime": "2025-05-14 14:54:29.645",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049952",
        "positionId": "56049952",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53086081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:29.645",
        "brokerTime": "2025-05-14 14:54:30.833",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049953",
        "positionId": "56049952",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": false
    },
    {
        "id": "53086082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31.111",
        "brokerTime": "2025-05-14 14:54:31.111",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049954",
        "positionId": "56049954",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31.111",
        "brokerTime": "2025-05-14 14:54:31.477",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049955",
        "positionId": "56049954",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31.820",
        "brokerTime": "2025-05-14 14:54:31.820",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049956",
        "positionId": "56049956",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:31.820",
        "brokerTime": "2025-05-14 14:54:32.141",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049957",
        "positionId": "56049956",
        "volume": 4.65,
        "price": 3226.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:32.683",
        "brokerTime": "2025-05-14 14:54:32.683",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049958",
        "positionId": "56049958",
        "volume": 4.65,
        "price": 3226.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:32.683",
        "brokerTime": "2025-05-14 14:54:32.998",
        "commission": -32.55,
        "swap": 0,
        "profit": -158.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049959",
        "positionId": "56049958",
        "volume": 4.65,
        "price": 3226.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.64999999999998,
        "takeProfit": null,
        "priceIn": 3226.61,
        "doubleCheck": true
    },
    {
        "id": "53086088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33.203",
        "brokerTime": "2025-05-14 14:54:33.203",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049960",
        "positionId": "56049960",
        "volume": 4.65,
        "price": 3226.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53086089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33.203",
        "brokerTime": "2025-05-14 14:54:33.625",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049961",
        "positionId": "56049960",
        "volume": 4.65,
        "price": 3226.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3226.71,
        "doubleCheck": true
    },
    {
        "id": "53086090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33.943",
        "brokerTime": "2025-05-14 14:54:33.943",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049962",
        "positionId": "56049962",
        "volume": 4.65,
        "price": 3226.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53086091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:33.943",
        "brokerTime": "2025-05-14 14:54:34.382",
        "commission": -32.55,
        "swap": 0,
        "profit": -41.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049963",
        "positionId": "56049962",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.4,
        "takeProfit": null,
        "priceIn": 3226.64,
        "doubleCheck": true
    },
    {
        "id": "53086092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:34.612",
        "brokerTime": "2025-05-14 14:54:34.612",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049964",
        "positionId": "56049964",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:34.612",
        "brokerTime": "2025-05-14 14:54:35.075",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049965",
        "positionId": "56049964",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35.311",
        "brokerTime": "2025-05-14 14:54:35.311",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049966",
        "positionId": "56049966",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:35.311",
        "brokerTime": "2025-05-14 14:54:35.831",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049967",
        "positionId": "56049966",
        "volume": 4.65,
        "price": 3226.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:36.049",
        "brokerTime": "2025-05-14 14:54:36.049",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049968",
        "positionId": "56049968",
        "volume": 4.65,
        "price": 3226.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:36.049",
        "brokerTime": "2025-05-14 14:54:36.447",
        "commission": -32.55,
        "swap": 0,
        "profit": -102.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049969",
        "positionId": "56049968",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -134.85,
        "takeProfit": null,
        "priceIn": 3226.53,
        "doubleCheck": true
    },
    {
        "id": "53086098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:37.326",
        "brokerTime": "2025-05-14 14:54:37.326",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049970",
        "positionId": "56049970",
        "volume": 4.65,
        "price": 3226.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53086099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:37.326",
        "brokerTime": "2025-05-14 14:54:37.877",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049971",
        "positionId": "56049970",
        "volume": 4.65,
        "price": 3226.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.62,
        "doubleCheck": true
    },
    {
        "id": "53086100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:38.723",
        "brokerTime": "2025-05-14 14:54:38.723",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049972",
        "positionId": "56049972",
        "volume": 4.65,
        "price": 3226.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53086101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:38.723",
        "brokerTime": "2025-05-14 14:54:39.394",
        "commission": -32.55,
        "swap": 0,
        "profit": -111.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049975",
        "positionId": "56049972",
        "volume": 4.65,
        "price": 3226.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -144.14999999999998,
        "takeProfit": null,
        "priceIn": 3226.59,
        "doubleCheck": true
    },
    {
        "id": "53086102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:39.557",
        "brokerTime": "2025-05-14 14:54:39.557",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049976",
        "positionId": "56049976",
        "volume": 4.65,
        "price": 3226.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53086103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:39.557",
        "brokerTime": "2025-05-14 14:54:39.950",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049977",
        "positionId": "56049976",
        "volume": 4.65,
        "price": 3226.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.63,
        "doubleCheck": true
    },
    {
        "id": "53086104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40.288",
        "brokerTime": "2025-05-14 14:54:40.288",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049978",
        "positionId": "56049978",
        "volume": 4.65,
        "price": 3226.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:40.288",
        "brokerTime": "2025-05-14 14:54:40.965",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049979",
        "positionId": "56049978",
        "volume": 4.65,
        "price": 3226.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3226.54,
        "doubleCheck": true
    },
    {
        "id": "53086106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:41.505",
        "brokerTime": "2025-05-14 14:54:41.505",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049980",
        "positionId": "56049980",
        "volume": 4.65,
        "price": 3226.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53086107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:41.505",
        "brokerTime": "2025-05-14 14:54:41.950",
        "commission": -32.55,
        "swap": 0,
        "profit": -88.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049981",
        "positionId": "56049980",
        "volume": 4.65,
        "price": 3226.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.89999999999999,
        "takeProfit": null,
        "priceIn": 3226.56,
        "doubleCheck": true
    },
    {
        "id": "53086108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:42.877",
        "brokerTime": "2025-05-14 14:54:42.877",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049982",
        "positionId": "56049982",
        "volume": 4.65,
        "price": 3226.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "id": "53086109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:42.877",
        "brokerTime": "2025-05-14 14:54:43.658",
        "commission": -32.55,
        "swap": 0,
        "profit": -23.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049983",
        "positionId": "56049982",
        "volume": 4.65,
        "price": 3226.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -55.8,
        "takeProfit": null,
        "priceIn": 3226.32,
        "doubleCheck": true
    },
    {
        "id": "53086110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:43.908",
        "brokerTime": "2025-05-14 14:54:43.908",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049984",
        "positionId": "56049984",
        "volume": 4.65,
        "price": 3226.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.13,
        "doubleCheck": true
    },
    {
        "id": "53086112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:43.908",
        "brokerTime": "2025-05-14 14:54:45.170",
        "commission": -32.55,
        "swap": 0,
        "profit": -65.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049986",
        "positionId": "56049984",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.64999999999999,
        "takeProfit": null,
        "priceIn": 3226.13,
        "doubleCheck": true
    },
    {
        "id": "53086113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:45.335",
        "brokerTime": "2025-05-14 14:54:45.335",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049987",
        "positionId": "56049987",
        "volume": 4.65,
        "price": 3226.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "id": "53086115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:45.335",
        "brokerTime": "2025-05-14 14:54:45.996",
        "commission": -32.55,
        "swap": 0,
        "profit": -79.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049989",
        "positionId": "56049987",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -111.6,
        "takeProfit": null,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "id": "53086116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:46.579",
        "brokerTime": "2025-05-14 14:54:46.579",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049990",
        "positionId": "56049990",
        "volume": 4.65,
        "price": 3225.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.98,
        "doubleCheck": true
    },
    {
        "id": "53086119",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:46.579",
        "brokerTime": "2025-05-14 14:54:46.901",
        "commission": -32.55,
        "swap": 0,
        "profit": -9.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049992",
        "positionId": "56049990",
        "volume": 4.65,
        "price": 3226,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -41.849999999999994,
        "takeProfit": null,
        "priceIn": 3225.98,
        "doubleCheck": true
    },
    {
        "id": "53086120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47.268",
        "brokerTime": "2025-05-14 14:54:47.268",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049993",
        "positionId": "56049993",
        "volume": 4.65,
        "price": 3225.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "id": "53086122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:47.268",
        "brokerTime": "2025-05-14 14:54:48.130",
        "commission": -32.55,
        "swap": 0,
        "profit": -4.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049995",
        "positionId": "56049993",
        "volume": 4.65,
        "price": 3225.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -37.199999999999996,
        "takeProfit": null,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "id": "53086124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:48.372",
        "brokerTime": "2025-05-14 14:54:48.372",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049996",
        "positionId": "56049996",
        "volume": 4.65,
        "price": 3225.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.9,
        "doubleCheck": true
    },
    {
        "id": "53086125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:48.372",
        "brokerTime": "2025-05-14 14:54:50.643",
        "commission": -32.55,
        "swap": 0,
        "profit": -125.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049997",
        "positionId": "56049996",
        "volume": 4.65,
        "price": 3226.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -158.1,
        "takeProfit": null,
        "priceIn": 3225.9,
        "doubleCheck": true
    },
    {
        "id": "53086126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:51.165",
        "brokerTime": "2025-05-14 14:54:51.165",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049998",
        "positionId": "56049998",
        "volume": 4.65,
        "price": 3225.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.81,
        "doubleCheck": true
    },
    {
        "id": "53086127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:51.165",
        "brokerTime": "2025-05-14 14:54:51.929",
        "commission": -32.55,
        "swap": 0,
        "profit": -139.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56049999",
        "positionId": "56049998",
        "volume": 4.65,
        "price": 3226.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -172.05,
        "takeProfit": null,
        "priceIn": 3225.81,
        "doubleCheck": true
    },
    {
        "id": "53086128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52.088",
        "brokerTime": "2025-05-14 14:54:52.088",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050000",
        "positionId": "56050000",
        "volume": 4.65,
        "price": 3225.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.92,
        "doubleCheck": true
    },
    {
        "id": "53086129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52.088",
        "brokerTime": "2025-05-14 14:54:52.368",
        "commission": -32.55,
        "swap": 0,
        "profit": -97.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050001",
        "positionId": "56050000",
        "volume": 4.65,
        "price": 3226.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -130.2,
        "takeProfit": null,
        "priceIn": 3225.92,
        "doubleCheck": true
    },
    {
        "id": "53086130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52.635",
        "brokerTime": "2025-05-14 14:54:52.635",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050002",
        "positionId": "56050002",
        "volume": 4.65,
        "price": 3225.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "id": "53086131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:52.635",
        "brokerTime": "2025-05-14 14:54:53.642",
        "commission": -32.55,
        "swap": 0,
        "profit": -172.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050003",
        "positionId": "56050002",
        "volume": 4.65,
        "price": 3226.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -204.60000000000002,
        "takeProfit": null,
        "priceIn": 3225.96,
        "doubleCheck": true
    },
    {
        "id": "53086132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:53.915",
        "brokerTime": "2025-05-14 14:54:53.915",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050004",
        "positionId": "56050004",
        "volume": 4.65,
        "price": 3226.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.08,
        "doubleCheck": true
    },
    {
        "id": "53086133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:53.915",
        "brokerTime": "2025-05-14 14:54:54.219",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050005",
        "positionId": "56050004",
        "volume": 4.65,
        "price": 3226.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3226.08,
        "doubleCheck": true
    },
    {
        "id": "53086134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:54.643",
        "brokerTime": "2025-05-14 14:54:54.643",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050006",
        "positionId": "56050006",
        "volume": 4.65,
        "price": 3226.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.14,
        "doubleCheck": true
    },
    {
        "id": "53086135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:54.643",
        "brokerTime": "2025-05-14 14:54:55.032",
        "commission": -32.55,
        "swap": 0,
        "profit": -60.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050007",
        "positionId": "56050006",
        "volume": 4.65,
        "price": 3226.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93,
        "takeProfit": null,
        "priceIn": 3226.14,
        "doubleCheck": true
    },
    {
        "id": "53086136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55.344",
        "brokerTime": "2025-05-14 14:54:55.344",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050008",
        "positionId": "56050008",
        "volume": 4.65,
        "price": 3226.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "id": "53086137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:55.344",
        "brokerTime": "2025-05-14 14:54:56.037",
        "commission": -32.55,
        "swap": 0,
        "profit": -32.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050009",
        "positionId": "56050008",
        "volume": 4.65,
        "price": 3226.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -65.1,
        "takeProfit": null,
        "priceIn": 3226.04,
        "doubleCheck": true
    },
    {
        "id": "53086138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:56.296",
        "brokerTime": "2025-05-14 14:54:56.296",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050010",
        "positionId": "56050010",
        "volume": 4.65,
        "price": 3225.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.88,
        "doubleCheck": true
    },
    {
        "id": "53086139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:56.296",
        "brokerTime": "2025-05-14 14:54:57.514",
        "commission": -32.55,
        "swap": 0,
        "profit": -93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050011",
        "positionId": "56050010",
        "volume": 4.65,
        "price": 3226.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.55,
        "takeProfit": null,
        "priceIn": 3225.88,
        "doubleCheck": true
    },
    {
        "id": "53086140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:58.905",
        "brokerTime": "2025-05-14 14:54:58.905",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050012",
        "positionId": "56050012",
        "volume": 4.65,
        "price": 3225.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.84,
        "doubleCheck": true
    },
    {
        "id": "53086141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:54:58.905",
        "brokerTime": "2025-05-14 14:54:59.725",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050013",
        "positionId": "56050012",
        "volume": 4.65,
        "price": 3226.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3225.84,
        "doubleCheck": true
    },
    {
        "id": "53086144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:00.502",
        "brokerTime": "2025-05-14 14:55:00.502",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050017",
        "positionId": "56050017",
        "volume": 4.65,
        "price": 3225.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.49,
        "doubleCheck": true
    },
    {
        "id": "53086147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:00.502",
        "brokerTime": "2025-05-14 14:55:00.867",
        "commission": -32.55,
        "swap": 0,
        "profit": -181.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050020",
        "positionId": "56050017",
        "volume": 4.65,
        "price": 3225.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.89999999999998,
        "takeProfit": null,
        "priceIn": 3225.49,
        "doubleCheck": true
    },
    {
        "id": "53086148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01.181",
        "brokerTime": "2025-05-14 14:55:01.181",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050021",
        "positionId": "56050021",
        "volume": 4.65,
        "price": 3225.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.66,
        "doubleCheck": true
    },
    {
        "id": "53086149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01.181",
        "brokerTime": "2025-05-14 14:55:01.535",
        "commission": -32.55,
        "swap": 0,
        "profit": -74.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050022",
        "positionId": "56050021",
        "volume": 4.65,
        "price": 3225.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.95,
        "takeProfit": null,
        "priceIn": 3225.66,
        "doubleCheck": true
    },
    {
        "id": "53086150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01.975",
        "brokerTime": "2025-05-14 14:55:01.975",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050023",
        "positionId": "56050023",
        "volume": 4.65,
        "price": 3225.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.54,
        "doubleCheck": true
    },
    {
        "id": "53086152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:01.975",
        "brokerTime": "2025-05-14 14:55:02.843",
        "commission": -32.55,
        "swap": 0,
        "profit": -130.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050025",
        "positionId": "56050023",
        "volume": 4.65,
        "price": 3225.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.75,
        "takeProfit": null,
        "priceIn": 3225.54,
        "doubleCheck": true
    },
    {
        "id": "53086153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:03.243",
        "brokerTime": "2025-05-14 14:55:03.243",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050026",
        "positionId": "56050026",
        "volume": 4.65,
        "price": 3225.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.59,
        "doubleCheck": true
    },
    {
        "id": "53086154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:03.243",
        "brokerTime": "2025-05-14 14:55:03.834",
        "commission": -32.55,
        "swap": 0,
        "profit": -32.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050027",
        "positionId": "56050026",
        "volume": 4.65,
        "price": 3225.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -65.1,
        "takeProfit": null,
        "priceIn": 3225.59,
        "doubleCheck": true
    },
    {
        "id": "53086158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:04.408",
        "brokerTime": "2025-05-14 14:55:04.408",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050030",
        "positionId": "56050030",
        "volume": 4.65,
        "price": 3225.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.32,
        "doubleCheck": true
    },
    {
        "id": "53086159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:04.408",
        "brokerTime": "2025-05-14 14:55:04.793",
        "commission": -32.55,
        "swap": 0,
        "profit": -69.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050031",
        "positionId": "56050030",
        "volume": 4.65,
        "price": 3225.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.3,
        "takeProfit": null,
        "priceIn": 3225.32,
        "doubleCheck": true
    },
    {
        "id": "53086162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:05.348",
        "brokerTime": "2025-05-14 14:55:05.348",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050033",
        "positionId": "56050033",
        "volume": 4.65,
        "price": 3225.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3225.23,
        "doubleCheck": true
    },
    {
        "id": "53086163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:05.348",
        "brokerTime": "2025-05-14 14:55:05.677",
        "commission": -32.55,
        "swap": 0,
        "profit": -83.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050034",
        "positionId": "56050033",
        "volume": 4.65,
        "price": 3225.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -116.25,
        "takeProfit": null,
        "priceIn": 3225.23,
        "doubleCheck": true
    },
    {
        "id": "53086167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:06.726",
        "brokerTime": "2025-05-14 14:55:06.726",
        "commission": -32.55,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050037",
        "positionId": "56050037",
        "volume": 4.65,
        "price": 3224.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.55,
        "takeProfit": null,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "id": "53086170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:06.726",
        "brokerTime": "2025-05-14 14:55:07.316",
        "commission": -32.55,
        "swap": 0,
        "profit": 4.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050057",
        "positionId": "56050037",
        "volume": 4.65,
        "price": 3224.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -27.9,
        "takeProfit": null,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "id": "53086199",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:55:07.406",
        "brokerTime": "2025-05-14 14:55:07.406",
        "commission": -6.23,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050074",
        "positionId": "56050074",
        "volume": 0.89,
        "price": 3224.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3324.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.23,
        "priceIn": 3224.96,
        "doubleCheck": true
    },
    {
        "id": "53086213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:07.870",
        "brokerTime": "2025-05-14 14:55:07.870",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050076",
        "positionId": "56050076",
        "volume": 5.72,
        "price": 3224.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.72,
        "doubleCheck": true
    },
    {
        "id": "53086214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:07.870",
        "brokerTime": "2025-05-14 14:55:08.387",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050077",
        "positionId": "56050076",
        "volume": 5.72,
        "price": 3224.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3224.72,
        "doubleCheck": true
    },
    {
        "id": "53086215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:08.608",
        "brokerTime": "2025-05-14 14:55:08.608",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050078",
        "positionId": "56050078",
        "volume": 5.72,
        "price": 3224.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.68,
        "doubleCheck": true
    },
    {
        "id": "53086216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:08.608",
        "brokerTime": "2025-05-14 14:55:08.938",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050079",
        "positionId": "56050078",
        "volume": 5.72,
        "price": 3224.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3224.68,
        "doubleCheck": true
    },
    {
        "id": "53086217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09.136",
        "brokerTime": "2025-05-14 14:55:09.136",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050080",
        "positionId": "56050080",
        "volume": 5.72,
        "price": 3224.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.62,
        "doubleCheck": true
    },
    {
        "id": "53086218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:09.136",
        "brokerTime": "2025-05-14 14:55:09.951",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050081",
        "positionId": "56050080",
        "volume": 5.72,
        "price": 3224.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3224.62,
        "doubleCheck": true
    },
    {
        "id": "53086219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:10.216",
        "brokerTime": "2025-05-14 14:55:10.216",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050082",
        "positionId": "56050082",
        "volume": 5.72,
        "price": 3224.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.57,
        "doubleCheck": true
    },
    {
        "id": "53086221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:10.216",
        "brokerTime": "2025-05-14 14:55:10.966",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050084",
        "positionId": "56050082",
        "volume": 5.72,
        "price": 3224.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3224.57,
        "doubleCheck": true
    },
    {
        "id": "53086222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:11.368",
        "brokerTime": "2025-05-14 14:55:11.368",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050085",
        "positionId": "56050085",
        "volume": 5.72,
        "price": 3224.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.37,
        "doubleCheck": true
    },
    {
        "id": "53086223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:11.368",
        "brokerTime": "2025-05-14 14:55:11.957",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050086",
        "positionId": "56050085",
        "volume": 5.72,
        "price": 3224.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.37,
        "doubleCheck": true
    },
    {
        "id": "53086224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:12.468",
        "brokerTime": "2025-05-14 14:55:12.468",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050087",
        "positionId": "56050087",
        "volume": 5.72,
        "price": 3224.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.43,
        "doubleCheck": true
    },
    {
        "id": "53086261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:12.468",
        "brokerTime": "2025-05-14 14:55:12.836",
        "commission": -40.04,
        "swap": 0,
        "profit": -11.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050121",
        "positionId": "56050087",
        "volume": 5.72,
        "price": 3224.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -51.48,
        "takeProfit": null,
        "priceIn": 3224.43,
        "doubleCheck": true
    },
    {
        "id": "53086263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13.115",
        "brokerTime": "2025-05-14 14:55:13.115",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050122",
        "positionId": "56050122",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.24,
        "doubleCheck": true
    },
    {
        "id": "53086267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13.115",
        "brokerTime": "2025-05-14 14:55:13.693",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050123",
        "positionId": "56050122",
        "volume": 5.72,
        "price": 3224.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3224.24,
        "doubleCheck": true
    },
    {
        "id": "53086269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13.905",
        "brokerTime": "2025-05-14 14:55:13.905",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050125",
        "positionId": "56050125",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "id": "53086738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:13.905",
        "brokerTime": "2025-05-14 14:55:14.555",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050459",
        "positionId": "56050125",
        "volume": 5.72,
        "price": 3224.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -114.4,
        "takeProfit": null,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "id": "53086741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:14.870",
        "brokerTime": "2025-05-14 14:55:14.870",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050461",
        "positionId": "56050461",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:14.870",
        "brokerTime": "2025-05-14 14:55:15.183",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050471",
        "positionId": "56050461",
        "volume": 5.72,
        "price": 3224.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -200.2,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:15.768",
        "brokerTime": "2025-05-14 14:55:15.768",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050488",
        "positionId": "56050488",
        "volume": 5.72,
        "price": 3224.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.07,
        "doubleCheck": true
    },
    {
        "id": "53086807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:15.768",
        "brokerTime": "2025-05-14 14:55:16.184",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050500",
        "positionId": "56050488",
        "volume": 5.72,
        "price": 3224.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3224.07,
        "doubleCheck": true
    },
    {
        "id": "53086820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:16.572",
        "brokerTime": "2025-05-14 14:55:16.572",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050505",
        "positionId": "56050505",
        "volume": 5.72,
        "price": 3224,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "id": "53086822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:16.572",
        "brokerTime": "2025-05-14 14:55:17.040",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050506",
        "positionId": "56050505",
        "volume": 5.72,
        "price": 3224.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.88,
        "takeProfit": null,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "id": "53086823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17.243",
        "brokerTime": "2025-05-14 14:55:17.243",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050507",
        "positionId": "56050507",
        "volume": 5.72,
        "price": 3224.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "id": "53086824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:17.243",
        "brokerTime": "2025-05-14 14:55:17.825",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050508",
        "positionId": "56050507",
        "volume": 5.72,
        "price": 3224.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "id": "53086825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18.220",
        "brokerTime": "2025-05-14 14:55:18.220",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050509",
        "positionId": "56050509",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "id": "53086826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18.220",
        "brokerTime": "2025-05-14 14:55:18.590",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050510",
        "positionId": "56050509",
        "volume": 5.72,
        "price": 3224.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -200.2,
        "takeProfit": null,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "id": "53086827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18.851",
        "brokerTime": "2025-05-14 14:55:18.851",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050511",
        "positionId": "56050511",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:18.851",
        "brokerTime": "2025-05-14 14:55:19.379",
        "commission": -40.04,
        "swap": 0,
        "profit": -143,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050512",
        "positionId": "56050511",
        "volume": 5.72,
        "price": 3224.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -183.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:19.573",
        "brokerTime": "2025-05-14 14:55:19.573",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050513",
        "positionId": "56050513",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "id": "53086830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:19.573",
        "brokerTime": "2025-05-14 14:55:19.982",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050514",
        "positionId": "56050513",
        "volume": 5.72,
        "price": 3224.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.16,
        "doubleCheck": true
    },
    {
        "id": "53086831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20.475",
        "brokerTime": "2025-05-14 14:55:20.475",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050515",
        "positionId": "56050515",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.28,
        "doubleCheck": true
    },
    {
        "id": "53086833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:20.475",
        "brokerTime": "2025-05-14 14:55:20.925",
        "commission": -40.04,
        "swap": 0,
        "profit": -85.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050517",
        "positionId": "56050515",
        "volume": 5.72,
        "price": 3224.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -125.84,
        "takeProfit": null,
        "priceIn": 3224.28,
        "doubleCheck": true
    },
    {
        "id": "53086834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:21.228",
        "brokerTime": "2025-05-14 14:55:21.228",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050518",
        "positionId": "56050518",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.18,
        "doubleCheck": true
    },
    {
        "id": "53086835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:21.228",
        "brokerTime": "2025-05-14 14:55:21.793",
        "commission": -40.04,
        "swap": 0,
        "profit": -28.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050519",
        "positionId": "56050518",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -68.64,
        "takeProfit": null,
        "priceIn": 3224.18,
        "doubleCheck": true
    },
    {
        "id": "53086836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:22.182",
        "brokerTime": "2025-05-14 14:55:22.182",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050521",
        "positionId": "56050521",
        "volume": 5.72,
        "price": 3224,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "id": "53086839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:22.182",
        "brokerTime": "2025-05-14 14:55:22.886",
        "commission": -40.04,
        "swap": 0,
        "profit": -143,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050523",
        "positionId": "56050521",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -183.04,
        "takeProfit": null,
        "priceIn": 3224,
        "doubleCheck": true
    },
    {
        "id": "53086840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23.088",
        "brokerTime": "2025-05-14 14:55:23.088",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050524",
        "positionId": "56050524",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "id": "53086842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23.088",
        "brokerTime": "2025-05-14 14:55:23.626",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050526",
        "positionId": "56050524",
        "volume": 5.72,
        "price": 3224.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.03,
        "doubleCheck": true
    },
    {
        "id": "53086843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23.945",
        "brokerTime": "2025-05-14 14:55:23.945",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050527",
        "positionId": "56050527",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53086844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:23.945",
        "brokerTime": "2025-05-14 14:55:24.271",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050528",
        "positionId": "56050527",
        "volume": 5.72,
        "price": 3224.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53086845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24.478",
        "brokerTime": "2025-05-14 14:55:24.478",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050529",
        "positionId": "56050529",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "id": "53086846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:24.478",
        "brokerTime": "2025-05-14 14:55:25.398",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050530",
        "positionId": "56050529",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "id": "53086847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26.079",
        "brokerTime": "2025-05-14 14:55:26.079",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050531",
        "positionId": "56050531",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53086848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26.079",
        "brokerTime": "2025-05-14 14:55:26.456",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050532",
        "positionId": "56050531",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53086849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26.765",
        "brokerTime": "2025-05-14 14:55:26.765",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050534",
        "positionId": "56050534",
        "volume": 5.72,
        "price": 3224.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "id": "53086851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:26.765",
        "brokerTime": "2025-05-14 14:55:27.355",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050535",
        "positionId": "56050534",
        "volume": 5.72,
        "price": 3224.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3224.01,
        "doubleCheck": true
    },
    {
        "id": "53086852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:28.545",
        "brokerTime": "2025-05-14 14:55:28.545",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050536",
        "positionId": "56050536",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53086853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:28.545",
        "brokerTime": "2025-05-14 14:55:28.918",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050537",
        "positionId": "56050536",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.88,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53086854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29.232",
        "brokerTime": "2025-05-14 14:55:29.232",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050538",
        "positionId": "56050538",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "id": "53086861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:29.232",
        "brokerTime": "2025-05-14 14:55:30.092",
        "commission": -40.04,
        "swap": 0,
        "profit": 97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050542",
        "positionId": "56050538",
        "volume": 5.72,
        "price": 3223.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 57.199999999999996,
        "takeProfit": null,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "id": "53086862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:30.640",
        "brokerTime": "2025-05-14 14:55:30.640",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050543",
        "positionId": "56050543",
        "volume": 5.72,
        "price": 3223.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "id": "53086864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:30.640",
        "brokerTime": "2025-05-14 14:55:31.138",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050545",
        "positionId": "56050543",
        "volume": 5.72,
        "price": 3223.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "id": "53086865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31.458",
        "brokerTime": "2025-05-14 14:55:31.458",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050546",
        "positionId": "56050546",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53086866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:31.458",
        "brokerTime": "2025-05-14 14:55:31.904",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050547",
        "positionId": "56050546",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53086867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32.107",
        "brokerTime": "2025-05-14 14:55:32.107",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050548",
        "positionId": "56050548",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53086868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32.107",
        "brokerTime": "2025-05-14 14:55:32.762",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050549",
        "positionId": "56050548",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53086869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32.941",
        "brokerTime": "2025-05-14 14:55:32.941",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050550",
        "positionId": "56050550",
        "volume": 5.72,
        "price": 3223.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "id": "53086872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:32.941",
        "brokerTime": "2025-05-14 14:55:33.688",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050552",
        "positionId": "56050550",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "id": "53086873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34.175",
        "brokerTime": "2025-05-14 14:55:34.175",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050553",
        "positionId": "56050553",
        "volume": 5.72,
        "price": 3223.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.58,
        "doubleCheck": true
    },
    {
        "id": "53086876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34.175",
        "brokerTime": "2025-05-14 14:55:34.538",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050556",
        "positionId": "56050553",
        "volume": 5.72,
        "price": 3223.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.58,
        "doubleCheck": true
    },
    {
        "id": "53086878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34.981",
        "brokerTime": "2025-05-14 14:55:34.981",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050557",
        "positionId": "56050557",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:34.981",
        "brokerTime": "2025-05-14 14:55:35.742",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050558",
        "positionId": "56050557",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:36.053",
        "brokerTime": "2025-05-14 14:55:36.053",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050559",
        "positionId": "56050559",
        "volume": 5.72,
        "price": 3223.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "id": "53086882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:36.053",
        "brokerTime": "2025-05-14 14:55:37.133",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050560",
        "positionId": "56050559",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "id": "53086883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:37.923",
        "brokerTime": "2025-05-14 14:55:37.923",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050561",
        "positionId": "56050561",
        "volume": 5.72,
        "price": 3223.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "id": "53086884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:37.923",
        "brokerTime": "2025-05-14 14:55:38.279",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050562",
        "positionId": "56050561",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "id": "53086885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:38.872",
        "brokerTime": "2025-05-14 14:55:38.872",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050563",
        "positionId": "56050563",
        "volume": 5.72,
        "price": 3223.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.71,
        "doubleCheck": true
    },
    {
        "id": "53086886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:38.872",
        "brokerTime": "2025-05-14 14:55:39.403",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050564",
        "positionId": "56050563",
        "volume": 5.72,
        "price": 3223.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.71,
        "doubleCheck": true
    },
    {
        "id": "53086887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:39.911",
        "brokerTime": "2025-05-14 14:55:39.911",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050565",
        "positionId": "56050565",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:39.911",
        "brokerTime": "2025-05-14 14:55:40.349",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050567",
        "positionId": "56050565",
        "volume": 5.72,
        "price": 3223.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:40.578",
        "brokerTime": "2025-05-14 14:55:40.578",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050568",
        "positionId": "56050568",
        "volume": 5.72,
        "price": 3223.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.69,
        "doubleCheck": true
    },
    {
        "id": "53086891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:40.578",
        "brokerTime": "2025-05-14 14:55:40.986",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050569",
        "positionId": "56050568",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3223.69,
        "doubleCheck": true
    },
    {
        "id": "53086892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41.180",
        "brokerTime": "2025-05-14 14:55:41.180",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050570",
        "positionId": "56050570",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "id": "53086893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:41.180",
        "brokerTime": "2025-05-14 14:55:42.139",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050571",
        "positionId": "56050570",
        "volume": 5.72,
        "price": 3223.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "id": "53086895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:42.523",
        "brokerTime": "2025-05-14 14:55:42.523",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050573",
        "positionId": "56050573",
        "volume": 5.72,
        "price": 3223.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "id": "53086896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:42.523",
        "brokerTime": "2025-05-14 14:55:43.715",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050574",
        "positionId": "56050573",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -228.79999999999998,
        "takeProfit": null,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "id": "53086897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:43.916",
        "brokerTime": "2025-05-14 14:55:43.916",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050575",
        "positionId": "56050575",
        "volume": 5.72,
        "price": 3223.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "id": "53086898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:43.916",
        "brokerTime": "2025-05-14 14:55:44.684",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050576",
        "positionId": "56050575",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.68,
        "takeProfit": null,
        "priceIn": 3223.72,
        "doubleCheck": true
    },
    {
        "id": "53086899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:45.295",
        "brokerTime": "2025-05-14 14:55:45.295",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050577",
        "positionId": "56050577",
        "volume": 5.72,
        "price": 3223.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.64,
        "doubleCheck": true
    },
    {
        "id": "53086900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:45.295",
        "brokerTime": "2025-05-14 14:55:46.094",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050578",
        "positionId": "56050577",
        "volume": 5.72,
        "price": 3223.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.64,
        "doubleCheck": true
    },
    {
        "id": "53086901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:46.370",
        "brokerTime": "2025-05-14 14:55:46.370",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050579",
        "positionId": "56050579",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:46.370",
        "brokerTime": "2025-05-14 14:55:46.814",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050580",
        "positionId": "56050579",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:47.186",
        "brokerTime": "2025-05-14 14:55:47.186",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050581",
        "positionId": "56050581",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:47.186",
        "brokerTime": "2025-05-14 14:55:47.789",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050582",
        "positionId": "56050581",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48.093",
        "brokerTime": "2025-05-14 14:55:48.093",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050583",
        "positionId": "56050583",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48.093",
        "brokerTime": "2025-05-14 14:55:48.611",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050584",
        "positionId": "56050583",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48.828",
        "brokerTime": "2025-05-14 14:55:48.828",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050585",
        "positionId": "56050585",
        "volume": 5.72,
        "price": 3223.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "id": "53086908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:48.828",
        "brokerTime": "2025-05-14 14:55:49.130",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050586",
        "positionId": "56050585",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3223.75,
        "doubleCheck": true
    },
    {
        "id": "53086909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:49.526",
        "brokerTime": "2025-05-14 14:55:49.526",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050587",
        "positionId": "56050587",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:49.526",
        "brokerTime": "2025-05-14 14:55:50.111",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050588",
        "positionId": "56050587",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50.401",
        "brokerTime": "2025-05-14 14:55:50.401",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050589",
        "positionId": "56050589",
        "volume": 5.72,
        "price": 3223.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.68,
        "doubleCheck": true
    },
    {
        "id": "53086912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:50.401",
        "brokerTime": "2025-05-14 14:55:50.965",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050590",
        "positionId": "56050589",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.68,
        "takeProfit": null,
        "priceIn": 3223.68,
        "doubleCheck": true
    },
    {
        "id": "53086913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:51.252",
        "brokerTime": "2025-05-14 14:55:51.252",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050591",
        "positionId": "56050591",
        "volume": 5.72,
        "price": 3223.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "id": "53086914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:51.252",
        "brokerTime": "2025-05-14 14:55:51.757",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050592",
        "positionId": "56050591",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.62,
        "doubleCheck": true
    },
    {
        "id": "53086915",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:52.182",
        "brokerTime": "2025-05-14 14:55:52.182",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050593",
        "positionId": "56050593",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:52.182",
        "brokerTime": "2025-05-14 14:55:52.836",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050594",
        "positionId": "56050593",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53.065",
        "brokerTime": "2025-05-14 14:55:53.065",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050595",
        "positionId": "56050595",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53.065",
        "brokerTime": "2025-05-14 14:55:53.500",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050596",
        "positionId": "56050595",
        "volume": 5.72,
        "price": 3223.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3223.66,
        "doubleCheck": true
    },
    {
        "id": "53086919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53.713",
        "brokerTime": "2025-05-14 14:55:53.713",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050597",
        "positionId": "56050597",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:53.713",
        "brokerTime": "2025-05-14 14:55:54.073",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050598",
        "positionId": "56050597",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53086921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54.356",
        "brokerTime": "2025-05-14 14:55:54.356",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050599",
        "positionId": "56050599",
        "volume": 5.72,
        "price": 3223.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:54.356",
        "brokerTime": "2025-05-14 14:55:54.820",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050600",
        "positionId": "56050599",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3223.65,
        "doubleCheck": true
    },
    {
        "id": "53086923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:55.451",
        "brokerTime": "2025-05-14 14:55:55.451",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050601",
        "positionId": "56050601",
        "volume": 5.72,
        "price": 3223.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "id": "53086924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:55.451",
        "brokerTime": "2025-05-14 14:55:55.875",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050602",
        "positionId": "56050601",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "id": "53086925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56.162",
        "brokerTime": "2025-05-14 14:55:56.162",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050603",
        "positionId": "56050603",
        "volume": 5.72,
        "price": 3223.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "id": "53086926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56.162",
        "brokerTime": "2025-05-14 14:55:56.825",
        "commission": -40.04,
        "swap": 0,
        "profit": -125.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050604",
        "positionId": "56050603",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.88,
        "takeProfit": null,
        "priceIn": 3223.57,
        "doubleCheck": true
    },
    {
        "id": "53086927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56.954",
        "brokerTime": "2025-05-14 14:55:56.954",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050605",
        "positionId": "56050605",
        "volume": 5.72,
        "price": 3223.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.46,
        "doubleCheck": true
    },
    {
        "id": "53086928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:56.954",
        "brokerTime": "2025-05-14 14:55:57.513",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050606",
        "positionId": "56050605",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -228.79999999999998,
        "takeProfit": null,
        "priceIn": 3223.46,
        "doubleCheck": true
    },
    {
        "id": "53086929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:57.819",
        "brokerTime": "2025-05-14 14:55:57.819",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050607",
        "positionId": "56050607",
        "volume": 5.72,
        "price": 3223.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "id": "53086930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:57.819",
        "brokerTime": "2025-05-14 14:55:58.130",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050608",
        "positionId": "56050607",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.6,
        "doubleCheck": true
    },
    {
        "id": "53086931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58.374",
        "brokerTime": "2025-05-14 14:55:58.374",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050609",
        "positionId": "56050609",
        "volume": 5.72,
        "price": 3223.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "id": "53086932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:58.374",
        "brokerTime": "2025-05-14 14:55:58.730",
        "commission": -40.04,
        "swap": 0,
        "profit": -154.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050610",
        "positionId": "56050609",
        "volume": 5.72,
        "price": 3223.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.48,
        "takeProfit": null,
        "priceIn": 3223.67,
        "doubleCheck": true
    },
    {
        "id": "53086933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59.290",
        "brokerTime": "2025-05-14 14:55:59.290",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050611",
        "positionId": "56050611",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59.290",
        "brokerTime": "2025-05-14 14:55:59.614",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050612",
        "positionId": "56050611",
        "volume": 5.72,
        "price": 3224.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.68,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53086935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59.934",
        "brokerTime": "2025-05-14 14:55:59.934",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050613",
        "positionId": "56050613",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "id": "53086941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:55:59.934",
        "brokerTime": "2025-05-14 14:56:00.567",
        "commission": -40.04,
        "swap": 0,
        "profit": -51.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050620",
        "positionId": "56050613",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -91.52,
        "takeProfit": null,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "id": "53086942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:00.896",
        "brokerTime": "2025-05-14 14:56:00.896",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050621",
        "positionId": "56050621",
        "volume": 5.72,
        "price": 3223.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.83,
        "doubleCheck": true
    },
    {
        "id": "53086949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:00.896",
        "brokerTime": "2025-05-14 14:56:01.469",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050626",
        "positionId": "56050621",
        "volume": 5.72,
        "price": 3223.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -62.92,
        "takeProfit": null,
        "priceIn": 3223.83,
        "doubleCheck": true
    },
    {
        "id": "53086953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02.051",
        "brokerTime": "2025-05-14 14:56:02.051",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050630",
        "positionId": "56050630",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53087001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02.051",
        "brokerTime": "2025-05-14 14:56:02.466",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050663",
        "positionId": "56050630",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.68,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53087004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02.805",
        "brokerTime": "2025-05-14 14:56:02.805",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050664",
        "positionId": "56050664",
        "volume": 5.72,
        "price": 3223.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53087005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:02.805",
        "brokerTime": "2025-05-14 14:56:03.276",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050665",
        "positionId": "56050664",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.7,
        "doubleCheck": true
    },
    {
        "id": "53087007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:03.791",
        "brokerTime": "2025-05-14 14:56:03.791",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050667",
        "positionId": "56050667",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "id": "53087008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:03.791",
        "brokerTime": "2025-05-14 14:56:04.303",
        "commission": -40.04,
        "swap": 0,
        "profit": -188.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050668",
        "positionId": "56050667",
        "volume": 5.72,
        "price": 3224.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -228.79999999999998,
        "takeProfit": null,
        "priceIn": 3223.74,
        "doubleCheck": true
    },
    {
        "id": "53087009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:04.790",
        "brokerTime": "2025-05-14 14:56:04.790",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050669",
        "positionId": "56050669",
        "volume": 5.72,
        "price": 3223.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "id": "53087010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:04.790",
        "brokerTime": "2025-05-14 14:56:05.746",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050671",
        "positionId": "56050669",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3223.81,
        "doubleCheck": true
    },
    {
        "id": "53087011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:06.192",
        "brokerTime": "2025-05-14 14:56:06.192",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050672",
        "positionId": "56050672",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "id": "53087012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:06.192",
        "brokerTime": "2025-05-14 14:56:06.565",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050673",
        "positionId": "56050672",
        "volume": 5.72,
        "price": 3224.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "id": "53087014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:07.197",
        "brokerTime": "2025-05-14 14:56:07.197",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050675",
        "positionId": "56050675",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.9,
        "doubleCheck": true
    },
    {
        "id": "53087015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:07.197",
        "brokerTime": "2025-05-14 14:56:07.834",
        "commission": -40.04,
        "swap": 0,
        "profit": -217.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050676",
        "positionId": "56050675",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -257.40000000000003,
        "takeProfit": null,
        "priceIn": 3223.9,
        "doubleCheck": true
    },
    {
        "id": "53087016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:08.271",
        "brokerTime": "2025-05-14 14:56:08.271",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050677",
        "positionId": "56050677",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:08.271",
        "brokerTime": "2025-05-14 14:56:08.897",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050678",
        "positionId": "56050677",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09.176",
        "brokerTime": "2025-05-14 14:56:09.176",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050679",
        "positionId": "56050679",
        "volume": 5.72,
        "price": 3224.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.11,
        "doubleCheck": true
    },
    {
        "id": "53087019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09.176",
        "brokerTime": "2025-05-14 14:56:09.707",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050680",
        "positionId": "56050679",
        "volume": 5.72,
        "price": 3224.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3224.11,
        "doubleCheck": true
    },
    {
        "id": "53087020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09.891",
        "brokerTime": "2025-05-14 14:56:09.891",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050681",
        "positionId": "56050681",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.23,
        "doubleCheck": true
    },
    {
        "id": "53087022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:09.891",
        "brokerTime": "2025-05-14 14:56:10.306",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050683",
        "positionId": "56050681",
        "volume": 5.72,
        "price": 3224.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3224.23,
        "doubleCheck": true
    },
    {
        "id": "53087023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:10.949",
        "brokerTime": "2025-05-14 14:56:10.949",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050684",
        "positionId": "56050684",
        "volume": 5.72,
        "price": 3224.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.21,
        "doubleCheck": true
    },
    {
        "id": "53087024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:10.949",
        "brokerTime": "2025-05-14 14:56:11.399",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050685",
        "positionId": "56050684",
        "volume": 5.72,
        "price": 3224.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3224.21,
        "doubleCheck": true
    },
    {
        "id": "53087025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:11.584",
        "brokerTime": "2025-05-14 14:56:11.584",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050686",
        "positionId": "56050686",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.2,
        "doubleCheck": true
    },
    {
        "id": "53087031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:11.584",
        "brokerTime": "2025-05-14 14:56:12.526",
        "commission": -40.04,
        "swap": 0,
        "profit": -205.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050692",
        "positionId": "56050686",
        "volume": 5.72,
        "price": 3224.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245.95999999999998,
        "takeProfit": null,
        "priceIn": 3224.2,
        "doubleCheck": true
    },
    {
        "id": "53087032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:12.894",
        "brokerTime": "2025-05-14 14:56:12.894",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050693",
        "positionId": "56050693",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53087033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:12.894",
        "brokerTime": "2025-05-14 14:56:13.814",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050694",
        "positionId": "56050693",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.63,
        "doubleCheck": true
    },
    {
        "id": "53087034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:14.106",
        "brokerTime": "2025-05-14 14:56:14.106",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050695",
        "positionId": "56050695",
        "volume": 5.72,
        "price": 3223.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "id": "53087035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:14.106",
        "brokerTime": "2025-05-14 14:56:14.711",
        "commission": -40.04,
        "swap": 0,
        "profit": -194.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050696",
        "positionId": "56050695",
        "volume": 5.72,
        "price": 3223.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -234.51999999999998,
        "takeProfit": null,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "id": "53087036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15.050",
        "brokerTime": "2025-05-14 14:56:15.050",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050697",
        "positionId": "56050697",
        "volume": 5.72,
        "price": 3223.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.96,
        "doubleCheck": true
    },
    {
        "id": "53087037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15.050",
        "brokerTime": "2025-05-14 14:56:15.414",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050698",
        "positionId": "56050697",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3223.96,
        "doubleCheck": true
    },
    {
        "id": "53087038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15.881",
        "brokerTime": "2025-05-14 14:56:15.881",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050699",
        "positionId": "56050699",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "id": "53087039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:15.881",
        "brokerTime": "2025-05-14 14:56:17.363",
        "commission": -40.04,
        "swap": 0,
        "profit": -68.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050700",
        "positionId": "56050699",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -108.68,
        "takeProfit": null,
        "priceIn": 3223.98,
        "doubleCheck": true
    },
    {
        "id": "53087040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:17.732",
        "brokerTime": "2025-05-14 14:56:17.732",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050701",
        "positionId": "56050701",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "id": "53087041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:17.732",
        "brokerTime": "2025-05-14 14:56:19.211",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050702",
        "positionId": "56050701",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.09,
        "doubleCheck": true
    },
    {
        "id": "53087042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20.213",
        "brokerTime": "2025-05-14 14:56:20.213",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050703",
        "positionId": "56050703",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20.213",
        "brokerTime": "2025-05-14 14:56:20.637",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050704",
        "positionId": "56050703",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20.904",
        "brokerTime": "2025-05-14 14:56:20.904",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050705",
        "positionId": "56050705",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:20.904",
        "brokerTime": "2025-05-14 14:56:21.394",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050706",
        "positionId": "56050705",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.08,
        "doubleCheck": true
    },
    {
        "id": "53087046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:21.876",
        "brokerTime": "2025-05-14 14:56:21.876",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050707",
        "positionId": "56050707",
        "volume": 5.72,
        "price": 3223.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.94,
        "doubleCheck": true
    },
    {
        "id": "53087047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:21.876",
        "brokerTime": "2025-05-14 14:56:22.530",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050708",
        "positionId": "56050707",
        "volume": 5.72,
        "price": 3224.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3223.94,
        "doubleCheck": true
    },
    {
        "id": "53087048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:23.321",
        "brokerTime": "2025-05-14 14:56:23.321",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050709",
        "positionId": "56050709",
        "volume": 5.72,
        "price": 3223.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.89,
        "doubleCheck": true
    },
    {
        "id": "53087049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:23.321",
        "brokerTime": "2025-05-14 14:56:23.756",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050710",
        "positionId": "56050709",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.89,
        "doubleCheck": true
    },
    {
        "id": "53087050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24.104",
        "brokerTime": "2025-05-14 14:56:24.104",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050711",
        "positionId": "56050711",
        "volume": 5.72,
        "price": 3223.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "id": "53087051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24.104",
        "brokerTime": "2025-05-14 14:56:24.502",
        "commission": -40.04,
        "swap": 0,
        "profit": -148.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050712",
        "positionId": "56050711",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -188.76,
        "takeProfit": null,
        "priceIn": 3223.84,
        "doubleCheck": true
    },
    {
        "id": "53087052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24.661",
        "brokerTime": "2025-05-14 14:56:24.661",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050713",
        "positionId": "56050713",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:24.661",
        "brokerTime": "2025-05-14 14:56:25.084",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050714",
        "positionId": "56050713",
        "volume": 5.72,
        "price": 3224.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25.456",
        "brokerTime": "2025-05-14 14:56:25.456",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050715",
        "positionId": "56050715",
        "volume": 5.72,
        "price": 3223.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "id": "53087055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:25.456",
        "brokerTime": "2025-05-14 14:56:25.816",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050716",
        "positionId": "56050715",
        "volume": 5.72,
        "price": 3224.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "id": "53087056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26.409",
        "brokerTime": "2025-05-14 14:56:26.409",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050717",
        "positionId": "56050717",
        "volume": 5.72,
        "price": 3223.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "id": "53087057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26.409",
        "brokerTime": "2025-05-14 14:56:26.742",
        "commission": -40.04,
        "swap": 0,
        "profit": -62.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050718",
        "positionId": "56050717",
        "volume": 5.72,
        "price": 3223.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.96000000000001,
        "takeProfit": null,
        "priceIn": 3223.88,
        "doubleCheck": true
    },
    {
        "id": "53087058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26.988",
        "brokerTime": "2025-05-14 14:56:26.988",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050719",
        "positionId": "56050719",
        "volume": 5.72,
        "price": 3223.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.78,
        "doubleCheck": true
    },
    {
        "id": "53087059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:26.988",
        "brokerTime": "2025-05-14 14:56:27.598",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050721",
        "positionId": "56050719",
        "volume": 5.72,
        "price": 3223.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.78,
        "doubleCheck": true
    },
    {
        "id": "53087061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:28.818",
        "brokerTime": "2025-05-14 14:56:28.818",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050722",
        "positionId": "56050722",
        "volume": 5.72,
        "price": 3223.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.82,
        "doubleCheck": true
    },
    {
        "id": "53087062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:28.818",
        "brokerTime": "2025-05-14 14:56:29.456",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050723",
        "positionId": "56050722",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3223.82,
        "doubleCheck": true
    },
    {
        "id": "53087063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:29.871",
        "brokerTime": "2025-05-14 14:56:29.871",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050724",
        "positionId": "56050724",
        "volume": 5.72,
        "price": 3223.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.91,
        "doubleCheck": true
    },
    {
        "id": "53087064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:29.871",
        "brokerTime": "2025-05-14 14:56:31.268",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050725",
        "positionId": "56050724",
        "volume": 5.72,
        "price": 3224.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.91,
        "doubleCheck": true
    },
    {
        "id": "53087065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:31.597",
        "brokerTime": "2025-05-14 14:56:31.597",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050726",
        "positionId": "56050726",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:31.597",
        "brokerTime": "2025-05-14 14:56:32.729",
        "commission": -40.04,
        "swap": 0,
        "profit": -194.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050727",
        "positionId": "56050726",
        "volume": 5.72,
        "price": 3224.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -234.51999999999998,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33.072",
        "brokerTime": "2025-05-14 14:56:33.072",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050728",
        "positionId": "56050728",
        "volume": 5.72,
        "price": 3224.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "id": "53087068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33.072",
        "brokerTime": "2025-05-14 14:56:33.521",
        "commission": -40.04,
        "swap": 0,
        "profit": -183.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050729",
        "positionId": "56050728",
        "volume": 5.72,
        "price": 3224.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.07999999999998,
        "takeProfit": null,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "id": "53087069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33.775",
        "brokerTime": "2025-05-14 14:56:33.775",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050730",
        "positionId": "56050730",
        "volume": 5.72,
        "price": 3224.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.12,
        "doubleCheck": true
    },
    {
        "id": "53087070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:33.775",
        "brokerTime": "2025-05-14 14:56:34.089",
        "commission": -40.04,
        "swap": 0,
        "profit": -91.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050731",
        "positionId": "56050730",
        "volume": 5.72,
        "price": 3224.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -131.56,
        "takeProfit": null,
        "priceIn": 3224.12,
        "doubleCheck": true
    },
    {
        "id": "53087071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34.391",
        "brokerTime": "2025-05-14 14:56:34.391",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050732",
        "positionId": "56050732",
        "volume": 5.72,
        "price": 3224.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "id": "53087074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:34.391",
        "brokerTime": "2025-05-14 14:56:35.266",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050734",
        "positionId": "56050732",
        "volume": 5.72,
        "price": 3224.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -62.92,
        "takeProfit": null,
        "priceIn": 3224.13,
        "doubleCheck": true
    },
    {
        "id": "53087075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:35.619",
        "brokerTime": "2025-05-14 14:56:35.619",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050735",
        "positionId": "56050735",
        "volume": 5.72,
        "price": 3223.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:35.619",
        "brokerTime": "2025-05-14 14:56:35.922",
        "commission": -40.04,
        "swap": 0,
        "profit": -131.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050736",
        "positionId": "56050735",
        "volume": 5.72,
        "price": 3224.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -171.6,
        "takeProfit": null,
        "priceIn": 3223.97,
        "doubleCheck": true
    },
    {
        "id": "53087077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36.228",
        "brokerTime": "2025-05-14 14:56:36.228",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050737",
        "positionId": "56050737",
        "volume": 5.72,
        "price": 3223.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.99,
        "doubleCheck": true
    },
    {
        "id": "53087078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:36.228",
        "brokerTime": "2025-05-14 14:56:36.910",
        "commission": -40.04,
        "swap": 0,
        "profit": -160.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050738",
        "positionId": "56050737",
        "volume": 5.72,
        "price": 3224.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -200.2,
        "takeProfit": null,
        "priceIn": 3223.99,
        "doubleCheck": true
    },
    {
        "id": "53087079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37.359",
        "brokerTime": "2025-05-14 14:56:37.359",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050739",
        "positionId": "56050739",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53087080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37.359",
        "brokerTime": "2025-05-14 14:56:37.678",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050740",
        "positionId": "56050739",
        "volume": 5.72,
        "price": 3224.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53087081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37.911",
        "brokerTime": "2025-05-14 14:56:37.911",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050741",
        "positionId": "56050741",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53087082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:37.911",
        "brokerTime": "2025-05-14 14:56:38.442",
        "commission": -40.04,
        "swap": 0,
        "profit": -200.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050742",
        "positionId": "56050741",
        "volume": 5.72,
        "price": 3224.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.23999999999998,
        "takeProfit": null,
        "priceIn": 3224.06,
        "doubleCheck": true
    },
    {
        "id": "53087083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:38.650",
        "brokerTime": "2025-05-14 14:56:38.650",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050743",
        "positionId": "56050743",
        "volume": 5.72,
        "price": 3224.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.27,
        "doubleCheck": true
    },
    {
        "id": "53087084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:38.650",
        "brokerTime": "2025-05-14 14:56:39.066",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050744",
        "positionId": "56050743",
        "volume": 5.72,
        "price": 3224.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -114.4,
        "takeProfit": null,
        "priceIn": 3224.27,
        "doubleCheck": true
    },
    {
        "id": "53087085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39.419",
        "brokerTime": "2025-05-14 14:56:39.419",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050745",
        "positionId": "56050745",
        "volume": 5.72,
        "price": 3224.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.25,
        "doubleCheck": true
    },
    {
        "id": "53087086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:39.419",
        "brokerTime": "2025-05-14 14:56:39.711",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050746",
        "positionId": "56050745",
        "volume": 5.72,
        "price": 3224.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3224.25,
        "doubleCheck": true
    },
    {
        "id": "53087087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40.033",
        "brokerTime": "2025-05-14 14:56:40.033",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050747",
        "positionId": "56050747",
        "volume": 5.72,
        "price": 3224.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.35,
        "doubleCheck": true
    },
    {
        "id": "53087088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40.033",
        "brokerTime": "2025-05-14 14:56:40.742",
        "commission": -40.04,
        "swap": 0,
        "profit": -22.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050748",
        "positionId": "56050747",
        "volume": 5.72,
        "price": 3224.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -62.92,
        "takeProfit": null,
        "priceIn": 3224.35,
        "doubleCheck": true
    },
    {
        "id": "53087089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40.921",
        "brokerTime": "2025-05-14 14:56:40.921",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050749",
        "positionId": "56050749",
        "volume": 5.72,
        "price": 3224.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.17,
        "doubleCheck": true
    },
    {
        "id": "53087090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:40.921",
        "brokerTime": "2025-05-14 14:56:41.258",
        "commission": -40.04,
        "swap": 0,
        "profit": 51.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050750",
        "positionId": "56050749",
        "volume": 5.72,
        "price": 3224.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 11.439999999999998,
        "takeProfit": null,
        "priceIn": 3224.17,
        "doubleCheck": true
    },
    {
        "id": "53087091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:41.564",
        "brokerTime": "2025-05-14 14:56:41.564",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050751",
        "positionId": "56050751",
        "volume": 5.72,
        "price": 3223.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.86,
        "doubleCheck": true
    },
    {
        "id": "53087092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:41.564",
        "brokerTime": "2025-05-14 14:56:42.076",
        "commission": -40.04,
        "swap": 0,
        "profit": -114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050752",
        "positionId": "56050751",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.44,
        "takeProfit": null,
        "priceIn": 3223.86,
        "doubleCheck": true
    },
    {
        "id": "53087093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42.467",
        "brokerTime": "2025-05-14 14:56:42.467",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050753",
        "positionId": "56050753",
        "volume": 5.72,
        "price": 3223.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.87,
        "doubleCheck": true
    },
    {
        "id": "53087094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:42.467",
        "brokerTime": "2025-05-14 14:56:42.890",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050754",
        "positionId": "56050753",
        "volume": 5.72,
        "price": 3224.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3223.87,
        "doubleCheck": true
    },
    {
        "id": "53087095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:43.314",
        "brokerTime": "2025-05-14 14:56:43.314",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050755",
        "positionId": "56050755",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53087096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:43.314",
        "brokerTime": "2025-05-14 14:56:44.096",
        "commission": -40.04,
        "swap": 0,
        "profit": -108.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050756",
        "positionId": "56050755",
        "volume": 5.72,
        "price": 3224.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -148.72,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53087097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:44.437",
        "brokerTime": "2025-05-14 14:56:44.437",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050757",
        "positionId": "56050757",
        "volume": 5.72,
        "price": 3224.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53087098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:44.437",
        "brokerTime": "2025-05-14 14:56:44.828",
        "commission": -40.04,
        "swap": 0,
        "profit": 143,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050758",
        "positionId": "56050757",
        "volume": 5.72,
        "price": 3223.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 102.96000000000001,
        "takeProfit": null,
        "priceIn": 3224.04,
        "doubleCheck": true
    },
    {
        "id": "53087099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:45.254",
        "brokerTime": "2025-05-14 14:56:45.254",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050759",
        "positionId": "56050759",
        "volume": 5.72,
        "price": 3223.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "id": "53087100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:45.254",
        "brokerTime": "2025-05-14 14:56:45.757",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050760",
        "positionId": "56050759",
        "volume": 5.72,
        "price": 3223.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.56,
        "doubleCheck": true
    },
    {
        "id": "53087101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46.057",
        "brokerTime": "2025-05-14 14:56:46.057",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050761",
        "positionId": "56050761",
        "volume": 5.72,
        "price": 3223.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.48,
        "doubleCheck": true
    },
    {
        "id": "53087102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46.057",
        "brokerTime": "2025-05-14 14:56:46.654",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050762",
        "positionId": "56050761",
        "volume": 5.72,
        "price": 3223.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3223.48,
        "doubleCheck": true
    },
    {
        "id": "53087103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46.983",
        "brokerTime": "2025-05-14 14:56:46.983",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050763",
        "positionId": "56050763",
        "volume": 5.72,
        "price": 3223.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.5,
        "doubleCheck": true
    },
    {
        "id": "53087104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:46.983",
        "brokerTime": "2025-05-14 14:56:47.529",
        "commission": -40.04,
        "swap": 0,
        "profit": -74.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050764",
        "positionId": "56050763",
        "volume": 5.72,
        "price": 3223.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -114.4,
        "takeProfit": null,
        "priceIn": 3223.5,
        "doubleCheck": true
    },
    {
        "id": "53087105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:49.189",
        "brokerTime": "2025-05-14 14:56:49.189",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050766",
        "positionId": "56050766",
        "volume": 5.72,
        "price": 3223.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.11,
        "doubleCheck": true
    },
    {
        "id": "53087112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:49.189",
        "brokerTime": "2025-05-14 14:56:49.678",
        "commission": -40.04,
        "swap": 0,
        "profit": 11.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050771",
        "positionId": "56050766",
        "volume": 5.72,
        "price": 3223.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -28.6,
        "takeProfit": null,
        "priceIn": 3223.11,
        "doubleCheck": true
    },
    {
        "id": "53087114",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:50.084",
        "brokerTime": "2025-05-14 14:56:50.084",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050772",
        "positionId": "56050772",
        "volume": 5.72,
        "price": 3222.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.72,
        "doubleCheck": true
    },
    {
        "id": "53087115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:50.084",
        "brokerTime": "2025-05-14 14:56:50.861",
        "commission": -40.04,
        "swap": 0,
        "profit": -148.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050773",
        "positionId": "56050772",
        "volume": 5.72,
        "price": 3222.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -188.76,
        "takeProfit": null,
        "priceIn": 3222.72,
        "doubleCheck": true
    },
    {
        "id": "53087116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:51.087",
        "brokerTime": "2025-05-14 14:56:51.087",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050774",
        "positionId": "56050774",
        "volume": 5.72,
        "price": 3222.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "id": "53087117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:51.087",
        "brokerTime": "2025-05-14 14:56:51.980",
        "commission": -40.04,
        "swap": 0,
        "profit": -102.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050775",
        "positionId": "56050774",
        "volume": 5.72,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -143,
        "takeProfit": null,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "id": "53087118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:52.320",
        "brokerTime": "2025-05-14 14:56:52.320",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050777",
        "positionId": "56050777",
        "volume": 5.72,
        "price": 3222.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.81,
        "doubleCheck": true
    },
    {
        "id": "53087120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:52.320",
        "brokerTime": "2025-05-14 14:56:53.059",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050778",
        "positionId": "56050777",
        "volume": 5.72,
        "price": 3223.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3222.81,
        "doubleCheck": true
    },
    {
        "id": "53087121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:53.637",
        "brokerTime": "2025-05-14 14:56:53.637",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050779",
        "positionId": "56050779",
        "volume": 5.72,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "id": "53087122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:53.637",
        "brokerTime": "2025-05-14 14:56:54.121",
        "commission": -40.04,
        "swap": 0,
        "profit": -120.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050780",
        "positionId": "56050779",
        "volume": 5.72,
        "price": 3223.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -160.16,
        "takeProfit": null,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "id": "53087123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:54.541",
        "brokerTime": "2025-05-14 14:56:54.541",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050781",
        "positionId": "56050781",
        "volume": 5.72,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "id": "53087124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:54.541",
        "brokerTime": "2025-05-14 14:56:55.100",
        "commission": -40.04,
        "swap": 0,
        "profit": -200.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050782",
        "positionId": "56050781",
        "volume": 5.72,
        "price": 3223.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.23999999999998,
        "takeProfit": null,
        "priceIn": 3222.83,
        "doubleCheck": true
    },
    {
        "id": "53087125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55.387",
        "brokerTime": "2025-05-14 14:56:55.387",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050783",
        "positionId": "56050783",
        "volume": 5.72,
        "price": 3223.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3223.01,
        "doubleCheck": true
    },
    {
        "id": "53087126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:55.387",
        "brokerTime": "2025-05-14 14:56:56.308",
        "commission": -40.04,
        "swap": 0,
        "profit": 17.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050784",
        "positionId": "56050783",
        "volume": 5.72,
        "price": 3222.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -22.88,
        "takeProfit": null,
        "priceIn": 3223.01,
        "doubleCheck": true
    },
    {
        "id": "53087127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:56.564",
        "brokerTime": "2025-05-14 14:56:56.564",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050785",
        "positionId": "56050785",
        "volume": 5.72,
        "price": 3222.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.73,
        "doubleCheck": true
    },
    {
        "id": "53087128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:56.564",
        "brokerTime": "2025-05-14 14:56:57.167",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050786",
        "positionId": "56050785",
        "volume": 5.72,
        "price": 3222.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3222.73,
        "doubleCheck": true
    },
    {
        "id": "53087130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57.467",
        "brokerTime": "2025-05-14 14:56:57.467",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050787",
        "positionId": "56050787",
        "volume": 5.72,
        "price": 3222.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "id": "53087132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:57.467",
        "brokerTime": "2025-05-14 14:56:57.784",
        "commission": -40.04,
        "swap": 0,
        "profit": -80.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050789",
        "positionId": "56050787",
        "volume": 5.72,
        "price": 3222.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -120.12,
        "takeProfit": null,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "id": "53087134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58.047",
        "brokerTime": "2025-05-14 14:56:58.047",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050790",
        "positionId": "56050790",
        "volume": 5.72,
        "price": 3222.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.37,
        "doubleCheck": true
    },
    {
        "id": "53087138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58.047",
        "brokerTime": "2025-05-14 14:56:58.574",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050794",
        "positionId": "56050790",
        "volume": 5.72,
        "price": 3222.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3222.37,
        "doubleCheck": true
    },
    {
        "id": "53087142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58.858",
        "brokerTime": "2025-05-14 14:56:58.858",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050796",
        "positionId": "56050796",
        "volume": 5.72,
        "price": 3222.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.27,
        "doubleCheck": true
    },
    {
        "id": "53087143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:58.858",
        "brokerTime": "2025-05-14 14:56:59.579",
        "commission": -40.04,
        "swap": 0,
        "profit": -137.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050797",
        "positionId": "56050796",
        "volume": 5.72,
        "price": 3222.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -177.32,
        "takeProfit": null,
        "priceIn": 3222.27,
        "doubleCheck": true
    },
    {
        "id": "53087144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:59.847",
        "brokerTime": "2025-05-14 14:56:59.847",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050798",
        "positionId": "56050798",
        "volume": 5.72,
        "price": 3222.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "id": "53087162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:56:59.847",
        "brokerTime": "2025-05-14 14:57:00.351",
        "commission": -40.04,
        "swap": 0,
        "profit": -97.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050816",
        "positionId": "56050798",
        "volume": 5.72,
        "price": 3222.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.28,
        "takeProfit": null,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "id": "53087164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:00.722",
        "brokerTime": "2025-05-14 14:57:00.722",
        "commission": -40.04,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050817",
        "positionId": "56050817",
        "volume": 5.72,
        "price": 3222.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -40.04,
        "takeProfit": null,
        "priceIn": 3222.06,
        "doubleCheck": true
    },
    {
        "id": "53087169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:00.722",
        "brokerTime": "2025-05-14 14:57:01.304",
        "commission": -40.04,
        "swap": 0,
        "profit": 114.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050821",
        "positionId": "56050817",
        "volume": 5.72,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 74.36000000000001,
        "takeProfit": null,
        "priceIn": 3222.06,
        "doubleCheck": true
    },
    {
        "id": "53087170",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:57:01.371",
        "brokerTime": "2025-05-14 14:57:01.371",
        "commission": -7.49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050822",
        "positionId": "56050822",
        "volume": 1.07,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3321.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.49,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "id": "53087237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:03.432",
        "brokerTime": "2025-05-14 14:57:03.432",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050855",
        "positionId": "56050855",
        "volume": 7,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53087325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:03.432",
        "brokerTime": "2025-05-14 14:57:03.868",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050955",
        "positionId": "56050855",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53087425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04.078",
        "brokerTime": "2025-05-14 14:57:04.078",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56050986",
        "positionId": "56050986",
        "volume": 7,
        "price": 3220.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.03,
        "doubleCheck": true
    },
    {
        "id": "53087535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04.078",
        "brokerTime": "2025-05-14 14:57:04.491",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051046",
        "positionId": "56050986",
        "volume": 7,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154,
        "takeProfit": null,
        "priceIn": 3220.03,
        "doubleCheck": true
    },
    {
        "id": "53087552",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04.748",
        "brokerTime": "2025-05-14 14:57:04.748",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051061",
        "positionId": "56051061",
        "volume": 7,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53087571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:04.748",
        "brokerTime": "2025-05-14 14:57:05.054",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051072",
        "positionId": "56051061",
        "volume": 7,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53087581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05.247",
        "brokerTime": "2025-05-14 14:57:05.247",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051073",
        "positionId": "56051073",
        "volume": 7,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53087585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:05.247",
        "brokerTime": "2025-05-14 14:57:05.816",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051077",
        "positionId": "56051073",
        "volume": 7,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53087586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:06.223",
        "brokerTime": "2025-05-14 14:57:06.223",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051078",
        "positionId": "56051078",
        "volume": 7,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53087590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:06.223",
        "brokerTime": "2025-05-14 14:57:06.731",
        "commission": -49,
        "swap": 0,
        "profit": 49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051082",
        "positionId": "56051078",
        "volume": 7,
        "price": 3219.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53087594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:07.172",
        "brokerTime": "2025-05-14 14:57:07.172",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051086",
        "positionId": "56051086",
        "volume": 7,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "id": "53087598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:07.172",
        "brokerTime": "2025-05-14 14:57:07.726",
        "commission": -49,
        "swap": 0,
        "profit": -308,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051090",
        "positionId": "56051086",
        "volume": 7,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -357,
        "takeProfit": null,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "id": "53087600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:08.094",
        "brokerTime": "2025-05-14 14:57:08.094",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051092",
        "positionId": "56051092",
        "volume": 7,
        "price": 3220.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.2,
        "doubleCheck": true
    },
    {
        "id": "53087602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:08.094",
        "brokerTime": "2025-05-14 14:57:08.860",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051093",
        "positionId": "56051092",
        "volume": 7,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3220.2,
        "doubleCheck": true
    },
    {
        "id": "53087603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:09.534",
        "brokerTime": "2025-05-14 14:57:09.534",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051094",
        "positionId": "56051094",
        "volume": 7,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.27,
        "doubleCheck": true
    },
    {
        "id": "53087604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:09.534",
        "brokerTime": "2025-05-14 14:57:10.110",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051095",
        "positionId": "56051094",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3220.27,
        "doubleCheck": true
    },
    {
        "id": "53087606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10.430",
        "brokerTime": "2025-05-14 14:57:10.430",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051097",
        "positionId": "56051097",
        "volume": 7,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "id": "53087608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10.430",
        "brokerTime": "2025-05-14 14:57:10.832",
        "commission": -49,
        "swap": 0,
        "profit": -266,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051099",
        "positionId": "56051097",
        "volume": 7,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315,
        "takeProfit": null,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "id": "53087610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10.969",
        "brokerTime": "2025-05-14 14:57:10.969",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051100",
        "positionId": "56051100",
        "volume": 7,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53087611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:10.969",
        "brokerTime": "2025-05-14 14:57:11.314",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051101",
        "positionId": "56051100",
        "volume": 7,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -77,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53087612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:11.734",
        "brokerTime": "2025-05-14 14:57:11.734",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051102",
        "positionId": "56051102",
        "volume": 7,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53087613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:11.734",
        "brokerTime": "2025-05-14 14:57:12.513",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051103",
        "positionId": "56051102",
        "volume": 7,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53087614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:12.768",
        "brokerTime": "2025-05-14 14:57:12.768",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051104",
        "positionId": "56051104",
        "volume": 7,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53087615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:12.768",
        "brokerTime": "2025-05-14 14:57:13.546",
        "commission": -49,
        "swap": 0,
        "profit": -21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051105",
        "positionId": "56051104",
        "volume": 7,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -70,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53087616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:13.972",
        "brokerTime": "2025-05-14 14:57:13.972",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051106",
        "positionId": "56051106",
        "volume": 7,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53087617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:13.972",
        "brokerTime": "2025-05-14 14:57:14.329",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051107",
        "positionId": "56051106",
        "volume": 7,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53087618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:14.910",
        "brokerTime": "2025-05-14 14:57:14.910",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051108",
        "positionId": "56051108",
        "volume": 7,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53087619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:14.910",
        "brokerTime": "2025-05-14 14:57:15.523",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051109",
        "positionId": "56051108",
        "volume": 7,
        "price": 3219.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53087621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:15.944",
        "brokerTime": "2025-05-14 14:57:15.944",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051111",
        "positionId": "56051111",
        "volume": 7,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53087623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:15.944",
        "brokerTime": "2025-05-14 14:57:16.409",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051112",
        "positionId": "56051111",
        "volume": 7,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53087626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17.021",
        "brokerTime": "2025-05-14 14:57:17.021",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051114",
        "positionId": "56051114",
        "volume": 7,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53087627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17.021",
        "brokerTime": "2025-05-14 14:57:17.683",
        "commission": -49,
        "swap": 0,
        "profit": -441,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051115",
        "positionId": "56051114",
        "volume": 7,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -490,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53087628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17.909",
        "brokerTime": "2025-05-14 14:57:17.909",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051116",
        "positionId": "56051116",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53087629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:17.909",
        "brokerTime": "2025-05-14 14:57:18.345",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051117",
        "positionId": "56051116",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53087630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:18.900",
        "brokerTime": "2025-05-14 14:57:18.900",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051118",
        "positionId": "56051118",
        "volume": 7,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53087631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:18.900",
        "brokerTime": "2025-05-14 14:57:19.678",
        "commission": -49,
        "swap": 0,
        "profit": -371,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051119",
        "positionId": "56051118",
        "volume": 7,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -420,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53087632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:20.007",
        "brokerTime": "2025-05-14 14:57:20.007",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051120",
        "positionId": "56051120",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "id": "53087634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:20.007",
        "brokerTime": "2025-05-14 14:57:20.636",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051122",
        "positionId": "56051120",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "id": "53087635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:21.313",
        "brokerTime": "2025-05-14 14:57:21.313",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051123",
        "positionId": "56051123",
        "volume": 7,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "id": "53087636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:21.313",
        "brokerTime": "2025-05-14 14:57:21.888",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051124",
        "positionId": "56051123",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322,
        "takeProfit": null,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "id": "53087638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:22.133",
        "brokerTime": "2025-05-14 14:57:22.133",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051126",
        "positionId": "56051126",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53087639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:22.133",
        "brokerTime": "2025-05-14 14:57:22.876",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051127",
        "positionId": "56051126",
        "volume": 7,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53087641",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23.191",
        "brokerTime": "2025-05-14 14:57:23.191",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051129",
        "positionId": "56051129",
        "volume": 7,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53087642",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23.191",
        "brokerTime": "2025-05-14 14:57:23.615",
        "commission": -49,
        "swap": 0,
        "profit": -217,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051130",
        "positionId": "56051129",
        "volume": 7,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -266,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53087643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23.969",
        "brokerTime": "2025-05-14 14:57:23.969",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051131",
        "positionId": "56051131",
        "volume": 7,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53087644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:23.969",
        "brokerTime": "2025-05-14 14:57:24.422",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051132",
        "positionId": "56051131",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53087645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:25.150",
        "brokerTime": "2025-05-14 14:57:25.150",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051133",
        "positionId": "56051133",
        "volume": 7,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53087646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:25.150",
        "brokerTime": "2025-05-14 14:57:25.711",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051134",
        "positionId": "56051133",
        "volume": 7,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53087647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26.024",
        "brokerTime": "2025-05-14 14:57:26.024",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051135",
        "positionId": "56051135",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "id": "53087648",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26.024",
        "brokerTime": "2025-05-14 14:57:26.385",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051136",
        "positionId": "56051135",
        "volume": 7,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84,
        "takeProfit": null,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "id": "53087649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26.675",
        "brokerTime": "2025-05-14 14:57:26.675",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051137",
        "positionId": "56051137",
        "volume": 7,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53087650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:26.675",
        "brokerTime": "2025-05-14 14:57:27.136",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051138",
        "positionId": "56051137",
        "volume": 7,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53087651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:27.727",
        "brokerTime": "2025-05-14 14:57:27.727",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051139",
        "positionId": "56051139",
        "volume": 7,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53087652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:27.727",
        "brokerTime": "2025-05-14 14:57:28.353",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051140",
        "positionId": "56051139",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53087653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:28.600",
        "brokerTime": "2025-05-14 14:57:28.600",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051141",
        "positionId": "56051141",
        "volume": 7,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.26,
        "doubleCheck": true
    },
    {
        "id": "53087654",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:28.600",
        "brokerTime": "2025-05-14 14:57:28.978",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051142",
        "positionId": "56051141",
        "volume": 7,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3221.26,
        "doubleCheck": true
    },
    {
        "id": "53087655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29.207",
        "brokerTime": "2025-05-14 14:57:29.207",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051143",
        "positionId": "56051143",
        "volume": 7,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53087656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:29.207",
        "brokerTime": "2025-05-14 14:57:29.731",
        "commission": -49,
        "swap": 0,
        "profit": -315,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051144",
        "positionId": "56051143",
        "volume": 7,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -364,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53087657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:30.012",
        "brokerTime": "2025-05-14 14:57:30.012",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051145",
        "positionId": "56051145",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53087661",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:30.012",
        "brokerTime": "2025-05-14 14:57:30.835",
        "commission": -49,
        "swap": 0,
        "profit": -581,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051150",
        "positionId": "56051145",
        "volume": 7,
        "price": 3222.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -630,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53087663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:31.349",
        "brokerTime": "2025-05-14 14:57:31.349",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051151",
        "positionId": "56051151",
        "volume": 7,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "id": "53087664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:31.349",
        "brokerTime": "2025-05-14 14:57:31.938",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051152",
        "positionId": "56051151",
        "volume": 7,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "id": "53087667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:32.418",
        "brokerTime": "2025-05-14 14:57:32.418",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051155",
        "positionId": "56051155",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53087670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:32.418",
        "brokerTime": "2025-05-14 14:57:32.846",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051156",
        "positionId": "56051155",
        "volume": 7,
        "price": 3221.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53087671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33.265",
        "brokerTime": "2025-05-14 14:57:33.265",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051157",
        "positionId": "56051157",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53087672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33.265",
        "brokerTime": "2025-05-14 14:57:33.543",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051158",
        "positionId": "56051157",
        "volume": 7,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -77,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53087673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33.924",
        "brokerTime": "2025-05-14 14:57:33.924",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051159",
        "positionId": "56051159",
        "volume": 7,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.32,
        "doubleCheck": true
    },
    {
        "id": "53087674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:33.924",
        "brokerTime": "2025-05-14 14:57:34.321",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051160",
        "positionId": "56051159",
        "volume": 7,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3221.32,
        "doubleCheck": true
    },
    {
        "id": "53087675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:34.555",
        "brokerTime": "2025-05-14 14:57:34.555",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051161",
        "positionId": "56051161",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53087676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:34.555",
        "brokerTime": "2025-05-14 14:57:34.932",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051162",
        "positionId": "56051161",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53087677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35.294",
        "brokerTime": "2025-05-14 14:57:35.294",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051163",
        "positionId": "56051163",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53087678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:35.294",
        "brokerTime": "2025-05-14 14:57:35.960",
        "commission": -49,
        "swap": 0,
        "profit": 42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051164",
        "positionId": "56051163",
        "volume": 7,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53087679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:36.477",
        "brokerTime": "2025-05-14 14:57:36.477",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051165",
        "positionId": "56051165",
        "volume": 7,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53087680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:36.477",
        "brokerTime": "2025-05-14 14:57:36.836",
        "commission": -49,
        "swap": 0,
        "profit": -322,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051166",
        "positionId": "56051165",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -371,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53087681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:37.166",
        "brokerTime": "2025-05-14 14:57:37.166",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051167",
        "positionId": "56051167",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53087682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:37.166",
        "brokerTime": "2025-05-14 14:57:38.088",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051168",
        "positionId": "56051167",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53087683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:38.353",
        "brokerTime": "2025-05-14 14:57:38.353",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051169",
        "positionId": "56051169",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53087684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:38.353",
        "brokerTime": "2025-05-14 14:57:38.877",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051170",
        "positionId": "56051169",
        "volume": 7,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53087685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:39.220",
        "brokerTime": "2025-05-14 14:57:39.220",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051171",
        "positionId": "56051171",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53087722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:39.220",
        "brokerTime": "2025-05-14 14:57:39.886",
        "commission": -49,
        "swap": 0,
        "profit": -791,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051208",
        "positionId": "56051171",
        "volume": 7,
        "price": 3222.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -840,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53087725",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:40.705",
        "brokerTime": "2025-05-14 14:57:40.705",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051211",
        "positionId": "56051211",
        "volume": 7,
        "price": 3222.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.52,
        "doubleCheck": true
    },
    {
        "id": "53087786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:40.705",
        "brokerTime": "2025-05-14 14:57:41.189",
        "commission": -49,
        "swap": 0,
        "profit": -252,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051276",
        "positionId": "56051211",
        "volume": 7,
        "price": 3222.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -301,
        "takeProfit": null,
        "priceIn": 3222.52,
        "doubleCheck": true
    },
    {
        "id": "53087810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41.479",
        "brokerTime": "2025-05-14 14:57:41.479",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051287",
        "positionId": "56051287",
        "volume": 7,
        "price": 3222.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.62,
        "doubleCheck": true
    },
    {
        "id": "53087817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:41.479",
        "brokerTime": "2025-05-14 14:57:41.790",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051294",
        "positionId": "56051287",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -238,
        "takeProfit": null,
        "priceIn": 3222.62,
        "doubleCheck": true
    },
    {
        "id": "53087824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:42.594",
        "brokerTime": "2025-05-14 14:57:42.594",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051299",
        "positionId": "56051299",
        "volume": 7,
        "price": 3222.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.74,
        "doubleCheck": true
    },
    {
        "id": "53087826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:42.594",
        "brokerTime": "2025-05-14 14:57:43.482",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051301",
        "positionId": "56051299",
        "volume": 7,
        "price": 3222.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3222.74,
        "doubleCheck": true
    },
    {
        "id": "53087827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:43.753",
        "brokerTime": "2025-05-14 14:57:43.753",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051302",
        "positionId": "56051302",
        "volume": 7,
        "price": 3222.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "id": "53087828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:43.753",
        "brokerTime": "2025-05-14 14:57:44.094",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051303",
        "positionId": "56051302",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "id": "53087829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:44.626",
        "brokerTime": "2025-05-14 14:57:44.626",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051304",
        "positionId": "56051304",
        "volume": 7,
        "price": 3222.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "id": "53087830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:44.626",
        "brokerTime": "2025-05-14 14:57:45.115",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051305",
        "positionId": "56051304",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "id": "53087831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45.486",
        "brokerTime": "2025-05-14 14:57:45.486",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051306",
        "positionId": "56051306",
        "volume": 7,
        "price": 3222.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "id": "53087865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:45.486",
        "brokerTime": "2025-05-14 14:57:46.049",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051340",
        "positionId": "56051306",
        "volume": 7,
        "price": 3222.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3222.71,
        "doubleCheck": true
    },
    {
        "id": "53087872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:46.515",
        "brokerTime": "2025-05-14 14:57:46.515",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051341",
        "positionId": "56051341",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.66,
        "doubleCheck": true
    },
    {
        "id": "53087873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:46.515",
        "brokerTime": "2025-05-14 14:57:46.927",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051342",
        "positionId": "56051341",
        "volume": 7,
        "price": 3222.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3222.66,
        "doubleCheck": true
    },
    {
        "id": "53087874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47.072",
        "brokerTime": "2025-05-14 14:57:47.072",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051343",
        "positionId": "56051343",
        "volume": 7,
        "price": 3222.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "id": "53087875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:47.072",
        "brokerTime": "2025-05-14 14:57:47.911",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051344",
        "positionId": "56051343",
        "volume": 7,
        "price": 3222.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3222.69,
        "doubleCheck": true
    },
    {
        "id": "53087876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:48.256",
        "brokerTime": "2025-05-14 14:57:48.256",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051345",
        "positionId": "56051345",
        "volume": 7,
        "price": 3222.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.61,
        "doubleCheck": true
    },
    {
        "id": "53087877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:48.256",
        "brokerTime": "2025-05-14 14:57:48.912",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051346",
        "positionId": "56051345",
        "volume": 7,
        "price": 3222.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3222.61,
        "doubleCheck": true
    },
    {
        "id": "53087878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:49.635",
        "brokerTime": "2025-05-14 14:57:49.635",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051347",
        "positionId": "56051347",
        "volume": 7,
        "price": 3222.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.33,
        "doubleCheck": true
    },
    {
        "id": "53087896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:49.635",
        "brokerTime": "2025-05-14 14:57:50.030",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051365",
        "positionId": "56051347",
        "volume": 7,
        "price": 3222.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231,
        "takeProfit": null,
        "priceIn": 3222.33,
        "doubleCheck": true
    },
    {
        "id": "53087898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50.302",
        "brokerTime": "2025-05-14 14:57:50.302",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051366",
        "positionId": "56051366",
        "volume": 7,
        "price": 3222.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.39,
        "doubleCheck": true
    },
    {
        "id": "53087917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:50.302",
        "brokerTime": "2025-05-14 14:57:51.209",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051384",
        "positionId": "56051366",
        "volume": 7,
        "price": 3222.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3222.39,
        "doubleCheck": true
    },
    {
        "id": "53087919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:51.772",
        "brokerTime": "2025-05-14 14:57:51.772",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051385",
        "positionId": "56051385",
        "volume": 7,
        "price": 3222.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "id": "53087920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:51.772",
        "brokerTime": "2025-05-14 14:57:52.165",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051386",
        "positionId": "56051385",
        "volume": 7,
        "price": 3222.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "id": "53087921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52.396",
        "brokerTime": "2025-05-14 14:57:52.396",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051387",
        "positionId": "56051387",
        "volume": 7,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53087922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:52.396",
        "brokerTime": "2025-05-14 14:57:52.867",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051388",
        "positionId": "56051387",
        "volume": 7,
        "price": 3222.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53087923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:53.185",
        "brokerTime": "2025-05-14 14:57:53.185",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051389",
        "positionId": "56051389",
        "volume": 7,
        "price": 3222.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "id": "53087924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:53.185",
        "brokerTime": "2025-05-14 14:57:54.741",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051390",
        "positionId": "56051389",
        "volume": 7,
        "price": 3222.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3222.5,
        "doubleCheck": true
    },
    {
        "id": "53087925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:54.923",
        "brokerTime": "2025-05-14 14:57:54.923",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051391",
        "positionId": "56051391",
        "volume": 7,
        "price": 3222.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "id": "53087926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:54.923",
        "brokerTime": "2025-05-14 14:57:55.538",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051392",
        "positionId": "56051391",
        "volume": 7,
        "price": 3222.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "id": "53087927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:55.775",
        "brokerTime": "2025-05-14 14:57:55.775",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051393",
        "positionId": "56051393",
        "volume": 7,
        "price": 3222.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.34,
        "doubleCheck": true
    },
    {
        "id": "53087928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:55.775",
        "brokerTime": "2025-05-14 14:57:56.197",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051394",
        "positionId": "56051393",
        "volume": 7,
        "price": 3222.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3222.34,
        "doubleCheck": true
    },
    {
        "id": "53087929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:56.633",
        "brokerTime": "2025-05-14 14:57:56.633",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051395",
        "positionId": "56051395",
        "volume": 7,
        "price": 3222.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "id": "53087930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:56.633",
        "brokerTime": "2025-05-14 14:57:57.198",
        "commission": -49,
        "swap": 0,
        "profit": -294,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051396",
        "positionId": "56051395",
        "volume": 7,
        "price": 3222.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -343,
        "takeProfit": null,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "id": "53087931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:57.633",
        "brokerTime": "2025-05-14 14:57:57.633",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051397",
        "positionId": "56051397",
        "volume": 7,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53087932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:57.633",
        "brokerTime": "2025-05-14 14:57:58.092",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051398",
        "positionId": "56051397",
        "volume": 7,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53087933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58.379",
        "brokerTime": "2025-05-14 14:57:58.379",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051399",
        "positionId": "56051399",
        "volume": 7,
        "price": 3222.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.35,
        "doubleCheck": true
    },
    {
        "id": "53087934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:58.379",
        "brokerTime": "2025-05-14 14:57:58.755",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051400",
        "positionId": "56051399",
        "volume": 7,
        "price": 3222.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3222.35,
        "doubleCheck": true
    },
    {
        "id": "53087935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:59.149",
        "brokerTime": "2025-05-14 14:57:59.149",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051401",
        "positionId": "56051401",
        "volume": 7,
        "price": 3222.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "id": "53087936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:57:59.149",
        "brokerTime": "2025-05-14 14:57:59.653",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051402",
        "positionId": "56051401",
        "volume": 7,
        "price": 3222.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3222.32,
        "doubleCheck": true
    },
    {
        "id": "53087938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:00.218",
        "brokerTime": "2025-05-14 14:58:00.218",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051404",
        "positionId": "56051404",
        "volume": 7,
        "price": 3222.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.4,
        "doubleCheck": true
    },
    {
        "id": "53087939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:00.218",
        "brokerTime": "2025-05-14 14:58:00.980",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051405",
        "positionId": "56051404",
        "volume": 7,
        "price": 3222.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3222.4,
        "doubleCheck": true
    },
    {
        "id": "53087945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:01.362",
        "brokerTime": "2025-05-14 14:58:01.362",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051411",
        "positionId": "56051411",
        "volume": 7,
        "price": 3222.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.3,
        "doubleCheck": true
    },
    {
        "id": "53088004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:01.362",
        "brokerTime": "2025-05-14 14:58:01.973",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051480",
        "positionId": "56051411",
        "volume": 7,
        "price": 3222.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231,
        "takeProfit": null,
        "priceIn": 3222.3,
        "doubleCheck": true
    },
    {
        "id": "53088115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:02.252",
        "brokerTime": "2025-05-14 14:58:02.252",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051538",
        "positionId": "56051538",
        "volume": 7,
        "price": 3222.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.25,
        "doubleCheck": true
    },
    {
        "id": "53088141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:02.252",
        "brokerTime": "2025-05-14 14:58:03.221",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051541",
        "positionId": "56051538",
        "volume": 7,
        "price": 3222.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3222.25,
        "doubleCheck": true
    },
    {
        "id": "53088142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:03.503",
        "brokerTime": "2025-05-14 14:58:03.503",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051542",
        "positionId": "56051542",
        "volume": 7,
        "price": 3222.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "id": "53088146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:03.503",
        "brokerTime": "2025-05-14 14:58:04.150",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051545",
        "positionId": "56051542",
        "volume": 7,
        "price": 3222.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3222.23,
        "doubleCheck": true
    },
    {
        "id": "53088147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:04.532",
        "brokerTime": "2025-05-14 14:58:04.532",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051546",
        "positionId": "56051546",
        "volume": 7,
        "price": 3222.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.1,
        "doubleCheck": true
    },
    {
        "id": "53088148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:04.532",
        "brokerTime": "2025-05-14 14:58:04.956",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051547",
        "positionId": "56051546",
        "volume": 7,
        "price": 3222.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3222.1,
        "doubleCheck": true
    },
    {
        "id": "53088149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05.217",
        "brokerTime": "2025-05-14 14:58:05.217",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051548",
        "positionId": "56051548",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3222.03,
        "doubleCheck": true
    },
    {
        "id": "53088150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05.217",
        "brokerTime": "2025-05-14 14:58:05.602",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051549",
        "positionId": "56051548",
        "volume": 7,
        "price": 3222.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3222.03,
        "doubleCheck": true
    },
    {
        "id": "53088151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05.832",
        "brokerTime": "2025-05-14 14:58:05.832",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051550",
        "positionId": "56051550",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53088152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:05.832",
        "brokerTime": "2025-05-14 14:58:06.542",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051551",
        "positionId": "56051550",
        "volume": 7,
        "price": 3222.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53088153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:06.734",
        "brokerTime": "2025-05-14 14:58:06.734",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051552",
        "positionId": "56051552",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53088154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:06.734",
        "brokerTime": "2025-05-14 14:58:07.455",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051553",
        "positionId": "56051552",
        "volume": 7,
        "price": 3222.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53088155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:07.913",
        "brokerTime": "2025-05-14 14:58:07.913",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051554",
        "positionId": "56051554",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "id": "53088156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:07.913",
        "brokerTime": "2025-05-14 14:58:08.399",
        "commission": -49,
        "swap": 0,
        "profit": -203,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051555",
        "positionId": "56051554",
        "volume": 7,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -252,
        "takeProfit": null,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "id": "53088158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:08.980",
        "brokerTime": "2025-05-14 14:58:08.980",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051557",
        "positionId": "56051557",
        "volume": 7,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "id": "53088159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:08.980",
        "brokerTime": "2025-05-14 14:58:10.271",
        "commission": -49,
        "swap": 0,
        "profit": 14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051558",
        "positionId": "56051557",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -35,
        "takeProfit": null,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "id": "53088160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:10.495",
        "brokerTime": "2025-05-14 14:58:10.495",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051559",
        "positionId": "56051559",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:10.495",
        "brokerTime": "2025-05-14 14:58:11.025",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051560",
        "positionId": "56051559",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:11.296",
        "brokerTime": "2025-05-14 14:58:11.296",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051561",
        "positionId": "56051561",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:11.296",
        "brokerTime": "2025-05-14 14:58:11.650",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051562",
        "positionId": "56051561",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12.003",
        "brokerTime": "2025-05-14 14:58:12.003",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051563",
        "positionId": "56051563",
        "volume": 7,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53088165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12.003",
        "brokerTime": "2025-05-14 14:58:12.468",
        "commission": -49,
        "swap": 0,
        "profit": -259,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051564",
        "positionId": "56051563",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53088166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12.889",
        "brokerTime": "2025-05-14 14:58:12.889",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051565",
        "positionId": "56051565",
        "volume": 7,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53088167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:12.889",
        "brokerTime": "2025-05-14 14:58:13.703",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051566",
        "positionId": "56051565",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53088168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:14.028",
        "brokerTime": "2025-05-14 14:58:14.028",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051567",
        "positionId": "56051567",
        "volume": 7,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "id": "53088170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:14.028",
        "brokerTime": "2025-05-14 14:58:14.980",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051569",
        "positionId": "56051567",
        "volume": 7,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "id": "53088171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:15.355",
        "brokerTime": "2025-05-14 14:58:15.355",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051570",
        "positionId": "56051570",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:15.355",
        "brokerTime": "2025-05-14 14:58:15.957",
        "commission": -49,
        "swap": 0,
        "profit": -217,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051571",
        "positionId": "56051570",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -266,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16.176",
        "brokerTime": "2025-05-14 14:58:16.176",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051572",
        "positionId": "56051572",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53088174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16.176",
        "brokerTime": "2025-05-14 14:58:16.746",
        "commission": -49,
        "swap": 0,
        "profit": 105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051573",
        "positionId": "56051572",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 56,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53088175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16.899",
        "brokerTime": "2025-05-14 14:58:16.899",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051574",
        "positionId": "56051574",
        "volume": 7,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53088176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:16.899",
        "brokerTime": "2025-05-14 14:58:17.642",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051575",
        "positionId": "56051574",
        "volume": 7,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53088177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:17.972",
        "brokerTime": "2025-05-14 14:58:17.972",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051576",
        "positionId": "56051576",
        "volume": 7,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "id": "53088178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:17.972",
        "brokerTime": "2025-05-14 14:58:18.425",
        "commission": -49,
        "swap": 0,
        "profit": -518,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051577",
        "positionId": "56051576",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -567,
        "takeProfit": null,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "id": "53088179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:18.857",
        "brokerTime": "2025-05-14 14:58:18.857",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051578",
        "positionId": "56051578",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:18.857",
        "brokerTime": "2025-05-14 14:58:19.400",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051579",
        "positionId": "56051578",
        "volume": 7,
        "price": 3222,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:19.597",
        "brokerTime": "2025-05-14 14:58:19.597",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051580",
        "positionId": "56051580",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53088182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:19.597",
        "brokerTime": "2025-05-14 14:58:19.887",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051581",
        "positionId": "56051580",
        "volume": 7,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53088183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20.266",
        "brokerTime": "2025-05-14 14:58:20.266",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051582",
        "positionId": "56051582",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:20.266",
        "brokerTime": "2025-05-14 14:58:20.747",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051583",
        "positionId": "56051582",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:21.110",
        "brokerTime": "2025-05-14 14:58:21.110",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051585",
        "positionId": "56051585",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53088187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:21.110",
        "brokerTime": "2025-05-14 14:58:21.776",
        "commission": -49,
        "swap": 0,
        "profit": -231,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051586",
        "positionId": "56051585",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -280,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53088188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:22.119",
        "brokerTime": "2025-05-14 14:58:22.119",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051587",
        "positionId": "56051587",
        "volume": 7,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53088189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:22.119",
        "brokerTime": "2025-05-14 14:58:22.811",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051588",
        "positionId": "56051587",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53088190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:23.121",
        "brokerTime": "2025-05-14 14:58:23.121",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051589",
        "positionId": "56051589",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53088191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:23.121",
        "brokerTime": "2025-05-14 14:58:24.041",
        "commission": -49,
        "swap": 0,
        "profit": -280,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051591",
        "positionId": "56051589",
        "volume": 7,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -329,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53088192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:24.628",
        "brokerTime": "2025-05-14 14:58:24.628",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051592",
        "positionId": "56051592",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "id": "53088193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:24.628",
        "brokerTime": "2025-05-14 14:58:25.183",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051593",
        "positionId": "56051592",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3221.82,
        "doubleCheck": true
    },
    {
        "id": "53088194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:25.752",
        "brokerTime": "2025-05-14 14:58:25.752",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051594",
        "positionId": "56051594",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53088195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:25.752",
        "brokerTime": "2025-05-14 14:58:26.053",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051595",
        "positionId": "56051594",
        "volume": 7,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53088196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26.248",
        "brokerTime": "2025-05-14 14:58:26.248",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051596",
        "positionId": "56051596",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:26.248",
        "brokerTime": "2025-05-14 14:58:26.606",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051597",
        "positionId": "56051596",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27.050",
        "brokerTime": "2025-05-14 14:58:27.050",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051598",
        "positionId": "56051598",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27.050",
        "brokerTime": "2025-05-14 14:58:27.764",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051599",
        "positionId": "56051598",
        "volume": 7,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27.974",
        "brokerTime": "2025-05-14 14:58:27.974",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051600",
        "positionId": "56051600",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:27.974",
        "brokerTime": "2025-05-14 14:58:29.468",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051601",
        "positionId": "56051600",
        "volume": 7,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:29.762",
        "brokerTime": "2025-05-14 14:58:29.762",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051602",
        "positionId": "56051602",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53088203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:29.762",
        "brokerTime": "2025-05-14 14:58:30.122",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051603",
        "positionId": "56051602",
        "volume": 7,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53088204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30.398",
        "brokerTime": "2025-05-14 14:58:30.398",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051604",
        "positionId": "56051604",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53088205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:30.398",
        "brokerTime": "2025-05-14 14:58:30.897",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051605",
        "positionId": "56051604",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53088206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31.189",
        "brokerTime": "2025-05-14 14:58:31.189",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051606",
        "positionId": "56051606",
        "volume": 7,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53088207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31.189",
        "brokerTime": "2025-05-14 14:58:31.720",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051607",
        "positionId": "56051606",
        "volume": 7,
        "price": 3221.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -238,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53088208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31.986",
        "brokerTime": "2025-05-14 14:58:31.986",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051608",
        "positionId": "56051608",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:31.986",
        "brokerTime": "2025-05-14 14:58:32.643",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051609",
        "positionId": "56051608",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:32.895",
        "brokerTime": "2025-05-14 14:58:32.895",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051610",
        "positionId": "56051610",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:32.895",
        "brokerTime": "2025-05-14 14:58:33.302",
        "commission": -49,
        "swap": 0,
        "profit": -231,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051611",
        "positionId": "56051610",
        "volume": 7,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -280,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:33.925",
        "brokerTime": "2025-05-14 14:58:33.925",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051612",
        "positionId": "56051612",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:33.925",
        "brokerTime": "2025-05-14 14:58:34.286",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051613",
        "positionId": "56051612",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:34.745",
        "brokerTime": "2025-05-14 14:58:34.745",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051615",
        "positionId": "56051615",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:34.745",
        "brokerTime": "2025-05-14 14:58:35.775",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051616",
        "positionId": "56051615",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:36.180",
        "brokerTime": "2025-05-14 14:58:36.180",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051617",
        "positionId": "56051617",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "id": "53088219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:36.180",
        "brokerTime": "2025-05-14 14:58:38.780",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051618",
        "positionId": "56051617",
        "volume": 7,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3221.85,
        "doubleCheck": true
    },
    {
        "id": "53088220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39.195",
        "brokerTime": "2025-05-14 14:58:39.195",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051619",
        "positionId": "56051619",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53088221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39.195",
        "brokerTime": "2025-05-14 14:58:39.596",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051620",
        "positionId": "56051619",
        "volume": 7,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53088222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39.850",
        "brokerTime": "2025-05-14 14:58:39.850",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051621",
        "positionId": "56051621",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:39.850",
        "brokerTime": "2025-05-14 14:58:40.811",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051622",
        "positionId": "56051621",
        "volume": 7,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:41.195",
        "brokerTime": "2025-05-14 14:58:41.195",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051623",
        "positionId": "56051623",
        "volume": 7,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:41.195",
        "brokerTime": "2025-05-14 14:58:41.822",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051624",
        "positionId": "56051623",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3221.75,
        "doubleCheck": true
    },
    {
        "id": "53088226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42.246",
        "brokerTime": "2025-05-14 14:58:42.246",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051625",
        "positionId": "56051625",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53088227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42.246",
        "brokerTime": "2025-05-14 14:58:42.624",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051626",
        "positionId": "56051625",
        "volume": 7,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53088228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42.894",
        "brokerTime": "2025-05-14 14:58:42.894",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051627",
        "positionId": "56051627",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:42.894",
        "brokerTime": "2025-05-14 14:58:44.038",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051628",
        "positionId": "56051627",
        "volume": 7,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53088230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:44.203",
        "brokerTime": "2025-05-14 14:58:44.203",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051629",
        "positionId": "56051629",
        "volume": 7,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53088231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:44.203",
        "brokerTime": "2025-05-14 14:58:45.014",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051630",
        "positionId": "56051629",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53088233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:45.200",
        "brokerTime": "2025-05-14 14:58:45.200",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051632",
        "positionId": "56051632",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:45.200",
        "brokerTime": "2025-05-14 14:58:45.785",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051634",
        "positionId": "56051632",
        "volume": 7,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:46.394",
        "brokerTime": "2025-05-14 14:58:46.394",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051635",
        "positionId": "56051635",
        "volume": 7,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53088237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:46.394",
        "brokerTime": "2025-05-14 14:58:46.889",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051636",
        "positionId": "56051635",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53088238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:47.315",
        "brokerTime": "2025-05-14 14:58:47.315",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051637",
        "positionId": "56051637",
        "volume": 7,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53088239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:47.315",
        "brokerTime": "2025-05-14 14:58:47.785",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051638",
        "positionId": "56051637",
        "volume": 7,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53088240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48.089",
        "brokerTime": "2025-05-14 14:58:48.089",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051639",
        "positionId": "56051639",
        "volume": 7,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53088241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48.089",
        "brokerTime": "2025-05-14 14:58:48.507",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051640",
        "positionId": "56051639",
        "volume": 7,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53088242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48.859",
        "brokerTime": "2025-05-14 14:58:48.859",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051641",
        "positionId": "56051641",
        "volume": 7,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53088243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:48.859",
        "brokerTime": "2025-05-14 14:58:49.330",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051642",
        "positionId": "56051641",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53088244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:49.702",
        "brokerTime": "2025-05-14 14:58:49.702",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051643",
        "positionId": "56051643",
        "volume": 7,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:49.702",
        "brokerTime": "2025-05-14 14:58:50.430",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051644",
        "positionId": "56051643",
        "volume": 7,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53088246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51.152",
        "brokerTime": "2025-05-14 14:58:51.152",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051645",
        "positionId": "56051645",
        "volume": 7,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53088247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51.152",
        "brokerTime": "2025-05-14 14:58:51.528",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051646",
        "positionId": "56051645",
        "volume": 7,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53088248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51.672",
        "brokerTime": "2025-05-14 14:58:51.672",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051647",
        "positionId": "56051647",
        "volume": 7,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:51.672",
        "brokerTime": "2025-05-14 14:58:52.296",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051648",
        "positionId": "56051647",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53088250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:52.952",
        "brokerTime": "2025-05-14 14:58:52.952",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051649",
        "positionId": "56051649",
        "volume": 7,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53088251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:52.952",
        "brokerTime": "2025-05-14 14:58:54.562",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051650",
        "positionId": "56051649",
        "volume": 7,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53088252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:55.011",
        "brokerTime": "2025-05-14 14:58:55.011",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051651",
        "positionId": "56051651",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53088253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:55.011",
        "brokerTime": "2025-05-14 14:58:55.712",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051652",
        "positionId": "56051651",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53088254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:56.263",
        "brokerTime": "2025-05-14 14:58:56.263",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051653",
        "positionId": "56051653",
        "volume": 7,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53088255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:56.263",
        "brokerTime": "2025-05-14 14:58:56.853",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051654",
        "positionId": "56051653",
        "volume": 7,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53088256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:57.040",
        "brokerTime": "2025-05-14 14:58:57.040",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051655",
        "positionId": "56051655",
        "volume": 7,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:57.040",
        "brokerTime": "2025-05-14 14:58:57.705",
        "commission": -49,
        "swap": 0,
        "profit": -189,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051656",
        "positionId": "56051655",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -238,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53088258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58.033",
        "brokerTime": "2025-05-14 14:58:58.033",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051657",
        "positionId": "56051657",
        "volume": 7,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53088260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58.033",
        "brokerTime": "2025-05-14 14:58:58.565",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051659",
        "positionId": "56051657",
        "volume": 7,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53088261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58.972",
        "brokerTime": "2025-05-14 14:58:58.972",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051660",
        "positionId": "56051660",
        "volume": 7,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53088262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:58.972",
        "brokerTime": "2025-05-14 14:58:59.626",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051661",
        "positionId": "56051660",
        "volume": 7,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53088263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:59.864",
        "brokerTime": "2025-05-14 14:58:59.864",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051662",
        "positionId": "56051662",
        "volume": 7,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:58:59.864",
        "brokerTime": "2025-05-14 14:59:00.722",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051677",
        "positionId": "56051662",
        "volume": 7,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53088280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:00.928",
        "brokerTime": "2025-05-14 14:59:00.928",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051679",
        "positionId": "56051679",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53088283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:00.928",
        "brokerTime": "2025-05-14 14:59:01.319",
        "commission": -49,
        "swap": 0,
        "profit": -210,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051680",
        "positionId": "56051679",
        "volume": 7,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53088395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02.041",
        "brokerTime": "2025-05-14 14:59:02.041",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051745",
        "positionId": "56051745",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53088413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02.041",
        "brokerTime": "2025-05-14 14:59:02.574",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051755",
        "positionId": "56051745",
        "volume": 7,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53088415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02.809",
        "brokerTime": "2025-05-14 14:59:02.809",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051757",
        "positionId": "56051757",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53088417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:02.809",
        "brokerTime": "2025-05-14 14:59:03.538",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051759",
        "positionId": "56051757",
        "volume": 7,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53088418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:03.835",
        "brokerTime": "2025-05-14 14:59:03.835",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051760",
        "positionId": "56051760",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53088419",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:03.835",
        "brokerTime": "2025-05-14 14:59:04.399",
        "commission": -49,
        "swap": 0,
        "profit": -7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051761",
        "positionId": "56051760",
        "volume": 7,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53088420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:04.661",
        "brokerTime": "2025-05-14 14:59:04.661",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051762",
        "positionId": "56051762",
        "volume": 7,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53088421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:04.661",
        "brokerTime": "2025-05-14 14:59:05.630",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051763",
        "positionId": "56051762",
        "volume": 7,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53088422",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:05.884",
        "brokerTime": "2025-05-14 14:59:05.884",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051764",
        "positionId": "56051764",
        "volume": 7,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53088423",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:05.884",
        "brokerTime": "2025-05-14 14:59:06.512",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051765",
        "positionId": "56051764",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53088424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:07.203",
        "brokerTime": "2025-05-14 14:59:07.203",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051766",
        "positionId": "56051766",
        "volume": 7,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53088425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:07.203",
        "brokerTime": "2025-05-14 14:59:07.844",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051767",
        "positionId": "56051766",
        "volume": 7,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53088426",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:08.534",
        "brokerTime": "2025-05-14 14:59:08.534",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051768",
        "positionId": "56051768",
        "volume": 7,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "id": "53088427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:08.534",
        "brokerTime": "2025-05-14 14:59:08.947",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051769",
        "positionId": "56051768",
        "volume": 7,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "id": "53088428",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09.363",
        "brokerTime": "2025-05-14 14:59:09.363",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051770",
        "positionId": "56051770",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53088429",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:09.363",
        "brokerTime": "2025-05-14 14:59:10.137",
        "commission": -49,
        "swap": 0,
        "profit": -364,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051771",
        "positionId": "56051770",
        "volume": 7,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -413,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53088430",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:10.530",
        "brokerTime": "2025-05-14 14:59:10.530",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051772",
        "positionId": "56051772",
        "volume": 7,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:10.530",
        "brokerTime": "2025-05-14 14:59:11.076",
        "commission": -49,
        "swap": 0,
        "profit": -49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051773",
        "positionId": "56051772",
        "volume": 7,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -98,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53088432",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11.295",
        "brokerTime": "2025-05-14 14:59:11.295",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051774",
        "positionId": "56051774",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53088433",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:11.295",
        "brokerTime": "2025-05-14 14:59:11.634",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051775",
        "positionId": "56051774",
        "volume": 7,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53088434",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12.030",
        "brokerTime": "2025-05-14 14:59:12.030",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051776",
        "positionId": "56051776",
        "volume": 7,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53088435",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12.030",
        "brokerTime": "2025-05-14 14:59:12.441",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051777",
        "positionId": "56051776",
        "volume": 7,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53088436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12.800",
        "brokerTime": "2025-05-14 14:59:12.800",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051778",
        "positionId": "56051778",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53088437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:12.800",
        "brokerTime": "2025-05-14 14:59:13.385",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051779",
        "positionId": "56051778",
        "volume": 7,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53088439",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:13.848",
        "brokerTime": "2025-05-14 14:59:13.848",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051781",
        "positionId": "56051781",
        "volume": 7,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53088441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:13.848",
        "brokerTime": "2025-05-14 14:59:14.652",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051782",
        "positionId": "56051781",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53088442",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:15.042",
        "brokerTime": "2025-05-14 14:59:15.042",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051783",
        "positionId": "56051783",
        "volume": 7,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53088443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:15.042",
        "brokerTime": "2025-05-14 14:59:16.536",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051784",
        "positionId": "56051783",
        "volume": 7,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53088444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:16.865",
        "brokerTime": "2025-05-14 14:59:16.865",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051785",
        "positionId": "56051785",
        "volume": 7,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53088445",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:16.865",
        "brokerTime": "2025-05-14 14:59:17.516",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051786",
        "positionId": "56051785",
        "volume": 7,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53088446",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:17.711",
        "brokerTime": "2025-05-14 14:59:17.711",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051787",
        "positionId": "56051787",
        "volume": 7,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53088447",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:17.711",
        "brokerTime": "2025-05-14 14:59:18.267",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051788",
        "positionId": "56051787",
        "volume": 7,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53088448",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:19.125",
        "brokerTime": "2025-05-14 14:59:19.125",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051789",
        "positionId": "56051789",
        "volume": 7,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "id": "53088449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:19.125",
        "brokerTime": "2025-05-14 14:59:19.715",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051790",
        "positionId": "56051789",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3221.29,
        "doubleCheck": true
    },
    {
        "id": "53088450",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20.169",
        "brokerTime": "2025-05-14 14:59:20.169",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051791",
        "positionId": "56051791",
        "volume": 7,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53088451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20.169",
        "brokerTime": "2025-05-14 14:59:20.529",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051792",
        "positionId": "56051791",
        "volume": 7,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53088452",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20.710",
        "brokerTime": "2025-05-14 14:59:20.710",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051793",
        "positionId": "56051793",
        "volume": 7,
        "price": 3221.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.28,
        "doubleCheck": true
    },
    {
        "id": "53088453",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:20.710",
        "brokerTime": "2025-05-14 14:59:21.199",
        "commission": -49,
        "swap": 0,
        "profit": -49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051794",
        "positionId": "56051793",
        "volume": 7,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -98,
        "takeProfit": null,
        "priceIn": 3221.28,
        "doubleCheck": true
    },
    {
        "id": "53088454",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21.420",
        "brokerTime": "2025-05-14 14:59:21.420",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051795",
        "positionId": "56051795",
        "volume": 7,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53088455",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:21.420",
        "brokerTime": "2025-05-14 14:59:21.772",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051796",
        "positionId": "56051795",
        "volume": 7,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53088456",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:22.039",
        "brokerTime": "2025-05-14 14:59:22.039",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051797",
        "positionId": "56051797",
        "volume": 7,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53088457",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:22.039",
        "brokerTime": "2025-05-14 14:59:22.524",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051798",
        "positionId": "56051797",
        "volume": 7,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53088458",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:23.478",
        "brokerTime": "2025-05-14 14:59:23.478",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051799",
        "positionId": "56051799",
        "volume": 7,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.11,
        "doubleCheck": true
    },
    {
        "id": "53088459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:23.478",
        "brokerTime": "2025-05-14 14:59:23.948",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051800",
        "positionId": "56051799",
        "volume": 7,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3221.11,
        "doubleCheck": true
    },
    {
        "id": "53088460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24.180",
        "brokerTime": "2025-05-14 14:59:24.180",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051801",
        "positionId": "56051801",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "id": "53088461",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24.180",
        "brokerTime": "2025-05-14 14:59:24.500",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051802",
        "positionId": "56051801",
        "volume": 7,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "id": "53088462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24.707",
        "brokerTime": "2025-05-14 14:59:24.707",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051803",
        "positionId": "56051803",
        "volume": 7,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53088463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:24.707",
        "brokerTime": "2025-05-14 14:59:25.254",
        "commission": -49,
        "swap": 0,
        "profit": 77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051804",
        "positionId": "56051803",
        "volume": 7,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 28,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53088465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:25.519",
        "brokerTime": "2025-05-14 14:59:25.519",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051806",
        "positionId": "56051806",
        "volume": 7,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53088466",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:25.519",
        "brokerTime": "2025-05-14 14:59:25.943",
        "commission": -49,
        "swap": 0,
        "profit": -273,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051807",
        "positionId": "56051806",
        "volume": 7,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53088467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26.242",
        "brokerTime": "2025-05-14 14:59:26.242",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051808",
        "positionId": "56051808",
        "volume": 7,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53088468",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:26.242",
        "brokerTime": "2025-05-14 14:59:26.843",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051809",
        "positionId": "56051808",
        "volume": 7,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53088469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:27.487",
        "brokerTime": "2025-05-14 14:59:27.487",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051810",
        "positionId": "56051810",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53088470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:27.487",
        "brokerTime": "2025-05-14 14:59:27.929",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051811",
        "positionId": "56051810",
        "volume": 7,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53088471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:28.207",
        "brokerTime": "2025-05-14 14:59:28.207",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051812",
        "positionId": "56051812",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53088472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:28.207",
        "brokerTime": "2025-05-14 14:59:28.583",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051813",
        "positionId": "56051812",
        "volume": 7,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53088474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:29.263",
        "brokerTime": "2025-05-14 14:59:29.263",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051815",
        "positionId": "56051815",
        "volume": 7,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53088475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:29.263",
        "brokerTime": "2025-05-14 14:59:29.577",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051816",
        "positionId": "56051815",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53088476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30.033",
        "brokerTime": "2025-05-14 14:59:30.033",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051817",
        "positionId": "56051817",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "id": "53088477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30.033",
        "brokerTime": "2025-05-14 14:59:30.502",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051818",
        "positionId": "56051817",
        "volume": 7,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "id": "53088479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30.777",
        "brokerTime": "2025-05-14 14:59:30.777",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051820",
        "positionId": "56051820",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53088480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:30.777",
        "brokerTime": "2025-05-14 14:59:31.236",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051821",
        "positionId": "56051820",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53088482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:31.662",
        "brokerTime": "2025-05-14 14:59:31.662",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051823",
        "positionId": "56051823",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "id": "53088485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:31.662",
        "brokerTime": "2025-05-14 14:59:33.084",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051826",
        "positionId": "56051823",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3220.85,
        "doubleCheck": true
    },
    {
        "id": "53088486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:33.473",
        "brokerTime": "2025-05-14 14:59:33.473",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051827",
        "positionId": "56051827",
        "volume": 7,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53088487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:33.473",
        "brokerTime": "2025-05-14 14:59:34.342",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051828",
        "positionId": "56051827",
        "volume": 7,
        "price": 3220.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53088488",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:34.766",
        "brokerTime": "2025-05-14 14:59:34.766",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051829",
        "positionId": "56051829",
        "volume": 7,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "id": "53088489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:34.766",
        "brokerTime": "2025-05-14 14:59:35.378",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051830",
        "positionId": "56051829",
        "volume": 7,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63,
        "takeProfit": null,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "id": "53088490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:35.720",
        "brokerTime": "2025-05-14 14:59:35.720",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051831",
        "positionId": "56051831",
        "volume": 7,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53088491",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:35.720",
        "brokerTime": "2025-05-14 14:59:36.422",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051832",
        "positionId": "56051831",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53088492",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:36.951",
        "brokerTime": "2025-05-14 14:59:36.951",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051833",
        "positionId": "56051833",
        "volume": 7,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53088493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:36.951",
        "brokerTime": "2025-05-14 14:59:37.511",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051834",
        "positionId": "56051833",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53088494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:38.056",
        "brokerTime": "2025-05-14 14:59:38.056",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051835",
        "positionId": "56051835",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53088495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:38.056",
        "brokerTime": "2025-05-14 14:59:39.074",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051836",
        "positionId": "56051835",
        "volume": 7,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53088496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39.416",
        "brokerTime": "2025-05-14 14:59:39.416",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051837",
        "positionId": "56051837",
        "volume": 7,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53088497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39.416",
        "brokerTime": "2025-05-14 14:59:39.775",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051838",
        "positionId": "56051837",
        "volume": 7,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53088498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39.969",
        "brokerTime": "2025-05-14 14:59:39.969",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051839",
        "positionId": "56051839",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53088499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:39.969",
        "brokerTime": "2025-05-14 14:59:40.777",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051840",
        "positionId": "56051839",
        "volume": 7,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53088500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:41.398",
        "brokerTime": "2025-05-14 14:59:41.398",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051841",
        "positionId": "56051841",
        "volume": 7,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.78,
        "doubleCheck": true
    },
    {
        "id": "53088501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:41.398",
        "brokerTime": "2025-05-14 14:59:41.845",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051842",
        "positionId": "56051841",
        "volume": 7,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3220.78,
        "doubleCheck": true
    },
    {
        "id": "53088502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:42.245",
        "brokerTime": "2025-05-14 14:59:42.245",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051843",
        "positionId": "56051843",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53088503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:42.245",
        "brokerTime": "2025-05-14 14:59:42.928",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051844",
        "positionId": "56051843",
        "volume": 7,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53088504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:43.323",
        "brokerTime": "2025-05-14 14:59:43.323",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051845",
        "positionId": "56051845",
        "volume": 7,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53088505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:43.323",
        "brokerTime": "2025-05-14 14:59:43.921",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051846",
        "positionId": "56051845",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53088506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44.038",
        "brokerTime": "2025-05-14 14:59:44.038",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051847",
        "positionId": "56051847",
        "volume": 7,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "id": "53088507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44.038",
        "brokerTime": "2025-05-14 14:59:44.476",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051848",
        "positionId": "56051847",
        "volume": 7,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "id": "53088508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44.774",
        "brokerTime": "2025-05-14 14:59:44.774",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051849",
        "positionId": "56051849",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53088509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:44.774",
        "brokerTime": "2025-05-14 14:59:45.199",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051850",
        "positionId": "56051849",
        "volume": 7,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53088511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:45.533",
        "brokerTime": "2025-05-14 14:59:45.533",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051852",
        "positionId": "56051852",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53088512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:45.533",
        "brokerTime": "2025-05-14 14:59:45.987",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051853",
        "positionId": "56051852",
        "volume": 7,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53088514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46.373",
        "brokerTime": "2025-05-14 14:59:46.373",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051855",
        "positionId": "56051855",
        "volume": 7,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53088516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:46.373",
        "brokerTime": "2025-05-14 14:59:47.525",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051857",
        "positionId": "56051855",
        "volume": 7,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53088518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:47.823",
        "brokerTime": "2025-05-14 14:59:47.823",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051859",
        "positionId": "56051859",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53088519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:47.823",
        "brokerTime": "2025-05-14 14:59:48.194",
        "commission": -49,
        "swap": 0,
        "profit": -196,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051860",
        "positionId": "56051859",
        "volume": 7,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -245,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53088520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:48.851",
        "brokerTime": "2025-05-14 14:59:48.851",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051861",
        "positionId": "56051861",
        "volume": 7,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53088522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:48.851",
        "brokerTime": "2025-05-14 14:59:49.290",
        "commission": -49,
        "swap": 0,
        "profit": 28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051863",
        "positionId": "56051861",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -21,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53088523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:49.774",
        "brokerTime": "2025-05-14 14:59:49.774",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051864",
        "positionId": "56051864",
        "volume": 7,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53088524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:49.774",
        "brokerTime": "2025-05-14 14:59:50.185",
        "commission": -49,
        "swap": 0,
        "profit": -252,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051865",
        "positionId": "56051864",
        "volume": 7,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -301,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53088525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:50.500",
        "brokerTime": "2025-05-14 14:59:50.500",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051866",
        "positionId": "56051866",
        "volume": 7,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53088526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:50.500",
        "brokerTime": "2025-05-14 14:59:51.059",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051867",
        "positionId": "56051866",
        "volume": 7,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53088527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:51.563",
        "brokerTime": "2025-05-14 14:59:51.563",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051868",
        "positionId": "56051868",
        "volume": 7,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53088528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:51.563",
        "brokerTime": "2025-05-14 14:59:51.968",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051869",
        "positionId": "56051868",
        "volume": 7,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53088529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52.111",
        "brokerTime": "2025-05-14 14:59:52.111",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051870",
        "positionId": "56051870",
        "volume": 7,
        "price": 3220.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.5,
        "doubleCheck": true
    },
    {
        "id": "53088530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:52.111",
        "brokerTime": "2025-05-14 14:59:52.576",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051871",
        "positionId": "56051870",
        "volume": 7,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3220.5,
        "doubleCheck": true
    },
    {
        "id": "53088531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:53.018",
        "brokerTime": "2025-05-14 14:59:53.018",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051872",
        "positionId": "56051872",
        "volume": 7,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53088532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:53.018",
        "brokerTime": "2025-05-14 14:59:53.850",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051873",
        "positionId": "56051872",
        "volume": 7,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53088533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:54.509",
        "brokerTime": "2025-05-14 14:59:54.509",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051874",
        "positionId": "56051874",
        "volume": 7,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53088534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:54.509",
        "brokerTime": "2025-05-14 14:59:54.829",
        "commission": -49,
        "swap": 0,
        "profit": -287,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051875",
        "positionId": "56051874",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -336,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53088535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55.220",
        "brokerTime": "2025-05-14 14:59:55.220",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051876",
        "positionId": "56051876",
        "volume": 7,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53088536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:55.220",
        "brokerTime": "2025-05-14 14:59:55.878",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051877",
        "positionId": "56051876",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53088537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:56.178",
        "brokerTime": "2025-05-14 14:59:56.178",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051878",
        "positionId": "56051878",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "id": "53088538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:56.178",
        "brokerTime": "2025-05-14 14:59:56.682",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051879",
        "positionId": "56051878",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "id": "53088539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57.134",
        "brokerTime": "2025-05-14 14:59:57.134",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051880",
        "positionId": "56051880",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53088542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57.134",
        "brokerTime": "2025-05-14 14:59:57.386",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051883",
        "positionId": "56051880",
        "volume": 7,
        "price": 3220.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53088546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57.960",
        "brokerTime": "2025-05-14 14:59:57.960",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051886",
        "positionId": "56051886",
        "volume": 7,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53088547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:57.960",
        "brokerTime": "2025-05-14 14:59:58.367",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051887",
        "positionId": "56051886",
        "volume": 7,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53088548",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:58.611",
        "brokerTime": "2025-05-14 14:59:58.611",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051888",
        "positionId": "56051888",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53088550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:58.611",
        "brokerTime": "2025-05-14 14:59:59.678",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051890",
        "positionId": "56051888",
        "volume": 7,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53088551",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:59.942",
        "brokerTime": "2025-05-14 14:59:59.942",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051891",
        "positionId": "56051891",
        "volume": 7,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53088588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:59:59.942",
        "brokerTime": "2025-05-14 15:00:00.687",
        "commission": -49,
        "swap": 0,
        "profit": -525,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051929",
        "positionId": "56051891",
        "volume": 7,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -574,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53088591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:01.102",
        "brokerTime": "2025-05-14 15:00:01.102",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56051934",
        "positionId": "56051934",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "id": "53088750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:01.102",
        "brokerTime": "2025-05-14 15:00:01.498",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052118",
        "positionId": "56051934",
        "volume": 7,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "id": "53088836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:02.139",
        "brokerTime": "2025-05-14 15:00:02.139",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052161",
        "positionId": "56052161",
        "volume": 7,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "id": "53089341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:02.139",
        "brokerTime": "2025-05-14 15:00:04.495",
        "commission": -49,
        "swap": 0,
        "profit": 280,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052630",
        "positionId": "56052161",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 231,
        "takeProfit": null,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "id": "53089451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:05.307",
        "brokerTime": "2025-05-14 15:00:05.307",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052721",
        "positionId": "56052721",
        "volume": 7,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53089459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:05.307",
        "brokerTime": "2025-05-14 15:00:05.530",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052725",
        "positionId": "56052721",
        "volume": 7,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53089460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:37:23.431",
        "brokerTime": "2025-05-14 15:00:05.602",
        "commission": -0.7,
        "swap": 0,
        "profit": 142.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052728",
        "positionId": "56048550",
        "volume": 0.1,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 141.9,
        "takeProfit": null,
        "priceIn": 3234.54,
        "doubleCheck": false
    },
    {
        "id": "53089465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:12.763",
        "brokerTime": "2025-05-14 15:00:12.763",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052731",
        "positionId": "56052731",
        "volume": 0.1,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "id": "53089467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13.273",
        "brokerTime": "2025-05-14 15:00:13.273",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052732",
        "positionId": "56052732",
        "volume": 7,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53089468",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:13.273",
        "brokerTime": "2025-05-14 15:00:14.053",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052733",
        "positionId": "56052732",
        "volume": 7,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53089469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:14.614",
        "brokerTime": "2025-05-14 15:00:14.614",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052734",
        "positionId": "56052734",
        "volume": 7,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53089470",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:14.614",
        "brokerTime": "2025-05-14 15:00:15.337",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052735",
        "positionId": "56052734",
        "volume": 7,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -77,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53089471",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:15.641",
        "brokerTime": "2025-05-14 15:00:15.641",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052736",
        "positionId": "56052736",
        "volume": 7,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53089472",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:15.641",
        "brokerTime": "2025-05-14 15:00:16.343",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052737",
        "positionId": "56052736",
        "volume": 7,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53089473",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:17.068",
        "brokerTime": "2025-05-14 15:00:17.068",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052738",
        "positionId": "56052738",
        "volume": 7,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53089474",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:17.068",
        "brokerTime": "2025-05-14 15:00:18.163",
        "commission": -49,
        "swap": 0,
        "profit": -105,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052739",
        "positionId": "56052738",
        "volume": 7,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53089475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:18.441",
        "brokerTime": "2025-05-14 15:00:18.441",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052740",
        "positionId": "56052740",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.68,
        "doubleCheck": true
    },
    {
        "id": "53089476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:18.441",
        "brokerTime": "2025-05-14 15:00:19.576",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052741",
        "positionId": "56052740",
        "volume": 7,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3220.68,
        "doubleCheck": true
    },
    {
        "id": "53089477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:19.782",
        "brokerTime": "2025-05-14 15:00:19.782",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052742",
        "positionId": "56052742",
        "volume": 7,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53089478",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:19.782",
        "brokerTime": "2025-05-14 15:00:20.390",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052743",
        "positionId": "56052742",
        "volume": 7,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -350,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53089479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:20.860",
        "brokerTime": "2025-05-14 15:00:20.860",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052744",
        "positionId": "56052744",
        "volume": 7,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53089480",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:20.860",
        "brokerTime": "2025-05-14 15:00:21.479",
        "commission": -49,
        "swap": 0,
        "profit": -70,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052745",
        "positionId": "56052744",
        "volume": 7,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53089481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:21.928",
        "brokerTime": "2025-05-14 15:00:21.928",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052746",
        "positionId": "56052746",
        "volume": 7,
        "price": 3220.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "id": "53089482",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:21.928",
        "brokerTime": "2025-05-14 15:00:22.977",
        "commission": -49,
        "swap": 0,
        "profit": -56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052747",
        "positionId": "56052746",
        "volume": 7,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105,
        "takeProfit": null,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "id": "53089483",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:23.824",
        "brokerTime": "2025-05-14 15:00:23.824",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052748",
        "positionId": "56052748",
        "volume": 7,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53089484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:23.824",
        "brokerTime": "2025-05-14 15:00:24.322",
        "commission": -49,
        "swap": 0,
        "profit": -84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052749",
        "positionId": "56052748",
        "volume": 7,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -133,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53089485",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:24.569",
        "brokerTime": "2025-05-14 15:00:24.569",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052750",
        "positionId": "56052750",
        "volume": 7,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53089486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:24.569",
        "brokerTime": "2025-05-14 15:00:25.095",
        "commission": -49,
        "swap": 0,
        "profit": -14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052751",
        "positionId": "56052750",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53089494",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:25.973",
        "brokerTime": "2025-05-14 15:00:25.973",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052755",
        "positionId": "56052755",
        "volume": 7,
        "price": 3219.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.4,
        "doubleCheck": true
    },
    {
        "id": "53089497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:25.973",
        "brokerTime": "2025-05-14 15:00:26.363",
        "commission": -49,
        "swap": 0,
        "profit": -287,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052756",
        "positionId": "56052755",
        "volume": 7,
        "price": 3219.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -336,
        "takeProfit": null,
        "priceIn": 3219.4,
        "doubleCheck": true
    },
    {
        "id": "53089498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:26.958",
        "brokerTime": "2025-05-14 15:00:26.958",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052757",
        "positionId": "56052757",
        "volume": 7,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53089500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:26.958",
        "brokerTime": "2025-05-14 15:00:27.445",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052759",
        "positionId": "56052757",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53089501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28.003",
        "brokerTime": "2025-05-14 15:00:28.003",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052760",
        "positionId": "56052760",
        "volume": 7,
        "price": 3219.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "id": "53089504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28.003",
        "brokerTime": "2025-05-14 15:00:28.426",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052763",
        "positionId": "56052760",
        "volume": 7,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -350,
        "takeProfit": null,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "id": "53089506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28.682",
        "brokerTime": "2025-05-14 15:00:28.682",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052764",
        "positionId": "56052764",
        "volume": 7,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53089507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:28.682",
        "brokerTime": "2025-05-14 15:00:29.346",
        "commission": -49,
        "swap": 0,
        "profit": -301,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052765",
        "positionId": "56052764",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -350,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53089510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:29.760",
        "brokerTime": "2025-05-14 15:00:29.760",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052768",
        "positionId": "56052768",
        "volume": 7,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53089511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:29.760",
        "brokerTime": "2025-05-14 15:00:30.360",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052769",
        "positionId": "56052768",
        "volume": 7,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53089512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:30.695",
        "brokerTime": "2025-05-14 15:00:30.695",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052770",
        "positionId": "56052770",
        "volume": 7,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53089514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:30.695",
        "brokerTime": "2025-05-14 15:00:31.498",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052772",
        "positionId": "56052770",
        "volume": 7,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53089516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:31.875",
        "brokerTime": "2025-05-14 15:00:31.875",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052773",
        "positionId": "56052773",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "id": "53089517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:31.875",
        "brokerTime": "2025-05-14 15:00:32.280",
        "commission": -49,
        "swap": 0,
        "profit": -168,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052774",
        "positionId": "56052773",
        "volume": 7,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -217,
        "takeProfit": null,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "id": "53089518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:32.664",
        "brokerTime": "2025-05-14 15:00:32.664",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052775",
        "positionId": "56052775",
        "volume": 7,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53089519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:32.664",
        "brokerTime": "2025-05-14 15:00:33.254",
        "commission": -49,
        "swap": 0,
        "profit": -42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052776",
        "positionId": "56052775",
        "volume": 7,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -91,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53089520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:33.585",
        "brokerTime": "2025-05-14 15:00:33.585",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052777",
        "positionId": "56052777",
        "volume": 7,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53089521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:33.585",
        "brokerTime": "2025-05-14 15:00:34.095",
        "commission": -49,
        "swap": 0,
        "profit": -91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052778",
        "positionId": "56052777",
        "volume": 7,
        "price": 3220.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53089522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34.301",
        "brokerTime": "2025-05-14 15:00:34.301",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052779",
        "positionId": "56052779",
        "volume": 7,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53089523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:34.301",
        "brokerTime": "2025-05-14 15:00:34.800",
        "commission": -49,
        "swap": 0,
        "profit": -119,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052780",
        "positionId": "56052779",
        "volume": 7,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -168,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53089524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35.033",
        "brokerTime": "2025-05-14 15:00:35.033",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052781",
        "positionId": "56052781",
        "volume": 7,
        "price": 3219.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.9,
        "doubleCheck": true
    },
    {
        "id": "53089525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35.033",
        "brokerTime": "2025-05-14 15:00:35.679",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052782",
        "positionId": "56052781",
        "volume": 7,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3219.9,
        "doubleCheck": true
    },
    {
        "id": "53089526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35.871",
        "brokerTime": "2025-05-14 15:00:35.871",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052784",
        "positionId": "56052784",
        "volume": 7,
        "price": 3219.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.73,
        "doubleCheck": true
    },
    {
        "id": "53089529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:35.871",
        "brokerTime": "2025-05-14 15:00:36.321",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052785",
        "positionId": "56052784",
        "volume": 7,
        "price": 3219.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3219.73,
        "doubleCheck": true
    },
    {
        "id": "53089530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:36.928",
        "brokerTime": "2025-05-14 15:00:36.928",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052790",
        "positionId": "56052790",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:36.928",
        "brokerTime": "2025-05-14 15:00:37.699",
        "commission": -49,
        "swap": 0,
        "profit": -7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052795",
        "positionId": "56052790",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:38.073",
        "brokerTime": "2025-05-14 15:00:38.073",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052796",
        "positionId": "56052796",
        "volume": 7,
        "price": 3219.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.08,
        "doubleCheck": true
    },
    {
        "id": "53089543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:38.073",
        "brokerTime": "2025-05-14 15:00:39.077",
        "commission": -49,
        "swap": 0,
        "profit": -329,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052799",
        "positionId": "56052796",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378,
        "takeProfit": null,
        "priceIn": 3219.08,
        "doubleCheck": true
    },
    {
        "id": "53089545",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:39.461",
        "brokerTime": "2025-05-14 15:00:39.461",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052813",
        "positionId": "56052813",
        "volume": 7,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.61,
        "doubleCheck": true
    },
    {
        "id": "53089576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:39.461",
        "brokerTime": "2025-05-14 15:00:40.213",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052820",
        "positionId": "56052813",
        "volume": 7,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.61,
        "doubleCheck": true
    },
    {
        "id": "53089577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:40.733",
        "brokerTime": "2025-05-14 15:00:40.733",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052821",
        "positionId": "56052821",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:40.733",
        "brokerTime": "2025-05-14 15:00:41.199",
        "commission": -49,
        "swap": 0,
        "profit": -154,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052822",
        "positionId": "56052821",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -203,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41.470",
        "brokerTime": "2025-05-14 15:00:41.470",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052823",
        "positionId": "56052823",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:41.470",
        "brokerTime": "2025-05-14 15:00:41.924",
        "commission": -49,
        "swap": 0,
        "profit": -98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052824",
        "positionId": "56052823",
        "volume": 7,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -147,
        "takeProfit": null,
        "priceIn": 3219.28,
        "doubleCheck": true
    },
    {
        "id": "53089582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:42.231",
        "brokerTime": "2025-05-14 15:00:42.231",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052826",
        "positionId": "56052826",
        "volume": 7,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "id": "53089585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:42.231",
        "brokerTime": "2025-05-14 15:00:42.750",
        "commission": -49,
        "swap": 0,
        "profit": -35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052829",
        "positionId": "56052826",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84,
        "takeProfit": null,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "id": "53089586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:43.557",
        "brokerTime": "2025-05-14 15:00:43.557",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052830",
        "positionId": "56052830",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53089588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:43.557",
        "brokerTime": "2025-05-14 15:00:43.860",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052832",
        "positionId": "56052830",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53089590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44.099",
        "brokerTime": "2025-05-14 15:00:44.099",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052833",
        "positionId": "56052833",
        "volume": 7,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53089591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44.099",
        "brokerTime": "2025-05-14 15:00:44.510",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052834",
        "positionId": "56052833",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53089592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44.925",
        "brokerTime": "2025-05-14 15:00:44.925",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052835",
        "positionId": "56052835",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:44.925",
        "brokerTime": "2025-05-14 15:00:45.715",
        "commission": -49,
        "swap": 0,
        "profit": 14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052836",
        "positionId": "56052835",
        "volume": 7,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -35,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:46.063",
        "brokerTime": "2025-05-14 15:00:46.063",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052837",
        "positionId": "56052837",
        "volume": 7,
        "price": 3219.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.04,
        "doubleCheck": true
    },
    {
        "id": "53089595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:46.063",
        "brokerTime": "2025-05-14 15:00:46.503",
        "commission": -49,
        "swap": 0,
        "profit": -343,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052838",
        "positionId": "56052837",
        "volume": 7,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -392,
        "takeProfit": null,
        "priceIn": 3219.04,
        "doubleCheck": true
    },
    {
        "id": "53089596",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47.161",
        "brokerTime": "2025-05-14 15:00:47.161",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052839",
        "positionId": "56052839",
        "volume": 7,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53089597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47.161",
        "brokerTime": "2025-05-14 15:00:47.674",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052840",
        "positionId": "56052839",
        "volume": 7,
        "price": 3219.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53089598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47.875",
        "brokerTime": "2025-05-14 15:00:47.875",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052841",
        "positionId": "56052841",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:47.875",
        "brokerTime": "2025-05-14 15:00:48.430",
        "commission": -49,
        "swap": 0,
        "profit": -224,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052842",
        "positionId": "56052841",
        "volume": 7,
        "price": 3219.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:48.900",
        "brokerTime": "2025-05-14 15:00:48.900",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052844",
        "positionId": "56052844",
        "volume": 7,
        "price": 3219.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "id": "53089603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:48.900",
        "brokerTime": "2025-05-14 15:00:49.947",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052845",
        "positionId": "56052844",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "id": "53089604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:50.479",
        "brokerTime": "2025-05-14 15:00:50.479",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052846",
        "positionId": "56052846",
        "volume": 7,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53089605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:50.479",
        "brokerTime": "2025-05-14 15:00:51.003",
        "commission": -49,
        "swap": 0,
        "profit": -133,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052847",
        "positionId": "56052846",
        "volume": 7,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53089606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:51.739",
        "brokerTime": "2025-05-14 15:00:51.739",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052848",
        "positionId": "56052848",
        "volume": 7,
        "price": 3219.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "id": "53089607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:51.739",
        "brokerTime": "2025-05-14 15:00:52.064",
        "commission": -49,
        "swap": 0,
        "profit": -77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052849",
        "positionId": "56052848",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126,
        "takeProfit": null,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "id": "53089608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52.336",
        "brokerTime": "2025-05-14 15:00:52.336",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052850",
        "positionId": "56052850",
        "volume": 7,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53089609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:52.336",
        "brokerTime": "2025-05-14 15:00:52.659",
        "commission": -49,
        "swap": 0,
        "profit": -112,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052851",
        "positionId": "56052850",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53089610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53.026",
        "brokerTime": "2025-05-14 15:00:53.026",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052852",
        "positionId": "56052852",
        "volume": 7,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.14,
        "doubleCheck": true
    },
    {
        "id": "53089611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53.026",
        "brokerTime": "2025-05-14 15:00:53.435",
        "commission": -49,
        "swap": 0,
        "profit": -259,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052853",
        "positionId": "56052852",
        "volume": 7,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308,
        "takeProfit": null,
        "priceIn": 3219.14,
        "doubleCheck": true
    },
    {
        "id": "53089612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53.706",
        "brokerTime": "2025-05-14 15:00:53.706",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052854",
        "positionId": "56052854",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "id": "53089613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:53.706",
        "brokerTime": "2025-05-14 15:00:54.405",
        "commission": -49,
        "swap": 0,
        "profit": -161,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052855",
        "positionId": "56052854",
        "volume": 7,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210,
        "takeProfit": null,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "id": "53089614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:54.925",
        "brokerTime": "2025-05-14 15:00:54.925",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052856",
        "positionId": "56052856",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:54.925",
        "brokerTime": "2025-05-14 15:00:55.662",
        "commission": -49,
        "swap": 0,
        "profit": -245,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052857",
        "positionId": "56052856",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -294,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:56.151",
        "brokerTime": "2025-05-14 15:00:56.151",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052858",
        "positionId": "56052858",
        "volume": 7,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "id": "53089617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:56.151",
        "brokerTime": "2025-05-14 15:00:56.804",
        "commission": -49,
        "swap": 0,
        "profit": -140,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052859",
        "positionId": "56052858",
        "volume": 7,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189,
        "takeProfit": null,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "id": "53089618",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:57.657",
        "brokerTime": "2025-05-14 15:00:57.657",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052860",
        "positionId": "56052860",
        "volume": 7,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53089619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:57.657",
        "brokerTime": "2025-05-14 15:00:57.955",
        "commission": -49,
        "swap": 0,
        "profit": -63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052861",
        "positionId": "56052860",
        "volume": 7,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -112,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53089620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59.149",
        "brokerTime": "2025-05-14 15:00:59.149",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052862",
        "positionId": "56052862",
        "volume": 7,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "id": "53089621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59.149",
        "brokerTime": "2025-05-14 15:00:59.446",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052863",
        "positionId": "56052862",
        "volume": 7,
        "price": 3219.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3219.27,
        "doubleCheck": true
    },
    {
        "id": "53089622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59.950",
        "brokerTime": "2025-05-14 15:00:59.950",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052864",
        "positionId": "56052864",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:59.950",
        "brokerTime": "2025-05-14 15:01:00.541",
        "commission": -49,
        "swap": 0,
        "profit": -147,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052867",
        "positionId": "56052864",
        "volume": 7,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196,
        "takeProfit": null,
        "priceIn": 3219.32,
        "doubleCheck": true
    },
    {
        "id": "53089626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:00.780",
        "brokerTime": "2025-05-14 15:01:00.780",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052868",
        "positionId": "56052868",
        "volume": 7,
        "price": 3219.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "id": "53089627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:00.780",
        "brokerTime": "2025-05-14 15:01:01.173",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052869",
        "positionId": "56052868",
        "volume": 7,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3219.37,
        "doubleCheck": true
    },
    {
        "id": "53089628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:02.064",
        "brokerTime": "2025-05-14 15:01:02.064",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052870",
        "positionId": "56052870",
        "volume": 7,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.25,
        "doubleCheck": true
    },
    {
        "id": "53089632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:02.064",
        "brokerTime": "2025-05-14 15:01:02.380",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052875",
        "positionId": "56052870",
        "volume": 7,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3219.25,
        "doubleCheck": true
    },
    {
        "id": "53089658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:03.082",
        "brokerTime": "2025-05-14 15:01:03.082",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052897",
        "positionId": "56052897",
        "volume": 7,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53089682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:03.082",
        "brokerTime": "2025-05-14 15:01:03.749",
        "commission": -49,
        "swap": 0,
        "profit": -28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052908",
        "positionId": "56052897",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -77,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53089684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:04.011",
        "brokerTime": "2025-05-14 15:01:04.011",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052910",
        "positionId": "56052910",
        "volume": 7,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "id": "53089685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:04.011",
        "brokerTime": "2025-05-14 15:01:04.555",
        "commission": -49,
        "swap": 0,
        "profit": -182,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052911",
        "positionId": "56052910",
        "volume": 7,
        "price": 3219.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231,
        "takeProfit": null,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "id": "53089693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:05.725",
        "brokerTime": "2025-05-14 15:01:05.725",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052916",
        "positionId": "56052916",
        "volume": 7,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53089694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:05.725",
        "brokerTime": "2025-05-14 15:01:06.266",
        "commission": -49,
        "swap": 0,
        "profit": -175,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052917",
        "positionId": "56052916",
        "volume": 7,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -224,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53089695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:06.630",
        "brokerTime": "2025-05-14 15:01:06.630",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052918",
        "positionId": "56052918",
        "volume": 7,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53089699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:06.630",
        "brokerTime": "2025-05-14 15:01:07.002",
        "commission": -49,
        "swap": 0,
        "profit": 189,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052923",
        "positionId": "56052918",
        "volume": 7,
        "price": 3218.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 140,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53089703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:07.657",
        "brokerTime": "2025-05-14 15:01:07.657",
        "commission": -49,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052927",
        "positionId": "56052927",
        "volume": 7,
        "price": 3218.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49,
        "takeProfit": null,
        "priceIn": 3218.63,
        "doubleCheck": true
    },
    {
        "id": "53089705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:07.657",
        "brokerTime": "2025-05-14 15:01:08.076",
        "commission": -49,
        "swap": 0,
        "profit": -126,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052928",
        "positionId": "56052927",
        "volume": 7,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -175,
        "takeProfit": null,
        "priceIn": 3218.63,
        "doubleCheck": true
    },
    {
        "id": "53089706",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:01:08.204",
        "brokerTime": "2025-05-14 15:01:08.204",
        "commission": -8.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052929",
        "positionId": "56052929",
        "volume": 1.28,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3318.71,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.96,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "id": "53089708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:08.998",
        "brokerTime": "2025-05-14 15:01:08.998",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052931",
        "positionId": "56052931",
        "volume": 8.54,
        "price": 3218.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "id": "53089709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:08.998",
        "brokerTime": "2025-05-14 15:01:09.641",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052932",
        "positionId": "56052931",
        "volume": 8.54,
        "price": 3218.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -247.66,
        "takeProfit": null,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "id": "53089710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:10.392",
        "brokerTime": "2025-05-14 15:01:10.392",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052933",
        "positionId": "56052933",
        "volume": 8.54,
        "price": 3218.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "id": "53089711",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:10.392",
        "brokerTime": "2025-05-14 15:01:10.941",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052934",
        "positionId": "56052933",
        "volume": 8.54,
        "price": 3218.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.8,
        "takeProfit": null,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "id": "53089712",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:11.469",
        "brokerTime": "2025-05-14 15:01:11.469",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052935",
        "positionId": "56052935",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089713",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:11.469",
        "brokerTime": "2025-05-14 15:01:11.896",
        "commission": -59.78,
        "swap": 0,
        "profit": -196.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052936",
        "positionId": "56052935",
        "volume": 8.54,
        "price": 3218.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -256.2,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089715",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:12.587",
        "brokerTime": "2025-05-14 15:01:12.587",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052938",
        "positionId": "56052938",
        "volume": 8.54,
        "price": 3218.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "id": "53089716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:12.587",
        "brokerTime": "2025-05-14 15:01:13.031",
        "commission": -59.78,
        "swap": 0,
        "profit": -204.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052939",
        "positionId": "56052938",
        "volume": 8.54,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.74,
        "takeProfit": null,
        "priceIn": 3218.47,
        "doubleCheck": true
    },
    {
        "id": "53089717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13.379",
        "brokerTime": "2025-05-14 15:01:13.379",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052940",
        "positionId": "56052940",
        "volume": 8.54,
        "price": 3218.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.46,
        "doubleCheck": true
    },
    {
        "id": "53089718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:13.379",
        "brokerTime": "2025-05-14 15:01:13.973",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052941",
        "positionId": "56052940",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -230.58,
        "takeProfit": null,
        "priceIn": 3218.46,
        "doubleCheck": true
    },
    {
        "id": "53089719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:14.460",
        "brokerTime": "2025-05-14 15:01:14.460",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052942",
        "positionId": "56052942",
        "volume": 8.54,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "id": "53089720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:14.460",
        "brokerTime": "2025-05-14 15:01:14.937",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052943",
        "positionId": "56052942",
        "volume": 8.54,
        "price": 3218.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -307.44,
        "takeProfit": null,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "id": "53089721",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:15.193",
        "brokerTime": "2025-05-14 15:01:15.193",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052944",
        "positionId": "56052944",
        "volume": 8.54,
        "price": 3218.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.58,
        "doubleCheck": true
    },
    {
        "id": "53089722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:15.193",
        "brokerTime": "2025-05-14 15:01:16.046",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052945",
        "positionId": "56052944",
        "volume": 8.54,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.58,
        "doubleCheck": true
    },
    {
        "id": "53089724",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:16.555",
        "brokerTime": "2025-05-14 15:01:16.555",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052947",
        "positionId": "56052947",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089725",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:16.555",
        "brokerTime": "2025-05-14 15:01:16.887",
        "commission": -59.78,
        "swap": 0,
        "profit": -350.14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052948",
        "positionId": "56052947",
        "volume": 8.54,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -409.91999999999996,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089727",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:17.881",
        "brokerTime": "2025-05-14 15:01:17.881",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052950",
        "positionId": "56052950",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:17.881",
        "brokerTime": "2025-05-14 15:01:18.543",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052951",
        "positionId": "56052950",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:18.782",
        "brokerTime": "2025-05-14 15:01:18.782",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052952",
        "positionId": "56052952",
        "volume": 8.54,
        "price": 3218.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.45,
        "doubleCheck": true
    },
    {
        "id": "53089730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:18.782",
        "brokerTime": "2025-05-14 15:01:19.195",
        "commission": -59.78,
        "swap": 0,
        "profit": -93.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052953",
        "positionId": "56052952",
        "volume": 8.54,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.72,
        "takeProfit": null,
        "priceIn": 3218.45,
        "doubleCheck": true
    },
    {
        "id": "53089732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19.448",
        "brokerTime": "2025-05-14 15:01:19.448",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052955",
        "positionId": "56052955",
        "volume": 8.54,
        "price": 3218.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.37,
        "doubleCheck": true
    },
    {
        "id": "53089733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:19.448",
        "brokerTime": "2025-05-14 15:01:19.827",
        "commission": -59.78,
        "swap": 0,
        "profit": -59.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052956",
        "positionId": "56052955",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119.56,
        "takeProfit": null,
        "priceIn": 3218.37,
        "doubleCheck": true
    },
    {
        "id": "53089734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20.059",
        "brokerTime": "2025-05-14 15:01:20.059",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052957",
        "positionId": "56052957",
        "volume": 8.54,
        "price": 3218.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.29,
        "doubleCheck": true
    },
    {
        "id": "53089735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20.059",
        "brokerTime": "2025-05-14 15:01:20.596",
        "commission": -59.78,
        "swap": 0,
        "profit": -93.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052958",
        "positionId": "56052957",
        "volume": 8.54,
        "price": 3218.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -153.72,
        "takeProfit": null,
        "priceIn": 3218.29,
        "doubleCheck": true
    },
    {
        "id": "53089738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20.990",
        "brokerTime": "2025-05-14 15:01:20.990",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052962",
        "positionId": "56052962",
        "volume": 8.54,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53089749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:20.990",
        "brokerTime": "2025-05-14 15:01:21.547",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052973",
        "positionId": "56052962",
        "volume": 8.54,
        "price": 3218.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -307.44,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53089752",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:21.776",
        "brokerTime": "2025-05-14 15:01:21.776",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052974",
        "positionId": "56052974",
        "volume": 8.54,
        "price": 3218.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.35,
        "doubleCheck": true
    },
    {
        "id": "53089755",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:21.776",
        "brokerTime": "2025-05-14 15:01:22.288",
        "commission": -59.78,
        "swap": 0,
        "profit": -264.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052976",
        "positionId": "56052974",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -324.52,
        "takeProfit": null,
        "priceIn": 3218.35,
        "doubleCheck": true
    },
    {
        "id": "53089756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:22.688",
        "brokerTime": "2025-05-14 15:01:22.688",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052977",
        "positionId": "56052977",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "id": "53089757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:22.688",
        "brokerTime": "2025-05-14 15:01:23.119",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052978",
        "positionId": "56052977",
        "volume": 8.54,
        "price": 3218.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -307.44,
        "takeProfit": null,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "id": "53089758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23.493",
        "brokerTime": "2025-05-14 15:01:23.493",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052979",
        "positionId": "56052979",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089759",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:23.493",
        "brokerTime": "2025-05-14 15:01:23.974",
        "commission": -59.78,
        "swap": 0,
        "profit": -204.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052980",
        "positionId": "56052979",
        "volume": 8.54,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.74,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:24.370",
        "brokerTime": "2025-05-14 15:01:24.370",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052981",
        "positionId": "56052981",
        "volume": 8.54,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53089761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:24.370",
        "brokerTime": "2025-05-14 15:01:24.717",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052982",
        "positionId": "56052981",
        "volume": 8.54,
        "price": 3219.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.5,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53089762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:25.009",
        "brokerTime": "2025-05-14 15:01:25.009",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052983",
        "positionId": "56052983",
        "volume": 8.54,
        "price": 3218.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.98,
        "doubleCheck": true
    },
    {
        "id": "53089763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:25.009",
        "brokerTime": "2025-05-14 15:01:25.969",
        "commission": -59.78,
        "swap": 0,
        "profit": -25.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052984",
        "positionId": "56052983",
        "volume": 8.54,
        "price": 3219.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -85.4,
        "takeProfit": null,
        "priceIn": 3218.98,
        "doubleCheck": true
    },
    {
        "id": "53089765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:26.292",
        "brokerTime": "2025-05-14 15:01:26.292",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052986",
        "positionId": "56052986",
        "volume": 8.54,
        "price": 3218.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.85,
        "doubleCheck": true
    },
    {
        "id": "53089766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:26.292",
        "brokerTime": "2025-05-14 15:01:26.723",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052987",
        "positionId": "56052986",
        "volume": 8.54,
        "price": 3219.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.5,
        "takeProfit": null,
        "priceIn": 3218.85,
        "doubleCheck": true
    },
    {
        "id": "53089767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:27.177",
        "brokerTime": "2025-05-14 15:01:27.177",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052988",
        "positionId": "56052988",
        "volume": 8.54,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "id": "53089768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:27.177",
        "brokerTime": "2025-05-14 15:01:28.089",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052989",
        "positionId": "56052988",
        "volume": 8.54,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.12,
        "takeProfit": null,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "id": "53089769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:28.415",
        "brokerTime": "2025-05-14 15:01:28.415",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052990",
        "positionId": "56052990",
        "volume": 8.54,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.95,
        "doubleCheck": true
    },
    {
        "id": "53089770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:28.415",
        "brokerTime": "2025-05-14 15:01:28.855",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052991",
        "positionId": "56052990",
        "volume": 8.54,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.95,
        "doubleCheck": true
    },
    {
        "id": "53089771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:29.177",
        "brokerTime": "2025-05-14 15:01:29.177",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052992",
        "positionId": "56052992",
        "volume": 8.54,
        "price": 3219,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3219,
        "doubleCheck": true
    },
    {
        "id": "53089772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:29.177",
        "brokerTime": "2025-05-14 15:01:29.766",
        "commission": -59.78,
        "swap": 0,
        "profit": -119.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052993",
        "positionId": "56052992",
        "volume": 8.54,
        "price": 3219.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.34,
        "takeProfit": null,
        "priceIn": 3219,
        "doubleCheck": true
    },
    {
        "id": "53089775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:30.294",
        "brokerTime": "2025-05-14 15:01:30.294",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052995",
        "positionId": "56052995",
        "volume": 8.54,
        "price": 3218.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.9,
        "doubleCheck": true
    },
    {
        "id": "53089776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:30.294",
        "brokerTime": "2025-05-14 15:01:30.830",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052996",
        "positionId": "56052995",
        "volume": 8.54,
        "price": 3219.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.8,
        "takeProfit": null,
        "priceIn": 3218.9,
        "doubleCheck": true
    },
    {
        "id": "53089777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:31.179",
        "brokerTime": "2025-05-14 15:01:31.179",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052997",
        "positionId": "56052997",
        "volume": 8.54,
        "price": 3218.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.83,
        "doubleCheck": true
    },
    {
        "id": "53089778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:31.179",
        "brokerTime": "2025-05-14 15:01:31.981",
        "commission": -59.78,
        "swap": 0,
        "profit": -145.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052998",
        "positionId": "56052997",
        "volume": 8.54,
        "price": 3219,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -204.96,
        "takeProfit": null,
        "priceIn": 3218.83,
        "doubleCheck": true
    },
    {
        "id": "53089779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:32.501",
        "brokerTime": "2025-05-14 15:01:32.501",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56052999",
        "positionId": "56052999",
        "volume": 8.54,
        "price": 3218.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.88,
        "doubleCheck": true
    },
    {
        "id": "53089780",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:32.501",
        "brokerTime": "2025-05-14 15:01:33.366",
        "commission": -59.78,
        "swap": 0,
        "profit": -42.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053000",
        "positionId": "56052999",
        "volume": 8.54,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.48,
        "takeProfit": null,
        "priceIn": 3218.88,
        "doubleCheck": true
    },
    {
        "id": "53089781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:33.683",
        "brokerTime": "2025-05-14 15:01:33.683",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053001",
        "positionId": "56053001",
        "volume": 8.54,
        "price": 3218.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.78,
        "doubleCheck": true
    },
    {
        "id": "53089782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:33.683",
        "brokerTime": "2025-05-14 15:01:34.481",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053002",
        "positionId": "56053001",
        "volume": 8.54,
        "price": 3218.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.78,
        "doubleCheck": true
    },
    {
        "id": "53089783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:35.188",
        "brokerTime": "2025-05-14 15:01:35.188",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053003",
        "positionId": "56053003",
        "volume": 8.54,
        "price": 3218.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.82,
        "doubleCheck": true
    },
    {
        "id": "53089784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:35.188",
        "brokerTime": "2025-05-14 15:01:36.133",
        "commission": -59.78,
        "swap": 0,
        "profit": -213.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053004",
        "positionId": "56053003",
        "volume": 8.54,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273.28,
        "takeProfit": null,
        "priceIn": 3218.82,
        "doubleCheck": true
    },
    {
        "id": "53089785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:36.310",
        "brokerTime": "2025-05-14 15:01:36.310",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053005",
        "positionId": "56053005",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.87,
        "doubleCheck": true
    },
    {
        "id": "53089786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:36.310",
        "brokerTime": "2025-05-14 15:01:36.655",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053006",
        "positionId": "56053005",
        "volume": 8.54,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -230.58,
        "takeProfit": null,
        "priceIn": 3218.87,
        "doubleCheck": true
    },
    {
        "id": "53089787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:37.271",
        "brokerTime": "2025-05-14 15:01:37.271",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053007",
        "positionId": "56053007",
        "volume": 8.54,
        "price": 3218.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.86,
        "doubleCheck": true
    },
    {
        "id": "53089790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:37.271",
        "brokerTime": "2025-05-14 15:01:37.772",
        "commission": -59.78,
        "swap": 0,
        "profit": 119.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053009",
        "positionId": "56053007",
        "volume": 8.54,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 59.78,
        "takeProfit": null,
        "priceIn": 3218.86,
        "doubleCheck": true
    },
    {
        "id": "53089792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:38.677",
        "brokerTime": "2025-05-14 15:01:38.677",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053011",
        "positionId": "56053011",
        "volume": 8.54,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "id": "53089794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:38.677",
        "brokerTime": "2025-05-14 15:01:39.041",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053012",
        "positionId": "56053011",
        "volume": 8.54,
        "price": 3218.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.55,
        "doubleCheck": true
    },
    {
        "id": "53089795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39.271",
        "brokerTime": "2025-05-14 15:01:39.271",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053013",
        "positionId": "56053013",
        "volume": 8.54,
        "price": 3218.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.6,
        "doubleCheck": true
    },
    {
        "id": "53089796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:39.271",
        "brokerTime": "2025-05-14 15:01:39.757",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053014",
        "positionId": "56053013",
        "volume": 8.54,
        "price": 3218.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -187.88,
        "takeProfit": null,
        "priceIn": 3218.6,
        "doubleCheck": true
    },
    {
        "id": "53089797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40.102",
        "brokerTime": "2025-05-14 15:01:40.102",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053015",
        "positionId": "56053015",
        "volume": 8.54,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53089798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40.102",
        "brokerTime": "2025-05-14 15:01:40.538",
        "commission": -59.78,
        "swap": 0,
        "profit": -34.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053016",
        "positionId": "56053015",
        "volume": 8.54,
        "price": 3218.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -93.94,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53089799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40.843",
        "brokerTime": "2025-05-14 15:01:40.843",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053017",
        "positionId": "56053017",
        "volume": 8.54,
        "price": 3218.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.48,
        "doubleCheck": true
    },
    {
        "id": "53089800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:40.843",
        "brokerTime": "2025-05-14 15:01:41.573",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053018",
        "positionId": "56053017",
        "volume": 8.54,
        "price": 3218.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196.42,
        "takeProfit": null,
        "priceIn": 3218.48,
        "doubleCheck": true
    },
    {
        "id": "53089801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:41.907",
        "brokerTime": "2025-05-14 15:01:41.907",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053019",
        "positionId": "56053019",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53089802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:41.907",
        "brokerTime": "2025-05-14 15:01:42.225",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053020",
        "positionId": "56053019",
        "volume": 8.54,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.12,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53089803",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:42.682",
        "brokerTime": "2025-05-14 15:01:42.682",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053021",
        "positionId": "56053021",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "id": "53089804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:42.682",
        "brokerTime": "2025-05-14 15:01:43.361",
        "commission": -59.78,
        "swap": 0,
        "profit": 85.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053022",
        "positionId": "56053021",
        "volume": 8.54,
        "price": 3218.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 25.620000000000005,
        "takeProfit": null,
        "priceIn": 3218.5,
        "doubleCheck": true
    },
    {
        "id": "53089805",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:43.742",
        "brokerTime": "2025-05-14 15:01:43.742",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053023",
        "positionId": "56053023",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53089806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:43.742",
        "brokerTime": "2025-05-14 15:01:44.304",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053024",
        "positionId": "56053023",
        "volume": 8.54,
        "price": 3218.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -230.58,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53089807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:45.204",
        "brokerTime": "2025-05-14 15:01:45.204",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053025",
        "positionId": "56053025",
        "volume": 8.54,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "id": "53089815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:45.204",
        "brokerTime": "2025-05-14 15:01:46.119",
        "commission": -59.78,
        "swap": 0,
        "profit": -119.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053032",
        "positionId": "56053025",
        "volume": 8.54,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.34,
        "takeProfit": null,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "id": "53089821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:46.802",
        "brokerTime": "2025-05-14 15:01:46.802",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053033",
        "positionId": "56053033",
        "volume": 8.54,
        "price": 3218.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.34,
        "doubleCheck": true
    },
    {
        "id": "53089822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:46.802",
        "brokerTime": "2025-05-14 15:01:47.170",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053034",
        "positionId": "56053033",
        "volume": 8.54,
        "price": 3218.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196.42,
        "takeProfit": null,
        "priceIn": 3218.34,
        "doubleCheck": true
    },
    {
        "id": "53089823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:47.884",
        "brokerTime": "2025-05-14 15:01:47.884",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053035",
        "positionId": "56053035",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53089824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:47.884",
        "brokerTime": "2025-05-14 15:01:48.435",
        "commission": -59.78,
        "swap": 0,
        "profit": -85.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053036",
        "positionId": "56053035",
        "volume": 8.54,
        "price": 3218.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.18,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53089825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:49.036",
        "brokerTime": "2025-05-14 15:01:49.036",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053037",
        "positionId": "56053037",
        "volume": 8.54,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.23,
        "doubleCheck": true
    },
    {
        "id": "53089826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:49.036",
        "brokerTime": "2025-05-14 15:01:49.479",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053038",
        "positionId": "56053037",
        "volume": 8.54,
        "price": 3218.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.23,
        "doubleCheck": true
    },
    {
        "id": "53089827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50.079",
        "brokerTime": "2025-05-14 15:01:50.079",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053039",
        "positionId": "56053039",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089828",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50.079",
        "brokerTime": "2025-05-14 15:01:50.526",
        "commission": -59.78,
        "swap": 0,
        "profit": -179.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053040",
        "positionId": "56053039",
        "volume": 8.54,
        "price": 3218.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.12,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50.751",
        "brokerTime": "2025-05-14 15:01:50.751",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053041",
        "positionId": "56053041",
        "volume": 8.54,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:50.751",
        "brokerTime": "2025-05-14 15:01:51.399",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053042",
        "positionId": "56053041",
        "volume": 8.54,
        "price": 3218.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.9,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53089831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:51.747",
        "brokerTime": "2025-05-14 15:01:51.747",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053043",
        "positionId": "56053043",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:51.747",
        "brokerTime": "2025-05-14 15:01:52.173",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053044",
        "positionId": "56053043",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52.415",
        "brokerTime": "2025-05-14 15:01:52.415",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053045",
        "positionId": "56053045",
        "volume": 8.54,
        "price": 3218.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.67,
        "doubleCheck": true
    },
    {
        "id": "53089834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:52.415",
        "brokerTime": "2025-05-14 15:01:52.787",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053046",
        "positionId": "56053045",
        "volume": 8.54,
        "price": 3218.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.67,
        "doubleCheck": true
    },
    {
        "id": "53089835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:53.380",
        "brokerTime": "2025-05-14 15:01:53.380",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053047",
        "positionId": "56053047",
        "volume": 8.54,
        "price": 3218.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.57,
        "doubleCheck": true
    },
    {
        "id": "53089842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:53.380",
        "brokerTime": "2025-05-14 15:01:54.376",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053054",
        "positionId": "56053047",
        "volume": 8.54,
        "price": 3218.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3218.57,
        "doubleCheck": true
    },
    {
        "id": "53089843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:54.606",
        "brokerTime": "2025-05-14 15:01:54.606",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053055",
        "positionId": "56053055",
        "volume": 8.54,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "id": "53089844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:54.606",
        "brokerTime": "2025-05-14 15:01:55.001",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053056",
        "positionId": "56053055",
        "volume": 8.54,
        "price": 3218.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.5,
        "takeProfit": null,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "id": "53089845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55.350",
        "brokerTime": "2025-05-14 15:01:55.350",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053057",
        "positionId": "56053057",
        "volume": 8.54,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.66,
        "doubleCheck": true
    },
    {
        "id": "53089864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:55.350",
        "brokerTime": "2025-05-14 15:01:56.078",
        "commission": -59.78,
        "swap": 0,
        "profit": -247.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053075",
        "positionId": "56053057",
        "volume": 8.54,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -307.44,
        "takeProfit": null,
        "priceIn": 3218.66,
        "doubleCheck": true
    },
    {
        "id": "53089865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56.367",
        "brokerTime": "2025-05-14 15:01:56.367",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053076",
        "positionId": "56053076",
        "volume": 8.54,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.72,
        "doubleCheck": true
    },
    {
        "id": "53089866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56.367",
        "brokerTime": "2025-05-14 15:01:56.826",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053077",
        "positionId": "56053076",
        "volume": 8.54,
        "price": 3218.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -187.88,
        "takeProfit": null,
        "priceIn": 3218.72,
        "doubleCheck": true
    },
    {
        "id": "53089867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56.957",
        "brokerTime": "2025-05-14 15:01:56.957",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053078",
        "positionId": "56053078",
        "volume": 8.54,
        "price": 3218.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.8,
        "doubleCheck": true
    },
    {
        "id": "53089868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:56.957",
        "brokerTime": "2025-05-14 15:01:57.691",
        "commission": -59.78,
        "swap": 0,
        "profit": -145.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053079",
        "positionId": "56053078",
        "volume": 8.54,
        "price": 3218.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -204.96,
        "takeProfit": null,
        "priceIn": 3218.8,
        "doubleCheck": true
    },
    {
        "id": "53089869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:57.965",
        "brokerTime": "2025-05-14 15:01:57.965",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053080",
        "positionId": "56053080",
        "volume": 8.54,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:57.965",
        "brokerTime": "2025-05-14 15:01:58.397",
        "commission": -59.78,
        "swap": 0,
        "profit": -222.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053081",
        "positionId": "56053080",
        "volume": 8.54,
        "price": 3218.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.82,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53089871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:58.682",
        "brokerTime": "2025-05-14 15:01:58.682",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053082",
        "positionId": "56053082",
        "volume": 8.54,
        "price": 3218.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.27,
        "doubleCheck": true
    },
    {
        "id": "53089872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:58.682",
        "brokerTime": "2025-05-14 15:01:59.046",
        "commission": -59.78,
        "swap": 0,
        "profit": -68.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053083",
        "positionId": "56053082",
        "volume": 8.54,
        "price": 3218.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -128.1,
        "takeProfit": null,
        "priceIn": 3218.27,
        "doubleCheck": true
    },
    {
        "id": "53089873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59.498",
        "brokerTime": "2025-05-14 15:01:59.498",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053084",
        "positionId": "56053084",
        "volume": 8.54,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53089876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:01:59.498",
        "brokerTime": "2025-05-14 15:02:00.116",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053087",
        "positionId": "56053084",
        "volume": 8.54,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -247.66,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53089879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:00.460",
        "brokerTime": "2025-05-14 15:02:00.460",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053090",
        "positionId": "56053090",
        "volume": 8.54,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53089880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:00.460",
        "brokerTime": "2025-05-14 15:02:00.943",
        "commission": -59.78,
        "swap": 0,
        "profit": -170.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053091",
        "positionId": "56053090",
        "volume": 8.54,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -230.58,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53089881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:01.250",
        "brokerTime": "2025-05-14 15:02:01.250",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053092",
        "positionId": "56053092",
        "volume": 8.54,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53089931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:01.250",
        "brokerTime": "2025-05-14 15:02:02.093",
        "commission": -59.78,
        "swap": 0,
        "profit": 1366.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053139",
        "positionId": "56053092",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 1306.6200000000001,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53090022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:03.242",
        "brokerTime": "2025-05-14 15:02:03.242",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053208",
        "positionId": "56053208",
        "volume": 8.54,
        "price": 3216.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.43,
        "doubleCheck": true
    },
    {
        "id": "53090031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:03.242",
        "brokerTime": "2025-05-14 15:02:03.991",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053212",
        "positionId": "56053208",
        "volume": 8.54,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.9,
        "takeProfit": null,
        "priceIn": 3216.43,
        "doubleCheck": true
    },
    {
        "id": "53090032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:00:12.763",
        "brokerTime": "2025-05-14 15:02:04.048",
        "commission": -0.7,
        "swap": 0,
        "profit": 37.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053213",
        "positionId": "56052731",
        "volume": 0.1,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 37.099999999999994,
        "takeProfit": null,
        "priceIn": 3220.49,
        "doubleCheck": true
    },
    {
        "id": "53090243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:10.851",
        "brokerTime": "2025-05-14 15:02:10.851",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053393",
        "positionId": "56053393",
        "volume": 0.1,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "id": "53090244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11.499",
        "brokerTime": "2025-05-14 15:02:11.499",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053394",
        "positionId": "56053394",
        "volume": 8.54,
        "price": 3216.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "id": "53090245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:11.499",
        "brokerTime": "2025-05-14 15:02:11.955",
        "commission": -59.78,
        "swap": 0,
        "profit": 213.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053395",
        "positionId": "56053394",
        "volume": 8.54,
        "price": 3216.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 153.72,
        "takeProfit": null,
        "priceIn": 3216.71,
        "doubleCheck": true
    },
    {
        "id": "53090246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12.210",
        "brokerTime": "2025-05-14 15:02:12.210",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053396",
        "positionId": "56053396",
        "volume": 8.54,
        "price": 3216.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.06,
        "doubleCheck": true
    },
    {
        "id": "53090249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12.210",
        "brokerTime": "2025-05-14 15:02:12.615",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053399",
        "positionId": "56053396",
        "volume": 8.54,
        "price": 3216.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -247.66,
        "takeProfit": null,
        "priceIn": 3216.06,
        "doubleCheck": true
    },
    {
        "id": "53090251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12.969",
        "brokerTime": "2025-05-14 15:02:12.969",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053402",
        "positionId": "56053402",
        "volume": 8.54,
        "price": 3216.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.05,
        "doubleCheck": true
    },
    {
        "id": "53090254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:12.969",
        "brokerTime": "2025-05-14 15:02:13.360",
        "commission": -59.78,
        "swap": 0,
        "profit": -239.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053404",
        "positionId": "56053402",
        "volume": 8.54,
        "price": 3216.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.9,
        "takeProfit": null,
        "priceIn": 3216.05,
        "doubleCheck": true
    },
    {
        "id": "53090255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:13.546",
        "brokerTime": "2025-05-14 15:02:13.546",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053405",
        "positionId": "56053405",
        "volume": 8.54,
        "price": 3216.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.22,
        "doubleCheck": true
    },
    {
        "id": "53090256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:13.546",
        "brokerTime": "2025-05-14 15:02:14.005",
        "commission": -59.78,
        "swap": 0,
        "profit": -187.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053406",
        "positionId": "56053405",
        "volume": 8.54,
        "price": 3216.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -247.66,
        "takeProfit": null,
        "priceIn": 3216.22,
        "doubleCheck": true
    },
    {
        "id": "53090257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14.232",
        "brokerTime": "2025-05-14 15:02:14.232",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053407",
        "positionId": "56053407",
        "volume": 8.54,
        "price": 3216.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.24,
        "doubleCheck": true
    },
    {
        "id": "53090259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14.232",
        "brokerTime": "2025-05-14 15:02:14.532",
        "commission": -59.78,
        "swap": 0,
        "profit": -222.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053409",
        "positionId": "56053407",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.82,
        "takeProfit": null,
        "priceIn": 3216.24,
        "doubleCheck": true
    },
    {
        "id": "53090260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14.778",
        "brokerTime": "2025-05-14 15:02:14.778",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053410",
        "positionId": "56053410",
        "volume": 8.54,
        "price": 3216.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.31,
        "doubleCheck": true
    },
    {
        "id": "53090262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:14.778",
        "brokerTime": "2025-05-14 15:02:15.134",
        "commission": -59.78,
        "swap": 0,
        "profit": -230.58,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053412",
        "positionId": "56053410",
        "volume": 8.54,
        "price": 3216.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.36,
        "takeProfit": null,
        "priceIn": 3216.31,
        "doubleCheck": true
    },
    {
        "id": "53090264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15.285",
        "brokerTime": "2025-05-14 15:02:15.285",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053414",
        "positionId": "56053414",
        "volume": 8.54,
        "price": 3216.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.53,
        "doubleCheck": true
    },
    {
        "id": "53090265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:15.285",
        "brokerTime": "2025-05-14 15:02:15.674",
        "commission": -59.78,
        "swap": 0,
        "profit": -136.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053415",
        "positionId": "56053414",
        "volume": 8.54,
        "price": 3216.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -196.42,
        "takeProfit": null,
        "priceIn": 3216.53,
        "doubleCheck": true
    },
    {
        "id": "53090266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:16.107",
        "brokerTime": "2025-05-14 15:02:16.107",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053416",
        "positionId": "56053416",
        "volume": 8.54,
        "price": 3216.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.45,
        "doubleCheck": true
    },
    {
        "id": "53090267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:16.107",
        "brokerTime": "2025-05-14 15:02:16.437",
        "commission": -59.78,
        "swap": 0,
        "profit": -42.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053417",
        "positionId": "56053416",
        "volume": 8.54,
        "price": 3216.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -102.48,
        "takeProfit": null,
        "priceIn": 3216.45,
        "doubleCheck": true
    },
    {
        "id": "53090268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17.023",
        "brokerTime": "2025-05-14 15:02:17.023",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053418",
        "positionId": "56053418",
        "volume": 8.54,
        "price": 3216.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3216.38,
        "doubleCheck": true
    },
    {
        "id": "53090269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17.023",
        "brokerTime": "2025-05-14 15:02:17.671",
        "commission": -59.78,
        "swap": 0,
        "profit": -367.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053419",
        "positionId": "56053418",
        "volume": 8.54,
        "price": 3216.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -427,
        "takeProfit": null,
        "priceIn": 3216.38,
        "doubleCheck": true
    },
    {
        "id": "53090270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17.954",
        "brokerTime": "2025-05-14 15:02:17.954",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053420",
        "positionId": "56053420",
        "volume": 8.54,
        "price": 3217.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.26,
        "doubleCheck": true
    },
    {
        "id": "53090272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:17.954",
        "brokerTime": "2025-05-14 15:02:18.717",
        "commission": -59.78,
        "swap": 0,
        "profit": -162.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053422",
        "positionId": "56053420",
        "volume": 8.54,
        "price": 3217.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -222.04,
        "takeProfit": null,
        "priceIn": 3217.26,
        "doubleCheck": true
    },
    {
        "id": "53090273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:19.002",
        "brokerTime": "2025-05-14 15:02:19.002",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053423",
        "positionId": "56053423",
        "volume": 8.54,
        "price": 3217.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.46,
        "doubleCheck": true
    },
    {
        "id": "53090274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:19.002",
        "brokerTime": "2025-05-14 15:02:19.955",
        "commission": -59.78,
        "swap": 0,
        "profit": -128.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053424",
        "positionId": "56053423",
        "volume": 8.54,
        "price": 3217.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -187.88,
        "takeProfit": null,
        "priceIn": 3217.46,
        "doubleCheck": true
    },
    {
        "id": "53090275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:20.172",
        "brokerTime": "2025-05-14 15:02:20.172",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053425",
        "positionId": "56053425",
        "volume": 8.54,
        "price": 3217.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.33,
        "doubleCheck": true
    },
    {
        "id": "53090276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:20.172",
        "brokerTime": "2025-05-14 15:02:20.718",
        "commission": -59.78,
        "swap": 0,
        "profit": -153.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053426",
        "positionId": "56053425",
        "volume": 8.54,
        "price": 3217.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.5,
        "takeProfit": null,
        "priceIn": 3217.33,
        "doubleCheck": true
    },
    {
        "id": "53090277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21.106",
        "brokerTime": "2025-05-14 15:02:21.106",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053427",
        "positionId": "56053427",
        "volume": 8.54,
        "price": 3217.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.5,
        "doubleCheck": true
    },
    {
        "id": "53090278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21.106",
        "brokerTime": "2025-05-14 15:02:21.423",
        "commission": -59.78,
        "swap": 0,
        "profit": -256.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053428",
        "positionId": "56053427",
        "volume": 8.54,
        "price": 3217.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.98,
        "takeProfit": null,
        "priceIn": 3217.5,
        "doubleCheck": true
    },
    {
        "id": "53090279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21.692",
        "brokerTime": "2025-05-14 15:02:21.692",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053429",
        "positionId": "56053429",
        "volume": 8.54,
        "price": 3217.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "id": "53090280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:21.692",
        "brokerTime": "2025-05-14 15:02:22.353",
        "commission": -59.78,
        "swap": 0,
        "profit": -76.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053430",
        "positionId": "56053429",
        "volume": 8.54,
        "price": 3217.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -136.64,
        "takeProfit": null,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "id": "53090281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:23.080",
        "brokerTime": "2025-05-14 15:02:23.080",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053431",
        "positionId": "56053431",
        "volume": 8.54,
        "price": 3217.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.57,
        "doubleCheck": true
    },
    {
        "id": "53090282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:23.080",
        "brokerTime": "2025-05-14 15:02:23.559",
        "commission": -59.78,
        "swap": 0,
        "profit": -230.58,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053432",
        "positionId": "56053431",
        "volume": 8.54,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.36,
        "takeProfit": null,
        "priceIn": 3217.57,
        "doubleCheck": true
    },
    {
        "id": "53090283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24.057",
        "brokerTime": "2025-05-14 15:02:24.057",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053433",
        "positionId": "56053433",
        "volume": 8.54,
        "price": 3217.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.63,
        "doubleCheck": true
    },
    {
        "id": "53090284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24.057",
        "brokerTime": "2025-05-14 15:02:24.406",
        "commission": -59.78,
        "swap": 0,
        "profit": -111.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053434",
        "positionId": "56053433",
        "volume": 8.54,
        "price": 3217.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.8,
        "takeProfit": null,
        "priceIn": 3217.63,
        "doubleCheck": true
    },
    {
        "id": "53090285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24.724",
        "brokerTime": "2025-05-14 15:02:24.724",
        "commission": -59.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053435",
        "positionId": "56053435",
        "volume": 8.54,
        "price": 3217.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.78,
        "takeProfit": null,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "id": "53090286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:24.724",
        "brokerTime": "2025-05-14 15:02:25.523",
        "commission": -59.78,
        "swap": 0,
        "profit": -555.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053436",
        "positionId": "56053435",
        "volume": 8.54,
        "price": 3218.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -614.88,
        "takeProfit": null,
        "priceIn": 3217.64,
        "doubleCheck": true
    },
    {
        "id": "53090287",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25.566",
        "brokerTime": "2025-05-14 15:02:25.566",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053437",
        "positionId": "56053437",
        "volume": 0.12,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3118.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "id": "53090288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25.862",
        "brokerTime": "2025-05-14 15:02:25.862",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053438",
        "positionId": "56053438",
        "volume": 8.42,
        "price": 3218.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53090289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25.862",
        "brokerTime": "2025-05-14 15:02:26.248",
        "commission": -58.94,
        "swap": 0,
        "profit": -210.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053439",
        "positionId": "56053438",
        "volume": 8.42,
        "price": 3218.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -269.44,
        "takeProfit": null,
        "priceIn": 3218.08,
        "doubleCheck": true
    },
    {
        "id": "53090291",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26.537",
        "brokerTime": "2025-05-14 15:02:26.537",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053441",
        "positionId": "56053441",
        "volume": 8.42,
        "price": 3218.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53090292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:26.537",
        "brokerTime": "2025-05-14 15:02:26.924",
        "commission": -58.94,
        "swap": 0,
        "profit": -328.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053442",
        "positionId": "56053441",
        "volume": 8.42,
        "price": 3218.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -387.32,
        "takeProfit": null,
        "priceIn": 3218.1,
        "doubleCheck": true
    },
    {
        "id": "53090293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27.112",
        "brokerTime": "2025-05-14 15:02:27.112",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053443",
        "positionId": "56053443",
        "volume": 8.42,
        "price": 3218.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "id": "53090298",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:27.112",
        "brokerTime": "2025-05-14 15:02:27.987",
        "commission": -58.94,
        "swap": 0,
        "profit": -210.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053448",
        "positionId": "56053443",
        "volume": 8.42,
        "price": 3218.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -269.44,
        "takeProfit": null,
        "priceIn": 3218.3,
        "doubleCheck": true
    },
    {
        "id": "53090299",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28.350",
        "brokerTime": "2025-05-14 15:02:28.350",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053449",
        "positionId": "56053449",
        "volume": 8.42,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53090300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28.350",
        "brokerTime": "2025-05-14 15:02:28.811",
        "commission": -58.94,
        "swap": 0,
        "profit": 227.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053450",
        "positionId": "56053449",
        "volume": 8.42,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 168.4,
        "takeProfit": null,
        "priceIn": 3218.28,
        "doubleCheck": true
    },
    {
        "id": "53090302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28.979",
        "brokerTime": "2025-05-14 15:02:28.979",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053452",
        "positionId": "56053452",
        "volume": 8.42,
        "price": 3217.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.72,
        "doubleCheck": true
    },
    {
        "id": "53090303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:28.979",
        "brokerTime": "2025-05-14 15:02:29.275",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053453",
        "positionId": "56053452",
        "volume": 8.42,
        "price": 3217.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -261.02,
        "takeProfit": null,
        "priceIn": 3217.72,
        "doubleCheck": true
    },
    {
        "id": "53090304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:29.591",
        "brokerTime": "2025-05-14 15:02:29.591",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053454",
        "positionId": "56053454",
        "volume": 8.42,
        "price": 3217.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.74,
        "doubleCheck": true
    },
    {
        "id": "53090305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:29.591",
        "brokerTime": "2025-05-14 15:02:30.199",
        "commission": -58.94,
        "swap": 0,
        "profit": -235.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053455",
        "positionId": "56053454",
        "volume": 8.42,
        "price": 3218.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -294.7,
        "takeProfit": null,
        "priceIn": 3217.74,
        "doubleCheck": true
    },
    {
        "id": "53090306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:30.702",
        "brokerTime": "2025-05-14 15:02:30.702",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053456",
        "positionId": "56053456",
        "volume": 8.42,
        "price": 3217.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.91,
        "doubleCheck": true
    },
    {
        "id": "53090307",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:30.702",
        "brokerTime": "2025-05-14 15:02:31.143",
        "commission": -58.94,
        "swap": 0,
        "profit": -25.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053457",
        "positionId": "56053456",
        "volume": 8.42,
        "price": 3217.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -84.2,
        "takeProfit": null,
        "priceIn": 3217.91,
        "doubleCheck": true
    },
    {
        "id": "53090308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:31.502",
        "brokerTime": "2025-05-14 15:02:31.502",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053458",
        "positionId": "56053458",
        "volume": 8.42,
        "price": 3217.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.86,
        "doubleCheck": true
    },
    {
        "id": "53090309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:31.502",
        "brokerTime": "2025-05-14 15:02:31.848",
        "commission": -58.94,
        "swap": 0,
        "profit": -176.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053459",
        "positionId": "56053458",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.76,
        "takeProfit": null,
        "priceIn": 3217.86,
        "doubleCheck": true
    },
    {
        "id": "53090310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32.161",
        "brokerTime": "2025-05-14 15:02:32.161",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053460",
        "positionId": "56053460",
        "volume": 8.42,
        "price": 3217.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.89,
        "doubleCheck": true
    },
    {
        "id": "53090311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:32.161",
        "brokerTime": "2025-05-14 15:02:32.447",
        "commission": -58.94,
        "swap": 0,
        "profit": -244.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053461",
        "positionId": "56053460",
        "volume": 8.42,
        "price": 3218.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -303.12,
        "takeProfit": null,
        "priceIn": 3217.89,
        "doubleCheck": true
    },
    {
        "id": "53090312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:33.162",
        "brokerTime": "2025-05-14 15:02:33.162",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053462",
        "positionId": "56053462",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:33.162",
        "brokerTime": "2025-05-14 15:02:33.692",
        "commission": -58.94,
        "swap": 0,
        "profit": -151.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053463",
        "positionId": "56053462",
        "volume": 8.42,
        "price": 3218.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.5,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34.157",
        "brokerTime": "2025-05-14 15:02:34.157",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053464",
        "positionId": "56053464",
        "volume": 8.42,
        "price": 3217.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.85,
        "doubleCheck": true
    },
    {
        "id": "53090318",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34.157",
        "brokerTime": "2025-05-14 15:02:34.663",
        "commission": -58.94,
        "swap": 0,
        "profit": -151.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053468",
        "positionId": "56053464",
        "volume": 8.42,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.5,
        "takeProfit": null,
        "priceIn": 3217.85,
        "doubleCheck": true
    },
    {
        "id": "53090319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34.807",
        "brokerTime": "2025-05-14 15:02:34.807",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053469",
        "positionId": "56053469",
        "volume": 8.42,
        "price": 3217.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.79,
        "doubleCheck": true
    },
    {
        "id": "53090320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:34.807",
        "brokerTime": "2025-05-14 15:02:35.154",
        "commission": -58.94,
        "swap": 0,
        "profit": -353.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053470",
        "positionId": "56053469",
        "volume": 8.42,
        "price": 3218.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.58,
        "takeProfit": null,
        "priceIn": 3217.79,
        "doubleCheck": true
    },
    {
        "id": "53090321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35.431",
        "brokerTime": "2025-05-14 15:02:35.431",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053471",
        "positionId": "56053471",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:35.431",
        "brokerTime": "2025-05-14 15:02:36.213",
        "commission": -58.94,
        "swap": 0,
        "profit": -143.14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053473",
        "positionId": "56053471",
        "volume": 8.42,
        "price": 3218.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.07999999999998,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:36.541",
        "brokerTime": "2025-05-14 15:02:36.541",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053474",
        "positionId": "56053474",
        "volume": 8.42,
        "price": 3217.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:36.541",
        "brokerTime": "2025-05-14 15:02:37.261",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053475",
        "positionId": "56053474",
        "volume": 8.42,
        "price": 3218.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -244.18,
        "takeProfit": null,
        "priceIn": 3217.98,
        "doubleCheck": true
    },
    {
        "id": "53090326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:37.966",
        "brokerTime": "2025-05-14 15:02:37.966",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053476",
        "positionId": "56053476",
        "volume": 8.42,
        "price": 3218.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.04,
        "doubleCheck": true
    },
    {
        "id": "53090327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:37.966",
        "brokerTime": "2025-05-14 15:02:38.356",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053477",
        "positionId": "56053476",
        "volume": 8.42,
        "price": 3218.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -261.02,
        "takeProfit": null,
        "priceIn": 3218.04,
        "doubleCheck": true
    },
    {
        "id": "53090328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:38.801",
        "brokerTime": "2025-05-14 15:02:38.801",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053478",
        "positionId": "56053478",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "id": "53090329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:38.801",
        "brokerTime": "2025-05-14 15:02:39.191",
        "commission": -58.94,
        "swap": 0,
        "profit": -134.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053479",
        "positionId": "56053478",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -193.66,
        "takeProfit": null,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "id": "53090330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:39.804",
        "brokerTime": "2025-05-14 15:02:39.804",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053480",
        "positionId": "56053480",
        "volume": 8.42,
        "price": 3218.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.06,
        "doubleCheck": true
    },
    {
        "id": "53090331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:39.804",
        "brokerTime": "2025-05-14 15:02:40.144",
        "commission": -58.94,
        "swap": 0,
        "profit": -143.14,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053481",
        "positionId": "56053480",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.07999999999998,
        "takeProfit": null,
        "priceIn": 3218.06,
        "doubleCheck": true
    },
    {
        "id": "53090333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40.411",
        "brokerTime": "2025-05-14 15:02:40.411",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053483",
        "positionId": "56053483",
        "volume": 8.42,
        "price": 3218.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "id": "53090335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:40.411",
        "brokerTime": "2025-05-14 15:02:40.900",
        "commission": -58.94,
        "swap": 0,
        "profit": -134.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053484",
        "positionId": "56053483",
        "volume": 8.42,
        "price": 3218.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -193.66,
        "takeProfit": null,
        "priceIn": 3218.07,
        "doubleCheck": true
    },
    {
        "id": "53090336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:41.087",
        "brokerTime": "2025-05-14 15:02:41.087",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053485",
        "positionId": "56053485",
        "volume": 8.42,
        "price": 3217.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3217.93,
        "doubleCheck": true
    },
    {
        "id": "53090356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:41.087",
        "brokerTime": "2025-05-14 15:02:41.941",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053505",
        "positionId": "56053485",
        "volume": 8.42,
        "price": 3218.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -244.18,
        "takeProfit": null,
        "priceIn": 3217.93,
        "doubleCheck": true
    },
    {
        "id": "53090369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:42.223",
        "brokerTime": "2025-05-14 15:02:42.223",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053506",
        "positionId": "56053506",
        "volume": 8.42,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.03,
        "doubleCheck": true
    },
    {
        "id": "53090371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:42.223",
        "brokerTime": "2025-05-14 15:02:42.626",
        "commission": -58.94,
        "swap": 0,
        "profit": -774.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053509",
        "positionId": "56053506",
        "volume": 8.42,
        "price": 3218.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -833.5799999999999,
        "takeProfit": null,
        "priceIn": 3218.03,
        "doubleCheck": true
    },
    {
        "id": "53090375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:43.317",
        "brokerTime": "2025-05-14 15:02:43.317",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053510",
        "positionId": "56053510",
        "volume": 8.42,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "id": "53090377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:43.317",
        "brokerTime": "2025-05-14 15:02:44.027",
        "commission": -58.94,
        "swap": 0,
        "profit": -286.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053512",
        "positionId": "56053510",
        "volume": 8.42,
        "price": 3219.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -345.21999999999997,
        "takeProfit": null,
        "priceIn": 3218.81,
        "doubleCheck": true
    },
    {
        "id": "53090378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:44.155",
        "brokerTime": "2025-05-14 15:02:44.155",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053513",
        "positionId": "56053513",
        "volume": 8.42,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3218.92,
        "doubleCheck": true
    },
    {
        "id": "53090379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:44.155",
        "brokerTime": "2025-05-14 15:02:44.653",
        "commission": -58.94,
        "swap": 0,
        "profit": -261.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053514",
        "positionId": "56053513",
        "volume": 8.42,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -319.96,
        "takeProfit": null,
        "priceIn": 3218.92,
        "doubleCheck": true
    },
    {
        "id": "53090381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:45.167",
        "brokerTime": "2025-05-14 15:02:45.167",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053516",
        "positionId": "56053516",
        "volume": 8.42,
        "price": 3219.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "id": "53090382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:45.167",
        "brokerTime": "2025-05-14 15:02:45.587",
        "commission": -58.94,
        "swap": 0,
        "profit": -345.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053517",
        "positionId": "56053516",
        "volume": 8.42,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -404.16,
        "takeProfit": null,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "id": "53090384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:46.081",
        "brokerTime": "2025-05-14 15:02:46.081",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053519",
        "positionId": "56053519",
        "volume": 8.42,
        "price": 3219.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3219.7,
        "doubleCheck": true
    },
    {
        "id": "53090385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:46.081",
        "brokerTime": "2025-05-14 15:02:46.483",
        "commission": -58.94,
        "swap": 0,
        "profit": -269.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053520",
        "positionId": "56053519",
        "volume": 8.42,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -328.38,
        "takeProfit": null,
        "priceIn": 3219.7,
        "doubleCheck": true
    },
    {
        "id": "53090386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:47.134",
        "brokerTime": "2025-05-14 15:02:47.134",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053521",
        "positionId": "56053521",
        "volume": 8.42,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53090387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:47.134",
        "brokerTime": "2025-05-14 15:02:47.992",
        "commission": -58.94,
        "swap": 0,
        "profit": -446.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053522",
        "positionId": "56053521",
        "volume": 8.42,
        "price": 3220.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -505.2,
        "takeProfit": null,
        "priceIn": 3219.89,
        "doubleCheck": true
    },
    {
        "id": "53090388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48.281",
        "brokerTime": "2025-05-14 15:02:48.281",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053523",
        "positionId": "56053523",
        "volume": 8.42,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "id": "53090389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48.281",
        "brokerTime": "2025-05-14 15:02:48.697",
        "commission": -58.94,
        "swap": 0,
        "profit": -277.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053524",
        "positionId": "56053523",
        "volume": 8.42,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -336.8,
        "takeProfit": null,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "id": "53090390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48.961",
        "brokerTime": "2025-05-14 15:02:48.961",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053525",
        "positionId": "56053525",
        "volume": 8.42,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.24,
        "doubleCheck": true
    },
    {
        "id": "53090391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:48.961",
        "brokerTime": "2025-05-14 15:02:49.479",
        "commission": -58.94,
        "swap": 0,
        "profit": -33.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053526",
        "positionId": "56053525",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -92.62,
        "takeProfit": null,
        "priceIn": 3220.24,
        "doubleCheck": true
    },
    {
        "id": "53090392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:49.852",
        "brokerTime": "2025-05-14 15:02:49.852",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053527",
        "positionId": "56053527",
        "volume": 8.42,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53090393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:49.852",
        "brokerTime": "2025-05-14 15:02:50.218",
        "commission": -58.94,
        "swap": 0,
        "profit": -193.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053528",
        "positionId": "56053527",
        "volume": 8.42,
        "price": 3220.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -252.6,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53090394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51.000",
        "brokerTime": "2025-05-14 15:02:51.000",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053529",
        "positionId": "56053529",
        "volume": 8.42,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53090395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51.000",
        "brokerTime": "2025-05-14 15:02:51.381",
        "commission": -58.94,
        "swap": 0,
        "profit": -159.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053530",
        "positionId": "56053529",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.92,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53090396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51.992",
        "brokerTime": "2025-05-14 15:02:51.992",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053531",
        "positionId": "56053531",
        "volume": 8.42,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "id": "53090397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:51.992",
        "brokerTime": "2025-05-14 15:02:52.272",
        "commission": -58.94,
        "swap": 0,
        "profit": -117.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053532",
        "positionId": "56053531",
        "volume": 8.42,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.82,
        "takeProfit": null,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "id": "53090398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:52.830",
        "brokerTime": "2025-05-14 15:02:52.830",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053533",
        "positionId": "56053533",
        "volume": 8.42,
        "price": 3220.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.38,
        "doubleCheck": true
    },
    {
        "id": "53090399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:52.830",
        "brokerTime": "2025-05-14 15:02:53.222",
        "commission": -58.94,
        "swap": 0,
        "profit": -67.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053534",
        "positionId": "56053533",
        "volume": 8.42,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126.3,
        "takeProfit": null,
        "priceIn": 3220.38,
        "doubleCheck": true
    },
    {
        "id": "53090400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53.424",
        "brokerTime": "2025-05-14 15:02:53.424",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053535",
        "positionId": "56053535",
        "volume": 8.42,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53090401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:53.424",
        "brokerTime": "2025-05-14 15:02:53.818",
        "commission": -58.94,
        "swap": 0,
        "profit": -185.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053536",
        "positionId": "56053535",
        "volume": 8.42,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -244.18,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53090402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:54.038",
        "brokerTime": "2025-05-14 15:02:54.038",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053537",
        "positionId": "56053537",
        "volume": 8.42,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53090403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:54.038",
        "brokerTime": "2025-05-14 15:02:54.435",
        "commission": -58.94,
        "swap": 0,
        "profit": -294.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053538",
        "positionId": "56053537",
        "volume": 8.42,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.64,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53090404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55.047",
        "brokerTime": "2025-05-14 15:02:55.047",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053539",
        "positionId": "56053539",
        "volume": 8.42,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53090405",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55.047",
        "brokerTime": "2025-05-14 15:02:55.452",
        "commission": -58.94,
        "swap": 0,
        "profit": -202.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053540",
        "positionId": "56053539",
        "volume": 8.42,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -261.02,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53090406",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55.857",
        "brokerTime": "2025-05-14 15:02:55.857",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053541",
        "positionId": "56053541",
        "volume": 8.42,
        "price": 3220.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "id": "53090407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:55.857",
        "brokerTime": "2025-05-14 15:02:56.434",
        "commission": -58.94,
        "swap": 0,
        "profit": -328.38,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053542",
        "positionId": "56053541",
        "volume": 8.42,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -387.32,
        "takeProfit": null,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "id": "53090409",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:56.943",
        "brokerTime": "2025-05-14 15:02:56.943",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053544",
        "positionId": "56053544",
        "volume": 8.42,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53090410",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:56.943",
        "brokerTime": "2025-05-14 15:02:57.441",
        "commission": -58.94,
        "swap": 0,
        "profit": -168.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053545",
        "positionId": "56053544",
        "volume": 8.42,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.34,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53090411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:57.684",
        "brokerTime": "2025-05-14 15:02:57.684",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053546",
        "positionId": "56053546",
        "volume": 8.42,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "id": "53090412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:57.684",
        "brokerTime": "2025-05-14 15:02:58.189",
        "commission": -58.94,
        "swap": 0,
        "profit": -277.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053547",
        "positionId": "56053546",
        "volume": 8.42,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -336.8,
        "takeProfit": null,
        "priceIn": 3220.82,
        "doubleCheck": false
    },
    {
        "id": "53090413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:58.637",
        "brokerTime": "2025-05-14 15:02:58.637",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053548",
        "positionId": "56053548",
        "volume": 8.42,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53090414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:58.637",
        "brokerTime": "2025-05-14 15:02:59.649",
        "commission": -58.94,
        "swap": 0,
        "profit": -117.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053549",
        "positionId": "56053548",
        "volume": 8.42,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.82,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53090415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:59.811",
        "brokerTime": "2025-05-14 15:02:59.811",
        "commission": -58.94,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053550",
        "positionId": "56053550",
        "volume": 8.42,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -58.94,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53090418",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:59.811",
        "brokerTime": "2025-05-14 15:03:00.169",
        "commission": -58.94,
        "swap": 0,
        "profit": -269.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053552",
        "positionId": "56053550",
        "volume": 8.42,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -328.38,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53090419",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00.254",
        "brokerTime": "2025-05-14 15:03:00.254",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053553",
        "positionId": "56053553",
        "volume": 0.14,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3120.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53090420",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00.575",
        "brokerTime": "2025-05-14 15:03:00.575",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053554",
        "positionId": "56053554",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53090421",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00.575",
        "brokerTime": "2025-05-14 15:03:00.987",
        "commission": -57.96,
        "swap": 0,
        "profit": -57.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053555",
        "positionId": "56053554",
        "volume": 8.28,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -115.92,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53090425",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:02.100",
        "brokerTime": "2025-05-14 15:03:02.100",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053559",
        "positionId": "56053559",
        "volume": 8.28,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "id": "53090427",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:02.100",
        "brokerTime": "2025-05-14 15:03:02.976",
        "commission": -57.96,
        "swap": 0,
        "profit": -339.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053561",
        "positionId": "56053559",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -397.44,
        "takeProfit": null,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "id": "53090436",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:03.469",
        "brokerTime": "2025-05-14 15:03:03.469",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053567",
        "positionId": "56053567",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "id": "53090444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:03.469",
        "brokerTime": "2025-05-14 15:03:03.811",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053577",
        "positionId": "56053567",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "id": "53090476",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:04.224",
        "brokerTime": "2025-05-14 15:03:04.224",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053601",
        "positionId": "56053601",
        "volume": 8.28,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53090498",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:04.224",
        "brokerTime": "2025-05-14 15:03:04.694",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053615",
        "positionId": "56053601",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53090503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05.132",
        "brokerTime": "2025-05-14 15:03:05.132",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053618",
        "positionId": "56053618",
        "volume": 8.28,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53090504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05.132",
        "brokerTime": "2025-05-14 15:03:05.582",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053619",
        "positionId": "56053618",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53090506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05.946",
        "brokerTime": "2025-05-14 15:03:05.946",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053621",
        "positionId": "56053621",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:05.946",
        "brokerTime": "2025-05-14 15:03:06.543",
        "commission": -57.96,
        "swap": 0,
        "profit": -306.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053622",
        "positionId": "56053621",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -364.32,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07.337",
        "brokerTime": "2025-05-14 15:03:07.337",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053623",
        "positionId": "56053623",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07.337",
        "brokerTime": "2025-05-14 15:03:07.731",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053624",
        "positionId": "56053623",
        "volume": 8.28,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07.923",
        "brokerTime": "2025-05-14 15:03:07.923",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053626",
        "positionId": "56053626",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53090512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:07.923",
        "brokerTime": "2025-05-14 15:03:08.422",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053627",
        "positionId": "56053626",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273.24,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53090513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:08.628",
        "brokerTime": "2025-05-14 15:03:08.628",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053628",
        "positionId": "56053628",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53090514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:08.628",
        "brokerTime": "2025-05-14 15:03:09.087",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053629",
        "positionId": "56053628",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53090515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09.292",
        "brokerTime": "2025-05-14 15:03:09.292",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053630",
        "positionId": "56053630",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53090516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09.292",
        "brokerTime": "2025-05-14 15:03:09.608",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053631",
        "positionId": "56053630",
        "volume": 8.28,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53090517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09.739",
        "brokerTime": "2025-05-14 15:03:09.739",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053632",
        "positionId": "56053632",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53090518",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:09.739",
        "brokerTime": "2025-05-14 15:03:10.124",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053633",
        "positionId": "56053632",
        "volume": 8.28,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -256.68,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53090519",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:10.558",
        "brokerTime": "2025-05-14 15:03:10.558",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053634",
        "positionId": "56053634",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "id": "53090520",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:10.558",
        "brokerTime": "2025-05-14 15:03:11.663",
        "commission": -57.96,
        "swap": 0,
        "profit": -298.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053635",
        "positionId": "56053634",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -356.03999999999996,
        "takeProfit": null,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "id": "53090521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:11.911",
        "brokerTime": "2025-05-14 15:03:11.911",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053636",
        "positionId": "56053636",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53090522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:11.911",
        "brokerTime": "2025-05-14 15:03:12.475",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053637",
        "positionId": "56053636",
        "volume": 8.28,
        "price": 3221.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53090523",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:12.704",
        "brokerTime": "2025-05-14 15:03:12.704",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053638",
        "positionId": "56053638",
        "volume": 8.28,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53090525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:12.704",
        "brokerTime": "2025-05-14 15:03:13.270",
        "commission": -57.96,
        "swap": 0,
        "profit": -16.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053640",
        "positionId": "56053638",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.52,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53090526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:13.727",
        "brokerTime": "2025-05-14 15:03:13.727",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053641",
        "positionId": "56053641",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "id": "53090527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:13.727",
        "brokerTime": "2025-05-14 15:03:14.253",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053642",
        "positionId": "56053641",
        "volume": 8.28,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -132.48,
        "takeProfit": null,
        "priceIn": 3221.02,
        "doubleCheck": true
    },
    {
        "id": "53090528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:14.878",
        "brokerTime": "2025-05-14 15:03:14.878",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053643",
        "positionId": "56053643",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:14.878",
        "brokerTime": "2025-05-14 15:03:15.394",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053644",
        "positionId": "56053643",
        "volume": 8.28,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:15.671",
        "brokerTime": "2025-05-14 15:03:15.671",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053645",
        "positionId": "56053645",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53090531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:15.671",
        "brokerTime": "2025-05-14 15:03:15.970",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053646",
        "positionId": "56053645",
        "volume": 8.28,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53090532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16.372",
        "brokerTime": "2025-05-14 15:03:16.372",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053647",
        "positionId": "56053647",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53090533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:16.372",
        "brokerTime": "2025-05-14 15:03:16.930",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053648",
        "positionId": "56053647",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53090535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:17.303",
        "brokerTime": "2025-05-14 15:03:17.303",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053650",
        "positionId": "56053650",
        "volume": 8.28,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53090536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:17.303",
        "brokerTime": "2025-05-14 15:03:18.058",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053651",
        "positionId": "56053650",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53090537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:18.629",
        "brokerTime": "2025-05-14 15:03:18.629",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053652",
        "positionId": "56053652",
        "volume": 8.28,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53090538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:18.629",
        "brokerTime": "2025-05-14 15:03:19.443",
        "commission": -57.96,
        "swap": 0,
        "profit": -480.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053653",
        "positionId": "56053652",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -538.2,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53090539",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:19.784",
        "brokerTime": "2025-05-14 15:03:19.784",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053654",
        "positionId": "56053654",
        "volume": 8.28,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53090540",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:19.784",
        "brokerTime": "2025-05-14 15:03:20.226",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053655",
        "positionId": "56053654",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53090541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:21.437",
        "brokerTime": "2025-05-14 15:03:21.437",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053656",
        "positionId": "56053656",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090542",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:21.437",
        "brokerTime": "2025-05-14 15:03:21.849",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053657",
        "positionId": "56053656",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -331.2,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090543",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:22.182",
        "brokerTime": "2025-05-14 15:03:22.182",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053658",
        "positionId": "56053658",
        "volume": 8.28,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53090546",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:22.182",
        "brokerTime": "2025-05-14 15:03:23.021",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053660",
        "positionId": "56053658",
        "volume": 8.28,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -289.8,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53090547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:23.212",
        "brokerTime": "2025-05-14 15:03:23.212",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053661",
        "positionId": "56053661",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090564",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:23.212",
        "brokerTime": "2025-05-14 15:03:31.997",
        "commission": -57.96,
        "swap": 0,
        "profit": -554.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053678",
        "positionId": "56053661",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -612.72,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090565",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:32.313",
        "brokerTime": "2025-05-14 15:03:32.313",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053679",
        "positionId": "56053679",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "id": "53090566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:32.313",
        "brokerTime": "2025-05-14 15:03:33.023",
        "commission": -57.96,
        "swap": 0,
        "profit": -16.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053680",
        "positionId": "56053679",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.52,
        "takeProfit": null,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "id": "53090567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:33.321",
        "brokerTime": "2025-05-14 15:03:33.321",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053681",
        "positionId": "56053681",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:33.321",
        "brokerTime": "2025-05-14 15:03:34.051",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053682",
        "positionId": "56053681",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:34.445",
        "brokerTime": "2025-05-14 15:03:34.445",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053683",
        "positionId": "56053683",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:34.445",
        "brokerTime": "2025-05-14 15:03:34.748",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053684",
        "positionId": "56053683",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:35.544",
        "brokerTime": "2025-05-14 15:03:35.544",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053685",
        "positionId": "56053685",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53090572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:35.544",
        "brokerTime": "2025-05-14 15:03:36.055",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053686",
        "positionId": "56053685",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53090573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36.350",
        "brokerTime": "2025-05-14 15:03:36.350",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053687",
        "positionId": "56053687",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:36.350",
        "brokerTime": "2025-05-14 15:03:36.810",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053688",
        "positionId": "56053687",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37.012",
        "brokerTime": "2025-05-14 15:03:37.012",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053694",
        "positionId": "56053694",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090584",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37.012",
        "brokerTime": "2025-05-14 15:03:37.371",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053697",
        "positionId": "56053694",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37.568",
        "brokerTime": "2025-05-14 15:03:37.568",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053701",
        "positionId": "56053701",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:37.568",
        "brokerTime": "2025-05-14 15:03:38.012",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053702",
        "positionId": "56053701",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38.238",
        "brokerTime": "2025-05-14 15:03:38.238",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053704",
        "positionId": "56053704",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53090592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38.238",
        "brokerTime": "2025-05-14 15:03:38.524",
        "commission": -57.96,
        "swap": 0,
        "profit": -405.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053705",
        "positionId": "56053704",
        "volume": 8.28,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -463.68,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53090593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38.816",
        "brokerTime": "2025-05-14 15:03:38.816",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053706",
        "positionId": "56053706",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:38.816",
        "brokerTime": "2025-05-14 15:03:39.560",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053707",
        "positionId": "56053706",
        "volume": 8.28,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:40.057",
        "brokerTime": "2025-05-14 15:03:40.057",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053708",
        "positionId": "56053708",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:40.057",
        "brokerTime": "2025-05-14 15:03:40.996",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053710",
        "positionId": "56053708",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:41.287",
        "brokerTime": "2025-05-14 15:03:41.287",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053711",
        "positionId": "56053711",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:41.287",
        "brokerTime": "2025-05-14 15:03:41.709",
        "commission": -57.96,
        "swap": 0,
        "profit": -57.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053712",
        "positionId": "56053711",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -115.92,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090600",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42.081",
        "brokerTime": "2025-05-14 15:03:42.081",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053713",
        "positionId": "56053713",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "id": "53090601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42.081",
        "brokerTime": "2025-05-14 15:03:42.440",
        "commission": -57.96,
        "swap": 0,
        "profit": 33.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053714",
        "positionId": "56053713",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -24.840000000000003,
        "takeProfit": null,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "id": "53090602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42.961",
        "brokerTime": "2025-05-14 15:03:42.961",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053715",
        "positionId": "56053715",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:42.961",
        "brokerTime": "2025-05-14 15:03:43.347",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053716",
        "positionId": "56053715",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:43.739",
        "brokerTime": "2025-05-14 15:03:43.739",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053751",
        "positionId": "56053751",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:43.739",
        "brokerTime": "2025-05-14 15:03:44.138",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053752",
        "positionId": "56053751",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44.336",
        "brokerTime": "2025-05-14 15:03:44.336",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053753",
        "positionId": "56053753",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:44.336",
        "brokerTime": "2025-05-14 15:03:44.904",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053754",
        "positionId": "56053753",
        "volume": 8.28,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -389.15999999999997,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090648",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45.218",
        "brokerTime": "2025-05-14 15:03:45.218",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053755",
        "positionId": "56053755",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45.218",
        "brokerTime": "2025-05-14 15:03:45.564",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053756",
        "positionId": "56053755",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45.880",
        "brokerTime": "2025-05-14 15:03:45.880",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053757",
        "positionId": "56053757",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090652",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:45.880",
        "brokerTime": "2025-05-14 15:03:46.252",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053759",
        "positionId": "56053757",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47.049",
        "brokerTime": "2025-05-14 15:03:47.049",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053760",
        "positionId": "56053760",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53090655",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47.049",
        "brokerTime": "2025-05-14 15:03:47.401",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053762",
        "positionId": "56053760",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53090657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47.981",
        "brokerTime": "2025-05-14 15:03:47.981",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053764",
        "positionId": "56053764",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:47.981",
        "brokerTime": "2025-05-14 15:03:48.517",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053782",
        "positionId": "56053764",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:48.722",
        "brokerTime": "2025-05-14 15:03:48.722",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053784",
        "positionId": "56053784",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:48.722",
        "brokerTime": "2025-05-14 15:03:49.302",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053786",
        "positionId": "56053784",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273.24,
        "takeProfit": null,
        "priceIn": 3221.66,
        "doubleCheck": true
    },
    {
        "id": "53090681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:49.873",
        "brokerTime": "2025-05-14 15:03:49.873",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053787",
        "positionId": "56053787",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53090682",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:49.873",
        "brokerTime": "2025-05-14 15:03:50.297",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053788",
        "positionId": "56053787",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53090683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:50.950",
        "brokerTime": "2025-05-14 15:03:50.950",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053789",
        "positionId": "56053789",
        "volume": 8.28,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53090684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:50.950",
        "brokerTime": "2025-05-14 15:03:51.554",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053790",
        "positionId": "56053789",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53090685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:51.859",
        "brokerTime": "2025-05-14 15:03:51.859",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053791",
        "positionId": "56053791",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:51.859",
        "brokerTime": "2025-05-14 15:03:52.622",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053792",
        "positionId": "56053791",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -289.8,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:53.083",
        "brokerTime": "2025-05-14 15:03:53.083",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053793",
        "positionId": "56053793",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53090688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:53.083",
        "brokerTime": "2025-05-14 15:03:53.880",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053794",
        "positionId": "56053793",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53090689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:54.251",
        "brokerTime": "2025-05-14 15:03:54.251",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053795",
        "positionId": "56053795",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:54.251",
        "brokerTime": "2025-05-14 15:03:54.588",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053796",
        "positionId": "56053795",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:55.002",
        "brokerTime": "2025-05-14 15:03:55.002",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053797",
        "positionId": "56053797",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:55.002",
        "brokerTime": "2025-05-14 15:03:56.073",
        "commission": -57.96,
        "swap": 0,
        "profit": -397.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053799",
        "positionId": "56053797",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -455.4,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53090694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:56.378",
        "brokerTime": "2025-05-14 15:03:56.378",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053800",
        "positionId": "56053800",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53090695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:56.378",
        "brokerTime": "2025-05-14 15:03:56.821",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053801",
        "positionId": "56053800",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53090696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:57.199",
        "brokerTime": "2025-05-14 15:03:57.199",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053802",
        "positionId": "56053802",
        "volume": 8.28,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53090697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:57.199",
        "brokerTime": "2025-05-14 15:03:57.734",
        "commission": -57.96,
        "swap": 0,
        "profit": 124.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053803",
        "positionId": "56053802",
        "volume": 8.28,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 66.24000000000001,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53090698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:58.407",
        "brokerTime": "2025-05-14 15:03:58.407",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053804",
        "positionId": "56053804",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53090699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:58.407",
        "brokerTime": "2025-05-14 15:03:58.824",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053805",
        "positionId": "56053804",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53090700",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:59.758",
        "brokerTime": "2025-05-14 15:03:59.758",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053806",
        "positionId": "56053806",
        "volume": 8.28,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53090703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:59.758",
        "brokerTime": "2025-05-14 15:04:00.588",
        "commission": -57.96,
        "swap": 0,
        "profit": -41.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053809",
        "positionId": "56053806",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -99.36,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53090705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:00.818",
        "brokerTime": "2025-05-14 15:04:00.818",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053811",
        "positionId": "56053811",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53090706",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:00.818",
        "brokerTime": "2025-05-14 15:04:01.146",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053812",
        "positionId": "56053811",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53090707",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:01.644",
        "brokerTime": "2025-05-14 15:04:01.644",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053813",
        "positionId": "56053813",
        "volume": 8.28,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53090709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:01.644",
        "brokerTime": "2025-05-14 15:04:02.104",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053818",
        "positionId": "56053813",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53090734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02.440",
        "brokerTime": "2025-05-14 15:04:02.440",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053840",
        "positionId": "56053840",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:02.440",
        "brokerTime": "2025-05-14 15:04:03.142",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053853",
        "positionId": "56053840",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -331.2,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:03.773",
        "brokerTime": "2025-05-14 15:04:03.773",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053859",
        "positionId": "56053859",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:03.773",
        "brokerTime": "2025-05-14 15:04:04.351",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053862",
        "positionId": "56053859",
        "volume": 8.28,
        "price": 3221.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:04.664",
        "brokerTime": "2025-05-14 15:04:04.664",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053864",
        "positionId": "56053864",
        "volume": 8.28,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.9,
        "doubleCheck": true
    },
    {
        "id": "53090779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:04.664",
        "brokerTime": "2025-05-14 15:04:04.964",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053867",
        "positionId": "56053864",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.9,
        "doubleCheck": true
    },
    {
        "id": "53090782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05.218",
        "brokerTime": "2025-05-14 15:04:05.218",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053868",
        "positionId": "56053868",
        "volume": 8.28,
        "price": 3221.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53090783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:05.218",
        "brokerTime": "2025-05-14 15:04:06.086",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053869",
        "positionId": "56053868",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -82.8,
        "takeProfit": null,
        "priceIn": 3221.89,
        "doubleCheck": true
    },
    {
        "id": "53090784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:06.344",
        "brokerTime": "2025-05-14 15:04:06.344",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053870",
        "positionId": "56053870",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:06.344",
        "brokerTime": "2025-05-14 15:04:06.983",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053871",
        "positionId": "56053870",
        "volume": 8.28,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:07.572",
        "brokerTime": "2025-05-14 15:04:07.572",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053872",
        "positionId": "56053872",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:07.572",
        "brokerTime": "2025-05-14 15:04:08.067",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053873",
        "positionId": "56053872",
        "volume": 8.28,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:08.609",
        "brokerTime": "2025-05-14 15:04:08.609",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053874",
        "positionId": "56053874",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53090789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:08.609",
        "brokerTime": "2025-05-14 15:04:09.078",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053875",
        "positionId": "56053874",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322.91999999999996,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53090790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09.399",
        "brokerTime": "2025-05-14 15:04:09.399",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053876",
        "positionId": "56053876",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53090791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:09.399",
        "brokerTime": "2025-05-14 15:04:09.826",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053877",
        "positionId": "56053876",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53090792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10.136",
        "brokerTime": "2025-05-14 15:04:10.136",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053880",
        "positionId": "56053880",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53090794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10.136",
        "brokerTime": "2025-05-14 15:04:10.572",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053881",
        "positionId": "56053880",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53090795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10.982",
        "brokerTime": "2025-05-14 15:04:10.982",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053882",
        "positionId": "56053882",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53090796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:10.982",
        "brokerTime": "2025-05-14 15:04:12.034",
        "commission": -57.96,
        "swap": 0,
        "profit": -240.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053883",
        "positionId": "56053882",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.08,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53090797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:12.625",
        "brokerTime": "2025-05-14 15:04:12.625",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053884",
        "positionId": "56053884",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53090799",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:12.625",
        "brokerTime": "2025-05-14 15:04:13.545",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053886",
        "positionId": "56053884",
        "volume": 8.28,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53090802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:13.920",
        "brokerTime": "2025-05-14 15:04:13.920",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053889",
        "positionId": "56053889",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:13.920",
        "brokerTime": "2025-05-14 15:04:14.395",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053894",
        "positionId": "56053889",
        "volume": 8.28,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -372.59999999999997,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:14.921",
        "brokerTime": "2025-05-14 15:04:14.921",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053895",
        "positionId": "56053895",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:14.921",
        "brokerTime": "2025-05-14 15:04:15.468",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053896",
        "positionId": "56053895",
        "volume": 8.28,
        "price": 3222.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16.141",
        "brokerTime": "2025-05-14 15:04:16.141",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053897",
        "positionId": "56053897",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16.141",
        "brokerTime": "2025-05-14 15:04:16.617",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053898",
        "positionId": "56053897",
        "volume": 8.28,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53090812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16.930",
        "brokerTime": "2025-05-14 15:04:16.930",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053899",
        "positionId": "56053899",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:16.930",
        "brokerTime": "2025-05-14 15:04:17.291",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053901",
        "positionId": "56053899",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:17.659",
        "brokerTime": "2025-05-14 15:04:17.659",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053902",
        "positionId": "56053902",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53090817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:17.659",
        "brokerTime": "2025-05-14 15:04:18.618",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053903",
        "positionId": "56053902",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53090818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:19.022",
        "brokerTime": "2025-05-14 15:04:19.022",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053904",
        "positionId": "56053904",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "id": "53090819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:19.022",
        "brokerTime": "2025-05-14 15:04:19.731",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053905",
        "positionId": "56053904",
        "volume": 8.28,
        "price": 3221.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3221.71,
        "doubleCheck": true
    },
    {
        "id": "53090820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:20.516",
        "brokerTime": "2025-05-14 15:04:20.516",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053906",
        "positionId": "56053906",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:20.516",
        "brokerTime": "2025-05-14 15:04:21.364",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053907",
        "positionId": "56053906",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:21.641",
        "brokerTime": "2025-05-14 15:04:21.641",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053908",
        "positionId": "56053908",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:21.641",
        "brokerTime": "2025-05-14 15:04:21.967",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053909",
        "positionId": "56053908",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.04,
        "takeProfit": null,
        "priceIn": 3221.72,
        "doubleCheck": true
    },
    {
        "id": "53090825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:22.541",
        "brokerTime": "2025-05-14 15:04:22.541",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053911",
        "positionId": "56053911",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53090826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:22.541",
        "brokerTime": "2025-05-14 15:04:22.796",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053912",
        "positionId": "56053911",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322.91999999999996,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53090827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23.049",
        "brokerTime": "2025-05-14 15:04:23.049",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053913",
        "positionId": "56053913",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53090830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:23.049",
        "brokerTime": "2025-05-14 15:04:24.700",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053915",
        "positionId": "56053913",
        "volume": 8.28,
        "price": 3221.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53090831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:24.924",
        "brokerTime": "2025-05-14 15:04:24.924",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053916",
        "positionId": "56053916",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53090832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:24.924",
        "brokerTime": "2025-05-14 15:04:25.568",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053917",
        "positionId": "56053916",
        "volume": 8.28,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -107.64,
        "takeProfit": null,
        "priceIn": 3221.77,
        "doubleCheck": true
    },
    {
        "id": "53090833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:25.830",
        "brokerTime": "2025-05-14 15:04:25.830",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053918",
        "positionId": "56053918",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53090834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:25.830",
        "brokerTime": "2025-05-14 15:04:26.152",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053919",
        "positionId": "56053918",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53090835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:26.561",
        "brokerTime": "2025-05-14 15:04:26.561",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053920",
        "positionId": "56053920",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:26.561",
        "brokerTime": "2025-05-14 15:04:27.394",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053922",
        "positionId": "56053920",
        "volume": 8.28,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53090838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:28.087",
        "brokerTime": "2025-05-14 15:04:28.087",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053923",
        "positionId": "56053923",
        "volume": 8.28,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:28.087",
        "brokerTime": "2025-05-14 15:04:28.790",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053924",
        "positionId": "56053923",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53090840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:29.697",
        "brokerTime": "2025-05-14 15:04:29.697",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053925",
        "positionId": "56053925",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:29.697",
        "brokerTime": "2025-05-14 15:04:30.040",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053926",
        "positionId": "56053925",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3221.78,
        "doubleCheck": true
    },
    {
        "id": "53090842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30.386",
        "brokerTime": "2025-05-14 15:04:30.386",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053927",
        "positionId": "56053927",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53090843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:30.386",
        "brokerTime": "2025-05-14 15:04:30.781",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053928",
        "positionId": "56053927",
        "volume": 8.28,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53090844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:31.033",
        "brokerTime": "2025-05-14 15:04:31.033",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053929",
        "positionId": "56053929",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53090845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:31.033",
        "brokerTime": "2025-05-14 15:04:31.915",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053930",
        "positionId": "56053929",
        "volume": 8.28,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -132.48,
        "takeProfit": null,
        "priceIn": 3221.73,
        "doubleCheck": true
    },
    {
        "id": "53090846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:32.371",
        "brokerTime": "2025-05-14 15:04:32.371",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053931",
        "positionId": "56053931",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53090847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:32.371",
        "brokerTime": "2025-05-14 15:04:33.002",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053932",
        "positionId": "56053931",
        "volume": 8.28,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53090849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:34.541",
        "brokerTime": "2025-05-14 15:04:34.541",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053934",
        "positionId": "56053934",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53090850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:34.541",
        "brokerTime": "2025-05-14 15:04:34.889",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053935",
        "positionId": "56053934",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53090851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35.091",
        "brokerTime": "2025-05-14 15:04:35.091",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053936",
        "positionId": "56053936",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:35.091",
        "brokerTime": "2025-05-14 15:04:35.427",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053937",
        "positionId": "56053936",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53090853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:36.491",
        "brokerTime": "2025-05-14 15:04:36.491",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053938",
        "positionId": "56053938",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53090854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:36.491",
        "brokerTime": "2025-05-14 15:04:36.752",
        "commission": -57.96,
        "swap": 0,
        "profit": 57.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053939",
        "positionId": "56053938",
        "volume": 8.28,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3221.68,
        "doubleCheck": true
    },
    {
        "id": "53090855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37.201",
        "brokerTime": "2025-05-14 15:04:37.201",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053940",
        "positionId": "56053940",
        "volume": 8.28,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37.201",
        "brokerTime": "2025-05-14 15:04:37.686",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053941",
        "positionId": "56053940",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3221.48,
        "doubleCheck": true
    },
    {
        "id": "53090857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37.904",
        "brokerTime": "2025-05-14 15:04:37.904",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053942",
        "positionId": "56053942",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53090859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:37.904",
        "brokerTime": "2025-05-14 15:04:38.422",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053944",
        "positionId": "56053942",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53090866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40.070",
        "brokerTime": "2025-05-14 15:04:40.070",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053951",
        "positionId": "56053951",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53090869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40.070",
        "brokerTime": "2025-05-14 15:04:40.532",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053954",
        "positionId": "56053951",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53090870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40.757",
        "brokerTime": "2025-05-14 15:04:40.757",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053955",
        "positionId": "56053955",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:40.757",
        "brokerTime": "2025-05-14 15:04:41.108",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053957",
        "positionId": "56053955",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53090874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:41.885",
        "brokerTime": "2025-05-14 15:04:41.885",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053959",
        "positionId": "56053959",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53090875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:41.885",
        "brokerTime": "2025-05-14 15:04:42.409",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053960",
        "positionId": "56053959",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53090876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:42.735",
        "brokerTime": "2025-05-14 15:04:42.735",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053961",
        "positionId": "56053961",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53090877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:42.735",
        "brokerTime": "2025-05-14 15:04:43.116",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053962",
        "positionId": "56053961",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53090878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43.467",
        "brokerTime": "2025-05-14 15:04:43.467",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053963",
        "positionId": "56053963",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:43.467",
        "brokerTime": "2025-05-14 15:04:43.994",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053964",
        "positionId": "56053963",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:44.233",
        "brokerTime": "2025-05-14 15:04:44.233",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053965",
        "positionId": "56053965",
        "volume": 8.28,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53090881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:44.233",
        "brokerTime": "2025-05-14 15:04:44.721",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053966",
        "positionId": "56053965",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53090882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:45.366",
        "brokerTime": "2025-05-14 15:04:45.366",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053967",
        "positionId": "56053967",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:45.366",
        "brokerTime": "2025-05-14 15:04:46.070",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053968",
        "positionId": "56053967",
        "volume": 8.28,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:46.776",
        "brokerTime": "2025-05-14 15:04:46.776",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053969",
        "positionId": "56053969",
        "volume": 8.28,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53090885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:46.776",
        "brokerTime": "2025-05-14 15:04:47.322",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053970",
        "positionId": "56053969",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53090886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:48.080",
        "brokerTime": "2025-05-14 15:04:48.080",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053971",
        "positionId": "56053971",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53090887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:48.080",
        "brokerTime": "2025-05-14 15:04:48.750",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053972",
        "positionId": "56053971",
        "volume": 8.28,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.44,
        "doubleCheck": true
    },
    {
        "id": "53090888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49.003",
        "brokerTime": "2025-05-14 15:04:49.003",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053973",
        "positionId": "56053973",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49.003",
        "brokerTime": "2025-05-14 15:04:49.564",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053976",
        "positionId": "56053973",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.4,
        "doubleCheck": true
    },
    {
        "id": "53090892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49.902",
        "brokerTime": "2025-05-14 15:04:49.902",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053977",
        "positionId": "56053977",
        "volume": 8.28,
        "price": 3221.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53090893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:49.902",
        "brokerTime": "2025-05-14 15:04:50.582",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053978",
        "positionId": "56053977",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3221.39,
        "doubleCheck": true
    },
    {
        "id": "53090894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:51.289",
        "brokerTime": "2025-05-14 15:04:51.289",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053979",
        "positionId": "56053979",
        "volume": 8.28,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:51.289",
        "brokerTime": "2025-05-14 15:04:51.598",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053982",
        "positionId": "56053979",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53090898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:53.009",
        "brokerTime": "2025-05-14 15:04:53.009",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053983",
        "positionId": "56053983",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53090899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:53.009",
        "brokerTime": "2025-05-14 15:04:54.145",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053984",
        "positionId": "56053983",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53090900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:54.305",
        "brokerTime": "2025-05-14 15:04:54.305",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053985",
        "positionId": "56053985",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53090902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:54.305",
        "brokerTime": "2025-05-14 15:04:55.103",
        "commission": -57.96,
        "swap": 0,
        "profit": 41.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053987",
        "positionId": "56053985",
        "volume": 8.28,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.560000000000002,
        "takeProfit": null,
        "priceIn": 3221.37,
        "doubleCheck": true
    },
    {
        "id": "53090903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:55.600",
        "brokerTime": "2025-05-14 15:04:55.600",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053988",
        "positionId": "56053988",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "id": "53090904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:55.600",
        "brokerTime": "2025-05-14 15:04:55.916",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053989",
        "positionId": "56053988",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "id": "53090907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56.406",
        "brokerTime": "2025-05-14 15:04:56.406",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053992",
        "positionId": "56053992",
        "volume": 8.28,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53090908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:56.406",
        "brokerTime": "2025-05-14 15:04:56.973",
        "commission": -57.96,
        "swap": 0,
        "profit": -82.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053993",
        "positionId": "56053992",
        "volume": 8.28,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140.76,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53090909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:57.330",
        "brokerTime": "2025-05-14 15:04:57.330",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053994",
        "positionId": "56053994",
        "volume": 8.28,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53090910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:57.330",
        "brokerTime": "2025-05-14 15:04:57.855",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053995",
        "positionId": "56053994",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -372.59999999999997,
        "takeProfit": null,
        "priceIn": 3220.46,
        "doubleCheck": true
    },
    {
        "id": "53090911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58.114",
        "brokerTime": "2025-05-14 15:04:58.114",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053996",
        "positionId": "56053996",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "id": "53090912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58.114",
        "brokerTime": "2025-05-14 15:04:58.734",
        "commission": -57.96,
        "swap": 0,
        "profit": -289.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053997",
        "positionId": "56053996",
        "volume": 8.28,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -347.76,
        "takeProfit": null,
        "priceIn": 3220.66,
        "doubleCheck": true
    },
    {
        "id": "53090913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58.967",
        "brokerTime": "2025-05-14 15:04:58.967",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56053998",
        "positionId": "56053998",
        "volume": 8.28,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "id": "53090918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:58.967",
        "brokerTime": "2025-05-14 15:04:59.284",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054003",
        "positionId": "56053998",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3220.82,
        "doubleCheck": true
    },
    {
        "id": "53090919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:59.713",
        "brokerTime": "2025-05-14 15:04:59.713",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054004",
        "positionId": "56054004",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53090921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:04:59.713",
        "brokerTime": "2025-05-14 15:05:00.118",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054007",
        "positionId": "56054004",
        "volume": 8.28,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -289.8,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53090925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:00.668",
        "brokerTime": "2025-05-14 15:05:00.668",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054010",
        "positionId": "56054010",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:00.668",
        "brokerTime": "2025-05-14 15:05:01.368",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054011",
        "positionId": "56054010",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -289.8,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53090927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:02.022",
        "brokerTime": "2025-05-14 15:05:02.022",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054012",
        "positionId": "56054012",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53090928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:02.022",
        "brokerTime": "2025-05-14 15:05:02.785",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054014",
        "positionId": "56054012",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53090929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03.212",
        "brokerTime": "2025-05-14 15:05:03.212",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054015",
        "positionId": "56054015",
        "volume": 8.28,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53090930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03.212",
        "brokerTime": "2025-05-14 15:05:03.636",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054016",
        "positionId": "56054015",
        "volume": 8.28,
        "price": 3221.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53090931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03.895",
        "brokerTime": "2025-05-14 15:05:03.895",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054017",
        "positionId": "56054017",
        "volume": 8.28,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53090932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:03.895",
        "brokerTime": "2025-05-14 15:05:04.273",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054018",
        "positionId": "56054017",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.23,
        "doubleCheck": true
    },
    {
        "id": "53090934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:04.764",
        "brokerTime": "2025-05-14 15:05:04.764",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054020",
        "positionId": "56054020",
        "volume": 8.28,
        "price": 3221.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.25,
        "doubleCheck": true
    },
    {
        "id": "53090935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:04.764",
        "brokerTime": "2025-05-14 15:05:05.105",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054021",
        "positionId": "56054020",
        "volume": 8.28,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3221.25,
        "doubleCheck": true
    },
    {
        "id": "53090936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:05.585",
        "brokerTime": "2025-05-14 15:05:05.585",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054022",
        "positionId": "56054022",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53090937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:05.585",
        "brokerTime": "2025-05-14 15:05:05.924",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054023",
        "positionId": "56054022",
        "volume": 8.28,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53090940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06.215",
        "brokerTime": "2025-05-14 15:05:06.215",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054026",
        "positionId": "56054026",
        "volume": 8.28,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "id": "53090941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:06.215",
        "brokerTime": "2025-05-14 15:05:06.609",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054027",
        "positionId": "56054026",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.04,
        "takeProfit": null,
        "priceIn": 3221.34,
        "doubleCheck": true
    },
    {
        "id": "53090942",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07.144",
        "brokerTime": "2025-05-14 15:05:07.144",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054028",
        "positionId": "56054028",
        "volume": 8.28,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07.144",
        "brokerTime": "2025-05-14 15:05:07.698",
        "commission": -57.96,
        "swap": 0,
        "profit": -33.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054029",
        "positionId": "56054028",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -91.08,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53090944",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07.949",
        "brokerTime": "2025-05-14 15:05:07.949",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054030",
        "positionId": "56054030",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53090945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:07.949",
        "brokerTime": "2025-05-14 15:05:08.744",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054031",
        "positionId": "56054030",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53090946",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:09.315",
        "brokerTime": "2025-05-14 15:05:09.315",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054032",
        "positionId": "56054032",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "id": "53090947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:09.315",
        "brokerTime": "2025-05-14 15:05:10.347",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054033",
        "positionId": "56054032",
        "volume": 8.28,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3220.87,
        "doubleCheck": true
    },
    {
        "id": "53090948",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:11.274",
        "brokerTime": "2025-05-14 15:05:11.274",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054034",
        "positionId": "56054034",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53090949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:11.274",
        "brokerTime": "2025-05-14 15:05:11.956",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054035",
        "positionId": "56054034",
        "volume": 8.28,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53090950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:12.755",
        "brokerTime": "2025-05-14 15:05:12.755",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054036",
        "positionId": "56054036",
        "volume": 8.28,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "id": "53090951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:12.755",
        "brokerTime": "2025-05-14 15:05:13.105",
        "commission": -57.96,
        "swap": 0,
        "profit": -66.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054037",
        "positionId": "56054036",
        "volume": 8.28,
        "price": 3221.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -124.19999999999999,
        "takeProfit": null,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "id": "53090952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:13.738",
        "brokerTime": "2025-05-14 15:05:13.738",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054038",
        "positionId": "56054038",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53090953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:13.738",
        "brokerTime": "2025-05-14 15:05:14.246",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054039",
        "positionId": "56054038",
        "volume": 8.28,
        "price": 3221,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53090954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:14.523",
        "brokerTime": "2025-05-14 15:05:14.523",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054040",
        "positionId": "56054040",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53090955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:14.523",
        "brokerTime": "2025-05-14 15:05:14.784",
        "commission": -57.96,
        "swap": 0,
        "profit": 356.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054041",
        "positionId": "56054040",
        "volume": 8.28,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 298.08000000000004,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53090956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15.187",
        "brokerTime": "2025-05-14 15:05:15.187",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054042",
        "positionId": "56054042",
        "volume": 8.28,
        "price": 3219.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.99,
        "doubleCheck": true
    },
    {
        "id": "53090957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:15.187",
        "brokerTime": "2025-05-14 15:05:15.939",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054043",
        "positionId": "56054042",
        "volume": 8.28,
        "price": 3220.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3219.99,
        "doubleCheck": true
    },
    {
        "id": "53090959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:16.347",
        "brokerTime": "2025-05-14 15:05:16.347",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054045",
        "positionId": "56054045",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53090960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:16.347",
        "brokerTime": "2025-05-14 15:05:16.989",
        "commission": -57.96,
        "swap": 0,
        "profit": -587.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054046",
        "positionId": "56054045",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -645.84,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53090961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:17.538",
        "brokerTime": "2025-05-14 15:05:17.538",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054047",
        "positionId": "56054047",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53090962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:17.538",
        "brokerTime": "2025-05-14 15:05:18.639",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054048",
        "positionId": "56054047",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -107.64,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53090963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:18.826",
        "brokerTime": "2025-05-14 15:05:18.826",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054049",
        "positionId": "56054049",
        "volume": 8.28,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.55,
        "doubleCheck": true
    },
    {
        "id": "53090964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:18.826",
        "brokerTime": "2025-05-14 15:05:19.918",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054050",
        "positionId": "56054049",
        "volume": 8.28,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3220.55,
        "doubleCheck": true
    },
    {
        "id": "53090965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20.111",
        "brokerTime": "2025-05-14 15:05:20.111",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054051",
        "positionId": "56054051",
        "volume": 8.28,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53090966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20.111",
        "brokerTime": "2025-05-14 15:05:20.553",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054052",
        "positionId": "56054051",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53090967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20.914",
        "brokerTime": "2025-05-14 15:05:20.914",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054053",
        "positionId": "56054053",
        "volume": 8.28,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53090968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:20.914",
        "brokerTime": "2025-05-14 15:05:21.436",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054054",
        "positionId": "56054053",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53090969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:21.626",
        "brokerTime": "2025-05-14 15:05:21.626",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054055",
        "positionId": "56054055",
        "volume": 8.28,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53090970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:21.626",
        "brokerTime": "2025-05-14 15:05:22.157",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054056",
        "positionId": "56054055",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53090971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:22.798",
        "brokerTime": "2025-05-14 15:05:22.798",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054057",
        "positionId": "56054057",
        "volume": 8.28,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53090972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:22.798",
        "brokerTime": "2025-05-14 15:05:23.459",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054058",
        "positionId": "56054057",
        "volume": 8.28,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -256.68,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53090973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:23.741",
        "brokerTime": "2025-05-14 15:05:23.741",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054059",
        "positionId": "56054059",
        "volume": 8.28,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53090974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:23.741",
        "brokerTime": "2025-05-14 15:05:24.922",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054060",
        "positionId": "56054059",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -107.64,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53090975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25.159",
        "brokerTime": "2025-05-14 15:05:25.159",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054061",
        "positionId": "56054061",
        "volume": 8.28,
        "price": 3220.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53090976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25.159",
        "brokerTime": "2025-05-14 15:05:25.545",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054062",
        "positionId": "56054061",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3220.57,
        "doubleCheck": true
    },
    {
        "id": "53090977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25.745",
        "brokerTime": "2025-05-14 15:05:25.745",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054063",
        "positionId": "56054063",
        "volume": 8.28,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53090978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:25.745",
        "brokerTime": "2025-05-14 15:05:26.137",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054064",
        "positionId": "56054063",
        "volume": 8.28,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53090979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:26.807",
        "brokerTime": "2025-05-14 15:05:26.807",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054065",
        "positionId": "56054065",
        "volume": 8.28,
        "price": 3220.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.65,
        "doubleCheck": true
    },
    {
        "id": "53090980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:26.807",
        "brokerTime": "2025-05-14 15:05:27.677",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054066",
        "positionId": "56054065",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -107.64,
        "takeProfit": null,
        "priceIn": 3220.65,
        "doubleCheck": true
    },
    {
        "id": "53090981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:27.879",
        "brokerTime": "2025-05-14 15:05:27.879",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054067",
        "positionId": "56054067",
        "volume": 8.28,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53090982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:27.879",
        "brokerTime": "2025-05-14 15:05:28.479",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054068",
        "positionId": "56054067",
        "volume": 8.28,
        "price": 3220.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182.16,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53090983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:29.476",
        "brokerTime": "2025-05-14 15:05:29.476",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054069",
        "positionId": "56054069",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53090984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:29.476",
        "brokerTime": "2025-05-14 15:05:29.782",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054070",
        "positionId": "56054069",
        "volume": 8.28,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53090985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:30.303",
        "brokerTime": "2025-05-14 15:05:30.303",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054071",
        "positionId": "56054071",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53090986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:30.303",
        "brokerTime": "2025-05-14 15:05:30.756",
        "commission": -57.96,
        "swap": 0,
        "profit": 298.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054072",
        "positionId": "56054071",
        "volume": 8.28,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 240.11999999999998,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53090987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:31.643",
        "brokerTime": "2025-05-14 15:05:31.643",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054073",
        "positionId": "56054073",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "id": "53090988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:31.643",
        "brokerTime": "2025-05-14 15:05:32.101",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054074",
        "positionId": "56054073",
        "volume": 8.28,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3219.83,
        "doubleCheck": true
    },
    {
        "id": "53090991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:32.516",
        "brokerTime": "2025-05-14 15:05:32.516",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054077",
        "positionId": "56054077",
        "volume": 8.28,
        "price": 3219.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.65,
        "doubleCheck": true
    },
    {
        "id": "53090992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:32.516",
        "brokerTime": "2025-05-14 15:05:32.868",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054078",
        "positionId": "56054077",
        "volume": 8.28,
        "price": 3219.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3219.65,
        "doubleCheck": true
    },
    {
        "id": "53090993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33.239",
        "brokerTime": "2025-05-14 15:05:33.239",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054079",
        "positionId": "56054079",
        "volume": 8.28,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53090995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:33.239",
        "brokerTime": "2025-05-14 15:05:33.763",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054081",
        "positionId": "56054079",
        "volume": 8.28,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53090996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:34.134",
        "brokerTime": "2025-05-14 15:05:34.134",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054083",
        "positionId": "56054083",
        "volume": 8.28,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53090999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:34.134",
        "brokerTime": "2025-05-14 15:05:34.987",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054085",
        "positionId": "56054083",
        "volume": 8.28,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53091002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:35.436",
        "brokerTime": "2025-05-14 15:05:35.436",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054088",
        "positionId": "56054088",
        "volume": 8.28,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53091004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:35.436",
        "brokerTime": "2025-05-14 15:05:35.806",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054089",
        "positionId": "56054088",
        "volume": 8.28,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -306.36,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53091005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36.126",
        "brokerTime": "2025-05-14 15:05:36.126",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054090",
        "positionId": "56054090",
        "volume": 8.28,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53091006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36.126",
        "brokerTime": "2025-05-14 15:05:36.639",
        "commission": -57.96,
        "swap": 0,
        "profit": -231.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054091",
        "positionId": "56054090",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -289.8,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53091007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36.882",
        "brokerTime": "2025-05-14 15:05:36.882",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054092",
        "positionId": "56054092",
        "volume": 8.28,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53091008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:36.882",
        "brokerTime": "2025-05-14 15:05:37.288",
        "commission": -57.96,
        "swap": 0,
        "profit": -107.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054093",
        "positionId": "56054092",
        "volume": 8.28,
        "price": 3219.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -165.6,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53091009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:37.648",
        "brokerTime": "2025-05-14 15:05:37.648",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054094",
        "positionId": "56054094",
        "volume": 8.28,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "id": "53091010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:37.648",
        "brokerTime": "2025-05-14 15:05:38.552",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054095",
        "positionId": "56054094",
        "volume": 8.28,
        "price": 3219.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -306.36,
        "takeProfit": null,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "id": "53091012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:39.001",
        "brokerTime": "2025-05-14 15:05:39.001",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054097",
        "positionId": "56054097",
        "volume": 8.28,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53091014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:39.001",
        "brokerTime": "2025-05-14 15:05:39.566",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054099",
        "positionId": "56054097",
        "volume": 8.28,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53091016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:40.029",
        "brokerTime": "2025-05-14 15:05:40.029",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054101",
        "positionId": "56054101",
        "volume": 8.28,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53091017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:40.029",
        "brokerTime": "2025-05-14 15:05:40.620",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054102",
        "positionId": "56054101",
        "volume": 8.28,
        "price": 3220.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53091019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41.083",
        "brokerTime": "2025-05-14 15:05:41.083",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054104",
        "positionId": "56054104",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53091020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41.083",
        "brokerTime": "2025-05-14 15:05:41.462",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054105",
        "positionId": "56054104",
        "volume": 8.28,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53091021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41.904",
        "brokerTime": "2025-05-14 15:05:41.904",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054106",
        "positionId": "56054106",
        "volume": 8.28,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53091022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:41.904",
        "brokerTime": "2025-05-14 15:05:42.293",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054107",
        "positionId": "56054106",
        "volume": 8.28,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53091023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:42.781",
        "brokerTime": "2025-05-14 15:05:42.781",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054108",
        "positionId": "56054108",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53091024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:42.781",
        "brokerTime": "2025-05-14 15:05:43.128",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054109",
        "positionId": "56054108",
        "volume": 8.28,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53091025",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:35:43.242",
        "brokerTime": "2025-05-14 15:05:43.624",
        "commission": -16.8,
        "swap": 0,
        "profit": -3703.03,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054110",
        "positionId": "56048374",
        "volume": 2.4,
        "price": 2870.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3719.8300000000004,
        "takeProfit": null,
        "priceIn": 2883.77,
        "doubleCheck": false,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29",
        "tProfit": -3868.76,
        "tnProfit": -3903.06,
        "tVolume": 4.8999999999999995,
        "tTrades": 4
    },
    {
        "id": "53091026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:43.635",
        "brokerTime": "2025-05-14 15:05:43.635",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054111",
        "positionId": "56054111",
        "volume": 8.28,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53091027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:43.635",
        "brokerTime": "2025-05-14 15:05:44.114",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054112",
        "positionId": "56054111",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53091028",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44.181",
        "brokerTime": "2025-05-14 15:05:44.181",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054113",
        "positionId": "56054113",
        "volume": 0.12,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2870.25,
        "doubleCheck": true
    },
    {
        "id": "53091029",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44.483",
        "brokerTime": "2025-05-14 15:05:44.483",
        "commission": -15.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054114",
        "positionId": "56054114",
        "volume": 2.28,
        "price": 2870.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.96,
        "takeProfit": null,
        "priceIn": 2870.2,
        "doubleCheck": true
    },
    {
        "id": "53091030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:44.680",
        "brokerTime": "2025-05-14 15:05:44.680",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054115",
        "positionId": "56054115",
        "volume": 8.28,
        "price": 3220.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "id": "53091031",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44.483",
        "brokerTime": "2025-05-14 15:05:45.046",
        "commission": -15.96,
        "swap": 0,
        "profit": -43.49,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054116",
        "positionId": "56054114",
        "volume": 2.28,
        "price": 2870.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.45,
        "takeProfit": null,
        "priceIn": 2870.2,
        "doubleCheck": true
    },
    {
        "id": "53091032",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:44.181",
        "brokerTime": "2025-05-14 15:05:45.067",
        "commission": -0.84,
        "swap": 0,
        "profit": -2.96,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054117",
        "positionId": "56054113",
        "volume": 0.12,
        "price": 2870.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.03,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.8,
        "priceIn": 2870.25,
        "doubleCheck": true
    },
    {
        "id": "53091033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:27:24.845",
        "brokerTime": "2025-05-14 15:05:45.089",
        "commission": -3.01,
        "swap": 0,
        "profit": 776.38,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054118",
        "positionId": "56048276",
        "volume": 0.43,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 773.37,
        "priceIn": 2886.34,
        "doubleCheck": false,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31",
        "tProfit": 2932.43,
        "tnProfit": 2907.02,
        "tVolume": 3.630000000000001,
        "tTrades": 14
    },
    {
        "id": "53091034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:17:16.656",
        "brokerTime": "2025-05-14 15:05:45.105",
        "commission": -2.52,
        "swap": 0,
        "profit": 609.19,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054119",
        "positionId": "56034354",
        "volume": 0.36,
        "price": 2870.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 606.6700000000001,
        "priceIn": 2885.33,
        "doubleCheck": false
    },
    {
        "id": "53091035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:15:56.154",
        "brokerTime": "2025-05-14 15:05:45.149",
        "commission": -2.1,
        "swap": 0,
        "profit": 472.31,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054120",
        "positionId": "56033307",
        "volume": 0.3,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 470.21,
        "priceIn": 2884.25,
        "doubleCheck": false
    },
    {
        "id": "53091036",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:13:35.067",
        "brokerTime": "2025-05-14 15:05:45.211",
        "commission": -1.75,
        "swap": 0,
        "profit": 363.01,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054121",
        "positionId": "56032846",
        "volume": 0.25,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 361.26,
        "priceIn": 2883.16,
        "doubleCheck": false
    },
    {
        "id": "53091037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 14:09:10.994",
        "brokerTime": "2025-05-14 15:05:45.267",
        "commission": -1.47,
        "swap": 0,
        "profit": 281.13,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054122",
        "positionId": "56032160",
        "volume": 0.21,
        "price": 2870.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 279.65999999999997,
        "priceIn": 2882.15,
        "doubleCheck": false
    },
    {
        "id": "53091038",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:02:39.998",
        "brokerTime": "2025-05-14 15:05:45.305",
        "commission": -0.7,
        "swap": 0,
        "profit": -119.28,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054123",
        "positionId": "56031516",
        "volume": 0.1,
        "price": 2870.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2970.03,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119.98,
        "priceIn": 2880.64,
        "doubleCheck": false
    },
    {
        "id": "53091039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:59:28.960",
        "brokerTime": "2025-05-14 15:05:45.346",
        "commission": -1.19,
        "swap": 0,
        "profit": 210.03,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054124",
        "positionId": "56030546",
        "volume": 0.17,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 208.84,
        "priceIn": 2881.09,
        "doubleCheck": false
    },
    {
        "id": "53091040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:57:58.984",
        "brokerTime": "2025-05-14 15:05:45.380",
        "commission": -0.98,
        "swap": 0,
        "profit": 156.79,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054125",
        "positionId": "56030517",
        "volume": 0.14,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 155.81,
        "priceIn": 2880.06,
        "doubleCheck": false
    },
    {
        "id": "53091041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:39:35.875",
        "brokerTime": "2025-05-14 15:05:45.399",
        "commission": -0.84,
        "swap": 0,
        "profit": 120.11,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054126",
        "positionId": "56029504",
        "volume": 0.12,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 119.27,
        "priceIn": 2879,
        "doubleCheck": false
    },
    {
        "id": "53091042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 13:20:35.318",
        "brokerTime": "2025-05-14 15:05:45.469",
        "commission": -0.7,
        "swap": 0,
        "profit": 88.65,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054127",
        "positionId": "56028231",
        "volume": 0.1,
        "price": 2870.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2786.59,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 87.95,
        "priceIn": 2877.98,
        "doubleCheck": false
    },
    {
        "id": "53091043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:44.680",
        "brokerTime": "2025-05-14 15:05:45.648",
        "commission": -57.96,
        "swap": 0,
        "profit": -33.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054128",
        "positionId": "56054115",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -91.08,
        "takeProfit": null,
        "priceIn": 3220.56,
        "doubleCheck": true
    },
    {
        "id": "53091044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:46.349",
        "brokerTime": "2025-05-14 15:05:46.349",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054129",
        "positionId": "56054129",
        "volume": 8.28,
        "price": 3220.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53091045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:46.349",
        "brokerTime": "2025-05-14 15:05:46.882",
        "commission": -57.96,
        "swap": 0,
        "profit": -281.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054130",
        "positionId": "56054129",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -339.47999999999996,
        "takeProfit": null,
        "priceIn": 3220.45,
        "doubleCheck": true
    },
    {
        "id": "53091046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:47.876",
        "brokerTime": "2025-05-14 15:05:47.876",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054131",
        "positionId": "56054131",
        "volume": 8.28,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53091047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:47.876",
        "brokerTime": "2025-05-14 15:05:48.246",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054132",
        "positionId": "56054131",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53091048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:48.813",
        "brokerTime": "2025-05-14 15:05:48.813",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054133",
        "positionId": "56054133",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53091050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:48.813",
        "brokerTime": "2025-05-14 15:05:49.121",
        "commission": -57.96,
        "swap": 0,
        "profit": -240.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054135",
        "positionId": "56054133",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.08,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53091051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49.276",
        "brokerTime": "2025-05-14 15:05:49.276",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054136",
        "positionId": "56054136",
        "volume": 8.28,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:49.276",
        "brokerTime": "2025-05-14 15:05:49.913",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054137",
        "positionId": "56054136",
        "volume": 8.28,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:50.675",
        "brokerTime": "2025-05-14 15:05:50.675",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054138",
        "positionId": "56054138",
        "volume": 8.28,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:50.675",
        "brokerTime": "2025-05-14 15:05:51.107",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054139",
        "positionId": "56054138",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:51.563",
        "brokerTime": "2025-05-14 15:05:51.563",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054141",
        "positionId": "56054141",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53091060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52.172",
        "brokerTime": "2025-05-14 15:05:52.172",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054142",
        "positionId": "56054142",
        "volume": 0.1,
        "price": 2870.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2870.67,
        "doubleCheck": true
    },
    {
        "id": "53091061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:52.204",
        "brokerTime": "2025-05-14 15:05:52.204",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054143",
        "positionId": "56054143",
        "volume": 0.1,
        "price": 2870.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2870.88,
        "doubleCheck": true
    },
    {
        "id": "53091062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:51.563",
        "brokerTime": "2025-05-14 15:05:52.917",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054144",
        "positionId": "56054141",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -132.48,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53091063",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:52.172",
        "brokerTime": "2025-05-14 15:05:53.079",
        "commission": -0.7,
        "swap": 0,
        "profit": -1.68,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054145",
        "positionId": "56054142",
        "volume": 0.1,
        "price": 2870.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.38,
        "takeProfit": null,
        "priceIn": 2870.67,
        "doubleCheck": true
    },
    {
        "id": "53091064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:53.563",
        "brokerTime": "2025-05-14 15:05:53.563",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054146",
        "positionId": "56054146",
        "volume": 8.28,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:53.563",
        "brokerTime": "2025-05-14 15:05:54.239",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054147",
        "positionId": "56054146",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:54.604",
        "brokerTime": "2025-05-14 15:05:54.604",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054148",
        "positionId": "56054148",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53091067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:54.604",
        "brokerTime": "2025-05-14 15:05:55.078",
        "commission": -57.96,
        "swap": 0,
        "profit": -132.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054149",
        "positionId": "56054148",
        "volume": 8.28,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -190.44,
        "takeProfit": null,
        "priceIn": 3220.81,
        "doubleCheck": true
    },
    {
        "id": "53091068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55.245",
        "brokerTime": "2025-05-14 15:05:55.245",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054150",
        "positionId": "56054150",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55.245",
        "brokerTime": "2025-05-14 15:05:55.646",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054151",
        "positionId": "56054150",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55.954",
        "brokerTime": "2025-05-14 15:05:55.954",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054152",
        "positionId": "56054152",
        "volume": 8.28,
        "price": 3220.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53091072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:55.954",
        "brokerTime": "2025-05-14 15:05:56.432",
        "commission": -57.96,
        "swap": 0,
        "profit": -49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054153",
        "positionId": "56054152",
        "volume": 8.28,
        "price": 3220.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -107.64,
        "takeProfit": null,
        "priceIn": 3220.79,
        "doubleCheck": true
    },
    {
        "id": "53091073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:56.651",
        "brokerTime": "2025-05-14 15:05:56.651",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054154",
        "positionId": "56054154",
        "volume": 8.28,
        "price": 3220.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53091074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:56.651",
        "brokerTime": "2025-05-14 15:05:56.991",
        "commission": -57.96,
        "swap": 0,
        "profit": -82.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054155",
        "positionId": "56054154",
        "volume": 8.28,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -140.76,
        "takeProfit": null,
        "priceIn": 3220.76,
        "doubleCheck": true
    },
    {
        "id": "53091075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:57.745",
        "brokerTime": "2025-05-14 15:05:57.745",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054156",
        "positionId": "56054156",
        "volume": 8.28,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53091076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:57.745",
        "brokerTime": "2025-05-14 15:05:58.213",
        "commission": -57.96,
        "swap": 0,
        "profit": -223.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054157",
        "positionId": "56054156",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -281.52,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53091077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:58.990",
        "brokerTime": "2025-05-14 15:05:58.990",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054158",
        "positionId": "56054158",
        "volume": 8.28,
        "price": 3220.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "id": "53091078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59.244",
        "brokerTime": "2025-05-14 15:05:59.244",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054159",
        "positionId": "56054159",
        "volume": 0.1,
        "price": 2870.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2870.69,
        "doubleCheck": true
    },
    {
        "id": "53091079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:58.990",
        "brokerTime": "2025-05-14 15:06:00.103",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054160",
        "positionId": "56054158",
        "volume": 8.28,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.74,
        "doubleCheck": true
    },
    {
        "id": "53091080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:00.507",
        "brokerTime": "2025-05-14 15:06:00.507",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054161",
        "positionId": "56054161",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53091084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:00.507",
        "brokerTime": "2025-05-14 15:06:00.974",
        "commission": -57.96,
        "swap": 0,
        "profit": 339.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054165",
        "positionId": "56054161",
        "volume": 8.28,
        "price": 3220.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 281.52000000000004,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53091085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01.362",
        "brokerTime": "2025-05-14 15:06:01.362",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054166",
        "positionId": "56054166",
        "volume": 8.28,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53091086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:01.362",
        "brokerTime": "2025-05-14 15:06:02.092",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054167",
        "positionId": "56054166",
        "volume": 8.28,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53091087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:02.598",
        "brokerTime": "2025-05-14 15:06:02.598",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054168",
        "positionId": "56054168",
        "volume": 8.28,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "id": "53091088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:02.598",
        "brokerTime": "2025-05-14 15:06:03.265",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054169",
        "positionId": "56054168",
        "volume": 8.28,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.18,
        "doubleCheck": true
    },
    {
        "id": "53091089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:03.733",
        "brokerTime": "2025-05-14 15:06:03.733",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054170",
        "positionId": "56054170",
        "volume": 8.28,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "id": "53091091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:03.733",
        "brokerTime": "2025-05-14 15:06:04.185",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054172",
        "positionId": "56054170",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3220.48,
        "doubleCheck": true
    },
    {
        "id": "53091092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04.424",
        "brokerTime": "2025-05-14 15:06:04.424",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054173",
        "positionId": "56054173",
        "volume": 8.28,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53091093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:04.424",
        "brokerTime": "2025-05-14 15:06:04.789",
        "commission": -57.96,
        "swap": 0,
        "profit": -99.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054174",
        "positionId": "56054173",
        "volume": 8.28,
        "price": 3220.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -157.32,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53091094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05.054",
        "brokerTime": "2025-05-14 15:06:05.054",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054175",
        "positionId": "56054175",
        "volume": 8.28,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53091095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05.054",
        "brokerTime": "2025-05-14 15:06:05.379",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054176",
        "positionId": "56054175",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3220.75,
        "doubleCheck": true
    },
    {
        "id": "53091096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05.743",
        "brokerTime": "2025-05-14 15:06:05.743",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054177",
        "positionId": "56054177",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53091097",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:05.743",
        "brokerTime": "2025-05-14 15:06:06.241",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054178",
        "positionId": "56054177",
        "volume": 8.28,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53091099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:07.355",
        "brokerTime": "2025-05-14 15:06:07.355",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054179",
        "positionId": "56054179",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:07.355",
        "brokerTime": "2025-05-14 15:06:07.966",
        "commission": -57.96,
        "swap": 0,
        "profit": -264.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054180",
        "positionId": "56054179",
        "volume": 8.28,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -322.91999999999996,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:08.273",
        "brokerTime": "2025-05-14 15:06:08.273",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054181",
        "positionId": "56054181",
        "volume": 8.28,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:08.273",
        "brokerTime": "2025-05-14 15:06:08.911",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054182",
        "positionId": "56054181",
        "volume": 8.28,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -82.8,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53091103",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:09.302",
        "brokerTime": "2025-05-14 15:06:09.302",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054183",
        "positionId": "56054183",
        "volume": 8.28,
        "price": 3220.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53091104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:09.302",
        "brokerTime": "2025-05-14 15:06:09.862",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054184",
        "positionId": "56054183",
        "volume": 8.28,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3220.63,
        "doubleCheck": true
    },
    {
        "id": "53091105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:10.290",
        "brokerTime": "2025-05-14 15:06:10.290",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054185",
        "positionId": "56054185",
        "volume": 8.28,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53091106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:10.290",
        "brokerTime": "2025-05-14 15:06:10.680",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054186",
        "positionId": "56054185",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182.16,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53091107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:11.015",
        "brokerTime": "2025-05-14 15:06:11.015",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054187",
        "positionId": "56054187",
        "volume": 8.28,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53091110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:11.015",
        "brokerTime": "2025-05-14 15:06:11.433",
        "commission": -57.96,
        "swap": 0,
        "profit": -298.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054189",
        "positionId": "56054187",
        "volume": 8.28,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -356.03999999999996,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53091111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:12.439",
        "brokerTime": "2025-05-14 15:06:12.439",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054190",
        "positionId": "56054190",
        "volume": 8.28,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:12.439",
        "brokerTime": "2025-05-14 15:06:13.122",
        "commission": -57.96,
        "swap": 0,
        "profit": -314.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054191",
        "positionId": "56054190",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -372.59999999999997,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:13.606",
        "brokerTime": "2025-05-14 15:06:13.606",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054192",
        "positionId": "56054192",
        "volume": 8.28,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53091114",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:13.606",
        "brokerTime": "2025-05-14 15:06:14.506",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054193",
        "positionId": "56054192",
        "volume": 8.28,
        "price": 3221.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53091115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:15.650",
        "brokerTime": "2025-05-14 15:06:15.650",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054194",
        "positionId": "56054194",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53091116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:15.650",
        "brokerTime": "2025-05-14 15:06:16.309",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054195",
        "positionId": "56054194",
        "volume": 8.28,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273.24,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53091121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:16.980",
        "brokerTime": "2025-05-14 15:06:16.980",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054200",
        "positionId": "56054200",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:16.980",
        "brokerTime": "2025-05-14 15:06:17.876",
        "commission": -57.96,
        "swap": 0,
        "profit": -91.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054202",
        "positionId": "56054200",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.04,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18.099",
        "brokerTime": "2025-05-14 15:06:18.099",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054203",
        "positionId": "56054203",
        "volume": 8.28,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53091125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18.099",
        "brokerTime": "2025-05-14 15:06:18.431",
        "commission": -57.96,
        "swap": 0,
        "profit": 49.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054204",
        "positionId": "56054203",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.280000000000001,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53091127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18.895",
        "brokerTime": "2025-05-14 15:06:18.895",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054205",
        "positionId": "56054205",
        "volume": 8.28,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:18.895",
        "brokerTime": "2025-05-14 15:06:19.616",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054207",
        "positionId": "56054205",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -132.48,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:19.952",
        "brokerTime": "2025-05-14 15:06:19.952",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054208",
        "positionId": "56054208",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53091132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:19.952",
        "brokerTime": "2025-05-14 15:06:20.526",
        "commission": -57.96,
        "swap": 0,
        "profit": -41.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054210",
        "positionId": "56054208",
        "volume": 8.28,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -99.36,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53091133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:20.861",
        "brokerTime": "2025-05-14 15:06:20.861",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054211",
        "positionId": "56054211",
        "volume": 8.28,
        "price": 3221.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.24,
        "doubleCheck": true
    },
    {
        "id": "53091134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:20.861",
        "brokerTime": "2025-05-14 15:06:21.263",
        "commission": -57.96,
        "swap": 0,
        "profit": 356.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054212",
        "positionId": "56054211",
        "volume": 8.28,
        "price": 3220.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 298.08000000000004,
        "takeProfit": null,
        "priceIn": 3221.24,
        "doubleCheck": true
    },
    {
        "id": "53091135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21.496",
        "brokerTime": "2025-05-14 15:06:21.496",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054213",
        "positionId": "56054213",
        "volume": 8.28,
        "price": 3220.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53091136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:21.496",
        "brokerTime": "2025-05-14 15:06:22.131",
        "commission": -57.96,
        "swap": 0,
        "profit": -372.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054214",
        "positionId": "56054213",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -430.56,
        "takeProfit": null,
        "priceIn": 3220.62,
        "doubleCheck": true
    },
    {
        "id": "53091137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:22.503",
        "brokerTime": "2025-05-14 15:06:22.503",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054215",
        "positionId": "56054215",
        "volume": 8.28,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53091138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:22.503",
        "brokerTime": "2025-05-14 15:06:23.100",
        "commission": -57.96,
        "swap": 0,
        "profit": -281.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054216",
        "positionId": "56054215",
        "volume": 8.28,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -339.47999999999996,
        "takeProfit": null,
        "priceIn": 3221.07,
        "doubleCheck": true
    },
    {
        "id": "53091139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:23.626",
        "brokerTime": "2025-05-14 15:06:23.626",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054217",
        "positionId": "56054217",
        "volume": 8.28,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "id": "53091140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:23.626",
        "brokerTime": "2025-05-14 15:06:24.218",
        "commission": -57.96,
        "swap": 0,
        "profit": -115.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054218",
        "positionId": "56054217",
        "volume": 8.28,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -173.88,
        "takeProfit": null,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "id": "53091141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24.402",
        "brokerTime": "2025-05-14 15:06:24.402",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054219",
        "positionId": "56054219",
        "volume": 8.28,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53091142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:24.402",
        "brokerTime": "2025-05-14 15:06:24.805",
        "commission": -57.96,
        "swap": 0,
        "profit": -74.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054220",
        "positionId": "56054219",
        "volume": 8.28,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -132.48,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53091143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:25.157",
        "brokerTime": "2025-05-14 15:06:25.157",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054221",
        "positionId": "56054221",
        "volume": 8.28,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53091145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:25.157",
        "brokerTime": "2025-05-14 15:06:26.467",
        "commission": -57.96,
        "swap": 0,
        "profit": -24.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054223",
        "positionId": "56054221",
        "volume": 8.28,
        "price": 3220.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -82.8,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53091146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:26.752",
        "brokerTime": "2025-05-14 15:06:26.752",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054224",
        "positionId": "56054224",
        "volume": 8.28,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "id": "53091147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:26.752",
        "brokerTime": "2025-05-14 15:06:27.788",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054225",
        "positionId": "56054224",
        "volume": 8.28,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -389.15999999999997,
        "takeProfit": null,
        "priceIn": 3220.71,
        "doubleCheck": true
    },
    {
        "id": "53091148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:28.162",
        "brokerTime": "2025-05-14 15:06:28.162",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054226",
        "positionId": "56054226",
        "volume": 8.28,
        "price": 3220.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.9,
        "doubleCheck": true
    },
    {
        "id": "53091149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:28.162",
        "brokerTime": "2025-05-14 15:06:29.241",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054227",
        "positionId": "56054226",
        "volume": 8.28,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182.16,
        "takeProfit": null,
        "priceIn": 3220.9,
        "doubleCheck": true
    },
    {
        "id": "53091150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:29.469",
        "brokerTime": "2025-05-14 15:06:29.469",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054228",
        "positionId": "56054228",
        "volume": 8.28,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:29.469",
        "brokerTime": "2025-05-14 15:06:29.940",
        "commission": -57.96,
        "swap": 0,
        "profit": -198.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054229",
        "positionId": "56054228",
        "volume": 8.28,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -256.68,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:30.158",
        "brokerTime": "2025-05-14 15:06:30.158",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054230",
        "positionId": "56054230",
        "volume": 8.28,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:30.158",
        "brokerTime": "2025-05-14 15:06:30.492",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054232",
        "positionId": "56054230",
        "volume": 8.28,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31.022",
        "brokerTime": "2025-05-14 15:06:31.022",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054233",
        "positionId": "56054233",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31.022",
        "brokerTime": "2025-05-14 15:06:31.421",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054234",
        "positionId": "56054233",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31.824",
        "brokerTime": "2025-05-14 15:06:31.824",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054235",
        "positionId": "56054235",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:31.824",
        "brokerTime": "2025-05-14 15:06:32.643",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054239",
        "positionId": "56054235",
        "volume": 8.28,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:33.468",
        "brokerTime": "2025-05-14 15:06:33.468",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054240",
        "positionId": "56054240",
        "volume": 8.28,
        "price": 3221.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:33.468",
        "brokerTime": "2025-05-14 15:06:33.881",
        "commission": -57.96,
        "swap": 0,
        "profit": -173.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054241",
        "positionId": "56054240",
        "volume": 8.28,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -231.84,
        "takeProfit": null,
        "priceIn": 3221.3,
        "doubleCheck": true
    },
    {
        "id": "53091164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:34.260",
        "brokerTime": "2025-05-14 15:06:34.260",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054242",
        "positionId": "56054242",
        "volume": 8.28,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53091165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:34.260",
        "brokerTime": "2025-05-14 15:06:35.052",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054243",
        "positionId": "56054242",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53091166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35.321",
        "brokerTime": "2025-05-14 15:06:35.321",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054244",
        "positionId": "56054244",
        "volume": 8.28,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53091167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35.321",
        "brokerTime": "2025-05-14 15:06:35.638",
        "commission": -57.96,
        "swap": 0,
        "profit": -190.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054245",
        "positionId": "56054244",
        "volume": 8.28,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -248.4,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53091168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35.949",
        "brokerTime": "2025-05-14 15:06:35.949",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054246",
        "positionId": "56054246",
        "volume": 8.28,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53091169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:35.949",
        "brokerTime": "2025-05-14 15:06:36.394",
        "commission": -57.96,
        "swap": 0,
        "profit": -149.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054247",
        "positionId": "56054246",
        "volume": 8.28,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -207,
        "takeProfit": null,
        "priceIn": 3221.6,
        "doubleCheck": true
    },
    {
        "id": "53091170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:37.270",
        "brokerTime": "2025-05-14 15:06:37.270",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054248",
        "positionId": "56054248",
        "volume": 8.28,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:37.270",
        "brokerTime": "2025-05-14 15:06:37.953",
        "commission": -57.96,
        "swap": 0,
        "profit": -215.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054249",
        "positionId": "56054248",
        "volume": 8.28,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -273.24,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:38.521",
        "brokerTime": "2025-05-14 15:06:38.521",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054250",
        "positionId": "56054250",
        "volume": 8.28,
        "price": 3221.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "id": "53091173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:38.521",
        "brokerTime": "2025-05-14 15:06:39.386",
        "commission": -57.96,
        "swap": 0,
        "profit": -331.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054251",
        "positionId": "56054250",
        "volume": 8.28,
        "price": 3221.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -389.15999999999997,
        "takeProfit": null,
        "priceIn": 3221.55,
        "doubleCheck": true
    },
    {
        "id": "53091174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:39.827",
        "brokerTime": "2025-05-14 15:06:39.827",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054252",
        "positionId": "56054252",
        "volume": 8.28,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53091176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:39.827",
        "brokerTime": "2025-05-14 15:06:40.639",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054254",
        "positionId": "56054252",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.74,
        "doubleCheck": true
    },
    {
        "id": "53091177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:41.441",
        "brokerTime": "2025-05-14 15:06:41.441",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054255",
        "positionId": "56054255",
        "volume": 8.28,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:41.441",
        "brokerTime": "2025-05-14 15:06:42.185",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054256",
        "positionId": "56054255",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:42.555",
        "brokerTime": "2025-05-14 15:06:42.555",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054257",
        "positionId": "56054257",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:42.555",
        "brokerTime": "2025-05-14 15:06:42.881",
        "commission": -57.96,
        "swap": 0,
        "profit": -124.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054258",
        "positionId": "56054257",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -182.16,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43.172",
        "brokerTime": "2025-05-14 15:06:43.172",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054259",
        "positionId": "56054259",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:43.172",
        "brokerTime": "2025-05-14 15:06:43.629",
        "commission": -57.96,
        "swap": 0,
        "profit": -182.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054260",
        "positionId": "56054259",
        "volume": 8.28,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -240.12,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:44.057",
        "brokerTime": "2025-05-14 15:06:44.057",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054261",
        "positionId": "56054261",
        "volume": 8.28,
        "price": 3221.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53091184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:44.057",
        "brokerTime": "2025-05-14 15:06:45.453",
        "commission": -57.96,
        "swap": 0,
        "profit": -207,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054262",
        "positionId": "56054261",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.96,
        "takeProfit": null,
        "priceIn": 3221.69,
        "doubleCheck": true
    },
    {
        "id": "53091185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:45.979",
        "brokerTime": "2025-05-14 15:06:45.979",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054263",
        "positionId": "56054263",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53091186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:45.979",
        "brokerTime": "2025-05-14 15:06:46.336",
        "commission": -57.96,
        "swap": 0,
        "profit": 66.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054264",
        "positionId": "56054263",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 8.279999999999994,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53091187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:46.661",
        "brokerTime": "2025-05-14 15:06:46.661",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054266",
        "positionId": "56054266",
        "volume": 8.28,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:46.661",
        "brokerTime": "2025-05-14 15:06:47.339",
        "commission": -57.96,
        "swap": 0,
        "profit": 57.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054267",
        "positionId": "56054266",
        "volume": 8.28,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:48.025",
        "brokerTime": "2025-05-14 15:06:48.025",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054268",
        "positionId": "56054268",
        "volume": 8.28,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:48.025",
        "brokerTime": "2025-05-14 15:06:49.505",
        "commission": -57.96,
        "swap": 0,
        "profit": -66.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054269",
        "positionId": "56054268",
        "volume": 8.28,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -124.19999999999999,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:49.770",
        "brokerTime": "2025-05-14 15:06:49.770",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054270",
        "positionId": "56054270",
        "volume": 8.28,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "id": "53091192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:49.770",
        "brokerTime": "2025-05-14 15:06:50.816",
        "commission": -57.96,
        "swap": 0,
        "profit": -273.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054271",
        "positionId": "56054270",
        "volume": 8.28,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -331.2,
        "takeProfit": null,
        "priceIn": 3221.38,
        "doubleCheck": true
    },
    {
        "id": "53091193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51.025",
        "brokerTime": "2025-05-14 15:06:51.025",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054272",
        "positionId": "56054272",
        "volume": 8.28,
        "price": 3221.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53091194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51.025",
        "brokerTime": "2025-05-14 15:06:51.435",
        "commission": -57.96,
        "swap": 0,
        "profit": -157.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054273",
        "positionId": "56054272",
        "volume": 8.28,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -215.28,
        "takeProfit": null,
        "priceIn": 3221.54,
        "doubleCheck": true
    },
    {
        "id": "53091195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51.822",
        "brokerTime": "2025-05-14 15:06:51.822",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054274",
        "positionId": "56054274",
        "volume": 8.28,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:51.822",
        "brokerTime": "2025-05-14 15:06:52.826",
        "commission": -57.96,
        "swap": 0,
        "profit": -165.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054275",
        "positionId": "56054274",
        "volume": 8.28,
        "price": 3221.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -223.56,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:53.113",
        "brokerTime": "2025-05-14 15:06:53.113",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054276",
        "positionId": "56054276",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:53.113",
        "brokerTime": "2025-05-14 15:06:53.523",
        "commission": -57.96,
        "swap": 0,
        "profit": -140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054277",
        "positionId": "56054276",
        "volume": 8.28,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.72,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:54.286",
        "brokerTime": "2025-05-14 15:06:54.286",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054278",
        "positionId": "56054278",
        "volume": 8.28,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:54.286",
        "brokerTime": "2025-05-14 15:06:54.947",
        "commission": -57.96,
        "swap": 0,
        "profit": -248.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054279",
        "positionId": "56054278",
        "volume": 8.28,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -306.36,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55.467",
        "brokerTime": "2025-05-14 15:06:55.467",
        "commission": -57.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054280",
        "positionId": "56054280",
        "volume": 8.28,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -57.96,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53091204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55.919",
        "brokerTime": "2025-05-14 15:06:55.919",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054281",
        "positionId": "56054281",
        "volume": 0.12,
        "price": 2871.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2771.8,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2871.8,
        "doubleCheck": true
    },
    {
        "id": "53091205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55.467",
        "brokerTime": "2025-05-14 15:06:56.150",
        "commission": -57.96,
        "swap": 0,
        "profit": -637.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054282",
        "positionId": "56054280",
        "volume": 8.28,
        "price": 3222.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -695.52,
        "takeProfit": null,
        "priceIn": 3221.79,
        "doubleCheck": true
    },
    {
        "id": "53091206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56.176",
        "brokerTime": "2025-05-14 15:06:56.176",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054283",
        "positionId": "56054283",
        "volume": 0.17,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.38,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "id": "53091207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56.409",
        "brokerTime": "2025-05-14 15:06:56.409",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054284",
        "positionId": "56054284",
        "volume": 8.11,
        "price": 3222.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53091209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56.409",
        "brokerTime": "2025-05-14 15:06:56.759",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054286",
        "positionId": "56054284",
        "volume": 8.11,
        "price": 3222.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3222.48,
        "doubleCheck": true
    },
    {
        "id": "53091211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:57.480",
        "brokerTime": "2025-05-14 15:06:57.480",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054287",
        "positionId": "56054287",
        "volume": 8.11,
        "price": 3222.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.42,
        "doubleCheck": true
    },
    {
        "id": "53091212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:57.480",
        "brokerTime": "2025-05-14 15:06:58.114",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054288",
        "positionId": "56054287",
        "volume": 8.11,
        "price": 3222.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.41,
        "takeProfit": null,
        "priceIn": 3222.42,
        "doubleCheck": true
    },
    {
        "id": "53091213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:58.728",
        "brokerTime": "2025-05-14 15:06:58.728",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054289",
        "positionId": "56054289",
        "volume": 8.11,
        "price": 3222.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "id": "53091214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:58.728",
        "brokerTime": "2025-05-14 15:06:59.104",
        "commission": -56.77,
        "swap": 0,
        "profit": 72.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054290",
        "positionId": "56054289",
        "volume": 8.11,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 16.21999999999999,
        "takeProfit": null,
        "priceIn": 3222.47,
        "doubleCheck": true
    },
    {
        "id": "53091215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59.434",
        "brokerTime": "2025-05-14 15:06:59.434",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054291",
        "positionId": "56054291",
        "volume": 8.11,
        "price": 3222.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "id": "53091216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:59.434",
        "brokerTime": "2025-05-14 15:07:00.055",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054292",
        "positionId": "56054291",
        "volume": 8.11,
        "price": 3222.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -332.51,
        "takeProfit": null,
        "priceIn": 3222.21,
        "doubleCheck": true
    },
    {
        "id": "53091218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:00.579",
        "brokerTime": "2025-05-14 15:07:00.579",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054294",
        "positionId": "56054294",
        "volume": 8.11,
        "price": 3222.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "id": "53091220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:00.579",
        "brokerTime": "2025-05-14 15:07:01.306",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054295",
        "positionId": "56054294",
        "volume": 8.11,
        "price": 3222.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3222.38,
        "doubleCheck": true
    },
    {
        "id": "53091222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:01.566",
        "brokerTime": "2025-05-14 15:07:01.566",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054297",
        "positionId": "56054297",
        "volume": 8.11,
        "price": 3222.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "id": "53091223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:01.566",
        "brokerTime": "2025-05-14 15:07:02.643",
        "commission": -56.77,
        "swap": 0,
        "profit": -16.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054298",
        "positionId": "56054297",
        "volume": 8.11,
        "price": 3222.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.99000000000001,
        "takeProfit": null,
        "priceIn": 3222.41,
        "doubleCheck": true
    },
    {
        "id": "53091224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:03.361",
        "brokerTime": "2025-05-14 15:07:03.361",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054299",
        "positionId": "56054299",
        "volume": 8.11,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.93,
        "doubleCheck": true
    },
    {
        "id": "53091225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:03.361",
        "brokerTime": "2025-05-14 15:07:03.903",
        "commission": -56.77,
        "swap": 0,
        "profit": 162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054300",
        "positionId": "56054299",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 105.42999999999998,
        "takeProfit": null,
        "priceIn": 3221.93,
        "doubleCheck": true
    },
    {
        "id": "53091226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:04.450",
        "brokerTime": "2025-05-14 15:07:04.450",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054301",
        "positionId": "56054301",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53091227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:04.450",
        "brokerTime": "2025-05-14 15:07:05.137",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054302",
        "positionId": "56054301",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3221.59,
        "doubleCheck": true
    },
    {
        "id": "53091228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:05.365",
        "brokerTime": "2025-05-14 15:07:05.365",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054303",
        "positionId": "56054303",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:05.365",
        "brokerTime": "2025-05-14 15:07:06.105",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054304",
        "positionId": "56054303",
        "volume": 8.11,
        "price": 3221.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -300.07,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:06.451",
        "brokerTime": "2025-05-14 15:07:06.451",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054305",
        "positionId": "56054305",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:06.451",
        "brokerTime": "2025-05-14 15:07:06.811",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054306",
        "positionId": "56054305",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:07.438",
        "brokerTime": "2025-05-14 15:07:07.438",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054307",
        "positionId": "56054307",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53091233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:07.438",
        "brokerTime": "2025-05-14 15:07:08.031",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054308",
        "positionId": "56054307",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53091234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:08.669",
        "brokerTime": "2025-05-14 15:07:08.669",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054309",
        "positionId": "56054309",
        "volume": 8.11,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:08.669",
        "brokerTime": "2025-05-14 15:07:09.055",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054310",
        "positionId": "56054309",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09.285",
        "brokerTime": "2025-05-14 15:07:09.285",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054311",
        "positionId": "56054311",
        "volume": 8.11,
        "price": 3221.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:09.285",
        "brokerTime": "2025-05-14 15:07:09.752",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054312",
        "positionId": "56054311",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3221.31,
        "doubleCheck": true
    },
    {
        "id": "53091238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:10.087",
        "brokerTime": "2025-05-14 15:07:10.087",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054313",
        "positionId": "56054313",
        "volume": 8.11,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53091239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:10.087",
        "brokerTime": "2025-05-14 15:07:11.272",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054314",
        "positionId": "56054313",
        "volume": 8.11,
        "price": 3221.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -364.95,
        "takeProfit": null,
        "priceIn": 3221.33,
        "doubleCheck": true
    },
    {
        "id": "53091240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:11.676",
        "brokerTime": "2025-05-14 15:07:11.676",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054315",
        "positionId": "56054315",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:11.676",
        "brokerTime": "2025-05-14 15:07:11.980",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054316",
        "positionId": "56054315",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12.077",
        "brokerTime": "2025-05-14 15:07:12.077",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054317",
        "positionId": "56054317",
        "volume": 8.11,
        "price": 3221.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53091244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:12.077",
        "brokerTime": "2025-05-14 15:07:12.369",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054319",
        "positionId": "56054317",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.43,
        "takeProfit": null,
        "priceIn": 3221.53,
        "doubleCheck": true
    },
    {
        "id": "53091245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13.354",
        "brokerTime": "2025-05-14 15:07:13.354",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054320",
        "positionId": "56054320",
        "volume": 8.11,
        "price": 3221.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.36,
        "doubleCheck": true
    },
    {
        "id": "53091246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13.354",
        "brokerTime": "2025-05-14 15:07:13.723",
        "commission": -56.77,
        "swap": 0,
        "profit": -332.51,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054321",
        "positionId": "56054320",
        "volume": 8.11,
        "price": 3221.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -389.28,
        "takeProfit": null,
        "priceIn": 3221.36,
        "doubleCheck": true
    },
    {
        "id": "53091247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13.941",
        "brokerTime": "2025-05-14 15:07:13.941",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054322",
        "positionId": "56054322",
        "volume": 8.11,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:13.941",
        "brokerTime": "2025-05-14 15:07:14.385",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054323",
        "positionId": "56054322",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:14.692",
        "brokerTime": "2025-05-14 15:07:14.692",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054324",
        "positionId": "56054324",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:14.692",
        "brokerTime": "2025-05-14 15:07:15.699",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054325",
        "positionId": "56054324",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:15.867",
        "brokerTime": "2025-05-14 15:07:15.867",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054326",
        "positionId": "56054326",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:15.867",
        "brokerTime": "2025-05-14 15:07:16.534",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054327",
        "positionId": "56054326",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:16.908",
        "brokerTime": "2025-05-14 15:07:16.908",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054328",
        "positionId": "56054328",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:16.908",
        "brokerTime": "2025-05-14 15:07:17.583",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054329",
        "positionId": "56054328",
        "volume": 8.11,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:17.905",
        "brokerTime": "2025-05-14 15:07:17.905",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054330",
        "positionId": "56054330",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:17.905",
        "brokerTime": "2025-05-14 15:07:18.418",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054331",
        "positionId": "56054330",
        "volume": 8.11,
        "price": 3221.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:18.981",
        "brokerTime": "2025-05-14 15:07:18.981",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054332",
        "positionId": "56054332",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:18.981",
        "brokerTime": "2025-05-14 15:07:20.296",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054334",
        "positionId": "56054332",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:22.229",
        "brokerTime": "2025-05-14 15:07:22.229",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054335",
        "positionId": "56054335",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:22.229",
        "brokerTime": "2025-05-14 15:07:22.588",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054336",
        "positionId": "56054335",
        "volume": 8.11,
        "price": 3221.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3221.56,
        "doubleCheck": true
    },
    {
        "id": "53091261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:23.858",
        "brokerTime": "2025-05-14 15:07:23.858",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054337",
        "positionId": "56054337",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:23.858",
        "brokerTime": "2025-05-14 15:07:24.772",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054338",
        "positionId": "56054337",
        "volume": 8.11,
        "price": 3221.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.18,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25.221",
        "brokerTime": "2025-05-14 15:07:25.221",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054339",
        "positionId": "56054339",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53091264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25.221",
        "brokerTime": "2025-05-14 15:07:25.505",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054340",
        "positionId": "56054339",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53091265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25.739",
        "brokerTime": "2025-05-14 15:07:25.739",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054341",
        "positionId": "56054341",
        "volume": 8.11,
        "price": 3221.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53091266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:25.739",
        "brokerTime": "2025-05-14 15:07:26.236",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054342",
        "positionId": "56054341",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -89.21000000000001,
        "takeProfit": null,
        "priceIn": 3221.76,
        "doubleCheck": true
    },
    {
        "id": "53091267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:26.530",
        "brokerTime": "2025-05-14 15:07:26.530",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054343",
        "positionId": "56054343",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53091268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:26.530",
        "brokerTime": "2025-05-14 15:07:27.025",
        "commission": -56.77,
        "swap": 0,
        "profit": -227.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054344",
        "positionId": "56054343",
        "volume": 8.11,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -283.85,
        "takeProfit": null,
        "priceIn": 3221.7,
        "doubleCheck": true
    },
    {
        "id": "53091269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27.447",
        "brokerTime": "2025-05-14 15:07:27.447",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054345",
        "positionId": "56054345",
        "volume": 8.11,
        "price": 3221.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53091270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:27.447",
        "brokerTime": "2025-05-14 15:07:27.954",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054346",
        "positionId": "56054345",
        "volume": 8.11,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3221.84,
        "doubleCheck": true
    },
    {
        "id": "53091271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:28.215",
        "brokerTime": "2025-05-14 15:07:28.215",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054347",
        "positionId": "56054347",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "id": "53091272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:28.215",
        "brokerTime": "2025-05-14 15:07:29.076",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054348",
        "positionId": "56054347",
        "volume": 8.11,
        "price": 3221.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "id": "53091273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:29.536",
        "brokerTime": "2025-05-14 15:07:29.536",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054349",
        "positionId": "56054349",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:29.536",
        "brokerTime": "2025-05-14 15:07:30.002",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054350",
        "positionId": "56054349",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -64.88,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30.224",
        "brokerTime": "2025-05-14 15:07:30.224",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054351",
        "positionId": "56054351",
        "volume": 8.11,
        "price": 3221.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53091276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30.224",
        "brokerTime": "2025-05-14 15:07:30.577",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054352",
        "positionId": "56054351",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.52,
        "takeProfit": null,
        "priceIn": 3221.43,
        "doubleCheck": true
    },
    {
        "id": "53091277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30.837",
        "brokerTime": "2025-05-14 15:07:30.837",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054353",
        "positionId": "56054353",
        "volume": 8.11,
        "price": 3221.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:30.837",
        "brokerTime": "2025-05-14 15:07:31.221",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054354",
        "positionId": "56054353",
        "volume": 8.11,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3221.45,
        "doubleCheck": true
    },
    {
        "id": "53091280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33.191",
        "brokerTime": "2025-05-14 15:07:33.191",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054356",
        "positionId": "56054356",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33.191",
        "brokerTime": "2025-05-14 15:07:33.625",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054357",
        "positionId": "56054356",
        "volume": 8.11,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3221.51,
        "doubleCheck": true
    },
    {
        "id": "53091282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33.815",
        "brokerTime": "2025-05-14 15:07:33.815",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054358",
        "positionId": "56054358",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:33.815",
        "brokerTime": "2025-05-14 15:07:34.213",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054359",
        "positionId": "56054358",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:34.569",
        "brokerTime": "2025-05-14 15:07:34.569",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054360",
        "positionId": "56054360",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:34.569",
        "brokerTime": "2025-05-14 15:07:35.071",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054361",
        "positionId": "56054360",
        "volume": 8.11,
        "price": 3221.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3221.49,
        "doubleCheck": true
    },
    {
        "id": "53091286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:35.617",
        "brokerTime": "2025-05-14 15:07:35.617",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054362",
        "positionId": "56054362",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53091287",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:35.617",
        "brokerTime": "2025-05-14 15:07:36.174",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054363",
        "positionId": "56054362",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53091288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36.404",
        "brokerTime": "2025-05-14 15:07:36.404",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054364",
        "positionId": "56054364",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:36.404",
        "brokerTime": "2025-05-14 15:07:37.004",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054365",
        "positionId": "56054364",
        "volume": 8.11,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091290",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:37.168",
        "brokerTime": "2025-05-14 15:07:37.168",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054366",
        "positionId": "56054366",
        "volume": 8.11,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091291",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:37.168",
        "brokerTime": "2025-05-14 15:07:38.085",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054367",
        "positionId": "56054366",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:38.314",
        "brokerTime": "2025-05-14 15:07:38.314",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054368",
        "positionId": "56054368",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:38.314",
        "brokerTime": "2025-05-14 15:07:38.724",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054369",
        "positionId": "56054368",
        "volume": 8.11,
        "price": 3221.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.42,
        "doubleCheck": true
    },
    {
        "id": "53091294",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:39.372",
        "brokerTime": "2025-05-14 15:07:39.372",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054370",
        "positionId": "56054370",
        "volume": 8.11,
        "price": 3221.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53091295",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:39.372",
        "brokerTime": "2025-05-14 15:07:39.698",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054371",
        "positionId": "56054370",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3221.5,
        "doubleCheck": true
    },
    {
        "id": "53091296",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:40.271",
        "brokerTime": "2025-05-14 15:07:40.271",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054372",
        "positionId": "56054372",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53091297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:40.271",
        "brokerTime": "2025-05-14 15:07:40.825",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054373",
        "positionId": "56054372",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53091300",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:41.244",
        "brokerTime": "2025-05-14 15:07:41.244",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054375",
        "positionId": "56054375",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53091301",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:41.244",
        "brokerTime": "2025-05-14 15:07:41.662",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054376",
        "positionId": "56054375",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53091302",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:42.247",
        "brokerTime": "2025-05-14 15:07:42.247",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054377",
        "positionId": "56054377",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53091303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:42.247",
        "brokerTime": "2025-05-14 15:07:43.382",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054378",
        "positionId": "56054377",
        "volume": 8.11,
        "price": 3221.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53091304",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:44.055",
        "brokerTime": "2025-05-14 15:07:44.055",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054379",
        "positionId": "56054379",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53091305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:44.055",
        "brokerTime": "2025-05-14 15:07:45.162",
        "commission": -56.77,
        "swap": 0,
        "profit": -259.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054380",
        "positionId": "56054379",
        "volume": 8.11,
        "price": 3221.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -316.28999999999996,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53091306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:45.643",
        "brokerTime": "2025-05-14 15:07:45.643",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054381",
        "positionId": "56054381",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53091307",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:45.643",
        "brokerTime": "2025-05-14 15:07:46.488",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054382",
        "positionId": "56054381",
        "volume": 8.11,
        "price": 3221.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53091308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:46.679",
        "brokerTime": "2025-05-14 15:07:46.679",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054383",
        "positionId": "56054383",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53091309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:46.679",
        "brokerTime": "2025-05-14 15:07:47.118",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054384",
        "positionId": "56054383",
        "volume": 8.11,
        "price": 3221.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3221.18,
        "doubleCheck": true
    },
    {
        "id": "53091310",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47.396",
        "brokerTime": "2025-05-14 15:07:47.396",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054385",
        "positionId": "56054385",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47.396",
        "brokerTime": "2025-05-14 15:07:47.706",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054386",
        "positionId": "56054385",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -267.63,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47.895",
        "brokerTime": "2025-05-14 15:07:47.895",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054387",
        "positionId": "56054387",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:47.895",
        "brokerTime": "2025-05-14 15:07:48.377",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054388",
        "positionId": "56054387",
        "volume": 8.11,
        "price": 3221.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:48.755",
        "brokerTime": "2025-05-14 15:07:48.755",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054389",
        "positionId": "56054389",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "id": "53091315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:48.755",
        "brokerTime": "2025-05-14 15:07:49.204",
        "commission": -56.77,
        "swap": 0,
        "profit": 40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054390",
        "positionId": "56054389",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.220000000000006,
        "takeProfit": null,
        "priceIn": 3221.21,
        "doubleCheck": true
    },
    {
        "id": "53091316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49.482",
        "brokerTime": "2025-05-14 15:07:49.482",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054391",
        "positionId": "56054391",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53091317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:49.482",
        "brokerTime": "2025-05-14 15:07:50.108",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054392",
        "positionId": "56054391",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53091320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:50.315",
        "brokerTime": "2025-05-14 15:07:50.315",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054395",
        "positionId": "56054395",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:50.315",
        "brokerTime": "2025-05-14 15:07:51.100",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054396",
        "positionId": "56054395",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091322",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:51.331",
        "brokerTime": "2025-05-14 15:07:51.331",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054397",
        "positionId": "56054397",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:51.331",
        "brokerTime": "2025-05-14 15:07:51.691",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054398",
        "positionId": "56054397",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:52.348",
        "brokerTime": "2025-05-14 15:07:52.348",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054399",
        "positionId": "56054399",
        "volume": 8.11,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "id": "53091325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:52.348",
        "brokerTime": "2025-05-14 15:07:53.054",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054400",
        "positionId": "56054399",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.03,
        "doubleCheck": true
    },
    {
        "id": "53091326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:53.395",
        "brokerTime": "2025-05-14 15:07:53.395",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054401",
        "positionId": "56054401",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:53.395",
        "brokerTime": "2025-05-14 15:07:54.205",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054402",
        "positionId": "56054401",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -267.63,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:54.529",
        "brokerTime": "2025-05-14 15:07:54.529",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054403",
        "positionId": "56054403",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "id": "53091329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:54.529",
        "brokerTime": "2025-05-14 15:07:54.795",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054404",
        "positionId": "56054403",
        "volume": 8.11,
        "price": 3221.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "id": "53091330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:54.965",
        "brokerTime": "2025-05-14 15:07:54.965",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054405",
        "positionId": "56054405",
        "volume": 8.11,
        "price": 3221.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "id": "53091331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:54.965",
        "brokerTime": "2025-05-14 15:07:55.817",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054406",
        "positionId": "56054405",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3221.04,
        "doubleCheck": true
    },
    {
        "id": "53091332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:56.271",
        "brokerTime": "2025-05-14 15:07:56.271",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054407",
        "positionId": "56054407",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "id": "53091333",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:56.271",
        "brokerTime": "2025-05-14 15:07:56.858",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054408",
        "positionId": "56054407",
        "volume": 8.11,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.01,
        "doubleCheck": true
    },
    {
        "id": "53091334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:57.037",
        "brokerTime": "2025-05-14 15:07:57.037",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054409",
        "positionId": "56054409",
        "volume": 8.11,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "id": "53091335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:57.037",
        "brokerTime": "2025-05-14 15:07:57.574",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054410",
        "positionId": "56054409",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "id": "53091336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:58.514",
        "brokerTime": "2025-05-14 15:07:58.514",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054411",
        "positionId": "56054411",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091337",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:07:58.514",
        "brokerTime": "2025-05-14 15:07:58.850",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054412",
        "positionId": "56054411",
        "volume": 8.11,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53091338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:00.093",
        "brokerTime": "2025-05-14 15:08:00.093",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054414",
        "positionId": "56054414",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:00.093",
        "brokerTime": "2025-05-14 15:08:00.548",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054415",
        "positionId": "56054414",
        "volume": 8.11,
        "price": 3221.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.62,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:01.173",
        "brokerTime": "2025-05-14 15:08:01.173",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054416",
        "positionId": "56054416",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:01.173",
        "brokerTime": "2025-05-14 15:08:02.033",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054417",
        "positionId": "56054416",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:02.928",
        "brokerTime": "2025-05-14 15:08:02.928",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054418",
        "positionId": "56054418",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53091343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:02.928",
        "brokerTime": "2025-05-14 15:08:03.602",
        "commission": -56.77,
        "swap": 0,
        "profit": 105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054419",
        "positionId": "56054418",
        "volume": 8.11,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 48.660000000000004,
        "takeProfit": null,
        "priceIn": 3221.35,
        "doubleCheck": true
    },
    {
        "id": "53091344",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:03.905",
        "brokerTime": "2025-05-14 15:08:03.905",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054420",
        "positionId": "56054420",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53091345",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:03.905",
        "brokerTime": "2025-05-14 15:08:04.537",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054421",
        "positionId": "56054420",
        "volume": 8.11,
        "price": 3221.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.43,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53091346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05.106",
        "brokerTime": "2025-05-14 15:08:05.106",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054422",
        "positionId": "56054422",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53091347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05.106",
        "brokerTime": "2025-05-14 15:08:05.470",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054423",
        "positionId": "56054422",
        "volume": 8.11,
        "price": 3221.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.43,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53091348",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05.819",
        "brokerTime": "2025-05-14 15:08:05.819",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054424",
        "positionId": "56054424",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53091349",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:05.819",
        "brokerTime": "2025-05-14 15:08:06.777",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054425",
        "positionId": "56054424",
        "volume": 8.11,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53091350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07.064",
        "brokerTime": "2025-05-14 15:08:07.064",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054426",
        "positionId": "56054426",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53091351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07.064",
        "brokerTime": "2025-05-14 15:08:07.427",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054427",
        "positionId": "56054426",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53091352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07.718",
        "brokerTime": "2025-05-14 15:08:07.718",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054428",
        "positionId": "56054428",
        "volume": 8.11,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53091353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:07.718",
        "brokerTime": "2025-05-14 15:08:08.124",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054429",
        "positionId": "56054428",
        "volume": 8.11,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53091354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:08.520",
        "brokerTime": "2025-05-14 15:08:08.520",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054430",
        "positionId": "56054430",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53091355",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:08.520",
        "brokerTime": "2025-05-14 15:08:08.819",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054431",
        "positionId": "56054430",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.41,
        "takeProfit": null,
        "priceIn": 3221.13,
        "doubleCheck": true
    },
    {
        "id": "53091356",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09.068",
        "brokerTime": "2025-05-14 15:08:09.068",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054432",
        "positionId": "56054432",
        "volume": 8.11,
        "price": 3221.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.27,
        "doubleCheck": true
    },
    {
        "id": "53091357",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09.068",
        "brokerTime": "2025-05-14 15:08:09.436",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054433",
        "positionId": "56054432",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -332.51,
        "takeProfit": null,
        "priceIn": 3221.27,
        "doubleCheck": true
    },
    {
        "id": "53091358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09.912",
        "brokerTime": "2025-05-14 15:08:09.912",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054434",
        "positionId": "56054434",
        "volume": 8.11,
        "price": 3221.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53091359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:09.912",
        "brokerTime": "2025-05-14 15:08:10.433",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054435",
        "positionId": "56054434",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.41,
        "takeProfit": null,
        "priceIn": 3221.46,
        "doubleCheck": true
    },
    {
        "id": "53091360",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:10.736",
        "brokerTime": "2025-05-14 15:08:10.736",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054436",
        "positionId": "56054436",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091361",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:10.736",
        "brokerTime": "2025-05-14 15:08:12.210",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054437",
        "positionId": "56054436",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:12.756",
        "brokerTime": "2025-05-14 15:08:12.756",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054439",
        "positionId": "56054439",
        "volume": 8.11,
        "price": 3221.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:12.756",
        "brokerTime": "2025-05-14 15:08:13.832",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054440",
        "positionId": "56054439",
        "volume": 8.11,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3221.58,
        "doubleCheck": true
    },
    {
        "id": "53091365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14.070",
        "brokerTime": "2025-05-14 15:08:14.070",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054441",
        "positionId": "56054441",
        "volume": 8.11,
        "price": 3221.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14.070",
        "brokerTime": "2025-05-14 15:08:14.415",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054442",
        "positionId": "56054441",
        "volume": 8.11,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3221.65,
        "doubleCheck": true
    },
    {
        "id": "53091367",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14.683",
        "brokerTime": "2025-05-14 15:08:14.683",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054443",
        "positionId": "56054443",
        "volume": 8.11,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53091368",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:14.683",
        "brokerTime": "2025-05-14 15:08:15.976",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054444",
        "positionId": "56054443",
        "volume": 8.11,
        "price": 3221.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53091369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:16.306",
        "brokerTime": "2025-05-14 15:08:16.306",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054445",
        "positionId": "56054445",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091370",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:16.306",
        "brokerTime": "2025-05-14 15:08:16.645",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054446",
        "positionId": "56054445",
        "volume": 8.11,
        "price": 3221.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091371",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:17.135",
        "brokerTime": "2025-05-14 15:08:17.135",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054447",
        "positionId": "56054447",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091372",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:17.135",
        "brokerTime": "2025-05-14 15:08:18.005",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054449",
        "positionId": "56054447",
        "volume": 8.11,
        "price": 3221.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -324.4,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091374",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:18.387",
        "brokerTime": "2025-05-14 15:08:18.387",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054450",
        "positionId": "56054450",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091375",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:18.387",
        "brokerTime": "2025-05-14 15:08:19.447",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054451",
        "positionId": "56054450",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091376",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:19.784",
        "brokerTime": "2025-05-14 15:08:19.784",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054452",
        "positionId": "56054452",
        "volume": 8.11,
        "price": 3221.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091377",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:19.784",
        "brokerTime": "2025-05-14 15:08:20.703",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054453",
        "positionId": "56054452",
        "volume": 8.11,
        "price": 3221.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3221.62,
        "doubleCheck": true
    },
    {
        "id": "53091378",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:20.957",
        "brokerTime": "2025-05-14 15:08:20.957",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054454",
        "positionId": "56054454",
        "volume": 8.11,
        "price": 3221.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091379",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:20.957",
        "brokerTime": "2025-05-14 15:08:21.461",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054455",
        "positionId": "56054454",
        "volume": 8.11,
        "price": 3221.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.64,
        "doubleCheck": true
    },
    {
        "id": "53091380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:21.767",
        "brokerTime": "2025-05-14 15:08:21.767",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054456",
        "positionId": "56054456",
        "volume": 8.11,
        "price": 3221.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.98,
        "doubleCheck": true
    },
    {
        "id": "53091381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:21.767",
        "brokerTime": "2025-05-14 15:08:22.243",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054457",
        "positionId": "56054456",
        "volume": 8.11,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.1,
        "takeProfit": null,
        "priceIn": 3221.98,
        "doubleCheck": true
    },
    {
        "id": "53091382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22.495",
        "brokerTime": "2025-05-14 15:08:22.495",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054458",
        "positionId": "56054458",
        "volume": 8.11,
        "price": 3221.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53091383",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:22.495",
        "brokerTime": "2025-05-14 15:08:23.025",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054459",
        "positionId": "56054458",
        "volume": 8.11,
        "price": 3222.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -300.07,
        "takeProfit": null,
        "priceIn": 3221.86,
        "doubleCheck": true
    },
    {
        "id": "53091384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:23.405",
        "brokerTime": "2025-05-14 15:08:23.405",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054460",
        "positionId": "56054460",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "id": "53091385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:23.405",
        "brokerTime": "2025-05-14 15:08:24.129",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054461",
        "positionId": "56054460",
        "volume": 8.11,
        "price": 3222.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "id": "53091386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:24.552",
        "brokerTime": "2025-05-14 15:08:24.552",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054462",
        "positionId": "56054462",
        "volume": 8.11,
        "price": 3221.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "id": "53091387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:24.552",
        "brokerTime": "2025-05-14 15:08:25.008",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054463",
        "positionId": "56054462",
        "volume": 8.11,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3221.94,
        "doubleCheck": true
    },
    {
        "id": "53091388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:26.849",
        "brokerTime": "2025-05-14 15:08:26.849",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054464",
        "positionId": "56054464",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "id": "53091389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:26.849",
        "brokerTime": "2025-05-14 15:08:27.915",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054465",
        "positionId": "56054464",
        "volume": 8.11,
        "price": 3222.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3221.81,
        "doubleCheck": true
    },
    {
        "id": "53091390",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:28.655",
        "brokerTime": "2025-05-14 15:08:28.655",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054466",
        "positionId": "56054466",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "id": "53091391",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:28.655",
        "brokerTime": "2025-05-14 15:08:29.178",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054467",
        "positionId": "56054466",
        "volume": 8.11,
        "price": 3221.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.8,
        "doubleCheck": true
    },
    {
        "id": "53091392",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29.458",
        "brokerTime": "2025-05-14 15:08:29.458",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054468",
        "positionId": "56054468",
        "volume": 8.11,
        "price": 3221.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53091393",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:29.458",
        "brokerTime": "2025-05-14 15:08:29.784",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054469",
        "positionId": "56054468",
        "volume": 8.11,
        "price": 3221.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.63,
        "doubleCheck": true
    },
    {
        "id": "53091394",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30.013",
        "brokerTime": "2025-05-14 15:08:30.013",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054470",
        "positionId": "56054470",
        "volume": 8.11,
        "price": 3221.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53091395",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30.013",
        "brokerTime": "2025-05-14 15:08:30.442",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054471",
        "positionId": "56054470",
        "volume": 8.11,
        "price": 3221.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3221.67,
        "doubleCheck": true
    },
    {
        "id": "53091396",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30.701",
        "brokerTime": "2025-05-14 15:08:30.701",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054472",
        "positionId": "56054472",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:30.701",
        "brokerTime": "2025-05-14 15:08:31.179",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054473",
        "positionId": "56054472",
        "volume": 8.11,
        "price": 3221.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091398",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32.244",
        "brokerTime": "2025-05-14 15:08:32.244",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054474",
        "positionId": "56054474",
        "volume": 8.11,
        "price": 3221.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53091399",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32.244",
        "brokerTime": "2025-05-14 15:08:32.655",
        "commission": -56.77,
        "swap": 0,
        "profit": -535.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054475",
        "positionId": "56054474",
        "volume": 8.11,
        "price": 3222.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -592.03,
        "takeProfit": null,
        "priceIn": 3221.61,
        "doubleCheck": true
    },
    {
        "id": "53091400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32.974",
        "brokerTime": "2025-05-14 15:08:32.974",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054476",
        "positionId": "56054476",
        "volume": 8.11,
        "price": 3222.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.02,
        "doubleCheck": true
    },
    {
        "id": "53091401",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:32.974",
        "brokerTime": "2025-05-14 15:08:33.345",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054477",
        "positionId": "56054476",
        "volume": 8.11,
        "price": 3222.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3222.02,
        "doubleCheck": true
    },
    {
        "id": "53091402",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:33.713",
        "brokerTime": "2025-05-14 15:08:33.713",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054478",
        "positionId": "56054478",
        "volume": 8.11,
        "price": 3222.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.01,
        "doubleCheck": true
    },
    {
        "id": "53091403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:33.713",
        "brokerTime": "2025-05-14 15:08:36.144",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054479",
        "positionId": "56054478",
        "volume": 8.11,
        "price": 3222.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3222.01,
        "doubleCheck": true
    },
    {
        "id": "53091404",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:36.439",
        "brokerTime": "2025-05-14 15:08:36.439",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054480",
        "positionId": "56054480",
        "volume": 8.11,
        "price": 3222.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3222.04,
        "doubleCheck": true
    },
    {
        "id": "53091411",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:36.439",
        "brokerTime": "2025-05-14 15:08:37.111",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054487",
        "positionId": "56054480",
        "volume": 8.11,
        "price": 3222.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3222.04,
        "doubleCheck": true
    },
    {
        "id": "53091412",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37.225",
        "brokerTime": "2025-05-14 15:08:37.225",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56054488",
        "positionId": "56054488",
        "volume": 0.14,
        "price": 2872.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2772.81,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2872.81,
        "doubleCheck": true
    },
    {
        "id": "53091413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37.469",
        "brokerTime": "2025-05-14 15:08:37.469",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054489",
        "positionId": "56054489",
        "volume": 8.11,
        "price": 3221.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "id": "53091414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37.469",
        "brokerTime": "2025-05-14 15:08:38.070",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054490",
        "positionId": "56054489",
        "volume": 8.11,
        "price": 3222.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.92,
        "doubleCheck": true
    },
    {
        "id": "53091581",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:39.477",
        "brokerTime": "2025-05-14 15:08:39.477",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054672",
        "positionId": "56054672",
        "volume": 8.11,
        "price": 3221.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "id": "53091672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:39.477",
        "brokerTime": "2025-05-14 15:08:39.983",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054673",
        "positionId": "56054672",
        "volume": 8.11,
        "price": 3222,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.83,
        "doubleCheck": true
    },
    {
        "id": "53091673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:41.298",
        "brokerTime": "2025-05-14 15:08:41.298",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054674",
        "positionId": "56054674",
        "volume": 8.11,
        "price": 3221.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:41.298",
        "brokerTime": "2025-05-14 15:08:41.624",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054675",
        "positionId": "56054674",
        "volume": 8.11,
        "price": 3221.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3221.52,
        "doubleCheck": true
    },
    {
        "id": "53091675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:42.165",
        "brokerTime": "2025-05-14 15:08:42.165",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054676",
        "positionId": "56054676",
        "volume": 8.11,
        "price": 3221.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53091676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:42.165",
        "brokerTime": "2025-05-14 15:08:42.857",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054677",
        "positionId": "56054676",
        "volume": 8.11,
        "price": 3221.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -64.88,
        "takeProfit": null,
        "priceIn": 3221.47,
        "doubleCheck": true
    },
    {
        "id": "53091677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:43.208",
        "brokerTime": "2025-05-14 15:08:43.208",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054678",
        "positionId": "56054678",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:43.208",
        "brokerTime": "2025-05-14 15:08:43.820",
        "commission": -56.77,
        "swap": 0,
        "profit": -291.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054679",
        "positionId": "56054678",
        "volume": 8.11,
        "price": 3221.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -348.72999999999996,
        "takeProfit": null,
        "priceIn": 3221.15,
        "doubleCheck": true
    },
    {
        "id": "53091679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:44.336",
        "brokerTime": "2025-05-14 15:08:44.336",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054680",
        "positionId": "56054680",
        "volume": 8.11,
        "price": 3221.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091686",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:44.336",
        "brokerTime": "2025-05-14 15:08:45.291",
        "commission": -56.77,
        "swap": 0,
        "profit": 316.29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054687",
        "positionId": "56054680",
        "volume": 8.11,
        "price": 3221.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 259.52000000000004,
        "takeProfit": null,
        "priceIn": 3221.57,
        "doubleCheck": true
    },
    {
        "id": "53091687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:45.608",
        "brokerTime": "2025-05-14 15:08:45.608",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054688",
        "positionId": "56054688",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:45.608",
        "brokerTime": "2025-05-14 15:08:46.168",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054689",
        "positionId": "56054688",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:46.670",
        "brokerTime": "2025-05-14 15:08:46.670",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054690",
        "positionId": "56054690",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53091690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:46.670",
        "brokerTime": "2025-05-14 15:08:47.028",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054691",
        "positionId": "56054690",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53091691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47.273",
        "brokerTime": "2025-05-14 15:08:47.273",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054692",
        "positionId": "56054692",
        "volume": 8.11,
        "price": 3221,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:47.273",
        "brokerTime": "2025-05-14 15:08:47.991",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054693",
        "positionId": "56054692",
        "volume": 8.11,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3221,
        "doubleCheck": true
    },
    {
        "id": "53091693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48.221",
        "brokerTime": "2025-05-14 15:08:48.221",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054694",
        "positionId": "56054694",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48.221",
        "brokerTime": "2025-05-14 15:08:48.565",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054695",
        "positionId": "56054694",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48.888",
        "brokerTime": "2025-05-14 15:08:48.888",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054696",
        "positionId": "56054696",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:48.888",
        "brokerTime": "2025-05-14 15:08:49.346",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054697",
        "positionId": "56054696",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3220.94,
        "doubleCheck": true
    },
    {
        "id": "53091697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:50.735",
        "brokerTime": "2025-05-14 15:08:50.735",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054698",
        "positionId": "56054698",
        "volume": 8.11,
        "price": 3220.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:50.735",
        "brokerTime": "2025-05-14 15:08:51.198",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054699",
        "positionId": "56054698",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -89.21000000000001,
        "takeProfit": null,
        "priceIn": 3220.91,
        "doubleCheck": true
    },
    {
        "id": "53091699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:51.502",
        "brokerTime": "2025-05-14 15:08:51.502",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054700",
        "positionId": "56054700",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091700",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:51.502",
        "brokerTime": "2025-05-14 15:08:52.528",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054701",
        "positionId": "56054700",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091701",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:52.778",
        "brokerTime": "2025-05-14 15:08:52.778",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054702",
        "positionId": "56054702",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:52.778",
        "brokerTime": "2025-05-14 15:08:53.117",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054703",
        "positionId": "56054702",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3220.77,
        "doubleCheck": true
    },
    {
        "id": "53091703",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:54.290",
        "brokerTime": "2025-05-14 15:08:54.290",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054724",
        "positionId": "56054724",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53091744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:54.290",
        "brokerTime": "2025-05-14 15:08:54.977",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054725",
        "positionId": "56054724",
        "volume": 8.11,
        "price": 3220.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.1,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53091745",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:55.393",
        "brokerTime": "2025-05-14 15:08:55.393",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054726",
        "positionId": "56054726",
        "volume": 8.11,
        "price": 3220.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53091747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:55.393",
        "brokerTime": "2025-05-14 15:08:55.822",
        "commission": -56.77,
        "swap": 0,
        "profit": 64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054729",
        "positionId": "56054726",
        "volume": 8.11,
        "price": 3220.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 8.109999999999992,
        "takeProfit": null,
        "priceIn": 3220.54,
        "doubleCheck": true
    },
    {
        "id": "53091749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:56.078",
        "brokerTime": "2025-05-14 15:08:56.078",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054730",
        "positionId": "56054730",
        "volume": 8.11,
        "price": 3220.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.01,
        "doubleCheck": true
    },
    {
        "id": "53091753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:56.078",
        "brokerTime": "2025-05-14 15:08:56.771",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054733",
        "positionId": "56054730",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3220.01,
        "doubleCheck": true
    },
    {
        "id": "53091758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:57.113",
        "brokerTime": "2025-05-14 15:08:57.113",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054737",
        "positionId": "56054737",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53091992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:57.113",
        "brokerTime": "2025-05-14 15:08:57.672",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56054952",
        "positionId": "56054737",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53092049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:58.139",
        "brokerTime": "2025-05-14 15:08:58.139",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055015",
        "positionId": "56055015",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53092359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:58.139",
        "brokerTime": "2025-05-14 15:09:00.138",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055287",
        "positionId": "56055015",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53092363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:00.664",
        "brokerTime": "2025-05-14 15:09:00.664",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055291",
        "positionId": "56055291",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53092365",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:00.664",
        "brokerTime": "2025-05-14 15:09:01.048",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055292",
        "positionId": "56055291",
        "volume": 8.11,
        "price": 3220.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53092407",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:01.951",
        "brokerTime": "2025-05-14 15:09:01.951",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055321",
        "positionId": "56055321",
        "volume": 8.11,
        "price": 3219.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.92,
        "doubleCheck": true
    },
    {
        "id": "53092514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:01.951",
        "brokerTime": "2025-05-14 15:09:02.447",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055381",
        "positionId": "56055321",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3219.92,
        "doubleCheck": true
    },
    {
        "id": "53092541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:02.767",
        "brokerTime": "2025-05-14 15:09:02.767",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055411",
        "positionId": "56055411",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53092680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:02.767",
        "brokerTime": "2025-05-14 15:09:03.248",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055513",
        "positionId": "56055411",
        "volume": 8.11,
        "price": 3220.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3220.02,
        "doubleCheck": true
    },
    {
        "id": "53092754",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:04.495",
        "brokerTime": "2025-05-14 15:09:04.495",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055542",
        "positionId": "56055542",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53092768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:04.495",
        "brokerTime": "2025-05-14 15:09:05.720",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055551",
        "positionId": "56055542",
        "volume": 8.11,
        "price": 3220,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53092849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:06.203",
        "brokerTime": "2025-05-14 15:09:06.203",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055632",
        "positionId": "56055632",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53092852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:06.203",
        "brokerTime": "2025-05-14 15:09:06.673",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055633",
        "positionId": "56055632",
        "volume": 8.11,
        "price": 3219.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53092855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:07.219",
        "brokerTime": "2025-05-14 15:09:07.219",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055635",
        "positionId": "56055635",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53092856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:07.219",
        "brokerTime": "2025-05-14 15:09:07.728",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055636",
        "positionId": "56055635",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -364.95,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53092858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:08.056",
        "brokerTime": "2025-05-14 15:09:08.056",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055638",
        "positionId": "56055638",
        "volume": 8.11,
        "price": 3220.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "id": "53092859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:08.056",
        "brokerTime": "2025-05-14 15:09:08.954",
        "commission": -56.77,
        "swap": 0,
        "profit": -397.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055639",
        "positionId": "56055638",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -454.15999999999997,
        "takeProfit": null,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "id": "53092860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:09.557",
        "brokerTime": "2025-05-14 15:09:09.557",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055640",
        "positionId": "56055640",
        "volume": 8.11,
        "price": 3220.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "id": "53092861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:09.557",
        "brokerTime": "2025-05-14 15:09:09.999",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055641",
        "positionId": "56055640",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "id": "53092862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:10.737",
        "brokerTime": "2025-05-14 15:09:10.737",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055642",
        "positionId": "56055642",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "id": "53092880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:10.737",
        "brokerTime": "2025-05-14 15:09:11.219",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055659",
        "positionId": "56055642",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "id": "53092881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12.018",
        "brokerTime": "2025-05-14 15:09:12.018",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055660",
        "positionId": "56055660",
        "volume": 8.11,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.35,
        "doubleCheck": true
    },
    {
        "id": "53092882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12.018",
        "brokerTime": "2025-05-14 15:09:12.487",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055661",
        "positionId": "56055660",
        "volume": 8.11,
        "price": 3220.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.35,
        "doubleCheck": true
    },
    {
        "id": "53092883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12.851",
        "brokerTime": "2025-05-14 15:09:12.851",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055662",
        "positionId": "56055662",
        "volume": 8.11,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "id": "53092884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:12.851",
        "brokerTime": "2025-05-14 15:09:13.342",
        "commission": -56.77,
        "swap": 0,
        "profit": -389.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055663",
        "positionId": "56055662",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -446.04999999999995,
        "takeProfit": null,
        "priceIn": 3220.32,
        "doubleCheck": true
    },
    {
        "id": "53092885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:13.558",
        "brokerTime": "2025-05-14 15:09:13.558",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055664",
        "positionId": "56055664",
        "volume": 8.11,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "id": "53092886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:13.558",
        "brokerTime": "2025-05-14 15:09:14.207",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055665",
        "positionId": "56055664",
        "volume": 8.11,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3220.61,
        "doubleCheck": true
    },
    {
        "id": "53092887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:14.715",
        "brokerTime": "2025-05-14 15:09:14.715",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055666",
        "positionId": "56055666",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53092888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:14.715",
        "brokerTime": "2025-05-14 15:09:15.066",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055667",
        "positionId": "56055666",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53092890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:15.652",
        "brokerTime": "2025-05-14 15:09:15.652",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055669",
        "positionId": "56055669",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53092891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:15.652",
        "brokerTime": "2025-05-14 15:09:16.305",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055670",
        "positionId": "56055669",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.73,
        "doubleCheck": true
    },
    {
        "id": "53092892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:16.582",
        "brokerTime": "2025-05-14 15:09:16.582",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055671",
        "positionId": "56055671",
        "volume": 8.11,
        "price": 3220.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53092893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:16.582",
        "brokerTime": "2025-05-14 15:09:17.003",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055672",
        "positionId": "56055671",
        "volume": 8.11,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3220.7,
        "doubleCheck": true
    },
    {
        "id": "53092894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17.360",
        "brokerTime": "2025-05-14 15:09:17.360",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055673",
        "positionId": "56055673",
        "volume": 8.11,
        "price": 3220.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53092895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:17.360",
        "brokerTime": "2025-05-14 15:09:18.161",
        "commission": -56.77,
        "swap": 0,
        "profit": -332.51,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055674",
        "positionId": "56055673",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -389.28,
        "takeProfit": null,
        "priceIn": 3220.69,
        "doubleCheck": true
    },
    {
        "id": "53092896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:18.451",
        "brokerTime": "2025-05-14 15:09:18.451",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055675",
        "positionId": "56055675",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53092897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:18.451",
        "brokerTime": "2025-05-14 15:09:18.988",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055676",
        "positionId": "56055675",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53092898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19.213",
        "brokerTime": "2025-05-14 15:09:19.213",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055677",
        "positionId": "56055677",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19.213",
        "brokerTime": "2025-05-14 15:09:19.574",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055678",
        "positionId": "56055677",
        "volume": 8.11,
        "price": 3221.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.41,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19.763",
        "brokerTime": "2025-05-14 15:09:19.763",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055679",
        "positionId": "56055679",
        "volume": 8.11,
        "price": 3220.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "id": "53092901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:19.763",
        "brokerTime": "2025-05-14 15:09:20.281",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055680",
        "positionId": "56055679",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.89,
        "doubleCheck": true
    },
    {
        "id": "53092902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:21.255",
        "brokerTime": "2025-05-14 15:09:21.255",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055681",
        "positionId": "56055681",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:21.255",
        "brokerTime": "2025-05-14 15:09:21.953",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055682",
        "positionId": "56055681",
        "volume": 8.11,
        "price": 3220.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:22.158",
        "brokerTime": "2025-05-14 15:09:22.158",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055683",
        "positionId": "56055683",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:22.158",
        "brokerTime": "2025-05-14 15:09:22.932",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055684",
        "positionId": "56055683",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:23.529",
        "brokerTime": "2025-05-14 15:09:23.529",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055685",
        "positionId": "56055685",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:23.529",
        "brokerTime": "2025-05-14 15:09:24.322",
        "commission": -56.77,
        "swap": 0,
        "profit": -259.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055686",
        "positionId": "56055685",
        "volume": 8.11,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -316.28999999999996,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:24.595",
        "brokerTime": "2025-05-14 15:09:24.595",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055687",
        "positionId": "56055687",
        "volume": 8.11,
        "price": 3220.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53092909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:24.595",
        "brokerTime": "2025-05-14 15:09:24.976",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055688",
        "positionId": "56055687",
        "volume": 8.11,
        "price": 3221.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3220.95,
        "doubleCheck": true
    },
    {
        "id": "53092910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25.187",
        "brokerTime": "2025-05-14 15:09:25.187",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055689",
        "positionId": "56055689",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53092911",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:25.187",
        "brokerTime": "2025-05-14 15:09:25.819",
        "commission": -56.77,
        "swap": 0,
        "profit": -324.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055690",
        "positionId": "56055689",
        "volume": 8.11,
        "price": 3221.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -381.16999999999996,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53092912",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:26.028",
        "brokerTime": "2025-05-14 15:09:26.028",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055691",
        "positionId": "56055691",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53092913",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:26.028",
        "brokerTime": "2025-05-14 15:09:26.698",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055692",
        "positionId": "56055691",
        "volume": 8.11,
        "price": 3221.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53092914",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27.153",
        "brokerTime": "2025-05-14 15:09:27.153",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055693",
        "positionId": "56055693",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53092915",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27.153",
        "brokerTime": "2025-05-14 15:09:27.656",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055694",
        "positionId": "56055693",
        "volume": 8.11,
        "price": 3221.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53092916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27.953",
        "brokerTime": "2025-05-14 15:09:27.953",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055695",
        "positionId": "56055695",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53092917",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:27.953",
        "brokerTime": "2025-05-14 15:09:28.370",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055696",
        "positionId": "56055695",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -64.88,
        "takeProfit": null,
        "priceIn": 3220.98,
        "doubleCheck": true
    },
    {
        "id": "53092918",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:28.911",
        "brokerTime": "2025-05-14 15:09:28.911",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055697",
        "positionId": "56055697",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:28.911",
        "brokerTime": "2025-05-14 15:09:29.568",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055698",
        "positionId": "56055697",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:29.828",
        "brokerTime": "2025-05-14 15:09:29.828",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055699",
        "positionId": "56055699",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:29.828",
        "brokerTime": "2025-05-14 15:09:30.124",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055700",
        "positionId": "56055699",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53092922",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30.383",
        "brokerTime": "2025-05-14 15:09:30.383",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055701",
        "positionId": "56055701",
        "volume": 8.11,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53092923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:30.383",
        "brokerTime": "2025-05-14 15:09:30.781",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055702",
        "positionId": "56055701",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.62,
        "takeProfit": null,
        "priceIn": 3220.88,
        "doubleCheck": true
    },
    {
        "id": "53092924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31.093",
        "brokerTime": "2025-05-14 15:09:31.093",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055703",
        "positionId": "56055703",
        "volume": 8.11,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53092925",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31.093",
        "brokerTime": "2025-05-14 15:09:31.512",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055704",
        "positionId": "56055703",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53092926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31.958",
        "brokerTime": "2025-05-14 15:09:31.958",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055705",
        "positionId": "56055705",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53092927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:31.958",
        "brokerTime": "2025-05-14 15:09:32.505",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055706",
        "positionId": "56055705",
        "volume": 8.11,
        "price": 3220.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53092928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:32.751",
        "brokerTime": "2025-05-14 15:09:32.751",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055707",
        "positionId": "56055707",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53092930",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:32.751",
        "brokerTime": "2025-05-14 15:09:33.810",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055710",
        "positionId": "56055707",
        "volume": 8.11,
        "price": 3221.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -324.4,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53092931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:34.409",
        "brokerTime": "2025-05-14 15:09:34.409",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055711",
        "positionId": "56055711",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "id": "53092932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:34.409",
        "brokerTime": "2025-05-14 15:09:34.952",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055712",
        "positionId": "56055711",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "id": "53092933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:35.143",
        "brokerTime": "2025-05-14 15:09:35.143",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055713",
        "positionId": "56055713",
        "volume": 8.11,
        "price": 3220.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "id": "53092934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:35.143",
        "brokerTime": "2025-05-14 15:09:35.795",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055714",
        "positionId": "56055713",
        "volume": 8.11,
        "price": 3221.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -267.63,
        "takeProfit": null,
        "priceIn": 3220.96,
        "doubleCheck": true
    },
    {
        "id": "53092935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:36.578",
        "brokerTime": "2025-05-14 15:09:36.578",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055715",
        "positionId": "56055715",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53092936",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:36.578",
        "brokerTime": "2025-05-14 15:09:37.046",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055716",
        "positionId": "56055715",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.76,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53092937",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37.306",
        "brokerTime": "2025-05-14 15:09:37.306",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055717",
        "positionId": "56055717",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53092938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:37.306",
        "brokerTime": "2025-05-14 15:09:37.970",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055718",
        "positionId": "56055717",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.76,
        "takeProfit": null,
        "priceIn": 3220.99,
        "doubleCheck": true
    },
    {
        "id": "53092939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38.165",
        "brokerTime": "2025-05-14 15:09:38.165",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055719",
        "positionId": "56055719",
        "volume": 8.11,
        "price": 3220.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092940",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38.165",
        "brokerTime": "2025-05-14 15:09:38.512",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055720",
        "positionId": "56055719",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.8,
        "doubleCheck": true
    },
    {
        "id": "53092941",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38.994",
        "brokerTime": "2025-05-14 15:09:38.994",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055721",
        "positionId": "56055721",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53092943",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:38.994",
        "brokerTime": "2025-05-14 15:09:39.692",
        "commission": -56.77,
        "swap": 0,
        "profit": 89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055723",
        "positionId": "56055721",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 32.43999999999999,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53092944",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:39.959",
        "brokerTime": "2025-05-14 15:09:39.959",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055724",
        "positionId": "56055724",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53092945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:39.959",
        "brokerTime": "2025-05-14 15:09:40.289",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055725",
        "positionId": "56055724",
        "volume": 8.11,
        "price": 3220.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3220.58,
        "doubleCheck": true
    },
    {
        "id": "53092947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:41.065",
        "brokerTime": "2025-05-14 15:09:41.065",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055727",
        "positionId": "56055727",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53092949",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:41.065",
        "brokerTime": "2025-05-14 15:09:41.876",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055729",
        "positionId": "56055727",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -89.21000000000001,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53092950",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:42.167",
        "brokerTime": "2025-05-14 15:09:42.167",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055730",
        "positionId": "56055730",
        "volume": 8.11,
        "price": 3220.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "id": "53092952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:42.167",
        "brokerTime": "2025-05-14 15:09:43.343",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055732",
        "positionId": "56055730",
        "volume": 8.11,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3220.4,
        "doubleCheck": true
    },
    {
        "id": "53092953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:43.675",
        "brokerTime": "2025-05-14 15:09:43.675",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055733",
        "positionId": "56055733",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.59,
        "doubleCheck": true
    },
    {
        "id": "53092954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:43.675",
        "brokerTime": "2025-05-14 15:09:44.562",
        "commission": -56.77,
        "swap": 0,
        "profit": -340.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055734",
        "positionId": "56055733",
        "volume": 8.11,
        "price": 3221.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -397.39,
        "takeProfit": null,
        "priceIn": 3220.59,
        "doubleCheck": true
    },
    {
        "id": "53092955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:44.874",
        "brokerTime": "2025-05-14 15:09:44.874",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055735",
        "positionId": "56055735",
        "volume": 8.11,
        "price": 3220.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53092957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:44.874",
        "brokerTime": "2025-05-14 15:09:45.930",
        "commission": -56.77,
        "swap": 0,
        "profit": 32.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055737",
        "positionId": "56055735",
        "volume": 8.11,
        "price": 3220.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -24.330000000000005,
        "takeProfit": null,
        "priceIn": 3220.86,
        "doubleCheck": true
    },
    {
        "id": "53092958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:46.490",
        "brokerTime": "2025-05-14 15:09:46.490",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055738",
        "positionId": "56055738",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53092959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:46.490",
        "brokerTime": "2025-05-14 15:09:47.856",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055739",
        "positionId": "56055738",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53092960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:48.297",
        "brokerTime": "2025-05-14 15:09:48.297",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055740",
        "positionId": "56055740",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:48.297",
        "brokerTime": "2025-05-14 15:09:49.852",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055741",
        "positionId": "56055740",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50.194",
        "brokerTime": "2025-05-14 15:09:50.194",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055742",
        "positionId": "56055742",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50.194",
        "brokerTime": "2025-05-14 15:09:50.609",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055743",
        "positionId": "56055742",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50.849",
        "brokerTime": "2025-05-14 15:09:50.849",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055744",
        "positionId": "56055744",
        "volume": 8.11,
        "price": 3220.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.42,
        "doubleCheck": true
    },
    {
        "id": "53092965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:50.849",
        "brokerTime": "2025-05-14 15:09:51.331",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055745",
        "positionId": "56055744",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.42,
        "doubleCheck": true
    },
    {
        "id": "53092966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:51.632",
        "brokerTime": "2025-05-14 15:09:51.632",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055746",
        "positionId": "56055746",
        "volume": 8.11,
        "price": 3220.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "id": "53092967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:51.632",
        "brokerTime": "2025-05-14 15:09:51.935",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055747",
        "positionId": "56055746",
        "volume": 8.11,
        "price": 3220.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.41,
        "doubleCheck": true
    },
    {
        "id": "53092968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52.277",
        "brokerTime": "2025-05-14 15:09:52.277",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055748",
        "positionId": "56055748",
        "volume": 8.11,
        "price": 3220.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53092969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:52.277",
        "brokerTime": "2025-05-14 15:09:53.036",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055749",
        "positionId": "56055748",
        "volume": 8.11,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3220.36,
        "doubleCheck": true
    },
    {
        "id": "53092970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:53.281",
        "brokerTime": "2025-05-14 15:09:53.281",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055750",
        "positionId": "56055750",
        "volume": 8.11,
        "price": 3220.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.43,
        "doubleCheck": true
    },
    {
        "id": "53092971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:53.281",
        "brokerTime": "2025-05-14 15:09:53.992",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055751",
        "positionId": "56055750",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3220.43,
        "doubleCheck": true
    },
    {
        "id": "53092972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:56.473",
        "brokerTime": "2025-05-14 15:09:56.473",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055752",
        "positionId": "56055752",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53092973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:56.473",
        "brokerTime": "2025-05-14 15:09:57.152",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055753",
        "positionId": "56055752",
        "volume": 8.11,
        "price": 3220.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53092974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:57.322",
        "brokerTime": "2025-05-14 15:09:57.322",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055754",
        "positionId": "56055754",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53092975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:57.322",
        "brokerTime": "2025-05-14 15:09:58.177",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055755",
        "positionId": "56055754",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53092976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:58.588",
        "brokerTime": "2025-05-14 15:09:58.588",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055756",
        "positionId": "56055756",
        "volume": 8.11,
        "price": 3220.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53092978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:58.588",
        "brokerTime": "2025-05-14 15:09:59.276",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055758",
        "positionId": "56055756",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -332.51,
        "takeProfit": null,
        "priceIn": 3220.64,
        "doubleCheck": true
    },
    {
        "id": "53092979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:59.962",
        "brokerTime": "2025-05-14 15:09:59.962",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055759",
        "positionId": "56055759",
        "volume": 8.11,
        "price": 3220.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53092983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:09:59.962",
        "brokerTime": "2025-05-14 15:10:00.583",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055763",
        "positionId": "56055759",
        "volume": 8.11,
        "price": 3220.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3220.67,
        "doubleCheck": true
    },
    {
        "id": "53092984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:01.034",
        "brokerTime": "2025-05-14 15:10:01.034",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055764",
        "positionId": "56055764",
        "volume": 8.11,
        "price": 3220.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:01.034",
        "brokerTime": "2025-05-14 15:10:02.047",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055765",
        "positionId": "56055764",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.51,
        "doubleCheck": true
    },
    {
        "id": "53092988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03.269",
        "brokerTime": "2025-05-14 15:10:03.269",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055770",
        "positionId": "56055770",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "id": "53093057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03.269",
        "brokerTime": "2025-05-14 15:10:03.699",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055843",
        "positionId": "56055770",
        "volume": 8.11,
        "price": 3220.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "id": "53093115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03.872",
        "brokerTime": "2025-05-14 15:10:03.872",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055865",
        "positionId": "56055865",
        "volume": 8.11,
        "price": 3220.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "id": "53093193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:03.872",
        "brokerTime": "2025-05-14 15:10:05.478",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055905",
        "positionId": "56055865",
        "volume": 8.11,
        "price": 3220.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.44,
        "doubleCheck": true
    },
    {
        "id": "53093195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:06.350",
        "brokerTime": "2025-05-14 15:10:06.350",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055907",
        "positionId": "56055907",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:06.350",
        "brokerTime": "2025-05-14 15:10:09.111",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055909",
        "positionId": "56055907",
        "volume": 8.11,
        "price": 3220.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:09.395",
        "brokerTime": "2025-05-14 15:10:09.395",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055911",
        "positionId": "56055911",
        "volume": 8.11,
        "price": 3220.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "id": "53093200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:09.395",
        "brokerTime": "2025-05-14 15:10:10.200",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055912",
        "positionId": "56055911",
        "volume": 8.11,
        "price": 3220.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3220.23,
        "doubleCheck": true
    },
    {
        "id": "53093201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:10.509",
        "brokerTime": "2025-05-14 15:10:10.509",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055913",
        "positionId": "56055913",
        "volume": 8.11,
        "price": 3220.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.13,
        "doubleCheck": true
    },
    {
        "id": "53093202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:10.509",
        "brokerTime": "2025-05-14 15:10:11.135",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055914",
        "positionId": "56055913",
        "volume": 8.11,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.13,
        "doubleCheck": true
    },
    {
        "id": "53093203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11.287",
        "brokerTime": "2025-05-14 15:10:11.287",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055915",
        "positionId": "56055915",
        "volume": 8.11,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.12,
        "doubleCheck": true
    },
    {
        "id": "53093206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:11.287",
        "brokerTime": "2025-05-14 15:10:11.769",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055917",
        "positionId": "56055915",
        "volume": 8.11,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.12,
        "doubleCheck": true
    },
    {
        "id": "53093207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:12.384",
        "brokerTime": "2025-05-14 15:10:12.384",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055918",
        "positionId": "56055918",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "id": "53093208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:12.384",
        "brokerTime": "2025-05-14 15:10:13.651",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055919",
        "positionId": "56055918",
        "volume": 8.11,
        "price": 3220.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.04,
        "doubleCheck": true
    },
    {
        "id": "53093210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:14.968",
        "brokerTime": "2025-05-14 15:10:14.968",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055921",
        "positionId": "56055921",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:14.968",
        "brokerTime": "2025-05-14 15:10:15.318",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055922",
        "positionId": "56055921",
        "volume": 8.11,
        "price": 3220.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:15.515",
        "brokerTime": "2025-05-14 15:10:15.515",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055923",
        "positionId": "56055923",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:15.515",
        "brokerTime": "2025-05-14 15:10:15.961",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055924",
        "positionId": "56055923",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3220.33,
        "doubleCheck": true
    },
    {
        "id": "53093214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:17.044",
        "brokerTime": "2025-05-14 15:10:17.044",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055925",
        "positionId": "56055925",
        "volume": 8.11,
        "price": 3220.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53093215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:17.044",
        "brokerTime": "2025-05-14 15:10:17.414",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055926",
        "positionId": "56055925",
        "volume": 8.11,
        "price": 3220.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.53,
        "doubleCheck": true
    },
    {
        "id": "53093216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:18.427",
        "brokerTime": "2025-05-14 15:10:18.427",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055927",
        "positionId": "56055927",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:18.427",
        "brokerTime": "2025-05-14 15:10:18.833",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055928",
        "positionId": "56055927",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.18,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19.051",
        "brokerTime": "2025-05-14 15:10:19.051",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055929",
        "positionId": "56055929",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53093219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19.051",
        "brokerTime": "2025-05-14 15:10:19.443",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055930",
        "positionId": "56055929",
        "volume": 8.11,
        "price": 3221.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53093220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19.736",
        "brokerTime": "2025-05-14 15:10:19.736",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055931",
        "positionId": "56055931",
        "volume": 8.11,
        "price": 3221.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53093221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:19.736",
        "brokerTime": "2025-05-14 15:10:20.071",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055932",
        "positionId": "56055931",
        "volume": 8.11,
        "price": 3221.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3221.09,
        "doubleCheck": true
    },
    {
        "id": "53093222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:20.545",
        "brokerTime": "2025-05-14 15:10:20.545",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055933",
        "positionId": "56055933",
        "volume": 8.11,
        "price": 3221.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53093223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:20.545",
        "brokerTime": "2025-05-14 15:10:21.218",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055934",
        "positionId": "56055933",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.19,
        "doubleCheck": true
    },
    {
        "id": "53093224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21.437",
        "brokerTime": "2025-05-14 15:10:21.437",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055935",
        "positionId": "56055935",
        "volume": 8.11,
        "price": 3221.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53093225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:21.437",
        "brokerTime": "2025-05-14 15:10:22.772",
        "commission": -56.77,
        "swap": 0,
        "profit": -275.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055936",
        "positionId": "56055935",
        "volume": 8.11,
        "price": 3221.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -332.51,
        "takeProfit": null,
        "priceIn": 3221.08,
        "doubleCheck": true
    },
    {
        "id": "53093227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:23.268",
        "brokerTime": "2025-05-14 15:10:23.268",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055938",
        "positionId": "56055938",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "id": "53093228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:23.268",
        "brokerTime": "2025-05-14 15:10:23.719",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055939",
        "positionId": "56055938",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3221.1,
        "doubleCheck": true
    },
    {
        "id": "53093229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:24.383",
        "brokerTime": "2025-05-14 15:10:24.383",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055940",
        "positionId": "56055940",
        "volume": 8.11,
        "price": 3221.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "id": "53093230",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:24.383",
        "brokerTime": "2025-05-14 15:10:24.783",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055941",
        "positionId": "56055940",
        "volume": 8.11,
        "price": 3221.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3221.2,
        "doubleCheck": true
    },
    {
        "id": "53093231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:25.452",
        "brokerTime": "2025-05-14 15:10:25.452",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055942",
        "positionId": "56055942",
        "volume": 8.11,
        "price": 3221.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53093232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:25.452",
        "brokerTime": "2025-05-14 15:10:25.848",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055943",
        "positionId": "56055942",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3221.16,
        "doubleCheck": true
    },
    {
        "id": "53093233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:26.063",
        "brokerTime": "2025-05-14 15:10:26.063",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055944",
        "positionId": "56055944",
        "volume": 8.11,
        "price": 3221.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53093234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:26.063",
        "brokerTime": "2025-05-14 15:10:27.597",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055945",
        "positionId": "56055944",
        "volume": 8.11,
        "price": 3221.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3221.17,
        "doubleCheck": true
    },
    {
        "id": "53093235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:27.863",
        "brokerTime": "2025-05-14 15:10:27.863",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055946",
        "positionId": "56055946",
        "volume": 8.11,
        "price": 3221.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "id": "53093236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:27.863",
        "brokerTime": "2025-05-14 15:10:28.432",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055947",
        "positionId": "56055946",
        "volume": 8.11,
        "price": 3221.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3221.06,
        "doubleCheck": true
    },
    {
        "id": "53093237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:29.436",
        "brokerTime": "2025-05-14 15:10:29.436",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055949",
        "positionId": "56055949",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53093238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:29.436",
        "brokerTime": "2025-05-14 15:10:29.761",
        "commission": -56.77,
        "swap": 0,
        "profit": -16.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055950",
        "positionId": "56055949",
        "volume": 8.11,
        "price": 3220.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.99000000000001,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53093239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:30.161",
        "brokerTime": "2025-05-14 15:10:30.161",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055951",
        "positionId": "56055951",
        "volume": 8.11,
        "price": 3220.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53093240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:30.161",
        "brokerTime": "2025-05-14 15:10:30.660",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055952",
        "positionId": "56055951",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.84,
        "doubleCheck": true
    },
    {
        "id": "53093241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:31.180",
        "brokerTime": "2025-05-14 15:10:31.180",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055953",
        "positionId": "56055953",
        "volume": 8.11,
        "price": 3220.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53093242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:31.180",
        "brokerTime": "2025-05-14 15:10:32.032",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055954",
        "positionId": "56055953",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3220.83,
        "doubleCheck": true
    },
    {
        "id": "53093243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:33.914",
        "brokerTime": "2025-05-14 15:10:33.914",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055955",
        "positionId": "56055955",
        "volume": 8.11,
        "price": 3220.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53093244",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:33.914",
        "brokerTime": "2025-05-14 15:10:34.289",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055956",
        "positionId": "56055955",
        "volume": 8.11,
        "price": 3221.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3220.93,
        "doubleCheck": true
    },
    {
        "id": "53093246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:34.878",
        "brokerTime": "2025-05-14 15:10:34.878",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055958",
        "positionId": "56055958",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:34.878",
        "brokerTime": "2025-05-14 15:10:36.210",
        "commission": -56.77,
        "swap": 0,
        "profit": -48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055959",
        "positionId": "56055958",
        "volume": 8.11,
        "price": 3220.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.43,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:36.573",
        "brokerTime": "2025-05-14 15:10:36.573",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055960",
        "positionId": "56055960",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093249",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:36.573",
        "brokerTime": "2025-05-14 15:10:37.072",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055961",
        "positionId": "56055960",
        "volume": 8.11,
        "price": 3221.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37.407",
        "brokerTime": "2025-05-14 15:10:37.407",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055962",
        "positionId": "56055962",
        "volume": 8.11,
        "price": 3220.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:37.407",
        "brokerTime": "2025-05-14 15:10:37.813",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055963",
        "positionId": "56055962",
        "volume": 8.11,
        "price": 3221.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3220.92,
        "doubleCheck": true
    },
    {
        "id": "53093252",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:38.380",
        "brokerTime": "2025-05-14 15:10:38.380",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055964",
        "positionId": "56055964",
        "volume": 8.11,
        "price": 3220.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53093253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:38.380",
        "brokerTime": "2025-05-14 15:10:39.743",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055965",
        "positionId": "56055964",
        "volume": 8.11,
        "price": 3221.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.97,
        "doubleCheck": true
    },
    {
        "id": "53093254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:39.955",
        "brokerTime": "2025-05-14 15:10:39.955",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055966",
        "positionId": "56055966",
        "volume": 8.11,
        "price": 3221.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53093255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:39.955",
        "brokerTime": "2025-05-14 15:10:40.729",
        "commission": -56.77,
        "swap": 0,
        "profit": 567.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055967",
        "positionId": "56055966",
        "volume": 8.11,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 510.93000000000006,
        "takeProfit": null,
        "priceIn": 3221.41,
        "doubleCheck": true
    },
    {
        "id": "53093256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:40.987",
        "brokerTime": "2025-05-14 15:10:40.987",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055968",
        "positionId": "56055968",
        "volume": 8.11,
        "price": 3220.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53093257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:40.987",
        "brokerTime": "2025-05-14 15:10:41.928",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055969",
        "positionId": "56055968",
        "volume": 8.11,
        "price": 3220.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3220.6,
        "doubleCheck": true
    },
    {
        "id": "53093258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:42.282",
        "brokerTime": "2025-05-14 15:10:42.282",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055970",
        "positionId": "56055970",
        "volume": 8.11,
        "price": 3220.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53093259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:42.282",
        "brokerTime": "2025-05-14 15:10:43.762",
        "commission": -56.77,
        "swap": 0,
        "profit": 8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055971",
        "positionId": "56055970",
        "volume": 8.11,
        "price": 3220.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -48.660000000000004,
        "takeProfit": null,
        "priceIn": 3220.72,
        "doubleCheck": true
    },
    {
        "id": "53093260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:44.330",
        "brokerTime": "2025-05-14 15:10:44.330",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055972",
        "positionId": "56055972",
        "volume": 8.11,
        "price": 3220.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53093261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:44.330",
        "brokerTime": "2025-05-14 15:10:45.868",
        "commission": -56.77,
        "swap": 0,
        "profit": 40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055973",
        "positionId": "56055972",
        "volume": 8.11,
        "price": 3220.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.220000000000006,
        "takeProfit": null,
        "priceIn": 3220.52,
        "doubleCheck": true
    },
    {
        "id": "53093262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:46.296",
        "brokerTime": "2025-05-14 15:10:46.296",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055974",
        "positionId": "56055974",
        "volume": 8.11,
        "price": 3220.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.3,
        "doubleCheck": true
    },
    {
        "id": "53093263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:46.296",
        "brokerTime": "2025-05-14 15:10:46.900",
        "commission": -56.77,
        "swap": 0,
        "profit": 113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055975",
        "positionId": "56055974",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 56.77,
        "takeProfit": null,
        "priceIn": 3220.3,
        "doubleCheck": true
    },
    {
        "id": "53093264",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:47.191",
        "brokerTime": "2025-05-14 15:10:47.191",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055976",
        "positionId": "56055976",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53093266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:47.191",
        "brokerTime": "2025-05-14 15:10:47.583",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055978",
        "positionId": "56055976",
        "volume": 8.11,
        "price": 3220.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53093267",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48.099",
        "brokerTime": "2025-05-14 15:10:48.099",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055979",
        "positionId": "56055979",
        "volume": 8.11,
        "price": 3220.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53093268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48.099",
        "brokerTime": "2025-05-14 15:10:48.465",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055981",
        "positionId": "56055979",
        "volume": 8.11,
        "price": 3220.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3220.08,
        "doubleCheck": true
    },
    {
        "id": "53093269",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48.934",
        "brokerTime": "2025-05-14 15:10:48.934",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055982",
        "positionId": "56055982",
        "volume": 8.11,
        "price": 3220.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53093270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:48.934",
        "brokerTime": "2025-05-14 15:10:49.407",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055983",
        "positionId": "56055982",
        "volume": 8.11,
        "price": 3220.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -267.63,
        "takeProfit": null,
        "priceIn": 3220.07,
        "doubleCheck": true
    },
    {
        "id": "53093271",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:50.229",
        "brokerTime": "2025-05-14 15:10:50.229",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055984",
        "positionId": "56055984",
        "volume": 8.11,
        "price": 3220.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.21,
        "doubleCheck": true
    },
    {
        "id": "53093272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:50.229",
        "brokerTime": "2025-05-14 15:10:50.815",
        "commission": -56.77,
        "swap": 0,
        "profit": 24.33,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055985",
        "positionId": "56055984",
        "volume": 8.11,
        "price": 3220.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -32.440000000000005,
        "takeProfit": null,
        "priceIn": 3220.21,
        "doubleCheck": true
    },
    {
        "id": "53093273",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:51.162",
        "brokerTime": "2025-05-14 15:10:51.162",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055986",
        "positionId": "56055986",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.15,
        "doubleCheck": true
    },
    {
        "id": "53093274",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:51.162",
        "brokerTime": "2025-05-14 15:10:52.043",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055987",
        "positionId": "56055986",
        "volume": 8.11,
        "price": 3220.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3220.15,
        "doubleCheck": true
    },
    {
        "id": "53093275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:52.468",
        "brokerTime": "2025-05-14 15:10:52.468",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055988",
        "positionId": "56055988",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "id": "53093276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:52.468",
        "brokerTime": "2025-05-14 15:10:52.840",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055989",
        "positionId": "56055988",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "id": "53093278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:55.056",
        "brokerTime": "2025-05-14 15:10:55.056",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055991",
        "positionId": "56055991",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53093279",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:55.056",
        "brokerTime": "2025-05-14 15:10:56.512",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055992",
        "positionId": "56055991",
        "volume": 8.11,
        "price": 3219.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3219.94,
        "doubleCheck": true
    },
    {
        "id": "53093286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:57.480",
        "brokerTime": "2025-05-14 15:10:57.480",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56055999",
        "positionId": "56055999",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53093289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:57.480",
        "brokerTime": "2025-05-14 15:10:57.959",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056002",
        "positionId": "56055999",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3219.66,
        "doubleCheck": true
    },
    {
        "id": "53093293",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:58.609",
        "brokerTime": "2025-05-14 15:10:58.609",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056006",
        "positionId": "56056006",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "id": "53093296",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:58.609",
        "brokerTime": "2025-05-14 15:10:59.152",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056009",
        "positionId": "56056006",
        "volume": 8.11,
        "price": 3219.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "id": "53093297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:59.879",
        "brokerTime": "2025-05-14 15:10:59.879",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056010",
        "positionId": "56056010",
        "volume": 8.11,
        "price": 3219.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53093312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:10:59.879",
        "brokerTime": "2025-05-14 15:11:00.413",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056026",
        "positionId": "56056010",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.63,
        "doubleCheck": true
    },
    {
        "id": "53093317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:01.013",
        "brokerTime": "2025-05-14 15:11:01.013",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056029",
        "positionId": "56056029",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53093320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:01.013",
        "brokerTime": "2025-05-14 15:11:01.429",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056033",
        "positionId": "56056029",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53093324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02.054",
        "brokerTime": "2025-05-14 15:11:02.054",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056036",
        "positionId": "56056036",
        "volume": 8.11,
        "price": 3219.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.67,
        "doubleCheck": true
    },
    {
        "id": "53093454",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02.054",
        "brokerTime": "2025-05-14 15:11:02.412",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056109",
        "positionId": "56056036",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3219.67,
        "doubleCheck": true
    },
    {
        "id": "53093493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02.874",
        "brokerTime": "2025-05-14 15:11:02.874",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056159",
        "positionId": "56056159",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.72,
        "doubleCheck": true
    },
    {
        "id": "53093623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:02.874",
        "brokerTime": "2025-05-14 15:11:03.391",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056231",
        "positionId": "56056159",
        "volume": 8.11,
        "price": 3219.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3219.72,
        "doubleCheck": true
    },
    {
        "id": "53093653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:03.768",
        "brokerTime": "2025-05-14 15:11:03.768",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056244",
        "positionId": "56056244",
        "volume": 8.11,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53093662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:03.768",
        "brokerTime": "2025-05-14 15:11:04.365",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056250",
        "positionId": "56056244",
        "volume": 8.11,
        "price": 3219.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53093664",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:04.585",
        "brokerTime": "2025-05-14 15:11:04.585",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056253",
        "positionId": "56056253",
        "volume": 8.11,
        "price": 3219.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53093668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:04.585",
        "brokerTime": "2025-05-14 15:11:04.919",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056254",
        "positionId": "56056253",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.68,
        "doubleCheck": true
    },
    {
        "id": "53093669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05.179",
        "brokerTime": "2025-05-14 15:11:05.179",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056255",
        "positionId": "56056255",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53093670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:05.179",
        "brokerTime": "2025-05-14 15:11:05.706",
        "commission": -56.77,
        "swap": 0,
        "profit": -194.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056256",
        "positionId": "56056255",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -251.41,
        "takeProfit": null,
        "priceIn": 3219.71,
        "doubleCheck": true
    },
    {
        "id": "53093671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:06.227",
        "brokerTime": "2025-05-14 15:11:06.227",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056257",
        "positionId": "56056257",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "id": "53093672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:06.227",
        "brokerTime": "2025-05-14 15:11:07.709",
        "commission": -56.77,
        "swap": 0,
        "profit": -227.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056258",
        "positionId": "56056257",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -283.85,
        "takeProfit": null,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "id": "53093673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08.008",
        "brokerTime": "2025-05-14 15:11:08.008",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056259",
        "positionId": "56056259",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.8,
        "doubleCheck": true
    },
    {
        "id": "53093674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08.008",
        "brokerTime": "2025-05-14 15:11:08.406",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056260",
        "positionId": "56056259",
        "volume": 8.11,
        "price": 3219.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3219.8,
        "doubleCheck": true
    },
    {
        "id": "53093675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08.630",
        "brokerTime": "2025-05-14 15:11:08.630",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056261",
        "positionId": "56056261",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.79,
        "doubleCheck": true
    },
    {
        "id": "53093677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:08.630",
        "brokerTime": "2025-05-14 15:11:10.136",
        "commission": -56.77,
        "swap": 0,
        "profit": -8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056263",
        "positionId": "56056261",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -64.88,
        "takeProfit": null,
        "priceIn": 3219.79,
        "doubleCheck": true
    },
    {
        "id": "53093678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:10.535",
        "brokerTime": "2025-05-14 15:11:10.535",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056265",
        "positionId": "56056265",
        "volume": 8.11,
        "price": 3219.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53093679",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:10.535",
        "brokerTime": "2025-05-14 15:11:11.126",
        "commission": -56.77,
        "swap": 0,
        "profit": 97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056266",
        "positionId": "56056265",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 40.54999999999999,
        "takeProfit": null,
        "priceIn": 3219.84,
        "doubleCheck": true
    },
    {
        "id": "53093680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11.481",
        "brokerTime": "2025-05-14 15:11:11.481",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056267",
        "positionId": "56056267",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.6,
        "doubleCheck": true
    },
    {
        "id": "53093681",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:11.481",
        "brokerTime": "2025-05-14 15:11:11.874",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056268",
        "positionId": "56056267",
        "volume": 8.11,
        "price": 3219.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3219.6,
        "doubleCheck": true
    },
    {
        "id": "53093683",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:12.600",
        "brokerTime": "2025-05-14 15:11:12.600",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056270",
        "positionId": "56056270",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.56,
        "doubleCheck": true
    },
    {
        "id": "53093684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:12.600",
        "brokerTime": "2025-05-14 15:11:13.128",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056271",
        "positionId": "56056270",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.56,
        "doubleCheck": true
    },
    {
        "id": "53093685",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:13.921",
        "brokerTime": "2025-05-14 15:11:13.921",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056272",
        "positionId": "56056272",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53093688",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:13.921",
        "brokerTime": "2025-05-14 15:11:14.664",
        "commission": -56.77,
        "swap": 0,
        "profit": 48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056275",
        "positionId": "56056272",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.110000000000007,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53093689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:14.986",
        "brokerTime": "2025-05-14 15:11:14.986",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056276",
        "positionId": "56056276",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53093691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:14.986",
        "brokerTime": "2025-05-14 15:11:15.292",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056278",
        "positionId": "56056276",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53093692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:16.420",
        "brokerTime": "2025-05-14 15:11:16.420",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056279",
        "positionId": "56056279",
        "volume": 8.11,
        "price": 3219.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "id": "53093693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:16.420",
        "brokerTime": "2025-05-14 15:11:16.800",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056280",
        "positionId": "56056279",
        "volume": 8.11,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.21,
        "doubleCheck": true
    },
    {
        "id": "53093694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:17.056",
        "brokerTime": "2025-05-14 15:11:17.056",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056281",
        "positionId": "56056281",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53093695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:17.056",
        "brokerTime": "2025-05-14 15:11:18.390",
        "commission": -56.77,
        "swap": 0,
        "profit": -283.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056282",
        "positionId": "56056281",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.62,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53093696",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:18.592",
        "brokerTime": "2025-05-14 15:11:18.592",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056283",
        "positionId": "56056283",
        "volume": 8.11,
        "price": 3219.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "id": "53093697",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:18.592",
        "brokerTime": "2025-05-14 15:11:18.932",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056284",
        "positionId": "56056283",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3219.45,
        "doubleCheck": true
    },
    {
        "id": "53093698",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19.302",
        "brokerTime": "2025-05-14 15:11:19.302",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056285",
        "positionId": "56056285",
        "volume": 8.11,
        "price": 3219.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.46,
        "doubleCheck": true
    },
    {
        "id": "53093699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:19.302",
        "brokerTime": "2025-05-14 15:11:19.798",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056286",
        "positionId": "56056285",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3219.46,
        "doubleCheck": true
    },
    {
        "id": "53093702",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:20.041",
        "brokerTime": "2025-05-14 15:11:20.041",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056288",
        "positionId": "56056288",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53093705",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:20.041",
        "brokerTime": "2025-05-14 15:11:20.971",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056291",
        "positionId": "56056288",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -324.4,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53093706",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21.205",
        "brokerTime": "2025-05-14 15:11:21.205",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056292",
        "positionId": "56056292",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53093707",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21.205",
        "brokerTime": "2025-05-14 15:11:21.493",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056293",
        "positionId": "56056292",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.52,
        "takeProfit": null,
        "priceIn": 3219.55,
        "doubleCheck": true
    },
    {
        "id": "53093708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21.803",
        "brokerTime": "2025-05-14 15:11:21.803",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056294",
        "positionId": "56056294",
        "volume": 8.11,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53093710",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:21.803",
        "brokerTime": "2025-05-14 15:11:22.713",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056296",
        "positionId": "56056294",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53093714",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:23.138",
        "brokerTime": "2025-05-14 15:11:23.138",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056301",
        "positionId": "56056301",
        "volume": 8.11,
        "price": 3219.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.35,
        "doubleCheck": true
    },
    {
        "id": "53093716",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:23.138",
        "brokerTime": "2025-05-14 15:11:23.424",
        "commission": -56.77,
        "swap": 0,
        "profit": 105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056302",
        "positionId": "56056301",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 48.660000000000004,
        "takeProfit": null,
        "priceIn": 3219.35,
        "doubleCheck": true
    },
    {
        "id": "53093717",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:24.683",
        "brokerTime": "2025-05-14 15:11:24.683",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056303",
        "positionId": "56056303",
        "volume": 8.11,
        "price": 3219.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "id": "53093718",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:24.683",
        "brokerTime": "2025-05-14 15:11:25.055",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056304",
        "positionId": "56056303",
        "volume": 8.11,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "id": "53093719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25.288",
        "brokerTime": "2025-05-14 15:11:25.288",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056305",
        "positionId": "56056305",
        "volume": 8.11,
        "price": 3219.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "id": "53093722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:25.288",
        "brokerTime": "2025-05-14 15:11:26.533",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056308",
        "positionId": "56056305",
        "volume": 8.11,
        "price": 3219.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3219.13,
        "doubleCheck": true
    },
    {
        "id": "53093723",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:27.591",
        "brokerTime": "2025-05-14 15:11:27.591",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056309",
        "positionId": "56056309",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.2,
        "doubleCheck": true
    },
    {
        "id": "53093726",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:27.591",
        "brokerTime": "2025-05-14 15:11:28.073",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056312",
        "positionId": "56056309",
        "volume": 8.11,
        "price": 3219.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.2,
        "doubleCheck": true
    },
    {
        "id": "53093727",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28.491",
        "brokerTime": "2025-05-14 15:11:28.491",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056313",
        "positionId": "56056313",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53093728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:28.491",
        "brokerTime": "2025-05-14 15:11:28.847",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056314",
        "positionId": "56056313",
        "volume": 8.11,
        "price": 3219.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53093729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:29.797",
        "brokerTime": "2025-05-14 15:11:29.797",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056315",
        "positionId": "56056315",
        "volume": 8.11,
        "price": 3219.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53093730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:29.797",
        "brokerTime": "2025-05-14 15:11:31.653",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056316",
        "positionId": "56056315",
        "volume": 8.11,
        "price": 3219.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3219.44,
        "doubleCheck": true
    },
    {
        "id": "53093731",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:31.907",
        "brokerTime": "2025-05-14 15:11:31.907",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056317",
        "positionId": "56056317",
        "volume": 8.11,
        "price": 3219.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.39,
        "doubleCheck": true
    },
    {
        "id": "53093732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:31.907",
        "brokerTime": "2025-05-14 15:11:32.858",
        "commission": -56.77,
        "swap": 0,
        "profit": -210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056318",
        "positionId": "56056317",
        "volume": 8.11,
        "price": 3219.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -267.63,
        "takeProfit": null,
        "priceIn": 3219.39,
        "doubleCheck": true
    },
    {
        "id": "53093733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:33.454",
        "brokerTime": "2025-05-14 15:11:33.454",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056319",
        "positionId": "56056319",
        "volume": 8.11,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "id": "53093734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:33.454",
        "brokerTime": "2025-05-14 15:11:33.833",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056320",
        "positionId": "56056319",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "id": "53093736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:34.074",
        "brokerTime": "2025-05-14 15:11:34.074",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056322",
        "positionId": "56056322",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.49,
        "doubleCheck": true
    },
    {
        "id": "53093737",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:34.074",
        "brokerTime": "2025-05-14 15:11:35.218",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056323",
        "positionId": "56056322",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.49,
        "doubleCheck": true
    },
    {
        "id": "53093738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:35.432",
        "brokerTime": "2025-05-14 15:11:35.432",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056324",
        "positionId": "56056324",
        "volume": 8.11,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53093740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:35.432",
        "brokerTime": "2025-05-14 15:11:37.267",
        "commission": -56.77,
        "swap": 0,
        "profit": -324.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056326",
        "positionId": "56056324",
        "volume": 8.11,
        "price": 3220.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -381.16999999999996,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53093741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:37.548",
        "brokerTime": "2025-05-14 15:11:37.548",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056327",
        "positionId": "56056327",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "id": "53093742",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:37.548",
        "brokerTime": "2025-05-14 15:11:37.978",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056328",
        "positionId": "56056327",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3220.14,
        "doubleCheck": true
    },
    {
        "id": "53093743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38.316",
        "brokerTime": "2025-05-14 15:11:38.316",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056329",
        "positionId": "56056329",
        "volume": 8.11,
        "price": 3220.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "id": "53093744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:38.316",
        "brokerTime": "2025-05-14 15:11:38.662",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056331",
        "positionId": "56056329",
        "volume": 8.11,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220.1,
        "doubleCheck": true
    },
    {
        "id": "53093746",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:39.066",
        "brokerTime": "2025-05-14 15:11:39.066",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056332",
        "positionId": "56056332",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53093747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:39.066",
        "brokerTime": "2025-05-14 15:11:39.663",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056333",
        "positionId": "56056332",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53093749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:40.391",
        "brokerTime": "2025-05-14 15:11:40.391",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056335",
        "positionId": "56056335",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.16,
        "doubleCheck": true
    },
    {
        "id": "53093751",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:40.391",
        "brokerTime": "2025-05-14 15:11:40.697",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056337",
        "positionId": "56056335",
        "volume": 8.11,
        "price": 3220.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3220.16,
        "doubleCheck": true
    },
    {
        "id": "53093752",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:41.329",
        "brokerTime": "2025-05-14 15:11:41.329",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056338",
        "positionId": "56056338",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53093753",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:41.329",
        "brokerTime": "2025-05-14 15:11:42.395",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056339",
        "positionId": "56056338",
        "volume": 8.11,
        "price": 3220.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3220.09,
        "doubleCheck": true
    },
    {
        "id": "53093754",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:42.789",
        "brokerTime": "2025-05-14 15:11:42.789",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056340",
        "positionId": "56056340",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53093756",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:42.789",
        "brokerTime": "2025-05-14 15:11:43.763",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056342",
        "positionId": "56056340",
        "volume": 8.11,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53093757",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:44.302",
        "brokerTime": "2025-05-14 15:11:44.302",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056343",
        "positionId": "56056343",
        "volume": 8.11,
        "price": 3219.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.77,
        "doubleCheck": true
    },
    {
        "id": "53093758",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:44.302",
        "brokerTime": "2025-05-14 15:11:45.298",
        "commission": -56.77,
        "swap": 0,
        "profit": -462.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056344",
        "positionId": "56056343",
        "volume": 8.11,
        "price": 3220.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -519.04,
        "takeProfit": null,
        "priceIn": 3219.77,
        "doubleCheck": true
    },
    {
        "id": "53093759",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:45.495",
        "brokerTime": "2025-05-14 15:11:45.495",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056345",
        "positionId": "56056345",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53093760",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:45.495",
        "brokerTime": "2025-05-14 15:11:46.502",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056346",
        "positionId": "56056345",
        "volume": 8.11,
        "price": 3220.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220.17,
        "doubleCheck": true
    },
    {
        "id": "53093761",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:46.705",
        "brokerTime": "2025-05-14 15:11:46.705",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056347",
        "positionId": "56056347",
        "volume": 8.11,
        "price": 3220,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3220,
        "doubleCheck": true
    },
    {
        "id": "53093762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:46.705",
        "brokerTime": "2025-05-14 15:11:47.070",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056348",
        "positionId": "56056347",
        "volume": 8.11,
        "price": 3220.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3220,
        "doubleCheck": true
    },
    {
        "id": "53093763",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47.431",
        "brokerTime": "2025-05-14 15:11:47.431",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056349",
        "positionId": "56056349",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093764",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:47.431",
        "brokerTime": "2025-05-14 15:11:47.870",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056350",
        "positionId": "56056349",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093765",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:48.043",
        "brokerTime": "2025-05-14 15:11:48.043",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056351",
        "positionId": "56056351",
        "volume": 8.11,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53093766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:48.043",
        "brokerTime": "2025-05-14 15:11:48.617",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056352",
        "positionId": "56056351",
        "volume": 8.11,
        "price": 3220.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53093767",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:49.490",
        "brokerTime": "2025-05-14 15:11:49.490",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056353",
        "positionId": "56056353",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093768",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:49.490",
        "brokerTime": "2025-05-14 15:11:49.860",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056354",
        "positionId": "56056353",
        "volume": 8.11,
        "price": 3220.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093769",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50.021",
        "brokerTime": "2025-05-14 15:11:50.021",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056355",
        "positionId": "56056355",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093770",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50.021",
        "brokerTime": "2025-05-14 15:11:50.419",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056356",
        "positionId": "56056355",
        "volume": 8.11,
        "price": 3220.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50.671",
        "brokerTime": "2025-05-14 15:11:50.671",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056357",
        "positionId": "56056357",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:50.671",
        "brokerTime": "2025-05-14 15:11:51.039",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056358",
        "positionId": "56056357",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093774",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:51.546",
        "brokerTime": "2025-05-14 15:11:51.546",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056360",
        "positionId": "56056360",
        "volume": 8.11,
        "price": 3219.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53093775",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:51.546",
        "brokerTime": "2025-05-14 15:11:51.849",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056361",
        "positionId": "56056360",
        "volume": 8.11,
        "price": 3220.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.93,
        "doubleCheck": true
    },
    {
        "id": "53093776",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52.128",
        "brokerTime": "2025-05-14 15:11:52.128",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056362",
        "positionId": "56056362",
        "volume": 8.11,
        "price": 3219.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.91,
        "doubleCheck": true
    },
    {
        "id": "53093777",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:52.128",
        "brokerTime": "2025-05-14 15:11:53.521",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056363",
        "positionId": "56056362",
        "volume": 8.11,
        "price": 3220.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3219.91,
        "doubleCheck": true
    },
    {
        "id": "53093778",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:53.864",
        "brokerTime": "2025-05-14 15:11:53.864",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056364",
        "positionId": "56056364",
        "volume": 8.11,
        "price": 3219.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093779",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:53.864",
        "brokerTime": "2025-05-14 15:11:54.442",
        "commission": -56.77,
        "swap": 0,
        "profit": -251.41,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056365",
        "positionId": "56056364",
        "volume": 8.11,
        "price": 3220.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.18,
        "takeProfit": null,
        "priceIn": 3219.95,
        "doubleCheck": true
    },
    {
        "id": "53093782",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:55.827",
        "brokerTime": "2025-05-14 15:11:55.827",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056367",
        "positionId": "56056367",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53093783",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:55.827",
        "brokerTime": "2025-05-14 15:11:56.194",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056368",
        "positionId": "56056367",
        "volume": 8.11,
        "price": 3220.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.85,
        "doubleCheck": true
    },
    {
        "id": "53093784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56.433",
        "brokerTime": "2025-05-14 15:11:56.433",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056369",
        "positionId": "56056369",
        "volume": 8.11,
        "price": 3219.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53093786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:56.433",
        "brokerTime": "2025-05-14 15:11:58.114",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056371",
        "positionId": "56056369",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.88,
        "doubleCheck": true
    },
    {
        "id": "53093787",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:58.652",
        "brokerTime": "2025-05-14 15:11:58.652",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056372",
        "positionId": "56056372",
        "volume": 8.11,
        "price": 3219.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:11:58.652",
        "brokerTime": "2025-05-14 15:12:00.155",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056373",
        "positionId": "56056372",
        "volume": 8.11,
        "price": 3220.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.97,
        "doubleCheck": true
    },
    {
        "id": "53093790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:01.961",
        "brokerTime": "2025-05-14 15:12:01.961",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056376",
        "positionId": "56056376",
        "volume": 8.11,
        "price": 3219.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "id": "53093791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:01.961",
        "brokerTime": "2025-05-14 15:12:02.258",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056377",
        "positionId": "56056376",
        "volume": 8.11,
        "price": 3220.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3219.98,
        "doubleCheck": true
    },
    {
        "id": "53093792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03.233",
        "brokerTime": "2025-05-14 15:12:03.233",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056378",
        "positionId": "56056378",
        "volume": 8.11,
        "price": 3219.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53093793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03.233",
        "brokerTime": "2025-05-14 15:12:03.747",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056379",
        "positionId": "56056378",
        "volume": 8.11,
        "price": 3220.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.87,
        "doubleCheck": true
    },
    {
        "id": "53093794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03.947",
        "brokerTime": "2025-05-14 15:12:03.947",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056380",
        "positionId": "56056380",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53093795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:03.947",
        "brokerTime": "2025-05-14 15:12:04.940",
        "commission": -56.77,
        "swap": 0,
        "profit": -64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056381",
        "positionId": "56056380",
        "volume": 8.11,
        "price": 3219.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -121.65,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53093796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05.196",
        "brokerTime": "2025-05-14 15:12:05.196",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056382",
        "positionId": "56056382",
        "volume": 8.11,
        "price": 3219.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "id": "53093797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05.196",
        "brokerTime": "2025-05-14 15:12:05.461",
        "commission": -56.77,
        "swap": 0,
        "profit": -235.19,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056383",
        "positionId": "56056382",
        "volume": 8.11,
        "price": 3219.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -291.96,
        "takeProfit": null,
        "priceIn": 3219.51,
        "doubleCheck": true
    },
    {
        "id": "53093798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05.996",
        "brokerTime": "2025-05-14 15:12:05.996",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056384",
        "positionId": "56056384",
        "volume": 8.11,
        "price": 3219.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "id": "53093841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:05.996",
        "brokerTime": "2025-05-14 15:12:06.544",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056601",
        "positionId": "56056384",
        "volume": 8.11,
        "price": 3219.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3219.62,
        "doubleCheck": true
    },
    {
        "id": "53094035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:06.761",
        "brokerTime": "2025-05-14 15:12:06.761",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056605",
        "positionId": "56056605",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "id": "53094046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:06.761",
        "brokerTime": "2025-05-14 15:12:07.220",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056611",
        "positionId": "56056605",
        "volume": 8.11,
        "price": 3219.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.74,
        "doubleCheck": true
    },
    {
        "id": "53094105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08.208",
        "brokerTime": "2025-05-14 15:12:08.208",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056661",
        "positionId": "56056661",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53094108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08.208",
        "brokerTime": "2025-05-14 15:12:08.633",
        "commission": -56.77,
        "swap": 0,
        "profit": -40.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056664",
        "positionId": "56056661",
        "volume": 8.11,
        "price": 3219.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -97.32,
        "takeProfit": null,
        "priceIn": 3219.41,
        "doubleCheck": true
    },
    {
        "id": "53094109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08.939",
        "brokerTime": "2025-05-14 15:12:08.939",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056665",
        "positionId": "56056665",
        "volume": 8.11,
        "price": 3219.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.31,
        "doubleCheck": true
    },
    {
        "id": "53094110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:08.939",
        "brokerTime": "2025-05-14 15:12:09.498",
        "commission": -56.77,
        "swap": 0,
        "profit": -89.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056666",
        "positionId": "56056665",
        "volume": 8.11,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -145.98,
        "takeProfit": null,
        "priceIn": 3219.31,
        "doubleCheck": true
    },
    {
        "id": "53094111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:09.702",
        "brokerTime": "2025-05-14 15:12:09.702",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056667",
        "positionId": "56056667",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53094112",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:09.702",
        "brokerTime": "2025-05-14 15:12:10.096",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056668",
        "positionId": "56056667",
        "volume": 8.11,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53094113",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:10.528",
        "brokerTime": "2025-05-14 15:12:10.528",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056669",
        "positionId": "56056669",
        "volume": 8.11,
        "price": 3219.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53094115",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:10.528",
        "brokerTime": "2025-05-14 15:12:12.133",
        "commission": -56.77,
        "swap": 0,
        "profit": -24.33,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056672",
        "positionId": "56056669",
        "volume": 8.11,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -81.1,
        "takeProfit": null,
        "priceIn": 3219.24,
        "doubleCheck": true
    },
    {
        "id": "53094116",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:12.651",
        "brokerTime": "2025-05-14 15:12:12.651",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056673",
        "positionId": "56056673",
        "volume": 8.11,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53094117",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:12.651",
        "brokerTime": "2025-05-14 15:12:13.224",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056674",
        "positionId": "56056673",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53094118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:13.938",
        "brokerTime": "2025-05-14 15:12:13.938",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056675",
        "positionId": "56056675",
        "volume": 8.11,
        "price": 3218.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53094120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:13.938",
        "brokerTime": "2025-05-14 15:12:15.342",
        "commission": -56.77,
        "swap": 0,
        "profit": 48.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056677",
        "positionId": "56056675",
        "volume": 8.11,
        "price": 3218.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.110000000000007,
        "takeProfit": null,
        "priceIn": 3218.99,
        "doubleCheck": true
    },
    {
        "id": "53094125",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:15.650",
        "brokerTime": "2025-05-14 15:12:15.650",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056680",
        "positionId": "56056680",
        "volume": 8.11,
        "price": 3218.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.69,
        "doubleCheck": true
    },
    {
        "id": "53094127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:15.650",
        "brokerTime": "2025-05-14 15:12:16.010",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056681",
        "positionId": "56056680",
        "volume": 8.11,
        "price": 3218.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3218.69,
        "doubleCheck": true
    },
    {
        "id": "53094128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16.241",
        "brokerTime": "2025-05-14 15:12:16.241",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056682",
        "positionId": "56056682",
        "volume": 8.11,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "id": "53094131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16.241",
        "brokerTime": "2025-05-14 15:12:16.633",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056684",
        "positionId": "56056682",
        "volume": 8.11,
        "price": 3218.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3218.71,
        "doubleCheck": true
    },
    {
        "id": "53094132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16.794",
        "brokerTime": "2025-05-14 15:12:16.794",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056685",
        "positionId": "56056685",
        "volume": 8.11,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53094134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:16.794",
        "brokerTime": "2025-05-14 15:12:17.299",
        "commission": -56.77,
        "swap": 0,
        "profit": -267.63,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056686",
        "positionId": "56056685",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -324.4,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53094135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:17.654",
        "brokerTime": "2025-05-14 15:12:17.654",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056687",
        "positionId": "56056687",
        "volume": 8.11,
        "price": 3218.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53094136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:17.654",
        "brokerTime": "2025-05-14 15:12:18.203",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056688",
        "positionId": "56056687",
        "volume": 8.11,
        "price": 3218.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3218.68,
        "doubleCheck": true
    },
    {
        "id": "53094137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18.361",
        "brokerTime": "2025-05-14 15:12:18.361",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056689",
        "positionId": "56056689",
        "volume": 8.11,
        "price": 3218.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "id": "53094142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:18.361",
        "brokerTime": "2025-05-14 15:12:18.781",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056693",
        "positionId": "56056689",
        "volume": 8.11,
        "price": 3218.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "id": "53094143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19.033",
        "brokerTime": "2025-05-14 15:12:19.033",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056694",
        "positionId": "56056694",
        "volume": 8.11,
        "price": 3218.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53094146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19.033",
        "brokerTime": "2025-05-14 15:12:19.446",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056695",
        "positionId": "56056694",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.52,
        "takeProfit": null,
        "priceIn": 3218.52,
        "doubleCheck": true
    },
    {
        "id": "53094147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19.720",
        "brokerTime": "2025-05-14 15:12:19.720",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056696",
        "positionId": "56056696",
        "volume": 8.11,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53094148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:19.720",
        "brokerTime": "2025-05-14 15:12:20.014",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056697",
        "positionId": "56056696",
        "volume": 8.11,
        "price": 3218.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53094149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20.437",
        "brokerTime": "2025-05-14 15:12:20.437",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056698",
        "positionId": "56056698",
        "volume": 8.11,
        "price": 3218.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "id": "53094150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:20.437",
        "brokerTime": "2025-05-14 15:12:21.254",
        "commission": -56.77,
        "swap": 0,
        "profit": 64.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056699",
        "positionId": "56056698",
        "volume": 8.11,
        "price": 3218.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 8.109999999999992,
        "takeProfit": null,
        "priceIn": 3218.59,
        "doubleCheck": true
    },
    {
        "id": "53094152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:21.606",
        "brokerTime": "2025-05-14 15:12:21.606",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056701",
        "positionId": "56056701",
        "volume": 8.11,
        "price": 3218.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.42,
        "doubleCheck": true
    },
    {
        "id": "53094153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:21.606",
        "brokerTime": "2025-05-14 15:12:22.210",
        "commission": -56.77,
        "swap": 0,
        "profit": -316.29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056702",
        "positionId": "56056701",
        "volume": 8.11,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -373.06,
        "takeProfit": null,
        "priceIn": 3218.42,
        "doubleCheck": true
    },
    {
        "id": "53094154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22.347",
        "brokerTime": "2025-05-14 15:12:22.347",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056703",
        "positionId": "56056703",
        "volume": 8.11,
        "price": 3218.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "id": "53094156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:22.347",
        "brokerTime": "2025-05-14 15:12:23.931",
        "commission": -56.77,
        "swap": 0,
        "profit": -162.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056706",
        "positionId": "56056703",
        "volume": 8.11,
        "price": 3218.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -218.97,
        "takeProfit": null,
        "priceIn": 3218.61,
        "doubleCheck": true
    },
    {
        "id": "53094158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:24.352",
        "brokerTime": "2025-05-14 15:12:24.352",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056707",
        "positionId": "56056707",
        "volume": 8.11,
        "price": 3218.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "id": "53094159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:24.352",
        "brokerTime": "2025-05-14 15:12:24.691",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056708",
        "positionId": "56056707",
        "volume": 8.11,
        "price": 3218.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3218.65,
        "doubleCheck": true
    },
    {
        "id": "53094160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:25.531",
        "brokerTime": "2025-05-14 15:12:25.531",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056709",
        "positionId": "56056709",
        "volume": 8.11,
        "price": 3218.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53094161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:25.531",
        "brokerTime": "2025-05-14 15:12:25.854",
        "commission": -56.77,
        "swap": 0,
        "profit": -373.06,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056710",
        "positionId": "56056709",
        "volume": 8.11,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -429.83,
        "takeProfit": null,
        "priceIn": 3218.56,
        "doubleCheck": true
    },
    {
        "id": "53094162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26.290",
        "brokerTime": "2025-05-14 15:12:26.290",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056711",
        "positionId": "56056711",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:26.290",
        "brokerTime": "2025-05-14 15:12:26.727",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056713",
        "positionId": "56056711",
        "volume": 8.11,
        "price": 3219.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:27.077",
        "brokerTime": "2025-05-14 15:12:27.077",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056714",
        "positionId": "56056714",
        "volume": 8.11,
        "price": 3219.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "id": "53094167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:27.077",
        "brokerTime": "2025-05-14 15:12:28.207",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056715",
        "positionId": "56056714",
        "volume": 8.11,
        "price": 3219.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.1,
        "doubleCheck": true
    },
    {
        "id": "53094168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:28.566",
        "brokerTime": "2025-05-14 15:12:28.566",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056716",
        "positionId": "56056716",
        "volume": 8.11,
        "price": 3219.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.15,
        "doubleCheck": true
    },
    {
        "id": "53094169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:28.566",
        "brokerTime": "2025-05-14 15:12:29.066",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056717",
        "positionId": "56056716",
        "volume": 8.11,
        "price": 3219.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.15,
        "doubleCheck": true
    },
    {
        "id": "53094170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29.366",
        "brokerTime": "2025-05-14 15:12:29.366",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056718",
        "positionId": "56056718",
        "volume": 8.11,
        "price": 3219.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.12,
        "doubleCheck": true
    },
    {
        "id": "53094171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:29.366",
        "brokerTime": "2025-05-14 15:12:29.957",
        "commission": -56.77,
        "swap": 0,
        "profit": -308.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056719",
        "positionId": "56056718",
        "volume": 8.11,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -364.95,
        "takeProfit": null,
        "priceIn": 3219.12,
        "doubleCheck": true
    },
    {
        "id": "53094172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:30.359",
        "brokerTime": "2025-05-14 15:12:30.359",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056720",
        "positionId": "56056720",
        "volume": 8.11,
        "price": 3219.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "id": "53094173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:30.359",
        "brokerTime": "2025-05-14 15:12:31.167",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056721",
        "positionId": "56056720",
        "volume": 8.11,
        "price": 3219.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "id": "53094174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:31.717",
        "brokerTime": "2025-05-14 15:12:31.717",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056722",
        "positionId": "56056722",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:31.717",
        "brokerTime": "2025-05-14 15:12:32.674",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056723",
        "positionId": "56056722",
        "volume": 8.11,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33.038",
        "brokerTime": "2025-05-14 15:12:33.038",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056724",
        "positionId": "56056724",
        "volume": 8.11,
        "price": 3219.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53094177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33.038",
        "brokerTime": "2025-05-14 15:12:33.529",
        "commission": -56.77,
        "swap": 0,
        "profit": -97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056725",
        "positionId": "56056724",
        "volume": 8.11,
        "price": 3219.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -154.09,
        "takeProfit": null,
        "priceIn": 3219.29,
        "doubleCheck": true
    },
    {
        "id": "53094178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33.829",
        "brokerTime": "2025-05-14 15:12:33.829",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056726",
        "positionId": "56056726",
        "volume": 8.11,
        "price": 3219.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53094179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:33.829",
        "brokerTime": "2025-05-14 15:12:34.324",
        "commission": -56.77,
        "swap": 0,
        "profit": 8.11,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056727",
        "positionId": "56056726",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -48.660000000000004,
        "takeProfit": null,
        "priceIn": 3219.23,
        "doubleCheck": true
    },
    {
        "id": "53094180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:35.176",
        "brokerTime": "2025-05-14 15:12:35.176",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056728",
        "positionId": "56056728",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:35.176",
        "brokerTime": "2025-05-14 15:12:36.291",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056730",
        "positionId": "56056728",
        "volume": 8.11,
        "price": 3219.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:36.583",
        "brokerTime": "2025-05-14 15:12:36.583",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056731",
        "positionId": "56056731",
        "volume": 8.11,
        "price": 3219.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.05,
        "doubleCheck": true
    },
    {
        "id": "53094184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:36.583",
        "brokerTime": "2025-05-14 15:12:37.300",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056732",
        "positionId": "56056731",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.52,
        "takeProfit": null,
        "priceIn": 3219.05,
        "doubleCheck": true
    },
    {
        "id": "53094185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:37.586",
        "brokerTime": "2025-05-14 15:12:37.586",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056733",
        "positionId": "56056733",
        "volume": 8.11,
        "price": 3219.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "id": "53094186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:37.586",
        "brokerTime": "2025-05-14 15:12:38.056",
        "commission": -56.77,
        "swap": 0,
        "profit": -186.53,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056734",
        "positionId": "56056733",
        "volume": 8.11,
        "price": 3219.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -243.3,
        "takeProfit": null,
        "priceIn": 3219.33,
        "doubleCheck": true
    },
    {
        "id": "53094187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38.356",
        "brokerTime": "2025-05-14 15:12:38.356",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056735",
        "positionId": "56056735",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:38.356",
        "brokerTime": "2025-05-14 15:12:38.813",
        "commission": -56.77,
        "swap": 0,
        "profit": -170.31,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056736",
        "positionId": "56056735",
        "volume": 8.11,
        "price": 3219.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -227.08,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:39.873",
        "brokerTime": "2025-05-14 15:12:39.873",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056737",
        "positionId": "56056737",
        "volume": 8.11,
        "price": 3219.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:39.873",
        "brokerTime": "2025-05-14 15:12:40.209",
        "commission": -56.77,
        "swap": 0,
        "profit": -364.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056738",
        "positionId": "56056737",
        "volume": 8.11,
        "price": 3219.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -421.71999999999997,
        "takeProfit": null,
        "priceIn": 3219.34,
        "doubleCheck": true
    },
    {
        "id": "53094191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:40.745",
        "brokerTime": "2025-05-14 15:12:40.745",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056739",
        "positionId": "56056739",
        "volume": 8.11,
        "price": 3219.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53094192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:40.745",
        "brokerTime": "2025-05-14 15:12:41.084",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056740",
        "positionId": "56056739",
        "volume": 8.11,
        "price": 3219.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3219.58,
        "doubleCheck": true
    },
    {
        "id": "53094193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:42.043",
        "brokerTime": "2025-05-14 15:12:42.043",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056741",
        "positionId": "56056741",
        "volume": 8.11,
        "price": 3219.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "id": "53094194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:42.043",
        "brokerTime": "2025-05-14 15:12:42.698",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056742",
        "positionId": "56056741",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3219.53,
        "doubleCheck": true
    },
    {
        "id": "53094195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:43.358",
        "brokerTime": "2025-05-14 15:12:43.358",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056743",
        "positionId": "56056743",
        "volume": 8.11,
        "price": 3219.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.42,
        "doubleCheck": true
    },
    {
        "id": "53094196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:43.358",
        "brokerTime": "2025-05-14 15:12:45.492",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056744",
        "positionId": "56056743",
        "volume": 8.11,
        "price": 3219.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.42,
        "doubleCheck": true
    },
    {
        "id": "53094197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:46.339",
        "brokerTime": "2025-05-14 15:12:46.339",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056745",
        "positionId": "56056745",
        "volume": 8.11,
        "price": 3219.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "id": "53094198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:46.339",
        "brokerTime": "2025-05-14 15:12:47.849",
        "commission": -56.77,
        "swap": 0,
        "profit": -113.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056746",
        "positionId": "56056745",
        "volume": 8.11,
        "price": 3219.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -170.31,
        "takeProfit": null,
        "priceIn": 3219.47,
        "doubleCheck": true
    },
    {
        "id": "53094199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:48.147",
        "brokerTime": "2025-05-14 15:12:48.147",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056747",
        "positionId": "56056747",
        "volume": 8.11,
        "price": 3219.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.43,
        "doubleCheck": true
    },
    {
        "id": "53094200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:48.147",
        "brokerTime": "2025-05-14 15:12:48.554",
        "commission": -56.77,
        "swap": 0,
        "profit": -56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056748",
        "positionId": "56056747",
        "volume": 8.11,
        "price": 3219.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -113.54,
        "takeProfit": null,
        "priceIn": 3219.43,
        "doubleCheck": true
    },
    {
        "id": "53094201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49.083",
        "brokerTime": "2025-05-14 15:12:49.083",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056749",
        "positionId": "56056749",
        "volume": 8.11,
        "price": 3219.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.11,
        "doubleCheck": true
    },
    {
        "id": "53094202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49.083",
        "brokerTime": "2025-05-14 15:12:49.622",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056750",
        "positionId": "56056749",
        "volume": 8.11,
        "price": 3219.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3219.11,
        "doubleCheck": true
    },
    {
        "id": "53094203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49.950",
        "brokerTime": "2025-05-14 15:12:49.950",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056751",
        "positionId": "56056751",
        "volume": 8.11,
        "price": 3219.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53094204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:49.950",
        "brokerTime": "2025-05-14 15:12:50.782",
        "commission": -56.77,
        "swap": 0,
        "profit": -178.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056752",
        "positionId": "56056751",
        "volume": 8.11,
        "price": 3219.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -235.19,
        "takeProfit": null,
        "priceIn": 3219.16,
        "doubleCheck": true
    },
    {
        "id": "53094205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:51.422",
        "brokerTime": "2025-05-14 15:12:51.422",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056753",
        "positionId": "56056753",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "id": "53094207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:51.422",
        "brokerTime": "2025-05-14 15:12:52.063",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056755",
        "positionId": "56056753",
        "volume": 8.11,
        "price": 3219.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3219.22,
        "doubleCheck": true
    },
    {
        "id": "53094209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:52.853",
        "brokerTime": "2025-05-14 15:12:52.853",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056757",
        "positionId": "56056757",
        "volume": 8.11,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53094210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:52.853",
        "brokerTime": "2025-05-14 15:12:53.421",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056758",
        "positionId": "56056757",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53094211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:53.721",
        "brokerTime": "2025-05-14 15:12:53.721",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056759",
        "positionId": "56056759",
        "volume": 8.11,
        "price": 3219.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "id": "53094212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:53.721",
        "brokerTime": "2025-05-14 15:12:54.218",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056760",
        "positionId": "56056759",
        "volume": 8.11,
        "price": 3219.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3219.02,
        "doubleCheck": true
    },
    {
        "id": "53094213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54.449",
        "brokerTime": "2025-05-14 15:12:54.449",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056761",
        "positionId": "56056761",
        "volume": 8.11,
        "price": 3219.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53094214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:54.449",
        "brokerTime": "2025-05-14 15:12:56.393",
        "commission": -56.77,
        "swap": 0,
        "profit": -121.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056762",
        "positionId": "56056761",
        "volume": 8.11,
        "price": 3219.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -178.42000000000002,
        "takeProfit": null,
        "priceIn": 3219.07,
        "doubleCheck": true
    },
    {
        "id": "53094220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:58.662",
        "brokerTime": "2025-05-14 15:12:58.662",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056768",
        "positionId": "56056768",
        "volume": 8.11,
        "price": 3219.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:12:58.662",
        "brokerTime": "2025-05-14 15:12:59.614",
        "commission": -56.77,
        "swap": 0,
        "profit": -81.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056771",
        "positionId": "56056768",
        "volume": 8.11,
        "price": 3219.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.87,
        "takeProfit": null,
        "priceIn": 3219.09,
        "doubleCheck": true
    },
    {
        "id": "53094224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:00.030",
        "brokerTime": "2025-05-14 15:13:00.030",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056772",
        "positionId": "56056772",
        "volume": 8.11,
        "price": 3218.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.79,
        "doubleCheck": true
    },
    {
        "id": "53094225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:00.030",
        "brokerTime": "2025-05-14 15:13:00.862",
        "commission": -56.77,
        "swap": 0,
        "profit": 97.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056773",
        "positionId": "56056772",
        "volume": 8.11,
        "price": 3218.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 40.54999999999999,
        "takeProfit": null,
        "priceIn": 3218.79,
        "doubleCheck": true
    },
    {
        "id": "53094227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02.162",
        "brokerTime": "2025-05-14 15:13:02.162",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056775",
        "positionId": "56056775",
        "volume": 8.11,
        "price": 3218.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.36,
        "doubleCheck": true
    },
    {
        "id": "53094228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02.162",
        "brokerTime": "2025-05-14 15:13:02.529",
        "commission": -56.77,
        "swap": 0,
        "profit": -243.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056776",
        "positionId": "56056775",
        "volume": 8.11,
        "price": 3218.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -300.07,
        "takeProfit": null,
        "priceIn": 3218.36,
        "doubleCheck": true
    },
    {
        "id": "53094229",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02.764",
        "brokerTime": "2025-05-14 15:13:02.764",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056777",
        "positionId": "56056777",
        "volume": 8.11,
        "price": 3218.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53094231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:02.764",
        "brokerTime": "2025-05-14 15:13:03.110",
        "commission": -56.77,
        "swap": 0,
        "profit": 56.77,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056779",
        "positionId": "56056777",
        "volume": 8.11,
        "price": 3218.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3218.44,
        "doubleCheck": true
    },
    {
        "id": "53094233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03.348",
        "brokerTime": "2025-05-14 15:13:03.348",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056781",
        "positionId": "56056781",
        "volume": 8.11,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "id": "53094234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:03.348",
        "brokerTime": "2025-05-14 15:13:03.803",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056783",
        "positionId": "56056781",
        "volume": 8.11,
        "price": 3218.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "id": "53094235",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:04.056",
        "brokerTime": "2025-05-14 15:13:04.056",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056784",
        "positionId": "56056784",
        "volume": 8.11,
        "price": 3218.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "id": "53094238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:04.056",
        "brokerTime": "2025-05-14 15:13:04.830",
        "commission": -56.77,
        "swap": 0,
        "profit": -32.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056787",
        "positionId": "56056784",
        "volume": 8.11,
        "price": 3218.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -89.21000000000001,
        "takeProfit": null,
        "priceIn": 3218.01,
        "doubleCheck": true
    },
    {
        "id": "53094242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:05.215",
        "brokerTime": "2025-05-14 15:13:05.215",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056790",
        "positionId": "56056790",
        "volume": 8.11,
        "price": 3217.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.77,
        "doubleCheck": true
    },
    {
        "id": "53094246",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:05.215",
        "brokerTime": "2025-05-14 15:13:05.610",
        "commission": -56.77,
        "swap": 0,
        "profit": -105.43,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056792",
        "positionId": "56056790",
        "volume": 8.11,
        "price": 3217.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -162.20000000000002,
        "takeProfit": null,
        "priceIn": 3217.77,
        "doubleCheck": true
    },
    {
        "id": "53094248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06.027",
        "brokerTime": "2025-05-14 15:13:06.027",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056795",
        "positionId": "56056795",
        "volume": 8.11,
        "price": 3217.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.81,
        "doubleCheck": true
    },
    {
        "id": "53094251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06.027",
        "brokerTime": "2025-05-14 15:13:06.532",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056796",
        "positionId": "56056795",
        "volume": 8.11,
        "price": 3218,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3217.81,
        "doubleCheck": true
    },
    {
        "id": "53094253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06.932",
        "brokerTime": "2025-05-14 15:13:06.932",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056798",
        "positionId": "56056798",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "id": "53094254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:06.932",
        "brokerTime": "2025-05-14 15:13:07.283",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056799",
        "positionId": "56056798",
        "volume": 8.11,
        "price": 3218,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "id": "53094255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:07.517",
        "brokerTime": "2025-05-14 15:13:07.517",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056800",
        "positionId": "56056800",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "id": "53094256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:07.517",
        "brokerTime": "2025-05-14 15:13:07.793",
        "commission": -56.77,
        "swap": 0,
        "profit": -218.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056801",
        "positionId": "56056800",
        "volume": 8.11,
        "price": 3218.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.74,
        "takeProfit": null,
        "priceIn": 3217.84,
        "doubleCheck": true
    },
    {
        "id": "53094257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08.245",
        "brokerTime": "2025-05-14 15:13:08.245",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056802",
        "positionId": "56056802",
        "volume": 8.11,
        "price": 3217.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.87,
        "doubleCheck": true
    },
    {
        "id": "53094258",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:08.245",
        "brokerTime": "2025-05-14 15:13:08.856",
        "commission": -56.77,
        "swap": 0,
        "profit": -129.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056803",
        "positionId": "56056802",
        "volume": 8.11,
        "price": 3218.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -186.53,
        "takeProfit": null,
        "priceIn": 3217.87,
        "doubleCheck": true
    },
    {
        "id": "53094259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:09.460",
        "brokerTime": "2025-05-14 15:13:09.460",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056804",
        "positionId": "56056804",
        "volume": 8.11,
        "price": 3217.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.66,
        "doubleCheck": true
    },
    {
        "id": "53094260",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:09.648",
        "brokerTime": "2025-05-14 15:13:09.648",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56056805",
        "positionId": "56056805",
        "volume": 0.12,
        "price": 2869.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2969.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2869.79,
        "doubleCheck": true
    },
    {
        "id": "53094261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:09.460",
        "brokerTime": "2025-05-14 15:13:10.436",
        "commission": -56.77,
        "swap": 0,
        "profit": -145.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056806",
        "positionId": "56056804",
        "volume": 8.11,
        "price": 3217.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -202.75,
        "takeProfit": null,
        "priceIn": 3217.66,
        "doubleCheck": true
    },
    {
        "id": "53094263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:10.858",
        "brokerTime": "2025-05-14 15:13:10.858",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056808",
        "positionId": "56056808",
        "volume": 8.11,
        "price": 3217.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.51,
        "doubleCheck": true
    },
    {
        "id": "53094266",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:10.858",
        "brokerTime": "2025-05-14 15:13:11.708",
        "commission": -56.77,
        "swap": 0,
        "profit": 210.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056811",
        "positionId": "56056808",
        "volume": 8.11,
        "price": 3217.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 154.09,
        "takeProfit": null,
        "priceIn": 3217.51,
        "doubleCheck": true
    },
    {
        "id": "53094268",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:11.988",
        "brokerTime": "2025-05-14 15:13:11.988",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056813",
        "positionId": "56056813",
        "volume": 8.11,
        "price": 3217.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "id": "53094270",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:11.988",
        "brokerTime": "2025-05-14 15:13:12.342",
        "commission": -56.77,
        "swap": 0,
        "profit": -154.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056814",
        "positionId": "56056813",
        "volume": 8.11,
        "price": 3217.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -210.86,
        "takeProfit": null,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "id": "53094272",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:12.861",
        "brokerTime": "2025-05-14 15:13:12.861",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056816",
        "positionId": "56056816",
        "volume": 8.11,
        "price": 3217.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "id": "53094276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:12.861",
        "brokerTime": "2025-05-14 15:13:13.416",
        "commission": -56.77,
        "swap": 0,
        "profit": 348.73,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056820",
        "positionId": "56056816",
        "volume": 8.11,
        "price": 3216.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 291.96000000000004,
        "takeProfit": null,
        "priceIn": 3217.02,
        "doubleCheck": true
    },
    {
        "id": "53094285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:13.858",
        "brokerTime": "2025-05-14 15:13:13.858",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056823",
        "positionId": "56056823",
        "volume": 8.11,
        "price": 3215.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3215.86,
        "doubleCheck": true
    },
    {
        "id": "53094359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:13.858",
        "brokerTime": "2025-05-14 15:13:14.160",
        "commission": -56.77,
        "swap": 0,
        "profit": -72.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056895",
        "positionId": "56056823",
        "volume": 8.11,
        "price": 3215.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.76,
        "takeProfit": null,
        "priceIn": 3215.86,
        "doubleCheck": true
    },
    {
        "id": "53094380",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:14.574",
        "brokerTime": "2025-05-14 15:13:14.574",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056904",
        "positionId": "56056904",
        "volume": 8.11,
        "price": 3215.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3215.58,
        "doubleCheck": true
    },
    {
        "id": "53094384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:14.574",
        "brokerTime": "2025-05-14 15:13:14.889",
        "commission": -56.77,
        "swap": 0,
        "profit": -202.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056907",
        "positionId": "56056904",
        "volume": 8.11,
        "price": 3215.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.52,
        "takeProfit": null,
        "priceIn": 3215.58,
        "doubleCheck": true
    },
    {
        "id": "53094387",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15.378",
        "brokerTime": "2025-05-14 15:13:15.378",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056908",
        "positionId": "56056908",
        "volume": 8.11,
        "price": 3215.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3215.73,
        "doubleCheck": true
    },
    {
        "id": "53094388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:15.378",
        "brokerTime": "2025-05-14 15:13:15.971",
        "commission": -56.77,
        "swap": 0,
        "profit": -137.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56056909",
        "positionId": "56056908",
        "volume": 8.11,
        "price": 3215.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -194.64000000000001,
        "takeProfit": null,
        "priceIn": 3215.73,
        "doubleCheck": true
    },
    {
        "id": "53094601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:16.311",
        "brokerTime": "2025-05-14 15:13:16.311",
        "commission": -56.77,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057124",
        "positionId": "56057124",
        "volume": 8.11,
        "price": 3215.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.77,
        "takeProfit": null,
        "priceIn": 3215.55,
        "doubleCheck": true
    },
    {
        "id": "53094653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:16.311",
        "brokerTime": "2025-05-14 15:13:17.296",
        "commission": -56.77,
        "swap": 0,
        "profit": 308.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057150",
        "positionId": "56057124",
        "volume": 8.11,
        "price": 3215.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 251.41,
        "takeProfit": null,
        "priceIn": 3215.55,
        "doubleCheck": true
    },
    {
        "id": "53094654",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:17.381",
        "brokerTime": "2025-05-14 15:13:17.381",
        "commission": -10.78,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057151",
        "positionId": "56057151",
        "volume": 1.54,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3315.18,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -10.78,
        "priceIn": 3215.18,
        "doubleCheck": true
    },
    {
        "id": "53094669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18.175",
        "brokerTime": "2025-05-14 15:13:18.175",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057173",
        "positionId": "56057173",
        "volume": 9.96,
        "price": 3215.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.36,
        "doubleCheck": true
    },
    {
        "id": "53094709",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18.175",
        "brokerTime": "2025-05-14 15:13:18.638",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057194",
        "positionId": "56057173",
        "volume": 9.96,
        "price": 3215.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3215.36,
        "doubleCheck": true
    },
    {
        "id": "53094741",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18.952",
        "brokerTime": "2025-05-14 15:13:18.952",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057209",
        "positionId": "56057209",
        "volume": 9.96,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53094762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:18.952",
        "brokerTime": "2025-05-14 15:13:19.254",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057233",
        "positionId": "56057209",
        "volume": 9.96,
        "price": 3215.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.2,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53094835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20.021",
        "brokerTime": "2025-05-14 15:13:20.021",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057277",
        "positionId": "56057277",
        "volume": 9.96,
        "price": 3215.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.06,
        "doubleCheck": true
    },
    {
        "id": "53094875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20.021",
        "brokerTime": "2025-05-14 15:13:20.450",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057297",
        "positionId": "56057277",
        "volume": 9.96,
        "price": 3215.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3215.06,
        "doubleCheck": true
    },
    {
        "id": "53094907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20.686",
        "brokerTime": "2025-05-14 15:13:20.686",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057310",
        "positionId": "56057310",
        "volume": 9.96,
        "price": 3215.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "id": "53094956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:20.686",
        "brokerTime": "2025-05-14 15:13:21.152",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057342",
        "positionId": "56057310",
        "volume": 9.96,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "id": "53094982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21.287",
        "brokerTime": "2025-05-14 15:13:21.287",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057355",
        "positionId": "56057355",
        "volume": 9.96,
        "price": 3215.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.07,
        "doubleCheck": true
    },
    {
        "id": "53095021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:21.287",
        "brokerTime": "2025-05-14 15:13:21.782",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057377",
        "positionId": "56057355",
        "volume": 9.96,
        "price": 3215.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -557.76,
        "takeProfit": null,
        "priceIn": 3215.07,
        "doubleCheck": true
    },
    {
        "id": "53095050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:22.046",
        "brokerTime": "2025-05-14 15:13:22.046",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057409",
        "positionId": "56057409",
        "volume": 9.96,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53095164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:22.046",
        "brokerTime": "2025-05-14 15:13:23.039",
        "commission": -69.72,
        "swap": 0,
        "profit": 9.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057469",
        "positionId": "56057409",
        "volume": 9.96,
        "price": 3215.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.76,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53095172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23.281",
        "brokerTime": "2025-05-14 15:13:23.281",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057479",
        "positionId": "56057479",
        "volume": 9.96,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53095227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23.281",
        "brokerTime": "2025-05-14 15:13:23.782",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057509",
        "positionId": "56057479",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53095248",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23.995",
        "brokerTime": "2025-05-14 15:13:23.995",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057526",
        "positionId": "56057526",
        "volume": 9.96,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53095292",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:23.995",
        "brokerTime": "2025-05-14 15:13:24.449",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057551",
        "positionId": "56057526",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53095319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:24.657",
        "brokerTime": "2025-05-14 15:13:24.657",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057567",
        "positionId": "56057567",
        "volume": 9.96,
        "price": 3215,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215,
        "doubleCheck": true
    },
    {
        "id": "53095366",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:24.657",
        "brokerTime": "2025-05-14 15:13:24.992",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057590",
        "positionId": "56057567",
        "volume": 9.96,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3215,
        "doubleCheck": true
    },
    {
        "id": "53095400",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25.371",
        "brokerTime": "2025-05-14 15:13:25.371",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057612",
        "positionId": "56057612",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53095481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:25.371",
        "brokerTime": "2025-05-14 15:13:26.012",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057680",
        "positionId": "56057612",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53095524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26.273",
        "brokerTime": "2025-05-14 15:13:26.273",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057697",
        "positionId": "56057697",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "id": "53095551",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26.273",
        "brokerTime": "2025-05-14 15:13:26.650",
        "commission": -69.72,
        "swap": 0,
        "profit": 59.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057715",
        "positionId": "56057697",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -9.96,
        "takeProfit": null,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "id": "53095602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26.909",
        "brokerTime": "2025-05-14 15:13:26.909",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057740",
        "positionId": "56057740",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53095641",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:26.909",
        "brokerTime": "2025-05-14 15:13:27.254",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057778",
        "positionId": "56057740",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53095672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27.395",
        "brokerTime": "2025-05-14 15:13:27.395",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057785",
        "positionId": "56057785",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53095722",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27.395",
        "brokerTime": "2025-05-14 15:13:27.799",
        "commission": -69.72,
        "swap": 0,
        "profit": -318.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057820",
        "positionId": "56057785",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -388.44000000000005,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53095734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27.948",
        "brokerTime": "2025-05-14 15:13:27.948",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057827",
        "positionId": "56057827",
        "volume": 9.96,
        "price": 3214.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.26,
        "doubleCheck": true
    },
    {
        "id": "53095795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:27.948",
        "brokerTime": "2025-05-14 15:13:28.432",
        "commission": -69.72,
        "swap": 0,
        "profit": 378.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057872",
        "positionId": "56057827",
        "volume": 9.96,
        "price": 3213.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 308.76,
        "takeProfit": null,
        "priceIn": 3214.26,
        "doubleCheck": true
    },
    {
        "id": "53095920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:28.909",
        "brokerTime": "2025-05-14 15:13:28.909",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56057934",
        "positionId": "56057934",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53096020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:28.909",
        "brokerTime": "2025-05-14 15:13:29.674",
        "commission": -69.72,
        "swap": 0,
        "profit": -39.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058000",
        "positionId": "56057934",
        "volume": 9.96,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.56,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53096086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:29.931",
        "brokerTime": "2025-05-14 15:13:29.931",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058059",
        "positionId": "56058059",
        "volume": 9.96,
        "price": 3213.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.22,
        "doubleCheck": true
    },
    {
        "id": "53096176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:29.931",
        "brokerTime": "2025-05-14 15:13:30.303",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058084",
        "positionId": "56058059",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3213.22,
        "doubleCheck": true
    },
    {
        "id": "53096192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:30.529",
        "brokerTime": "2025-05-14 15:13:30.529",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058097",
        "positionId": "56058097",
        "volume": 9.96,
        "price": 3213.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "id": "53096256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:30.529",
        "brokerTime": "2025-05-14 15:13:30.894",
        "commission": -69.72,
        "swap": 0,
        "profit": -398.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058161",
        "positionId": "56058097",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -468.12,
        "takeProfit": null,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "id": "53096352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31.138",
        "brokerTime": "2025-05-14 15:13:31.138",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058226",
        "positionId": "56058226",
        "volume": 9.96,
        "price": 3213.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.51,
        "doubleCheck": true
    },
    {
        "id": "53096459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31.138",
        "brokerTime": "2025-05-14 15:13:31.518",
        "commission": -69.72,
        "swap": 0,
        "profit": -537.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058254",
        "positionId": "56058226",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -607.5600000000001,
        "takeProfit": null,
        "priceIn": 3213.51,
        "doubleCheck": true
    },
    {
        "id": "53096541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31.860",
        "brokerTime": "2025-05-14 15:13:31.860",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058311",
        "positionId": "56058311",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53096669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:31.860",
        "brokerTime": "2025-05-14 15:13:32.333",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058381",
        "positionId": "56058311",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -448.20000000000005,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53096734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:32.580",
        "brokerTime": "2025-05-14 15:13:32.580",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058418",
        "positionId": "56058418",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53096856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:32.580",
        "brokerTime": "2025-05-14 15:13:32.986",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058504",
        "positionId": "56058418",
        "volume": 9.96,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -169.32,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53096971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33.428",
        "brokerTime": "2025-05-14 15:13:33.428",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058551",
        "positionId": "56058551",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53097093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:33.428",
        "brokerTime": "2025-05-14 15:13:33.813",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058634",
        "positionId": "56058551",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.4,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53097157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:34.121",
        "brokerTime": "2025-05-14 15:13:34.121",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058688",
        "positionId": "56058688",
        "volume": 9.96,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53097354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:34.121",
        "brokerTime": "2025-05-14 15:13:34.960",
        "commission": -69.72,
        "swap": 0,
        "profit": -438.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058762",
        "positionId": "56058688",
        "volume": 9.96,
        "price": 3214.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -507.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53097385",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:08:37.225",
        "brokerTime": "2025-05-14 15:13:35.198",
        "commission": -0.98,
        "swap": 0,
        "profit": 85.85,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56058788",
        "positionId": "56054488",
        "volume": 0.14,
        "price": 2867.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.01,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 84.86999999999999,
        "priceIn": 2872.81,
        "doubleCheck": false
    },
    {
        "id": "53097386",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:55.919",
        "brokerTime": "2025-05-14 15:13:35.301",
        "commission": -0.84,
        "swap": 0,
        "profit": 60,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56058791",
        "positionId": "56054281",
        "volume": 0.12,
        "price": 2867.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.02,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 59.16,
        "priceIn": 2871.8,
        "doubleCheck": false
    },
    {
        "id": "53097413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:05:59.244",
        "brokerTime": "2025-05-14 15:13:35.391",
        "commission": -0.7,
        "swap": 0,
        "profit": 34.64,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56058793",
        "positionId": "56054159",
        "volume": 0.1,
        "price": 2867.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2773.02,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 33.94,
        "priceIn": 2870.69,
        "doubleCheck": false
    },
    {
        "id": "53097428",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:35.645",
        "brokerTime": "2025-05-14 15:13:35.645",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058815",
        "positionId": "56058815",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53097486",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:35.645",
        "brokerTime": "2025-05-14 15:13:36.006",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058855",
        "positionId": "56058815",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53097559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36.327",
        "brokerTime": "2025-05-14 15:13:36.327",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058883",
        "positionId": "56058883",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53097646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:36.327",
        "brokerTime": "2025-05-14 15:13:36.715",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56058960",
        "positionId": "56058883",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -318.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53097750",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37.046",
        "brokerTime": "2025-05-14 15:13:37.046",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059002",
        "positionId": "56059002",
        "volume": 9.96,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.48,
        "doubleCheck": true
    },
    {
        "id": "53097793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37.046",
        "brokerTime": "2025-05-14 15:13:37.376",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059023",
        "positionId": "56059002",
        "volume": 9.96,
        "price": 3214.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.48,
        "doubleCheck": true
    },
    {
        "id": "53097833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37.608",
        "brokerTime": "2025-05-14 15:13:37.608",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059089",
        "positionId": "56059089",
        "volume": 9.96,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.5,
        "doubleCheck": true
    },
    {
        "id": "53097997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:37.608",
        "brokerTime": "2025-05-14 15:13:38.103",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059167",
        "positionId": "56059089",
        "volume": 9.96,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -328.67999999999995,
        "takeProfit": null,
        "priceIn": 3214.5,
        "doubleCheck": true
    },
    {
        "id": "53098086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38.358",
        "brokerTime": "2025-05-14 15:13:38.358",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059201",
        "positionId": "56059201",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53098199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38.358",
        "brokerTime": "2025-05-14 15:13:38.770",
        "commission": -69.72,
        "swap": 0,
        "profit": -268.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059275",
        "positionId": "56059201",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -338.64,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53098303",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38.989",
        "brokerTime": "2025-05-14 15:13:38.989",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059327",
        "positionId": "56059327",
        "volume": 9.96,
        "price": 3214.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.54,
        "doubleCheck": true
    },
    {
        "id": "53098459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:38.989",
        "brokerTime": "2025-05-14 15:13:39.539",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059421",
        "positionId": "56059327",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3214.54,
        "doubleCheck": true
    },
    {
        "id": "53098583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:39.799",
        "brokerTime": "2025-05-14 15:13:39.799",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059485",
        "positionId": "56059485",
        "volume": 9.96,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "id": "53098771",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:39.799",
        "brokerTime": "2025-05-14 15:13:40.265",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059594",
        "positionId": "56059485",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.48,
        "takeProfit": null,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "id": "53098843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:40.559",
        "brokerTime": "2025-05-14 15:13:40.559",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059633",
        "positionId": "56059633",
        "volume": 9.96,
        "price": 3214.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.34,
        "doubleCheck": true
    },
    {
        "id": "53099060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:40.559",
        "brokerTime": "2025-05-14 15:13:41.008",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059759",
        "positionId": "56059633",
        "volume": 9.96,
        "price": 3214.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3214.34,
        "doubleCheck": true
    },
    {
        "id": "53099110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41.283",
        "brokerTime": "2025-05-14 15:13:41.283",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059802",
        "positionId": "56059802",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53099239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:41.283",
        "brokerTime": "2025-05-14 15:13:41.653",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059889",
        "positionId": "56059802",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119.52,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53099384",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.035",
        "brokerTime": "2025-05-14 15:13:42.035",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56059971",
        "positionId": "56059971",
        "volume": 9.96,
        "price": 3214.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "id": "53099481",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.206",
        "brokerTime": "2025-05-14 15:13:42.206",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56059993",
        "positionId": "56059993",
        "volume": 0.1,
        "price": 2867.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2867.11,
        "doubleCheck": true
    },
    {
        "id": "53099535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.035",
        "brokerTime": "2025-05-14 15:13:42.413",
        "commission": -69.72,
        "swap": 0,
        "profit": -617.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060046",
        "positionId": "56059971",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -687.24,
        "takeProfit": null,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "id": "53099633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.737",
        "brokerTime": "2025-05-14 15:13:42.737",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060092",
        "positionId": "56060092",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53099811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.737",
        "brokerTime": "2025-05-14 15:13:43.130",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060199",
        "positionId": "56060092",
        "volume": 9.96,
        "price": 3214.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.2,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53100062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:43.774",
        "brokerTime": "2025-05-14 15:13:43.774",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060330",
        "positionId": "56060330",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53100265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:43.774",
        "brokerTime": "2025-05-14 15:13:44.258",
        "commission": -69.72,
        "swap": 0,
        "profit": -19.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060454",
        "positionId": "56060330",
        "volume": 9.96,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -89.64,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53100285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44.498",
        "brokerTime": "2025-05-14 15:13:44.498",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060481",
        "positionId": "56060481",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53100451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:44.498",
        "brokerTime": "2025-05-14 15:13:44.878",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060603",
        "positionId": "56060481",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53100662",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:45.340",
        "brokerTime": "2025-05-14 15:13:45.340",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060711",
        "positionId": "56060711",
        "volume": 9.96,
        "price": 3214.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.11,
        "doubleCheck": true
    },
    {
        "id": "53100790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:45.340",
        "brokerTime": "2025-05-14 15:13:45.687",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060774",
        "positionId": "56060711",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -268.91999999999996,
        "takeProfit": null,
        "priceIn": 3214.11,
        "doubleCheck": true
    },
    {
        "id": "53100992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:46.100",
        "brokerTime": "2025-05-14 15:13:46.100",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56060915",
        "positionId": "56060915",
        "volume": 9.96,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "id": "53101305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:46.100",
        "brokerTime": "2025-05-14 15:13:46.895",
        "commission": -69.72,
        "swap": 0,
        "profit": -278.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061096",
        "positionId": "56060915",
        "volume": 9.96,
        "price": 3214.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -348.6,
        "takeProfit": null,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "id": "53101490",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:47.236",
        "brokerTime": "2025-05-14 15:13:47.236",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061219",
        "positionId": "56061219",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "id": "53101740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:47.236",
        "brokerTime": "2025-05-14 15:13:47.827",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061291",
        "positionId": "56061219",
        "volume": 9.96,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -318.72,
        "takeProfit": null,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "id": "53101804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:48.142",
        "brokerTime": "2025-05-14 15:13:48.142",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061347",
        "positionId": "56061347",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53102064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:48.142",
        "brokerTime": "2025-05-14 15:13:48.689",
        "commission": -69.72,
        "swap": 0,
        "profit": -597.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061480",
        "positionId": "56061347",
        "volume": 9.96,
        "price": 3215.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -667.32,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53102335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:49.210",
        "brokerTime": "2025-05-14 15:13:49.210",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061634",
        "positionId": "56061634",
        "volume": 9.96,
        "price": 3215.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.04,
        "doubleCheck": true
    },
    {
        "id": "53102663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:49.210",
        "brokerTime": "2025-05-14 15:13:50.155",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061915",
        "positionId": "56061634",
        "volume": 9.96,
        "price": 3215.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3215.04,
        "doubleCheck": true
    },
    {
        "id": "53102866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:50.532",
        "brokerTime": "2025-05-14 15:13:50.532",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56061974",
        "positionId": "56061974",
        "volume": 9.96,
        "price": 3215.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3215.01,
        "doubleCheck": true
    },
    {
        "id": "53103122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:50.532",
        "brokerTime": "2025-05-14 15:13:50.964",
        "commission": -69.72,
        "swap": 0,
        "profit": 9.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062150",
        "positionId": "56061974",
        "volume": 9.96,
        "price": 3215,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -59.76,
        "takeProfit": null,
        "priceIn": 3215.01,
        "doubleCheck": true
    },
    {
        "id": "53103332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51.369",
        "brokerTime": "2025-05-14 15:13:51.369",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062230",
        "positionId": "56062230",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53103656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:51.369",
        "brokerTime": "2025-05-14 15:13:51.840",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062405",
        "positionId": "56062230",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.48,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53103781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52.112",
        "brokerTime": "2025-05-14 15:13:52.112",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062503",
        "positionId": "56062503",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53104003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52.112",
        "brokerTime": "2025-05-14 15:13:52.586",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062608",
        "positionId": "56062503",
        "volume": 9.96,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53104144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52.824",
        "brokerTime": "2025-05-14 15:13:52.824",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062687",
        "positionId": "56062687",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.36,
        "doubleCheck": true
    },
    {
        "id": "53104403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:52.824",
        "brokerTime": "2025-05-14 15:13:53.150",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062836",
        "positionId": "56062687",
        "volume": 9.96,
        "price": 3214.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3214.36,
        "doubleCheck": true
    },
    {
        "id": "53104589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:53.699",
        "brokerTime": "2025-05-14 15:13:53.699",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56062941",
        "positionId": "56062941",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53105074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:53.699",
        "brokerTime": "2025-05-14 15:13:54.447",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063178",
        "positionId": "56062941",
        "volume": 9.96,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53105253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:54.774",
        "brokerTime": "2025-05-14 15:13:54.774",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063313",
        "positionId": "56063313",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53105598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:54.774",
        "brokerTime": "2025-05-14 15:13:55.117",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063472",
        "positionId": "56063313",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53105743",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55.419",
        "brokerTime": "2025-05-14 15:13:55.419",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063530",
        "positionId": "56063530",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53105823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:55.419",
        "brokerTime": "2025-05-14 15:13:55.735",
        "commission": -69.72,
        "swap": 0,
        "profit": 209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063622",
        "positionId": "56063530",
        "volume": 9.96,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 139.44,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53106095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56.105",
        "brokerTime": "2025-05-14 15:13:56.105",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063808",
        "positionId": "56063808",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.27,
        "doubleCheck": true
    },
    {
        "id": "53106397",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56.105",
        "brokerTime": "2025-05-14 15:13:56.564",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56063965",
        "positionId": "56063808",
        "volume": 9.96,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3214.27,
        "doubleCheck": true
    },
    {
        "id": "53106639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56.919",
        "brokerTime": "2025-05-14 15:13:56.919",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064089",
        "positionId": "56064089",
        "volume": 9.96,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "id": "53106845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:56.919",
        "brokerTime": "2025-05-14 15:13:57.192",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064173",
        "positionId": "56064089",
        "volume": 9.96,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "id": "53107041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:57.589",
        "brokerTime": "2025-05-14 15:13:57.589",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064311",
        "positionId": "56064311",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53107327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:57.589",
        "brokerTime": "2025-05-14 15:13:57.876",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064454",
        "positionId": "56064311",
        "volume": 9.96,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53107424",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58.045",
        "brokerTime": "2025-05-14 15:13:58.045",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064549",
        "positionId": "56064549",
        "volume": 9.96,
        "price": 3214.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.4,
        "doubleCheck": true
    },
    {
        "id": "53107855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:58.045",
        "brokerTime": "2025-05-14 15:13:58.634",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064732",
        "positionId": "56064549",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3214.4,
        "doubleCheck": true
    },
    {
        "id": "53108184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59.159",
        "brokerTime": "2025-05-14 15:13:59.159",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56064935",
        "positionId": "56064935",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "id": "53108389",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59.159",
        "brokerTime": "2025-05-14 15:13:59.460",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065036",
        "positionId": "56064935",
        "volume": 9.96,
        "price": 3214.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -328.67999999999995,
        "takeProfit": null,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "id": "53108469",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59.667",
        "brokerTime": "2025-05-14 15:13:59.667",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065118",
        "positionId": "56065118",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53108699",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:59.667",
        "brokerTime": "2025-05-14 15:13:59.938",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065217",
        "positionId": "56065118",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.48,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53108800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00.187",
        "brokerTime": "2025-05-14 15:14:00.187",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065306",
        "positionId": "56065306",
        "volume": 9.96,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53108919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:14:00.330",
        "brokerTime": "2025-05-14 15:14:00.330",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56065325",
        "positionId": "56065325",
        "volume": 0.14,
        "price": 2867.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2967.15,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2867.15,
        "doubleCheck": true
    },
    {
        "id": "53109121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:00.187",
        "brokerTime": "2025-05-14 15:14:00.736",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065473",
        "positionId": "56065306",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53109408",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:01.059",
        "brokerTime": "2025-05-14 15:14:01.059",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065598",
        "positionId": "56065598",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53109730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:01.059",
        "brokerTime": "2025-05-14 15:14:02.051",
        "commission": -69.72,
        "swap": 0,
        "profit": 69.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065852",
        "positionId": "56065598",
        "volume": 9.96,
        "price": 3214.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3214.43,
        "doubleCheck": true
    },
    {
        "id": "53109923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02.385",
        "brokerTime": "2025-05-14 15:14:02.385",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56065892",
        "positionId": "56065892",
        "volume": 9.96,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53110131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02.385",
        "brokerTime": "2025-05-14 15:14:02.748",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066030",
        "positionId": "56065892",
        "volume": 9.96,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53110225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02.955",
        "brokerTime": "2025-05-14 15:14:02.955",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066113",
        "positionId": "56066113",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53110444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:02.955",
        "brokerTime": "2025-05-14 15:14:03.323",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066201",
        "positionId": "56066113",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53110619",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:03.613",
        "brokerTime": "2025-05-14 15:14:03.613",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066308",
        "positionId": "56066308",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53111247",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:03.613",
        "brokerTime": "2025-05-14 15:14:04.356",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066647",
        "positionId": "56066308",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53111403",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:04.651",
        "brokerTime": "2025-05-14 15:14:04.651",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066727",
        "positionId": "56066727",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53111493",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:04.651",
        "brokerTime": "2025-05-14 15:14:04.976",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066825",
        "positionId": "56066727",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -268.91999999999996,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53111630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05.350",
        "brokerTime": "2025-05-14 15:14:05.350",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066858",
        "positionId": "56066858",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53111781",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05.350",
        "brokerTime": "2025-05-14 15:14:05.864",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066937",
        "positionId": "56066858",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -219.12,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53111798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05.978",
        "brokerTime": "2025-05-14 15:14:05.978",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066956",
        "positionId": "56066956",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "id": "53111859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:05.978",
        "brokerTime": "2025-05-14 15:14:06.432",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56066984",
        "positionId": "56066956",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.48,
        "takeProfit": null,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "id": "53111924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:06.688",
        "brokerTime": "2025-05-14 15:14:06.688",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067045",
        "positionId": "56067045",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53112136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:06.688",
        "brokerTime": "2025-05-14 15:14:07.470",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067131",
        "positionId": "56067045",
        "volume": 9.96,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.2,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53112250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:07.831",
        "brokerTime": "2025-05-14 15:14:07.831",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067247",
        "positionId": "56067247",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53112444",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:07.831",
        "brokerTime": "2025-05-14 15:14:08.254",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067347",
        "positionId": "56067247",
        "volume": 9.96,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53112720",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:08.714",
        "brokerTime": "2025-05-14 15:14:08.714",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067479",
        "positionId": "56067479",
        "volume": 9.96,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "id": "53113049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:08.714",
        "brokerTime": "2025-05-14 15:14:09.459",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067675",
        "positionId": "56067479",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "id": "53113417",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:10.270",
        "brokerTime": "2025-05-14 15:14:10.270",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067845",
        "positionId": "56067845",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53113437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:10.270",
        "brokerTime": "2025-05-14 15:14:10.638",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067868",
        "positionId": "56067845",
        "volume": 9.96,
        "price": 3213.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.4,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53113475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:11.086",
        "brokerTime": "2025-05-14 15:14:11.086",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067879",
        "positionId": "56067879",
        "volume": 9.96,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.15,
        "doubleCheck": true
    },
    {
        "id": "53113479",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:11.086",
        "brokerTime": "2025-05-14 15:14:11.457",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067884",
        "positionId": "56067879",
        "volume": 9.96,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.15,
        "doubleCheck": true
    },
    {
        "id": "53113495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12.127",
        "brokerTime": "2025-05-14 15:14:12.127",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067894",
        "positionId": "56067894",
        "volume": 9.96,
        "price": 3213.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "id": "53113500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12.127",
        "brokerTime": "2025-05-14 15:14:12.454",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067896",
        "positionId": "56067894",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "id": "53113503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12.587",
        "brokerTime": "2025-05-14 15:14:12.587",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067899",
        "positionId": "56067899",
        "volume": 9.96,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "id": "53113510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:12.587",
        "brokerTime": "2025-05-14 15:14:13.043",
        "commission": -69.72,
        "swap": 0,
        "profit": 19.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067904",
        "positionId": "56067899",
        "volume": 9.96,
        "price": 3213.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49.8,
        "takeProfit": null,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "id": "53113513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13.348",
        "brokerTime": "2025-05-14 15:14:13.348",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067906",
        "positionId": "56067906",
        "volume": 9.96,
        "price": 3212.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "id": "53113517",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:13.348",
        "brokerTime": "2025-05-14 15:14:13.844",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067910",
        "positionId": "56067906",
        "volume": 9.96,
        "price": 3213.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119.52,
        "takeProfit": null,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "id": "53113522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:14.390",
        "brokerTime": "2025-05-14 15:14:14.390",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067914",
        "positionId": "56067914",
        "volume": 9.96,
        "price": 3212.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.77,
        "doubleCheck": true
    },
    {
        "id": "53113524",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:14.390",
        "brokerTime": "2025-05-14 15:14:14.695",
        "commission": -69.72,
        "swap": 0,
        "profit": -537.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56067916",
        "positionId": "56067914",
        "volume": 9.96,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -607.5600000000001,
        "takeProfit": null,
        "priceIn": 3212.77,
        "doubleCheck": true
    },
    {
        "id": "53113606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:15.196",
        "brokerTime": "2025-05-14 15:14:15.196",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068127",
        "positionId": "56068127",
        "volume": 9.96,
        "price": 3213.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "id": "53113762",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:15.196",
        "brokerTime": "2025-05-14 15:14:15.718",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068133",
        "positionId": "56068127",
        "volume": 9.96,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3213.26,
        "doubleCheck": true
    },
    {
        "id": "53113766",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16.096",
        "brokerTime": "2025-05-14 15:14:16.096",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068137",
        "positionId": "56068137",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53113785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16.096",
        "brokerTime": "2025-05-14 15:14:16.479",
        "commission": -69.72,
        "swap": 0,
        "profit": -408.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068154",
        "positionId": "56068137",
        "volume": 9.96,
        "price": 3213.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -478.08000000000004,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53113788",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16.748",
        "brokerTime": "2025-05-14 15:14:16.748",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068156",
        "positionId": "56068156",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.66,
        "doubleCheck": true
    },
    {
        "id": "53113789",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:16.748",
        "brokerTime": "2025-05-14 15:14:17.175",
        "commission": -69.72,
        "swap": 0,
        "profit": 239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068157",
        "positionId": "56068156",
        "volume": 9.96,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 169.32,
        "takeProfit": null,
        "priceIn": 3213.66,
        "doubleCheck": true
    },
    {
        "id": "53113790",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:17.596",
        "brokerTime": "2025-05-14 15:14:17.596",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068158",
        "positionId": "56068158",
        "volume": 9.96,
        "price": 3213.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "id": "53113791",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:17.596",
        "brokerTime": "2025-05-14 15:14:17.965",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068159",
        "positionId": "56068158",
        "volume": 9.96,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.48,
        "takeProfit": null,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "id": "53113792",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18.174",
        "brokerTime": "2025-05-14 15:14:18.174",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068160",
        "positionId": "56068160",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53113793",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18.174",
        "brokerTime": "2025-05-14 15:14:18.595",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068161",
        "positionId": "56068160",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53113794",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18.721",
        "brokerTime": "2025-05-14 15:14:18.721",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068162",
        "positionId": "56068162",
        "volume": 9.96,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "id": "53113795",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:18.721",
        "brokerTime": "2025-05-14 15:14:19.478",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068163",
        "positionId": "56068162",
        "volume": 9.96,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.04,
        "takeProfit": null,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "id": "53113796",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:19.819",
        "brokerTime": "2025-05-14 15:14:19.819",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068164",
        "positionId": "56068164",
        "volume": 9.96,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "id": "53113797",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:19.819",
        "brokerTime": "2025-05-14 15:14:20.268",
        "commission": -69.72,
        "swap": 0,
        "profit": -388.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068165",
        "positionId": "56068164",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.15999999999997,
        "takeProfit": null,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "id": "53113798",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:20.697",
        "brokerTime": "2025-05-14 15:14:20.697",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068166",
        "positionId": "56068166",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53113800",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:20.697",
        "brokerTime": "2025-05-14 15:14:21.337",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068168",
        "positionId": "56068166",
        "volume": 9.96,
        "price": 3213.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53113802",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:22.239",
        "brokerTime": "2025-05-14 15:14:22.239",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068170",
        "positionId": "56068170",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53113804",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:22.239",
        "brokerTime": "2025-05-14 15:14:22.909",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068172",
        "positionId": "56068170",
        "volume": 9.96,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.04,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53113805",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:23.253",
        "brokerTime": "2025-05-14 15:14:23.253",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068173",
        "positionId": "56068173",
        "volume": 9.96,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "id": "53113806",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:23.253",
        "brokerTime": "2025-05-14 15:14:23.877",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068174",
        "positionId": "56068173",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "id": "53113807",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24.111",
        "brokerTime": "2025-05-14 15:14:24.111",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068175",
        "positionId": "56068175",
        "volume": 9.96,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "id": "53113808",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24.111",
        "brokerTime": "2025-05-14 15:14:24.464",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068176",
        "positionId": "56068175",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3213.48,
        "doubleCheck": true
    },
    {
        "id": "53113809",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24.720",
        "brokerTime": "2025-05-14 15:14:24.720",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068177",
        "positionId": "56068177",
        "volume": 9.96,
        "price": 3213.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.56,
        "doubleCheck": true
    },
    {
        "id": "53113811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:24.720",
        "brokerTime": "2025-05-14 15:14:25.214",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068179",
        "positionId": "56068177",
        "volume": 9.96,
        "price": 3213.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3213.56,
        "doubleCheck": true
    },
    {
        "id": "53113813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25.403",
        "brokerTime": "2025-05-14 15:14:25.403",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068181",
        "positionId": "56068181",
        "volume": 9.96,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53113819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:25.403",
        "brokerTime": "2025-05-14 15:14:26.137",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068186",
        "positionId": "56068181",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53113821",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:26.527",
        "brokerTime": "2025-05-14 15:14:26.527",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068188",
        "positionId": "56068188",
        "volume": 9.96,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.42,
        "doubleCheck": true
    },
    {
        "id": "53113825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:26.527",
        "brokerTime": "2025-05-14 15:14:27.248",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068192",
        "positionId": "56068188",
        "volume": 9.96,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.2,
        "takeProfit": null,
        "priceIn": 3213.42,
        "doubleCheck": true
    },
    {
        "id": "53113827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27.481",
        "brokerTime": "2025-05-14 15:14:27.481",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068194",
        "positionId": "56068194",
        "volume": 9.96,
        "price": 3213.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "id": "53113829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:27.481",
        "brokerTime": "2025-05-14 15:14:27.847",
        "commission": -69.72,
        "swap": 0,
        "profit": -258.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068197",
        "positionId": "56068194",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -328.67999999999995,
        "takeProfit": null,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "id": "53113832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28.132",
        "brokerTime": "2025-05-14 15:14:28.132",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068199",
        "positionId": "56068199",
        "volume": 9.96,
        "price": 3213.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.16,
        "doubleCheck": true
    },
    {
        "id": "53113834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28.132",
        "brokerTime": "2025-05-14 15:14:28.677",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068201",
        "positionId": "56068199",
        "volume": 9.96,
        "price": 3213.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3213.16,
        "doubleCheck": true
    },
    {
        "id": "53113836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28.856",
        "brokerTime": "2025-05-14 15:14:28.856",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068203",
        "positionId": "56068203",
        "volume": 9.96,
        "price": 3213.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "id": "53113840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:28.856",
        "brokerTime": "2025-05-14 15:14:29.611",
        "commission": -69.72,
        "swap": 0,
        "profit": -717.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068207",
        "positionId": "56068203",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -786.84,
        "takeProfit": null,
        "priceIn": 3213.23,
        "doubleCheck": true
    },
    {
        "id": "53113841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:29.921",
        "brokerTime": "2025-05-14 15:14:29.921",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068208",
        "positionId": "56068208",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53113842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:29.921",
        "brokerTime": "2025-05-14 15:14:30.304",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068209",
        "positionId": "56068208",
        "volume": 9.96,
        "price": 3213.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53113843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:30.624",
        "brokerTime": "2025-05-14 15:14:30.624",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068210",
        "positionId": "56068210",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "id": "53113844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:30.624",
        "brokerTime": "2025-05-14 15:14:31.007",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068211",
        "positionId": "56068210",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -398.4,
        "takeProfit": null,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "id": "53113845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31.311",
        "brokerTime": "2025-05-14 15:14:31.311",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068212",
        "positionId": "56068212",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:31.311",
        "brokerTime": "2025-05-14 15:14:31.834",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068214",
        "positionId": "56068212",
        "volume": 9.96,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:32.524",
        "brokerTime": "2025-05-14 15:14:32.524",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068215",
        "positionId": "56068215",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:32.524",
        "brokerTime": "2025-05-14 15:14:32.950",
        "commission": -69.72,
        "swap": 0,
        "profit": -169.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068216",
        "positionId": "56068215",
        "volume": 9.96,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.04,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33.248",
        "brokerTime": "2025-05-14 15:14:33.248",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068217",
        "positionId": "56068217",
        "volume": 9.96,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.99,
        "doubleCheck": true
    },
    {
        "id": "53113851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:33.248",
        "brokerTime": "2025-05-14 15:14:33.576",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068218",
        "positionId": "56068217",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -398.4,
        "takeProfit": null,
        "priceIn": 3213.99,
        "doubleCheck": true
    },
    {
        "id": "53113852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:34.275",
        "brokerTime": "2025-05-14 15:14:34.275",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068219",
        "positionId": "56068219",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53113853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:34.275",
        "brokerTime": "2025-05-14 15:14:34.781",
        "commission": -69.72,
        "swap": 0,
        "profit": -69.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068220",
        "positionId": "56068219",
        "volume": 9.96,
        "price": 3214.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.44,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53113854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:35.335",
        "brokerTime": "2025-05-14 15:14:35.335",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068221",
        "positionId": "56068221",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "id": "53113855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:35.335",
        "brokerTime": "2025-05-14 15:14:35.902",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068222",
        "positionId": "56068221",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "id": "53113856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37.001",
        "brokerTime": "2025-05-14 15:14:37.001",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068223",
        "positionId": "56068223",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53113857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37.001",
        "brokerTime": "2025-05-14 15:14:37.551",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068224",
        "positionId": "56068223",
        "volume": 9.96,
        "price": 3214.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -268.91999999999996,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53113858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37.901",
        "brokerTime": "2025-05-14 15:14:37.901",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068225",
        "positionId": "56068225",
        "volume": 9.96,
        "price": 3213.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "id": "53113859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:37.901",
        "brokerTime": "2025-05-14 15:14:38.470",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068226",
        "positionId": "56068225",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "id": "53113860",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:38.753",
        "brokerTime": "2025-05-14 15:14:38.753",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068227",
        "positionId": "56068227",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53113861",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:38.753",
        "brokerTime": "2025-05-14 15:14:39.158",
        "commission": -69.72,
        "swap": 0,
        "profit": -268.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068228",
        "positionId": "56068227",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -338.64,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53113862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:39.554",
        "brokerTime": "2025-05-14 15:14:39.554",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068229",
        "positionId": "56068229",
        "volume": 9.96,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "id": "53113863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:39.554",
        "brokerTime": "2025-05-14 15:14:40.032",
        "commission": -69.72,
        "swap": 0,
        "profit": -368.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068230",
        "positionId": "56068229",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -438.24,
        "takeProfit": null,
        "priceIn": 3213.95,
        "doubleCheck": true
    },
    {
        "id": "53113864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40.339",
        "brokerTime": "2025-05-14 15:14:40.339",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068231",
        "positionId": "56068231",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53113865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:40.339",
        "brokerTime": "2025-05-14 15:14:40.909",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068232",
        "positionId": "56068231",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53113866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:41.504",
        "brokerTime": "2025-05-14 15:14:41.504",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068233",
        "positionId": "56068233",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "id": "53113867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:41.504",
        "brokerTime": "2025-05-14 15:14:42.101",
        "commission": -69.72,
        "swap": 0,
        "profit": -338.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068234",
        "positionId": "56068233",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -408.36,
        "takeProfit": null,
        "priceIn": 3214.58,
        "doubleCheck": true
    },
    {
        "id": "53113868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42.468",
        "brokerTime": "2025-05-14 15:14:42.468",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068235",
        "positionId": "56068235",
        "volume": 9.96,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "id": "53113869",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:42.468",
        "brokerTime": "2025-05-14 15:14:42.954",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068236",
        "positionId": "56068235",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "id": "53113870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:43.355",
        "brokerTime": "2025-05-14 15:14:43.355",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068237",
        "positionId": "56068237",
        "volume": 9.96,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.9,
        "doubleCheck": true
    },
    {
        "id": "53113871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:43.355",
        "brokerTime": "2025-05-14 15:14:43.819",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068238",
        "positionId": "56068237",
        "volume": 9.96,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -219.12,
        "takeProfit": null,
        "priceIn": 3214.9,
        "doubleCheck": true
    },
    {
        "id": "53113872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:44.077",
        "brokerTime": "2025-05-14 15:14:44.077",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068239",
        "positionId": "56068239",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53113873",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:44.077",
        "brokerTime": "2025-05-14 15:14:44.679",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068240",
        "positionId": "56068239",
        "volume": 9.96,
        "price": 3215.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53113874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:45.502",
        "brokerTime": "2025-05-14 15:14:45.502",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068241",
        "positionId": "56068241",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53113875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:45.502",
        "brokerTime": "2025-05-14 15:14:46.200",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068242",
        "positionId": "56068241",
        "volume": 9.96,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53113876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46.471",
        "brokerTime": "2025-05-14 15:14:46.471",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068243",
        "positionId": "56068243",
        "volume": 9.96,
        "price": 3214.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "id": "53113877",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:46.471",
        "brokerTime": "2025-05-14 15:14:46.895",
        "commission": -69.72,
        "swap": 0,
        "profit": 169.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068244",
        "positionId": "56068243",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 99.6,
        "takeProfit": null,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "id": "53113878",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47.109",
        "brokerTime": "2025-05-14 15:14:47.109",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068245",
        "positionId": "56068245",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53113879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47.109",
        "brokerTime": "2025-05-14 15:14:47.547",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068246",
        "positionId": "56068245",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -448.20000000000005,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53113880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47.803",
        "brokerTime": "2025-05-14 15:14:47.803",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068247",
        "positionId": "56068247",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "id": "53113881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:47.803",
        "brokerTime": "2025-05-14 15:14:48.222",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068248",
        "positionId": "56068247",
        "volume": 9.96,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "id": "53113882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:48.722",
        "brokerTime": "2025-05-14 15:14:48.722",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068249",
        "positionId": "56068249",
        "volume": 9.96,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53113883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:48.722",
        "brokerTime": "2025-05-14 15:14:49.347",
        "commission": -69.72,
        "swap": 0,
        "profit": -468.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068250",
        "positionId": "56068249",
        "volume": 9.96,
        "price": 3214.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -537.84,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53113884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:49.570",
        "brokerTime": "2025-05-14 15:14:49.570",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068251",
        "positionId": "56068251",
        "volume": 9.96,
        "price": 3214.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.59,
        "doubleCheck": true
    },
    {
        "id": "53113885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:49.570",
        "brokerTime": "2025-05-14 15:14:50.019",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068252",
        "positionId": "56068251",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.59,
        "doubleCheck": true
    },
    {
        "id": "53113886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:50.790",
        "brokerTime": "2025-05-14 15:14:50.790",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068253",
        "positionId": "56068253",
        "volume": 9.96,
        "price": 3214.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.79,
        "doubleCheck": true
    },
    {
        "id": "53113887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:50.790",
        "brokerTime": "2025-05-14 15:14:51.255",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068254",
        "positionId": "56068253",
        "volume": 9.96,
        "price": 3214.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -169.32,
        "takeProfit": null,
        "priceIn": 3214.79,
        "doubleCheck": true
    },
    {
        "id": "53113888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51.469",
        "brokerTime": "2025-05-14 15:14:51.469",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068255",
        "positionId": "56068255",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53113889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:51.469",
        "brokerTime": "2025-05-14 15:14:51.809",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068256",
        "positionId": "56068255",
        "volume": 9.96,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.4,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53113890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52.134",
        "brokerTime": "2025-05-14 15:14:52.134",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068257",
        "positionId": "56068257",
        "volume": 9.96,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53113891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52.134",
        "brokerTime": "2025-05-14 15:14:52.538",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068258",
        "positionId": "56068257",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -219.12,
        "takeProfit": null,
        "priceIn": 3214.41,
        "doubleCheck": true
    },
    {
        "id": "53113892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52.827",
        "brokerTime": "2025-05-14 15:14:52.827",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068259",
        "positionId": "56068259",
        "volume": 9.96,
        "price": 3214.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.46,
        "doubleCheck": true
    },
    {
        "id": "53113893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:52.827",
        "brokerTime": "2025-05-14 15:14:53.110",
        "commission": -69.72,
        "swap": 0,
        "profit": -69.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068260",
        "positionId": "56068259",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -139.44,
        "takeProfit": null,
        "priceIn": 3214.46,
        "doubleCheck": true
    },
    {
        "id": "53113894",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53.403",
        "brokerTime": "2025-05-14 15:14:53.403",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068261",
        "positionId": "56068261",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53113895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:53.403",
        "brokerTime": "2025-05-14 15:14:53.923",
        "commission": -69.72,
        "swap": 0,
        "profit": 19.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068262",
        "positionId": "56068261",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -49.8,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53113896",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54.125",
        "brokerTime": "2025-05-14 15:14:54.125",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068263",
        "positionId": "56068263",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54.125",
        "brokerTime": "2025-05-14 15:14:54.497",
        "commission": -69.72,
        "swap": 0,
        "profit": -39.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068264",
        "positionId": "56068263",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -109.56,
        "takeProfit": null,
        "priceIn": 3214.08,
        "doubleCheck": true
    },
    {
        "id": "53113898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54.878",
        "brokerTime": "2025-05-14 15:14:54.878",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068265",
        "positionId": "56068265",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53113899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:54.878",
        "brokerTime": "2025-05-14 15:14:55.264",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068266",
        "positionId": "56068265",
        "volume": 9.96,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3214.07,
        "doubleCheck": true
    },
    {
        "id": "53113900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55.484",
        "brokerTime": "2025-05-14 15:14:55.484",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068267",
        "positionId": "56068267",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.97,
        "doubleCheck": true
    },
    {
        "id": "53113901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:55.484",
        "brokerTime": "2025-05-14 15:14:55.843",
        "commission": -69.72,
        "swap": 0,
        "profit": -99.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068268",
        "positionId": "56068267",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -169.32,
        "takeProfit": null,
        "priceIn": 3213.97,
        "doubleCheck": true
    },
    {
        "id": "53113902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56.068",
        "brokerTime": "2025-05-14 15:14:56.068",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068269",
        "positionId": "56068269",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53113903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56.068",
        "brokerTime": "2025-05-14 15:14:56.609",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068270",
        "positionId": "56068269",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53113904",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56.994",
        "brokerTime": "2025-05-14 15:14:56.994",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068271",
        "positionId": "56068271",
        "volume": 9.96,
        "price": 3213.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.38,
        "doubleCheck": true
    },
    {
        "id": "53113905",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:56.994",
        "brokerTime": "2025-05-14 15:14:57.811",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068272",
        "positionId": "56068271",
        "volume": 9.96,
        "price": 3213.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3213.38,
        "doubleCheck": true
    },
    {
        "id": "53113906",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:58.227",
        "brokerTime": "2025-05-14 15:14:58.227",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068273",
        "positionId": "56068273",
        "volume": 9.96,
        "price": 3213.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "id": "53113907",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:58.227",
        "brokerTime": "2025-05-14 15:14:58.649",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068274",
        "positionId": "56068273",
        "volume": 9.96,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "id": "53113908",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59.055",
        "brokerTime": "2025-05-14 15:14:59.055",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068275",
        "positionId": "56068275",
        "volume": 9.96,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53113909",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59.055",
        "brokerTime": "2025-05-14 15:14:59.508",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068276",
        "positionId": "56068275",
        "volume": 9.96,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53113910",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59.826",
        "brokerTime": "2025-05-14 15:14:59.826",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068277",
        "positionId": "56068277",
        "volume": 9.96,
        "price": 3213.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "id": "53113937",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:15:00.847",
        "brokerTime": "2025-05-14 15:15:00.847",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56068304",
        "positionId": "56068304",
        "volume": 0.17,
        "price": 2865.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2966.07,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 2865.96,
        "doubleCheck": true
    },
    {
        "id": "53113938",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:14:59.826",
        "brokerTime": "2025-05-14 15:15:00.911",
        "commission": -69.72,
        "swap": 0,
        "profit": 219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068305",
        "positionId": "56068277",
        "volume": 9.96,
        "price": 3213.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 149.4,
        "takeProfit": null,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "id": "53113945",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:02.280",
        "brokerTime": "2025-05-14 15:15:02.280",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068312",
        "positionId": "56068312",
        "volume": 9.96,
        "price": 3212.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.99,
        "doubleCheck": true
    },
    {
        "id": "53113947",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:02.280",
        "brokerTime": "2025-05-14 15:15:03.982",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068314",
        "positionId": "56068312",
        "volume": 9.96,
        "price": 3213.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.48,
        "takeProfit": null,
        "priceIn": 3212.99,
        "doubleCheck": true
    },
    {
        "id": "53113948",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:04.291",
        "brokerTime": "2025-05-14 15:15:04.291",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068315",
        "positionId": "56068315",
        "volume": 9.96,
        "price": 3212.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "id": "53113952",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:04.291",
        "brokerTime": "2025-05-14 15:15:05.394",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068319",
        "positionId": "56068315",
        "volume": 9.96,
        "price": 3213.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "id": "53113953",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:05.637",
        "brokerTime": "2025-05-14 15:15:05.637",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068320",
        "positionId": "56068320",
        "volume": 9.96,
        "price": 3212.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.92,
        "doubleCheck": true
    },
    {
        "id": "53113954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:05.637",
        "brokerTime": "2025-05-14 15:15:06.042",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068321",
        "positionId": "56068320",
        "volume": 9.96,
        "price": 3213.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3212.92,
        "doubleCheck": true
    },
    {
        "id": "53113956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:06.767",
        "brokerTime": "2025-05-14 15:15:06.767",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068324",
        "positionId": "56068324",
        "volume": 9.96,
        "price": 3212.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "id": "53113960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:06.767",
        "brokerTime": "2025-05-14 15:15:07.246",
        "commission": -69.72,
        "swap": 0,
        "profit": -766.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068326",
        "positionId": "56068324",
        "volume": 9.96,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -836.64,
        "takeProfit": null,
        "priceIn": 3212.98,
        "doubleCheck": true
    },
    {
        "id": "53113962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:07.898",
        "brokerTime": "2025-05-14 15:15:07.898",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068327",
        "positionId": "56068327",
        "volume": 9.96,
        "price": 3213.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.73,
        "doubleCheck": true
    },
    {
        "id": "53113963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:07.898",
        "brokerTime": "2025-05-14 15:15:08.631",
        "commission": -69.72,
        "swap": 0,
        "profit": -358.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068328",
        "positionId": "56068327",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.28,
        "takeProfit": null,
        "priceIn": 3213.73,
        "doubleCheck": true
    },
    {
        "id": "53113964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:08.946",
        "brokerTime": "2025-05-14 15:15:08.946",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068329",
        "positionId": "56068329",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53113965",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:08.946",
        "brokerTime": "2025-05-14 15:15:09.412",
        "commission": -69.72,
        "swap": 0,
        "profit": -597.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068330",
        "positionId": "56068329",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -667.32,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53113966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:09.738",
        "brokerTime": "2025-05-14 15:15:09.738",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068331",
        "positionId": "56068331",
        "volume": 9.96,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.24,
        "doubleCheck": true
    },
    {
        "id": "53113968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:09.738",
        "brokerTime": "2025-05-14 15:15:10.180",
        "commission": -69.72,
        "swap": 0,
        "profit": 89.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068333",
        "positionId": "56068331",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 19.92,
        "takeProfit": null,
        "priceIn": 3214.24,
        "doubleCheck": true
    },
    {
        "id": "53113969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:10.664",
        "brokerTime": "2025-05-14 15:15:10.664",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068334",
        "positionId": "56068334",
        "volume": 9.96,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53113970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:10.664",
        "brokerTime": "2025-05-14 15:15:11.297",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068335",
        "positionId": "56068334",
        "volume": 9.96,
        "price": 3214.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53113971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11.445",
        "brokerTime": "2025-05-14 15:15:11.445",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068336",
        "positionId": "56068336",
        "volume": 9.96,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53113972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:11.445",
        "brokerTime": "2025-05-14 15:15:11.870",
        "commission": -69.72,
        "swap": 0,
        "profit": -89.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068337",
        "positionId": "56068336",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -159.36,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53113973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12.221",
        "brokerTime": "2025-05-14 15:15:12.221",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068338",
        "positionId": "56068338",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53113975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12.221",
        "brokerTime": "2025-05-14 15:15:12.584",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068340",
        "positionId": "56068338",
        "volume": 9.96,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53113976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12.799",
        "brokerTime": "2025-05-14 15:15:12.799",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068341",
        "positionId": "56068341",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53113977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:12.799",
        "brokerTime": "2025-05-14 15:15:13.187",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068342",
        "positionId": "56068341",
        "volume": 9.96,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -448.20000000000005,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53113978",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13.415",
        "brokerTime": "2025-05-14 15:15:13.415",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068343",
        "positionId": "56068343",
        "volume": 9.96,
        "price": 3214.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "id": "53113979",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:13.415",
        "brokerTime": "2025-05-14 15:15:13.806",
        "commission": -69.72,
        "swap": 0,
        "profit": 49.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068344",
        "positionId": "56068343",
        "volume": 9.96,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -19.92,
        "takeProfit": null,
        "priceIn": 3214.04,
        "doubleCheck": true
    },
    {
        "id": "53113980",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:14.246",
        "brokerTime": "2025-05-14 15:15:14.246",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068345",
        "positionId": "56068345",
        "volume": 9.96,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53113981",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:14.246",
        "brokerTime": "2025-05-14 15:15:14.948",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068346",
        "positionId": "56068345",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53113982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15.160",
        "brokerTime": "2025-05-14 15:15:15.160",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068347",
        "positionId": "56068347",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53113983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15.160",
        "brokerTime": "2025-05-14 15:15:15.402",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068348",
        "positionId": "56068347",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -219.12,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53113984",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15.963",
        "brokerTime": "2025-05-14 15:15:15.963",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068349",
        "positionId": "56068349",
        "volume": 9.96,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.7,
        "doubleCheck": true
    },
    {
        "id": "53113985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:15.963",
        "brokerTime": "2025-05-14 15:15:17.065",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068352",
        "positionId": "56068349",
        "volume": 9.96,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3213.7,
        "doubleCheck": true
    },
    {
        "id": "53113986",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:17.409",
        "brokerTime": "2025-05-14 15:15:17.409",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068353",
        "positionId": "56068353",
        "volume": 9.96,
        "price": 3213.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "id": "53113987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:17.409",
        "brokerTime": "2025-05-14 15:15:17.789",
        "commission": -69.72,
        "swap": 0,
        "profit": -517.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068354",
        "positionId": "56068353",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -587.64,
        "takeProfit": null,
        "priceIn": 3213.33,
        "doubleCheck": true
    },
    {
        "id": "53113988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:18.376",
        "brokerTime": "2025-05-14 15:15:18.376",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068355",
        "positionId": "56068355",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53113989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:18.376",
        "brokerTime": "2025-05-14 15:15:18.697",
        "commission": -69.72,
        "swap": 0,
        "profit": -338.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068356",
        "positionId": "56068355",
        "volume": 9.96,
        "price": 3214.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -408.36,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53113990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:19.386",
        "brokerTime": "2025-05-14 15:15:19.386",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068357",
        "positionId": "56068357",
        "volume": 9.96,
        "price": 3213.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.67,
        "doubleCheck": true
    },
    {
        "id": "53113991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:19.386",
        "brokerTime": "2025-05-14 15:15:19.732",
        "commission": -69.72,
        "swap": 0,
        "profit": -49.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068358",
        "positionId": "56068357",
        "volume": 9.96,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -119.52,
        "takeProfit": null,
        "priceIn": 3213.67,
        "doubleCheck": true
    },
    {
        "id": "53113992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:20.316",
        "brokerTime": "2025-05-14 15:15:20.316",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068359",
        "positionId": "56068359",
        "volume": 9.96,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53113993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:20.316",
        "brokerTime": "2025-05-14 15:15:20.911",
        "commission": -69.72,
        "swap": 0,
        "profit": -478.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068360",
        "positionId": "56068359",
        "volume": 9.96,
        "price": 3214.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -547.8,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53113994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:21.442",
        "brokerTime": "2025-05-14 15:15:21.442",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068361",
        "positionId": "56068361",
        "volume": 9.96,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53113995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:21.442",
        "brokerTime": "2025-05-14 15:15:21.947",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068362",
        "positionId": "56068361",
        "volume": 9.96,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -557.76,
        "takeProfit": null,
        "priceIn": 3213.98,
        "doubleCheck": true
    },
    {
        "id": "53113996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:22.140",
        "brokerTime": "2025-05-14 15:15:22.140",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068363",
        "positionId": "56068363",
        "volume": 9.96,
        "price": 3214.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "id": "53113997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:22.140",
        "brokerTime": "2025-05-14 15:15:22.856",
        "commission": -69.72,
        "swap": 0,
        "profit": -418.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068364",
        "positionId": "56068363",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -488.03999999999996,
        "takeProfit": null,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "id": "53113998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23.223",
        "brokerTime": "2025-05-14 15:15:23.223",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068365",
        "positionId": "56068365",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23.223",
        "brokerTime": "2025-05-14 15:15:23.706",
        "commission": -69.72,
        "swap": 0,
        "profit": -468.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068367",
        "positionId": "56068365",
        "volume": 9.96,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -537.84,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23.889",
        "brokerTime": "2025-05-14 15:15:23.889",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068368",
        "positionId": "56068368",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53114002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:23.889",
        "brokerTime": "2025-05-14 15:15:24.223",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068369",
        "positionId": "56068368",
        "volume": 9.96,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.48,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53114003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:24.696",
        "brokerTime": "2025-05-14 15:15:24.696",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068370",
        "positionId": "56068370",
        "volume": 9.96,
        "price": 3214.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.66,
        "doubleCheck": true
    },
    {
        "id": "53114004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:24.696",
        "brokerTime": "2025-05-14 15:15:25.069",
        "commission": -69.72,
        "swap": 0,
        "profit": -388.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068371",
        "positionId": "56068370",
        "volume": 9.96,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.15999999999997,
        "takeProfit": null,
        "priceIn": 3214.66,
        "doubleCheck": true
    },
    {
        "id": "53114005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25.409",
        "brokerTime": "2025-05-14 15:15:25.409",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068372",
        "positionId": "56068372",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "id": "53114006",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:25.409",
        "brokerTime": "2025-05-14 15:15:25.781",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068373",
        "positionId": "56068372",
        "volume": 9.96,
        "price": 3215.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "id": "53114007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26.152",
        "brokerTime": "2025-05-14 15:15:26.152",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068374",
        "positionId": "56068374",
        "volume": 9.96,
        "price": 3214.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "id": "53114009",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26.152",
        "brokerTime": "2025-05-14 15:15:26.566",
        "commission": -69.72,
        "swap": 0,
        "profit": -488.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068376",
        "positionId": "56068374",
        "volume": 9.96,
        "price": 3215.36,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -557.76,
        "takeProfit": null,
        "priceIn": 3214.87,
        "doubleCheck": true
    },
    {
        "id": "53114010",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26.893",
        "brokerTime": "2025-05-14 15:15:26.893",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068377",
        "positionId": "56068377",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53114011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:26.893",
        "brokerTime": "2025-05-14 15:15:27.707",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068378",
        "positionId": "56068377",
        "volume": 9.96,
        "price": 3215.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53114012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28.314",
        "brokerTime": "2025-05-14 15:15:28.314",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068380",
        "positionId": "56068380",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53114014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28.314",
        "brokerTime": "2025-05-14 15:15:28.615",
        "commission": -69.72,
        "swap": 0,
        "profit": -149.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068381",
        "positionId": "56068380",
        "volume": 9.96,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -219.12,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53114015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28.813",
        "brokerTime": "2025-05-14 15:15:28.813",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068382",
        "positionId": "56068382",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53114016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:28.813",
        "brokerTime": "2025-05-14 15:15:29.155",
        "commission": -69.72,
        "swap": 0,
        "profit": -179.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068383",
        "positionId": "56068382",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -249,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53114017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29.419",
        "brokerTime": "2025-05-14 15:15:29.419",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068384",
        "positionId": "56068384",
        "volume": 9.96,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "id": "53114018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29.419",
        "brokerTime": "2025-05-14 15:15:29.785",
        "commission": -69.72,
        "swap": 0,
        "profit": -308.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068385",
        "positionId": "56068384",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.48,
        "takeProfit": null,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "id": "53114019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29.955",
        "brokerTime": "2025-05-14 15:15:29.955",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068386",
        "positionId": "56068386",
        "volume": 9.96,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53114020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:29.955",
        "brokerTime": "2025-05-14 15:15:30.383",
        "commission": -69.72,
        "swap": 0,
        "profit": -239.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068387",
        "positionId": "56068386",
        "volume": 9.96,
        "price": 3214.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -308.76,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53114021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:30.624",
        "brokerTime": "2025-05-14 15:15:30.624",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068388",
        "positionId": "56068388",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53114022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:30.624",
        "brokerTime": "2025-05-14 15:15:31.186",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068389",
        "positionId": "56068388",
        "volume": 9.96,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53114023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31.468",
        "brokerTime": "2025-05-14 15:15:31.468",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068390",
        "positionId": "56068390",
        "volume": 9.96,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "id": "53114025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:31.468",
        "brokerTime": "2025-05-14 15:15:32.565",
        "commission": -69.72,
        "swap": 0,
        "profit": -139.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068392",
        "positionId": "56068390",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -209.16,
        "takeProfit": null,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "id": "53114026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:32.750",
        "brokerTime": "2025-05-14 15:15:32.750",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068393",
        "positionId": "56068393",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:32.750",
        "brokerTime": "2025-05-14 15:15:33.218",
        "commission": -69.72,
        "swap": 0,
        "profit": -79.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068394",
        "positionId": "56068393",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -149.4,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114029",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:33.671",
        "brokerTime": "2025-05-14 15:15:33.671",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068396",
        "positionId": "56068396",
        "volume": 9.96,
        "price": 3214.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.38,
        "doubleCheck": true
    },
    {
        "id": "53114030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:33.671",
        "brokerTime": "2025-05-14 15:15:34.134",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068397",
        "positionId": "56068396",
        "volume": 9.96,
        "price": 3214.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -268.91999999999996,
        "takeProfit": null,
        "priceIn": 3214.38,
        "doubleCheck": true
    },
    {
        "id": "53114032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:34.686",
        "brokerTime": "2025-05-14 15:15:34.686",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068399",
        "positionId": "56068399",
        "volume": 9.96,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "id": "53114033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:34.686",
        "brokerTime": "2025-05-14 15:15:35.201",
        "commission": -69.72,
        "swap": 0,
        "profit": -318.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068400",
        "positionId": "56068399",
        "volume": 9.96,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -388.44000000000005,
        "takeProfit": null,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "id": "53114035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:35.866",
        "brokerTime": "2025-05-14 15:15:35.866",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068402",
        "positionId": "56068402",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53114037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:35.866",
        "brokerTime": "2025-05-14 15:15:36.479",
        "commission": -69.72,
        "swap": 0,
        "profit": -378.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068404",
        "positionId": "56068402",
        "volume": 9.96,
        "price": 3214.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -448.20000000000005,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53114038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:36.801",
        "brokerTime": "2025-05-14 15:15:36.801",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068405",
        "positionId": "56068405",
        "volume": 9.96,
        "price": 3214.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53114040",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:36.801",
        "brokerTime": "2025-05-14 15:15:37.248",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068407",
        "positionId": "56068405",
        "volume": 9.96,
        "price": 3214.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3214.64,
        "doubleCheck": true
    },
    {
        "id": "53114042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39.142",
        "brokerTime": "2025-05-14 15:15:39.142",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068409",
        "positionId": "56068409",
        "volume": 9.96,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53114043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39.142",
        "brokerTime": "2025-05-14 15:15:39.708",
        "commission": -69.72,
        "swap": 0,
        "profit": -199.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068410",
        "positionId": "56068409",
        "volume": 9.96,
        "price": 3214.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -268.91999999999996,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53114044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39.902",
        "brokerTime": "2025-05-14 15:15:39.902",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068411",
        "positionId": "56068411",
        "volume": 9.96,
        "price": 3214.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:39.902",
        "brokerTime": "2025-05-14 15:15:40.457",
        "commission": -69.72,
        "swap": 0,
        "profit": -368.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068412",
        "positionId": "56068411",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -438.24,
        "takeProfit": null,
        "priceIn": 3214.56,
        "doubleCheck": true
    },
    {
        "id": "53114046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:40.685",
        "brokerTime": "2025-05-14 15:15:40.685",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068413",
        "positionId": "56068413",
        "volume": 9.96,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53114048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:40.685",
        "brokerTime": "2025-05-14 15:15:41.793",
        "commission": -69.72,
        "swap": 0,
        "profit": -249,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068414",
        "positionId": "56068413",
        "volume": 9.96,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -318.72,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53114049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:42.694",
        "brokerTime": "2025-05-14 15:15:42.694",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068415",
        "positionId": "56068415",
        "volume": 9.96,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "id": "53114050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:42.694",
        "brokerTime": "2025-05-14 15:15:43.153",
        "commission": -69.72,
        "swap": 0,
        "profit": -189.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068416",
        "positionId": "56068415",
        "volume": 9.96,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -258.96000000000004,
        "takeProfit": null,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "id": "53114051",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43.400",
        "brokerTime": "2025-05-14 15:15:43.400",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068417",
        "positionId": "56068417",
        "volume": 9.96,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53114052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43.400",
        "brokerTime": "2025-05-14 15:15:43.815",
        "commission": -69.72,
        "swap": 0,
        "profit": -219.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068418",
        "positionId": "56068417",
        "volume": 9.96,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -288.84000000000003,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53114053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43.997",
        "brokerTime": "2025-05-14 15:15:43.997",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068419",
        "positionId": "56068419",
        "volume": 9.96,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53114055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:43.997",
        "brokerTime": "2025-05-14 15:15:44.498",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068421",
        "positionId": "56068419",
        "volume": 9.96,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53114056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:45.033",
        "brokerTime": "2025-05-14 15:15:45.033",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068422",
        "positionId": "56068422",
        "volume": 9.96,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.33,
        "doubleCheck": true
    },
    {
        "id": "53114058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:45.033",
        "brokerTime": "2025-05-14 15:15:45.741",
        "commission": -69.72,
        "swap": 0,
        "profit": -119.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068424",
        "positionId": "56068422",
        "volume": 9.96,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189.24,
        "takeProfit": null,
        "priceIn": 3214.33,
        "doubleCheck": true
    },
    {
        "id": "53114059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:46.048",
        "brokerTime": "2025-05-14 15:15:46.048",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068425",
        "positionId": "56068425",
        "volume": 9.96,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "id": "53114060",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:46.048",
        "brokerTime": "2025-05-14 15:15:46.452",
        "commission": -69.72,
        "swap": 0,
        "profit": -209.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068426",
        "positionId": "56068425",
        "volume": 9.96,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -278.88,
        "takeProfit": null,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "id": "53114061",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:47.014",
        "brokerTime": "2025-05-14 15:15:47.014",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068427",
        "positionId": "56068427",
        "volume": 9.96,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53114062",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:47.014",
        "brokerTime": "2025-05-14 15:15:47.476",
        "commission": -69.72,
        "swap": 0,
        "profit": -129.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068428",
        "positionId": "56068427",
        "volume": 9.96,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -199.2,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53114064",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:48.022",
        "brokerTime": "2025-05-14 15:15:48.022",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068430",
        "positionId": "56068430",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "id": "53114065",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:48.022",
        "brokerTime": "2025-05-14 15:15:48.399",
        "commission": -69.72,
        "swap": 0,
        "profit": -278.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068431",
        "positionId": "56068430",
        "volume": 9.96,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -348.6,
        "takeProfit": null,
        "priceIn": 3214.09,
        "doubleCheck": true
    },
    {
        "id": "53114066",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:49.027",
        "brokerTime": "2025-05-14 15:15:49.027",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068432",
        "positionId": "56068432",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53114067",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:49.027",
        "brokerTime": "2025-05-14 15:15:49.584",
        "commission": -69.72,
        "swap": 0,
        "profit": -59.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068433",
        "positionId": "56068432",
        "volume": 9.96,
        "price": 3214.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -129.48,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53114068",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:50.049",
        "brokerTime": "2025-05-14 15:15:50.049",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068434",
        "positionId": "56068434",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53114069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:50.049",
        "brokerTime": "2025-05-14 15:15:50.708",
        "commission": -69.72,
        "swap": 0,
        "profit": 99.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068435",
        "positionId": "56068434",
        "volume": 9.96,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 29.879999999999995,
        "takeProfit": null,
        "priceIn": 3213.85,
        "doubleCheck": true
    },
    {
        "id": "53114070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:51.423",
        "brokerTime": "2025-05-14 15:15:51.423",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068437",
        "positionId": "56068437",
        "volume": 9.96,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53114071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:51.423",
        "brokerTime": "2025-05-14 15:15:52.034",
        "commission": -69.72,
        "swap": 0,
        "profit": -398.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068438",
        "positionId": "56068437",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -468.12,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53114072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:52.376",
        "brokerTime": "2025-05-14 15:15:52.376",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068439",
        "positionId": "56068439",
        "volume": 9.96,
        "price": 3213.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.63,
        "doubleCheck": true
    },
    {
        "id": "53114074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:52.376",
        "brokerTime": "2025-05-14 15:15:52.815",
        "commission": -69.72,
        "swap": 0,
        "profit": -428.28,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068441",
        "positionId": "56068439",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -498,
        "takeProfit": null,
        "priceIn": 3213.63,
        "doubleCheck": true
    },
    {
        "id": "53114075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53.062",
        "brokerTime": "2025-05-14 15:15:53.062",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068442",
        "positionId": "56068442",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53.062",
        "brokerTime": "2025-05-14 15:15:53.375",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068443",
        "positionId": "56068442",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53.826",
        "brokerTime": "2025-05-14 15:15:53.826",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068444",
        "positionId": "56068444",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:53.826",
        "brokerTime": "2025-05-14 15:15:54.226",
        "commission": -69.72,
        "swap": 0,
        "profit": -159.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068445",
        "positionId": "56068444",
        "volume": 9.96,
        "price": 3214.07,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.08,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:54.820",
        "brokerTime": "2025-05-14 15:15:54.820",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068446",
        "positionId": "56068446",
        "volume": 9.96,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53114081",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:54.820",
        "brokerTime": "2025-05-14 15:15:55.733",
        "commission": -69.72,
        "swap": 0,
        "profit": -418.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068448",
        "positionId": "56068446",
        "volume": 9.96,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -488.03999999999996,
        "takeProfit": null,
        "priceIn": 3213.87,
        "doubleCheck": true
    },
    {
        "id": "53114082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:56.139",
        "brokerTime": "2025-05-14 15:15:56.139",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068449",
        "positionId": "56068449",
        "volume": 9.96,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53114083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:56.139",
        "brokerTime": "2025-05-14 15:15:56.846",
        "commission": -69.72,
        "swap": 0,
        "profit": 89.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068450",
        "positionId": "56068449",
        "volume": 9.96,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 19.92,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53114084",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57.330",
        "brokerTime": "2025-05-14 15:15:57.330",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068451",
        "positionId": "56068451",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53114085",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57.330",
        "brokerTime": "2025-05-14 15:15:57.739",
        "commission": -69.72,
        "swap": 0,
        "profit": -229.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068452",
        "positionId": "56068451",
        "volume": 9.96,
        "price": 3213.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -298.8,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53114086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57.967",
        "brokerTime": "2025-05-14 15:15:57.967",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068453",
        "positionId": "56068453",
        "volume": 9.96,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "id": "53114087",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:57.967",
        "brokerTime": "2025-05-14 15:15:58.328",
        "commission": -69.72,
        "swap": 0,
        "profit": -119.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068454",
        "positionId": "56068453",
        "volume": 9.96,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189.24,
        "takeProfit": null,
        "priceIn": 3213.77,
        "doubleCheck": true
    },
    {
        "id": "53114088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:58.692",
        "brokerTime": "2025-05-14 15:15:58.692",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068455",
        "positionId": "56068455",
        "volume": 9.96,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53114092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:58.692",
        "brokerTime": "2025-05-14 15:15:59.100",
        "commission": -69.72,
        "swap": 0,
        "profit": -109.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068460",
        "positionId": "56068455",
        "volume": 9.96,
        "price": 3213.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -179.28,
        "takeProfit": null,
        "priceIn": 3213.74,
        "doubleCheck": true
    },
    {
        "id": "53114095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:59.977",
        "brokerTime": "2025-05-14 15:15:59.977",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068462",
        "positionId": "56068462",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53114098",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:15:59.977",
        "brokerTime": "2025-05-14 15:16:00.729",
        "commission": -69.72,
        "swap": 0,
        "profit": -328.68,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068465",
        "positionId": "56068462",
        "volume": 9.96,
        "price": 3214.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -398.4,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53114099",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:01.171",
        "brokerTime": "2025-05-14 15:16:01.171",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068466",
        "positionId": "56068466",
        "volume": 9.96,
        "price": 3213.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114100",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:01.171",
        "brokerTime": "2025-05-14 15:16:02.014",
        "commission": -69.72,
        "swap": 0,
        "profit": -29.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068467",
        "positionId": "56068466",
        "volume": 9.96,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -99.6,
        "takeProfit": null,
        "priceIn": 3213.91,
        "doubleCheck": true
    },
    {
        "id": "53114101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:02.696",
        "brokerTime": "2025-05-14 15:16:02.696",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068468",
        "positionId": "56068468",
        "volume": 9.96,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "id": "53114102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:02.696",
        "brokerTime": "2025-05-14 15:16:03.305",
        "commission": -69.72,
        "swap": 0,
        "profit": -298.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068469",
        "positionId": "56068468",
        "volume": 9.96,
        "price": 3214.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -368.52,
        "takeProfit": null,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "id": "53114104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:03.766",
        "brokerTime": "2025-05-14 15:16:03.766",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068471",
        "positionId": "56068471",
        "volume": 9.96,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53114105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:03.766",
        "brokerTime": "2025-05-14 15:16:04.434",
        "commission": -69.72,
        "swap": 0,
        "profit": 69.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068472",
        "positionId": "56068471",
        "volume": 9.96,
        "price": 3213.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3213.76,
        "doubleCheck": true
    },
    {
        "id": "53114106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:05.025",
        "brokerTime": "2025-05-14 15:16:05.025",
        "commission": -69.72,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068473",
        "positionId": "56068473",
        "volume": 9.96,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -69.72,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53114107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:05.025",
        "brokerTime": "2025-05-14 15:16:05.400",
        "commission": -69.72,
        "swap": 0,
        "profit": -29.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068474",
        "positionId": "56068473",
        "volume": 9.96,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -99.6,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53114108",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:06:56.176",
        "brokerTime": "2025-05-14 15:16:05.467",
        "commission": -1.19,
        "swap": 0,
        "profit": 151.81,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068475",
        "positionId": "56054283",
        "volume": 0.17,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 150.62,
        "priceIn": 3222.38,
        "doubleCheck": false
    },
    {
        "id": "53114109",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:03:00.254",
        "brokerTime": "2025-05-14 15:16:05.496",
        "commission": -0.98,
        "swap": 0,
        "profit": 104.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068476",
        "positionId": "56053553",
        "volume": 0.14,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 103.88,
        "priceIn": 3220.94,
        "doubleCheck": false
    },
    {
        "id": "53114110",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:25.566",
        "brokerTime": "2025-05-14 15:16:05.520",
        "commission": -0.84,
        "swap": 0,
        "profit": 55.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068477",
        "positionId": "56053437",
        "volume": 0.12,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 54.599999999999994,
        "priceIn": 3218.07,
        "doubleCheck": false
    },
    {
        "id": "53114111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:02:10.851",
        "brokerTime": "2025-05-14 15:16:05.537",
        "commission": -0.7,
        "swap": 0,
        "profit": 32.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068478",
        "positionId": "56053393",
        "volume": 0.1,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3122.56,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 31.900000000000002,
        "priceIn": 3216.71,
        "doubleCheck": false
    },
    {
        "id": "53114118",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:12.322",
        "brokerTime": "2025-05-14 15:16:12.322",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068484",
        "positionId": "56068484",
        "volume": 0.1,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "id": "53114119",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:12.428",
        "brokerTime": "2025-05-14 15:16:12.428",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56068485",
        "positionId": "56068485",
        "volume": 0.21,
        "price": 2864.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2964.7,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 2864.7,
        "doubleCheck": true
    },
    {
        "id": "53114146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:13.311",
        "brokerTime": "2025-05-14 15:16:13.311",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068503",
        "positionId": "56068503",
        "volume": 10.39,
        "price": 3212.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.73,
        "takeProfit": null,
        "priceIn": 3212.17,
        "doubleCheck": true
    },
    {
        "id": "53114148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:13.311",
        "brokerTime": "2025-05-14 15:16:13.846",
        "commission": -72.73,
        "swap": 0,
        "profit": -166.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068508",
        "positionId": "56068503",
        "volume": 10.39,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -238.97000000000003,
        "takeProfit": null,
        "priceIn": 3212.17,
        "doubleCheck": true
    },
    {
        "id": "53114159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:14.190",
        "brokerTime": "2025-05-14 15:16:14.190",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068511",
        "positionId": "56068511",
        "volume": 10.39,
        "price": 3212.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.73,
        "takeProfit": null,
        "priceIn": 3212.27,
        "doubleCheck": true
    },
    {
        "id": "53114162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:14.190",
        "brokerTime": "2025-05-14 15:16:14.731",
        "commission": -72.73,
        "swap": 0,
        "profit": -259.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068514",
        "positionId": "56068511",
        "volume": 10.39,
        "price": 3212.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -332.48,
        "takeProfit": null,
        "priceIn": 3212.27,
        "doubleCheck": true
    },
    {
        "id": "53114163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15.134",
        "brokerTime": "2025-05-14 15:16:15.134",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068515",
        "positionId": "56068515",
        "volume": 10.39,
        "price": 3212.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.73,
        "takeProfit": null,
        "priceIn": 3212.26,
        "doubleCheck": true
    },
    {
        "id": "53114165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15.134",
        "brokerTime": "2025-05-14 15:16:15.537",
        "commission": -72.73,
        "swap": 0,
        "profit": -332.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068517",
        "positionId": "56068515",
        "volume": 10.39,
        "price": 3212.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -405.21000000000004,
        "takeProfit": null,
        "priceIn": 3212.26,
        "doubleCheck": true
    },
    {
        "id": "53114166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15.912",
        "brokerTime": "2025-05-14 15:16:15.912",
        "commission": -72.73,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068518",
        "positionId": "56068518",
        "volume": 10.39,
        "price": 3212.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -72.73,
        "takeProfit": null,
        "priceIn": 3212.32,
        "doubleCheck": true
    },
    {
        "id": "53114167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:15.912",
        "brokerTime": "2025-05-14 15:16:16.368",
        "commission": -72.73,
        "swap": 0,
        "profit": -51.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068519",
        "positionId": "56068518",
        "volume": 10.39,
        "price": 3212.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -124.68,
        "takeProfit": null,
        "priceIn": 3212.32,
        "doubleCheck": true
    },
    {
        "id": "53114168",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:16.445",
        "brokerTime": "2025-05-14 15:16:16.445",
        "commission": -12.95,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068520",
        "positionId": "56068520",
        "volume": 1.85,
        "price": 3212.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3312.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12.95,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "id": "53114169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:17.306",
        "brokerTime": "2025-05-14 15:16:17.306",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068521",
        "positionId": "56068521",
        "volume": 12.61,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53114170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:17.306",
        "brokerTime": "2025-05-14 15:16:18.085",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068522",
        "positionId": "56068521",
        "volume": 12.61,
        "price": 3211.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53114171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:18.588",
        "brokerTime": "2025-05-14 15:16:18.588",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068523",
        "positionId": "56068523",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "id": "53114172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:18.588",
        "brokerTime": "2025-05-14 15:16:19.189",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068524",
        "positionId": "56068523",
        "volume": 12.61,
        "price": 3211.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -453.96,
        "takeProfit": null,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "id": "53114173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:19.665",
        "brokerTime": "2025-05-14 15:16:19.665",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068525",
        "positionId": "56068525",
        "volume": 12.61,
        "price": 3211.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "id": "53114174",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:19.665",
        "brokerTime": "2025-05-14 15:16:20.309",
        "commission": -88.27,
        "swap": 0,
        "profit": -491.79,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068526",
        "positionId": "56068525",
        "volume": 12.61,
        "price": 3212.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -580.0600000000001,
        "takeProfit": null,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "id": "53114175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:20.585",
        "brokerTime": "2025-05-14 15:16:20.585",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068527",
        "positionId": "56068527",
        "volume": 12.61,
        "price": 3211.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.93,
        "doubleCheck": true
    },
    {
        "id": "53114176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:20.585",
        "brokerTime": "2025-05-14 15:16:20.982",
        "commission": -88.27,
        "swap": 0,
        "profit": -214.37,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068528",
        "positionId": "56068527",
        "volume": 12.61,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -302.64,
        "takeProfit": null,
        "priceIn": 3211.93,
        "doubleCheck": true
    },
    {
        "id": "53114177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21.146",
        "brokerTime": "2025-05-14 15:16:21.146",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068529",
        "positionId": "56068529",
        "volume": 12.61,
        "price": 3212.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.04,
        "doubleCheck": true
    },
    {
        "id": "53114178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:21.146",
        "brokerTime": "2025-05-14 15:16:21.511",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068530",
        "positionId": "56068529",
        "volume": 12.61,
        "price": 3212.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3212.04,
        "doubleCheck": true
    },
    {
        "id": "53114179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22.061",
        "brokerTime": "2025-05-14 15:16:22.061",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068531",
        "positionId": "56068531",
        "volume": 12.61,
        "price": 3212.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "id": "53114180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22.061",
        "brokerTime": "2025-05-14 15:16:22.541",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068533",
        "positionId": "56068531",
        "volume": 12.61,
        "price": 3212.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -416.13,
        "takeProfit": null,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "id": "53114181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22.718",
        "brokerTime": "2025-05-14 15:16:22.718",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068534",
        "positionId": "56068534",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "id": "53114182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:22.718",
        "brokerTime": "2025-05-14 15:16:23.243",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068535",
        "positionId": "56068534",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -517.01,
        "takeProfit": null,
        "priceIn": 3211.62,
        "doubleCheck": true
    },
    {
        "id": "53114183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23.453",
        "brokerTime": "2025-05-14 15:16:23.453",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068536",
        "positionId": "56068536",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:23.453",
        "brokerTime": "2025-05-14 15:16:24.026",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068537",
        "positionId": "56068536",
        "volume": 12.61,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -517.01,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:24.533",
        "brokerTime": "2025-05-14 15:16:24.533",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068538",
        "positionId": "56068538",
        "volume": 12.61,
        "price": 3212.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.09,
        "doubleCheck": true
    },
    {
        "id": "53114186",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:24.533",
        "brokerTime": "2025-05-14 15:16:25.079",
        "commission": -88.27,
        "swap": 0,
        "profit": 63.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068539",
        "positionId": "56068538",
        "volume": 12.61,
        "price": 3212.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -25.22,
        "takeProfit": null,
        "priceIn": 3212.09,
        "doubleCheck": true
    },
    {
        "id": "53114187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25.338",
        "brokerTime": "2025-05-14 15:16:25.338",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068540",
        "positionId": "56068540",
        "volume": 12.61,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53114188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:25.338",
        "brokerTime": "2025-05-14 15:16:25.819",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068541",
        "positionId": "56068540",
        "volume": 12.61,
        "price": 3211.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -151.32,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53114189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:26.050",
        "brokerTime": "2025-05-14 15:16:26.050",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068542",
        "positionId": "56068542",
        "volume": 12.61,
        "price": 3211.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.66,
        "doubleCheck": true
    },
    {
        "id": "53114190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:26.050",
        "brokerTime": "2025-05-14 15:16:26.831",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068543",
        "positionId": "56068542",
        "volume": 12.61,
        "price": 3211.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -504.4,
        "takeProfit": null,
        "priceIn": 3211.66,
        "doubleCheck": true
    },
    {
        "id": "53114191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:27.135",
        "brokerTime": "2025-05-14 15:16:27.135",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068544",
        "positionId": "56068544",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:27.135",
        "brokerTime": "2025-05-14 15:16:27.601",
        "commission": -88.27,
        "swap": 0,
        "profit": -163.93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068545",
        "positionId": "56068544",
        "volume": 12.61,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -252.2,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:28.801",
        "brokerTime": "2025-05-14 15:16:28.801",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068555",
        "positionId": "56068555",
        "volume": 12.61,
        "price": 3211.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "id": "53114205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:28.801",
        "brokerTime": "2025-05-14 15:16:29.216",
        "commission": -88.27,
        "swap": 0,
        "profit": -580.06,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068558",
        "positionId": "56068555",
        "volume": 12.61,
        "price": 3212.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -668.3299999999999,
        "takeProfit": null,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "id": "53114206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:29.501",
        "brokerTime": "2025-05-14 15:16:29.501",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068559",
        "positionId": "56068559",
        "volume": 12.61,
        "price": 3212.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.62,
        "doubleCheck": true
    },
    {
        "id": "53114207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:29.501",
        "brokerTime": "2025-05-14 15:16:29.812",
        "commission": -88.27,
        "swap": 0,
        "profit": -176.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068560",
        "positionId": "56068559",
        "volume": 12.61,
        "price": 3212.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.81,
        "takeProfit": null,
        "priceIn": 3212.62,
        "doubleCheck": true
    },
    {
        "id": "53114208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30.265",
        "brokerTime": "2025-05-14 15:16:30.265",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068561",
        "positionId": "56068561",
        "volume": 12.61,
        "price": 3212.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.6,
        "doubleCheck": true
    },
    {
        "id": "53114209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:30.265",
        "brokerTime": "2025-05-14 15:16:31.559",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068562",
        "positionId": "56068561",
        "volume": 12.61,
        "price": 3212.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3212.6,
        "doubleCheck": true
    },
    {
        "id": "53114210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:31.989",
        "brokerTime": "2025-05-14 15:16:31.989",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068563",
        "positionId": "56068563",
        "volume": 12.61,
        "price": 3212.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3212.49,
        "doubleCheck": true
    },
    {
        "id": "53114211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:31.989",
        "brokerTime": "2025-05-14 15:16:32.666",
        "commission": -88.27,
        "swap": 0,
        "profit": 201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068564",
        "positionId": "56068563",
        "volume": 12.61,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 113.49,
        "takeProfit": null,
        "priceIn": 3212.49,
        "doubleCheck": true
    },
    {
        "id": "53114212",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:33.068",
        "brokerTime": "2025-05-14 15:16:33.068",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068565",
        "positionId": "56068565",
        "volume": 12.61,
        "price": 3211.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.69,
        "doubleCheck": true
    },
    {
        "id": "53114213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:33.068",
        "brokerTime": "2025-05-14 15:16:33.677",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068566",
        "positionId": "56068565",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3211.69,
        "doubleCheck": true
    },
    {
        "id": "53114214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34.016",
        "brokerTime": "2025-05-14 15:16:34.016",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068567",
        "positionId": "56068567",
        "volume": 12.61,
        "price": 3211.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "id": "53114216",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34.016",
        "brokerTime": "2025-05-14 15:16:34.372",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068569",
        "positionId": "56068567",
        "volume": 12.61,
        "price": 3212,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -416.13,
        "takeProfit": null,
        "priceIn": 3211.74,
        "doubleCheck": true
    },
    {
        "id": "53114217",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34.609",
        "brokerTime": "2025-05-14 15:16:34.609",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068570",
        "positionId": "56068570",
        "volume": 12.61,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114218",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:34.609",
        "brokerTime": "2025-05-14 15:16:35.327",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068571",
        "positionId": "56068570",
        "volume": 12.61,
        "price": 3212.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -403.52,
        "takeProfit": null,
        "priceIn": 3211.76,
        "doubleCheck": true
    },
    {
        "id": "53114219",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:35.622",
        "brokerTime": "2025-05-14 15:16:35.622",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068572",
        "positionId": "56068572",
        "volume": 12.61,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "id": "53114220",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:35.622",
        "brokerTime": "2025-05-14 15:16:36.450",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068573",
        "positionId": "56068572",
        "volume": 12.61,
        "price": 3212.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.03,
        "takeProfit": null,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "id": "53114221",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:36.997",
        "brokerTime": "2025-05-14 15:16:36.997",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068574",
        "positionId": "56068574",
        "volume": 12.61,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53114222",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:36.997",
        "brokerTime": "2025-05-14 15:16:37.481",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068575",
        "positionId": "56068574",
        "volume": 12.61,
        "price": 3212.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.08,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53114223",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:37.939",
        "brokerTime": "2025-05-14 15:16:37.939",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068576",
        "positionId": "56068576",
        "volume": 12.61,
        "price": 3211.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.9,
        "doubleCheck": true
    },
    {
        "id": "53114224",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:37.939",
        "brokerTime": "2025-05-14 15:16:38.318",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068577",
        "positionId": "56068576",
        "volume": 12.61,
        "price": 3212.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3211.9,
        "doubleCheck": true
    },
    {
        "id": "53114225",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:38.737",
        "brokerTime": "2025-05-14 15:16:38.737",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068578",
        "positionId": "56068578",
        "volume": 12.61,
        "price": 3211.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.96,
        "doubleCheck": true
    },
    {
        "id": "53114226",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:38.737",
        "brokerTime": "2025-05-14 15:16:39.081",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068579",
        "positionId": "56068578",
        "volume": 12.61,
        "price": 3212.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.54,
        "takeProfit": null,
        "priceIn": 3211.96,
        "doubleCheck": true
    },
    {
        "id": "53114227",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39.317",
        "brokerTime": "2025-05-14 15:16:39.317",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068580",
        "positionId": "56068580",
        "volume": 12.61,
        "price": 3211.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.84,
        "doubleCheck": true
    },
    {
        "id": "53114228",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:39.317",
        "brokerTime": "2025-05-14 15:16:39.677",
        "commission": -88.27,
        "swap": 0,
        "profit": -126.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068581",
        "positionId": "56068580",
        "volume": 12.61,
        "price": 3211.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -214.37,
        "takeProfit": null,
        "priceIn": 3211.84,
        "doubleCheck": true
    },
    {
        "id": "53114231",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:40.405",
        "brokerTime": "2025-05-14 15:16:40.405",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068584",
        "positionId": "56068584",
        "volume": 12.61,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53114232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:40.405",
        "brokerTime": "2025-05-14 15:16:41.118",
        "commission": -88.27,
        "swap": 0,
        "profit": -479.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068585",
        "positionId": "56068584",
        "volume": 12.61,
        "price": 3211.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -567.45,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53114233",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:41.290",
        "brokerTime": "2025-05-14 15:16:41.290",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068586",
        "positionId": "56068586",
        "volume": 12.61,
        "price": 3211.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.29,
        "doubleCheck": true
    },
    {
        "id": "53114234",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:41.290",
        "brokerTime": "2025-05-14 15:16:41.959",
        "commission": -88.27,
        "swap": 0,
        "profit": -428.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068587",
        "positionId": "56068586",
        "volume": 12.61,
        "price": 3211.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -517.01,
        "takeProfit": null,
        "priceIn": 3211.29,
        "doubleCheck": true
    },
    {
        "id": "53114236",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:42.248",
        "brokerTime": "2025-05-14 15:16:42.248",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068589",
        "positionId": "56068589",
        "volume": 12.61,
        "price": 3211.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.41,
        "doubleCheck": true
    },
    {
        "id": "53114237",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:42.248",
        "brokerTime": "2025-05-14 15:16:42.768",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068590",
        "positionId": "56068589",
        "volume": 12.61,
        "price": 3211.72,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3211.41,
        "doubleCheck": true
    },
    {
        "id": "53114238",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:43.411",
        "brokerTime": "2025-05-14 15:16:43.411",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068591",
        "positionId": "56068591",
        "volume": 12.61,
        "price": 3211.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.49,
        "doubleCheck": true
    },
    {
        "id": "53114239",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:43.411",
        "brokerTime": "2025-05-14 15:16:43.707",
        "commission": -88.27,
        "swap": 0,
        "profit": -138.71,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068592",
        "positionId": "56068591",
        "volume": 12.61,
        "price": 3211.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -226.98000000000002,
        "takeProfit": null,
        "priceIn": 3211.49,
        "doubleCheck": true
    },
    {
        "id": "53114240",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:44.584",
        "brokerTime": "2025-05-14 15:16:44.584",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068593",
        "positionId": "56068593",
        "volume": 12.61,
        "price": 3211.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.31,
        "doubleCheck": true
    },
    {
        "id": "53114241",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:44.584",
        "brokerTime": "2025-05-14 15:16:44.929",
        "commission": -88.27,
        "swap": 0,
        "profit": -214.37,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068594",
        "positionId": "56068593",
        "volume": 12.61,
        "price": 3211.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -302.64,
        "takeProfit": null,
        "priceIn": 3211.31,
        "doubleCheck": true
    },
    {
        "id": "53114243",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45.196",
        "brokerTime": "2025-05-14 15:16:45.196",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068596",
        "positionId": "56068596",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "id": "53114245",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:45.196",
        "brokerTime": "2025-05-14 15:16:45.989",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068598",
        "positionId": "56068596",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.46999999999997,
        "takeProfit": null,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "id": "53114251",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:46.280",
        "brokerTime": "2025-05-14 15:16:46.280",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068602",
        "positionId": "56068602",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "id": "53114253",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:46.280",
        "brokerTime": "2025-05-14 15:16:46.830",
        "commission": -88.27,
        "swap": 0,
        "profit": -542.23,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068603",
        "positionId": "56068602",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -630.5,
        "takeProfit": null,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "id": "53114254",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:47.089",
        "brokerTime": "2025-05-14 15:16:47.089",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068604",
        "positionId": "56068604",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "id": "53114255",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:47.089",
        "brokerTime": "2025-05-14 15:16:47.602",
        "commission": -88.27,
        "swap": 0,
        "profit": -453.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068605",
        "positionId": "56068604",
        "volume": 12.61,
        "price": 3211.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -542.23,
        "takeProfit": null,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "id": "53114256",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48.052",
        "brokerTime": "2025-05-14 15:16:48.052",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068606",
        "positionId": "56068606",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48.052",
        "brokerTime": "2025-05-14 15:16:48.502",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068608",
        "positionId": "56068606",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114259",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48.949",
        "brokerTime": "2025-05-14 15:16:48.949",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068609",
        "positionId": "56068609",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.75,
        "doubleCheck": true
    },
    {
        "id": "53114260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:48.949",
        "brokerTime": "2025-05-14 15:16:49.324",
        "commission": -88.27,
        "swap": 0,
        "profit": -517.01,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068610",
        "positionId": "56068609",
        "volume": 12.61,
        "price": 3211.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -605.28,
        "takeProfit": null,
        "priceIn": 3210.75,
        "doubleCheck": true
    },
    {
        "id": "53114261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:49.633",
        "brokerTime": "2025-05-14 15:16:49.633",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068611",
        "positionId": "56068611",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114262",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:49.633",
        "brokerTime": "2025-05-14 15:16:50.075",
        "commission": -88.27,
        "swap": 0,
        "profit": 37.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068612",
        "positionId": "56068611",
        "volume": 12.61,
        "price": 3210.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -50.44,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50.385",
        "brokerTime": "2025-05-14 15:16:50.385",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068613",
        "positionId": "56068613",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114265",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:50.385",
        "brokerTime": "2025-05-14 15:16:50.953",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068615",
        "positionId": "56068613",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -151.32,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114489",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:51.599",
        "brokerTime": "2025-05-14 15:16:51.599",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068841",
        "positionId": "56068841",
        "volume": 12.61,
        "price": 3210.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.33,
        "doubleCheck": true
    },
    {
        "id": "53114515",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:51.599",
        "brokerTime": "2025-05-14 15:16:52.136",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068848",
        "positionId": "56068841",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3210.33,
        "doubleCheck": true
    },
    {
        "id": "53114521",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:52.956",
        "brokerTime": "2025-05-14 15:16:52.956",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068849",
        "positionId": "56068849",
        "volume": 12.61,
        "price": 3210.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.42,
        "doubleCheck": true
    },
    {
        "id": "53114522",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:52.956",
        "brokerTime": "2025-05-14 15:16:53.504",
        "commission": -88.27,
        "swap": 0,
        "profit": -517.01,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068850",
        "positionId": "56068849",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -605.28,
        "takeProfit": null,
        "priceIn": 3210.42,
        "doubleCheck": true
    },
    {
        "id": "53114525",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:53.815",
        "brokerTime": "2025-05-14 15:16:53.815",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068852",
        "positionId": "56068852",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:53.815",
        "brokerTime": "2025-05-14 15:16:54.144",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068853",
        "positionId": "56068852",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -403.52,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114527",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:54.605",
        "brokerTime": "2025-05-14 15:16:54.605",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068854",
        "positionId": "56068854",
        "volume": 12.61,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53114528",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:54.605",
        "brokerTime": "2025-05-14 15:16:55.057",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068855",
        "positionId": "56068854",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53114529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55.373",
        "brokerTime": "2025-05-14 15:16:55.373",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068856",
        "positionId": "56068856",
        "volume": 12.61,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53114530",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:55.373",
        "brokerTime": "2025-05-14 15:16:55.771",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068857",
        "positionId": "56068856",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -453.96,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53114531",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:56.117",
        "brokerTime": "2025-05-14 15:16:56.117",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068858",
        "positionId": "56068858",
        "volume": 12.61,
        "price": 3210.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.34,
        "doubleCheck": true
    },
    {
        "id": "53114534",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:56.117",
        "brokerTime": "2025-05-14 15:16:56.872",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068860",
        "positionId": "56068858",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.34,
        "doubleCheck": true
    },
    {
        "id": "53114535",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:57.328",
        "brokerTime": "2025-05-14 15:16:57.328",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068861",
        "positionId": "56068861",
        "volume": 12.61,
        "price": 3210.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.39,
        "doubleCheck": true
    },
    {
        "id": "53114536",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:57.328",
        "brokerTime": "2025-05-14 15:16:57.819",
        "commission": -88.27,
        "swap": 0,
        "profit": -189.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068862",
        "positionId": "56068861",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -277.42,
        "takeProfit": null,
        "priceIn": 3210.39,
        "doubleCheck": true
    },
    {
        "id": "53114537",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:58.469",
        "brokerTime": "2025-05-14 15:16:58.469",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068863",
        "positionId": "56068863",
        "volume": 12.61,
        "price": 3210.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.43,
        "doubleCheck": true
    },
    {
        "id": "53114538",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:58.469",
        "brokerTime": "2025-05-14 15:16:59.107",
        "commission": -88.27,
        "swap": 0,
        "profit": -554.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068864",
        "positionId": "56068863",
        "volume": 12.61,
        "price": 3210.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -643.11,
        "takeProfit": null,
        "priceIn": 3210.43,
        "doubleCheck": true
    },
    {
        "id": "53114541",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:59.938",
        "brokerTime": "2025-05-14 15:16:59.938",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068866",
        "positionId": "56068866",
        "volume": 12.61,
        "price": 3210.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.68,
        "doubleCheck": true
    },
    {
        "id": "53114546",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:17:00.393",
        "brokerTime": "2025-05-14 15:17:00.393",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56068871",
        "positionId": "56068871",
        "volume": 0.25,
        "price": 2863.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 2863.53,
        "doubleCheck": true
    },
    {
        "id": "53114547",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:59.938",
        "brokerTime": "2025-05-14 15:17:00.395",
        "commission": -88.27,
        "swap": 0,
        "profit": -504.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068872",
        "positionId": "56068866",
        "volume": 12.61,
        "price": 3211.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -592.67,
        "takeProfit": null,
        "priceIn": 3210.68,
        "doubleCheck": true
    },
    {
        "id": "53114549",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01.213",
        "brokerTime": "2025-05-14 15:17:01.213",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068873",
        "positionId": "56068873",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "id": "53114550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01.214",
        "brokerTime": "2025-05-14 15:17:01.214",
        "commission": -7.63,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56068874",
        "positionId": "56068874",
        "volume": 1.09,
        "price": 2863.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.63,
        "takeProfit": null,
        "priceIn": 2863.2,
        "doubleCheck": true
    },
    {
        "id": "53114554",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01.213",
        "brokerTime": "2025-05-14 15:17:01.974",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068879",
        "positionId": "56068873",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3210.69,
        "doubleCheck": true
    },
    {
        "id": "53114556",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:02.547",
        "brokerTime": "2025-05-14 15:17:02.547",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068880",
        "positionId": "56068880",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114557",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:02.547",
        "brokerTime": "2025-05-14 15:17:02.883",
        "commission": -88.27,
        "swap": 0,
        "profit": -466.57,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068881",
        "positionId": "56068880",
        "volume": 12.61,
        "price": 3210.92,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -554.84,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114558",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03.304",
        "brokerTime": "2025-05-14 15:17:03.304",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068882",
        "positionId": "56068882",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:03.304",
        "brokerTime": "2025-05-14 15:17:03.804",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068883",
        "positionId": "56068882",
        "volume": 12.61,
        "price": 3211.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114560",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04.030",
        "brokerTime": "2025-05-14 15:17:04.030",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068884",
        "positionId": "56068884",
        "volume": 12.61,
        "price": 3211.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.01,
        "doubleCheck": true
    },
    {
        "id": "53114562",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04.030",
        "brokerTime": "2025-05-14 15:17:04.469",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068886",
        "positionId": "56068884",
        "volume": 12.61,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -504.4,
        "takeProfit": null,
        "priceIn": 3211.01,
        "doubleCheck": true
    },
    {
        "id": "53114563",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04.732",
        "brokerTime": "2025-05-14 15:17:04.732",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068887",
        "positionId": "56068887",
        "volume": 12.61,
        "price": 3211.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.14,
        "doubleCheck": true
    },
    {
        "id": "53114566",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:04.732",
        "brokerTime": "2025-05-14 15:17:05.382",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068890",
        "positionId": "56068887",
        "volume": 12.61,
        "price": 3211.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -441.34999999999997,
        "takeProfit": null,
        "priceIn": 3211.14,
        "doubleCheck": true
    },
    {
        "id": "53114567",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:05.746",
        "brokerTime": "2025-05-14 15:17:05.746",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068891",
        "positionId": "56068891",
        "volume": 12.61,
        "price": 3211.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.26,
        "doubleCheck": true
    },
    {
        "id": "53114568",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:05.746",
        "brokerTime": "2025-05-14 15:17:06.485",
        "commission": -88.27,
        "swap": 0,
        "profit": -100.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068892",
        "positionId": "56068891",
        "volume": 12.61,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189.14999999999998,
        "takeProfit": null,
        "priceIn": 3211.26,
        "doubleCheck": true
    },
    {
        "id": "53114569",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:06.815",
        "brokerTime": "2025-05-14 15:17:06.815",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068893",
        "positionId": "56068893",
        "volume": 12.61,
        "price": 3211.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "id": "53114570",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:06.815",
        "brokerTime": "2025-05-14 15:17:07.443",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068894",
        "positionId": "56068893",
        "volume": 12.61,
        "price": 3211.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -416.13,
        "takeProfit": null,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "id": "53114571",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:07.755",
        "brokerTime": "2025-05-14 15:17:07.755",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068895",
        "positionId": "56068895",
        "volume": 12.61,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53114572",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:07.755",
        "brokerTime": "2025-05-14 15:17:08.357",
        "commission": -88.27,
        "swap": 0,
        "profit": 189.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068896",
        "positionId": "56068895",
        "volume": 12.61,
        "price": 3211.09,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 100.88000000000001,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53114573",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:08.511",
        "brokerTime": "2025-05-14 15:17:08.511",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068897",
        "positionId": "56068897",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.84,
        "doubleCheck": true
    },
    {
        "id": "53114574",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:08.511",
        "brokerTime": "2025-05-14 15:17:08.976",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068898",
        "positionId": "56068897",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.03,
        "takeProfit": null,
        "priceIn": 3210.84,
        "doubleCheck": true
    },
    {
        "id": "53114575",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09.446",
        "brokerTime": "2025-05-14 15:17:09.446",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068899",
        "positionId": "56068899",
        "volume": 12.61,
        "price": 3210.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.89,
        "doubleCheck": true
    },
    {
        "id": "53114576",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:09.446",
        "brokerTime": "2025-05-14 15:17:09.860",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068900",
        "positionId": "56068899",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -504.4,
        "takeProfit": null,
        "priceIn": 3210.89,
        "doubleCheck": true
    },
    {
        "id": "53114577",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:10.106",
        "brokerTime": "2025-05-14 15:17:10.106",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068901",
        "positionId": "56068901",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.91,
        "doubleCheck": true
    },
    {
        "id": "53114578",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:10.106",
        "brokerTime": "2025-05-14 15:17:10.864",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068902",
        "positionId": "56068901",
        "volume": 12.61,
        "price": 3211.22,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3210.91,
        "doubleCheck": true
    },
    {
        "id": "53114579",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:11.595",
        "brokerTime": "2025-05-14 15:17:11.595",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068903",
        "positionId": "56068903",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114580",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:11.595",
        "brokerTime": "2025-05-14 15:17:12.051",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068904",
        "positionId": "56068903",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12.284",
        "brokerTime": "2025-05-14 15:17:12.284",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068906",
        "positionId": "56068906",
        "volume": 12.61,
        "price": 3210.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "id": "53114583",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:12.284",
        "brokerTime": "2025-05-14 15:17:12.668",
        "commission": -88.27,
        "swap": 0,
        "profit": -138.71,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068907",
        "positionId": "56068906",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -226.98000000000002,
        "takeProfit": null,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "id": "53114584",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:13.082",
        "brokerTime": "2025-05-14 15:17:13.082",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068908",
        "positionId": "56068908",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114585",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:13.082",
        "brokerTime": "2025-05-14 15:17:13.518",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068909",
        "positionId": "56068908",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114586",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:14.135",
        "brokerTime": "2025-05-14 15:17:14.135",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068910",
        "positionId": "56068910",
        "volume": 12.61,
        "price": 3210.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "id": "53114587",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:14.135",
        "brokerTime": "2025-05-14 15:17:14.848",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068911",
        "positionId": "56068910",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "id": "53114588",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:15.492",
        "brokerTime": "2025-05-14 15:17:15.492",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068912",
        "positionId": "56068912",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114589",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:15.492",
        "brokerTime": "2025-05-14 15:17:16.138",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068913",
        "positionId": "56068912",
        "volume": 12.61,
        "price": 3210.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.46999999999997,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114590",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:16.500",
        "brokerTime": "2025-05-14 15:17:16.500",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068914",
        "positionId": "56068914",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114591",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:16.500",
        "brokerTime": "2025-05-14 15:17:16.861",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068915",
        "positionId": "56068914",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114592",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17.194",
        "brokerTime": "2025-05-14 15:17:17.194",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068916",
        "positionId": "56068916",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "id": "53114593",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:17.194",
        "brokerTime": "2025-05-14 15:17:17.617",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068917",
        "positionId": "56068916",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -403.52,
        "takeProfit": null,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "id": "53114594",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18.164",
        "brokerTime": "2025-05-14 15:17:18.164",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068918",
        "positionId": "56068918",
        "volume": 12.61,
        "price": 3210.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114595",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18.164",
        "brokerTime": "2025-05-14 15:17:18.635",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068919",
        "positionId": "56068918",
        "volume": 12.61,
        "price": 3210.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3210.58,
        "doubleCheck": true
    },
    {
        "id": "53114597",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18.912",
        "brokerTime": "2025-05-14 15:17:18.912",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068921",
        "positionId": "56068921",
        "volume": 12.61,
        "price": 3210.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114598",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:18.912",
        "brokerTime": "2025-05-14 15:17:19.452",
        "commission": -88.27,
        "swap": 0,
        "profit": -163.93,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068922",
        "positionId": "56068921",
        "volume": 12.61,
        "price": 3210.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -252.2,
        "takeProfit": null,
        "priceIn": 3210.57,
        "doubleCheck": true
    },
    {
        "id": "53114599",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:19.748",
        "brokerTime": "2025-05-14 15:17:19.748",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068923",
        "positionId": "56068923",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114601",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:19.748",
        "brokerTime": "2025-05-14 15:17:20.293",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068925",
        "positionId": "56068923",
        "volume": 12.61,
        "price": 3210.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -201.76,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114602",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:20.598",
        "brokerTime": "2025-05-14 15:17:20.598",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068926",
        "positionId": "56068926",
        "volume": 12.61,
        "price": 3210.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "id": "53114603",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:20.598",
        "brokerTime": "2025-05-14 15:17:21.159",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068927",
        "positionId": "56068926",
        "volume": 12.61,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "id": "53114604",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21.388",
        "brokerTime": "2025-05-14 15:17:21.388",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068928",
        "positionId": "56068928",
        "volume": 12.61,
        "price": 3210.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "id": "53114605",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:21.388",
        "brokerTime": "2025-05-14 15:17:21.745",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068929",
        "positionId": "56068928",
        "volume": 12.61,
        "price": 3210.84,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.08,
        "takeProfit": null,
        "priceIn": 3210.63,
        "doubleCheck": true
    },
    {
        "id": "53114606",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22.072",
        "brokerTime": "2025-05-14 15:17:22.072",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068930",
        "positionId": "56068930",
        "volume": 12.61,
        "price": 3210.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "id": "53114607",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22.072",
        "brokerTime": "2025-05-14 15:17:22.524",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068931",
        "positionId": "56068930",
        "volume": 12.61,
        "price": 3211.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -403.52,
        "takeProfit": null,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "id": "53114608",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22.817",
        "brokerTime": "2025-05-14 15:17:22.817",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068932",
        "positionId": "56068932",
        "volume": 12.61,
        "price": 3210.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.78,
        "doubleCheck": true
    },
    {
        "id": "53114609",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:22.817",
        "brokerTime": "2025-05-14 15:17:23.335",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068933",
        "positionId": "56068932",
        "volume": 12.61,
        "price": 3210.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3210.78,
        "doubleCheck": true
    },
    {
        "id": "53114610",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:23.541",
        "brokerTime": "2025-05-14 15:17:23.541",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068934",
        "positionId": "56068934",
        "volume": 12.61,
        "price": 3210.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "id": "53114611",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:23.541",
        "brokerTime": "2025-05-14 15:17:24.180",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068935",
        "positionId": "56068934",
        "volume": 12.61,
        "price": 3211.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -453.96,
        "takeProfit": null,
        "priceIn": 3210.76,
        "doubleCheck": true
    },
    {
        "id": "53114612",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:24.567",
        "brokerTime": "2025-05-14 15:17:24.567",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068936",
        "positionId": "56068936",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "id": "53114613",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:24.567",
        "brokerTime": "2025-05-14 15:17:24.890",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068937",
        "positionId": "56068936",
        "volume": 12.61,
        "price": 3211.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.08,
        "takeProfit": null,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "id": "53114614",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25.128",
        "brokerTime": "2025-05-14 15:17:25.128",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068938",
        "positionId": "56068938",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "id": "53114615",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:25.128",
        "brokerTime": "2025-05-14 15:17:25.721",
        "commission": -88.27,
        "swap": 0,
        "profit": -100.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068939",
        "positionId": "56068938",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -189.14999999999998,
        "takeProfit": null,
        "priceIn": 3210.82,
        "doubleCheck": true
    },
    {
        "id": "53114616",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:26.018",
        "brokerTime": "2025-05-14 15:17:26.018",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068940",
        "positionId": "56068940",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "id": "53114617",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:26.018",
        "brokerTime": "2025-05-14 15:17:26.759",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068941",
        "positionId": "56068940",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -441.34999999999997,
        "takeProfit": null,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "id": "53114620",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:27.311",
        "brokerTime": "2025-05-14 15:17:27.311",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068944",
        "positionId": "56068944",
        "volume": 12.61,
        "price": 3210.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "id": "53114621",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:27.311",
        "brokerTime": "2025-05-14 15:17:27.844",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068945",
        "positionId": "56068944",
        "volume": 12.61,
        "price": 3210.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.03,
        "takeProfit": null,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "id": "53114622",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:28.284",
        "brokerTime": "2025-05-14 15:17:28.284",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068946",
        "positionId": "56068946",
        "volume": 12.61,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114623",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:28.284",
        "brokerTime": "2025-05-14 15:17:28.790",
        "commission": -88.27,
        "swap": 0,
        "profit": -37.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068947",
        "positionId": "56068946",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -126.1,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53114624",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:29.120",
        "brokerTime": "2025-05-14 15:17:29.120",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068948",
        "positionId": "56068948",
        "volume": 12.61,
        "price": 3210.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "id": "53114625",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:29.120",
        "brokerTime": "2025-05-14 15:17:29.573",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068949",
        "positionId": "56068948",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.46999999999997,
        "takeProfit": null,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "id": "53114626",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:30.430",
        "brokerTime": "2025-05-14 15:17:30.430",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068950",
        "positionId": "56068950",
        "volume": 12.61,
        "price": 3210.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "id": "53114627",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:30.430",
        "brokerTime": "2025-05-14 15:17:31.077",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068951",
        "positionId": "56068950",
        "volume": 12.61,
        "price": 3210.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "id": "53114628",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:31.422",
        "brokerTime": "2025-05-14 15:17:31.422",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068952",
        "positionId": "56068952",
        "volume": 12.61,
        "price": 3210.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.32,
        "doubleCheck": true
    },
    {
        "id": "53114629",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:31.422",
        "brokerTime": "2025-05-14 15:17:32.025",
        "commission": -88.27,
        "swap": 0,
        "profit": -416.13,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068953",
        "positionId": "56068952",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -504.4,
        "takeProfit": null,
        "priceIn": 3210.32,
        "doubleCheck": true
    },
    {
        "id": "53114630",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32.235",
        "brokerTime": "2025-05-14 15:17:32.235",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068954",
        "positionId": "56068954",
        "volume": 12.61,
        "price": 3210.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "id": "53114631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32.235",
        "brokerTime": "2025-05-14 15:17:32.691",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068955",
        "positionId": "56068954",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -201.76,
        "takeProfit": null,
        "priceIn": 3210.45,
        "doubleCheck": true
    },
    {
        "id": "53114632",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32.923",
        "brokerTime": "2025-05-14 15:17:32.923",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068956",
        "positionId": "56068956",
        "volume": 12.61,
        "price": 3210.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "id": "53114633",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:32.923",
        "brokerTime": "2025-05-14 15:17:33.260",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068957",
        "positionId": "56068956",
        "volume": 12.61,
        "price": 3210.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3210.36,
        "doubleCheck": true
    },
    {
        "id": "53114634",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:33.535",
        "brokerTime": "2025-05-14 15:17:33.535",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068958",
        "positionId": "56068958",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114635",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:33.535",
        "brokerTime": "2025-05-14 15:17:33.975",
        "commission": -88.27,
        "swap": 0,
        "profit": -264.81,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068959",
        "positionId": "56068958",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -353.08,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114636",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34.494",
        "brokerTime": "2025-05-14 15:17:34.494",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068960",
        "positionId": "56068960",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "id": "53114637",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:34.494",
        "brokerTime": "2025-05-14 15:17:34.912",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068961",
        "positionId": "56068960",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "id": "53114638",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:35.192",
        "brokerTime": "2025-05-14 15:17:35.192",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068962",
        "positionId": "56068962",
        "volume": 12.61,
        "price": 3211.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "id": "53114639",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:35.192",
        "brokerTime": "2025-05-14 15:17:35.464",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068963",
        "positionId": "56068962",
        "volume": 12.61,
        "price": 3211.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -327.86,
        "takeProfit": null,
        "priceIn": 3211.02,
        "doubleCheck": true
    },
    {
        "id": "53114640",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36.109",
        "brokerTime": "2025-05-14 15:17:36.109",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068964",
        "positionId": "56068964",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "id": "53114642",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36.109",
        "brokerTime": "2025-05-14 15:17:36.442",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068966",
        "positionId": "56068964",
        "volume": 12.61,
        "price": 3211.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -453.96,
        "takeProfit": null,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "id": "53114643",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36.760",
        "brokerTime": "2025-05-14 15:17:36.760",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068967",
        "positionId": "56068967",
        "volume": 12.61,
        "price": 3211,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "id": "53114644",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:36.760",
        "brokerTime": "2025-05-14 15:17:37.191",
        "commission": -88.27,
        "swap": 0,
        "profit": -378.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068968",
        "positionId": "56068967",
        "volume": 12.61,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -466.57,
        "takeProfit": null,
        "priceIn": 3211,
        "doubleCheck": true
    },
    {
        "id": "53114645",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:37.613",
        "brokerTime": "2025-05-14 15:17:37.613",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068969",
        "positionId": "56068969",
        "volume": 12.61,
        "price": 3211.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3211.07,
        "doubleCheck": true
    },
    {
        "id": "53114646",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:37.613",
        "brokerTime": "2025-05-14 15:17:38.300",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068970",
        "positionId": "56068969",
        "volume": 12.61,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3211.07,
        "doubleCheck": true
    },
    {
        "id": "53114647",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39.001",
        "brokerTime": "2025-05-14 15:17:39.001",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068971",
        "positionId": "56068971",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "id": "53114649",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39.001",
        "brokerTime": "2025-05-14 15:17:39.557",
        "commission": -88.27,
        "swap": 0,
        "profit": -365.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068973",
        "positionId": "56068971",
        "volume": 12.61,
        "price": 3211.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -453.96,
        "takeProfit": null,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "id": "53114650",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39.852",
        "brokerTime": "2025-05-14 15:17:39.852",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068974",
        "positionId": "56068974",
        "volume": 12.61,
        "price": 3210.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.95,
        "doubleCheck": true
    },
    {
        "id": "53114651",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:39.852",
        "brokerTime": "2025-05-14 15:17:40.338",
        "commission": -88.27,
        "swap": 0,
        "profit": 25.22,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068975",
        "positionId": "56068974",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -63.05,
        "takeProfit": null,
        "priceIn": 3210.95,
        "doubleCheck": true
    },
    {
        "id": "53114653",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:40.564",
        "brokerTime": "2025-05-14 15:17:40.564",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068977",
        "positionId": "56068977",
        "volume": 12.61,
        "price": 3210.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "id": "53114656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:40.564",
        "brokerTime": "2025-05-14 15:17:41.127",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068979",
        "positionId": "56068977",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.56,
        "doubleCheck": true
    },
    {
        "id": "53114657",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:41.623",
        "brokerTime": "2025-05-14 15:17:41.623",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068980",
        "positionId": "56068980",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114658",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:41.623",
        "brokerTime": "2025-05-14 15:17:42.094",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068981",
        "positionId": "56068980",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.46999999999997,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114663",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42.386",
        "brokerTime": "2025-05-14 15:17:42.386",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068986",
        "positionId": "56068986",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114665",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:42.386",
        "brokerTime": "2025-05-14 15:17:42.716",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068988",
        "positionId": "56068986",
        "volume": 12.61,
        "price": 3210.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114666",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43.048",
        "brokerTime": "2025-05-14 15:17:43.048",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068989",
        "positionId": "56068989",
        "volume": 12.61,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114667",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43.048",
        "brokerTime": "2025-05-14 15:17:43.628",
        "commission": -88.27,
        "swap": 0,
        "profit": -315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068990",
        "positionId": "56068989",
        "volume": 12.61,
        "price": 3210.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -403.52,
        "takeProfit": null,
        "priceIn": 3210.61,
        "doubleCheck": true
    },
    {
        "id": "53114668",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43.846",
        "brokerTime": "2025-05-14 15:17:43.846",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068991",
        "positionId": "56068991",
        "volume": 12.61,
        "price": 3210.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "id": "53114669",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:43.846",
        "brokerTime": "2025-05-14 15:17:44.562",
        "commission": -88.27,
        "swap": 0,
        "profit": -403.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068992",
        "positionId": "56068991",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -491.78999999999996,
        "takeProfit": null,
        "priceIn": 3210.65,
        "doubleCheck": true
    },
    {
        "id": "53114670",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:45.153",
        "brokerTime": "2025-05-14 15:17:45.153",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068993",
        "positionId": "56068993",
        "volume": 12.61,
        "price": 3210.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114671",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:45.153",
        "brokerTime": "2025-05-14 15:17:45.964",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068994",
        "positionId": "56068993",
        "volume": 12.61,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.54,
        "takeProfit": null,
        "priceIn": 3210.9,
        "doubleCheck": true
    },
    {
        "id": "53114672",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:46.318",
        "brokerTime": "2025-05-14 15:17:46.318",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068995",
        "positionId": "56068995",
        "volume": 12.61,
        "price": 3210.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.6,
        "doubleCheck": true
    },
    {
        "id": "53114673",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:46.318",
        "brokerTime": "2025-05-14 15:17:46.997",
        "commission": -88.27,
        "swap": 0,
        "profit": -390.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068996",
        "positionId": "56068995",
        "volume": 12.61,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -479.18,
        "takeProfit": null,
        "priceIn": 3210.6,
        "doubleCheck": true
    },
    {
        "id": "53114674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:47.289",
        "brokerTime": "2025-05-14 15:17:47.289",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068997",
        "positionId": "56068997",
        "volume": 12.61,
        "price": 3210.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "id": "53114675",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:47.289",
        "brokerTime": "2025-05-14 15:17:47.739",
        "commission": -88.27,
        "swap": 0,
        "profit": 50.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068998",
        "positionId": "56068997",
        "volume": 12.61,
        "price": 3210.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -37.83,
        "takeProfit": null,
        "priceIn": 3210.79,
        "doubleCheck": true
    },
    {
        "id": "53114676",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48.011",
        "brokerTime": "2025-05-14 15:17:48.011",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56068999",
        "positionId": "56068999",
        "volume": 12.61,
        "price": 3210.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.59,
        "doubleCheck": true
    },
    {
        "id": "53114677",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48.011",
        "brokerTime": "2025-05-14 15:17:48.416",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069000",
        "positionId": "56068999",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.59,
        "doubleCheck": true
    },
    {
        "id": "53114678",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48.874",
        "brokerTime": "2025-05-14 15:17:48.874",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069001",
        "positionId": "56069001",
        "volume": 12.61,
        "price": 3210.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.54,
        "doubleCheck": true
    },
    {
        "id": "53114684",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:48.874",
        "brokerTime": "2025-05-14 15:17:49.287",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069007",
        "positionId": "56069001",
        "volume": 12.61,
        "price": 3210.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -441.34999999999997,
        "takeProfit": null,
        "priceIn": 3210.54,
        "doubleCheck": true
    },
    {
        "id": "53114687",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:49.683",
        "brokerTime": "2025-05-14 15:17:49.683",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069009",
        "positionId": "56069009",
        "volume": 12.61,
        "price": 3210.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "id": "53114689",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:49.683",
        "brokerTime": "2025-05-14 15:17:49.987",
        "commission": -88.27,
        "swap": 0,
        "profit": -151.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069011",
        "positionId": "56069009",
        "volume": 12.61,
        "price": 3210.93,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.58999999999997,
        "takeProfit": null,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "id": "53114690",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50.242",
        "brokerTime": "2025-05-14 15:17:50.242",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069012",
        "positionId": "56069012",
        "volume": 12.61,
        "price": 3210.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "id": "53114691",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:50.242",
        "brokerTime": "2025-05-14 15:17:51.071",
        "commission": -88.27,
        "swap": 0,
        "profit": -592.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069013",
        "positionId": "56069012",
        "volume": 12.61,
        "price": 3211.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -680.9399999999999,
        "takeProfit": null,
        "priceIn": 3210.72,
        "doubleCheck": true
    },
    {
        "id": "53114692",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:51.672",
        "brokerTime": "2025-05-14 15:17:51.672",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069014",
        "positionId": "56069014",
        "volume": 12.61,
        "price": 3210.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.8,
        "doubleCheck": true
    },
    {
        "id": "53114693",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:51.672",
        "brokerTime": "2025-05-14 15:17:52.099",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069015",
        "positionId": "56069014",
        "volume": 12.61,
        "price": 3210.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -327.86,
        "takeProfit": null,
        "priceIn": 3210.8,
        "doubleCheck": true
    },
    {
        "id": "53114694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52.409",
        "brokerTime": "2025-05-14 15:17:52.409",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069016",
        "positionId": "56069016",
        "volume": 12.61,
        "price": 3210.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "id": "53114695",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52.409",
        "brokerTime": "2025-05-14 15:17:52.817",
        "commission": -88.27,
        "swap": 0,
        "profit": 151.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069049",
        "positionId": "56069016",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 63.05,
        "takeProfit": null,
        "priceIn": 3210.81,
        "doubleCheck": true
    },
    {
        "id": "53114728",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52.995",
        "brokerTime": "2025-05-14 15:17:52.995",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069050",
        "positionId": "56069050",
        "volume": 12.61,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "id": "53114729",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:52.995",
        "brokerTime": "2025-05-14 15:17:53.344",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069051",
        "positionId": "56069050",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -390.90999999999997,
        "takeProfit": null,
        "priceIn": 3210.47,
        "doubleCheck": true
    },
    {
        "id": "53114730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:53.558",
        "brokerTime": "2025-05-14 15:17:53.558",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069052",
        "positionId": "56069052",
        "volume": 12.61,
        "price": 3210.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114732",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:53.558",
        "brokerTime": "2025-05-14 15:17:53.929",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069054",
        "positionId": "56069052",
        "volume": 12.61,
        "price": 3210.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.03,
        "takeProfit": null,
        "priceIn": 3210.55,
        "doubleCheck": true
    },
    {
        "id": "53114733",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54.208",
        "brokerTime": "2025-05-14 15:17:54.208",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069055",
        "positionId": "56069055",
        "volume": 12.61,
        "price": 3210.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "id": "53114734",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:54.208",
        "brokerTime": "2025-05-14 15:17:54.653",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069056",
        "positionId": "56069055",
        "volume": 12.61,
        "price": 3210.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "id": "53114735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55.101",
        "brokerTime": "2025-05-14 15:17:55.101",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069057",
        "positionId": "56069057",
        "volume": 12.61,
        "price": 3210.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "id": "53114736",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55.101",
        "brokerTime": "2025-05-14 15:17:55.579",
        "commission": -88.27,
        "swap": 0,
        "profit": -50.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069058",
        "positionId": "56069057",
        "volume": 12.61,
        "price": 3210.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -138.70999999999998,
        "takeProfit": null,
        "priceIn": 3210.46,
        "doubleCheck": true
    },
    {
        "id": "53114737",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55.836",
        "brokerTime": "2025-05-14 15:17:55.836",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069059",
        "positionId": "56069059",
        "volume": 12.61,
        "price": 3210.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.28,
        "doubleCheck": true
    },
    {
        "id": "53114738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:55.836",
        "brokerTime": "2025-05-14 15:17:56.288",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069060",
        "positionId": "56069059",
        "volume": 12.61,
        "price": 3210.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -390.90999999999997,
        "takeProfit": null,
        "priceIn": 3210.28,
        "doubleCheck": true
    },
    {
        "id": "53114739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:56.545",
        "brokerTime": "2025-05-14 15:17:56.545",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069061",
        "positionId": "56069061",
        "volume": 12.61,
        "price": 3210.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.35,
        "doubleCheck": true
    },
    {
        "id": "53114740",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:56.545",
        "brokerTime": "2025-05-14 15:17:57.061",
        "commission": -88.27,
        "swap": 0,
        "profit": -201.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069062",
        "positionId": "56069061",
        "volume": 12.61,
        "price": 3210.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.03,
        "takeProfit": null,
        "priceIn": 3210.35,
        "doubleCheck": true
    },
    {
        "id": "53114744",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:57.888",
        "brokerTime": "2025-05-14 15:17:57.888",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069066",
        "positionId": "56069066",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.68,
        "doubleCheck": true
    },
    {
        "id": "53114747",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:57.888",
        "brokerTime": "2025-05-14 15:17:58.541",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069068",
        "positionId": "56069066",
        "volume": 12.61,
        "price": 3209.86,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3209.68,
        "doubleCheck": true
    },
    {
        "id": "53114749",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:58.679",
        "brokerTime": "2025-05-14 15:17:58.679",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069070",
        "positionId": "56069070",
        "volume": 12.61,
        "price": 3209.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "id": "53114837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:58.679",
        "brokerTime": "2025-05-14 15:17:59.857",
        "commission": -88.27,
        "swap": 0,
        "profit": -403.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069140",
        "positionId": "56069070",
        "volume": 12.61,
        "price": 3210.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -491.78999999999996,
        "takeProfit": null,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "id": "53114920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:00.608",
        "brokerTime": "2025-05-14 15:18:00.608",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069224",
        "positionId": "56069224",
        "volume": 12.61,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53114962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:00.608",
        "brokerTime": "2025-05-14 15:18:01.061",
        "commission": -88.27,
        "swap": 0,
        "profit": -378.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069257",
        "positionId": "56069224",
        "volume": 12.61,
        "price": 3209.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -466.57,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53115003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01.334",
        "brokerTime": "2025-05-14 15:18:01.334",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069299",
        "positionId": "56069299",
        "volume": 12.61,
        "price": 3209.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.59,
        "doubleCheck": true
    },
    {
        "id": "53115213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:01.334",
        "brokerTime": "2025-05-14 15:18:02.083",
        "commission": -88.27,
        "swap": 0,
        "profit": -151.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069529",
        "positionId": "56069299",
        "volume": 12.61,
        "price": 3209.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.58999999999997,
        "takeProfit": null,
        "priceIn": 3209.59,
        "doubleCheck": true
    },
    {
        "id": "53115533",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:02.588",
        "brokerTime": "2025-05-14 15:18:02.588",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069679",
        "positionId": "56069679",
        "volume": 12.61,
        "price": 3209.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.54,
        "doubleCheck": true
    },
    {
        "id": "53115656",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:02.588",
        "brokerTime": "2025-05-14 15:18:03.078",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069793",
        "positionId": "56069679",
        "volume": 12.61,
        "price": 3209.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -201.76,
        "takeProfit": null,
        "priceIn": 3209.54,
        "doubleCheck": true
    },
    {
        "id": "53115719",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:03.548",
        "brokerTime": "2025-05-14 15:18:03.548",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069836",
        "positionId": "56069836",
        "volume": 12.61,
        "price": 3209.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "id": "53115772",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:03.548",
        "brokerTime": "2025-05-14 15:18:04.154",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069888",
        "positionId": "56069836",
        "volume": 12.61,
        "price": 3209.58,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "id": "53115786",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04.435",
        "brokerTime": "2025-05-14 15:18:04.435",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069899",
        "positionId": "56069899",
        "volume": 12.61,
        "price": 3209.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.3,
        "doubleCheck": true
    },
    {
        "id": "53115836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:04.435",
        "brokerTime": "2025-05-14 15:18:04.986",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069952",
        "positionId": "56069899",
        "volume": 12.61,
        "price": 3209.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -327.86,
        "takeProfit": null,
        "priceIn": 3209.3,
        "doubleCheck": true
    },
    {
        "id": "53115852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05.138",
        "brokerTime": "2025-05-14 15:18:05.138",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069975",
        "positionId": "56069975",
        "volume": 12.61,
        "price": 3209.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.18,
        "doubleCheck": true
    },
    {
        "id": "53115883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05.138",
        "brokerTime": "2025-05-14 15:18:05.546",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56069994",
        "positionId": "56069975",
        "volume": 12.61,
        "price": 3209.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -529.62,
        "takeProfit": null,
        "priceIn": 3209.18,
        "doubleCheck": true
    },
    {
        "id": "53115890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05.685",
        "brokerTime": "2025-05-14 15:18:05.685",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070002",
        "positionId": "56070002",
        "volume": 12.61,
        "price": 3209.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "id": "53115939",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:05.685",
        "brokerTime": "2025-05-14 15:18:06.101",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070046",
        "positionId": "56070002",
        "volume": 12.61,
        "price": 3209.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -441.34999999999997,
        "takeProfit": null,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "id": "53115960",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06.484",
        "brokerTime": "2025-05-14 15:18:06.484",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070072",
        "positionId": "56070072",
        "volume": 12.61,
        "price": 3209.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.46,
        "doubleCheck": true
    },
    {
        "id": "53116033",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:06.484",
        "brokerTime": "2025-05-14 15:18:07.034",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070141",
        "positionId": "56070072",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3209.46,
        "doubleCheck": true
    },
    {
        "id": "53116049",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:07.286",
        "brokerTime": "2025-05-14 15:18:07.286",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070159",
        "positionId": "56070159",
        "volume": 12.61,
        "price": 3209.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.47,
        "doubleCheck": true
    },
    {
        "id": "53116082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:07.286",
        "brokerTime": "2025-05-14 15:18:07.762",
        "commission": -88.27,
        "swap": 0,
        "profit": -327.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070196",
        "positionId": "56070159",
        "volume": 12.61,
        "price": 3209.73,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -416.13,
        "takeProfit": null,
        "priceIn": 3209.47,
        "doubleCheck": true
    },
    {
        "id": "53116106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:08.301",
        "brokerTime": "2025-05-14 15:18:08.301",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070208",
        "positionId": "56070208",
        "volume": 12.61,
        "price": 3209.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.36,
        "doubleCheck": true
    },
    {
        "id": "53116131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:08.301",
        "brokerTime": "2025-05-14 15:18:08.770",
        "commission": -88.27,
        "swap": 0,
        "profit": -252.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070236",
        "positionId": "56070208",
        "volume": 12.61,
        "price": 3209.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -340.46999999999997,
        "takeProfit": null,
        "priceIn": 3209.36,
        "doubleCheck": true
    },
    {
        "id": "53116156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:09.272",
        "brokerTime": "2025-05-14 15:18:09.272",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070254",
        "positionId": "56070254",
        "volume": 12.61,
        "price": 3210,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210,
        "doubleCheck": true
    },
    {
        "id": "53116194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:09.272",
        "brokerTime": "2025-05-14 15:18:10.081",
        "commission": -88.27,
        "swap": 0,
        "profit": 214.37,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070292",
        "positionId": "56070254",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 126.10000000000001,
        "takeProfit": null,
        "priceIn": 3210,
        "doubleCheck": true
    },
    {
        "id": "53116208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:10.502",
        "brokerTime": "2025-05-14 15:18:10.502",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070309",
        "positionId": "56070309",
        "volume": 12.61,
        "price": 3209.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.75,
        "doubleCheck": true
    },
    {
        "id": "53116232",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:10.502",
        "brokerTime": "2025-05-14 15:18:10.977",
        "commission": -88.27,
        "swap": 0,
        "profit": -63.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070329",
        "positionId": "56070309",
        "volume": 12.61,
        "price": 3209.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -151.32,
        "takeProfit": null,
        "priceIn": 3209.75,
        "doubleCheck": true
    },
    {
        "id": "53116242",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11.275",
        "brokerTime": "2025-05-14 15:18:11.275",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070337",
        "positionId": "56070337",
        "volume": 12.61,
        "price": 3209.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.63,
        "doubleCheck": true
    },
    {
        "id": "53116261",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:11.275",
        "brokerTime": "2025-05-14 15:18:11.717",
        "commission": -88.27,
        "swap": 0,
        "profit": -353.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070356",
        "positionId": "56070337",
        "volume": 12.61,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -441.34999999999997,
        "takeProfit": null,
        "priceIn": 3209.63,
        "doubleCheck": true
    },
    {
        "id": "53116289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:12.123",
        "brokerTime": "2025-05-14 15:18:12.123",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070382",
        "positionId": "56070382",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "id": "53116312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:12.123",
        "brokerTime": "2025-05-14 15:18:12.663",
        "commission": -88.27,
        "swap": 0,
        "profit": 12.61,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070406",
        "positionId": "56070382",
        "volume": 12.61,
        "price": 3209.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -75.66,
        "takeProfit": null,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "id": "53116340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:13.072",
        "brokerTime": "2025-05-14 15:18:13.072",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070432",
        "positionId": "56070432",
        "volume": 12.61,
        "price": 3209.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "id": "53116352",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:13.072",
        "brokerTime": "2025-05-14 15:18:13.560",
        "commission": -88.27,
        "swap": 0,
        "profit": -340.47,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070443",
        "positionId": "56070432",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -428.74,
        "takeProfit": null,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "id": "53116382",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14.025",
        "brokerTime": "2025-05-14 15:18:14.025",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070471",
        "positionId": "56070471",
        "volume": 12.61,
        "price": 3209.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "id": "53116388",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14.025",
        "brokerTime": "2025-05-14 15:18:14.372",
        "commission": -88.27,
        "swap": 0,
        "profit": -113.49,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070475",
        "positionId": "56070471",
        "volume": 12.61,
        "price": 3209.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -201.76,
        "takeProfit": null,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "id": "53116413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14.994",
        "brokerTime": "2025-05-14 15:18:14.994",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070501",
        "positionId": "56070501",
        "volume": 12.61,
        "price": 3209.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "id": "53116431",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:14.994",
        "brokerTime": "2025-05-14 15:18:15.784",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070518",
        "positionId": "56070501",
        "volume": 12.61,
        "price": 3209.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -529.62,
        "takeProfit": null,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "id": "53116437",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16.070",
        "brokerTime": "2025-05-14 15:18:16.070",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070521",
        "positionId": "56070521",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116438",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16.070",
        "brokerTime": "2025-05-14 15:18:16.449",
        "commission": -88.27,
        "swap": 0,
        "profit": -290.03,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070523",
        "positionId": "56070521",
        "volume": 12.61,
        "price": 3209.62,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.29999999999995,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116440",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16.710",
        "brokerTime": "2025-05-14 15:18:16.710",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070524",
        "positionId": "56070524",
        "volume": 12.61,
        "price": 3209.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "id": "53116441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:16.710",
        "brokerTime": "2025-05-14 15:18:17.149",
        "commission": -88.27,
        "swap": 0,
        "profit": -441.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070525",
        "positionId": "56070524",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -529.62,
        "takeProfit": null,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "id": "53116443",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17.403",
        "brokerTime": "2025-05-14 15:18:17.403",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070527",
        "positionId": "56070527",
        "volume": 12.61,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53116445",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17.403",
        "brokerTime": "2025-05-14 15:18:17.782",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070529",
        "positionId": "56070527",
        "volume": 12.61,
        "price": 3209.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -390.90999999999997,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53116446",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17.965",
        "brokerTime": "2025-05-14 15:18:17.965",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070531",
        "positionId": "56070531",
        "volume": 12.61,
        "price": 3209.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "id": "53116449",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:17.965",
        "brokerTime": "2025-05-14 15:18:18.692",
        "commission": -88.27,
        "swap": 0,
        "profit": -176.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070533",
        "positionId": "56070531",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -264.81,
        "takeProfit": null,
        "priceIn": 3209.69,
        "doubleCheck": true
    },
    {
        "id": "53116451",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:19.276",
        "brokerTime": "2025-05-14 15:18:19.276",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070535",
        "positionId": "56070535",
        "volume": 12.61,
        "price": 3209.67,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.67,
        "doubleCheck": true
    },
    {
        "id": "53116458",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:19.276",
        "brokerTime": "2025-05-14 15:18:19.948",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070540",
        "positionId": "56070535",
        "volume": 12.61,
        "price": 3209.67,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.67,
        "doubleCheck": true
    },
    {
        "id": "53116459",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:20.296",
        "brokerTime": "2025-05-14 15:18:20.296",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070541",
        "positionId": "56070541",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116460",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:20.296",
        "brokerTime": "2025-05-14 15:18:20.884",
        "commission": -88.27,
        "swap": 0,
        "profit": -554.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070542",
        "positionId": "56070541",
        "volume": 12.61,
        "price": 3209.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -643.11,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116461",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21.071",
        "brokerTime": "2025-05-14 15:18:21.071",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070543",
        "positionId": "56070543",
        "volume": 12.61,
        "price": 3209.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "id": "53116462",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21.071",
        "brokerTime": "2025-05-14 15:18:21.468",
        "commission": -88.27,
        "swap": 0,
        "profit": -75.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070544",
        "positionId": "56070543",
        "volume": 12.61,
        "price": 3209.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -163.93,
        "takeProfit": null,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "id": "53116463",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21.982",
        "brokerTime": "2025-05-14 15:18:21.982",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070545",
        "positionId": "56070545",
        "volume": 12.61,
        "price": 3209.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "id": "53116464",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:21.982",
        "brokerTime": "2025-05-14 15:18:22.511",
        "commission": -88.27,
        "swap": 0,
        "profit": -302.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070546",
        "positionId": "56070545",
        "volume": 12.61,
        "price": 3209.68,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -390.90999999999997,
        "takeProfit": null,
        "priceIn": 3209.44,
        "doubleCheck": true
    },
    {
        "id": "53116465",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:22.742",
        "brokerTime": "2025-05-14 15:18:22.742",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070547",
        "positionId": "56070547",
        "volume": 12.61,
        "price": 3209.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "id": "53116467",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:22.742",
        "brokerTime": "2025-05-14 15:18:23.119",
        "commission": -88.27,
        "swap": 0,
        "profit": -88.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070549",
        "positionId": "56070547",
        "volume": 12.61,
        "price": 3209.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -176.54,
        "takeProfit": null,
        "priceIn": 3209.33,
        "doubleCheck": true
    },
    {
        "id": "53116477",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:23.837",
        "brokerTime": "2025-05-14 15:18:23.837",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070558",
        "positionId": "56070558",
        "volume": 12.61,
        "price": 3209.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "id": "53116484",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:23.837",
        "brokerTime": "2025-05-14 15:18:24.138",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070565",
        "positionId": "56070558",
        "volume": 12.61,
        "price": 3209.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -327.86,
        "takeProfit": null,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "id": "53116487",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:24.564",
        "brokerTime": "2025-05-14 15:18:24.564",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070567",
        "positionId": "56070567",
        "volume": 12.61,
        "price": 3209.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "id": "53116488",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:24.564",
        "brokerTime": "2025-05-14 15:18:25.114",
        "commission": -88.27,
        "swap": 0,
        "profit": -277.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070568",
        "positionId": "56070567",
        "volume": 12.61,
        "price": 3209.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -365.69,
        "takeProfit": null,
        "priceIn": 3209.31,
        "doubleCheck": true
    },
    {
        "id": "53116492",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25.465",
        "brokerTime": "2025-05-14 15:18:25.465",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070573",
        "positionId": "56070573",
        "volume": 12.61,
        "price": 3209.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116495",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:25.465",
        "brokerTime": "2025-05-14 15:18:25.873",
        "commission": -88.27,
        "swap": 0,
        "profit": -504.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070574",
        "positionId": "56070573",
        "volume": 12.61,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -592.67,
        "takeProfit": null,
        "priceIn": 3209.39,
        "doubleCheck": true
    },
    {
        "id": "53116496",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:26.673",
        "brokerTime": "2025-05-14 15:18:26.673",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070575",
        "positionId": "56070575",
        "volume": 12.61,
        "price": 3209.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.82,
        "doubleCheck": true
    },
    {
        "id": "53116497",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:26.673",
        "brokerTime": "2025-05-14 15:18:27.487",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070576",
        "positionId": "56070575",
        "volume": 12.61,
        "price": 3210,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3209.82,
        "doubleCheck": true
    },
    {
        "id": "53116499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28.034",
        "brokerTime": "2025-05-14 15:18:28.034",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070578",
        "positionId": "56070578",
        "volume": 12.61,
        "price": 3210.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3210.02,
        "doubleCheck": true
    },
    {
        "id": "53116501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28.034",
        "brokerTime": "2025-05-14 15:18:28.437",
        "commission": -88.27,
        "swap": 0,
        "profit": 88.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070580",
        "positionId": "56070578",
        "volume": 12.61,
        "price": 3209.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3210.02,
        "doubleCheck": true
    },
    {
        "id": "53116502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28.958",
        "brokerTime": "2025-05-14 15:18:28.958",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070581",
        "positionId": "56070581",
        "volume": 12.61,
        "price": 3209.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "id": "53116503",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:28.958",
        "brokerTime": "2025-05-14 15:18:29.377",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070582",
        "positionId": "56070581",
        "volume": 12.61,
        "price": 3209.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3209.52,
        "doubleCheck": true
    },
    {
        "id": "53116504",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:29.626",
        "brokerTime": "2025-05-14 15:18:29.626",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070583",
        "positionId": "56070583",
        "volume": 12.61,
        "price": 3209.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.42,
        "doubleCheck": true
    },
    {
        "id": "53116505",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:29.626",
        "brokerTime": "2025-05-14 15:18:30.224",
        "commission": -88.27,
        "swap": 0,
        "profit": 315.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070584",
        "positionId": "56070583",
        "volume": 12.61,
        "price": 3209.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 226.98000000000002,
        "takeProfit": null,
        "priceIn": 3209.42,
        "doubleCheck": true
    },
    {
        "id": "53116506",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:30.699",
        "brokerTime": "2025-05-14 15:18:30.699",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070585",
        "positionId": "56070585",
        "volume": 12.61,
        "price": 3209.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.21,
        "doubleCheck": true
    },
    {
        "id": "53116508",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:30.699",
        "brokerTime": "2025-05-14 15:18:31.388",
        "commission": -88.27,
        "swap": 0,
        "profit": -239.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070587",
        "positionId": "56070585",
        "volume": 12.61,
        "price": 3209.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -327.86,
        "takeProfit": null,
        "priceIn": 3209.21,
        "doubleCheck": true
    },
    {
        "id": "53116510",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:31.977",
        "brokerTime": "2025-05-14 15:18:31.977",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070589",
        "positionId": "56070589",
        "volume": 12.61,
        "price": 3209.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.12,
        "doubleCheck": true
    },
    {
        "id": "53116511",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:31.977",
        "brokerTime": "2025-05-14 15:18:32.389",
        "commission": -88.27,
        "swap": 0,
        "profit": -226.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070590",
        "positionId": "56070589",
        "volume": 12.61,
        "price": 3209.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -315.25,
        "takeProfit": null,
        "priceIn": 3209.12,
        "doubleCheck": true
    },
    {
        "id": "53116512",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:32.699",
        "brokerTime": "2025-05-14 15:18:32.699",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070591",
        "positionId": "56070591",
        "volume": 12.61,
        "price": 3209.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209.1,
        "doubleCheck": true
    },
    {
        "id": "53116513",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:32.699",
        "brokerTime": "2025-05-14 15:18:33.101",
        "commission": -88.27,
        "swap": 0,
        "profit": -189.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070592",
        "positionId": "56070591",
        "volume": 12.61,
        "price": 3209.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -277.42,
        "takeProfit": null,
        "priceIn": 3209.1,
        "doubleCheck": true
    },
    {
        "id": "53116514",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33.399",
        "brokerTime": "2025-05-14 15:18:33.399",
        "commission": -88.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070594",
        "positionId": "56070594",
        "volume": 12.61,
        "price": 3209,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -88.27,
        "takeProfit": null,
        "priceIn": 3209,
        "doubleCheck": true
    },
    {
        "id": "53116516",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:33.399",
        "brokerTime": "2025-05-14 15:18:33.834",
        "commission": -88.27,
        "swap": 0,
        "profit": 151.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070595",
        "positionId": "56070594",
        "volume": 12.61,
        "price": 3208.88,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 63.05,
        "takeProfit": null,
        "priceIn": 3209,
        "doubleCheck": true
    },
    {
        "id": "53116518",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:18:33.917",
        "brokerTime": "2025-05-14 15:18:33.917",
        "commission": -15.54,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070596",
        "positionId": "56070596",
        "volume": 2.22,
        "price": 3208.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.88,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.54,
        "priceIn": 3208.88,
        "doubleCheck": true
    },
    {
        "id": "53116526",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35.171",
        "brokerTime": "2025-05-14 15:18:35.171",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070604",
        "positionId": "56070604",
        "volume": 15.27,
        "price": 3209.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "id": "53116529",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35.171",
        "brokerTime": "2025-05-14 15:18:35.587",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070606",
        "positionId": "56070604",
        "volume": 15.27,
        "price": 3209.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -763.5,
        "takeProfit": null,
        "priceIn": 3209.05,
        "doubleCheck": true
    },
    {
        "id": "53116532",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35.781",
        "brokerTime": "2025-05-14 15:18:35.781",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070609",
        "positionId": "56070609",
        "volume": 15.27,
        "price": 3209.27,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "id": "53116784",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:35.781",
        "brokerTime": "2025-05-14 15:18:36.588",
        "commission": -106.89,
        "swap": 0,
        "profit": -167.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070840",
        "positionId": "56070609",
        "volume": 15.27,
        "price": 3209.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -274.86,
        "takeProfit": null,
        "priceIn": 3209.27,
        "doubleCheck": true
    },
    {
        "id": "53116785",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:37.057",
        "brokerTime": "2025-05-14 15:18:37.057",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070841",
        "positionId": "56070841",
        "volume": 15.27,
        "price": 3208.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3208.96,
        "doubleCheck": true
    },
    {
        "id": "53116801",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:37.057",
        "brokerTime": "2025-05-14 15:18:37.566",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070856",
        "positionId": "56070841",
        "volume": 15.27,
        "price": 3209.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3208.96,
        "doubleCheck": true
    },
    {
        "id": "53116810",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:38.451",
        "brokerTime": "2025-05-14 15:18:38.451",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070863",
        "positionId": "56070863",
        "volume": 15.27,
        "price": 3209.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.04,
        "doubleCheck": true
    },
    {
        "id": "53116811",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:38.451",
        "brokerTime": "2025-05-14 15:18:38.864",
        "commission": -106.89,
        "swap": 0,
        "profit": -519.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070864",
        "positionId": "56070863",
        "volume": 15.27,
        "price": 3209.38,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -626.0699999999999,
        "takeProfit": null,
        "priceIn": 3209.04,
        "doubleCheck": true
    },
    {
        "id": "53116812",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39.057",
        "brokerTime": "2025-05-14 15:18:39.057",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070865",
        "positionId": "56070865",
        "volume": 15.27,
        "price": 3209.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "id": "53116813",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39.057",
        "brokerTime": "2025-05-14 15:18:39.682",
        "commission": -106.89,
        "swap": 0,
        "profit": -1221.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070866",
        "positionId": "56070865",
        "volume": 15.27,
        "price": 3210.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1328.49,
        "takeProfit": null,
        "priceIn": 3209.22,
        "doubleCheck": true
    },
    {
        "id": "53116815",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39.970",
        "brokerTime": "2025-05-14 15:18:39.970",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070868",
        "positionId": "56070868",
        "volume": 15.27,
        "price": 3209.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.8,
        "doubleCheck": true
    },
    {
        "id": "53116816",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:39.970",
        "brokerTime": "2025-05-14 15:18:40.384",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070869",
        "positionId": "56070868",
        "volume": 15.27,
        "price": 3209.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -335.94,
        "takeProfit": null,
        "priceIn": 3209.8,
        "doubleCheck": true
    },
    {
        "id": "53116817",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:40.624",
        "brokerTime": "2025-05-14 15:18:40.624",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070870",
        "positionId": "56070870",
        "volume": 15.27,
        "price": 3209.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "id": "53116818",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:40.624",
        "brokerTime": "2025-05-14 15:18:41.241",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070871",
        "positionId": "56070870",
        "volume": 15.27,
        "price": 3209.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -488.64,
        "takeProfit": null,
        "priceIn": 3209.64,
        "doubleCheck": true
    },
    {
        "id": "53116819",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:41.594",
        "brokerTime": "2025-05-14 15:18:41.594",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070872",
        "positionId": "56070872",
        "volume": 15.27,
        "price": 3209.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.65,
        "doubleCheck": true
    },
    {
        "id": "53116820",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:41.594",
        "brokerTime": "2025-05-14 15:18:42.077",
        "commission": -106.89,
        "swap": 0,
        "profit": -167.97,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070874",
        "positionId": "56070872",
        "volume": 15.27,
        "price": 3209.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -274.86,
        "takeProfit": null,
        "priceIn": 3209.65,
        "doubleCheck": true
    },
    {
        "id": "53116822",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:42.609",
        "brokerTime": "2025-05-14 15:18:42.609",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070875",
        "positionId": "56070875",
        "volume": 15.27,
        "price": 3209.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53116823",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:42.609",
        "brokerTime": "2025-05-14 15:18:43.038",
        "commission": -106.89,
        "swap": 0,
        "profit": -198.51,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070876",
        "positionId": "56070875",
        "volume": 15.27,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -305.4,
        "takeProfit": null,
        "priceIn": 3209.66,
        "doubleCheck": true
    },
    {
        "id": "53116824",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:43.536",
        "brokerTime": "2025-05-14 15:18:43.536",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070877",
        "positionId": "56070877",
        "volume": 15.27,
        "price": 3209.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.61,
        "doubleCheck": true
    },
    {
        "id": "53116825",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:43.536",
        "brokerTime": "2025-05-14 15:18:44.486",
        "commission": -106.89,
        "swap": 0,
        "profit": -870.39,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070878",
        "positionId": "56070877",
        "volume": 15.27,
        "price": 3210.18,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -977.28,
        "takeProfit": null,
        "priceIn": 3209.61,
        "doubleCheck": true
    },
    {
        "id": "53116826",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:44.857",
        "brokerTime": "2025-05-14 15:18:44.857",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070879",
        "positionId": "56070879",
        "volume": 15.27,
        "price": 3209.92,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.92,
        "doubleCheck": true
    },
    {
        "id": "53116827",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:44.857",
        "brokerTime": "2025-05-14 15:18:45.245",
        "commission": -106.89,
        "swap": 0,
        "profit": -412.29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070882",
        "positionId": "56070879",
        "volume": 15.27,
        "price": 3210.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -519.1800000000001,
        "takeProfit": null,
        "priceIn": 3209.92,
        "doubleCheck": true
    },
    {
        "id": "53116829",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:45.580",
        "brokerTime": "2025-05-14 15:18:45.580",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070884",
        "positionId": "56070884",
        "volume": 15.27,
        "price": 3210.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.22,
        "doubleCheck": true
    },
    {
        "id": "53116830",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:45.580",
        "brokerTime": "2025-05-14 15:18:46.000",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070885",
        "positionId": "56070884",
        "volume": 15.27,
        "price": 3210.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3210.22,
        "doubleCheck": true
    },
    {
        "id": "53116831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46.407",
        "brokerTime": "2025-05-14 15:18:46.407",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070886",
        "positionId": "56070886",
        "volume": 15.27,
        "price": 3210.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.26,
        "doubleCheck": true
    },
    {
        "id": "53116832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:46.407",
        "brokerTime": "2025-05-14 15:18:46.689",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070887",
        "positionId": "56070886",
        "volume": 15.27,
        "price": 3210.47,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -427.56,
        "takeProfit": null,
        "priceIn": 3210.26,
        "doubleCheck": true
    },
    {
        "id": "53116834",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:47.604",
        "brokerTime": "2025-05-14 15:18:47.604",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070889",
        "positionId": "56070889",
        "volume": 15.27,
        "price": 3209.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "id": "53116835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:47.604",
        "brokerTime": "2025-05-14 15:18:48.070",
        "commission": -106.89,
        "swap": 0,
        "profit": -763.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070890",
        "positionId": "56070889",
        "volume": 15.27,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -870.39,
        "takeProfit": null,
        "priceIn": 3209.79,
        "doubleCheck": true
    },
    {
        "id": "53116836",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48.401",
        "brokerTime": "2025-05-14 15:18:48.401",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070891",
        "positionId": "56070891",
        "volume": 15.27,
        "price": 3210.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.16,
        "doubleCheck": true
    },
    {
        "id": "53116837",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:48.401",
        "brokerTime": "2025-05-14 15:18:49.169",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070892",
        "positionId": "56070891",
        "volume": 15.27,
        "price": 3210.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3210.16,
        "doubleCheck": true
    },
    {
        "id": "53116838",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:49.694",
        "brokerTime": "2025-05-14 15:18:49.694",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070893",
        "positionId": "56070893",
        "volume": 15.27,
        "price": 3210.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "id": "53116839",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:49.694",
        "brokerTime": "2025-05-14 15:18:50.071",
        "commission": -106.89,
        "swap": 0,
        "profit": 335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070894",
        "positionId": "56070893",
        "volume": 15.27,
        "price": 3210.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 229.05,
        "takeProfit": null,
        "priceIn": 3210.48,
        "doubleCheck": true
    },
    {
        "id": "53116840",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50.246",
        "brokerTime": "2025-05-14 15:18:50.246",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070895",
        "positionId": "56070895",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.11,
        "doubleCheck": true
    },
    {
        "id": "53116841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:50.246",
        "brokerTime": "2025-05-14 15:18:51.133",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070896",
        "positionId": "56070895",
        "volume": 15.27,
        "price": 3210.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -351.21,
        "takeProfit": null,
        "priceIn": 3210.11,
        "doubleCheck": true
    },
    {
        "id": "53116842",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51.374",
        "brokerTime": "2025-05-14 15:18:51.374",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070897",
        "positionId": "56070897",
        "volume": 15.27,
        "price": 3210.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.05,
        "doubleCheck": true
    },
    {
        "id": "53116843",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51.374",
        "brokerTime": "2025-05-14 15:18:51.764",
        "commission": -106.89,
        "swap": 0,
        "profit": -106.89,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070898",
        "positionId": "56070897",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.78,
        "takeProfit": null,
        "priceIn": 3210.05,
        "doubleCheck": true
    },
    {
        "id": "53116844",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51.901",
        "brokerTime": "2025-05-14 15:18:51.901",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070899",
        "positionId": "56070899",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116845",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:51.901",
        "brokerTime": "2025-05-14 15:18:53.052",
        "commission": -106.89,
        "swap": 0,
        "profit": -1068.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070900",
        "positionId": "56070899",
        "volume": 15.27,
        "price": 3210.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1175.7900000000002,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116846",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:53.293",
        "brokerTime": "2025-05-14 15:18:53.293",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070901",
        "positionId": "56070901",
        "volume": 15.27,
        "price": 3210.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.21,
        "doubleCheck": true
    },
    {
        "id": "53116847",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:53.293",
        "brokerTime": "2025-05-14 15:18:54.172",
        "commission": -106.89,
        "swap": 0,
        "profit": 152.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070902",
        "positionId": "56070901",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 45.80999999999999,
        "takeProfit": null,
        "priceIn": 3210.21,
        "doubleCheck": true
    },
    {
        "id": "53116848",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:54.460",
        "brokerTime": "2025-05-14 15:18:54.460",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070903",
        "positionId": "56070903",
        "volume": 15.27,
        "price": 3209.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.9,
        "doubleCheck": true
    },
    {
        "id": "53116849",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:54.460",
        "brokerTime": "2025-05-14 15:18:54.738",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070904",
        "positionId": "56070903",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3209.9,
        "doubleCheck": true
    },
    {
        "id": "53116850",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55.023",
        "brokerTime": "2025-05-14 15:18:55.023",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070905",
        "positionId": "56070905",
        "volume": 15.27,
        "price": 3209.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.81,
        "doubleCheck": true
    },
    {
        "id": "53116851",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55.023",
        "brokerTime": "2025-05-14 15:18:55.645",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070906",
        "positionId": "56070905",
        "volume": 15.27,
        "price": 3210.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3209.81,
        "doubleCheck": true
    },
    {
        "id": "53116852",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55.821",
        "brokerTime": "2025-05-14 15:18:55.821",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070907",
        "positionId": "56070907",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116853",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:55.821",
        "brokerTime": "2025-05-14 15:18:56.311",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070908",
        "positionId": "56070907",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116854",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:56.574",
        "brokerTime": "2025-05-14 15:18:56.574",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070909",
        "positionId": "56070909",
        "volume": 15.27,
        "price": 3209.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116855",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:56.574",
        "brokerTime": "2025-05-14 15:18:56.916",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070910",
        "positionId": "56070909",
        "volume": 15.27,
        "price": 3210.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3209.91,
        "doubleCheck": true
    },
    {
        "id": "53116856",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:57.659",
        "brokerTime": "2025-05-14 15:18:57.659",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070911",
        "positionId": "56070911",
        "volume": 15.27,
        "price": 3210.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.08,
        "doubleCheck": true
    },
    {
        "id": "53116857",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:57.659",
        "brokerTime": "2025-05-14 15:18:58.036",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070912",
        "positionId": "56070911",
        "volume": 15.27,
        "price": 3210.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -763.5,
        "takeProfit": null,
        "priceIn": 3210.08,
        "doubleCheck": true
    },
    {
        "id": "53116858",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:58.677",
        "brokerTime": "2025-05-14 15:18:58.677",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070913",
        "positionId": "56070913",
        "volume": 15.27,
        "price": 3210.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53116859",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:18:58.677",
        "brokerTime": "2025-05-14 15:18:59.855",
        "commission": -106.89,
        "swap": 0,
        "profit": 30.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070914",
        "positionId": "56070913",
        "volume": 15.27,
        "price": 3210.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -76.35,
        "takeProfit": null,
        "priceIn": 3210.29,
        "doubleCheck": true
    },
    {
        "id": "53116862",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:00.398",
        "brokerTime": "2025-05-14 15:19:00.398",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070917",
        "positionId": "56070917",
        "volume": 15.27,
        "price": 3210.12,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.12,
        "doubleCheck": true
    },
    {
        "id": "53116863",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:00.398",
        "brokerTime": "2025-05-14 15:19:01.178",
        "commission": -106.89,
        "swap": 0,
        "profit": -1084.17,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070919",
        "positionId": "56070917",
        "volume": 15.27,
        "price": 3210.83,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1191.0600000000002,
        "takeProfit": null,
        "priceIn": 3210.12,
        "doubleCheck": true
    },
    {
        "id": "53116864",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:01.368",
        "brokerTime": "2025-05-14 15:19:01.368",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070920",
        "positionId": "56070920",
        "volume": 15.27,
        "price": 3210.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "id": "53116865",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:01.368",
        "brokerTime": "2025-05-14 15:19:02.062",
        "commission": -106.89,
        "swap": 0,
        "profit": -702.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070921",
        "positionId": "56070920",
        "volume": 15.27,
        "price": 3211.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -809.31,
        "takeProfit": null,
        "priceIn": 3210.64,
        "doubleCheck": true
    },
    {
        "id": "53116866",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:02.698",
        "brokerTime": "2025-05-14 15:19:02.698",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070922",
        "positionId": "56070922",
        "volume": 15.27,
        "price": 3210.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53116867",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:02.698",
        "brokerTime": "2025-05-14 15:19:03.130",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070923",
        "positionId": "56070922",
        "volume": 15.27,
        "price": 3210.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -488.64,
        "takeProfit": null,
        "priceIn": 3210.66,
        "doubleCheck": true
    },
    {
        "id": "53116868",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03.390",
        "brokerTime": "2025-05-14 15:19:03.390",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070924",
        "positionId": "56070924",
        "volume": 15.27,
        "price": 3211.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.06,
        "doubleCheck": true
    },
    {
        "id": "53116870",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:03.390",
        "brokerTime": "2025-05-14 15:19:03.868",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070926",
        "positionId": "56070924",
        "volume": 15.27,
        "price": 3211.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.06,
        "doubleCheck": true
    },
    {
        "id": "53116871",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04.035",
        "brokerTime": "2025-05-14 15:19:04.035",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070927",
        "positionId": "56070927",
        "volume": 15.27,
        "price": 3210.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "id": "53116872",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04.035",
        "brokerTime": "2025-05-14 15:19:04.382",
        "commission": -106.89,
        "swap": 0,
        "profit": -717.69,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070928",
        "positionId": "56070927",
        "volume": 15.27,
        "price": 3211.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -824.58,
        "takeProfit": null,
        "priceIn": 3210.97,
        "doubleCheck": true
    },
    {
        "id": "53116874",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04.673",
        "brokerTime": "2025-05-14 15:19:04.673",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070930",
        "positionId": "56070930",
        "volume": 15.27,
        "price": 3211.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.3,
        "doubleCheck": true
    },
    {
        "id": "53116875",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:04.673",
        "brokerTime": "2025-05-14 15:19:05.058",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070931",
        "positionId": "56070930",
        "volume": 15.27,
        "price": 3211.54,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3211.3,
        "doubleCheck": true
    },
    {
        "id": "53116876",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05.335",
        "brokerTime": "2025-05-14 15:19:05.335",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070932",
        "positionId": "56070932",
        "volume": 15.27,
        "price": 3211.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.34,
        "doubleCheck": true
    },
    {
        "id": "53116879",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:05.335",
        "brokerTime": "2025-05-14 15:19:06.021",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070935",
        "positionId": "56070932",
        "volume": 15.27,
        "price": 3211.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.05,
        "takeProfit": null,
        "priceIn": 3211.34,
        "doubleCheck": true
    },
    {
        "id": "53116880",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:06.354",
        "brokerTime": "2025-05-14 15:19:06.354",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070936",
        "positionId": "56070936",
        "volume": 15.27,
        "price": 3211.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "id": "53116881",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:06.354",
        "brokerTime": "2025-05-14 15:19:06.715",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070937",
        "positionId": "56070936",
        "volume": 15.27,
        "price": 3211.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3211.17,
        "doubleCheck": true
    },
    {
        "id": "53116882",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:07.382",
        "brokerTime": "2025-05-14 15:19:07.382",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070938",
        "positionId": "56070938",
        "volume": 15.27,
        "price": 3211.24,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53116883",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:07.382",
        "brokerTime": "2025-05-14 15:19:07.883",
        "commission": -106.89,
        "swap": 0,
        "profit": -641.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070939",
        "positionId": "56070938",
        "volume": 15.27,
        "price": 3211.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -748.23,
        "takeProfit": null,
        "priceIn": 3211.24,
        "doubleCheck": true
    },
    {
        "id": "53116884",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08.027",
        "brokerTime": "2025-05-14 15:19:08.027",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070940",
        "positionId": "56070940",
        "volume": 15.27,
        "price": 3211.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "id": "53116885",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08.027",
        "brokerTime": "2025-05-14 15:19:08.439",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070941",
        "positionId": "56070940",
        "volume": 15.27,
        "price": 3211.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "id": "53116886",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08.626",
        "brokerTime": "2025-05-14 15:19:08.626",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070942",
        "positionId": "56070942",
        "volume": 15.27,
        "price": 3211.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "id": "53116887",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:08.626",
        "brokerTime": "2025-05-14 15:19:09.009",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070943",
        "positionId": "56070942",
        "volume": 15.27,
        "price": 3211.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -763.5,
        "takeProfit": null,
        "priceIn": 3211.55,
        "doubleCheck": true
    },
    {
        "id": "53116888",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09.251",
        "brokerTime": "2025-05-14 15:19:09.251",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070944",
        "positionId": "56070944",
        "volume": 15.27,
        "price": 3211.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.68,
        "doubleCheck": true
    },
    {
        "id": "53116889",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:09.251",
        "brokerTime": "2025-05-14 15:19:09.894",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070945",
        "positionId": "56070944",
        "volume": 15.27,
        "price": 3211.91,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.09999999999997,
        "takeProfit": null,
        "priceIn": 3211.68,
        "doubleCheck": true
    },
    {
        "id": "53116890",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:10.417",
        "brokerTime": "2025-05-14 15:19:10.417",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070946",
        "positionId": "56070946",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53116891",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:10.417",
        "brokerTime": "2025-05-14 15:19:10.822",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070947",
        "positionId": "56070946",
        "volume": 15.27,
        "price": 3211.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.13,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53116892",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11.171",
        "brokerTime": "2025-05-14 15:19:11.171",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070948",
        "positionId": "56070948",
        "volume": 15.27,
        "price": 3211.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53116893",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11.171",
        "brokerTime": "2025-05-14 15:19:11.474",
        "commission": -106.89,
        "swap": 0,
        "profit": -290.13,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070949",
        "positionId": "56070948",
        "volume": 15.27,
        "price": 3212.01,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -397.02,
        "takeProfit": null,
        "priceIn": 3211.82,
        "doubleCheck": true
    },
    {
        "id": "53116895",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11.911",
        "brokerTime": "2025-05-14 15:19:11.911",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070951",
        "positionId": "56070951",
        "volume": 15.27,
        "price": 3211.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "id": "53116897",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:11.911",
        "brokerTime": "2025-05-14 15:19:12.470",
        "commission": -106.89,
        "swap": 0,
        "profit": -473.37,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070952",
        "positionId": "56070951",
        "volume": 15.27,
        "price": 3212.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -580.26,
        "takeProfit": null,
        "priceIn": 3211.8,
        "doubleCheck": true
    },
    {
        "id": "53116898",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:12.871",
        "brokerTime": "2025-05-14 15:19:12.871",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070953",
        "positionId": "56070953",
        "volume": 15.27,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.1,
        "doubleCheck": true
    },
    {
        "id": "53116899",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:12.871",
        "brokerTime": "2025-05-14 15:19:13.650",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070954",
        "positionId": "56070953",
        "volume": 15.27,
        "price": 3212.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3212.1,
        "doubleCheck": true
    },
    {
        "id": "53116900",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14.093",
        "brokerTime": "2025-05-14 15:19:14.093",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070955",
        "positionId": "56070955",
        "volume": 15.27,
        "price": 3212.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "id": "53116901",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14.093",
        "brokerTime": "2025-05-14 15:19:14.387",
        "commission": -106.89,
        "swap": 0,
        "profit": -412.29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070956",
        "positionId": "56070955",
        "volume": 15.27,
        "price": 3212.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -519.1800000000001,
        "takeProfit": null,
        "priceIn": 3212.13,
        "doubleCheck": true
    },
    {
        "id": "53116902",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14.660",
        "brokerTime": "2025-05-14 15:19:14.660",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070957",
        "positionId": "56070957",
        "volume": 15.27,
        "price": 3212.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.23,
        "doubleCheck": true
    },
    {
        "id": "53116903",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:14.660",
        "brokerTime": "2025-05-14 15:19:15.213",
        "commission": -106.89,
        "swap": 0,
        "profit": -442.83,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070958",
        "positionId": "56070957",
        "volume": 15.27,
        "price": 3212.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -549.72,
        "takeProfit": null,
        "priceIn": 3212.23,
        "doubleCheck": true
    },
    {
        "id": "53116916",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:15.780",
        "brokerTime": "2025-05-14 15:19:15.780",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070970",
        "positionId": "56070970",
        "volume": 15.27,
        "price": 3213.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "id": "53116919",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:15.780",
        "brokerTime": "2025-05-14 15:19:16.479",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070974",
        "positionId": "56070970",
        "volume": 15.27,
        "price": 3213.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.13,
        "takeProfit": null,
        "priceIn": 3213.36,
        "doubleCheck": true
    },
    {
        "id": "53116923",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:16.769",
        "brokerTime": "2025-05-14 15:19:16.769",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070977",
        "positionId": "56070977",
        "volume": 0.12,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3113.25,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "id": "53116924",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17.338",
        "brokerTime": "2025-05-14 15:19:17.338",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070978",
        "positionId": "56070978",
        "volume": 15.15,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.64,
        "doubleCheck": true
    },
    {
        "id": "53116926",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:17.338",
        "brokerTime": "2025-05-14 15:19:18.386",
        "commission": -106.05,
        "swap": 0,
        "profit": -1105.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070980",
        "positionId": "56070978",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1212,
        "takeProfit": null,
        "priceIn": 3213.64,
        "doubleCheck": true
    },
    {
        "id": "53116927",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:18.702",
        "brokerTime": "2025-05-14 15:19:18.702",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070981",
        "positionId": "56070981",
        "volume": 15.15,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.2,
        "doubleCheck": true
    },
    {
        "id": "53116928",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:18.702",
        "brokerTime": "2025-05-14 15:19:19.423",
        "commission": -106.05,
        "swap": 0,
        "profit": -318.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070983",
        "positionId": "56070981",
        "volume": 15.15,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -424.2,
        "takeProfit": null,
        "priceIn": 3214.2,
        "doubleCheck": true
    },
    {
        "id": "53116929",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:19.561",
        "brokerTime": "2025-05-14 15:19:19.561",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56070984",
        "positionId": "56070984",
        "volume": 15.15,
        "price": 3214.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "id": "53116951",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:19.561",
        "brokerTime": "2025-05-14 15:19:20.345",
        "commission": -106.05,
        "swap": 0,
        "profit": -1363.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071001",
        "positionId": "56070984",
        "volume": 15.15,
        "price": 3215.11,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1469.55,
        "takeProfit": null,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "id": "53116954",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:20.969",
        "brokerTime": "2025-05-14 15:19:20.969",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071004",
        "positionId": "56071004",
        "volume": 15.15,
        "price": 3214.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53116956",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:20.969",
        "brokerTime": "2025-05-14 15:19:21.329",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071006",
        "positionId": "56071004",
        "volume": 15.15,
        "price": 3215.16,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -454.5,
        "takeProfit": null,
        "priceIn": 3214.93,
        "doubleCheck": true
    },
    {
        "id": "53116957",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:21.628",
        "brokerTime": "2025-05-14 15:19:21.628",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071007",
        "positionId": "56071007",
        "volume": 15.15,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "id": "53116958",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:21.628",
        "brokerTime": "2025-05-14 15:19:22.424",
        "commission": -106.05,
        "swap": 0,
        "profit": -272.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071008",
        "positionId": "56071007",
        "volume": 15.15,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.75,
        "takeProfit": null,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "id": "53116959",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:22.725",
        "brokerTime": "2025-05-14 15:19:22.725",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071010",
        "positionId": "56071010",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "id": "53116961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:22.725",
        "brokerTime": "2025-05-14 15:19:23.618",
        "commission": -106.05,
        "swap": 0,
        "profit": -439.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071011",
        "positionId": "56071010",
        "volume": 15.15,
        "price": 3215.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -545.4,
        "takeProfit": null,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "id": "53116962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:24.181",
        "brokerTime": "2025-05-14 15:19:24.181",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071012",
        "positionId": "56071012",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53116963",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:24.181",
        "brokerTime": "2025-05-14 15:19:24.575",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071013",
        "positionId": "56071012",
        "volume": 15.15,
        "price": 3215.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -409.05,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53116964",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25.164",
        "brokerTime": "2025-05-14 15:19:25.164",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071014",
        "positionId": "56071014",
        "volume": 15.15,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.13,
        "doubleCheck": true
    },
    {
        "id": "53116966",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25.164",
        "brokerTime": "2025-05-14 15:19:25.776",
        "commission": -106.05,
        "swap": 0,
        "profit": 121.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071016",
        "positionId": "56071014",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 15.150000000000006,
        "takeProfit": null,
        "priceIn": 3215.13,
        "doubleCheck": true
    },
    {
        "id": "53116967",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25.881",
        "brokerTime": "2025-05-14 15:19:25.881",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071017",
        "positionId": "56071017",
        "volume": 15.15,
        "price": 3214.68,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53116968",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:25.881",
        "brokerTime": "2025-05-14 15:19:26.445",
        "commission": -106.05,
        "swap": 0,
        "profit": -106.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071018",
        "positionId": "56071017",
        "volume": 15.15,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -212.1,
        "takeProfit": null,
        "priceIn": 3214.68,
        "doubleCheck": true
    },
    {
        "id": "53116969",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:26.887",
        "brokerTime": "2025-05-14 15:19:26.887",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071019",
        "positionId": "56071019",
        "volume": 15.15,
        "price": 3214.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.75,
        "doubleCheck": true
    },
    {
        "id": "53116970",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:26.887",
        "brokerTime": "2025-05-14 15:19:27.374",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071020",
        "positionId": "56071019",
        "volume": 15.15,
        "price": 3215.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -636.3,
        "takeProfit": null,
        "priceIn": 3214.75,
        "doubleCheck": true
    },
    {
        "id": "53116971",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:27.620",
        "brokerTime": "2025-05-14 15:19:27.620",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071021",
        "positionId": "56071021",
        "volume": 15.15,
        "price": 3214.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "id": "53116972",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:27.620",
        "brokerTime": "2025-05-14 15:19:28.202",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071022",
        "positionId": "56071021",
        "volume": 15.15,
        "price": 3215.13,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -636.3,
        "takeProfit": null,
        "priceIn": 3214.78,
        "doubleCheck": true
    },
    {
        "id": "53116973",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:28.629",
        "brokerTime": "2025-05-14 15:19:28.629",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071023",
        "positionId": "56071023",
        "volume": 15.15,
        "price": 3214.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "id": "53116974",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:28.629",
        "brokerTime": "2025-05-14 15:19:29.288",
        "commission": -106.05,
        "swap": 0,
        "profit": -575.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071024",
        "positionId": "56071023",
        "volume": 15.15,
        "price": 3215.21,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -681.75,
        "takeProfit": null,
        "priceIn": 3214.83,
        "doubleCheck": true
    },
    {
        "id": "53116975",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:29.833",
        "brokerTime": "2025-05-14 15:19:29.833",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071025",
        "positionId": "56071025",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "id": "53116976",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:29.833",
        "brokerTime": "2025-05-14 15:19:30.281",
        "commission": -106.05,
        "swap": 0,
        "profit": 257.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071026",
        "positionId": "56071025",
        "volume": 15.15,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 151.5,
        "takeProfit": null,
        "priceIn": 3215.19,
        "doubleCheck": true
    },
    {
        "id": "53116977",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:30.756",
        "brokerTime": "2025-05-14 15:19:30.756",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071027",
        "positionId": "56071027",
        "volume": 15.15,
        "price": 3214.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53116982",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:30.756",
        "brokerTime": "2025-05-14 15:19:31.488",
        "commission": -106.05,
        "swap": 0,
        "profit": -515.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071030",
        "positionId": "56071027",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -621.15,
        "takeProfit": null,
        "priceIn": 3214.81,
        "doubleCheck": true
    },
    {
        "id": "53116983",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32.152",
        "brokerTime": "2025-05-14 15:19:32.152",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071031",
        "positionId": "56071031",
        "volume": 15.15,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "id": "53116985",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32.152",
        "brokerTime": "2025-05-14 15:19:32.702",
        "commission": -106.05,
        "swap": 0,
        "profit": -287.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071033",
        "positionId": "56071031",
        "volume": 15.15,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -393.90000000000003,
        "takeProfit": null,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "id": "53116987",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32.971",
        "brokerTime": "2025-05-14 15:19:32.971",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071035",
        "positionId": "56071035",
        "volume": 15.15,
        "price": 3214.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53116988",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:32.971",
        "brokerTime": "2025-05-14 15:19:33.492",
        "commission": -106.05,
        "swap": 0,
        "profit": -363.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071036",
        "positionId": "56071035",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -469.65000000000003,
        "takeProfit": null,
        "priceIn": 3214.15,
        "doubleCheck": true
    },
    {
        "id": "53116989",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34.047",
        "brokerTime": "2025-05-14 15:19:34.047",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071037",
        "positionId": "56071037",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "id": "53116990",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34.047",
        "brokerTime": "2025-05-14 15:19:34.429",
        "commission": -106.05,
        "swap": 0,
        "profit": 75.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071038",
        "positionId": "56071037",
        "volume": 15.15,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.299999999999997,
        "takeProfit": null,
        "priceIn": 3214.37,
        "doubleCheck": true
    },
    {
        "id": "53116991",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34.700",
        "brokerTime": "2025-05-14 15:19:34.700",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071039",
        "positionId": "56071039",
        "volume": 15.15,
        "price": 3214.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.19,
        "doubleCheck": true
    },
    {
        "id": "53116992",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:34.700",
        "brokerTime": "2025-05-14 15:19:35.006",
        "commission": -106.05,
        "swap": 0,
        "profit": -272.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071040",
        "positionId": "56071039",
        "volume": 15.15,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -378.75,
        "takeProfit": null,
        "priceIn": 3214.19,
        "doubleCheck": true
    },
    {
        "id": "53116993",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35.368",
        "brokerTime": "2025-05-14 15:19:35.368",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071041",
        "positionId": "56071041",
        "volume": 15.15,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "id": "53116994",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:35.368",
        "brokerTime": "2025-05-14 15:19:36.003",
        "commission": -106.05,
        "swap": 0,
        "profit": -575.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071042",
        "positionId": "56071041",
        "volume": 15.15,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -681.75,
        "takeProfit": null,
        "priceIn": 3214.23,
        "doubleCheck": true
    },
    {
        "id": "53116995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:36.475",
        "brokerTime": "2025-05-14 15:19:36.475",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071043",
        "positionId": "56071043",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53116996",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:36.475",
        "brokerTime": "2025-05-14 15:19:36.873",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071044",
        "positionId": "56071043",
        "volume": 15.15,
        "price": 3214.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -636.3,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53116997",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37.065",
        "brokerTime": "2025-05-14 15:19:37.065",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071045",
        "positionId": "56071045",
        "volume": 15.15,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53116998",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37.065",
        "brokerTime": "2025-05-14 15:19:37.433",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071046",
        "positionId": "56071045",
        "volume": 15.15,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -712.05,
        "takeProfit": null,
        "priceIn": 3214.3,
        "doubleCheck": true
    },
    {
        "id": "53116999",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37.694",
        "brokerTime": "2025-05-14 15:19:37.694",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071047",
        "positionId": "56071047",
        "volume": 15.15,
        "price": 3214.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "id": "53117000",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:37.694",
        "brokerTime": "2025-05-14 15:19:38.253",
        "commission": -106.05,
        "swap": 0,
        "profit": -227.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071048",
        "positionId": "56071047",
        "volume": 15.15,
        "price": 3214.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -333.3,
        "takeProfit": null,
        "priceIn": 3214.45,
        "doubleCheck": true
    },
    {
        "id": "53117001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:38.514",
        "brokerTime": "2025-05-14 15:19:38.514",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071049",
        "positionId": "56071049",
        "volume": 15.15,
        "price": 3214.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53117002",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:38.514",
        "brokerTime": "2025-05-14 15:19:38.961",
        "commission": -106.05,
        "swap": 0,
        "profit": -181.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071050",
        "positionId": "56071049",
        "volume": 15.15,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -287.85,
        "takeProfit": null,
        "priceIn": 3214.39,
        "doubleCheck": true
    },
    {
        "id": "53117003",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39.318",
        "brokerTime": "2025-05-14 15:19:39.318",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071051",
        "positionId": "56071051",
        "volume": 15.15,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53117004",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39.318",
        "brokerTime": "2025-05-14 15:19:39.703",
        "commission": -106.05,
        "swap": 0,
        "profit": -166.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071052",
        "positionId": "56071051",
        "volume": 15.15,
        "price": 3214.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -272.7,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53117005",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39.857",
        "brokerTime": "2025-05-14 15:19:39.857",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071053",
        "positionId": "56071053",
        "volume": 15.15,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "id": "53117007",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:39.857",
        "brokerTime": "2025-05-14 15:19:40.304",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071055",
        "positionId": "56071053",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -712.05,
        "takeProfit": null,
        "priceIn": 3214.25,
        "doubleCheck": true
    },
    {
        "id": "53117008",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:40.576",
        "brokerTime": "2025-05-14 15:19:40.576",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071056",
        "positionId": "56071056",
        "volume": 15.15,
        "price": 3214.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.42,
        "doubleCheck": true
    },
    {
        "id": "53117012",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:40.576",
        "brokerTime": "2025-05-14 15:19:40.851",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071061",
        "positionId": "56071056",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -454.5,
        "takeProfit": null,
        "priceIn": 3214.42,
        "doubleCheck": true
    },
    {
        "id": "53117014",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41.280",
        "brokerTime": "2025-05-14 15:19:41.280",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071062",
        "positionId": "56071062",
        "volume": 15.15,
        "price": 3214.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "id": "53117015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:41.280",
        "brokerTime": "2025-05-14 15:19:41.753",
        "commission": -106.05,
        "swap": 0,
        "profit": -318.15,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071063",
        "positionId": "56071062",
        "volume": 15.15,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -424.2,
        "takeProfit": null,
        "priceIn": 3214.61,
        "doubleCheck": true
    },
    {
        "id": "53117016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:42.255",
        "brokerTime": "2025-05-14 15:19:42.255",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071064",
        "positionId": "56071064",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.65,
        "doubleCheck": true
    },
    {
        "id": "53117017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:42.255",
        "brokerTime": "2025-05-14 15:19:42.723",
        "commission": -106.05,
        "swap": 0,
        "profit": -469.65,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071065",
        "positionId": "56071064",
        "volume": 15.15,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -575.6999999999999,
        "takeProfit": null,
        "priceIn": 3214.65,
        "doubleCheck": true
    },
    {
        "id": "53117018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43.115",
        "brokerTime": "2025-05-14 15:19:43.115",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071066",
        "positionId": "56071066",
        "volume": 15.15,
        "price": 3214.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53117019",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43.115",
        "brokerTime": "2025-05-14 15:19:43.430",
        "commission": -106.05,
        "swap": 0,
        "profit": -348.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071067",
        "positionId": "56071066",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -454.5,
        "takeProfit": null,
        "priceIn": 3214.82,
        "doubleCheck": true
    },
    {
        "id": "53117020",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43.750",
        "brokerTime": "2025-05-14 15:19:43.750",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071068",
        "positionId": "56071068",
        "volume": 15.15,
        "price": 3214.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "id": "53117021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:43.750",
        "brokerTime": "2025-05-14 15:19:44.580",
        "commission": -106.05,
        "swap": 0,
        "profit": -606,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071069",
        "positionId": "56071068",
        "volume": 15.15,
        "price": 3215.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -712.05,
        "takeProfit": null,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "id": "53117022",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:45.238",
        "brokerTime": "2025-05-14 15:19:45.238",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071070",
        "positionId": "56071070",
        "volume": 15.15,
        "price": 3215.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "id": "53117023",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:45.238",
        "brokerTime": "2025-05-14 15:19:46.398",
        "commission": -106.05,
        "swap": 0,
        "profit": 90.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071071",
        "positionId": "56071070",
        "volume": 15.15,
        "price": 3215.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.149999999999991,
        "takeProfit": null,
        "priceIn": 3215.08,
        "doubleCheck": true
    },
    {
        "id": "53117024",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:46.874",
        "brokerTime": "2025-05-14 15:19:46.874",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071072",
        "positionId": "56071072",
        "volume": 15.15,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "id": "53117025",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:46.874",
        "brokerTime": "2025-05-14 15:19:47.192",
        "commission": -106.05,
        "swap": 0,
        "profit": -363.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071073",
        "positionId": "56071072",
        "volume": 15.15,
        "price": 3215,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -469.65000000000003,
        "takeProfit": null,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "id": "53117026",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47.362",
        "brokerTime": "2025-05-14 15:19:47.362",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071074",
        "positionId": "56071074",
        "volume": 15.15,
        "price": 3214.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53117027",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47.362",
        "brokerTime": "2025-05-14 15:19:47.736",
        "commission": -106.05,
        "swap": 0,
        "profit": -530.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071075",
        "positionId": "56071074",
        "volume": 15.15,
        "price": 3215.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -636.3,
        "takeProfit": null,
        "priceIn": 3214.71,
        "doubleCheck": true
    },
    {
        "id": "53117028",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47.912",
        "brokerTime": "2025-05-14 15:19:47.912",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071076",
        "positionId": "56071076",
        "volume": 15.15,
        "price": 3214.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "id": "53117030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:47.912",
        "brokerTime": "2025-05-14 15:19:48.393",
        "commission": -106.05,
        "swap": 0,
        "profit": 196.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071078",
        "positionId": "56071076",
        "volume": 15.15,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 90.89999999999999,
        "takeProfit": null,
        "priceIn": 3214.63,
        "doubleCheck": true
    },
    {
        "id": "53117031",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:48.972",
        "brokerTime": "2025-05-14 15:19:48.972",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071079",
        "positionId": "56071079",
        "volume": 15.15,
        "price": 3213.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.88,
        "doubleCheck": true
    },
    {
        "id": "53117032",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:48.972",
        "brokerTime": "2025-05-14 15:19:49.737",
        "commission": -106.05,
        "swap": 0,
        "profit": 106.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071081",
        "positionId": "56071079",
        "volume": 15.15,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0,
        "takeProfit": null,
        "priceIn": 3213.88,
        "doubleCheck": true
    },
    {
        "id": "53117034",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:49.971",
        "brokerTime": "2025-05-14 15:19:49.971",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071082",
        "positionId": "56071082",
        "volume": 15.15,
        "price": 3213.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.58,
        "doubleCheck": true
    },
    {
        "id": "53117035",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:49.971",
        "brokerTime": "2025-05-14 15:19:50.321",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071083",
        "positionId": "56071082",
        "volume": 15.15,
        "price": 3213.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -409.05,
        "takeProfit": null,
        "priceIn": 3213.58,
        "doubleCheck": true
    },
    {
        "id": "53117037",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:50.892",
        "brokerTime": "2025-05-14 15:19:50.892",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071085",
        "positionId": "56071085",
        "volume": 15.15,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "id": "53117038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:50.892",
        "brokerTime": "2025-05-14 15:19:51.366",
        "commission": -106.05,
        "swap": 0,
        "profit": -499.95,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071086",
        "positionId": "56071085",
        "volume": 15.15,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -606,
        "takeProfit": null,
        "priceIn": 3213.41,
        "doubleCheck": true
    },
    {
        "id": "53117039",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52.022",
        "brokerTime": "2025-05-14 15:19:52.022",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071087",
        "positionId": "56071087",
        "volume": 15.15,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53117041",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52.022",
        "brokerTime": "2025-05-14 15:19:52.359",
        "commission": -106.05,
        "swap": 0,
        "profit": -181.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071089",
        "positionId": "56071087",
        "volume": 15.15,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -287.85,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53117042",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52.813",
        "brokerTime": "2025-05-14 15:19:52.813",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071090",
        "positionId": "56071090",
        "volume": 15.15,
        "price": 3213.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "id": "53117043",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:52.813",
        "brokerTime": "2025-05-14 15:19:53.277",
        "commission": -106.05,
        "swap": 0,
        "profit": -303,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071091",
        "positionId": "56071090",
        "volume": 15.15,
        "price": 3213.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -409.05,
        "takeProfit": null,
        "priceIn": 3213.44,
        "doubleCheck": true
    },
    {
        "id": "53117044",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:53.813",
        "brokerTime": "2025-05-14 15:19:53.813",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071092",
        "positionId": "56071092",
        "volume": 15.15,
        "price": 3213.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "id": "53117045",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:53.813",
        "brokerTime": "2025-05-14 15:19:54.702",
        "commission": -106.05,
        "swap": 0,
        "profit": -666.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071093",
        "positionId": "56071092",
        "volume": 15.15,
        "price": 3213.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -772.65,
        "takeProfit": null,
        "priceIn": 3213.31,
        "doubleCheck": true
    },
    {
        "id": "53117046",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:54.977",
        "brokerTime": "2025-05-14 15:19:54.977",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071094",
        "positionId": "56071094",
        "volume": 15.15,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117047",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:54.977",
        "brokerTime": "2025-05-14 15:19:55.542",
        "commission": -106.05,
        "swap": 0,
        "profit": -863.55,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071095",
        "positionId": "56071094",
        "volume": 15.15,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -969.5999999999999,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117048",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:55.724",
        "brokerTime": "2025-05-14 15:19:55.724",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071096",
        "positionId": "56071096",
        "volume": 15.15,
        "price": 3213.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53117050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:55.724",
        "brokerTime": "2025-05-14 15:19:56.047",
        "commission": -106.05,
        "swap": 0,
        "profit": -424.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071098",
        "positionId": "56071096",
        "volume": 15.15,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -530.25,
        "takeProfit": null,
        "priceIn": 3213.89,
        "doubleCheck": true
    },
    {
        "id": "53117052",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:56.660",
        "brokerTime": "2025-05-14 15:19:56.660",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071100",
        "positionId": "56071100",
        "volume": 15.15,
        "price": 3214.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.16,
        "doubleCheck": true
    },
    {
        "id": "53117054",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:56.660",
        "brokerTime": "2025-05-14 15:19:57.241",
        "commission": -106.05,
        "swap": 0,
        "profit": -742.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071102",
        "positionId": "56071100",
        "volume": 15.15,
        "price": 3214.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -848.4,
        "takeProfit": null,
        "priceIn": 3214.16,
        "doubleCheck": true
    },
    {
        "id": "53117055",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57.471",
        "brokerTime": "2025-05-14 15:19:57.471",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071103",
        "positionId": "56071103",
        "volume": 15.15,
        "price": 3214.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53117056",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:57.471",
        "brokerTime": "2025-05-14 15:19:58.632",
        "commission": -106.05,
        "swap": 0,
        "profit": -939.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071104",
        "positionId": "56071103",
        "volume": 15.15,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1045.35,
        "takeProfit": null,
        "priceIn": 3214.53,
        "doubleCheck": true
    },
    {
        "id": "53117057",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:58.934",
        "brokerTime": "2025-05-14 15:19:58.934",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071105",
        "positionId": "56071105",
        "volume": 15.15,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53117058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:58.934",
        "brokerTime": "2025-05-14 15:19:59.585",
        "commission": -106.05,
        "swap": 0,
        "profit": -454.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071106",
        "positionId": "56071105",
        "volume": 15.15,
        "price": 3215.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -560.55,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53117059",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:59.946",
        "brokerTime": "2025-05-14 15:19:59.946",
        "commission": -106.05,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071107",
        "positionId": "56071107",
        "volume": 15.15,
        "price": 3215.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.05,
        "takeProfit": null,
        "priceIn": 3215.05,
        "doubleCheck": true
    },
    {
        "id": "53117069",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:59.946",
        "brokerTime": "2025-05-14 15:20:00.942",
        "commission": -106.05,
        "swap": 0,
        "profit": -212.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071116",
        "positionId": "56071107",
        "volume": 15.15,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -318.15,
        "takeProfit": null,
        "priceIn": 3215.05,
        "doubleCheck": true
    },
    {
        "id": "53117070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:01.030",
        "brokerTime": "2025-05-14 15:20:01.030",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071117",
        "positionId": "56071117",
        "volume": 0.14,
        "price": 3214.97,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3114.97,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3214.97,
        "doubleCheck": true
    },
    {
        "id": "53117072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:02.106",
        "brokerTime": "2025-05-14 15:20:02.106",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071119",
        "positionId": "56071119",
        "volume": 15.01,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53117073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:02.106",
        "brokerTime": "2025-05-14 15:20:02.837",
        "commission": -105.07,
        "swap": 0,
        "profit": -855.57,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071120",
        "positionId": "56071119",
        "volume": 15.01,
        "price": 3215.56,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -960.6400000000001,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53117075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:03.157",
        "brokerTime": "2025-05-14 15:20:03.157",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071122",
        "positionId": "56071122",
        "volume": 15.01,
        "price": 3215.38,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.38,
        "doubleCheck": true
    },
    {
        "id": "53117076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:03.157",
        "brokerTime": "2025-05-14 15:20:03.629",
        "commission": -105.07,
        "swap": 0,
        "profit": -120.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071124",
        "positionId": "56071122",
        "volume": 15.01,
        "price": 3215.46,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -225.14999999999998,
        "takeProfit": null,
        "priceIn": 3215.38,
        "doubleCheck": true
    },
    {
        "id": "53117077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:04.099",
        "brokerTime": "2025-05-14 15:20:04.099",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071125",
        "positionId": "56071125",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.26,
        "doubleCheck": true
    },
    {
        "id": "53117078",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:04.099",
        "brokerTime": "2025-05-14 15:20:04.774",
        "commission": -105.07,
        "swap": 0,
        "profit": -405.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071126",
        "positionId": "56071125",
        "volume": 15.01,
        "price": 3215.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -510.34,
        "takeProfit": null,
        "priceIn": 3215.26,
        "doubleCheck": true
    },
    {
        "id": "53117079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:05.041",
        "brokerTime": "2025-05-14 15:20:05.041",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071127",
        "positionId": "56071127",
        "volume": 15.01,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53117080",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:05.041",
        "brokerTime": "2025-05-14 15:20:05.501",
        "commission": -105.07,
        "swap": 0,
        "profit": -510.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071128",
        "positionId": "56071127",
        "volume": 15.01,
        "price": 3215.57,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -615.41,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53117082",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:06.142",
        "brokerTime": "2025-05-14 15:20:06.142",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071130",
        "positionId": "56071130",
        "volume": 15.01,
        "price": 3215.23,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53117083",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:06.142",
        "brokerTime": "2025-05-14 15:20:06.602",
        "commission": -105.07,
        "swap": 0,
        "profit": -390.26,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071133",
        "positionId": "56071130",
        "volume": 15.01,
        "price": 3215.49,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -495.33,
        "takeProfit": null,
        "priceIn": 3215.23,
        "doubleCheck": true
    },
    {
        "id": "53117088",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:07.000",
        "brokerTime": "2025-05-14 15:20:07.000",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071136",
        "positionId": "56071136",
        "volume": 15.01,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "id": "53117089",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:07.000",
        "brokerTime": "2025-05-14 15:20:07.464",
        "commission": -105.07,
        "swap": 0,
        "profit": -180.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071137",
        "positionId": "56071136",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -285.19,
        "takeProfit": null,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "id": "53117090",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08.048",
        "brokerTime": "2025-05-14 15:20:08.048",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071138",
        "positionId": "56071138",
        "volume": 15.01,
        "price": 3215.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53117091",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08.048",
        "brokerTime": "2025-05-14 15:20:08.435",
        "commission": -105.07,
        "swap": 0,
        "profit": -300.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071139",
        "positionId": "56071138",
        "volume": 15.01,
        "price": 3215.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -405.27,
        "takeProfit": null,
        "priceIn": 3215.15,
        "doubleCheck": true
    },
    {
        "id": "53117092",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08.672",
        "brokerTime": "2025-05-14 15:20:08.672",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071140",
        "positionId": "56071140",
        "volume": 15.01,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "id": "53117093",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:08.672",
        "brokerTime": "2025-05-14 15:20:09.063",
        "commission": -105.07,
        "swap": 0,
        "profit": -180.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071141",
        "positionId": "56071140",
        "volume": 15.01,
        "price": 3215.26,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -285.19,
        "takeProfit": null,
        "priceIn": 3215.14,
        "doubleCheck": true
    },
    {
        "id": "53117094",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:09.522",
        "brokerTime": "2025-05-14 15:20:09.522",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071142",
        "positionId": "56071142",
        "volume": 15.01,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53117095",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:09.522",
        "brokerTime": "2025-05-14 15:20:10.722",
        "commission": -105.07,
        "swap": 0,
        "profit": -375.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071143",
        "positionId": "56071142",
        "volume": 15.01,
        "price": 3215.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -480.32,
        "takeProfit": null,
        "priceIn": 3214.95,
        "doubleCheck": true
    },
    {
        "id": "53117096",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11.058",
        "brokerTime": "2025-05-14 15:20:11.058",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071144",
        "positionId": "56071144",
        "volume": 15.01,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "id": "53117101",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11.058",
        "brokerTime": "2025-05-14 15:20:11.633",
        "commission": -105.07,
        "swap": 0,
        "profit": 1140.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071147",
        "positionId": "56071144",
        "volume": 15.01,
        "price": 3214,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 1035.69,
        "takeProfit": null,
        "priceIn": 3214.76,
        "doubleCheck": true
    },
    {
        "id": "53117102",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11.821",
        "brokerTime": "2025-05-14 15:20:11.821",
        "commission": -105.07,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071148",
        "positionId": "56071148",
        "volume": 15.01,
        "price": 3213.78,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -105.07,
        "takeProfit": null,
        "priceIn": 3213.78,
        "doubleCheck": true
    },
    {
        "id": "53117104",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:11.821",
        "brokerTime": "2025-05-14 15:20:12.306",
        "commission": -105.07,
        "swap": 0,
        "profit": -885.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071150",
        "positionId": "56071148",
        "volume": 15.01,
        "price": 3214.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -990.6600000000001,
        "takeProfit": null,
        "priceIn": 3213.78,
        "doubleCheck": true
    },
    {
        "id": "53117105",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:01.030",
        "brokerTime": "2025-05-14 15:20:12.514",
        "commission": -0.98,
        "swap": 0,
        "profit": 7.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071151",
        "positionId": "56071117",
        "volume": 0.14,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 6.58,
        "priceIn": 3214.97,
        "doubleCheck": false
    },
    {
        "id": "53117106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:19:16.769",
        "brokerTime": "2025-05-14 15:20:12.542",
        "commission": -0.84,
        "swap": 0,
        "profit": -11.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071152",
        "positionId": "56070977",
        "volume": 0.12,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -12.72,
        "priceIn": 3213.44,
        "doubleCheck": false
    },
    {
        "id": "53117107",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:16:12.322",
        "brokerTime": "2025-05-14 15:20:12.571",
        "commission": -0.7,
        "swap": 0,
        "profit": -25.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071153",
        "positionId": "56068484",
        "volume": 0.1,
        "price": 3214.43,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3115.19,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -26.099999999999998,
        "priceIn": 3211.89,
        "doubleCheck": false
    },
    {
        "id": "53117120",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19.436",
        "brokerTime": "2025-05-14 15:20:19.436",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071166",
        "positionId": "56071166",
        "volume": 0.1,
        "price": 3213.81,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3213.81,
        "doubleCheck": true
    },
    {
        "id": "53117121",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19.719",
        "brokerTime": "2025-05-14 15:20:19.719",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071167",
        "positionId": "56071167",
        "volume": 15.27,
        "price": 3213.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.82,
        "doubleCheck": true
    },
    {
        "id": "53117122",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19.719",
        "brokerTime": "2025-05-14 15:20:20.328",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071168",
        "positionId": "56071167",
        "volume": 15.27,
        "price": 3213.77,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.540000000000006,
        "takeProfit": null,
        "priceIn": 3213.82,
        "doubleCheck": true
    },
    {
        "id": "53117123",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:20.954",
        "brokerTime": "2025-05-14 15:20:20.954",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071169",
        "positionId": "56071169",
        "volume": 15.27,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "id": "53117124",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:20.954",
        "brokerTime": "2025-05-14 15:20:21.654",
        "commission": -106.89,
        "swap": 0,
        "profit": -91.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071170",
        "positionId": "56071169",
        "volume": 15.27,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -198.51,
        "takeProfit": null,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "id": "53117126",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22.035",
        "brokerTime": "2025-05-14 15:20:22.035",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071172",
        "positionId": "56071172",
        "volume": 15.27,
        "price": 3213.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "id": "53117127",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22.035",
        "brokerTime": "2025-05-14 15:20:22.379",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071173",
        "positionId": "56071172",
        "volume": 15.27,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -427.56,
        "takeProfit": null,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "id": "53117128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22.626",
        "brokerTime": "2025-05-14 15:20:22.626",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071174",
        "positionId": "56071174",
        "volume": 15.27,
        "price": 3213.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "id": "53117129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:22.626",
        "brokerTime": "2025-05-14 15:20:22.996",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071175",
        "positionId": "56071174",
        "volume": 15.27,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3213.5,
        "doubleCheck": true
    },
    {
        "id": "53117130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23.153",
        "brokerTime": "2025-05-14 15:20:23.153",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071176",
        "positionId": "56071176",
        "volume": 15.27,
        "price": 3213.46,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.46,
        "doubleCheck": true
    },
    {
        "id": "53117132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23.153",
        "brokerTime": "2025-05-14 15:20:23.537",
        "commission": -106.89,
        "swap": 0,
        "profit": -549.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071178",
        "positionId": "56071176",
        "volume": 15.27,
        "price": 3213.82,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -656.61,
        "takeProfit": null,
        "priceIn": 3213.46,
        "doubleCheck": true
    },
    {
        "id": "53117133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23.745",
        "brokerTime": "2025-05-14 15:20:23.745",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071179",
        "positionId": "56071179",
        "volume": 15.27,
        "price": 3213.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "id": "53117134",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:23.745",
        "brokerTime": "2025-05-14 15:20:24.273",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071180",
        "positionId": "56071179",
        "volume": 15.27,
        "price": 3213.87,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -534.45,
        "takeProfit": null,
        "priceIn": 3213.59,
        "doubleCheck": true
    },
    {
        "id": "53117135",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24.436",
        "brokerTime": "2025-05-14 15:20:24.436",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071181",
        "positionId": "56071181",
        "volume": 15.27,
        "price": 3213.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53117136",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:24.436",
        "brokerTime": "2025-05-14 15:20:25.305",
        "commission": -106.89,
        "swap": 0,
        "profit": -839.85,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071182",
        "positionId": "56071181",
        "volume": 15.27,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -946.74,
        "takeProfit": null,
        "priceIn": 3213.43,
        "doubleCheck": true
    },
    {
        "id": "53117137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:25.675",
        "brokerTime": "2025-05-14 15:20:25.675",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071183",
        "positionId": "56071183",
        "volume": 15.27,
        "price": 3213.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53117138",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:25.675",
        "brokerTime": "2025-05-14 15:20:25.997",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071184",
        "positionId": "56071183",
        "volume": 15.27,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.09999999999997,
        "takeProfit": null,
        "priceIn": 3213.83,
        "doubleCheck": true
    },
    {
        "id": "53117139",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:26.591",
        "brokerTime": "2025-05-14 15:20:26.591",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071185",
        "positionId": "56071185",
        "volume": 15.27,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53117140",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:26.591",
        "brokerTime": "2025-05-14 15:20:27.020",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071186",
        "positionId": "56071185",
        "volume": 15.27,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53117141",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27.179",
        "brokerTime": "2025-05-14 15:20:27.179",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071187",
        "positionId": "56071187",
        "volume": 15.27,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "id": "53117142",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:27.179",
        "brokerTime": "2025-05-14 15:20:28.150",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071188",
        "positionId": "56071187",
        "volume": 15.27,
        "price": 3213.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -534.45,
        "takeProfit": null,
        "priceIn": 3213.71,
        "doubleCheck": true
    },
    {
        "id": "53117143",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:28.662",
        "brokerTime": "2025-05-14 15:20:28.662",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071189",
        "positionId": "56071189",
        "volume": 15.27,
        "price": 3213.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.94,
        "doubleCheck": true
    },
    {
        "id": "53117144",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:28.662",
        "brokerTime": "2025-05-14 15:20:29.176",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071190",
        "positionId": "56071189",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.05,
        "takeProfit": null,
        "priceIn": 3213.94,
        "doubleCheck": true
    },
    {
        "id": "53117145",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29.383",
        "brokerTime": "2025-05-14 15:20:29.383",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071191",
        "positionId": "56071191",
        "volume": 15.27,
        "price": 3213.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53117146",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:29.383",
        "brokerTime": "2025-05-14 15:20:29.863",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071192",
        "positionId": "56071191",
        "volume": 15.27,
        "price": 3213.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.09999999999997,
        "takeProfit": null,
        "priceIn": 3213.72,
        "doubleCheck": true
    },
    {
        "id": "53117147",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:30.261",
        "brokerTime": "2025-05-14 15:20:30.261",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071193",
        "positionId": "56071193",
        "volume": 15.27,
        "price": 3213.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "id": "53117148",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:30.261",
        "brokerTime": "2025-05-14 15:20:30.755",
        "commission": -106.89,
        "swap": 0,
        "profit": -458.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071194",
        "positionId": "56071193",
        "volume": 15.27,
        "price": 3214.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -564.99,
        "takeProfit": null,
        "priceIn": 3213.84,
        "doubleCheck": true
    },
    {
        "id": "53117149",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31.316",
        "brokerTime": "2025-05-14 15:20:31.316",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071195",
        "positionId": "56071195",
        "volume": 15.27,
        "price": 3214.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53117150",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31.316",
        "brokerTime": "2025-05-14 15:20:31.638",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071197",
        "positionId": "56071195",
        "volume": 15.27,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3214.06,
        "doubleCheck": true
    },
    {
        "id": "53117151",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31.983",
        "brokerTime": "2025-05-14 15:20:31.983",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071199",
        "positionId": "56071199",
        "volume": 15.27,
        "price": 3214.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "id": "53117152",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:31.983",
        "brokerTime": "2025-05-14 15:20:32.567",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071200",
        "positionId": "56071199",
        "volume": 15.27,
        "price": 3214.44,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.13,
        "takeProfit": null,
        "priceIn": 3214.32,
        "doubleCheck": true
    },
    {
        "id": "53117153",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:32.731",
        "brokerTime": "2025-05-14 15:20:32.731",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071201",
        "positionId": "56071201",
        "volume": 15.27,
        "price": 3214.21,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "id": "53117154",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:32.731",
        "brokerTime": "2025-05-14 15:20:33.110",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071202",
        "positionId": "56071201",
        "volume": 15.27,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3214.21,
        "doubleCheck": true
    },
    {
        "id": "53117155",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:33.599",
        "brokerTime": "2025-05-14 15:20:33.599",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071203",
        "positionId": "56071203",
        "volume": 15.27,
        "price": 3214.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53117156",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:33.599",
        "brokerTime": "2025-05-14 15:20:33.900",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071204",
        "positionId": "56071203",
        "volume": 15.27,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -335.94,
        "takeProfit": null,
        "priceIn": 3214.18,
        "doubleCheck": true
    },
    {
        "id": "53117157",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34.180",
        "brokerTime": "2025-05-14 15:20:34.180",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071205",
        "positionId": "56071205",
        "volume": 15.27,
        "price": 3214.1,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "id": "53117158",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:34.180",
        "brokerTime": "2025-05-14 15:20:35.223",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071206",
        "positionId": "56071205",
        "volume": 15.27,
        "price": 3214.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3214.1,
        "doubleCheck": true
    },
    {
        "id": "53117159",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:35.814",
        "brokerTime": "2025-05-14 15:20:35.814",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071207",
        "positionId": "56071207",
        "volume": 15.27,
        "price": 3214.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "id": "53117160",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:35.814",
        "brokerTime": "2025-05-14 15:20:36.108",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071208",
        "positionId": "56071207",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.540000000000006,
        "takeProfit": null,
        "priceIn": 3214.29,
        "doubleCheck": true
    },
    {
        "id": "53117161",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:36.546",
        "brokerTime": "2025-05-14 15:20:36.546",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071209",
        "positionId": "56071209",
        "volume": 15.27,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53117162",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:36.546",
        "brokerTime": "2025-05-14 15:20:36.975",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071210",
        "positionId": "56071209",
        "volume": 15.27,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53117163",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37.147",
        "brokerTime": "2025-05-14 15:20:37.147",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071211",
        "positionId": "56071211",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53117164",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:37.147",
        "brokerTime": "2025-05-14 15:20:37.639",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071212",
        "positionId": "56071211",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53117165",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38.130",
        "brokerTime": "2025-05-14 15:20:38.130",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071213",
        "positionId": "56071213",
        "volume": 15.27,
        "price": 3214.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53117166",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38.130",
        "brokerTime": "2025-05-14 15:20:38.513",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071214",
        "positionId": "56071213",
        "volume": 15.27,
        "price": 3214.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.09999999999997,
        "takeProfit": null,
        "priceIn": 3214.02,
        "doubleCheck": true
    },
    {
        "id": "53117167",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38.935",
        "brokerTime": "2025-05-14 15:20:38.935",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071215",
        "positionId": "56071215",
        "volume": 15.27,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53117168",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:38.935",
        "brokerTime": "2025-05-14 15:20:39.398",
        "commission": -106.89,
        "swap": 0,
        "profit": -152.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071216",
        "positionId": "56071215",
        "volume": 15.27,
        "price": 3214.27,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.59,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53117169",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:39.659",
        "brokerTime": "2025-05-14 15:20:39.659",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071217",
        "positionId": "56071217",
        "volume": 15.27,
        "price": 3214.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53117170",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:39.659",
        "brokerTime": "2025-05-14 15:20:40.033",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071218",
        "positionId": "56071217",
        "volume": 15.27,
        "price": 3214.23,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3214.03,
        "doubleCheck": true
    },
    {
        "id": "53117171",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40.348",
        "brokerTime": "2025-05-14 15:20:40.348",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071219",
        "positionId": "56071219",
        "volume": 15.27,
        "price": 3214.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "id": "53117172",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:40.348",
        "brokerTime": "2025-05-14 15:20:41.015",
        "commission": -106.89,
        "swap": 0,
        "profit": -564.99,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071220",
        "positionId": "56071219",
        "volume": 15.27,
        "price": 3214.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -671.88,
        "takeProfit": null,
        "priceIn": 3214.13,
        "doubleCheck": true
    },
    {
        "id": "53117173",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:41.262",
        "brokerTime": "2025-05-14 15:20:41.262",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071221",
        "positionId": "56071221",
        "volume": 15.27,
        "price": 3214.31,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53117175",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:41.262",
        "brokerTime": "2025-05-14 15:20:41.755",
        "commission": -106.89,
        "swap": 0,
        "profit": -656.61,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071223",
        "positionId": "56071221",
        "volume": 15.27,
        "price": 3214.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -763.5,
        "takeProfit": null,
        "priceIn": 3214.31,
        "doubleCheck": true
    },
    {
        "id": "53117176",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42.243",
        "brokerTime": "2025-05-14 15:20:42.243",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071226",
        "positionId": "56071226",
        "volume": 15.27,
        "price": 3214.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "id": "53117177",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42.243",
        "brokerTime": "2025-05-14 15:20:42.630",
        "commission": -106.89,
        "swap": 0,
        "profit": -213.78,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071227",
        "positionId": "56071226",
        "volume": 15.27,
        "price": 3214.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -320.67,
        "takeProfit": null,
        "priceIn": 3214.62,
        "doubleCheck": true
    },
    {
        "id": "53117178",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42.862",
        "brokerTime": "2025-05-14 15:20:42.862",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071228",
        "positionId": "56071228",
        "volume": 15.27,
        "price": 3214.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53117179",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:42.862",
        "brokerTime": "2025-05-14 15:20:43.323",
        "commission": -106.89,
        "swap": 0,
        "profit": -519.18,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071229",
        "positionId": "56071228",
        "volume": 15.27,
        "price": 3214.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -626.0699999999999,
        "takeProfit": null,
        "priceIn": 3214.51,
        "doubleCheck": true
    },
    {
        "id": "53117180",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:43.732",
        "brokerTime": "2025-05-14 15:20:43.732",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071230",
        "positionId": "56071230",
        "volume": 15.27,
        "price": 3214.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "id": "53117181",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:43.732",
        "brokerTime": "2025-05-14 15:20:44.371",
        "commission": -106.89,
        "swap": 0,
        "profit": -626.07,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071231",
        "positionId": "56071230",
        "volume": 15.27,
        "price": 3214.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -732.96,
        "takeProfit": null,
        "priceIn": 3214.28,
        "doubleCheck": true
    },
    {
        "id": "53117182",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:44.837",
        "brokerTime": "2025-05-14 15:20:44.837",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071232",
        "positionId": "56071232",
        "volume": 15.27,
        "price": 3214.7,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53117183",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:44.837",
        "brokerTime": "2025-05-14 15:20:45.361",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071233",
        "positionId": "56071232",
        "volume": 15.27,
        "price": 3214.9,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3214.7,
        "doubleCheck": true
    },
    {
        "id": "53117184",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:45.663",
        "brokerTime": "2025-05-14 15:20:45.663",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071234",
        "positionId": "56071234",
        "volume": 15.27,
        "price": 3214.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.77,
        "doubleCheck": true
    },
    {
        "id": "53117185",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:45.663",
        "brokerTime": "2025-05-14 15:20:46.329",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071236",
        "positionId": "56071234",
        "volume": 15.27,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3214.77,
        "doubleCheck": true
    },
    {
        "id": "53117187",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:46.567",
        "brokerTime": "2025-05-14 15:20:46.567",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071237",
        "positionId": "56071237",
        "volume": 15.27,
        "price": 3214.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53117188",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:46.567",
        "brokerTime": "2025-05-14 15:20:46.995",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071238",
        "positionId": "56071237",
        "volume": 15.27,
        "price": 3215.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -335.94,
        "takeProfit": null,
        "priceIn": 3214.99,
        "doubleCheck": true
    },
    {
        "id": "53117189",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47.296",
        "brokerTime": "2025-05-14 15:20:47.296",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071239",
        "positionId": "56071239",
        "volume": 15.27,
        "price": 3215.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3215.09,
        "doubleCheck": true
    },
    {
        "id": "53117190",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:47.296",
        "brokerTime": "2025-05-14 15:20:47.795",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071240",
        "positionId": "56071239",
        "volume": 15.27,
        "price": 3215.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -351.21,
        "takeProfit": null,
        "priceIn": 3215.09,
        "doubleCheck": true
    },
    {
        "id": "53117191",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:48.295",
        "brokerTime": "2025-05-14 15:20:48.295",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071241",
        "positionId": "56071241",
        "volume": 15.27,
        "price": 3215.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "id": "53117192",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:48.295",
        "brokerTime": "2025-05-14 15:20:49.045",
        "commission": -106.89,
        "swap": 0,
        "profit": -244.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071242",
        "positionId": "56071241",
        "volume": 15.27,
        "price": 3215.19,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -351.21,
        "takeProfit": null,
        "priceIn": 3215.03,
        "doubleCheck": true
    },
    {
        "id": "53117193",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:49.305",
        "brokerTime": "2025-05-14 15:20:49.305",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071243",
        "positionId": "56071243",
        "volume": 15.27,
        "price": 3214.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.94,
        "doubleCheck": true
    },
    {
        "id": "53117194",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:49.305",
        "brokerTime": "2025-05-14 15:20:50.008",
        "commission": -106.89,
        "swap": 0,
        "profit": -152.7,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071244",
        "positionId": "56071243",
        "volume": 15.27,
        "price": 3215.04,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -259.59,
        "takeProfit": null,
        "priceIn": 3214.94,
        "doubleCheck": true
    },
    {
        "id": "53117195",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:50.943",
        "brokerTime": "2025-05-14 15:20:50.943",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071245",
        "positionId": "56071245",
        "volume": 15.27,
        "price": 3214.88,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "id": "53117196",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:50.943",
        "brokerTime": "2025-05-14 15:20:51.626",
        "commission": -106.89,
        "swap": 0,
        "profit": -610.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071246",
        "positionId": "56071245",
        "volume": 15.27,
        "price": 3215.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -717.6899999999999,
        "takeProfit": null,
        "priceIn": 3214.88,
        "doubleCheck": true
    },
    {
        "id": "53117197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:52.267",
        "brokerTime": "2025-05-14 15:20:52.267",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071247",
        "positionId": "56071247",
        "volume": 15.27,
        "price": 3214.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.96,
        "doubleCheck": true
    },
    {
        "id": "53117198",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:52.267",
        "brokerTime": "2025-05-14 15:20:53.150",
        "commission": -106.89,
        "swap": 0,
        "profit": 15.27,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071248",
        "positionId": "56071247",
        "volume": 15.27,
        "price": 3214.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -91.62,
        "takeProfit": null,
        "priceIn": 3214.96,
        "doubleCheck": true
    },
    {
        "id": "53117199",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:53.624",
        "brokerTime": "2025-05-14 15:20:53.624",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071249",
        "positionId": "56071249",
        "volume": 15.27,
        "price": 3214.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.69,
        "doubleCheck": true
    },
    {
        "id": "53117200",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:53.624",
        "brokerTime": "2025-05-14 15:20:53.978",
        "commission": -106.89,
        "swap": 0,
        "profit": 320.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071250",
        "positionId": "56071249",
        "volume": 15.27,
        "price": 3214.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 213.78000000000003,
        "takeProfit": null,
        "priceIn": 3214.69,
        "doubleCheck": true
    },
    {
        "id": "53117201",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:54.619",
        "brokerTime": "2025-05-14 15:20:54.619",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071251",
        "positionId": "56071251",
        "volume": 15.27,
        "price": 3214.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53117202",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:54.619",
        "brokerTime": "2025-05-14 15:20:55.215",
        "commission": -106.89,
        "swap": 0,
        "profit": -274.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071252",
        "positionId": "56071251",
        "volume": 15.27,
        "price": 3214.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -381.75,
        "takeProfit": null,
        "priceIn": 3214.17,
        "doubleCheck": true
    },
    {
        "id": "53117203",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:55.820",
        "brokerTime": "2025-05-14 15:20:55.820",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071253",
        "positionId": "56071253",
        "volume": 15.27,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53117204",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:55.820",
        "brokerTime": "2025-05-14 15:20:56.384",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071254",
        "positionId": "56071253",
        "volume": 15.27,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53117205",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57.031",
        "brokerTime": "2025-05-14 15:20:57.031",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071255",
        "positionId": "56071255",
        "volume": 15.27,
        "price": 3214,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53117206",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57.031",
        "brokerTime": "2025-05-14 15:20:57.450",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071256",
        "positionId": "56071255",
        "volume": 15.27,
        "price": 3214.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3214,
        "doubleCheck": true
    },
    {
        "id": "53117207",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57.975",
        "brokerTime": "2025-05-14 15:20:57.975",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071257",
        "positionId": "56071257",
        "volume": 15.27,
        "price": 3213.9,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.9,
        "doubleCheck": true
    },
    {
        "id": "53117208",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:57.975",
        "brokerTime": "2025-05-14 15:20:58.598",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071258",
        "positionId": "56071257",
        "volume": 15.27,
        "price": 3213.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.05,
        "takeProfit": null,
        "priceIn": 3213.9,
        "doubleCheck": true
    },
    {
        "id": "53117209",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:58.889",
        "brokerTime": "2025-05-14 15:20:58.889",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071259",
        "positionId": "56071259",
        "volume": 15.27,
        "price": 3213.62,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53117210",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:58.889",
        "brokerTime": "2025-05-14 15:20:59.660",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071260",
        "positionId": "56071259",
        "volume": 15.27,
        "price": 3213.7,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.05,
        "takeProfit": null,
        "priceIn": 3213.62,
        "doubleCheck": true
    },
    {
        "id": "53117211",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:59.972",
        "brokerTime": "2025-05-14 15:20:59.972",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071261",
        "positionId": "56071261",
        "volume": 15.27,
        "price": 3213.45,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53117213",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:59.972",
        "brokerTime": "2025-05-14 15:21:00.482",
        "commission": -106.89,
        "swap": 0,
        "profit": -106.89,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071263",
        "positionId": "56071261",
        "volume": 15.27,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -213.78,
        "takeProfit": null,
        "priceIn": 3213.45,
        "doubleCheck": true
    },
    {
        "id": "53117214",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:00.891",
        "brokerTime": "2025-05-14 15:21:00.891",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071264",
        "positionId": "56071264",
        "volume": 15.27,
        "price": 3213.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.3,
        "doubleCheck": true
    },
    {
        "id": "53117215",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:00.891",
        "brokerTime": "2025-05-14 15:21:01.305",
        "commission": -106.89,
        "swap": 0,
        "profit": -183.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071267",
        "positionId": "56071264",
        "volume": 15.27,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -290.13,
        "takeProfit": null,
        "priceIn": 3213.3,
        "doubleCheck": true
    },
    {
        "id": "53117250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02.090",
        "brokerTime": "2025-05-14 15:21:02.090",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071300",
        "positionId": "56071300",
        "volume": 15.27,
        "price": 3213.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.07,
        "doubleCheck": true
    },
    {
        "id": "53117275",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02.090",
        "brokerTime": "2025-05-14 15:21:02.437",
        "commission": -106.89,
        "swap": 0,
        "profit": -381.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071306",
        "positionId": "56071300",
        "volume": 15.27,
        "price": 3213.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -488.64,
        "takeProfit": null,
        "priceIn": 3213.07,
        "doubleCheck": true
    },
    {
        "id": "53117276",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02.884",
        "brokerTime": "2025-05-14 15:21:02.884",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071307",
        "positionId": "56071307",
        "volume": 15.27,
        "price": 3213.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "id": "53117277",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:02.884",
        "brokerTime": "2025-05-14 15:21:03.449",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071308",
        "positionId": "56071307",
        "volume": 15.27,
        "price": 3213.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3213.17,
        "doubleCheck": true
    },
    {
        "id": "53117278",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:03.813",
        "brokerTime": "2025-05-14 15:21:03.813",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071310",
        "positionId": "56071310",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.08,
        "doubleCheck": true
    },
    {
        "id": "53117280",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:03.813",
        "brokerTime": "2025-05-14 15:21:04.731",
        "commission": -106.89,
        "swap": 0,
        "profit": 76.35,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071311",
        "positionId": "56071310",
        "volume": 15.27,
        "price": 3213.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.540000000000006,
        "takeProfit": null,
        "priceIn": 3213.08,
        "doubleCheck": true
    },
    {
        "id": "53117281",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:05.122",
        "brokerTime": "2025-05-14 15:21:05.122",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071312",
        "positionId": "56071312",
        "volume": 15.27,
        "price": 3212.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.85,
        "doubleCheck": true
    },
    {
        "id": "53117282",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:05.122",
        "brokerTime": "2025-05-14 15:21:05.686",
        "commission": -106.89,
        "swap": 0,
        "profit": 91.62,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071313",
        "positionId": "56071312",
        "volume": 15.27,
        "price": 3212.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.269999999999996,
        "takeProfit": null,
        "priceIn": 3212.85,
        "doubleCheck": true
    },
    {
        "id": "53117283",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06.131",
        "brokerTime": "2025-05-14 15:21:06.131",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071314",
        "positionId": "56071314",
        "volume": 15.27,
        "price": 3212.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.53,
        "doubleCheck": true
    },
    {
        "id": "53117284",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06.131",
        "brokerTime": "2025-05-14 15:21:06.563",
        "commission": -106.89,
        "swap": 0,
        "profit": -397.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071315",
        "positionId": "56071314",
        "volume": 15.27,
        "price": 3212.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -503.90999999999997,
        "takeProfit": null,
        "priceIn": 3212.53,
        "doubleCheck": true
    },
    {
        "id": "53117285",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06.828",
        "brokerTime": "2025-05-14 15:21:06.828",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071316",
        "positionId": "56071316",
        "volume": 15.27,
        "price": 3211.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.98,
        "doubleCheck": true
    },
    {
        "id": "53117286",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:06.828",
        "brokerTime": "2025-05-14 15:21:07.304",
        "commission": -106.89,
        "swap": 0,
        "profit": -61.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071317",
        "positionId": "56071316",
        "volume": 15.27,
        "price": 3212.02,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.97,
        "takeProfit": null,
        "priceIn": 3211.98,
        "doubleCheck": true
    },
    {
        "id": "53117288",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:07.790",
        "brokerTime": "2025-05-14 15:21:07.790",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071319",
        "positionId": "56071319",
        "volume": 15.27,
        "price": 3211.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "id": "53117289",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:07.790",
        "brokerTime": "2025-05-14 15:21:08.142",
        "commission": -106.89,
        "swap": 0,
        "profit": -320.67,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071320",
        "positionId": "56071319",
        "volume": 15.27,
        "price": 3212.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -427.56,
        "takeProfit": null,
        "priceIn": 3211.89,
        "doubleCheck": true
    },
    {
        "id": "53117290",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08.403",
        "brokerTime": "2025-05-14 15:21:08.403",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071321",
        "positionId": "56071321",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53117297",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:08.403",
        "brokerTime": "2025-05-14 15:21:09.007",
        "commission": -106.89,
        "swap": 0,
        "profit": 183.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071328",
        "positionId": "56071321",
        "volume": 15.27,
        "price": 3211.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 76.35000000000001,
        "takeProfit": null,
        "priceIn": 3211.75,
        "doubleCheck": true
    },
    {
        "id": "53117306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:09.816",
        "brokerTime": "2025-05-14 15:21:09.816",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071332",
        "positionId": "56071332",
        "volume": 15.27,
        "price": 3211.4,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3211.4,
        "doubleCheck": true
    },
    {
        "id": "53117308",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:09.816",
        "brokerTime": "2025-05-14 15:21:10.218",
        "commission": -106.89,
        "swap": 0,
        "profit": -534.45,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071334",
        "positionId": "56071332",
        "volume": 15.27,
        "price": 3211.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -641.34,
        "takeProfit": null,
        "priceIn": 3211.4,
        "doubleCheck": true
    },
    {
        "id": "53117309",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:20:19.436",
        "brokerTime": "2025-05-14 15:21:10.263",
        "commission": -0.7,
        "swap": 0,
        "profit": 20.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071335",
        "positionId": "56071166",
        "volume": 0.1,
        "price": 3211.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 19.8,
        "takeProfit": null,
        "priceIn": 3213.81,
        "doubleCheck": true
    },
    {
        "id": "53117311",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:16.985",
        "brokerTime": "2025-05-14 15:21:16.985",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071337",
        "positionId": "56071337",
        "volume": 0.1,
        "price": 3212.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3212.14,
        "doubleCheck": true
    },
    {
        "id": "53117312",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17.280",
        "brokerTime": "2025-05-14 15:21:17.280",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071338",
        "positionId": "56071338",
        "volume": 15.27,
        "price": 3212.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.19,
        "doubleCheck": true
    },
    {
        "id": "53117313",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:17.280",
        "brokerTime": "2025-05-14 15:21:17.858",
        "commission": -106.89,
        "swap": 0,
        "profit": -274.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071339",
        "positionId": "56071338",
        "volume": 15.27,
        "price": 3212.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -381.75,
        "takeProfit": null,
        "priceIn": 3212.19,
        "doubleCheck": true
    },
    {
        "id": "53117314",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18.193",
        "brokerTime": "2025-05-14 15:21:18.193",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071340",
        "positionId": "56071340",
        "volume": 15.27,
        "price": 3212.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "id": "53117315",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18.193",
        "brokerTime": "2025-05-14 15:21:18.471",
        "commission": -106.89,
        "swap": 0,
        "profit": -503.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071341",
        "positionId": "56071340",
        "volume": 15.27,
        "price": 3212.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -610.8000000000001,
        "takeProfit": null,
        "priceIn": 3212.08,
        "doubleCheck": true
    },
    {
        "id": "53117316",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18.960",
        "brokerTime": "2025-05-14 15:21:18.960",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071342",
        "positionId": "56071342",
        "volume": 15.27,
        "price": 3212.43,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.43,
        "doubleCheck": true
    },
    {
        "id": "53117317",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:18.960",
        "brokerTime": "2025-05-14 15:21:19.317",
        "commission": -106.89,
        "swap": 0,
        "profit": -397.02,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071343",
        "positionId": "56071342",
        "volume": 15.27,
        "price": 3212.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -503.90999999999997,
        "takeProfit": null,
        "priceIn": 3212.43,
        "doubleCheck": true
    },
    {
        "id": "53117318",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:19.875",
        "brokerTime": "2025-05-14 15:21:19.875",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071345",
        "positionId": "56071345",
        "volume": 15.27,
        "price": 3212.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.42,
        "doubleCheck": true
    },
    {
        "id": "53117319",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:19.875",
        "brokerTime": "2025-05-14 15:21:20.428",
        "commission": -106.89,
        "swap": 0,
        "profit": -122.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071346",
        "positionId": "56071345",
        "volume": 15.27,
        "price": 3212.5,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -229.05,
        "takeProfit": null,
        "priceIn": 3212.42,
        "doubleCheck": true
    },
    {
        "id": "53117320",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:20.874",
        "brokerTime": "2025-05-14 15:21:20.874",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071347",
        "positionId": "56071347",
        "volume": 15.27,
        "price": 3212.29,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.29,
        "doubleCheck": true
    },
    {
        "id": "53117321",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:20.874",
        "brokerTime": "2025-05-14 15:21:21.359",
        "commission": -106.89,
        "swap": 0,
        "profit": -61.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071348",
        "positionId": "56071347",
        "volume": 15.27,
        "price": 3212.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -167.97,
        "takeProfit": null,
        "priceIn": 3212.29,
        "doubleCheck": true
    },
    {
        "id": "53117322",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:21.660",
        "brokerTime": "2025-05-14 15:21:21.660",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071349",
        "positionId": "56071349",
        "volume": 15.27,
        "price": 3212.11,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.11,
        "doubleCheck": true
    },
    {
        "id": "53117323",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:21.660",
        "brokerTime": "2025-05-14 15:21:21.974",
        "commission": -106.89,
        "swap": 0,
        "profit": -351.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071350",
        "positionId": "56071349",
        "volume": 15.27,
        "price": 3212.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -458.09999999999997,
        "takeProfit": null,
        "priceIn": 3212.11,
        "doubleCheck": true
    },
    {
        "id": "53117324",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22.156",
        "brokerTime": "2025-05-14 15:21:22.156",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071351",
        "positionId": "56071351",
        "volume": 15.27,
        "price": 3212.25,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.25,
        "doubleCheck": true
    },
    {
        "id": "53117325",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:22.156",
        "brokerTime": "2025-05-14 15:21:22.627",
        "commission": -106.89,
        "swap": 0,
        "profit": -229.05,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071352",
        "positionId": "56071351",
        "volume": 15.27,
        "price": 3212.4,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -335.94,
        "takeProfit": null,
        "priceIn": 3212.25,
        "doubleCheck": true
    },
    {
        "id": "53117326",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:23.233",
        "brokerTime": "2025-05-14 15:21:23.233",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071353",
        "positionId": "56071353",
        "volume": 15.27,
        "price": 3212.39,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.39,
        "doubleCheck": true
    },
    {
        "id": "53117327",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:23.233",
        "brokerTime": "2025-05-14 15:21:23.934",
        "commission": -106.89,
        "swap": 0,
        "profit": -702.42,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071354",
        "positionId": "56071353",
        "volume": 15.27,
        "price": 3212.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -809.31,
        "takeProfit": null,
        "priceIn": 3212.39,
        "doubleCheck": true
    },
    {
        "id": "53117328",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:24.361",
        "brokerTime": "2025-05-14 15:21:24.361",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071355",
        "positionId": "56071355",
        "volume": 15.27,
        "price": 3212.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.84,
        "doubleCheck": true
    },
    {
        "id": "53117329",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:24.361",
        "brokerTime": "2025-05-14 15:21:24.994",
        "commission": -106.89,
        "swap": 0,
        "profit": -335.94,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071356",
        "positionId": "56071355",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -442.83,
        "takeProfit": null,
        "priceIn": 3212.84,
        "doubleCheck": true
    },
    {
        "id": "53117330",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:25.352",
        "brokerTime": "2025-05-14 15:21:25.352",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071357",
        "positionId": "56071357",
        "volume": 15.27,
        "price": 3212.8,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.8,
        "doubleCheck": true
    },
    {
        "id": "53117331",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:25.352",
        "brokerTime": "2025-05-14 15:21:25.812",
        "commission": -106.89,
        "swap": 0,
        "profit": -427.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071358",
        "positionId": "56071357",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -534.45,
        "takeProfit": null,
        "priceIn": 3212.8,
        "doubleCheck": true
    },
    {
        "id": "53117332",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:26.459",
        "brokerTime": "2025-05-14 15:21:26.459",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071359",
        "positionId": "56071359",
        "volume": 15.27,
        "price": 3212.95,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.95,
        "doubleCheck": true
    },
    {
        "id": "53117334",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:26.459",
        "brokerTime": "2025-05-14 15:21:27.022",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071361",
        "positionId": "56071359",
        "volume": 15.27,
        "price": 3213.15,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3212.95,
        "doubleCheck": true
    },
    {
        "id": "53117335",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:27.285",
        "brokerTime": "2025-05-14 15:21:27.285",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071362",
        "positionId": "56071362",
        "volume": 15.27,
        "price": 3212.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "id": "53117336",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:27.285",
        "brokerTime": "2025-05-14 15:21:28.169",
        "commission": -106.89,
        "swap": 0,
        "profit": -549.72,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071364",
        "positionId": "56071362",
        "volume": 15.27,
        "price": 3213.32,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -656.61,
        "takeProfit": null,
        "priceIn": 3212.96,
        "doubleCheck": true
    },
    {
        "id": "53117338",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:28.655",
        "brokerTime": "2025-05-14 15:21:28.655",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071365",
        "positionId": "56071365",
        "volume": 15.27,
        "price": 3213.18,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.18,
        "doubleCheck": true
    },
    {
        "id": "53117339",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:28.655",
        "brokerTime": "2025-05-14 15:21:29.036",
        "commission": -106.89,
        "swap": 0,
        "profit": -259.59,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071366",
        "positionId": "56071365",
        "volume": 15.27,
        "price": 3213.35,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -366.47999999999996,
        "takeProfit": null,
        "priceIn": 3213.18,
        "doubleCheck": true
    },
    {
        "id": "53117340",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29.415",
        "brokerTime": "2025-05-14 15:21:29.415",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071367",
        "positionId": "56071367",
        "volume": 15.27,
        "price": 3213.14,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.14,
        "doubleCheck": true
    },
    {
        "id": "53117341",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29.415",
        "brokerTime": "2025-05-14 15:21:29.687",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071368",
        "positionId": "56071367",
        "volume": 15.27,
        "price": 3213.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3213.14,
        "doubleCheck": true
    },
    {
        "id": "53117342",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29.883",
        "brokerTime": "2025-05-14 15:21:29.883",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071369",
        "positionId": "56071369",
        "volume": 15.27,
        "price": 3213.13,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.13,
        "doubleCheck": true
    },
    {
        "id": "53117343",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:29.883",
        "brokerTime": "2025-05-14 15:21:31.196",
        "commission": -106.89,
        "swap": 0,
        "profit": -366.48,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071370",
        "positionId": "56071369",
        "volume": 15.27,
        "price": 3213.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -473.37,
        "takeProfit": null,
        "priceIn": 3213.13,
        "doubleCheck": true
    },
    {
        "id": "53117344",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:31.383",
        "brokerTime": "2025-05-14 15:21:31.383",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071371",
        "positionId": "56071371",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.06,
        "doubleCheck": true
    },
    {
        "id": "53117345",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:31.383",
        "brokerTime": "2025-05-14 15:21:31.702",
        "commission": -106.89,
        "swap": 0,
        "profit": -30.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071372",
        "positionId": "56071371",
        "volume": 15.27,
        "price": 3213.08,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.43,
        "takeProfit": null,
        "priceIn": 3213.06,
        "doubleCheck": true
    },
    {
        "id": "53117346",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32.047",
        "brokerTime": "2025-05-14 15:21:32.047",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071373",
        "positionId": "56071373",
        "volume": 15.27,
        "price": 3212.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3212.86,
        "doubleCheck": true
    },
    {
        "id": "53117347",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32.047",
        "brokerTime": "2025-05-14 15:21:32.609",
        "commission": -106.89,
        "swap": 0,
        "profit": -305.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071374",
        "positionId": "56071373",
        "volume": 15.27,
        "price": 3213.06,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -412.28999999999996,
        "takeProfit": null,
        "priceIn": 3212.86,
        "doubleCheck": true
    },
    {
        "id": "53117348",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32.825",
        "brokerTime": "2025-05-14 15:21:32.825",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071375",
        "positionId": "56071375",
        "volume": 15.27,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117349",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:32.825",
        "brokerTime": "2025-05-14 15:21:33.541",
        "commission": -106.89,
        "swap": 0,
        "profit": -30.54,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071376",
        "positionId": "56071375",
        "volume": 15.27,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -137.43,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117350",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:33.851",
        "brokerTime": "2025-05-14 15:21:33.851",
        "commission": -106.89,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071377",
        "positionId": "56071377",
        "volume": 15.27,
        "price": 3213.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -106.89,
        "takeProfit": null,
        "priceIn": 3213.34,
        "doubleCheck": true
    },
    {
        "id": "53117351",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:33.851",
        "brokerTime": "2025-05-14 15:21:34.525",
        "commission": -106.89,
        "swap": 0,
        "profit": -641.34,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071378",
        "positionId": "56071377",
        "volume": 15.27,
        "price": 3213.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -748.23,
        "takeProfit": null,
        "priceIn": 3213.34,
        "doubleCheck": true
    },
    {
        "id": "53117352",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:55:07.406",
        "brokerTime": "2025-05-14 15:21:34.848",
        "commission": -6.23,
        "swap": 0,
        "profit": -1027.06,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071379",
        "positionId": "56050074",
        "volume": 0.89,
        "price": 3213.42,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 18.68%/1528.93/8184.87]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1033.29,
        "priceIn": 3224.96,
        "doubleCheck": false,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28",
        "tProfit": -7546.03,
        "tnProfit": -7635.7,
        "tVolume": 12.81,
        "tTrades": 18
    },
    {
        "id": "53117353",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:35.137",
        "brokerTime": "2025-05-14 15:21:35.137",
        "commission": -99.4,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071380",
        "positionId": "56071380",
        "volume": 14.2,
        "price": 3213.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -99.4,
        "takeProfit": null,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "id": "53117354",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:35.137",
        "brokerTime": "2025-05-14 15:21:35.769",
        "commission": -99.4,
        "swap": 0,
        "profit": -312.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071381",
        "positionId": "56071380",
        "volume": 14.2,
        "price": 3213.71,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -411.79999999999995,
        "takeProfit": null,
        "priceIn": 3213.49,
        "doubleCheck": true
    },
    {
        "id": "53117355",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:50:05.035",
        "brokerTime": "2025-05-14 15:21:35.903",
        "commission": -5.18,
        "swap": 0,
        "profit": -944.98,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071382",
        "positionId": "56049337",
        "volume": 0.74,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.72%/1272.80/7610.83]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -950.16,
        "priceIn": 3226.32,
        "doubleCheck": false
    },
    {
        "id": "53117356",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:57:01.371",
        "brokerTime": "2025-05-14 15:21:35.903",
        "commission": -7.49,
        "swap": 0,
        "profit": -884.89,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071383",
        "positionId": "56050822",
        "volume": 1.07,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 17.84%/1272.80/7133.35]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -892.38,
        "priceIn": 3221.82,
        "doubleCheck": false
    },
    {
        "id": "53117357",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:49:01.552",
        "brokerTime": "2025-05-14 15:21:35.904",
        "commission": -4.34,
        "swap": 0,
        "profit": -863.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071384",
        "positionId": "56049172",
        "volume": 0.62,
        "price": 3213.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 19.75%/1272.80/6443.88]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -867.38,
        "priceIn": 3227.47,
        "doubleCheck": false
    },
    {
        "id": "53117358",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:36.139",
        "brokerTime": "2025-05-14 15:21:36.139",
        "commission": -79.03,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071385",
        "positionId": "56071385",
        "volume": 11.29,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.03,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117359",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:36.139",
        "brokerTime": "2025-05-14 15:21:36.506",
        "commission": -79.03,
        "swap": 0,
        "profit": -237.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071386",
        "positionId": "56071385",
        "volume": 11.29,
        "price": 3213.74,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -316.12,
        "takeProfit": null,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117360",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:48:02.188",
        "brokerTime": "2025-05-14 15:21:36.579",
        "commission": -3.64,
        "swap": 0,
        "profit": -782.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071387",
        "positionId": "56048999",
        "volume": 0.52,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 15.49%/936.11/6043.69]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -786.24,
        "priceIn": 3228.58,
        "doubleCheck": false
    },
    {
        "id": "53117361",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:47:21.245",
        "brokerTime": "2025-05-14 15:21:36.579",
        "commission": -3.01,
        "swap": 0,
        "profit": -693.16,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071388",
        "positionId": "56048939",
        "volume": 0.43,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.40%/936.11/5707.93]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -696.17,
        "priceIn": 3229.65,
        "doubleCheck": false
    },
    {
        "id": "53117362",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:01:08.204",
        "brokerTime": "2025-05-14 15:21:36.580",
        "commission": -8.96,
        "swap": 0,
        "profit": -663.04,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071389",
        "positionId": "56052929",
        "volume": 1.28,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 17.24%/936.11/5430.19]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -672,
        "priceIn": 3218.71,
        "doubleCheck": false
    },
    {
        "id": "53117363",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:37.334",
        "brokerTime": "2025-05-14 15:21:37.334",
        "commission": -60.27,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071390",
        "positionId": "56071390",
        "volume": 8.61,
        "price": 3213.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -60.27,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53117364",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:37.334",
        "brokerTime": "2025-05-14 15:21:38.169",
        "commission": -60.27,
        "swap": 0,
        "profit": -766.29,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071391",
        "positionId": "56071390",
        "volume": 8.61,
        "price": 3214.41,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -826.56,
        "takeProfit": null,
        "priceIn": 3213.52,
        "doubleCheck": true
    },
    {
        "id": "53117365",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:46:01.531",
        "brokerTime": "2025-05-14 15:21:38.199",
        "commission": -2.52,
        "swap": 0,
        "profit": -592.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071392",
        "positionId": "56048820",
        "volume": 0.36,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 12.56%/578.72/4606.21]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -595.0799999999999,
        "priceIn": 3230.66,
        "doubleCheck": false
    },
    {
        "id": "53117366",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:43:00.348",
        "brokerTime": "2025-05-14 15:21:38.199",
        "commission": -2.1,
        "swap": 0,
        "profit": -523.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071393",
        "positionId": "56048759",
        "volume": 0.3,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 13.23%/578.72/4373.61]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -525.9,
        "priceIn": 3231.66,
        "doubleCheck": false
    },
    {
        "id": "53117367",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:42:38.594",
        "brokerTime": "2025-05-14 15:21:38.199",
        "commission": -1.75,
        "swap": 0,
        "profit": -463,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071394",
        "positionId": "56048738",
        "volume": 0.25,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 13.85%/578.72/4179.73]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -464.75,
        "priceIn": 3232.72,
        "doubleCheck": false
    },
    {
        "id": "53117368",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:38:53.196",
        "brokerTime": "2025-05-14 15:21:38.200",
        "commission": -1.47,
        "swap": 0,
        "profit": -412.23,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071395",
        "positionId": "56048576",
        "volume": 0.21,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.63,
        "brokerComment": "[so 14.40%/578.72/4018.11]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -413.70000000000005,
        "priceIn": 3233.83,
        "doubleCheck": false
    },
    {
        "id": "53117369",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:37:05.803",
        "brokerTime": "2025-05-14 15:21:38.200",
        "commission": -1.19,
        "swap": 0,
        "profit": -352.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071396",
        "positionId": "56048522",
        "volume": 0.17,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 14.91%/578.72/3882.30]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -354.11,
        "priceIn": 3234.96,
        "doubleCheck": false
    },
    {
        "id": "53117370",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:17:01.214",
        "brokerTime": "2025-05-14 15:21:38.200",
        "commission": -7.63,
        "swap": 0,
        "profit": -323.98,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071397",
        "positionId": "56068874",
        "volume": 1.09,
        "price": 2865.85,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "brokerComment": "[so 15.34%/578.72/3772.32]",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -331.61,
        "takeProfit": null,
        "priceIn": 2863.2,
        "doubleCheck": false
    },
    {
        "id": "53117371",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:36:00.510",
        "brokerTime": "2025-05-14 15:21:38.200",
        "commission": -0.98,
        "swap": 0,
        "profit": -304.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071398",
        "positionId": "56048484",
        "volume": 0.14,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 15.34%/578.72/3772.48]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -305.62,
        "priceIn": 3235.96,
        "doubleCheck": false
    },
    {
        "id": "53117372",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:32:18.336",
        "brokerTime": "2025-05-14 15:21:38.200",
        "commission": -0.84,
        "swap": 0,
        "profit": -274.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071399",
        "positionId": "56048322",
        "volume": 0.12,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 15.72%/578.72/3681.89]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -275.28,
        "priceIn": 3237.07,
        "doubleCheck": false
    },
    {
        "id": "53117373",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 14:26:35.512",
        "brokerTime": "2025-05-14 15:21:38.201",
        "commission": -0.7,
        "swap": 0,
        "profit": -238.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071400",
        "positionId": "56048272",
        "volume": 0.1,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.59,
        "brokerComment": "[so 16.06%/578.72/3604.21]",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -239.6,
        "priceIn": 3238.09,
        "doubleCheck": false
    },
    {
        "id": "53117374",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:17.381",
        "brokerTime": "2025-05-14 15:21:38.201",
        "commission": -10.78,
        "swap": 0,
        "profit": -150.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071401",
        "positionId": "56057151",
        "volume": 1.54,
        "price": 3214.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_SO",
        "takeProfit": 3308.68,
        "brokerComment": "[so 16.35%/578.72/3539.45]",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -161.7,
        "priceIn": 3215.18,
        "doubleCheck": false
    },
    {
        "id": "53117375",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:18:33.917",
        "brokerTime": "2025-05-14 15:21:40.025",
        "commission": -15.54,
        "swap": 0,
        "profit": 1209.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071402",
        "positionId": "56070596",
        "volume": 2.22,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.68,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 1194.3600000000001,
        "priceIn": 3208.88,
        "doubleCheck": false
    },
    {
        "id": "53117376",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:16.445",
        "brokerTime": "2025-05-14 15:21:40.183",
        "commission": -12.95,
        "swap": 0,
        "profit": 416.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071403",
        "positionId": "56068520",
        "volume": 1.85,
        "price": 3214.33,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3308.68,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 403.3,
        "priceIn": 3212.08,
        "doubleCheck": false
    },
    {
        "id": "53117377",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:21:46.359",
        "brokerTime": "2025-05-14 15:21:46.359",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071404",
        "positionId": "56071404",
        "volume": 0.1,
        "price": 3214.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3214.47,
        "doubleCheck": true
    },
    {
        "id": "53117381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:22:00.158",
        "brokerTime": "2025-05-14 15:22:00.158",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071408",
        "positionId": "56071408",
        "volume": 0.12,
        "price": 3213.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3113.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:23:00.330",
        "brokerTime": "2025-05-14 15:23:00.330",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071439",
        "positionId": "56071439",
        "volume": 0.14,
        "price": 3214.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3114.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "id": "53117559",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:24:00.337",
        "brokerTime": "2025-05-14 15:24:00.337",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071554",
        "positionId": "56071554",
        "volume": 0.17,
        "price": 3216.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.01,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3216.01,
        "doubleCheck": true
    },
    {
        "id": "53117831",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:24:00.337",
        "brokerTime": "2025-05-14 15:24:47.027",
        "commission": -1.19,
        "swap": 0,
        "profit": -12.75,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071775",
        "positionId": "56071554",
        "volume": 0.17,
        "price": 3216.76,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.19,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -13.94,
        "priceIn": 3216.01,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34",
        "tProfit": -124.23,
        "tnProfit": -127.94,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53117832",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:23:00.330",
        "brokerTime": "2025-05-14 15:24:47.068",
        "commission": -0.98,
        "swap": 0,
        "profit": -26.74,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071776",
        "positionId": "56071439",
        "volume": 0.14,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.21,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -27.72,
        "priceIn": 3214.84,
        "doubleCheck": true
    },
    {
        "id": "53117833",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:22:00.158",
        "brokerTime": "2025-05-14 15:24:47.104",
        "commission": -0.84,
        "swap": 0,
        "profit": -38.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071777",
        "positionId": "56071408",
        "volume": 0.12,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -39.480000000000004,
        "priceIn": 3213.53,
        "doubleCheck": true
    },
    {
        "id": "53117834",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:21:46.359",
        "brokerTime": "2025-05-14 15:24:47.145",
        "commission": -0.7,
        "swap": 0,
        "profit": 20.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071778",
        "positionId": "56071404",
        "volume": 0.1,
        "price": 3216.55,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 20.1,
        "takeProfit": null,
        "priceIn": 3214.47,
        "doubleCheck": true,
        "tProfit": 20.8,
        "tnProfit": 20.1,
        "tVolume": 0.1,
        "tTrades": 1
    },
    {
        "id": "53117835",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:21:16.985",
        "brokerTime": "2025-05-14 15:24:47.183",
        "commission": -0.7,
        "swap": 0,
        "profit": -46.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56071779",
        "positionId": "56071337",
        "volume": 0.1,
        "price": 3216.75,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3116.29,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -46.800000000000004,
        "priceIn": 3212.14,
        "doubleCheck": true
    },
    {
        "id": "53117837",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:17:00.393",
        "brokerTime": "2025-05-14 15:24:48.790",
        "commission": -1.75,
        "swap": 0,
        "profit": 66.22,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071781",
        "positionId": "56068871",
        "volume": 0.25,
        "price": 2865.89,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 64.47,
        "priceIn": 2863.53,
        "doubleCheck": false,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33",
        "tProfit": -30.65,
        "tnProfit": -37.58,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "id": "53117838",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:16:12.428",
        "brokerTime": "2025-05-14 15:24:48.857",
        "commission": -1.47,
        "swap": 0,
        "profit": 29.46,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071782",
        "positionId": "56068485",
        "volume": 0.21,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 27.990000000000002,
        "priceIn": 2864.7,
        "doubleCheck": false
    },
    {
        "id": "53117839",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:15:00.847",
        "brokerTime": "2025-05-14 15:24:48.926",
        "commission": -1.19,
        "swap": 0,
        "profit": -0.19,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071783",
        "positionId": "56068304",
        "volume": 0.17,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.38,
        "priceIn": 2865.96,
        "doubleCheck": false
    },
    {
        "id": "53117840",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:14:00.330",
        "brokerTime": "2025-05-14 15:24:48.956",
        "commission": -0.98,
        "swap": 0,
        "profit": -18.85,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071784",
        "positionId": "56065325",
        "volume": 0.14,
        "price": 2865.95,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -19.830000000000002,
        "priceIn": 2867.15,
        "doubleCheck": false
    },
    {
        "id": "53117841",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 15:13:42.206",
        "brokerTime": "2025-05-14 15:24:48.988",
        "commission": -0.7,
        "swap": 0,
        "profit": 10.21,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071785",
        "positionId": "56059993",
        "volume": 0.1,
        "price": 2866.2,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9.510000000000002,
        "takeProfit": null,
        "priceIn": 2867.11,
        "doubleCheck": false,
        "tProfit": 10.21,
        "tnProfit": 9.51,
        "tVolume": 0.1,
        "tTrades": 1
    },
    {
        "id": "53117842",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:13:09.648",
        "brokerTime": "2025-05-14 15:24:49.036",
        "commission": -0.84,
        "swap": 0,
        "profit": -51.85,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071786",
        "positionId": "56056805",
        "volume": 0.12,
        "price": 2865.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -52.690000000000005,
        "priceIn": 2869.79,
        "doubleCheck": false
    },
    {
        "id": "53117843",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 15:05:52.204",
        "brokerTime": "2025-05-14 15:24:49.065",
        "commission": -0.7,
        "swap": 0,
        "profit": -55.44,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56071787",
        "positionId": "56054143",
        "volume": 0.1,
        "price": 2865.94,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2963.29,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -56.14,
        "priceIn": 2870.88,
        "doubleCheck": false
    },
    {
        "id": "53154288",
        "platform": "mt5",
        "type": "DEAL_TYPE_BALANCE",
        "time": "2025-05-14 17:37:49.798",
        "brokerTime": "2025-05-14 17:37:49.798",
        "commission": 0,
        "swap": 0,
        "profit": 99000,
        "magic": 0,
        "accountCurrencyExchangeRate": 1,
        "netProfit": 99000,
        "price": null,
        "takeProfit": null,
        "volume": null,
        "priceIn": null,
        "doubleCheck": true,
        "tProfit": 99000,
        "tnProfit": 99000,
        "tVolume": null,
        "tTrades": 1
    },
    {
        "id": "53157918",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:36.591",
        "brokerTime": "2025-05-14 18:01:36.591",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56102616",
        "positionId": "56102616",
        "volume": 0.1,
        "price": 2839.07,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.07,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2839.07,
        "doubleCheck": true
    },
    {
        "id": "53157919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:37.906",
        "brokerTime": "2025-05-14 18:01:37.906",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56102617",
        "positionId": "56102617",
        "volume": 0.1,
        "price": 3183.48,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3283.48,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3183.48,
        "doubleCheck": true
    },
    {
        "id": "53157920",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:38.581",
        "brokerTime": "2025-05-14 18:01:38.581",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56102618",
        "positionId": "56102618",
        "volume": 0.1,
        "price": 3183.19,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.19,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3183.19,
        "doubleCheck": true
    },
    {
        "id": "53157921",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39.399",
        "brokerTime": "2025-05-14 18:01:39.399",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56102619",
        "positionId": "56102619",
        "volume": 0.1,
        "price": 2838.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2738.73,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2838.73,
        "doubleCheck": true
    },
    {
        "id": "53158559",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:02:56.955",
        "brokerTime": "2025-05-14 18:02:56.955",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56103208",
        "positionId": "56103208",
        "volume": 0.12,
        "price": 3182.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3282.47,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3182.47,
        "doubleCheck": true
    },
    {
        "id": "53159124",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00.001",
        "brokerTime": "2025-05-14 18:03:00.001",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56103772",
        "positionId": "56103772",
        "volume": 0.12,
        "price": 2838.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2938.04,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2838.04,
        "doubleCheck": true
    },
    {
        "id": "53159346",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00.176",
        "brokerTime": "2025-05-14 18:03:00.176",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56103776",
        "positionId": "56103776",
        "volume": 0.14,
        "price": 3181.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3181.17,
        "doubleCheck": true
    },
    {
        "id": "53161851",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:04:11.003",
        "brokerTime": "2025-05-14 18:04:11.003",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56105904",
        "positionId": "56105904",
        "volume": 0.17,
        "price": 3180.17,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.17,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3180.17,
        "doubleCheck": true
    },
    {
        "id": "53162475",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:06:48.890",
        "brokerTime": "2025-05-14 18:06:48.890",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56106448",
        "positionId": "56106448",
        "volume": 0.12,
        "price": 2839.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2739.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2839.86,
        "doubleCheck": true
    },
    {
        "id": "53162542",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:04:11.003",
        "brokerTime": "2025-05-14 18:07:33.871",
        "commission": -1.19,
        "swap": 0,
        "profit": 44.88,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106516",
        "positionId": "56105904",
        "volume": 0.17,
        "price": 3182.81,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.95,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 43.690000000000005,
        "priceIn": 3180.17,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37",
        "tProfit": 64.86,
        "tnProfit": 61.15,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53162543",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00.176",
        "brokerTime": "2025-05-14 18:07:33.951",
        "commission": -0.98,
        "swap": 0,
        "profit": 22.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106517",
        "positionId": "56103776",
        "volume": 0.14,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.96,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 21.84,
        "priceIn": 3181.17,
        "doubleCheck": true
    },
    {
        "id": "53162544",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:02:56.955",
        "brokerTime": "2025-05-14 18:07:34.002",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.96,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106518",
        "positionId": "56103208",
        "volume": 0.12,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.96,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 3.12,
        "priceIn": 3182.47,
        "doubleCheck": true
    },
    {
        "id": "53162545",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:37.906",
        "brokerTime": "2025-05-14 18:07:34.058",
        "commission": -0.7,
        "swap": 0,
        "profit": -6.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106519",
        "positionId": "56102617",
        "volume": 0.1,
        "price": 3182.8,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.03,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.5,
        "priceIn": 3183.48,
        "doubleCheck": true
    },
    {
        "id": "53162547",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:07:40.599",
        "brokerTime": "2025-05-14 18:07:40.599",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106521",
        "positionId": "56106521",
        "volume": 0.1,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3182.3,
        "doubleCheck": true
    },
    {
        "id": "53162615",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:08:36.882",
        "brokerTime": "2025-05-14 18:08:36.882",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106570",
        "positionId": "56106570",
        "volume": 0.12,
        "price": 3181.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.03,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3181.03,
        "doubleCheck": true
    },
    {
        "id": "53162681",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:10:50.399",
        "brokerTime": "2025-05-14 18:10:50.399",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56106631",
        "positionId": "56106631",
        "volume": 0.14,
        "price": 3179.79,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.79,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3179.79,
        "doubleCheck": true
    },
    {
        "id": "53164694",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:18:02.184",
        "brokerTime": "2025-05-14 18:18:02.184",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56108320",
        "positionId": "56108320",
        "volume": 0.14,
        "price": 2840.98,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2740.98,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2840.98,
        "doubleCheck": true
    },
    {
        "id": "53164733",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:10:50.399",
        "brokerTime": "2025-05-14 18:18:07.219",
        "commission": -0.98,
        "swap": 0,
        "profit": 34.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108346",
        "positionId": "56106631",
        "volume": 0.14,
        "price": 3182.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.63,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 33.88,
        "priceIn": 3179.79,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38",
        "tProfit": 50.1,
        "tnProfit": 48.28,
        "tVolume": 0.26,
        "tTrades": 2
    },
    {
        "id": "53164734",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:08:36.882",
        "brokerTime": "2025-05-14 18:18:07.332",
        "commission": -0.84,
        "swap": 0,
        "profit": 15.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108347",
        "positionId": "56106570",
        "volume": 0.12,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.62,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 14.4,
        "priceIn": 3181.03,
        "doubleCheck": true
    },
    {
        "id": "53164735",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:07:40.599",
        "brokerTime": "2025-05-14 18:18:07.383",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108348",
        "positionId": "56106521",
        "volume": 0.1,
        "price": 3182.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.62,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3182.3,
        "doubleCheck": true
    },
    {
        "id": "53164756",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:18:13.928",
        "brokerTime": "2025-05-14 18:18:13.928",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108362",
        "positionId": "56108362",
        "volume": 0.1,
        "price": 3182.91,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3182.91,
        "doubleCheck": true
    },
    {
        "id": "53164955",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:29.503",
        "brokerTime": "2025-05-14 18:19:29.503",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56108507",
        "positionId": "56108507",
        "volume": 0.17,
        "price": 2841.99,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2741.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 2841.99,
        "doubleCheck": true
    },
    {
        "id": "53164961",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:50.603",
        "brokerTime": "2025-05-14 18:19:50.603",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108513",
        "positionId": "56108513",
        "volume": 0.12,
        "price": 3184.3,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.27,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3184.3,
        "doubleCheck": true
    },
    {
        "id": "53164995",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:00.407",
        "brokerTime": "2025-05-14 18:21:00.407",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56108545",
        "positionId": "56108545",
        "volume": 0.21,
        "price": 2843.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2743.09,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 2843.09,
        "doubleCheck": true
    },
    {
        "id": "53165001",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:01.358",
        "brokerTime": "2025-05-14 18:21:01.358",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108550",
        "positionId": "56108550",
        "volume": 0.14,
        "price": 3185.32,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.32,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3185.32,
        "doubleCheck": true
    },
    {
        "id": "53165509",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:26:48.200",
        "brokerTime": "2025-05-14 18:26:48.200",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56108920",
        "positionId": "56108920",
        "volume": 0.17,
        "price": 3186.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.36,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3186.36,
        "doubleCheck": true
    },
    {
        "id": "53166015",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:26:48.200",
        "brokerTime": "2025-05-14 18:31:47.147",
        "commission": -1.19,
        "swap": 0,
        "profit": 40.46,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109365",
        "positionId": "56108920",
        "volume": 0.17,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 39.27,
        "priceIn": 3186.36,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39",
        "tProfit": 55.16,
        "tnProfit": 51.45,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53166016",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:01.358",
        "brokerTime": "2025-05-14 18:31:47.176",
        "commission": -0.98,
        "swap": 0,
        "profit": 18.76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109366",
        "positionId": "56108550",
        "volume": 0.14,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 17.78,
        "priceIn": 3185.32,
        "doubleCheck": true
    },
    {
        "id": "53166017",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:50.603",
        "brokerTime": "2025-05-14 18:31:47.205",
        "commission": -0.84,
        "swap": 0,
        "profit": 3.84,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109367",
        "positionId": "56108513",
        "volume": 0.12,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 3,
        "priceIn": 3184.3,
        "doubleCheck": true
    },
    {
        "id": "53166018",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:38.581",
        "brokerTime": "2025-05-14 18:31:47.259",
        "commission": -0.7,
        "swap": 0,
        "profit": -7.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109368",
        "positionId": "56102618",
        "volume": 0.1,
        "price": 3183.98,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.55,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.6,
        "priceIn": 3183.19,
        "doubleCheck": true
    },
    {
        "id": "53166021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:31:53.759",
        "brokerTime": "2025-05-14 18:31:53.759",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109371",
        "positionId": "56109371",
        "volume": 0.1,
        "price": 3183.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3183.66,
        "doubleCheck": true
    },
    {
        "id": "53166030",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:32:10.755",
        "brokerTime": "2025-05-14 18:32:10.755",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109380",
        "positionId": "56109380",
        "volume": 0.12,
        "price": 3184.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "id": "53166106",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:33:43.149",
        "brokerTime": "2025-05-14 18:33:43.149",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109439",
        "positionId": "56109439",
        "volume": 0.14,
        "price": 3186.05,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.05,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3186.05,
        "doubleCheck": true
    },
    {
        "id": "53166449",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:38:11.774",
        "brokerTime": "2025-05-14 18:38:11.774",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109710",
        "positionId": "56109710",
        "volume": 0.12,
        "price": 3181.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.89,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3181.89,
        "doubleCheck": true
    },
    {
        "id": "53166500",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:33:43.149",
        "brokerTime": "2025-05-14 18:39:03.278",
        "commission": -0.98,
        "swap": 0,
        "profit": 51.52,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109747",
        "positionId": "56109439",
        "volume": 0.14,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.25,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 50.540000000000006,
        "priceIn": 3186.05,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40",
        "tProfit": 92.62,
        "tnProfit": 90.1,
        "tVolume": 0.36,
        "tTrades": 3
    },
    {
        "id": "53166501",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:32:10.755",
        "brokerTime": "2025-05-14 18:39:03.291",
        "commission": -0.84,
        "swap": 0,
        "profit": 28.2,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109748",
        "positionId": "56109380",
        "volume": 0.12,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.27,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 27.36,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "id": "53166502",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:31:53.759",
        "brokerTime": "2025-05-14 18:39:03.320",
        "commission": -0.7,
        "swap": 0,
        "profit": 12.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109749",
        "positionId": "56109371",
        "volume": 0.1,
        "price": 3182.37,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3086.27,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 12.200000000000001,
        "priceIn": 3183.66,
        "doubleCheck": true
    },
    {
        "id": "53166507",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:39:09.860",
        "brokerTime": "2025-05-14 18:39:09.860",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56109753",
        "positionId": "56109753",
        "volume": 0.1,
        "price": 3182.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3182.03,
        "doubleCheck": true
    },
    {
        "id": "53167053",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:40:41.562",
        "brokerTime": "2025-05-14 18:40:41.562",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56110139",
        "positionId": "56110139",
        "volume": 0.12,
        "price": 3183.04,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.04,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3183.04,
        "doubleCheck": true
    },
    {
        "id": "53167341",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:44:24.985",
        "brokerTime": "2025-05-14 18:44:24.985",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56110346",
        "positionId": "56110346",
        "volume": 0.14,
        "price": 3180.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.85,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "id": "53168419",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:49:54.924",
        "brokerTime": "2025-05-14 18:49:54.924",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56111190",
        "positionId": "56111190",
        "volume": 0.17,
        "price": 3179.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3179.66,
        "doubleCheck": true
    },
    {
        "id": "53169856",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:49:54.924",
        "brokerTime": "2025-05-14 19:00:21.008",
        "commission": -1.19,
        "swap": 0,
        "profit": 51,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112467",
        "positionId": "56111190",
        "volume": 0.17,
        "price": 3182.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 49.81,
        "priceIn": 3179.66,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41",
        "tProfit": 84.82,
        "tnProfit": 81.11,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53169857",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:44:24.985",
        "brokerTime": "2025-05-14 19:00:21.038",
        "commission": -0.98,
        "swap": 0,
        "profit": 27.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112468",
        "positionId": "56110346",
        "volume": 0.14,
        "price": 3182.66,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 26.32,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "id": "53169858",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:38:11.774",
        "brokerTime": "2025-05-14 19:00:21.103",
        "commission": -0.84,
        "swap": 0,
        "profit": 9.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112469",
        "positionId": "56109710",
        "volume": 0.12,
        "price": 3182.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 8.28,
        "priceIn": 3181.89,
        "doubleCheck": true
    },
    {
        "id": "53169859",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:18:13.928",
        "brokerTime": "2025-05-14 19:00:21.168",
        "commission": -0.7,
        "swap": 0,
        "profit": -2.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112470",
        "positionId": "56108362",
        "volume": 0.1,
        "price": 3182.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.47,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.3,
        "priceIn": 3182.91,
        "doubleCheck": true
    },
    {
        "id": "53169861",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:00:27.598",
        "brokerTime": "2025-05-14 19:00:27.598",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112474",
        "positionId": "56112474",
        "volume": 0.1,
        "price": 3182.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3182.82,
        "doubleCheck": true
    },
    {
        "id": "53170105",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:05:41.640",
        "brokerTime": "2025-05-14 19:05:41.640",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112677",
        "positionId": "56112677",
        "volume": 0.12,
        "price": 3181.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.78,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3181.63,
        "doubleCheck": true
    },
    {
        "id": "53170131",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:06:00.143",
        "brokerTime": "2025-05-14 19:06:00.143",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56112701",
        "positionId": "56112701",
        "volume": 0.14,
        "price": 3180.59,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.59,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3180.59,
        "doubleCheck": true
    },
    {
        "id": "53173200",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:14:23.279",
        "brokerTime": "2025-05-14 19:14:23.279",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56114882",
        "positionId": "56114882",
        "volume": 0.17,
        "price": 3179.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3179.55,
        "doubleCheck": true
    },
    {
        "id": "53174250",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:22:55.252",
        "brokerTime": "2025-05-14 19:22:55.252",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115762",
        "positionId": "56115762",
        "volume": 0.14,
        "price": 3184.08,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3084.08,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3184.08,
        "doubleCheck": true
    },
    {
        "id": "53174257",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:23:04.029",
        "brokerTime": "2025-05-14 19:23:04.029",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115769",
        "positionId": "56115769",
        "volume": 0.17,
        "price": 3185.09,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.1,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3185.09,
        "doubleCheck": true
    },
    {
        "id": "53174264",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:14:23.279",
        "brokerTime": "2025-05-14 19:23:19.487",
        "commission": -1.19,
        "swap": 0,
        "profit": 89.08,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115776",
        "positionId": "56114882",
        "volume": 0.17,
        "price": 3184.79,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 87.89,
        "priceIn": 3179.55,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42",
        "tProfit": 205.14,
        "tnProfit": 201.43,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53174265",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:06:00.143",
        "brokerTime": "2025-05-14 19:23:19.517",
        "commission": -0.98,
        "swap": 0,
        "profit": 58.66,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115777",
        "positionId": "56112701",
        "volume": 0.14,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 57.68,
        "priceIn": 3180.59,
        "doubleCheck": true
    },
    {
        "id": "53174266",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:05:41.640",
        "brokerTime": "2025-05-14 19:23:19.590",
        "commission": -0.84,
        "swap": 0,
        "profit": 37.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115778",
        "positionId": "56112677",
        "volume": 0.12,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 36.959999999999994,
        "priceIn": 3181.63,
        "doubleCheck": true
    },
    {
        "id": "53174267",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:00:27.598",
        "brokerTime": "2025-05-14 19:23:19.612",
        "commission": -0.7,
        "swap": 0,
        "profit": 19.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115779",
        "positionId": "56112474",
        "volume": 0.1,
        "price": 3184.78,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.37,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 18.900000000000002,
        "priceIn": 3182.82,
        "doubleCheck": true
    },
    {
        "id": "53174269",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:23:26.007",
        "brokerTime": "2025-05-14 19:23:26.007",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115781",
        "positionId": "56115781",
        "volume": 0.1,
        "price": 3184.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "id": "53174452",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:25:27.944",
        "brokerTime": "2025-05-14 19:25:27.944",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56115910",
        "positionId": "56115910",
        "volume": 0.12,
        "price": 3183.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3283.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3183.61,
        "doubleCheck": true
    },
    {
        "id": "53175456",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:27:03.178",
        "brokerTime": "2025-05-14 19:27:03.178",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116611",
        "positionId": "56116611",
        "volume": 0.14,
        "price": 3182.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3282.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3182.61,
        "doubleCheck": true
    },
    {
        "id": "53175931",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:23:04.029",
        "brokerTime": "2025-05-14 19:31:26.318",
        "commission": -1.19,
        "swap": 0,
        "profit": 41.82,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116964",
        "positionId": "56115769",
        "volume": 0.17,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 40.63,
        "priceIn": 3185.09,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43",
        "tProfit": 61.04,
        "tnProfit": 57.33,
        "tVolume": 0.53,
        "tTrades": 4
    },
    {
        "id": "53175932",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:22:55.252",
        "brokerTime": "2025-05-14 19:31:26.352",
        "commission": -0.98,
        "swap": 0,
        "profit": 20.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116965",
        "positionId": "56115762",
        "volume": 0.14,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 19.32,
        "priceIn": 3184.08,
        "doubleCheck": true
    },
    {
        "id": "53175933",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:40:41.562",
        "brokerTime": "2025-05-14 19:31:26.392",
        "commission": -0.84,
        "swap": 0,
        "profit": 4.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116966",
        "positionId": "56110139",
        "volume": 0.12,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.33,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 4.08,
        "priceIn": 3183.04,
        "doubleCheck": true
    },
    {
        "id": "53175934",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:39:09.860",
        "brokerTime": "2025-05-14 19:31:26.438",
        "commission": -0.7,
        "swap": 0,
        "profit": -6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116967",
        "positionId": "56109753",
        "volume": 0.1,
        "price": 3182.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3085.31,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.7,
        "priceIn": 3182.03,
        "doubleCheck": true
    },
    {
        "id": "53175935",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:31:32.900",
        "brokerTime": "2025-05-14 19:31:32.900",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56116968",
        "positionId": "56116968",
        "volume": 0.1,
        "price": 3181.93,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3181.93,
        "doubleCheck": true
    },
    {
        "id": "53176317",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:33:21.282",
        "brokerTime": "2025-05-14 19:33:21.282",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56117226",
        "positionId": "56117226",
        "volume": 0.17,
        "price": 3181.61,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3281.61,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3181.61,
        "doubleCheck": true
    },
    {
        "id": "53176631",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:38:59.059",
        "brokerTime": "2025-05-14 19:38:59.059",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56117467",
        "positionId": "56117467",
        "volume": 0.12,
        "price": 3182.96,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.96,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3182.96,
        "doubleCheck": true
    },
    {
        "id": "53177419",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:40:41.437",
        "brokerTime": "2025-05-14 19:40:41.437",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56118108",
        "positionId": "56118108",
        "volume": 0.21,
        "price": 3180.36,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3280.36,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3180.36,
        "doubleCheck": true
    },
    {
        "id": "53178747",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:41:00.122",
        "brokerTime": "2025-05-14 19:41:00.122",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56119260",
        "positionId": "56119260",
        "volume": 0.25,
        "price": 3177.22,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3277.22,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3177.22,
        "doubleCheck": true
    },
    {
        "id": "53179997",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:42:03.697",
        "brokerTime": "2025-05-14 19:42:03.697",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120225",
        "positionId": "56120225",
        "volume": 0.3,
        "price": 3175.37,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.44,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3175.37,
        "doubleCheck": true
    },
    {
        "id": "53180413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:38:59.059",
        "brokerTime": "2025-05-14 19:42:36.364",
        "commission": -0.84,
        "swap": 0,
        "profit": 87.24,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120515",
        "positionId": "56117467",
        "volume": 0.12,
        "price": 3175.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.19,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 86.39999999999999,
        "priceIn": 3182.96,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44",
        "tProfit": 149.64,
        "tnProfit": 148.1,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53180414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:31:32.900",
        "brokerTime": "2025-05-14 19:42:36.406",
        "commission": -0.7,
        "swap": 0,
        "profit": 62.4,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120516",
        "positionId": "56116968",
        "volume": 0.1,
        "price": 3175.69,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3083.28,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 61.699999999999996,
        "priceIn": 3181.93,
        "doubleCheck": true
    },
    {
        "id": "53180415",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:42:43.015",
        "brokerTime": "2025-05-14 19:42:43.015",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120517",
        "positionId": "56120517",
        "volume": 0.1,
        "price": 3176.5,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3176.5,
        "doubleCheck": true
    },
    {
        "id": "53180441",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:43:00.137",
        "brokerTime": "2025-05-14 19:43:00.137",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120542",
        "positionId": "56120542",
        "volume": 0.12,
        "price": 3177.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3077.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3177.72,
        "doubleCheck": true
    },
    {
        "id": "53180674",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:44:07.200",
        "brokerTime": "2025-05-14 19:44:07.200",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56120722",
        "positionId": "56120722",
        "volume": 0.14,
        "price": 3178.74,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3078.74,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3178.74,
        "doubleCheck": true
    },
    {
        "id": "53180962",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:45:02.124",
        "brokerTime": "2025-05-14 19:45:02.124",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121000",
        "positionId": "56121000",
        "volume": 0.17,
        "price": 3179.77,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3079.77,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3179.77,
        "doubleCheck": true
    },
    {
        "id": "53181914",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:42:03.697",
        "brokerTime": "2025-05-14 19:45:32.649",
        "commission": -2.1,
        "swap": 0,
        "profit": 156.9,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121852",
        "positionId": "56120225",
        "volume": 0.3,
        "price": 3180.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.13,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 154.8,
        "priceIn": 3175.37,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45",
        "tProfit": 127.29,
        "tnProfit": 118.26,
        "tVolume": 1.29,
        "tTrades": 7
    },
    {
        "id": "53181915",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:41:00.122",
        "brokerTime": "2025-05-14 19:45:32.703",
        "commission": -1.75,
        "swap": 0,
        "profit": 84.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121853",
        "positionId": "56119260",
        "volume": 0.25,
        "price": 3180.6,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.97,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 82.75,
        "priceIn": 3177.22,
        "doubleCheck": true
    },
    {
        "id": "53181917",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:40:41.437",
        "brokerTime": "2025-05-14 19:45:32.896",
        "commission": -1.47,
        "swap": 0,
        "profit": 6.09,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121854",
        "positionId": "56118108",
        "volume": 0.21,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.96,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 4.62,
        "priceIn": 3180.36,
        "doubleCheck": true
    },
    {
        "id": "53181918",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:33:21.282",
        "brokerTime": "2025-05-14 19:45:33.009",
        "commission": -1.19,
        "swap": 0,
        "profit": -16.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121855",
        "positionId": "56117226",
        "volume": 0.17,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.06,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -17.51,
        "priceIn": 3181.61,
        "doubleCheck": true
    },
    {
        "id": "53181919",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:27:03.178",
        "brokerTime": "2025-05-14 19:45:33.117",
        "commission": -0.98,
        "swap": 0,
        "profit": -27.44,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121856",
        "positionId": "56116611",
        "volume": 0.14,
        "price": 3180.65,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.06,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -28.42,
        "priceIn": 3182.61,
        "doubleCheck": true
    },
    {
        "id": "53181920",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:25:27.944",
        "brokerTime": "2025-05-14 19:45:33.134",
        "commission": -0.84,
        "swap": 0,
        "profit": -35.64,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121857",
        "positionId": "56115910",
        "volume": 0.12,
        "price": 3180.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.02,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -36.480000000000004,
        "priceIn": 3183.61,
        "doubleCheck": true
    },
    {
        "id": "53181921",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:23:26.007",
        "brokerTime": "2025-05-14 19:45:33.170",
        "commission": -0.7,
        "swap": 0,
        "profit": -40.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56121858",
        "positionId": "56115781",
        "volume": 0.1,
        "price": 3180.64,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -41.5,
        "priceIn": 3184.72,
        "doubleCheck": true
    },
    {
        "id": "53182346",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:45:39.655",
        "brokerTime": "2025-05-14 19:45:39.655",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56122237",
        "positionId": "56122237",
        "volume": 0.1,
        "price": 3180.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "id": "53182381",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:00.150",
        "brokerTime": "2025-05-14 19:46:00.150",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56122258",
        "positionId": "56122258",
        "volume": 0.21,
        "price": 3181.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3081.14,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3181.15,
        "doubleCheck": true
    },
    {
        "id": "53182499",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:37.792",
        "brokerTime": "2025-05-14 19:46:37.792",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56122357",
        "positionId": "56122357",
        "volume": 0.25,
        "price": 2844.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2744.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 2844.16,
        "doubleCheck": true
    },
    {
        "id": "53182582",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:47:22.530",
        "brokerTime": "2025-05-14 19:47:22.530",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56122418",
        "positionId": "56122418",
        "volume": 0.25,
        "price": 3182.16,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.16,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3182.16,
        "doubleCheck": true
    },
    {
        "id": "53182671",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:48:54.946",
        "brokerTime": "2025-05-14 19:48:54.946",
        "commission": -7.63,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56122487",
        "positionId": "56122487",
        "volume": 1.09,
        "price": 3183.35,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -7.63,
        "takeProfit": null,
        "priceIn": 3183.35,
        "doubleCheck": true
    },
    {
        "id": "53182739",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:49:09.935",
        "brokerTime": "2025-05-14 19:49:09.935",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56122536",
        "positionId": "56122536",
        "volume": 0.3,
        "price": 2845.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2745.42,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 2845.42,
        "doubleCheck": true
    },
    {
        "id": "53183071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:53:22.808",
        "brokerTime": "2025-05-14 19:53:22.808",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56122797",
        "positionId": "56122797",
        "volume": 0.36,
        "price": 2846.44,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2746.44,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 2846.44,
        "doubleCheck": true
    },
    {
        "id": "53183137",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:54:00.126",
        "brokerTime": "2025-05-14 19:54:00.126",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56122865",
        "positionId": "56122865",
        "volume": 0.43,
        "price": 2847.94,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2747.94,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 2847.94,
        "doubleCheck": true
    },
    {
        "id": "53183281",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:54:01.475",
        "brokerTime": "2025-05-14 19:54:01.475",
        "commission": -15.96,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56123000",
        "positionId": "56123000",
        "volume": 2.28,
        "price": 2848.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -15.96,
        "takeProfit": null,
        "priceIn": 2848.03,
        "doubleCheck": true
    },
    {
        "id": "53190736",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:48:54.946",
        "brokerTime": "2025-05-14 21:02:22.254",
        "commission": -7.63,
        "swap": 0,
        "profit": -331.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129427",
        "positionId": "56122487",
        "volume": 1.09,
        "price": 3180.31,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -338.99,
        "takeProfit": null,
        "priceIn": 3183.35,
        "doubleCheck": true,
        "tProfit": -331.36,
        "tnProfit": -338.99,
        "tVolume": 1.09,
        "tTrades": 1
    },
    {
        "id": "53190754",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:03:40.662",
        "brokerTime": "2025-05-14 21:03:40.662",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129447",
        "positionId": "56129447",
        "volume": 0.12,
        "price": 3179.6,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3279.68,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3179.6,
        "doubleCheck": true
    },
    {
        "id": "53191128",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:47:22.530",
        "brokerTime": "2025-05-14 21:05:00.655",
        "commission": -1.75,
        "swap": 0,
        "profit": 75.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129719",
        "positionId": "56122418",
        "volume": 0.25,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 73.75,
        "priceIn": 3182.16,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47",
        "tProfit": 82.46,
        "tnProfit": 75.53,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "id": "53191129",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:00.150",
        "brokerTime": "2025-05-14 21:05:00.673",
        "commission": -1.47,
        "swap": 0,
        "profit": 42.21,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129720",
        "positionId": "56122258",
        "volume": 0.21,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 40.74,
        "priceIn": 3181.15,
        "doubleCheck": true
    },
    {
        "id": "53191130",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:45:02.124",
        "brokerTime": "2025-05-14 21:05:00.694",
        "commission": -1.19,
        "swap": 0,
        "profit": 10.71,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129721",
        "positionId": "56121000",
        "volume": 0.17,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 9.520000000000001,
        "priceIn": 3179.77,
        "doubleCheck": true
    },
    {
        "id": "53191131",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:44:07.200",
        "brokerTime": "2025-05-14 21:05:00.726",
        "commission": -0.98,
        "swap": 0,
        "profit": -5.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129722",
        "positionId": "56120722",
        "volume": 0.14,
        "price": 3179.14,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -6.58,
        "priceIn": 3178.74,
        "doubleCheck": true
    },
    {
        "id": "53191132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:43:00.137",
        "brokerTime": "2025-05-14 21:05:00.938",
        "commission": -0.84,
        "swap": 0,
        "profit": -15.36,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129723",
        "positionId": "56120542",
        "volume": 0.12,
        "price": 3179,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.4,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.2,
        "priceIn": 3177.72,
        "doubleCheck": true
    },
    {
        "id": "53191133",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:42:43.015",
        "brokerTime": "2025-05-14 21:05:00.965",
        "commission": -0.7,
        "swap": 0,
        "profit": -25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129724",
        "positionId": "56120517",
        "volume": 0.1,
        "price": 3179,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3082.42,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -25.7,
        "priceIn": 3176.5,
        "doubleCheck": true
    },
    {
        "id": "53191197",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 21:05:07.432",
        "brokerTime": "2025-05-14 21:05:07.432",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129769",
        "positionId": "56129769",
        "volume": 0.1,
        "price": 3178.63,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3178.63,
        "doubleCheck": true
    },
    {
        "id": "53191202",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:05:09.164",
        "brokerTime": "2025-05-14 21:05:09.164",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56129773",
        "positionId": "56129773",
        "volume": 0.14,
        "price": 3178.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3278.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3178.58,
        "doubleCheck": true
    },
    {
        "id": "53191760",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:06:42.826",
        "brokerTime": "2025-05-14 21:06:42.826",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56130281",
        "positionId": "56130281",
        "volume": 0.17,
        "price": 3177.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3277.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3177.58,
        "doubleCheck": true
    },
    {
        "id": "53191872",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:07:52.814",
        "brokerTime": "2025-05-14 21:07:52.814",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56130368",
        "positionId": "56130368",
        "volume": 0.21,
        "price": 3176.58,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3276.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3176.58,
        "doubleCheck": true
    },
    {
        "id": "53192201",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:10:13.086",
        "brokerTime": "2025-05-14 21:10:13.086",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56130613",
        "positionId": "56130613",
        "volume": 0.25,
        "price": 3175.51,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.54,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3175.51,
        "doubleCheck": true
    },
    {
        "id": "53195905",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:10:13.086",
        "brokerTime": "2025-05-14 21:21:50.372",
        "commission": -1.75,
        "swap": 0,
        "profit": 69.25,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133743",
        "positionId": "56130613",
        "volume": 0.25,
        "price": 3178.28,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 67.5,
        "priceIn": 3175.51,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48",
        "tProfit": 73.61,
        "tnProfit": 66.68,
        "tVolume": 0.99,
        "tTrades": 6
    },
    {
        "id": "53195906",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:07:52.814",
        "brokerTime": "2025-05-14 21:21:50.475",
        "commission": -1.47,
        "swap": 0,
        "profit": 35.91,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133744",
        "positionId": "56130368",
        "volume": 0.21,
        "price": 3178.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 34.44,
        "priceIn": 3176.58,
        "doubleCheck": true
    },
    {
        "id": "53195907",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:06:42.826",
        "brokerTime": "2025-05-14 21:21:50.509",
        "commission": -1.19,
        "swap": 0,
        "profit": 12.07,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133745",
        "positionId": "56130281",
        "volume": 0.17,
        "price": 3178.29,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 10.88,
        "priceIn": 3177.58,
        "doubleCheck": true
    },
    {
        "id": "53195908",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:05:09.164",
        "brokerTime": "2025-05-14 21:21:50.595",
        "commission": -0.98,
        "swap": 0,
        "profit": -3.92,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133746",
        "positionId": "56129773",
        "volume": 0.14,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.26,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4.9,
        "priceIn": 3178.58,
        "doubleCheck": true
    },
    {
        "id": "53195909",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:03:40.662",
        "brokerTime": "2025-05-14 21:21:50.633",
        "commission": -0.84,
        "swap": 0,
        "profit": -15.6,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133747",
        "positionId": "56129447",
        "volume": 0.12,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.28,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.44,
        "priceIn": 3179.6,
        "doubleCheck": true
    },
    {
        "id": "53195910",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:45:39.655",
        "brokerTime": "2025-05-14 21:21:50.660",
        "commission": -0.7,
        "swap": 0,
        "profit": -24.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133748",
        "positionId": "56122237",
        "volume": 0.1,
        "price": 3178.3,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.28,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -24.8,
        "priceIn": 3180.71,
        "doubleCheck": true
    },
    {
        "id": "53195911",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:21:57.118",
        "brokerTime": "2025-05-14 21:21:57.118",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56133750",
        "positionId": "56133750",
        "volume": 0.1,
        "price": 3177.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3177.85,
        "doubleCheck": true
    },
    {
        "id": "53196378",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:26:00.950",
        "brokerTime": "2025-05-14 21:26:00.950",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56134151",
        "positionId": "56134151",
        "volume": 0.12,
        "price": 3176.85,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3276.85,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3176.85,
        "doubleCheck": true
    },
    {
        "id": "53197149",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:44:28.171",
        "brokerTime": "2025-05-14 21:44:28.171",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56134801",
        "positionId": "56134801",
        "volume": 0.14,
        "price": 3175.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3275.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3175.82,
        "doubleCheck": true
    },
    {
        "id": "53197586",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:50:44.292",
        "brokerTime": "2025-05-14 21:50:44.292",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56135113",
        "positionId": "56135113",
        "volume": 0.17,
        "price": 3174.82,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3274.82,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3174.82,
        "doubleCheck": true
    },
    {
        "id": "53197912",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:54:47.282",
        "brokerTime": "2025-05-14 21:54:47.282",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56135346",
        "positionId": "56135346",
        "volume": 0.21,
        "price": 3173.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3273.77,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "id": "53198294",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:56:42.886",
        "brokerTime": "2025-05-14 21:56:42.886",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56135691",
        "positionId": "56135691",
        "volume": 0.25,
        "price": 3172.26,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3272.27,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3172.26,
        "doubleCheck": true
    },
    {
        "id": "53199162",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:00:12.022",
        "brokerTime": "2025-05-14 22:00:12.022",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56136424",
        "positionId": "56136424",
        "volume": 0.3,
        "price": 3171.2,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3271.21,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3171.2,
        "doubleCheck": true
    },
    {
        "id": "53200333",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:02:28.527",
        "brokerTime": "2025-05-14 22:02:28.527",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56137254",
        "positionId": "56137254",
        "volume": 0.36,
        "price": 3169.03,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3269.13,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 3169.03,
        "doubleCheck": true
    },
    {
        "id": "53201730",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 21:05:07.432",
        "brokerTime": "2025-05-14 22:05:01.233",
        "commission": -0.7,
        "swap": 0,
        "profit": 76,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138317",
        "positionId": "56129769",
        "volume": 0.1,
        "price": 3171.03,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 75.3,
        "takeProfit": null,
        "priceIn": 3178.63,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51",
        "tProfit": 72.7,
        "tnProfit": 71.3,
        "tVolume": 0.2,
        "tTrades": 2
    },
    {
        "id": "53202050",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:05:07.692",
        "brokerTime": "2025-05-14 22:05:07.692",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138541",
        "positionId": "56138541",
        "volume": 0.1,
        "price": 3170.15,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 3170.15,
        "doubleCheck": true
    },
    {
        "id": "53202058",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:05:07.692",
        "brokerTime": "2025-05-14 22:05:13.120",
        "commission": -0.7,
        "swap": 0,
        "profit": -3.3,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138546",
        "positionId": "56138541",
        "volume": 0.1,
        "price": 3170.48,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -4,
        "takeProfit": null,
        "priceIn": 3170.15,
        "doubleCheck": true
    },
    {
        "id": "53202059",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:02:28.527",
        "brokerTime": "2025-05-14 22:05:13.160",
        "commission": -2.52,
        "swap": 0,
        "profit": 43.56,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138547",
        "positionId": "56137254",
        "volume": 0.36,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.79,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 41.04,
        "priceIn": 3169.03,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49",
        "tProfit": -420.01,
        "tnProfit": -431.56,
        "tVolume": 1.65,
        "tTrades": 8
    },
    {
        "id": "53202060",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:00:12.022",
        "brokerTime": "2025-05-14 22:05:13.184",
        "commission": -2.1,
        "swap": 0,
        "profit": -28.8,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138548",
        "positionId": "56136424",
        "volume": 0.3,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.72,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -30.900000000000002,
        "priceIn": 3171.2,
        "doubleCheck": true
    },
    {
        "id": "53202061",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:56:42.886",
        "brokerTime": "2025-05-14 22:05:13.226",
        "commission": -1.75,
        "swap": 0,
        "profit": -50.5,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138549",
        "positionId": "56135691",
        "volume": 0.25,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.54,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -52.25,
        "priceIn": 3172.26,
        "doubleCheck": true
    },
    {
        "id": "53202062",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:54:47.282",
        "brokerTime": "2025-05-14 22:05:13.247",
        "commission": -1.47,
        "swap": 0,
        "profit": -72.87,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138551",
        "positionId": "56135346",
        "volume": 0.21,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.49,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -74.34,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "id": "53202064",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:50:44.292",
        "brokerTime": "2025-05-14 22:05:13.291",
        "commission": -1.19,
        "swap": 0,
        "profit": -77.86,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138552",
        "positionId": "56135113",
        "volume": 0.17,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.05,
        "priceIn": 3174.82,
        "doubleCheck": true
    },
    {
        "id": "53202065",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:44:28.171",
        "brokerTime": "2025-05-14 22:05:13.330",
        "commission": -0.98,
        "swap": 0,
        "profit": -78.12,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138553",
        "positionId": "56134801",
        "volume": 0.14,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.27,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -79.10000000000001,
        "priceIn": 3175.82,
        "doubleCheck": true
    },
    {
        "id": "53202066",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:26:00.950",
        "brokerTime": "2025-05-14 22:05:13.366",
        "commission": -0.84,
        "swap": 0,
        "profit": -79.32,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138554",
        "positionId": "56134151",
        "volume": 0.12,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -80.16,
        "priceIn": 3176.85,
        "doubleCheck": true
    },
    {
        "id": "53202067",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 21:21:57.118",
        "brokerTime": "2025-05-14 22:05:13.408",
        "commission": -0.7,
        "swap": 0,
        "profit": -76.1,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138555",
        "positionId": "56133750",
        "volume": 0.1,
        "price": 3170.24,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3268.35,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -76.8,
        "priceIn": 3177.85,
        "doubleCheck": true
    },
    {
        "id": "53202069",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 19:54:01.475",
        "brokerTime": "2025-05-14 22:05:14.355",
        "commission": -15.96,
        "swap": 0,
        "profit": -2467.59,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138557",
        "positionId": "56123000",
        "volume": 2.28,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2483.55,
        "takeProfit": null,
        "priceIn": 2848.03,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50",
        "tProfit": -2471.72,
        "tnProfit": -2489.22,
        "tVolume": 2.5,
        "tTrades": 3
    },
    {
        "id": "53202070",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:54:00.126",
        "brokerTime": "2025-05-14 22:05:14.379",
        "commission": -3.01,
        "swap": 0,
        "profit": 447.14,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138558",
        "positionId": "56122865",
        "volume": 0.43,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 444.13,
        "priceIn": 2847.94,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52",
        "tProfit": 1365.89,
        "tnProfit": 1351.33,
        "tVolume": 2.08,
        "tTrades": 9
    },
    {
        "id": "53202071",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:53:22.808",
        "brokerTime": "2025-05-14 22:05:14.402",
        "commission": -2.52,
        "swap": 0,
        "profit": 314.04,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138559",
        "positionId": "56122797",
        "volume": 0.36,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 311.52000000000004,
        "priceIn": 2846.44,
        "doubleCheck": true
    },
    {
        "id": "53202072",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:49:09.935",
        "brokerTime": "2025-05-14 22:05:14.460",
        "commission": -2.1,
        "swap": 0,
        "profit": 227.52,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138560",
        "positionId": "56122536",
        "volume": 0.3,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 225.42000000000002,
        "priceIn": 2845.42,
        "doubleCheck": true
    },
    {
        "id": "53202073",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 19:46:37.792",
        "brokerTime": "2025-05-14 22:05:14.519",
        "commission": -1.75,
        "swap": 0,
        "profit": 154.42,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138561",
        "positionId": "56122357",
        "volume": 0.25,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 152.67,
        "priceIn": 2844.16,
        "doubleCheck": true
    },
    {
        "id": "53202074",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:21:00.407",
        "brokerTime": "2025-05-14 22:05:14.539",
        "commission": -1.47,
        "swap": 0,
        "profit": 104.61,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138562",
        "positionId": "56108545",
        "volume": 0.21,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 103.14,
        "priceIn": 2843.09,
        "doubleCheck": true
    },
    {
        "id": "53202075",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:19:29.503",
        "brokerTime": "2025-05-14 22:05:14.601",
        "commission": -1.19,
        "swap": 0,
        "profit": 63.8,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138563",
        "positionId": "56108507",
        "volume": 0.17,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 62.61,
        "priceIn": 2841.99,
        "doubleCheck": true
    },
    {
        "id": "53202076",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:18:02.184",
        "brokerTime": "2025-05-14 22:05:14.648",
        "commission": -0.98,
        "swap": 0,
        "profit": 36.75,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138564",
        "positionId": "56108320",
        "volume": 0.14,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 35.77,
        "priceIn": 2840.98,
        "doubleCheck": true
    },
    {
        "id": "53202077",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:06:48.890",
        "brokerTime": "2025-05-14 22:05:14.671",
        "commission": -0.84,
        "swap": 0,
        "profit": 16.49,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138565",
        "positionId": "56106448",
        "volume": 0.12,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 15.649999999999999,
        "priceIn": 2839.86,
        "doubleCheck": true
    },
    {
        "id": "53202078",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:03:00.001",
        "brokerTime": "2025-05-14 22:05:14.707",
        "commission": -0.84,
        "swap": 0,
        "profit": 4.02,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138566",
        "positionId": "56103772",
        "volume": 0.12,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.8,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 3.1799999999999997,
        "priceIn": 2838.04,
        "doubleCheck": true
    },
    {
        "id": "53202079",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 18:01:39.399",
        "brokerTime": "2025-05-14 22:05:14.725",
        "commission": -0.7,
        "swap": 0,
        "profit": 1.12,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138567",
        "positionId": "56102619",
        "volume": 0.1,
        "price": 2838.63,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2748.18,
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 0.42000000000000015,
        "priceIn": 2838.73,
        "doubleCheck": true
    },
    {
        "id": "53202080",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 18:01:36.591",
        "brokerTime": "2025-05-14 22:05:14.759",
        "commission": -0.7,
        "swap": 0,
        "profit": -8.15,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138568",
        "positionId": "56102616",
        "volume": 0.1,
        "price": 2838.34,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.76,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -8.85,
        "priceIn": 2839.07,
        "doubleCheck": true
    },
    {
        "id": "53202412",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:20.408",
        "brokerTime": "2025-05-14 22:06:20.408",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138781",
        "positionId": "56138781",
        "volume": 0.1,
        "price": 3170.69,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3270.79,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3170.69,
        "doubleCheck": true
    },
    {
        "id": "53202413",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:06:21.236",
        "brokerTime": "2025-05-14 22:06:21.236",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138782",
        "positionId": "56138782",
        "volume": 0.1,
        "price": 3170.49,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3070.49,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 3170.49,
        "doubleCheck": true
    },
    {
        "id": "53202414",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:06:22.315",
        "brokerTime": "2025-05-14 22:06:22.315",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138783",
        "positionId": "56138783",
        "volume": 0.1,
        "price": 2838.42,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2738.42,
        "brokerComment": "Sell Order",
        "comment": "Sell Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2838.42,
        "doubleCheck": true
    },
    {
        "id": "53202415",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:22.873",
        "brokerTime": "2025-05-14 22:06:22.873",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56138784",
        "positionId": "56138784",
        "volume": 0.1,
        "price": 2838.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2938.66,
        "brokerComment": "Buy Order",
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "priceIn": 2838.66,
        "doubleCheck": true
    },
    {
        "id": "53202550",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:08:52.116",
        "brokerTime": "2025-05-14 22:08:52.116",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56138885",
        "positionId": "56138885",
        "volume": 0.12,
        "price": 3171.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3071.52,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 3171.52,
        "doubleCheck": true
    },
    {
        "id": "53202738",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:11:25.521",
        "brokerTime": "2025-05-14 22:11:25.521",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139025",
        "positionId": "56139025",
        "volume": 0.14,
        "price": 3172.65,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3072.58,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 3172.65,
        "doubleCheck": true
    },
    {
        "id": "53202973",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:15:05.010",
        "brokerTime": "2025-05-14 22:15:05.010",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139204",
        "positionId": "56139204",
        "volume": 0.12,
        "price": 2837.66,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.66,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2837.66,
        "doubleCheck": true
    },
    {
        "id": "53203011",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:17:22.207",
        "brokerTime": "2025-05-14 22:17:22.207",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139235",
        "positionId": "56139235",
        "volume": 0.12,
        "price": 2839.53,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2739.53,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2839.53,
        "doubleCheck": true
    },
    {
        "id": "53203021",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:18:04.676",
        "brokerTime": "2025-05-14 22:18:04.676",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139242",
        "positionId": "56139242",
        "volume": 0.17,
        "price": 3173.71,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3073.71,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 3173.71,
        "doubleCheck": true
    },
    {
        "id": "53203111",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:21:30.201",
        "brokerTime": "2025-05-14 22:21:30.201",
        "commission": -0.98,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139325",
        "positionId": "56139325",
        "volume": 0.14,
        "price": 2840.54,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2740.54,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.98,
        "priceIn": 2840.54,
        "doubleCheck": true
    },
    {
        "id": "53203132",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:23:52.652",
        "brokerTime": "2025-05-14 22:23:52.652",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139344",
        "positionId": "56139344",
        "volume": 0.21,
        "price": 3174.72,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3074.72,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 3174.72,
        "doubleCheck": true
    },
    {
        "id": "53203156",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:15:05.010",
        "brokerTime": "2025-05-14 22:26:04.758",
        "commission": -0.84,
        "swap": 0,
        "profit": 32.72,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139364",
        "positionId": "56139204",
        "volume": 0.12,
        "price": 2840.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.39,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 31.88,
        "priceIn": 2837.66,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53",
        "tProfit": 48.81,
        "tnProfit": 47.27,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53203157",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:06:22.873",
        "brokerTime": "2025-05-14 22:26:04.808",
        "commission": -0.7,
        "swap": 0,
        "profit": 16.09,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139365",
        "positionId": "56138784",
        "volume": 0.1,
        "price": 2840.1,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2937.39,
        "comment": "Buy Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 15.39,
        "priceIn": 2838.66,
        "doubleCheck": true
    },
    {
        "id": "53203162",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:26:11.379",
        "brokerTime": "2025-05-14 22:26:11.379",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139370",
        "positionId": "56139370",
        "volume": 0.1,
        "price": 2840.56,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2840.56,
        "doubleCheck": true
    },
    {
        "id": "53203170",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:27:04.391",
        "brokerTime": "2025-05-14 22:27:04.391",
        "commission": -0.84,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139378",
        "positionId": "56139378",
        "volume": 0.12,
        "price": 2839.52,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.52,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.84,
        "priceIn": 2839.52,
        "doubleCheck": true
    },
    {
        "id": "53203260",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:34:26.897",
        "brokerTime": "2025-05-14 22:34:26.897",
        "commission": -1.19,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139461",
        "positionId": "56139461",
        "volume": 0.17,
        "price": 2841.55,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2741.55,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.19,
        "priceIn": 2841.55,
        "doubleCheck": true
    },
    {
        "id": "53203263",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:34:32.054",
        "brokerTime": "2025-05-14 22:34:32.054",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139464",
        "positionId": "56139464",
        "volume": 0.25,
        "price": 3175.73,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3075.73,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 3175.73,
        "doubleCheck": true
    },
    {
        "id": "53203305",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:37:20.633",
        "brokerTime": "2025-05-14 22:37:20.633",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139497",
        "positionId": "56139497",
        "volume": 0.3,
        "price": 3176.83,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3076.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 3176.83,
        "doubleCheck": true
    },
    {
        "id": "53203306",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:37:20.873",
        "brokerTime": "2025-05-14 22:37:20.873",
        "commission": -1.47,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139498",
        "positionId": "56139498",
        "volume": 0.21,
        "price": 2842.86,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2742.86,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.47,
        "priceIn": 2842.86,
        "doubleCheck": true
    },
    {
        "id": "53203369",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:39:22.956",
        "brokerTime": "2025-05-14 22:39:22.956",
        "commission": -1.75,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139559",
        "positionId": "56139559",
        "volume": 0.25,
        "price": 2843.89,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2743.89,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -1.75,
        "priceIn": 2843.89,
        "doubleCheck": true
    },
    {
        "id": "53203680",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:40:30.286",
        "brokerTime": "2025-05-14 22:40:30.286",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139841",
        "positionId": "56139841",
        "volume": 0.36,
        "price": 3177.84,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3077.84,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 3177.84,
        "doubleCheck": true
    },
    {
        "id": "53203708",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:41:10.849",
        "brokerTime": "2025-05-14 22:41:10.849",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139871",
        "positionId": "56139871",
        "volume": 0.43,
        "price": 3179.02,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 3078.99,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 3179.02,
        "doubleCheck": true
    },
    {
        "id": "53203711",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:41:11.393",
        "brokerTime": "2025-05-14 22:41:11.393",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUUSD.PRO",
        "magic": 0,
        "orderId": "56139873",
        "positionId": "56139873",
        "volume": 2.4,
        "price": 3179.28,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 3179.28,
        "doubleCheck": true
    },
    {
        "id": "53203735",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:41:57.475",
        "brokerTime": "2025-05-14 22:41:57.475",
        "commission": -2.1,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139897",
        "positionId": "56139897",
        "volume": 0.3,
        "price": 2845.01,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2745.01,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.1,
        "priceIn": 2845.01,
        "doubleCheck": true
    },
    {
        "id": "53203783",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:27:04.391",
        "brokerTime": "2025-05-14 22:46:49.124",
        "commission": -0.84,
        "swap": 0,
        "profit": 63.42,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139937",
        "positionId": "56139378",
        "volume": 0.12,
        "price": 2844.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.27,
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 62.58,
        "priceIn": 2839.52,
        "doubleCheck": true,
        "isShow": false,
        "collapseIndex": "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54",
        "tProfit": 104.65,
        "tnProfit": 103.11,
        "tVolume": 0.22,
        "tTrades": 2
    },
    {
        "id": "53203784",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:26:11.379",
        "brokerTime": "2025-05-14 22:46:49.174",
        "commission": -0.7,
        "swap": 0,
        "profit": 41.23,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139938",
        "positionId": "56139370",
        "volume": 0.1,
        "price": 2844.25,
        "entryType": "DEAL_ENTRY_OUT",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2939.27,
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": 40.529999999999994,
        "priceIn": 2840.56,
        "doubleCheck": true
    },
    {
        "id": "53203785",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:46:55.608",
        "brokerTime": "2025-05-14 22:46:55.608",
        "commission": -0.7,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56139939",
        "positionId": "56139939",
        "volume": 0.1,
        "price": 2844.57,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "RR",
        "comment": "RR",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -0.7,
        "takeProfit": null,
        "priceIn": 2844.57,
        "doubleCheck": true
    },
    {
        "id": "53204038",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:53:40.291",
        "brokerTime": "2025-05-14 22:53:40.291",
        "commission": -2.52,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56140134",
        "positionId": "56140134",
        "volume": 0.36,
        "price": 2846.33,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2746.33,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -2.52,
        "priceIn": 2846.33,
        "doubleCheck": true
    },
    {
        "id": "53204086",
        "platform": "mt5",
        "type": "DEAL_TYPE_SELL",
        "time": "2025-05-14 22:54:21.201",
        "brokerTime": "2025-05-14 22:54:21.201",
        "commission": -3.01,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56140174",
        "positionId": "56140174",
        "volume": 0.43,
        "price": 2847.34,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "takeProfit": 2747.34,
        "brokerComment": "Safety Order",
        "comment": "Safety Order",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -3.01,
        "priceIn": 2847.34,
        "doubleCheck": true
    },
    {
        "id": "53204087",
        "platform": "mt5",
        "type": "DEAL_TYPE_BUY",
        "time": "2025-05-14 22:54:21.680",
        "brokerTime": "2025-05-14 22:54:21.680",
        "commission": -16.8,
        "swap": 0,
        "profit": 0,
        "symbol": "XAUEUR.PRO",
        "magic": 0,
        "orderId": "56140175",
        "positionId": "56140175",
        "volume": 2.4,
        "price": 2847.47,
        "entryType": "DEAL_ENTRY_IN",
        "reason": "DEAL_REASON_EXPERT",
        "brokerComment": "BT",
        "comment": "BT",
        "accountCurrencyExchangeRate": 1,
        "netProfit": -16.8,
        "takeProfit": null,
        "priceIn": 2847.47,
        "doubleCheck": true
    }
]